module.exports = {
	"2049": {
		"name": "exclamation question mark",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2014,
		"display": 1,
		"shortname": ":interrobang:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2049",
			"fully_qualified": "2049-fe0f",
			"non_fully_qualified": "2049",
			"output": "2049-fe0f",
			"default_matches": [
				"2049-fe0f"
			],
			"greedy_matches": [
				"2049-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"exclamation",
			"interrobang",
			"mark",
			"punctuation",
			"question"
		]
	},
	"2122": {
		"name": "trade mark",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2120,
		"display": 1,
		"shortname": ":tm:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2122",
			"fully_qualified": "2122-fe0f",
			"non_fully_qualified": "2122",
			"output": "2122-fe0f",
			"default_matches": [
				"2122-fe0f"
			],
			"greedy_matches": [
				"2122-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"tm",
			"trademark"
		]
	},
	"2139": {
		"name": "information",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2054,
		"display": 1,
		"shortname": ":information_source:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2139",
			"fully_qualified": "2139-fe0f",
			"non_fully_qualified": "2139",
			"output": "2139-fe0f",
			"default_matches": [
				"2139-fe0f"
			],
			"greedy_matches": [
				"2139-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"i",
			"information"
		]
	},
	"2194": {
		"name": "left-right arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2102,
		"display": 1,
		"shortname": ":left_right_arrow:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2194",
			"fully_qualified": "2194-fe0f",
			"non_fully_qualified": "2194",
			"output": "2194-fe0f",
			"default_matches": [
				"2194-fe0f"
			],
			"greedy_matches": [
				"2194-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow"
		]
	},
	"2195": {
		"name": "up-down arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2101,
		"display": 1,
		"shortname": ":arrow_up_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2195",
			"fully_qualified": "2195-fe0f",
			"non_fully_qualified": "2195",
			"output": "2195-fe0f",
			"default_matches": [
				"2195-fe0f"
			],
			"greedy_matches": [
				"2195-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow"
		]
	},
	"2196": {
		"name": "up-left arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2100,
		"display": 1,
		"shortname": ":arrow_upper_left:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2196",
			"fully_qualified": "2196-fe0f",
			"non_fully_qualified": "2196",
			"output": "2196-fe0f",
			"default_matches": [
				"2196-fe0f"
			],
			"greedy_matches": [
				"2196-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"direction",
			"intercardinal",
			"northwest"
		]
	},
	"2197": {
		"name": "up-right arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2097,
		"display": 1,
		"shortname": ":arrow_upper_right:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2197",
			"fully_qualified": "2197-fe0f",
			"non_fully_qualified": "2197",
			"output": "2197-fe0f",
			"default_matches": [
				"2197-fe0f"
			],
			"greedy_matches": [
				"2197-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"direction",
			"intercardinal",
			"northeast"
		]
	},
	"2198": {
		"name": "down-right arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2098,
		"display": 1,
		"shortname": ":arrow_lower_right:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2198",
			"fully_qualified": "2198-fe0f",
			"non_fully_qualified": "2198",
			"output": "2198-fe0f",
			"default_matches": [
				"2198-fe0f"
			],
			"greedy_matches": [
				"2198-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"direction",
			"intercardinal",
			"southeast"
		]
	},
	"2199": {
		"name": "down-left arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2099,
		"display": 1,
		"shortname": ":arrow_lower_left:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2199",
			"fully_qualified": "2199-fe0f",
			"non_fully_qualified": "2199",
			"output": "2199-fe0f",
			"default_matches": [
				"2199-fe0f"
			],
			"greedy_matches": [
				"2199-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"direction",
			"intercardinal",
			"southwest"
		]
	},
	"2328": {
		"name": "keyboard",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1745,
		"display": 1,
		"shortname": ":keyboard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2328",
			"fully_qualified": "2328-fe0f",
			"non_fully_qualified": "2328",
			"output": "2328-fe0f",
			"default_matches": [
				"2328-fe0f",
				"2328"
			],
			"greedy_matches": [
				"2328-fe0f",
				"2328"
			],
			"decimal": ""
		},
		"keywords": [
			"computer"
		]
	},
	"2600": {
		"name": "sun",
		"unicode_version": 1.1,
		"category": "nature",
		"order": 1149,
		"display": 1,
		"shortname": ":sunny:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2600",
			"fully_qualified": "2600-fe0f",
			"non_fully_qualified": "2600",
			"output": "2600-fe0f",
			"default_matches": [
				"2600-fe0f",
				"2600"
			],
			"greedy_matches": [
				"2600-fe0f",
				"2600"
			],
			"decimal": ""
		},
		"keywords": [
			"bright",
			"rays",
			"sunny"
		]
	},
	"2601": {
		"name": "cloud",
		"unicode_version": 1.1,
		"category": "nature",
		"order": 1155,
		"display": 1,
		"shortname": ":cloud:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2601",
			"fully_qualified": "2601-fe0f",
			"non_fully_qualified": "2601",
			"output": "2601-fe0f",
			"default_matches": [
				"2601-fe0f",
				"2601"
			],
			"greedy_matches": [
				"2601-fe0f",
				"2601"
			],
			"decimal": ""
		},
		"keywords": [
			"weather"
		]
	},
	"2602": {
		"name": "umbrella",
		"unicode_version": 1.1,
		"category": "people",
		"order": 1011,
		"display": 1,
		"shortname": ":umbrella2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2602",
			"fully_qualified": "2602-fe0f",
			"non_fully_qualified": "2602",
			"output": "2602-fe0f",
			"default_matches": [
				"2602-fe0f",
				"2602"
			],
			"greedy_matches": [
				"2602-fe0f",
				"2602"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"rain"
		]
	},
	"2603": {
		"name": "snowman",
		"unicode_version": 1.1,
		"category": "nature",
		"order": 1160,
		"display": 1,
		"shortname": ":snowman2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2603",
			"fully_qualified": "2603-fe0f",
			"non_fully_qualified": "2603",
			"output": "2603-fe0f",
			"default_matches": [
				"2603-fe0f",
				"2603"
			],
			"greedy_matches": [
				"2603-fe0f",
				"2603"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"snow"
		]
	},
	"2604": {
		"name": "comet",
		"unicode_version": 1.1,
		"category": "nature",
		"order": 1148,
		"display": 1,
		"shortname": ":comet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2604",
			"fully_qualified": "2604-fe0f",
			"non_fully_qualified": "2604",
			"output": "2604-fe0f",
			"default_matches": [
				"2604-fe0f",
				"2604"
			],
			"greedy_matches": [
				"2604-fe0f",
				"2604"
			],
			"decimal": ""
		},
		"keywords": [
			"space"
		]
	},
	"2611": {
		"name": "ballot box with check",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2132,
		"display": 1,
		"shortname": ":ballot_box_with_check:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2611",
			"fully_qualified": "2611-fe0f",
			"non_fully_qualified": "2611",
			"output": "2611-fe0f",
			"default_matches": [
				"2611-fe0f"
			],
			"greedy_matches": [
				"2611-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ballot",
			"box",
			"check"
		]
	},
	"2614": {
		"name": "umbrella with rain drops",
		"unicode_version": 4,
		"category": "nature",
		"order": 1170,
		"display": 1,
		"shortname": ":umbrella:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2614",
			"fully_qualified": "2614",
			"non_fully_qualified": "2614",
			"output": "2614",
			"default_matches": [
				"2614"
			],
			"greedy_matches": [
				"2614"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"drop",
			"rain",
			"umbrella"
		]
	},
	"2615": {
		"name": "hot beverage",
		"unicode_version": 4,
		"category": "food",
		"order": 1249,
		"display": 1,
		"shortname": ":coffee:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2615",
			"fully_qualified": "2615",
			"non_fully_qualified": "2615",
			"output": "2615",
			"default_matches": [
				"2615"
			],
			"greedy_matches": [
				"2615"
			],
			"decimal": ""
		},
		"keywords": [
			"beverage",
			"coffee",
			"drink",
			"hot",
			"steaming",
			"tea"
		]
	},
	"2618": {
		"name": "shamrock",
		"unicode_version": 4.1,
		"category": "nature",
		"order": 1107,
		"display": 1,
		"shortname": ":shamrock:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2618",
			"fully_qualified": "2618-fe0f",
			"non_fully_qualified": "2618",
			"output": "2618-fe0f",
			"default_matches": [
				"2618-fe0f",
				"2618"
			],
			"greedy_matches": [
				"2618-fe0f",
				"2618"
			],
			"decimal": ""
		},
		"keywords": [
			"plant"
		]
	},
	"2620": {
		"name": "skull and crossbones",
		"unicode_version": 1.1,
		"category": "people",
		"order": 83,
		"display": 1,
		"shortname": ":skull_crossbones:",
		"shortname_alternates": [
			":skull_and_crossbones:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2620",
			"fully_qualified": "2620-fe0f",
			"non_fully_qualified": "2620",
			"output": "2620-fe0f",
			"default_matches": [
				"2620-fe0f",
				"2620"
			],
			"greedy_matches": [
				"2620-fe0f",
				"2620"
			],
			"decimal": ""
		},
		"keywords": [
			"crossbones",
			"death",
			"face",
			"monster",
			"skull"
		]
	},
	"2622": {
		"name": "radioactive",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1968,
		"display": 1,
		"shortname": ":radioactive:",
		"shortname_alternates": [
			":radioactive_sign:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2622",
			"fully_qualified": "2622-fe0f",
			"non_fully_qualified": "2622",
			"output": "2622-fe0f",
			"default_matches": [
				"2622-fe0f"
			],
			"greedy_matches": [
				"2622-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"radioactive",
			"sign"
		]
	},
	"2623": {
		"name": "biohazard",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1969,
		"display": 1,
		"shortname": ":biohazard:",
		"shortname_alternates": [
			":biohazard_sign:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2623",
			"fully_qualified": "2623-fe0f",
			"non_fully_qualified": "2623",
			"output": "2623-fe0f",
			"default_matches": [
				"2623-fe0f"
			],
			"greedy_matches": [
				"2623-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"biohazard",
			"sign"
		]
	},
	"2626": {
		"name": "orthodox cross",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1950,
		"display": 1,
		"shortname": ":orthodox_cross:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2626",
			"fully_qualified": "2626-fe0f",
			"non_fully_qualified": "2626",
			"output": "2626-fe0f",
			"default_matches": [
				"2626-fe0f"
			],
			"greedy_matches": [
				"2626-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Christian",
			"cross",
			"religion"
		]
	},
	"2638": {
		"name": "wheel of dharma",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1945,
		"display": 1,
		"shortname": ":wheel_of_dharma:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2638",
			"fully_qualified": "2638-fe0f",
			"non_fully_qualified": "2638",
			"output": "2638-fe0f",
			"default_matches": [
				"2638-fe0f"
			],
			"greedy_matches": [
				"2638-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Buddhist",
			"dharma",
			"religion",
			"wheel"
		]
	},
	"2639": {
		"name": "frowning face",
		"unicode_version": 1.1,
		"category": "people",
		"order": 38,
		"display": 1,
		"shortname": ":frowning2:",
		"shortname_alternates": [
			":white_frowning_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2639",
			"fully_qualified": "2639-fe0f",
			"non_fully_qualified": "2639",
			"output": "2639-fe0f",
			"default_matches": [
				"2639-fe0f",
				"2639"
			],
			"greedy_matches": [
				"2639-fe0f",
				"2639"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"frown"
		]
	},
	"2640": {
		"name": "female sign",
		"unicode_version": 1.1,
		"category": "people",
		"order": 2508,
		"display": 0,
		"shortname": ":female_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2640",
			"fully_qualified": "2640-fe0f",
			"non_fully_qualified": "2640",
			"output": "2640-fe0f",
			"default_matches": [
				"2640-fe0f"
			],
			"greedy_matches": [
				"2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"woman"
		]
	},
	"2642": {
		"name": "male sign",
		"unicode_version": 1.1,
		"category": "people",
		"order": 2509,
		"display": 0,
		"shortname": ":male_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2642",
			"fully_qualified": "2642-fe0f",
			"non_fully_qualified": "2642",
			"output": "2642-fe0f",
			"default_matches": [
				"2642-fe0f"
			],
			"greedy_matches": [
				"2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man"
		]
	},
	"2648": {
		"name": "Aries",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1953,
		"display": 1,
		"shortname": ":aries:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2648",
			"fully_qualified": "2648",
			"non_fully_qualified": "2648",
			"output": "2648",
			"default_matches": [
				"2648"
			],
			"greedy_matches": [
				"2648"
			],
			"decimal": ""
		},
		"keywords": [
			"ram",
			"zodiac"
		]
	},
	"2649": {
		"name": "Taurus",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1954,
		"display": 1,
		"shortname": ":taurus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2649",
			"fully_qualified": "2649",
			"non_fully_qualified": "2649",
			"output": "2649",
			"default_matches": [
				"2649"
			],
			"greedy_matches": [
				"2649"
			],
			"decimal": ""
		},
		"keywords": [
			"bull",
			"ox",
			"zodiac"
		]
	},
	"2650": {
		"name": "Sagittarius",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1961,
		"display": 1,
		"shortname": ":sagittarius:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2650",
			"fully_qualified": "2650",
			"non_fully_qualified": "2650",
			"output": "2650",
			"default_matches": [
				"2650"
			],
			"greedy_matches": [
				"2650"
			],
			"decimal": ""
		},
		"keywords": [
			"archer",
			"zodiac"
		]
	},
	"2651": {
		"name": "Capricorn",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1962,
		"display": 1,
		"shortname": ":capricorn:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2651",
			"fully_qualified": "2651",
			"non_fully_qualified": "2651",
			"output": "2651",
			"default_matches": [
				"2651"
			],
			"greedy_matches": [
				"2651"
			],
			"decimal": ""
		},
		"keywords": [
			"goat",
			"zodiac"
		]
	},
	"2652": {
		"name": "Aquarius",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1963,
		"display": 1,
		"shortname": ":aquarius:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2652",
			"fully_qualified": "2652",
			"non_fully_qualified": "2652",
			"output": "2652",
			"default_matches": [
				"2652"
			],
			"greedy_matches": [
				"2652"
			],
			"decimal": ""
		},
		"keywords": [
			"bearer",
			"water",
			"zodiac"
		]
	},
	"2653": {
		"name": "Pisces",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1964,
		"display": 1,
		"shortname": ":pisces:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2653",
			"fully_qualified": "2653",
			"non_fully_qualified": "2653",
			"output": "2653",
			"default_matches": [
				"2653"
			],
			"greedy_matches": [
				"2653"
			],
			"decimal": ""
		},
		"keywords": [
			"fish",
			"zodiac"
		]
	},
	"2660": {
		"name": "spade suit",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2167,
		"display": 1,
		"shortname": ":spades:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2660",
			"fully_qualified": "2660-fe0f",
			"non_fully_qualified": "2660",
			"output": "2660-fe0f",
			"default_matches": [
				"2660-fe0f",
				"2660"
			],
			"greedy_matches": [
				"2660-fe0f",
				"2660"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"game"
		]
	},
	"2663": {
		"name": "club suit",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2168,
		"display": 1,
		"shortname": ":clubs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2663",
			"fully_qualified": "2663-fe0f",
			"non_fully_qualified": "2663",
			"output": "2663-fe0f",
			"default_matches": [
				"2663-fe0f",
				"2663"
			],
			"greedy_matches": [
				"2663-fe0f",
				"2663"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"game"
		]
	},
	"2665": {
		"name": "heart suit",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2169,
		"display": 1,
		"shortname": ":hearts:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2665",
			"fully_qualified": "2665-fe0f",
			"non_fully_qualified": "2665",
			"output": "2665-fe0f",
			"default_matches": [
				"2665-fe0f",
				"2665"
			],
			"greedy_matches": [
				"2665-fe0f",
				"2665"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"game"
		]
	},
	"2666": {
		"name": "diamond suit",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2170,
		"display": 1,
		"shortname": ":diamonds:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2666",
			"fully_qualified": "2666-fe0f",
			"non_fully_qualified": "2666",
			"output": "2666-fe0f",
			"default_matches": [
				"2666-fe0f",
				"2666"
			],
			"greedy_matches": [
				"2666-fe0f",
				"2666"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"game"
		]
	},
	"2668": {
		"name": "hot springs",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2001,
		"display": 1,
		"shortname": ":hotsprings:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2668",
			"fully_qualified": "2668-fe0f",
			"non_fully_qualified": "2668",
			"output": "2668-fe0f",
			"default_matches": [
				"2668-fe0f",
				"2668"
			],
			"greedy_matches": [
				"2668-fe0f",
				"2668"
			],
			"decimal": ""
		},
		"keywords": [
			"hot",
			"hotsprings",
			"springs",
			"steaming"
		]
	},
	"2692": {
		"name": "hammer and pick",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1797,
		"display": 1,
		"shortname": ":hammer_pick:",
		"shortname_alternates": [
			":hammer_and_pick:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2692",
			"fully_qualified": "2692-fe0f",
			"non_fully_qualified": "2692",
			"output": "2692-fe0f",
			"default_matches": [
				"2692-fe0f",
				"2692"
			],
			"greedy_matches": [
				"2692-fe0f",
				"2692"
			],
			"decimal": ""
		},
		"keywords": [
			"hammer",
			"pick",
			"tool"
		]
	},
	"2693": {
		"name": "anchor",
		"unicode_version": 4.1,
		"category": "travel",
		"order": 1673,
		"display": 1,
		"shortname": ":anchor:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2693",
			"fully_qualified": "2693",
			"non_fully_qualified": "2693",
			"output": "2693",
			"default_matches": [
				"2693"
			],
			"greedy_matches": [
				"2693"
			],
			"decimal": ""
		},
		"keywords": [
			"ship",
			"tool"
		]
	},
	"2694": {
		"name": "crossed swords",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1807,
		"display": 1,
		"shortname": ":crossed_swords:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2694",
			"fully_qualified": "2694-fe0f",
			"non_fully_qualified": "2694",
			"output": "2694-fe0f",
			"default_matches": [
				"2694-fe0f",
				"2694"
			],
			"greedy_matches": [
				"2694-fe0f",
				"2694"
			],
			"decimal": ""
		},
		"keywords": [
			"crossed",
			"swords",
			"weapon"
		]
	},
	"2695": {
		"name": "medical symbol",
		"unicode_version": 4.1,
		"category": "people",
		"order": 2510,
		"display": 0,
		"shortname": ":medical_symbol:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2695",
			"fully_qualified": "2695-fe0f",
			"non_fully_qualified": "2695",
			"output": "2695-fe0f",
			"default_matches": [
				"2695-fe0f"
			],
			"greedy_matches": [
				"2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"aesculapius",
			"medicine",
			"staff"
		]
	},
	"2696": {
		"name": "balance scale",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1794,
		"display": 1,
		"shortname": ":scales:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2696",
			"fully_qualified": "2696-fe0f",
			"non_fully_qualified": "2696",
			"output": "2696-fe0f",
			"default_matches": [
				"2696-fe0f",
				"2696"
			],
			"greedy_matches": [
				"2696-fe0f",
				"2696"
			],
			"decimal": ""
		},
		"keywords": [
			"Libra",
			"balance",
			"justice",
			"scales",
			"tool",
			"weight",
			"zodiac"
		]
	},
	"2697": {
		"name": "alembic",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1816,
		"display": 1,
		"shortname": ":alembic:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2697",
			"fully_qualified": "2697-fe0f",
			"non_fully_qualified": "2697",
			"output": "2697-fe0f",
			"default_matches": [
				"2697-fe0f",
				"2697"
			],
			"greedy_matches": [
				"2697-fe0f",
				"2697"
			],
			"decimal": ""
		},
		"keywords": [
			"chemistry",
			"tool"
		]
	},
	"2699": {
		"name": "gear",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1801,
		"display": 1,
		"shortname": ":gear:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2699",
			"fully_qualified": "2699-fe0f",
			"non_fully_qualified": "2699",
			"output": "2699-fe0f",
			"default_matches": [
				"2699-fe0f",
				"2699"
			],
			"greedy_matches": [
				"2699-fe0f",
				"2699"
			],
			"decimal": ""
		},
		"keywords": [
			"tool"
		]
	},
	"2702": {
		"name": "scissors",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1910,
		"display": 1,
		"shortname": ":scissors:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2702",
			"fully_qualified": "2702-fe0f",
			"non_fully_qualified": "2702",
			"output": "2702-fe0f",
			"default_matches": [
				"2702-fe0f",
				"2702"
			],
			"greedy_matches": [
				"2702-fe0f",
				"2702"
			],
			"decimal": ""
		},
		"keywords": [
			"cutting",
			"tool"
		]
	},
	"2705": {
		"name": "white heavy check mark",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2024,
		"display": 1,
		"shortname": ":white_check_mark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2705",
			"fully_qualified": "2705",
			"non_fully_qualified": "2705",
			"output": "2705",
			"default_matches": [
				"2705"
			],
			"greedy_matches": [
				"2705"
			],
			"decimal": ""
		},
		"keywords": [
			"check",
			"mark"
		]
	},
	"2708": {
		"name": "airplane",
		"unicode_version": 1.1,
		"category": "travel",
		"order": 1660,
		"display": 1,
		"shortname": ":airplane:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2708",
			"fully_qualified": "2708-fe0f",
			"non_fully_qualified": "2708",
			"output": "2708-fe0f",
			"default_matches": [
				"2708-fe0f",
				"2708"
			],
			"greedy_matches": [
				"2708-fe0f",
				"2708"
			],
			"decimal": ""
		},
		"keywords": [
			"aeroplane",
			"airplane"
		]
	},
	"2709": {
		"name": "envelope",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1857,
		"display": 1,
		"shortname": ":envelope:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2709",
			"fully_qualified": "2709-fe0f",
			"non_fully_qualified": "2709",
			"output": "2709-fe0f",
			"default_matches": [
				"2709-fe0f",
				"2709"
			],
			"greedy_matches": [
				"2709-fe0f",
				"2709"
			],
			"decimal": ""
		},
		"keywords": [
			"email",
			"letter"
		]
	},
	"2712": {
		"name": "black nib",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1913,
		"display": 1,
		"shortname": ":black_nib:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2712",
			"fully_qualified": "2712-fe0f",
			"non_fully_qualified": "2712",
			"output": "2712-fe0f",
			"default_matches": [
				"2712-fe0f",
				"2712"
			],
			"greedy_matches": [
				"2712-fe0f",
				"2712"
			],
			"decimal": ""
		},
		"keywords": [
			"nib",
			"pen"
		]
	},
	"2714": {
		"name": "heavy check mark",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2131,
		"display": 1,
		"shortname": ":heavy_check_mark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2714",
			"fully_qualified": "2714-fe0f",
			"non_fully_qualified": "2714",
			"output": "2714-fe0f",
			"default_matches": [
				"2714-fe0f"
			],
			"greedy_matches": [
				"2714-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"check",
			"mark"
		]
	},
	"2716": {
		"name": "heavy multiplication x",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2117,
		"display": 1,
		"shortname": ":heavy_multiplication_x:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2716",
			"fully_qualified": "2716-fe0f",
			"non_fully_qualified": "2716",
			"output": "2716-fe0f",
			"default_matches": [
				"2716-fe0f"
			],
			"greedy_matches": [
				"2716-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cancel",
			"multiplication",
			"multiply",
			"x"
		]
	},
	"2721": {
		"name": "star of David",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1946,
		"display": 1,
		"shortname": ":star_of_david:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2721",
			"fully_qualified": "2721-fe0f",
			"non_fully_qualified": "2721",
			"output": "2721-fe0f",
			"default_matches": [
				"2721-fe0f"
			],
			"greedy_matches": [
				"2721-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"David",
			"Jew",
			"Jewish",
			"religion",
			"star"
		]
	},
	"2728": {
		"name": "sparkles",
		"unicode_version": 6,
		"category": "nature",
		"order": 1144,
		"display": 1,
		"shortname": ":sparkles:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2728",
			"fully_qualified": "2728",
			"non_fully_qualified": "2728",
			"output": "2728",
			"default_matches": [
				"2728"
			],
			"greedy_matches": [
				"2728"
			],
			"decimal": ""
		},
		"keywords": [
			"sparkle",
			"star"
		]
	},
	"2733": {
		"name": "eight-spoked asterisk",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2028,
		"display": 1,
		"shortname": ":eight_spoked_asterisk:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2733",
			"fully_qualified": "2733-fe0f",
			"non_fully_qualified": "2733",
			"output": "2733-fe0f",
			"default_matches": [
				"2733-fe0f",
				"2733"
			],
			"greedy_matches": [
				"2733-fe0f",
				"2733"
			],
			"decimal": ""
		},
		"keywords": [
			"asterisk"
		]
	},
	"2734": {
		"name": "eight-pointed star",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1977,
		"display": 1,
		"shortname": ":eight_pointed_black_star:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2734",
			"fully_qualified": "2734-fe0f",
			"non_fully_qualified": "2734",
			"output": "2734-fe0f",
			"default_matches": [
				"2734-fe0f",
				"2734"
			],
			"greedy_matches": [
				"2734-fe0f",
				"2734"
			],
			"decimal": ""
		},
		"keywords": [
			"star"
		]
	},
	"2744": {
		"name": "snowflake",
		"unicode_version": 1.1,
		"category": "nature",
		"order": 1162,
		"display": 1,
		"shortname": ":snowflake:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2744",
			"fully_qualified": "2744-fe0f",
			"non_fully_qualified": "2744",
			"output": "2744-fe0f",
			"default_matches": [
				"2744-fe0f",
				"2744"
			],
			"greedy_matches": [
				"2744-fe0f",
				"2744"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"snow"
		]
	},
	"2747": {
		"name": "sparkle",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2027,
		"display": 1,
		"shortname": ":sparkle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2747",
			"fully_qualified": "2747-fe0f",
			"non_fully_qualified": "2747",
			"output": "2747-fe0f",
			"default_matches": [
				"2747-fe0f",
				"2747"
			],
			"greedy_matches": [
				"2747-fe0f",
				"2747"
			],
			"decimal": ""
		},
		"keywords": [
			"sparkle"
		]
	},
	"2753": {
		"name": "question mark",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2011,
		"display": 1,
		"shortname": ":question:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2753",
			"fully_qualified": "2753",
			"non_fully_qualified": "2753",
			"output": "2753",
			"default_matches": [
				"2753"
			],
			"greedy_matches": [
				"2753"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"punctuation",
			"question"
		]
	},
	"2754": {
		"name": "white question mark",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2012,
		"display": 1,
		"shortname": ":grey_question:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2754",
			"fully_qualified": "2754",
			"non_fully_qualified": "2754",
			"output": "2754",
			"default_matches": [
				"2754"
			],
			"greedy_matches": [
				"2754"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"outlined",
			"punctuation",
			"question"
		]
	},
	"2755": {
		"name": "white exclamation mark",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2010,
		"display": 1,
		"shortname": ":grey_exclamation:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2755",
			"fully_qualified": "2755",
			"non_fully_qualified": "2755",
			"output": "2755",
			"default_matches": [
				"2755"
			],
			"greedy_matches": [
				"2755"
			],
			"decimal": ""
		},
		"keywords": [
			"exclamation",
			"mark",
			"outlined",
			"punctuation"
		]
	},
	"2757": {
		"name": "exclamation mark",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 2009,
		"display": 1,
		"shortname": ":exclamation:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2757",
			"fully_qualified": "2757",
			"non_fully_qualified": "2757",
			"output": "2757",
			"default_matches": [
				"2757"
			],
			"greedy_matches": [
				"2757"
			],
			"decimal": ""
		},
		"keywords": [
			"exclamation",
			"mark",
			"punctuation"
		]
	},
	"2763": {
		"name": "heavy heart exclamation",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1932,
		"display": 1,
		"shortname": ":heart_exclamation:",
		"shortname_alternates": [
			":heavy_heart_exclamation_mark_ornament:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2763",
			"fully_qualified": "2763-fe0f",
			"non_fully_qualified": "2763",
			"output": "2763-fe0f",
			"default_matches": [
				"2763-fe0f",
				"2763"
			],
			"greedy_matches": [
				"2763-fe0f",
				"2763"
			],
			"decimal": ""
		},
		"keywords": [
			"exclamation",
			"mark",
			"punctuation"
		]
	},
	"2764": {
		"name": "red heart",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1925,
		"display": 1,
		"shortname": ":heart:",
		"shortname_alternates": [],
		"ascii": [
			"<3"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2764",
			"fully_qualified": "2764-fe0f",
			"non_fully_qualified": "2764",
			"output": "2764-fe0f",
			"default_matches": [
				"2764-fe0f",
				"2764"
			],
			"greedy_matches": [
				"2764-fe0f",
				"2764"
			],
			"decimal": ""
		},
		"keywords": [
			"heart"
		]
	},
	"2795": {
		"name": "heavy plus sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2114,
		"display": 1,
		"shortname": ":heavy_plus_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2795",
			"fully_qualified": "2795",
			"non_fully_qualified": "2795",
			"output": "2795",
			"default_matches": [
				"2795"
			],
			"greedy_matches": [
				"2795"
			],
			"decimal": ""
		},
		"keywords": [
			"math",
			"plus"
		]
	},
	"2796": {
		"name": "heavy minus sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2115,
		"display": 1,
		"shortname": ":heavy_minus_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2796",
			"fully_qualified": "2796",
			"non_fully_qualified": "2796",
			"output": "2796",
			"default_matches": [
				"2796"
			],
			"greedy_matches": [
				"2796"
			],
			"decimal": ""
		},
		"keywords": [
			"math",
			"minus"
		]
	},
	"2797": {
		"name": "heavy division sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2116,
		"display": 1,
		"shortname": ":heavy_division_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2797",
			"fully_qualified": "2797",
			"non_fully_qualified": "2797",
			"output": "2797",
			"default_matches": [
				"2797"
			],
			"greedy_matches": [
				"2797"
			],
			"decimal": ""
		},
		"keywords": [
			"division",
			"math"
		]
	},
	"2934": {
		"name": "right arrow curving up",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2105,
		"display": 1,
		"shortname": ":arrow_heading_up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2934",
			"fully_qualified": "2934-fe0f",
			"non_fully_qualified": "2934",
			"output": "2934-fe0f",
			"default_matches": [
				"2934-fe0f"
			],
			"greedy_matches": [
				"2934-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow"
		]
	},
	"2935": {
		"name": "right arrow curving down",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2106,
		"display": 1,
		"shortname": ":arrow_heading_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2935",
			"fully_qualified": "2935-fe0f",
			"non_fully_qualified": "2935",
			"output": "2935-fe0f",
			"default_matches": [
				"2935-fe0f"
			],
			"greedy_matches": [
				"2935-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"down"
		]
	},
	"3030": {
		"name": "wavy dash",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2123,
		"display": 1,
		"shortname": ":wavy_dash:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "3030",
			"fully_qualified": "3030-fe0f",
			"non_fully_qualified": "3030",
			"output": "3030-fe0f",
			"default_matches": [
				"3030-fe0f"
			],
			"greedy_matches": [
				"3030-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dash",
			"punctuation",
			"wavy"
		]
	},
	"3297": {
		"name": "Japanese “congratulations” button",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1982,
		"display": 1,
		"shortname": ":congratulations:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "3297",
			"fully_qualified": "3297-fe0f",
			"non_fully_qualified": "3297",
			"output": "3297-fe0f",
			"default_matches": [
				"3297-fe0f",
				"3297"
			],
			"greedy_matches": [
				"3297-fe0f",
				"3297"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“congratulations”",
			"祝"
		]
	},
	"3299": {
		"name": "Japanese “secret” button",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1981,
		"display": 1,
		"shortname": ":secret:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "3299",
			"fully_qualified": "3299-fe0f",
			"non_fully_qualified": "3299",
			"output": "3299-fe0f",
			"default_matches": [
				"3299-fe0f",
				"3299"
			],
			"greedy_matches": [
				"3299-fe0f",
				"3299"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“secret”",
			"秘"
		]
	},
	"1f600": {
		"name": "grinning face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 1,
		"display": 1,
		"shortname": ":grinning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f600",
			"fully_qualified": "1f600",
			"non_fully_qualified": "1f600",
			"output": "1f600",
			"default_matches": [
				"1f600"
			],
			"greedy_matches": [
				"1f600"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"grin"
		]
	},
	"1f603": {
		"name": "smiling face with open mouth",
		"unicode_version": 6,
		"category": "people",
		"order": 2,
		"display": 1,
		"shortname": ":smiley:",
		"shortname_alternates": [],
		"ascii": [
			":D",
			":-D",
			"=D"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f603",
			"fully_qualified": "1f603",
			"non_fully_qualified": "1f603",
			"output": "1f603",
			"default_matches": [
				"1f603"
			],
			"greedy_matches": [
				"1f603"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"mouth",
			"open",
			"smile"
		]
	},
	"1f604": {
		"name": "smiling face with open mouth & smiling eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 3,
		"display": 1,
		"shortname": ":smile:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f604",
			"fully_qualified": "1f604",
			"non_fully_qualified": "1f604",
			"output": "1f604",
			"default_matches": [
				"1f604"
			],
			"greedy_matches": [
				"1f604"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"mouth",
			"open",
			"smile"
		]
	},
	"1f601": {
		"name": "grinning face with smiling eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 4,
		"display": 1,
		"shortname": ":grin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f601",
			"fully_qualified": "1f601",
			"non_fully_qualified": "1f601",
			"output": "1f601",
			"default_matches": [
				"1f601"
			],
			"greedy_matches": [
				"1f601"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"grin",
			"smile"
		]
	},
	"1f606": {
		"name": "smiling face with open mouth & closed eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 5,
		"display": 1,
		"shortname": ":laughing:",
		"shortname_alternates": [
			":satisfied:"
		],
		"ascii": [
			">:)",
			">;)",
			">:-)",
			">=)"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f606",
			"fully_qualified": "1f606",
			"non_fully_qualified": "1f606",
			"output": "1f606",
			"default_matches": [
				"1f606"
			],
			"greedy_matches": [
				"1f606"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"laugh",
			"mouth",
			"open",
			"satisfied",
			"smile"
		]
	},
	"1f605": {
		"name": "smiling face with open mouth & cold sweat",
		"unicode_version": 6,
		"category": "people",
		"order": 6,
		"display": 1,
		"shortname": ":sweat_smile:",
		"shortname_alternates": [],
		"ascii": [
			"':)",
			"':-)",
			"'=)",
			"':D",
			"':-D",
			"'=D"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f605",
			"fully_qualified": "1f605",
			"non_fully_qualified": "1f605",
			"output": "1f605",
			"default_matches": [
				"1f605"
			],
			"greedy_matches": [
				"1f605"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"face",
			"open",
			"smile",
			"sweat"
		]
	},
	"1f602": {
		"name": "face with tears of joy",
		"unicode_version": 6,
		"category": "people",
		"order": 7,
		"display": 1,
		"shortname": ":joy:",
		"shortname_alternates": [],
		"ascii": [
			":')",
			":'-)"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f602",
			"fully_qualified": "1f602",
			"non_fully_qualified": "1f602",
			"output": "1f602",
			"default_matches": [
				"1f602"
			],
			"greedy_matches": [
				"1f602"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"joy",
			"laugh",
			"tear"
		]
	},
	"1f923": {
		"name": "rolling on the floor laughing",
		"unicode_version": 9,
		"category": "people",
		"order": 8,
		"display": 1,
		"shortname": ":rofl:",
		"shortname_alternates": [
			":rolling_on_the_floor_laughing:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f923",
			"fully_qualified": "1f923",
			"non_fully_qualified": "1f923",
			"output": "1f923",
			"default_matches": [
				"1f923"
			],
			"greedy_matches": [
				"1f923"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"floor",
			"laugh",
			"rolling"
		]
	},
	"263a": {
		"name": "smiling face",
		"unicode_version": 1.1,
		"category": "people",
		"order": 9,
		"display": 1,
		"shortname": ":relaxed:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "263a",
			"fully_qualified": "263a-fe0f",
			"non_fully_qualified": "263a",
			"output": "263a-fe0f",
			"default_matches": [
				"263a-fe0f",
				"263a"
			],
			"greedy_matches": [
				"263a-fe0f",
				"263a"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"outlined",
			"relaxed",
			"smile"
		]
	},
	"1f60a": {
		"name": "smiling face with smiling eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 10,
		"display": 1,
		"shortname": ":blush:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60a",
			"fully_qualified": "1f60a",
			"non_fully_qualified": "1f60a",
			"output": "1f60a",
			"default_matches": [
				"1f60a"
			],
			"greedy_matches": [
				"1f60a"
			],
			"decimal": ""
		},
		"keywords": [
			"blush",
			"eye",
			"face",
			"smile"
		]
	},
	"1f607": {
		"name": "smiling face with halo",
		"unicode_version": 6,
		"category": "people",
		"order": 11,
		"display": 1,
		"shortname": ":innocent:",
		"shortname_alternates": [],
		"ascii": [
			"O:-)",
			"0:-3",
			"0:3",
			"0:-)",
			"0:)",
			"0;^)",
			"O:)",
			"O;-)",
			"O=)",
			"0;-)",
			"O:-3",
			"O:3"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f607",
			"fully_qualified": "1f607",
			"non_fully_qualified": "1f607",
			"output": "1f607",
			"default_matches": [
				"1f607"
			],
			"greedy_matches": [
				"1f607"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"face",
			"fairy tale",
			"fantasy",
			"halo",
			"innocent",
			"smile"
		]
	},
	"1f642": {
		"name": "slightly smiling face",
		"unicode_version": 7,
		"category": "people",
		"order": 12,
		"display": 1,
		"shortname": ":slight_smile:",
		"shortname_alternates": [
			":slightly_smiling_face:"
		],
		"ascii": [
			":)",
			":-)",
			"=]",
			"=)",
			":]"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f642",
			"fully_qualified": "1f642",
			"non_fully_qualified": "1f642",
			"output": "1f642",
			"default_matches": [
				"1f642"
			],
			"greedy_matches": [
				"1f642"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"smile"
		]
	},
	"1f643": {
		"name": "upside-down face",
		"unicode_version": 8,
		"category": "people",
		"order": 13,
		"display": 1,
		"shortname": ":upside_down:",
		"shortname_alternates": [
			":upside_down_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f643",
			"fully_qualified": "1f643",
			"non_fully_qualified": "1f643",
			"output": "1f643",
			"default_matches": [
				"1f643"
			],
			"greedy_matches": [
				"1f643"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"upside-down"
		]
	},
	"1f609": {
		"name": "winking face",
		"unicode_version": 6,
		"category": "people",
		"order": 14,
		"display": 1,
		"shortname": ":wink:",
		"shortname_alternates": [],
		"ascii": [
			";)",
			";-)",
			"*-)",
			"*)",
			";-]",
			";]",
			";D",
			";^)"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f609",
			"fully_qualified": "1f609",
			"non_fully_qualified": "1f609",
			"output": "1f609",
			"default_matches": [
				"1f609"
			],
			"greedy_matches": [
				"1f609"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"wink"
		]
	},
	"1f60c": {
		"name": "relieved face",
		"unicode_version": 6,
		"category": "people",
		"order": 15,
		"display": 1,
		"shortname": ":relieved:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60c",
			"fully_qualified": "1f60c",
			"non_fully_qualified": "1f60c",
			"output": "1f60c",
			"default_matches": [
				"1f60c"
			],
			"greedy_matches": [
				"1f60c"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"relieved"
		]
	},
	"1f60d": {
		"name": "smiling face with heart-eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 16,
		"display": 1,
		"shortname": ":heart_eyes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60d",
			"fully_qualified": "1f60d",
			"non_fully_qualified": "1f60d",
			"output": "1f60d",
			"default_matches": [
				"1f60d"
			],
			"greedy_matches": [
				"1f60d"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"love",
			"smile"
		]
	},
	"1f618": {
		"name": "face blowing a kiss",
		"unicode_version": 6,
		"category": "people",
		"order": 17,
		"display": 1,
		"shortname": ":kissing_heart:",
		"shortname_alternates": [],
		"ascii": [
			":*",
			":-*",
			"=*",
			":^*"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f618",
			"fully_qualified": "1f618",
			"non_fully_qualified": "1f618",
			"output": "1f618",
			"default_matches": [
				"1f618"
			],
			"greedy_matches": [
				"1f618"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"kiss"
		]
	},
	"1f617": {
		"name": "kissing face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 18,
		"display": 1,
		"shortname": ":kissing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f617",
			"fully_qualified": "1f617",
			"non_fully_qualified": "1f617",
			"output": "1f617",
			"default_matches": [
				"1f617"
			],
			"greedy_matches": [
				"1f617"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"kiss"
		]
	},
	"1f619": {
		"name": "kissing face with smiling eyes",
		"unicode_version": 6.1,
		"category": "people",
		"order": 19,
		"display": 1,
		"shortname": ":kissing_smiling_eyes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f619",
			"fully_qualified": "1f619",
			"non_fully_qualified": "1f619",
			"output": "1f619",
			"default_matches": [
				"1f619"
			],
			"greedy_matches": [
				"1f619"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"kiss",
			"smile"
		]
	},
	"1f61a": {
		"name": "kissing face with closed eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 20,
		"display": 1,
		"shortname": ":kissing_closed_eyes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61a",
			"fully_qualified": "1f61a",
			"non_fully_qualified": "1f61a",
			"output": "1f61a",
			"default_matches": [
				"1f61a"
			],
			"greedy_matches": [
				"1f61a"
			],
			"decimal": ""
		},
		"keywords": [
			"closed",
			"eye",
			"face",
			"kiss"
		]
	},
	"1f60b": {
		"name": "face savouring delicious food",
		"unicode_version": 6,
		"category": "people",
		"order": 21,
		"display": 1,
		"shortname": ":yum:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60b",
			"fully_qualified": "1f60b",
			"non_fully_qualified": "1f60b",
			"output": "1f60b",
			"default_matches": [
				"1f60b"
			],
			"greedy_matches": [
				"1f60b"
			],
			"decimal": ""
		},
		"keywords": [
			"delicious",
			"face",
			"savouring",
			"smile",
			"um",
			"yum"
		]
	},
	"1f61c": {
		"name": "face with stuck-out tongue & winking eye",
		"unicode_version": 6,
		"category": "people",
		"order": 22,
		"display": 1,
		"shortname": ":stuck_out_tongue_winking_eye:",
		"shortname_alternates": [],
		"ascii": [
			">:P",
			"X-P"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61c",
			"fully_qualified": "1f61c",
			"non_fully_qualified": "1f61c",
			"output": "1f61c",
			"default_matches": [
				"1f61c"
			],
			"greedy_matches": [
				"1f61c"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"joke",
			"tongue",
			"wink"
		]
	},
	"1f61d": {
		"name": "face with stuck-out tongue & closed eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 23,
		"display": 1,
		"shortname": ":stuck_out_tongue_closed_eyes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61d",
			"fully_qualified": "1f61d",
			"non_fully_qualified": "1f61d",
			"output": "1f61d",
			"default_matches": [
				"1f61d"
			],
			"greedy_matches": [
				"1f61d"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face",
			"horrible",
			"taste",
			"tongue"
		]
	},
	"1f61b": {
		"name": "face with stuck-out tongue",
		"unicode_version": 6.1,
		"category": "people",
		"order": 24,
		"display": 1,
		"shortname": ":stuck_out_tongue:",
		"shortname_alternates": [],
		"ascii": [
			":P",
			":-P",
			"=P",
			":-Þ",
			":Þ",
			":-b",
			":b"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61b",
			"fully_qualified": "1f61b",
			"non_fully_qualified": "1f61b",
			"output": "1f61b",
			"default_matches": [
				"1f61b"
			],
			"greedy_matches": [
				"1f61b"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"tongue"
		]
	},
	"1f911": {
		"name": "money-mouth face",
		"unicode_version": 8,
		"category": "people",
		"order": 25,
		"display": 1,
		"shortname": ":money_mouth:",
		"shortname_alternates": [
			":money_mouth_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f911",
			"fully_qualified": "1f911",
			"non_fully_qualified": "1f911",
			"output": "1f911",
			"default_matches": [
				"1f911"
			],
			"greedy_matches": [
				"1f911"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"money",
			"mouth"
		]
	},
	"1f917": {
		"name": "hugging face",
		"unicode_version": 8,
		"category": "people",
		"order": 26,
		"display": 1,
		"shortname": ":hugging:",
		"shortname_alternates": [
			":hugging_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f917",
			"fully_qualified": "1f917",
			"non_fully_qualified": "1f917",
			"output": "1f917",
			"default_matches": [
				"1f917"
			],
			"greedy_matches": [
				"1f917"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"hug",
			"hugging"
		]
	},
	"1f913": {
		"name": "nerd face",
		"unicode_version": 8,
		"category": "people",
		"order": 27,
		"display": 1,
		"shortname": ":nerd:",
		"shortname_alternates": [
			":nerd_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f913",
			"fully_qualified": "1f913",
			"non_fully_qualified": "1f913",
			"output": "1f913",
			"default_matches": [
				"1f913"
			],
			"greedy_matches": [
				"1f913"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"geek",
			"nerd"
		]
	},
	"1f60e": {
		"name": "smiling face with sunglasses",
		"unicode_version": 6,
		"category": "people",
		"order": 28,
		"display": 1,
		"shortname": ":sunglasses:",
		"shortname_alternates": [],
		"ascii": [
			"B-)",
			"B)",
			"8)",
			"8-)",
			"B-D",
			"8-D"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60e",
			"fully_qualified": "1f60e",
			"non_fully_qualified": "1f60e",
			"output": "1f60e",
			"default_matches": [
				"1f60e"
			],
			"greedy_matches": [
				"1f60e"
			],
			"decimal": ""
		},
		"keywords": [
			"bright",
			"cool",
			"eye",
			"eyewear",
			"face",
			"glasses",
			"smile",
			"sun",
			"sunglasses"
		]
	},
	"1f921": {
		"name": "clown face",
		"unicode_version": 9,
		"category": "people",
		"order": 29,
		"display": 1,
		"shortname": ":clown:",
		"shortname_alternates": [
			":clown_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f921",
			"fully_qualified": "1f921",
			"non_fully_qualified": "1f921",
			"output": "1f921",
			"default_matches": [
				"1f921"
			],
			"greedy_matches": [
				"1f921"
			],
			"decimal": ""
		},
		"keywords": [
			"clown",
			"face"
		]
	},
	"1f920": {
		"name": "cowboy hat face",
		"unicode_version": 9,
		"category": "people",
		"order": 30,
		"display": 1,
		"shortname": ":cowboy:",
		"shortname_alternates": [
			":face_with_cowboy_hat:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f920",
			"fully_qualified": "1f920",
			"non_fully_qualified": "1f920",
			"output": "1f920",
			"default_matches": [
				"1f920"
			],
			"greedy_matches": [
				"1f920"
			],
			"decimal": ""
		},
		"keywords": [
			"cowboy",
			"cowgirl",
			"face",
			"hat"
		]
	},
	"1f60f": {
		"name": "smirking face",
		"unicode_version": 6,
		"category": "people",
		"order": 31,
		"display": 1,
		"shortname": ":smirk:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f60f",
			"fully_qualified": "1f60f",
			"non_fully_qualified": "1f60f",
			"output": "1f60f",
			"default_matches": [
				"1f60f"
			],
			"greedy_matches": [
				"1f60f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"smirk"
		]
	},
	"1f612": {
		"name": "unamused face",
		"unicode_version": 6,
		"category": "people",
		"order": 32,
		"display": 1,
		"shortname": ":unamused:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f612",
			"fully_qualified": "1f612",
			"non_fully_qualified": "1f612",
			"output": "1f612",
			"default_matches": [
				"1f612"
			],
			"greedy_matches": [
				"1f612"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"unamused",
			"unhappy"
		]
	},
	"1f61e": {
		"name": "disappointed face",
		"unicode_version": 6,
		"category": "people",
		"order": 33,
		"display": 1,
		"shortname": ":disappointed:",
		"shortname_alternates": [],
		"ascii": [
			">:[",
			":-(",
			":(",
			":-[",
			":[",
			"=("
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61e",
			"fully_qualified": "1f61e",
			"non_fully_qualified": "1f61e",
			"output": "1f61e",
			"default_matches": [
				"1f61e"
			],
			"greedy_matches": [
				"1f61e"
			],
			"decimal": ""
		},
		"keywords": [
			"disappointed",
			"face"
		]
	},
	"1f614": {
		"name": "pensive face",
		"unicode_version": 6,
		"category": "people",
		"order": 34,
		"display": 1,
		"shortname": ":pensive:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f614",
			"fully_qualified": "1f614",
			"non_fully_qualified": "1f614",
			"output": "1f614",
			"default_matches": [
				"1f614"
			],
			"greedy_matches": [
				"1f614"
			],
			"decimal": ""
		},
		"keywords": [
			"dejected",
			"face",
			"pensive"
		]
	},
	"1f61f": {
		"name": "worried face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 35,
		"display": 1,
		"shortname": ":worried:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f61f",
			"fully_qualified": "1f61f",
			"non_fully_qualified": "1f61f",
			"output": "1f61f",
			"default_matches": [
				"1f61f"
			],
			"greedy_matches": [
				"1f61f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"worried"
		]
	},
	"1f615": {
		"name": "confused face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 36,
		"display": 1,
		"shortname": ":confused:",
		"shortname_alternates": [],
		"ascii": [
			">:\\",
			">:/",
			":-/",
			":-.",
			":/",
			":\\",
			"=/",
			"=\\",
			":L",
			"=L"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f615",
			"fully_qualified": "1f615",
			"non_fully_qualified": "1f615",
			"output": "1f615",
			"default_matches": [
				"1f615"
			],
			"greedy_matches": [
				"1f615"
			],
			"decimal": ""
		},
		"keywords": [
			"confused",
			"face"
		]
	},
	"1f641": {
		"name": "slightly frowning face",
		"unicode_version": 7,
		"category": "people",
		"order": 37,
		"display": 1,
		"shortname": ":slight_frown:",
		"shortname_alternates": [
			":slightly_frowning_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f641",
			"fully_qualified": "1f641",
			"non_fully_qualified": "1f641",
			"output": "1f641",
			"default_matches": [
				"1f641"
			],
			"greedy_matches": [
				"1f641"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"frown"
		]
	},
	"1f623": {
		"name": "persevering face",
		"unicode_version": 6,
		"category": "people",
		"order": 39,
		"display": 1,
		"shortname": ":persevere:",
		"shortname_alternates": [],
		"ascii": [
			">.<"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f623",
			"fully_qualified": "1f623",
			"non_fully_qualified": "1f623",
			"output": "1f623",
			"default_matches": [
				"1f623"
			],
			"greedy_matches": [
				"1f623"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"persevere"
		]
	},
	"1f616": {
		"name": "confounded face",
		"unicode_version": 6,
		"category": "people",
		"order": 40,
		"display": 1,
		"shortname": ":confounded:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f616",
			"fully_qualified": "1f616",
			"non_fully_qualified": "1f616",
			"output": "1f616",
			"default_matches": [
				"1f616"
			],
			"greedy_matches": [
				"1f616"
			],
			"decimal": ""
		},
		"keywords": [
			"confounded",
			"face"
		]
	},
	"1f62b": {
		"name": "tired face",
		"unicode_version": 6,
		"category": "people",
		"order": 41,
		"display": 1,
		"shortname": ":tired_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62b",
			"fully_qualified": "1f62b",
			"non_fully_qualified": "1f62b",
			"output": "1f62b",
			"default_matches": [
				"1f62b"
			],
			"greedy_matches": [
				"1f62b"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"tired"
		]
	},
	"1f629": {
		"name": "weary face",
		"unicode_version": 6,
		"category": "people",
		"order": 42,
		"display": 1,
		"shortname": ":weary:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f629",
			"fully_qualified": "1f629",
			"non_fully_qualified": "1f629",
			"output": "1f629",
			"default_matches": [
				"1f629"
			],
			"greedy_matches": [
				"1f629"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"tired",
			"weary"
		]
	},
	"1f624": {
		"name": "face with steam from nose",
		"unicode_version": 6,
		"category": "people",
		"order": 43,
		"display": 1,
		"shortname": ":triumph:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f624",
			"fully_qualified": "1f624",
			"non_fully_qualified": "1f624",
			"output": "1f624",
			"default_matches": [
				"1f624"
			],
			"greedy_matches": [
				"1f624"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"triumph",
			"won"
		]
	},
	"1f620": {
		"name": "angry face",
		"unicode_version": 6,
		"category": "people",
		"order": 44,
		"display": 1,
		"shortname": ":angry:",
		"shortname_alternates": [],
		"ascii": [
			">:(",
			">:-(",
			":@"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f620",
			"fully_qualified": "1f620",
			"non_fully_qualified": "1f620",
			"output": "1f620",
			"default_matches": [
				"1f620"
			],
			"greedy_matches": [
				"1f620"
			],
			"decimal": ""
		},
		"keywords": [
			"angry",
			"face",
			"mad"
		]
	},
	"1f621": {
		"name": "pouting face",
		"unicode_version": 6,
		"category": "people",
		"order": 45,
		"display": 1,
		"shortname": ":rage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f621",
			"fully_qualified": "1f621",
			"non_fully_qualified": "1f621",
			"output": "1f621",
			"default_matches": [
				"1f621"
			],
			"greedy_matches": [
				"1f621"
			],
			"decimal": ""
		},
		"keywords": [
			"angry",
			"face",
			"mad",
			"pouting",
			"rage",
			"red"
		]
	},
	"1f636": {
		"name": "face without mouth",
		"unicode_version": 6,
		"category": "people",
		"order": 46,
		"display": 1,
		"shortname": ":no_mouth:",
		"shortname_alternates": [],
		"ascii": [
			":-X",
			":X",
			":-#",
			":#",
			"=X",
			"=#"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f636",
			"fully_qualified": "1f636",
			"non_fully_qualified": "1f636",
			"output": "1f636",
			"default_matches": [
				"1f636"
			],
			"greedy_matches": [
				"1f636"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"mouth",
			"quiet",
			"silent"
		]
	},
	"1f610": {
		"name": "neutral face",
		"unicode_version": 6,
		"category": "people",
		"order": 47,
		"display": 1,
		"shortname": ":neutral_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f610",
			"fully_qualified": "1f610",
			"non_fully_qualified": "1f610",
			"output": "1f610",
			"default_matches": [
				"1f610"
			],
			"greedy_matches": [
				"1f610"
			],
			"decimal": ""
		},
		"keywords": [
			"deadpan",
			"face",
			"neutral"
		]
	},
	"1f611": {
		"name": "expressionless face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 48,
		"display": 1,
		"shortname": ":expressionless:",
		"shortname_alternates": [],
		"ascii": [
			"-_-",
			"-__-",
			"-___-"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f611",
			"fully_qualified": "1f611",
			"non_fully_qualified": "1f611",
			"output": "1f611",
			"default_matches": [
				"1f611"
			],
			"greedy_matches": [
				"1f611"
			],
			"decimal": ""
		},
		"keywords": [
			"expressionless",
			"face",
			"inexpressive",
			"unexpressive"
		]
	},
	"1f62f": {
		"name": "hushed face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 49,
		"display": 1,
		"shortname": ":hushed:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62f",
			"fully_qualified": "1f62f",
			"non_fully_qualified": "1f62f",
			"output": "1f62f",
			"default_matches": [
				"1f62f"
			],
			"greedy_matches": [
				"1f62f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"hushed",
			"stunned",
			"surprised"
		]
	},
	"1f626": {
		"name": "frowning face with open mouth",
		"unicode_version": 6.1,
		"category": "people",
		"order": 50,
		"display": 1,
		"shortname": ":frowning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f626",
			"fully_qualified": "1f626",
			"non_fully_qualified": "1f626",
			"output": "1f626",
			"default_matches": [
				"1f626"
			],
			"greedy_matches": [
				"1f626"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"frown",
			"mouth",
			"open"
		]
	},
	"1f627": {
		"name": "anguished face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 51,
		"display": 1,
		"shortname": ":anguished:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f627",
			"fully_qualified": "1f627",
			"non_fully_qualified": "1f627",
			"output": "1f627",
			"default_matches": [
				"1f627"
			],
			"greedy_matches": [
				"1f627"
			],
			"decimal": ""
		},
		"keywords": [
			"anguished",
			"face"
		]
	},
	"1f62e": {
		"name": "face with open mouth",
		"unicode_version": 6.1,
		"category": "people",
		"order": 52,
		"display": 1,
		"shortname": ":open_mouth:",
		"shortname_alternates": [],
		"ascii": [
			":-O",
			":O",
			"O_O",
			">:O"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62e",
			"fully_qualified": "1f62e",
			"non_fully_qualified": "1f62e",
			"output": "1f62e",
			"default_matches": [
				"1f62e"
			],
			"greedy_matches": [
				"1f62e"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"mouth",
			"open",
			"sympathy"
		]
	},
	"1f632": {
		"name": "astonished face",
		"unicode_version": 6,
		"category": "people",
		"order": 53,
		"display": 1,
		"shortname": ":astonished:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f632",
			"fully_qualified": "1f632",
			"non_fully_qualified": "1f632",
			"output": "1f632",
			"default_matches": [
				"1f632"
			],
			"greedy_matches": [
				"1f632"
			],
			"decimal": ""
		},
		"keywords": [
			"astonished",
			"face",
			"shocked",
			"totally"
		]
	},
	"1f635": {
		"name": "dizzy face",
		"unicode_version": 6,
		"category": "people",
		"order": 54,
		"display": 1,
		"shortname": ":dizzy_face:",
		"shortname_alternates": [],
		"ascii": [
			"#-)",
			"#)",
			"%-)",
			"%)",
			"X)",
			"X-)"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f635",
			"fully_qualified": "1f635",
			"non_fully_qualified": "1f635",
			"output": "1f635",
			"default_matches": [
				"1f635"
			],
			"greedy_matches": [
				"1f635"
			],
			"decimal": ""
		},
		"keywords": [
			"dizzy",
			"face"
		]
	},
	"1f633": {
		"name": "flushed face",
		"unicode_version": 6,
		"category": "people",
		"order": 55,
		"display": 1,
		"shortname": ":flushed:",
		"shortname_alternates": [],
		"ascii": [
			":$",
			"=$"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f633",
			"fully_qualified": "1f633",
			"non_fully_qualified": "1f633",
			"output": "1f633",
			"default_matches": [
				"1f633"
			],
			"greedy_matches": [
				"1f633"
			],
			"decimal": ""
		},
		"keywords": [
			"dazed",
			"face",
			"flushed"
		]
	},
	"1f631": {
		"name": "face screaming in fear",
		"unicode_version": 6,
		"category": "people",
		"order": 56,
		"display": 1,
		"shortname": ":scream:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f631",
			"fully_qualified": "1f631",
			"non_fully_qualified": "1f631",
			"output": "1f631",
			"default_matches": [
				"1f631"
			],
			"greedy_matches": [
				"1f631"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"fear",
			"fearful",
			"munch",
			"scared",
			"scream"
		]
	},
	"1f628": {
		"name": "fearful face",
		"unicode_version": 6,
		"category": "people",
		"order": 57,
		"display": 1,
		"shortname": ":fearful:",
		"shortname_alternates": [],
		"ascii": [
			"D:"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f628",
			"fully_qualified": "1f628",
			"non_fully_qualified": "1f628",
			"output": "1f628",
			"default_matches": [
				"1f628"
			],
			"greedy_matches": [
				"1f628"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"fear",
			"fearful",
			"scared"
		]
	},
	"1f630": {
		"name": "face with open mouth & cold sweat",
		"unicode_version": 6,
		"category": "people",
		"order": 58,
		"display": 1,
		"shortname": ":cold_sweat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f630",
			"fully_qualified": "1f630",
			"non_fully_qualified": "1f630",
			"output": "1f630",
			"default_matches": [
				"1f630"
			],
			"greedy_matches": [
				"1f630"
			],
			"decimal": ""
		},
		"keywords": [
			"blue",
			"cold",
			"face",
			"mouth",
			"open",
			"rushed",
			"sweat"
		]
	},
	"1f622": {
		"name": "crying face",
		"unicode_version": 6,
		"category": "people",
		"order": 59,
		"display": 1,
		"shortname": ":cry:",
		"shortname_alternates": [],
		"ascii": [
			":'(",
			":'-(",
			";(",
			";-("
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f622",
			"fully_qualified": "1f622",
			"non_fully_qualified": "1f622",
			"output": "1f622",
			"default_matches": [
				"1f622"
			],
			"greedy_matches": [
				"1f622"
			],
			"decimal": ""
		},
		"keywords": [
			"cry",
			"face",
			"sad",
			"tear"
		]
	},
	"1f625": {
		"name": "disappointed but relieved face",
		"unicode_version": 6,
		"category": "people",
		"order": 60,
		"display": 1,
		"shortname": ":disappointed_relieved:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f625",
			"fully_qualified": "1f625",
			"non_fully_qualified": "1f625",
			"output": "1f625",
			"default_matches": [
				"1f625"
			],
			"greedy_matches": [
				"1f625"
			],
			"decimal": ""
		},
		"keywords": [
			"disappointed",
			"face",
			"relieved",
			"whew"
		]
	},
	"1f924": {
		"name": "drooling face",
		"unicode_version": 9,
		"category": "people",
		"order": 61,
		"display": 1,
		"shortname": ":drooling_face:",
		"shortname_alternates": [
			":drool:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f924",
			"fully_qualified": "1f924",
			"non_fully_qualified": "1f924",
			"output": "1f924",
			"default_matches": [
				"1f924"
			],
			"greedy_matches": [
				"1f924"
			],
			"decimal": ""
		},
		"keywords": [
			"drooling",
			"face"
		]
	},
	"1f62d": {
		"name": "loudly crying face",
		"unicode_version": 6,
		"category": "people",
		"order": 62,
		"display": 1,
		"shortname": ":sob:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62d",
			"fully_qualified": "1f62d",
			"non_fully_qualified": "1f62d",
			"output": "1f62d",
			"default_matches": [
				"1f62d"
			],
			"greedy_matches": [
				"1f62d"
			],
			"decimal": ""
		},
		"keywords": [
			"cry",
			"face",
			"sad",
			"sob",
			"tear"
		]
	},
	"1f613": {
		"name": "face with cold sweat",
		"unicode_version": 6,
		"category": "people",
		"order": 63,
		"display": 1,
		"shortname": ":sweat:",
		"shortname_alternates": [],
		"ascii": [
			"':(",
			"':-(",
			"'=("
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f613",
			"fully_qualified": "1f613",
			"non_fully_qualified": "1f613",
			"output": "1f613",
			"default_matches": [
				"1f613"
			],
			"greedy_matches": [
				"1f613"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"face",
			"sweat"
		]
	},
	"1f62a": {
		"name": "sleepy face",
		"unicode_version": 6,
		"category": "people",
		"order": 64,
		"display": 1,
		"shortname": ":sleepy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62a",
			"fully_qualified": "1f62a",
			"non_fully_qualified": "1f62a",
			"output": "1f62a",
			"default_matches": [
				"1f62a"
			],
			"greedy_matches": [
				"1f62a"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"sleep"
		]
	},
	"1f634": {
		"name": "sleeping face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 65,
		"display": 1,
		"shortname": ":sleeping:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f634",
			"fully_qualified": "1f634",
			"non_fully_qualified": "1f634",
			"output": "1f634",
			"default_matches": [
				"1f634"
			],
			"greedy_matches": [
				"1f634"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"sleep",
			"zzz"
		]
	},
	"1f644": {
		"name": "face with rolling eyes",
		"unicode_version": 8,
		"category": "people",
		"order": 66,
		"display": 1,
		"shortname": ":rolling_eyes:",
		"shortname_alternates": [
			":face_with_rolling_eyes:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f644",
			"fully_qualified": "1f644",
			"non_fully_qualified": "1f644",
			"output": "1f644",
			"default_matches": [
				"1f644"
			],
			"greedy_matches": [
				"1f644"
			],
			"decimal": ""
		},
		"keywords": [
			"eyes",
			"face",
			"rolling"
		]
	},
	"1f914": {
		"name": "thinking face",
		"unicode_version": 8,
		"category": "people",
		"order": 67,
		"display": 1,
		"shortname": ":thinking:",
		"shortname_alternates": [
			":thinking_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f914",
			"fully_qualified": "1f914",
			"non_fully_qualified": "1f914",
			"output": "1f914",
			"default_matches": [
				"1f914"
			],
			"greedy_matches": [
				"1f914"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"thinking"
		]
	},
	"1f925": {
		"name": "lying face",
		"unicode_version": 9,
		"category": "people",
		"order": 68,
		"display": 1,
		"shortname": ":lying_face:",
		"shortname_alternates": [
			":liar:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f925",
			"fully_qualified": "1f925",
			"non_fully_qualified": "1f925",
			"output": "1f925",
			"default_matches": [
				"1f925"
			],
			"greedy_matches": [
				"1f925"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"lie",
			"pinocchio"
		]
	},
	"1f62c": {
		"name": "grimacing face",
		"unicode_version": 6.1,
		"category": "people",
		"order": 69,
		"display": 1,
		"shortname": ":grimacing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f62c",
			"fully_qualified": "1f62c",
			"non_fully_qualified": "1f62c",
			"output": "1f62c",
			"default_matches": [
				"1f62c"
			],
			"greedy_matches": [
				"1f62c"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"grimace"
		]
	},
	"1f910": {
		"name": "zipper-mouth face",
		"unicode_version": 8,
		"category": "people",
		"order": 70,
		"display": 1,
		"shortname": ":zipper_mouth:",
		"shortname_alternates": [
			":zipper_mouth_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f910",
			"fully_qualified": "1f910",
			"non_fully_qualified": "1f910",
			"output": "1f910",
			"default_matches": [
				"1f910"
			],
			"greedy_matches": [
				"1f910"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"mouth",
			"zipper"
		]
	},
	"1f922": {
		"name": "nauseated face",
		"unicode_version": 9,
		"category": "people",
		"order": 71,
		"display": 1,
		"shortname": ":nauseated_face:",
		"shortname_alternates": [
			":sick:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f922",
			"fully_qualified": "1f922",
			"non_fully_qualified": "1f922",
			"output": "1f922",
			"default_matches": [
				"1f922"
			],
			"greedy_matches": [
				"1f922"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"nauseated",
			"vomit"
		]
	},
	"1f927": {
		"name": "sneezing face",
		"unicode_version": 9,
		"category": "people",
		"order": 72,
		"display": 1,
		"shortname": ":sneezing_face:",
		"shortname_alternates": [
			":sneeze:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f927",
			"fully_qualified": "1f927",
			"non_fully_qualified": "1f927",
			"output": "1f927",
			"default_matches": [
				"1f927"
			],
			"greedy_matches": [
				"1f927"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"gesundheit",
			"sneeze"
		]
	},
	"1f637": {
		"name": "face with medical mask",
		"unicode_version": 6,
		"category": "people",
		"order": 73,
		"display": 1,
		"shortname": ":mask:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f637",
			"fully_qualified": "1f637",
			"non_fully_qualified": "1f637",
			"output": "1f637",
			"default_matches": [
				"1f637"
			],
			"greedy_matches": [
				"1f637"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"doctor",
			"face",
			"mask",
			"medicine",
			"sick"
		]
	},
	"1f912": {
		"name": "face with thermometer",
		"unicode_version": 8,
		"category": "people",
		"order": 74,
		"display": 1,
		"shortname": ":thermometer_face:",
		"shortname_alternates": [
			":face_with_thermometer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f912",
			"fully_qualified": "1f912",
			"non_fully_qualified": "1f912",
			"output": "1f912",
			"default_matches": [
				"1f912"
			],
			"greedy_matches": [
				"1f912"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"ill",
			"sick",
			"thermometer"
		]
	},
	"1f915": {
		"name": "face with head-bandage",
		"unicode_version": 8,
		"category": "people",
		"order": 75,
		"display": 1,
		"shortname": ":head_bandage:",
		"shortname_alternates": [
			":face_with_head_bandage:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f915",
			"fully_qualified": "1f915",
			"non_fully_qualified": "1f915",
			"output": "1f915",
			"default_matches": [
				"1f915"
			],
			"greedy_matches": [
				"1f915"
			],
			"decimal": ""
		},
		"keywords": [
			"bandage",
			"face",
			"hurt",
			"injury"
		]
	},
	"1f608": {
		"name": "smiling face with horns",
		"unicode_version": 6,
		"category": "people",
		"order": 76,
		"display": 1,
		"shortname": ":smiling_imp:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f608",
			"fully_qualified": "1f608",
			"non_fully_qualified": "1f608",
			"output": "1f608",
			"default_matches": [
				"1f608"
			],
			"greedy_matches": [
				"1f608"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"fairy tale",
			"fantasy",
			"horns",
			"smile"
		]
	},
	"1f47f": {
		"name": "angry face with horns",
		"unicode_version": 6,
		"category": "people",
		"order": 77,
		"display": 1,
		"shortname": ":imp:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47f",
			"fully_qualified": "1f47f",
			"non_fully_qualified": "1f47f",
			"output": "1f47f",
			"default_matches": [
				"1f47f"
			],
			"greedy_matches": [
				"1f47f"
			],
			"decimal": ""
		},
		"keywords": [
			"demon",
			"devil",
			"face",
			"fairy tale",
			"fantasy",
			"imp"
		]
	},
	"1f479": {
		"name": "ogre",
		"unicode_version": 6,
		"category": "people",
		"order": 78,
		"display": 1,
		"shortname": ":japanese_ogre:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f479",
			"fully_qualified": "1f479",
			"non_fully_qualified": "1f479",
			"output": "1f479",
			"default_matches": [
				"1f479"
			],
			"greedy_matches": [
				"1f479"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f47a": {
		"name": "goblin",
		"unicode_version": 6,
		"category": "people",
		"order": 79,
		"display": 1,
		"shortname": ":japanese_goblin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47a",
			"fully_qualified": "1f47a",
			"non_fully_qualified": "1f47a",
			"output": "1f47a",
			"default_matches": [
				"1f47a"
			],
			"greedy_matches": [
				"1f47a"
			],
			"decimal": ""
		},
		"keywords": [
			"creature",
			"face",
			"fairy tale",
			"fantasy",
			"monster"
		]
	},
	"1f4a9": {
		"name": "pile of poo",
		"unicode_version": 6,
		"category": "people",
		"order": 80,
		"display": 1,
		"shortname": ":poop:",
		"shortname_alternates": [
			":shit:",
			":hankey:",
			":poo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a9",
			"fully_qualified": "1f4a9",
			"non_fully_qualified": "1f4a9",
			"output": "1f4a9",
			"default_matches": [
				"1f4a9"
			],
			"greedy_matches": [
				"1f4a9"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"dung",
			"face",
			"monster",
			"poo",
			"poop"
		]
	},
	"1f47b": {
		"name": "ghost",
		"unicode_version": 6,
		"category": "people",
		"order": 81,
		"display": 1,
		"shortname": ":ghost:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47b",
			"fully_qualified": "1f47b",
			"non_fully_qualified": "1f47b",
			"output": "1f47b",
			"default_matches": [
				"1f47b"
			],
			"greedy_matches": [
				"1f47b"
			],
			"decimal": ""
		},
		"keywords": [
			"creature",
			"face",
			"fairy tale",
			"fantasy",
			"monster"
		]
	},
	"1f480": {
		"name": "skull",
		"unicode_version": 6,
		"category": "people",
		"order": 82,
		"display": 1,
		"shortname": ":skull:",
		"shortname_alternates": [
			":skeleton:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f480",
			"fully_qualified": "1f480",
			"non_fully_qualified": "1f480",
			"output": "1f480",
			"default_matches": [
				"1f480"
			],
			"greedy_matches": [
				"1f480"
			],
			"decimal": ""
		},
		"keywords": [
			"death",
			"face",
			"fairy tale",
			"monster"
		]
	},
	"1f47d": {
		"name": "alien",
		"unicode_version": 6,
		"category": "people",
		"order": 84,
		"display": 1,
		"shortname": ":alien:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47d",
			"fully_qualified": "1f47d",
			"non_fully_qualified": "1f47d",
			"output": "1f47d",
			"default_matches": [
				"1f47d"
			],
			"greedy_matches": [
				"1f47d"
			],
			"decimal": ""
		},
		"keywords": [
			"creature",
			"extraterrestrial",
			"face",
			"fairy tale",
			"fantasy",
			"monster",
			"ufo"
		]
	},
	"1f47e": {
		"name": "alien monster",
		"unicode_version": 6,
		"category": "people",
		"order": 85,
		"display": 1,
		"shortname": ":space_invader:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47e",
			"fully_qualified": "1f47e",
			"non_fully_qualified": "1f47e",
			"output": "1f47e",
			"default_matches": [
				"1f47e"
			],
			"greedy_matches": [
				"1f47e"
			],
			"decimal": ""
		},
		"keywords": [
			"alien",
			"creature",
			"extraterrestrial",
			"face",
			"fairy tale",
			"fantasy",
			"monster",
			"ufo"
		]
	},
	"1f916": {
		"name": "robot face",
		"unicode_version": 8,
		"category": "people",
		"order": 86,
		"display": 1,
		"shortname": ":robot:",
		"shortname_alternates": [
			":robot_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f916",
			"fully_qualified": "1f916",
			"non_fully_qualified": "1f916",
			"output": "1f916",
			"default_matches": [
				"1f916"
			],
			"greedy_matches": [
				"1f916"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"monster",
			"robot"
		]
	},
	"1f383": {
		"name": "jack-o-lantern",
		"unicode_version": 6,
		"category": "people",
		"order": 87,
		"display": 1,
		"shortname": ":jack_o_lantern:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f383",
			"fully_qualified": "1f383",
			"non_fully_qualified": "1f383",
			"output": "1f383",
			"default_matches": [
				"1f383"
			],
			"greedy_matches": [
				"1f383"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"halloween",
			"jack",
			"lantern"
		]
	},
	"1f63a": {
		"name": "smiling cat face with open mouth",
		"unicode_version": 6,
		"category": "people",
		"order": 88,
		"display": 1,
		"shortname": ":smiley_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63a",
			"fully_qualified": "1f63a",
			"non_fully_qualified": "1f63a",
			"output": "1f63a",
			"default_matches": [
				"1f63a"
			],
			"greedy_matches": [
				"1f63a"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"mouth",
			"open",
			"smile"
		]
	},
	"1f638": {
		"name": "grinning cat face with smiling eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 89,
		"display": 1,
		"shortname": ":smile_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f638",
			"fully_qualified": "1f638",
			"non_fully_qualified": "1f638",
			"output": "1f638",
			"default_matches": [
				"1f638"
			],
			"greedy_matches": [
				"1f638"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"eye",
			"face",
			"grin",
			"smile"
		]
	},
	"1f639": {
		"name": "cat face with tears of joy",
		"unicode_version": 6,
		"category": "people",
		"order": 90,
		"display": 1,
		"shortname": ":joy_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f639",
			"fully_qualified": "1f639",
			"non_fully_qualified": "1f639",
			"output": "1f639",
			"default_matches": [
				"1f639"
			],
			"greedy_matches": [
				"1f639"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"joy",
			"tear"
		]
	},
	"1f63b": {
		"name": "smiling cat face with heart-eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 91,
		"display": 1,
		"shortname": ":heart_eyes_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63b",
			"fully_qualified": "1f63b",
			"non_fully_qualified": "1f63b",
			"output": "1f63b",
			"default_matches": [
				"1f63b"
			],
			"greedy_matches": [
				"1f63b"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"eye",
			"face",
			"love",
			"smile"
		]
	},
	"1f63c": {
		"name": "cat face with wry smile",
		"unicode_version": 6,
		"category": "people",
		"order": 92,
		"display": 1,
		"shortname": ":smirk_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63c",
			"fully_qualified": "1f63c",
			"non_fully_qualified": "1f63c",
			"output": "1f63c",
			"default_matches": [
				"1f63c"
			],
			"greedy_matches": [
				"1f63c"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"ironic",
			"smile",
			"wry"
		]
	},
	"1f63d": {
		"name": "kissing cat face with closed eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 93,
		"display": 1,
		"shortname": ":kissing_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63d",
			"fully_qualified": "1f63d",
			"non_fully_qualified": "1f63d",
			"output": "1f63d",
			"default_matches": [
				"1f63d"
			],
			"greedy_matches": [
				"1f63d"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"eye",
			"face",
			"kiss"
		]
	},
	"1f640": {
		"name": "weary cat face",
		"unicode_version": 6,
		"category": "people",
		"order": 94,
		"display": 1,
		"shortname": ":scream_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f640",
			"fully_qualified": "1f640",
			"non_fully_qualified": "1f640",
			"output": "1f640",
			"default_matches": [
				"1f640"
			],
			"greedy_matches": [
				"1f640"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"oh",
			"surprised",
			"weary"
		]
	},
	"1f63f": {
		"name": "crying cat face",
		"unicode_version": 6,
		"category": "people",
		"order": 95,
		"display": 1,
		"shortname": ":crying_cat_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63f",
			"fully_qualified": "1f63f",
			"non_fully_qualified": "1f63f",
			"output": "1f63f",
			"default_matches": [
				"1f63f"
			],
			"greedy_matches": [
				"1f63f"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"cry",
			"face",
			"sad",
			"tear"
		]
	},
	"1f63e": {
		"name": "pouting cat face",
		"unicode_version": 6,
		"category": "people",
		"order": 96,
		"display": 1,
		"shortname": ":pouting_cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f63e",
			"fully_qualified": "1f63e",
			"non_fully_qualified": "1f63e",
			"output": "1f63e",
			"default_matches": [
				"1f63e"
			],
			"greedy_matches": [
				"1f63e"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"pouting"
		]
	},
	"1f450": {
		"name": "open hands",
		"unicode_version": 6,
		"category": "people",
		"order": 97,
		"display": 1,
		"shortname": ":open_hands:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f450-1f3fb",
			"1f450-1f3fc",
			"1f450-1f3fd",
			"1f450-1f3fe",
			"1f450-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450",
			"fully_qualified": "1f450",
			"non_fully_qualified": "1f450",
			"output": "1f450",
			"default_matches": [
				"1f450"
			],
			"greedy_matches": [
				"1f450"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"open"
		]
	},
	"1f450-1f3fb": {
		"name": "open hands: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 98,
		"display": 1,
		"shortname": ":open_hands_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450-1f3fb",
			"fully_qualified": "1f450-1f3fb",
			"non_fully_qualified": "1f450-1f3fb",
			"output": "1f450-1f3fb",
			"default_matches": [
				"1f450-1f3fb"
			],
			"greedy_matches": [
				"1f450-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"light skin tone",
			"open"
		]
	},
	"1f450-1f3fc": {
		"name": "open hands: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 99,
		"display": 1,
		"shortname": ":open_hands_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450-1f3fc",
			"fully_qualified": "1f450-1f3fc",
			"non_fully_qualified": "1f450-1f3fc",
			"output": "1f450-1f3fc",
			"default_matches": [
				"1f450-1f3fc"
			],
			"greedy_matches": [
				"1f450-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-light skin tone",
			"open"
		]
	},
	"1f450-1f3fd": {
		"name": "open hands: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 100,
		"display": 1,
		"shortname": ":open_hands_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450-1f3fd",
			"fully_qualified": "1f450-1f3fd",
			"non_fully_qualified": "1f450-1f3fd",
			"output": "1f450-1f3fd",
			"default_matches": [
				"1f450-1f3fd"
			],
			"greedy_matches": [
				"1f450-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium skin tone",
			"open"
		]
	},
	"1f450-1f3fe": {
		"name": "open hands: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 101,
		"display": 1,
		"shortname": ":open_hands_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450-1f3fe",
			"fully_qualified": "1f450-1f3fe",
			"non_fully_qualified": "1f450-1f3fe",
			"output": "1f450-1f3fe",
			"default_matches": [
				"1f450-1f3fe"
			],
			"greedy_matches": [
				"1f450-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-dark skin tone",
			"open"
		]
	},
	"1f450-1f3ff": {
		"name": "open hands: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 102,
		"display": 1,
		"shortname": ":open_hands_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f450-1f3ff",
			"fully_qualified": "1f450-1f3ff",
			"non_fully_qualified": "1f450-1f3ff",
			"output": "1f450-1f3ff",
			"default_matches": [
				"1f450-1f3ff"
			],
			"greedy_matches": [
				"1f450-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand",
			"open"
		]
	},
	"1f64c": {
		"name": "raising hands",
		"unicode_version": 6,
		"category": "people",
		"order": 103,
		"display": 1,
		"shortname": ":raised_hands:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64c-1f3fb",
			"1f64c-1f3fc",
			"1f64c-1f3fd",
			"1f64c-1f3fe",
			"1f64c-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c",
			"fully_qualified": "1f64c",
			"non_fully_qualified": "1f64c",
			"output": "1f64c",
			"default_matches": [
				"1f64c"
			],
			"greedy_matches": [
				"1f64c"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"gesture",
			"hand",
			"hooray",
			"raised"
		]
	},
	"1f64c-1f3fb": {
		"name": "raising hands: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 104,
		"display": 1,
		"shortname": ":raised_hands_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c-1f3fb",
			"fully_qualified": "1f64c-1f3fb",
			"non_fully_qualified": "1f64c-1f3fb",
			"output": "1f64c-1f3fb",
			"default_matches": [
				"1f64c-1f3fb"
			],
			"greedy_matches": [
				"1f64c-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"gesture",
			"hand",
			"hooray",
			"light skin tone",
			"raised"
		]
	},
	"1f64c-1f3fc": {
		"name": "raising hands: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 105,
		"display": 1,
		"shortname": ":raised_hands_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c-1f3fc",
			"fully_qualified": "1f64c-1f3fc",
			"non_fully_qualified": "1f64c-1f3fc",
			"output": "1f64c-1f3fc",
			"default_matches": [
				"1f64c-1f3fc"
			],
			"greedy_matches": [
				"1f64c-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"gesture",
			"hand",
			"hooray",
			"medium-light skin tone",
			"raised"
		]
	},
	"1f64c-1f3fd": {
		"name": "raising hands: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 106,
		"display": 1,
		"shortname": ":raised_hands_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c-1f3fd",
			"fully_qualified": "1f64c-1f3fd",
			"non_fully_qualified": "1f64c-1f3fd",
			"output": "1f64c-1f3fd",
			"default_matches": [
				"1f64c-1f3fd"
			],
			"greedy_matches": [
				"1f64c-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"gesture",
			"hand",
			"hooray",
			"medium skin tone",
			"raised"
		]
	},
	"1f64c-1f3fe": {
		"name": "raising hands: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 107,
		"display": 1,
		"shortname": ":raised_hands_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c-1f3fe",
			"fully_qualified": "1f64c-1f3fe",
			"non_fully_qualified": "1f64c-1f3fe",
			"output": "1f64c-1f3fe",
			"default_matches": [
				"1f64c-1f3fe"
			],
			"greedy_matches": [
				"1f64c-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"gesture",
			"hand",
			"hooray",
			"medium-dark skin tone",
			"raised"
		]
	},
	"1f64c-1f3ff": {
		"name": "raising hands: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 108,
		"display": 1,
		"shortname": ":raised_hands_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64c-1f3ff",
			"fully_qualified": "1f64c-1f3ff",
			"non_fully_qualified": "1f64c-1f3ff",
			"output": "1f64c-1f3ff",
			"default_matches": [
				"1f64c-1f3ff"
			],
			"greedy_matches": [
				"1f64c-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"dark skin tone",
			"gesture",
			"hand",
			"hooray",
			"raised"
		]
	},
	"1f44f": {
		"name": "clapping hands",
		"unicode_version": 6,
		"category": "people",
		"order": 109,
		"display": 1,
		"shortname": ":clap:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f44f-1f3fb",
			"1f44f-1f3fc",
			"1f44f-1f3fd",
			"1f44f-1f3fe",
			"1f44f-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f",
			"fully_qualified": "1f44f",
			"non_fully_qualified": "1f44f",
			"output": "1f44f",
			"default_matches": [
				"1f44f"
			],
			"greedy_matches": [
				"1f44f"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"hand"
		]
	},
	"1f44f-1f3fb": {
		"name": "clapping hands: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 110,
		"display": 1,
		"shortname": ":clap_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f-1f3fb",
			"fully_qualified": "1f44f-1f3fb",
			"non_fully_qualified": "1f44f-1f3fb",
			"output": "1f44f-1f3fb",
			"default_matches": [
				"1f44f-1f3fb"
			],
			"greedy_matches": [
				"1f44f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"hand",
			"light skin tone"
		]
	},
	"1f44f-1f3fc": {
		"name": "clapping hands: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 111,
		"display": 1,
		"shortname": ":clap_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f-1f3fc",
			"fully_qualified": "1f44f-1f3fc",
			"non_fully_qualified": "1f44f-1f3fc",
			"output": "1f44f-1f3fc",
			"default_matches": [
				"1f44f-1f3fc"
			],
			"greedy_matches": [
				"1f44f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f44f-1f3fd": {
		"name": "clapping hands: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 112,
		"display": 1,
		"shortname": ":clap_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f-1f3fd",
			"fully_qualified": "1f44f-1f3fd",
			"non_fully_qualified": "1f44f-1f3fd",
			"output": "1f44f-1f3fd",
			"default_matches": [
				"1f44f-1f3fd"
			],
			"greedy_matches": [
				"1f44f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"hand",
			"medium skin tone"
		]
	},
	"1f44f-1f3fe": {
		"name": "clapping hands: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 113,
		"display": 1,
		"shortname": ":clap_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f-1f3fe",
			"fully_qualified": "1f44f-1f3fe",
			"non_fully_qualified": "1f44f-1f3fe",
			"output": "1f44f-1f3fe",
			"default_matches": [
				"1f44f-1f3fe"
			],
			"greedy_matches": [
				"1f44f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f44f-1f3ff": {
		"name": "clapping hands: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 114,
		"display": 1,
		"shortname": ":clap_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44f-1f3ff",
			"fully_qualified": "1f44f-1f3ff",
			"non_fully_qualified": "1f44f-1f3ff",
			"output": "1f44f-1f3ff",
			"default_matches": [
				"1f44f-1f3ff"
			],
			"greedy_matches": [
				"1f44f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"clap",
			"dark skin tone",
			"hand"
		]
	},
	"1f64f": {
		"name": "folded hands",
		"unicode_version": 6,
		"category": "people",
		"order": 115,
		"display": 1,
		"shortname": ":pray:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64f-1f3fb",
			"1f64f-1f3fc",
			"1f64f-1f3fd",
			"1f64f-1f3fe",
			"1f64f-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f",
			"fully_qualified": "1f64f",
			"non_fully_qualified": "1f64f",
			"output": "1f64f",
			"default_matches": [
				"1f64f"
			],
			"greedy_matches": [
				"1f64f"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"folded",
			"gesture",
			"hand",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f64f-1f3fb": {
		"name": "folded hands: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 116,
		"display": 1,
		"shortname": ":pray_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f-1f3fb",
			"fully_qualified": "1f64f-1f3fb",
			"non_fully_qualified": "1f64f-1f3fb",
			"output": "1f64f-1f3fb",
			"default_matches": [
				"1f64f-1f3fb"
			],
			"greedy_matches": [
				"1f64f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"folded",
			"gesture",
			"hand",
			"light skin tone",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f64f-1f3fc": {
		"name": "folded hands: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 117,
		"display": 1,
		"shortname": ":pray_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f-1f3fc",
			"fully_qualified": "1f64f-1f3fc",
			"non_fully_qualified": "1f64f-1f3fc",
			"output": "1f64f-1f3fc",
			"default_matches": [
				"1f64f-1f3fc"
			],
			"greedy_matches": [
				"1f64f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"folded",
			"gesture",
			"hand",
			"medium-light skin tone",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f64f-1f3fd": {
		"name": "folded hands: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 118,
		"display": 1,
		"shortname": ":pray_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f-1f3fd",
			"fully_qualified": "1f64f-1f3fd",
			"non_fully_qualified": "1f64f-1f3fd",
			"output": "1f64f-1f3fd",
			"default_matches": [
				"1f64f-1f3fd"
			],
			"greedy_matches": [
				"1f64f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"folded",
			"gesture",
			"hand",
			"medium skin tone",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f64f-1f3fe": {
		"name": "folded hands: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 119,
		"display": 1,
		"shortname": ":pray_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f-1f3fe",
			"fully_qualified": "1f64f-1f3fe",
			"non_fully_qualified": "1f64f-1f3fe",
			"output": "1f64f-1f3fe",
			"default_matches": [
				"1f64f-1f3fe"
			],
			"greedy_matches": [
				"1f64f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"folded",
			"gesture",
			"hand",
			"medium-dark skin tone",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f64f-1f3ff": {
		"name": "folded hands: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 120,
		"display": 1,
		"shortname": ":pray_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64f-1f3ff",
			"fully_qualified": "1f64f-1f3ff",
			"non_fully_qualified": "1f64f-1f3ff",
			"output": "1f64f-1f3ff",
			"default_matches": [
				"1f64f-1f3ff"
			],
			"greedy_matches": [
				"1f64f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"ask",
			"bow",
			"dark skin tone",
			"folded",
			"gesture",
			"hand",
			"please",
			"pray",
			"thanks"
		]
	},
	"1f91d": {
		"name": "handshake",
		"unicode_version": 9,
		"category": "people",
		"order": 121,
		"display": 1,
		"shortname": ":handshake:",
		"shortname_alternates": [
			":shaking_hands:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91d",
			"fully_qualified": "1f91d",
			"non_fully_qualified": "1f91d",
			"output": "1f91d",
			"default_matches": [
				"1f91d"
			],
			"greedy_matches": [
				"1f91d"
			],
			"decimal": ""
		},
		"keywords": [
			"agreement",
			"hand",
			"handshake",
			"meeting",
			"shake"
		]
	},
	"1f44d": {
		"name": "thumbs up",
		"unicode_version": 6,
		"category": "people",
		"order": 122,
		"display": 1,
		"shortname": ":thumbsup:",
		"shortname_alternates": [
			":+1:",
			":thumbup:"
		],
		"ascii": [
			"(y)"
		],
		"diversity": null,
		"diversities": [
			"1f44d-1f3fb",
			"1f44d-1f3fc",
			"1f44d-1f3fd",
			"1f44d-1f3fe",
			"1f44d-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d",
			"fully_qualified": "1f44d",
			"non_fully_qualified": "1f44d",
			"output": "1f44d",
			"default_matches": [
				"1f44d"
			],
			"greedy_matches": [
				"1f44d"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"hand",
			"thumb",
			"up"
		]
	},
	"1f44d-1f3fb": {
		"name": "thumbs up: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 123,
		"display": 1,
		"shortname": ":thumbsup_tone1:",
		"shortname_alternates": [
			":+1_tone1:",
			":thumbup_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d-1f3fb",
			"fully_qualified": "1f44d-1f3fb",
			"non_fully_qualified": "1f44d-1f3fb",
			"output": "1f44d-1f3fb",
			"default_matches": [
				"1f44d-1f3fb"
			],
			"greedy_matches": [
				"1f44d-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"hand",
			"light skin tone",
			"thumb",
			"up"
		]
	},
	"1f44d-1f3fc": {
		"name": "thumbs up: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 124,
		"display": 1,
		"shortname": ":thumbsup_tone2:",
		"shortname_alternates": [
			":+1_tone2:",
			":thumbup_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d-1f3fc",
			"fully_qualified": "1f44d-1f3fc",
			"non_fully_qualified": "1f44d-1f3fc",
			"output": "1f44d-1f3fc",
			"default_matches": [
				"1f44d-1f3fc"
			],
			"greedy_matches": [
				"1f44d-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"hand",
			"medium-light skin tone",
			"thumb",
			"up"
		]
	},
	"1f44d-1f3fd": {
		"name": "thumbs up: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 125,
		"display": 1,
		"shortname": ":thumbsup_tone3:",
		"shortname_alternates": [
			":+1_tone3:",
			":thumbup_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d-1f3fd",
			"fully_qualified": "1f44d-1f3fd",
			"non_fully_qualified": "1f44d-1f3fd",
			"output": "1f44d-1f3fd",
			"default_matches": [
				"1f44d-1f3fd"
			],
			"greedy_matches": [
				"1f44d-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"hand",
			"medium skin tone",
			"thumb",
			"up"
		]
	},
	"1f44d-1f3fe": {
		"name": "thumbs up: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 126,
		"display": 1,
		"shortname": ":thumbsup_tone4:",
		"shortname_alternates": [
			":+1_tone4:",
			":thumbup_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d-1f3fe",
			"fully_qualified": "1f44d-1f3fe",
			"non_fully_qualified": "1f44d-1f3fe",
			"output": "1f44d-1f3fe",
			"default_matches": [
				"1f44d-1f3fe"
			],
			"greedy_matches": [
				"1f44d-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"hand",
			"medium-dark skin tone",
			"thumb",
			"up"
		]
	},
	"1f44d-1f3ff": {
		"name": "thumbs up: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 127,
		"display": 1,
		"shortname": ":thumbsup_tone5:",
		"shortname_alternates": [
			":+1_tone5:",
			":thumbup_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44d-1f3ff",
			"fully_qualified": "1f44d-1f3ff",
			"non_fully_qualified": "1f44d-1f3ff",
			"output": "1f44d-1f3ff",
			"default_matches": [
				"1f44d-1f3ff"
			],
			"greedy_matches": [
				"1f44d-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"+1",
			"dark skin tone",
			"hand",
			"thumb",
			"up"
		]
	},
	"1f44e": {
		"name": "thumbs down",
		"unicode_version": 6,
		"category": "people",
		"order": 128,
		"display": 1,
		"shortname": ":thumbsdown:",
		"shortname_alternates": [
			":-1:",
			":thumbdown:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f44e-1f3fb",
			"1f44e-1f3fc",
			"1f44e-1f3fd",
			"1f44e-1f3fe",
			"1f44e-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e",
			"fully_qualified": "1f44e",
			"non_fully_qualified": "1f44e",
			"output": "1f44e",
			"default_matches": [
				"1f44e"
			],
			"greedy_matches": [
				"1f44e"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"down",
			"hand",
			"thumb"
		]
	},
	"1f44e-1f3fb": {
		"name": "thumbs down: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 129,
		"display": 1,
		"shortname": ":thumbsdown_tone1:",
		"shortname_alternates": [
			":-1_tone1:",
			":thumbdown_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e-1f3fb",
			"fully_qualified": "1f44e-1f3fb",
			"non_fully_qualified": "1f44e-1f3fb",
			"output": "1f44e-1f3fb",
			"default_matches": [
				"1f44e-1f3fb"
			],
			"greedy_matches": [
				"1f44e-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"down",
			"hand",
			"light skin tone",
			"thumb"
		]
	},
	"1f44e-1f3fc": {
		"name": "thumbs down: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 130,
		"display": 1,
		"shortname": ":thumbsdown_tone2:",
		"shortname_alternates": [
			":-1_tone2:",
			":thumbdown_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e-1f3fc",
			"fully_qualified": "1f44e-1f3fc",
			"non_fully_qualified": "1f44e-1f3fc",
			"output": "1f44e-1f3fc",
			"default_matches": [
				"1f44e-1f3fc"
			],
			"greedy_matches": [
				"1f44e-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"down",
			"hand",
			"medium-light skin tone",
			"thumb"
		]
	},
	"1f44e-1f3fd": {
		"name": "thumbs down: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 131,
		"display": 1,
		"shortname": ":thumbsdown_tone3:",
		"shortname_alternates": [
			":-1_tone3:",
			":thumbdown_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e-1f3fd",
			"fully_qualified": "1f44e-1f3fd",
			"non_fully_qualified": "1f44e-1f3fd",
			"output": "1f44e-1f3fd",
			"default_matches": [
				"1f44e-1f3fd"
			],
			"greedy_matches": [
				"1f44e-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"down",
			"hand",
			"medium skin tone",
			"thumb"
		]
	},
	"1f44e-1f3fe": {
		"name": "thumbs down: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 132,
		"display": 1,
		"shortname": ":thumbsdown_tone4:",
		"shortname_alternates": [
			":-1_tone4:",
			":thumbdown_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e-1f3fe",
			"fully_qualified": "1f44e-1f3fe",
			"non_fully_qualified": "1f44e-1f3fe",
			"output": "1f44e-1f3fe",
			"default_matches": [
				"1f44e-1f3fe"
			],
			"greedy_matches": [
				"1f44e-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"down",
			"hand",
			"medium-dark skin tone",
			"thumb"
		]
	},
	"1f44e-1f3ff": {
		"name": "thumbs down: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 133,
		"display": 1,
		"shortname": ":thumbsdown_tone5:",
		"shortname_alternates": [
			":-1_tone5:",
			":thumbdown_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44e-1f3ff",
			"fully_qualified": "1f44e-1f3ff",
			"non_fully_qualified": "1f44e-1f3ff",
			"output": "1f44e-1f3ff",
			"default_matches": [
				"1f44e-1f3ff"
			],
			"greedy_matches": [
				"1f44e-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"-1",
			"dark skin tone",
			"down",
			"hand",
			"thumb"
		]
	},
	"1f44a": {
		"name": "oncoming fist",
		"unicode_version": 6,
		"category": "people",
		"order": 134,
		"display": 1,
		"shortname": ":punch:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f44a-1f3fb",
			"1f44a-1f3fc",
			"1f44a-1f3fd",
			"1f44a-1f3fe",
			"1f44a-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a",
			"fully_qualified": "1f44a",
			"non_fully_qualified": "1f44a",
			"output": "1f44a",
			"default_matches": [
				"1f44a"
			],
			"greedy_matches": [
				"1f44a"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"punch"
		]
	},
	"1f44a-1f3fb": {
		"name": "oncoming fist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 135,
		"display": 1,
		"shortname": ":punch_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a-1f3fb",
			"fully_qualified": "1f44a-1f3fb",
			"non_fully_qualified": "1f44a-1f3fb",
			"output": "1f44a-1f3fb",
			"default_matches": [
				"1f44a-1f3fb"
			],
			"greedy_matches": [
				"1f44a-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"light skin tone",
			"punch"
		]
	},
	"1f44a-1f3fc": {
		"name": "oncoming fist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 136,
		"display": 1,
		"shortname": ":punch_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a-1f3fc",
			"fully_qualified": "1f44a-1f3fc",
			"non_fully_qualified": "1f44a-1f3fc",
			"output": "1f44a-1f3fc",
			"default_matches": [
				"1f44a-1f3fc"
			],
			"greedy_matches": [
				"1f44a-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium-light skin tone",
			"punch"
		]
	},
	"1f44a-1f3fd": {
		"name": "oncoming fist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 137,
		"display": 1,
		"shortname": ":punch_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a-1f3fd",
			"fully_qualified": "1f44a-1f3fd",
			"non_fully_qualified": "1f44a-1f3fd",
			"output": "1f44a-1f3fd",
			"default_matches": [
				"1f44a-1f3fd"
			],
			"greedy_matches": [
				"1f44a-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium skin tone",
			"punch"
		]
	},
	"1f44a-1f3fe": {
		"name": "oncoming fist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 138,
		"display": 1,
		"shortname": ":punch_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a-1f3fe",
			"fully_qualified": "1f44a-1f3fe",
			"non_fully_qualified": "1f44a-1f3fe",
			"output": "1f44a-1f3fe",
			"default_matches": [
				"1f44a-1f3fe"
			],
			"greedy_matches": [
				"1f44a-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium-dark skin tone",
			"punch"
		]
	},
	"1f44a-1f3ff": {
		"name": "oncoming fist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 139,
		"display": 1,
		"shortname": ":punch_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44a-1f3ff",
			"fully_qualified": "1f44a-1f3ff",
			"non_fully_qualified": "1f44a-1f3ff",
			"output": "1f44a-1f3ff",
			"default_matches": [
				"1f44a-1f3ff"
			],
			"greedy_matches": [
				"1f44a-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"dark skin tone",
			"fist",
			"hand",
			"punch"
		]
	},
	"270a": {
		"name": "raised fist",
		"unicode_version": 6,
		"category": "people",
		"order": 140,
		"display": 1,
		"shortname": ":fist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"270a-1f3fb",
			"270a-1f3fc",
			"270a-1f3fd",
			"270a-1f3fe",
			"270a-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a",
			"fully_qualified": "270a",
			"non_fully_qualified": "270a",
			"output": "270a",
			"default_matches": [
				"270a"
			],
			"greedy_matches": [
				"270a"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"punch"
		]
	},
	"270a-1f3fb": {
		"name": "raised fist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 141,
		"display": 1,
		"shortname": ":fist_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a-1f3fb",
			"fully_qualified": "270a-1f3fb",
			"non_fully_qualified": "270a-1f3fb",
			"output": "270a-1f3fb",
			"default_matches": [
				"270a-1f3fb"
			],
			"greedy_matches": [
				"270a-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"light skin tone",
			"punch"
		]
	},
	"270a-1f3fc": {
		"name": "raised fist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 142,
		"display": 1,
		"shortname": ":fist_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a-1f3fc",
			"fully_qualified": "270a-1f3fc",
			"non_fully_qualified": "270a-1f3fc",
			"output": "270a-1f3fc",
			"default_matches": [
				"270a-1f3fc"
			],
			"greedy_matches": [
				"270a-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium-light skin tone",
			"punch"
		]
	},
	"270a-1f3fd": {
		"name": "raised fist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 143,
		"display": 1,
		"shortname": ":fist_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a-1f3fd",
			"fully_qualified": "270a-1f3fd",
			"non_fully_qualified": "270a-1f3fd",
			"output": "270a-1f3fd",
			"default_matches": [
				"270a-1f3fd"
			],
			"greedy_matches": [
				"270a-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium skin tone",
			"punch"
		]
	},
	"270a-1f3fe": {
		"name": "raised fist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 144,
		"display": 1,
		"shortname": ":fist_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a-1f3fe",
			"fully_qualified": "270a-1f3fe",
			"non_fully_qualified": "270a-1f3fe",
			"output": "270a-1f3fe",
			"default_matches": [
				"270a-1f3fe"
			],
			"greedy_matches": [
				"270a-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"fist",
			"hand",
			"medium-dark skin tone",
			"punch"
		]
	},
	"270a-1f3ff": {
		"name": "raised fist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 145,
		"display": 1,
		"shortname": ":fist_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270a-1f3ff",
			"fully_qualified": "270a-1f3ff",
			"non_fully_qualified": "270a-1f3ff",
			"output": "270a-1f3ff",
			"default_matches": [
				"270a-1f3ff"
			],
			"greedy_matches": [
				"270a-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"clenched",
			"dark skin tone",
			"fist",
			"hand",
			"punch"
		]
	},
	"1f91b": {
		"name": "left-facing fist",
		"unicode_version": 9,
		"category": "people",
		"order": 146,
		"display": 1,
		"shortname": ":left_facing_fist:",
		"shortname_alternates": [
			":left_fist:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f91b-1f3fb",
			"1f91b-1f3fc",
			"1f91b-1f3fd",
			"1f91b-1f3fe",
			"1f91b-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b",
			"fully_qualified": "1f91b",
			"non_fully_qualified": "1f91b",
			"output": "1f91b",
			"default_matches": [
				"1f91b"
			],
			"greedy_matches": [
				"1f91b"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"leftwards"
		]
	},
	"1f91b-1f3fb": {
		"name": "left-facing fist: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 147,
		"display": 1,
		"shortname": ":left_facing_fist_tone1:",
		"shortname_alternates": [
			":left_fist_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b-1f3fb",
			"fully_qualified": "1f91b-1f3fb",
			"non_fully_qualified": "1f91b-1f3fb",
			"output": "1f91b-1f3fb",
			"default_matches": [
				"1f91b-1f3fb"
			],
			"greedy_matches": [
				"1f91b-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"leftwards",
			"light skin tone"
		]
	},
	"1f91b-1f3fc": {
		"name": "left-facing fist: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 148,
		"display": 1,
		"shortname": ":left_facing_fist_tone2:",
		"shortname_alternates": [
			":left_fist_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b-1f3fc",
			"fully_qualified": "1f91b-1f3fc",
			"non_fully_qualified": "1f91b-1f3fc",
			"output": "1f91b-1f3fc",
			"default_matches": [
				"1f91b-1f3fc"
			],
			"greedy_matches": [
				"1f91b-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"leftwards",
			"medium-light skin tone"
		]
	},
	"1f91b-1f3fd": {
		"name": "left-facing fist: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 149,
		"display": 1,
		"shortname": ":left_facing_fist_tone3:",
		"shortname_alternates": [
			":left_fist_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b-1f3fd",
			"fully_qualified": "1f91b-1f3fd",
			"non_fully_qualified": "1f91b-1f3fd",
			"output": "1f91b-1f3fd",
			"default_matches": [
				"1f91b-1f3fd"
			],
			"greedy_matches": [
				"1f91b-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"leftwards",
			"medium skin tone"
		]
	},
	"1f91b-1f3fe": {
		"name": "left-facing fist: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 150,
		"display": 1,
		"shortname": ":left_facing_fist_tone4:",
		"shortname_alternates": [
			":left_fist_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b-1f3fe",
			"fully_qualified": "1f91b-1f3fe",
			"non_fully_qualified": "1f91b-1f3fe",
			"output": "1f91b-1f3fe",
			"default_matches": [
				"1f91b-1f3fe"
			],
			"greedy_matches": [
				"1f91b-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"leftwards",
			"medium-dark skin tone"
		]
	},
	"1f91b-1f3ff": {
		"name": "left-facing fist: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 151,
		"display": 1,
		"shortname": ":left_facing_fist_tone5:",
		"shortname_alternates": [
			":left_fist_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91b-1f3ff",
			"fully_qualified": "1f91b-1f3ff",
			"non_fully_qualified": "1f91b-1f3ff",
			"output": "1f91b-1f3ff",
			"default_matches": [
				"1f91b-1f3ff"
			],
			"greedy_matches": [
				"1f91b-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"fist",
			"leftwards"
		]
	},
	"1f91c": {
		"name": "right-facing fist",
		"unicode_version": 9,
		"category": "people",
		"order": 152,
		"display": 1,
		"shortname": ":right_facing_fist:",
		"shortname_alternates": [
			":right_fist:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f91c-1f3fb",
			"1f91c-1f3fc",
			"1f91c-1f3fd",
			"1f91c-1f3fe",
			"1f91c-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c",
			"fully_qualified": "1f91c",
			"non_fully_qualified": "1f91c",
			"output": "1f91c",
			"default_matches": [
				"1f91c"
			],
			"greedy_matches": [
				"1f91c"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"rightwards"
		]
	},
	"1f91c-1f3fb": {
		"name": "right-facing fist: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 153,
		"display": 1,
		"shortname": ":right_facing_fist_tone1:",
		"shortname_alternates": [
			":right_fist_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c-1f3fb",
			"fully_qualified": "1f91c-1f3fb",
			"non_fully_qualified": "1f91c-1f3fb",
			"output": "1f91c-1f3fb",
			"default_matches": [
				"1f91c-1f3fb"
			],
			"greedy_matches": [
				"1f91c-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"light skin tone",
			"rightwards"
		]
	},
	"1f91c-1f3fc": {
		"name": "right-facing fist: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 154,
		"display": 1,
		"shortname": ":right_facing_fist_tone2:",
		"shortname_alternates": [
			":right_fist_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c-1f3fc",
			"fully_qualified": "1f91c-1f3fc",
			"non_fully_qualified": "1f91c-1f3fc",
			"output": "1f91c-1f3fc",
			"default_matches": [
				"1f91c-1f3fc"
			],
			"greedy_matches": [
				"1f91c-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"medium-light skin tone",
			"rightwards"
		]
	},
	"1f91c-1f3fd": {
		"name": "right-facing fist: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 155,
		"display": 1,
		"shortname": ":right_facing_fist_tone3:",
		"shortname_alternates": [
			":right_fist_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c-1f3fd",
			"fully_qualified": "1f91c-1f3fd",
			"non_fully_qualified": "1f91c-1f3fd",
			"output": "1f91c-1f3fd",
			"default_matches": [
				"1f91c-1f3fd"
			],
			"greedy_matches": [
				"1f91c-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"medium skin tone",
			"rightwards"
		]
	},
	"1f91c-1f3fe": {
		"name": "right-facing fist: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 156,
		"display": 1,
		"shortname": ":right_facing_fist_tone4:",
		"shortname_alternates": [
			":right_fist_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c-1f3fe",
			"fully_qualified": "1f91c-1f3fe",
			"non_fully_qualified": "1f91c-1f3fe",
			"output": "1f91c-1f3fe",
			"default_matches": [
				"1f91c-1f3fe"
			],
			"greedy_matches": [
				"1f91c-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"fist",
			"medium-dark skin tone",
			"rightwards"
		]
	},
	"1f91c-1f3ff": {
		"name": "right-facing fist: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 157,
		"display": 1,
		"shortname": ":right_facing_fist_tone5:",
		"shortname_alternates": [
			":right_fist_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91c-1f3ff",
			"fully_qualified": "1f91c-1f3ff",
			"non_fully_qualified": "1f91c-1f3ff",
			"output": "1f91c-1f3ff",
			"default_matches": [
				"1f91c-1f3ff"
			],
			"greedy_matches": [
				"1f91c-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"fist",
			"rightwards"
		]
	},
	"1f91e": {
		"name": "crossed fingers",
		"unicode_version": 9,
		"category": "people",
		"order": 158,
		"display": 1,
		"shortname": ":fingers_crossed:",
		"shortname_alternates": [
			":hand_with_index_and_middle_finger_crossed:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f91e-1f3fb",
			"1f91e-1f3fc",
			"1f91e-1f3fd",
			"1f91e-1f3fe",
			"1f91e-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e",
			"fully_qualified": "1f91e",
			"non_fully_qualified": "1f91e",
			"output": "1f91e",
			"default_matches": [
				"1f91e"
			],
			"greedy_matches": [
				"1f91e"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"finger",
			"hand",
			"luck"
		]
	},
	"1f91e-1f3fb": {
		"name": "crossed fingers: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 159,
		"display": 1,
		"shortname": ":fingers_crossed_tone1:",
		"shortname_alternates": [
			":hand_with_index_and_middle_fingers_crossed_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e-1f3fb",
			"fully_qualified": "1f91e-1f3fb",
			"non_fully_qualified": "1f91e-1f3fb",
			"output": "1f91e-1f3fb",
			"default_matches": [
				"1f91e-1f3fb"
			],
			"greedy_matches": [
				"1f91e-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"finger",
			"hand",
			"light skin tone",
			"luck"
		]
	},
	"1f91e-1f3fc": {
		"name": "crossed fingers: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 160,
		"display": 1,
		"shortname": ":fingers_crossed_tone2:",
		"shortname_alternates": [
			":hand_with_index_and_middle_fingers_crossed_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e-1f3fc",
			"fully_qualified": "1f91e-1f3fc",
			"non_fully_qualified": "1f91e-1f3fc",
			"output": "1f91e-1f3fc",
			"default_matches": [
				"1f91e-1f3fc"
			],
			"greedy_matches": [
				"1f91e-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"finger",
			"hand",
			"luck",
			"medium-light skin tone"
		]
	},
	"1f91e-1f3fd": {
		"name": "crossed fingers: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 161,
		"display": 1,
		"shortname": ":fingers_crossed_tone3:",
		"shortname_alternates": [
			":hand_with_index_and_middle_fingers_crossed_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e-1f3fd",
			"fully_qualified": "1f91e-1f3fd",
			"non_fully_qualified": "1f91e-1f3fd",
			"output": "1f91e-1f3fd",
			"default_matches": [
				"1f91e-1f3fd"
			],
			"greedy_matches": [
				"1f91e-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"finger",
			"hand",
			"luck",
			"medium skin tone"
		]
	},
	"1f91e-1f3fe": {
		"name": "crossed fingers: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 162,
		"display": 1,
		"shortname": ":fingers_crossed_tone4:",
		"shortname_alternates": [
			":hand_with_index_and_middle_fingers_crossed_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e-1f3fe",
			"fully_qualified": "1f91e-1f3fe",
			"non_fully_qualified": "1f91e-1f3fe",
			"output": "1f91e-1f3fe",
			"default_matches": [
				"1f91e-1f3fe"
			],
			"greedy_matches": [
				"1f91e-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"finger",
			"hand",
			"luck",
			"medium-dark skin tone"
		]
	},
	"1f91e-1f3ff": {
		"name": "crossed fingers: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 163,
		"display": 1,
		"shortname": ":fingers_crossed_tone5:",
		"shortname_alternates": [
			":hand_with_index_and_middle_fingers_crossed_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91e-1f3ff",
			"fully_qualified": "1f91e-1f3ff",
			"non_fully_qualified": "1f91e-1f3ff",
			"output": "1f91e-1f3ff",
			"default_matches": [
				"1f91e-1f3ff"
			],
			"greedy_matches": [
				"1f91e-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"cross",
			"dark skin tone",
			"finger",
			"hand",
			"luck"
		]
	},
	"270c": {
		"name": "victory hand",
		"unicode_version": 1.1,
		"category": "people",
		"order": 164,
		"display": 1,
		"shortname": ":v:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"270c-1f3fb",
			"270c-1f3fc",
			"270c-1f3fd",
			"270c-1f3fe",
			"270c-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c",
			"fully_qualified": "270c-fe0f",
			"non_fully_qualified": "270c",
			"output": "270c-fe0f",
			"default_matches": [
				"270c-fe0f",
				"270c"
			],
			"greedy_matches": [
				"270c-fe0f",
				"270c"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"v",
			"victory"
		]
	},
	"270c-1f3fb": {
		"name": "victory hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 165,
		"display": 1,
		"shortname": ":v_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c-1f3fb",
			"fully_qualified": "270c-1f3fb",
			"non_fully_qualified": "270c-1f3fb",
			"output": "270c-1f3fb",
			"default_matches": [
				"270c-1f3fb",
				"270c-fe0f-1f3fb"
			],
			"greedy_matches": [
				"270c-1f3fb",
				"270c-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"light skin tone",
			"v",
			"victory"
		]
	},
	"270c-1f3fc": {
		"name": "victory hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 166,
		"display": 1,
		"shortname": ":v_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c-1f3fc",
			"fully_qualified": "270c-1f3fc",
			"non_fully_qualified": "270c-1f3fc",
			"output": "270c-1f3fc",
			"default_matches": [
				"270c-1f3fc",
				"270c-fe0f-1f3fc"
			],
			"greedy_matches": [
				"270c-1f3fc",
				"270c-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-light skin tone",
			"v",
			"victory"
		]
	},
	"270c-1f3fd": {
		"name": "victory hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 167,
		"display": 1,
		"shortname": ":v_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c-1f3fd",
			"fully_qualified": "270c-1f3fd",
			"non_fully_qualified": "270c-1f3fd",
			"output": "270c-1f3fd",
			"default_matches": [
				"270c-1f3fd",
				"270c-fe0f-1f3fd"
			],
			"greedy_matches": [
				"270c-1f3fd",
				"270c-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium skin tone",
			"v",
			"victory"
		]
	},
	"270c-1f3fe": {
		"name": "victory hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 168,
		"display": 1,
		"shortname": ":v_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c-1f3fe",
			"fully_qualified": "270c-1f3fe",
			"non_fully_qualified": "270c-1f3fe",
			"output": "270c-1f3fe",
			"default_matches": [
				"270c-1f3fe",
				"270c-fe0f-1f3fe"
			],
			"greedy_matches": [
				"270c-1f3fe",
				"270c-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-dark skin tone",
			"v",
			"victory"
		]
	},
	"270c-1f3ff": {
		"name": "victory hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 169,
		"display": 1,
		"shortname": ":v_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270c-1f3ff",
			"fully_qualified": "270c-1f3ff",
			"non_fully_qualified": "270c-1f3ff",
			"output": "270c-1f3ff",
			"default_matches": [
				"270c-1f3ff",
				"270c-fe0f-1f3ff"
			],
			"greedy_matches": [
				"270c-1f3ff",
				"270c-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand",
			"v",
			"victory"
		]
	},
	"1f918": {
		"name": "sign of the horns",
		"unicode_version": 8,
		"category": "people",
		"order": 170,
		"display": 1,
		"shortname": ":metal:",
		"shortname_alternates": [
			":sign_of_the_horns:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f918-1f3fb",
			"1f918-1f3fc",
			"1f918-1f3fd",
			"1f918-1f3fe",
			"1f918-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918",
			"fully_qualified": "1f918",
			"non_fully_qualified": "1f918",
			"output": "1f918",
			"default_matches": [
				"1f918"
			],
			"greedy_matches": [
				"1f918"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"horns",
			"rock-on"
		]
	},
	"1f918-1f3fb": {
		"name": "sign of the horns: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 171,
		"display": 1,
		"shortname": ":metal_tone1:",
		"shortname_alternates": [
			":sign_of_the_horns_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918-1f3fb",
			"fully_qualified": "1f918-1f3fb",
			"non_fully_qualified": "1f918-1f3fb",
			"output": "1f918-1f3fb",
			"default_matches": [
				"1f918-1f3fb"
			],
			"greedy_matches": [
				"1f918-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"horns",
			"light skin tone",
			"rock-on"
		]
	},
	"1f918-1f3fc": {
		"name": "sign of the horns: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 172,
		"display": 1,
		"shortname": ":metal_tone2:",
		"shortname_alternates": [
			":sign_of_the_horns_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918-1f3fc",
			"fully_qualified": "1f918-1f3fc",
			"non_fully_qualified": "1f918-1f3fc",
			"output": "1f918-1f3fc",
			"default_matches": [
				"1f918-1f3fc"
			],
			"greedy_matches": [
				"1f918-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"horns",
			"medium-light skin tone",
			"rock-on"
		]
	},
	"1f918-1f3fd": {
		"name": "sign of the horns: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 173,
		"display": 1,
		"shortname": ":metal_tone3:",
		"shortname_alternates": [
			":sign_of_the_horns_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918-1f3fd",
			"fully_qualified": "1f918-1f3fd",
			"non_fully_qualified": "1f918-1f3fd",
			"output": "1f918-1f3fd",
			"default_matches": [
				"1f918-1f3fd"
			],
			"greedy_matches": [
				"1f918-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"horns",
			"medium skin tone",
			"rock-on"
		]
	},
	"1f918-1f3fe": {
		"name": "sign of the horns: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 174,
		"display": 1,
		"shortname": ":metal_tone4:",
		"shortname_alternates": [
			":sign_of_the_horns_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918-1f3fe",
			"fully_qualified": "1f918-1f3fe",
			"non_fully_qualified": "1f918-1f3fe",
			"output": "1f918-1f3fe",
			"default_matches": [
				"1f918-1f3fe"
			],
			"greedy_matches": [
				"1f918-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"horns",
			"medium-dark skin tone",
			"rock-on"
		]
	},
	"1f918-1f3ff": {
		"name": "sign of the horns: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 175,
		"display": 1,
		"shortname": ":metal_tone5:",
		"shortname_alternates": [
			":sign_of_the_horns_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f918-1f3ff",
			"fully_qualified": "1f918-1f3ff",
			"non_fully_qualified": "1f918-1f3ff",
			"output": "1f918-1f3ff",
			"default_matches": [
				"1f918-1f3ff"
			],
			"greedy_matches": [
				"1f918-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"finger",
			"hand",
			"horns",
			"rock-on"
		]
	},
	"1f44c": {
		"name": "OK hand",
		"unicode_version": 6,
		"category": "people",
		"order": 176,
		"display": 1,
		"shortname": ":ok_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f44c-1f3fb",
			"1f44c-1f3fc",
			"1f44c-1f3fd",
			"1f44c-1f3fe",
			"1f44c-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c",
			"fully_qualified": "1f44c",
			"non_fully_qualified": "1f44c",
			"output": "1f44c",
			"default_matches": [
				"1f44c"
			],
			"greedy_matches": [
				"1f44c"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"hand"
		]
	},
	"1f44c-1f3fb": {
		"name": "OK hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 177,
		"display": 1,
		"shortname": ":ok_hand_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c-1f3fb",
			"fully_qualified": "1f44c-1f3fb",
			"non_fully_qualified": "1f44c-1f3fb",
			"output": "1f44c-1f3fb",
			"default_matches": [
				"1f44c-1f3fb"
			],
			"greedy_matches": [
				"1f44c-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"hand",
			"light skin tone"
		]
	},
	"1f44c-1f3fc": {
		"name": "OK hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 178,
		"display": 1,
		"shortname": ":ok_hand_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c-1f3fc",
			"fully_qualified": "1f44c-1f3fc",
			"non_fully_qualified": "1f44c-1f3fc",
			"output": "1f44c-1f3fc",
			"default_matches": [
				"1f44c-1f3fc"
			],
			"greedy_matches": [
				"1f44c-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f44c-1f3fd": {
		"name": "OK hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 179,
		"display": 1,
		"shortname": ":ok_hand_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c-1f3fd",
			"fully_qualified": "1f44c-1f3fd",
			"non_fully_qualified": "1f44c-1f3fd",
			"output": "1f44c-1f3fd",
			"default_matches": [
				"1f44c-1f3fd"
			],
			"greedy_matches": [
				"1f44c-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"hand",
			"medium skin tone"
		]
	},
	"1f44c-1f3fe": {
		"name": "OK hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 180,
		"display": 1,
		"shortname": ":ok_hand_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c-1f3fe",
			"fully_qualified": "1f44c-1f3fe",
			"non_fully_qualified": "1f44c-1f3fe",
			"output": "1f44c-1f3fe",
			"default_matches": [
				"1f44c-1f3fe"
			],
			"greedy_matches": [
				"1f44c-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f44c-1f3ff": {
		"name": "OK hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 181,
		"display": 1,
		"shortname": ":ok_hand_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44c-1f3ff",
			"fully_qualified": "1f44c-1f3ff",
			"non_fully_qualified": "1f44c-1f3ff",
			"output": "1f44c-1f3ff",
			"default_matches": [
				"1f44c-1f3ff"
			],
			"greedy_matches": [
				"1f44c-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"dark skin tone",
			"hand"
		]
	},
	"1f448": {
		"name": "backhand index pointing left",
		"unicode_version": 6,
		"category": "people",
		"order": 182,
		"display": 1,
		"shortname": ":point_left:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f448-1f3fb",
			"1f448-1f3fc",
			"1f448-1f3fd",
			"1f448-1f3fe",
			"1f448-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448",
			"fully_qualified": "1f448",
			"non_fully_qualified": "1f448",
			"output": "1f448",
			"default_matches": [
				"1f448"
			],
			"greedy_matches": [
				"1f448"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"1f448-1f3fb": {
		"name": "backhand index pointing left: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 183,
		"display": 1,
		"shortname": ":point_left_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448-1f3fb",
			"fully_qualified": "1f448-1f3fb",
			"non_fully_qualified": "1f448-1f3fb",
			"output": "1f448-1f3fb",
			"default_matches": [
				"1f448-1f3fb"
			],
			"greedy_matches": [
				"1f448-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"light skin tone",
			"point"
		]
	},
	"1f448-1f3fc": {
		"name": "backhand index pointing left: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 184,
		"display": 1,
		"shortname": ":point_left_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448-1f3fc",
			"fully_qualified": "1f448-1f3fc",
			"non_fully_qualified": "1f448-1f3fc",
			"output": "1f448-1f3fc",
			"default_matches": [
				"1f448-1f3fc"
			],
			"greedy_matches": [
				"1f448-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-light skin tone",
			"point"
		]
	},
	"1f448-1f3fd": {
		"name": "backhand index pointing left: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 185,
		"display": 1,
		"shortname": ":point_left_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448-1f3fd",
			"fully_qualified": "1f448-1f3fd",
			"non_fully_qualified": "1f448-1f3fd",
			"output": "1f448-1f3fd",
			"default_matches": [
				"1f448-1f3fd"
			],
			"greedy_matches": [
				"1f448-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium skin tone",
			"point"
		]
	},
	"1f448-1f3fe": {
		"name": "backhand index pointing left: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 186,
		"display": 1,
		"shortname": ":point_left_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448-1f3fe",
			"fully_qualified": "1f448-1f3fe",
			"non_fully_qualified": "1f448-1f3fe",
			"output": "1f448-1f3fe",
			"default_matches": [
				"1f448-1f3fe"
			],
			"greedy_matches": [
				"1f448-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-dark skin tone",
			"point"
		]
	},
	"1f448-1f3ff": {
		"name": "backhand index pointing left: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 187,
		"display": 1,
		"shortname": ":point_left_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f448-1f3ff",
			"fully_qualified": "1f448-1f3ff",
			"non_fully_qualified": "1f448-1f3ff",
			"output": "1f448-1f3ff",
			"default_matches": [
				"1f448-1f3ff"
			],
			"greedy_matches": [
				"1f448-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"dark skin tone",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"1f449": {
		"name": "backhand index pointing right",
		"unicode_version": 6,
		"category": "people",
		"order": 188,
		"display": 1,
		"shortname": ":point_right:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f449-1f3fb",
			"1f449-1f3fc",
			"1f449-1f3fd",
			"1f449-1f3fe",
			"1f449-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449",
			"fully_qualified": "1f449",
			"non_fully_qualified": "1f449",
			"output": "1f449",
			"default_matches": [
				"1f449"
			],
			"greedy_matches": [
				"1f449"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"1f449-1f3fb": {
		"name": "backhand index pointing right: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 189,
		"display": 1,
		"shortname": ":point_right_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449-1f3fb",
			"fully_qualified": "1f449-1f3fb",
			"non_fully_qualified": "1f449-1f3fb",
			"output": "1f449-1f3fb",
			"default_matches": [
				"1f449-1f3fb"
			],
			"greedy_matches": [
				"1f449-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"light skin tone",
			"point"
		]
	},
	"1f449-1f3fc": {
		"name": "backhand index pointing right: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 190,
		"display": 1,
		"shortname": ":point_right_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449-1f3fc",
			"fully_qualified": "1f449-1f3fc",
			"non_fully_qualified": "1f449-1f3fc",
			"output": "1f449-1f3fc",
			"default_matches": [
				"1f449-1f3fc"
			],
			"greedy_matches": [
				"1f449-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-light skin tone",
			"point"
		]
	},
	"1f449-1f3fd": {
		"name": "backhand index pointing right: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 191,
		"display": 1,
		"shortname": ":point_right_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449-1f3fd",
			"fully_qualified": "1f449-1f3fd",
			"non_fully_qualified": "1f449-1f3fd",
			"output": "1f449-1f3fd",
			"default_matches": [
				"1f449-1f3fd"
			],
			"greedy_matches": [
				"1f449-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium skin tone",
			"point"
		]
	},
	"1f449-1f3fe": {
		"name": "backhand index pointing right: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 192,
		"display": 1,
		"shortname": ":point_right_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449-1f3fe",
			"fully_qualified": "1f449-1f3fe",
			"non_fully_qualified": "1f449-1f3fe",
			"output": "1f449-1f3fe",
			"default_matches": [
				"1f449-1f3fe"
			],
			"greedy_matches": [
				"1f449-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-dark skin tone",
			"point"
		]
	},
	"1f449-1f3ff": {
		"name": "backhand index pointing right: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 193,
		"display": 1,
		"shortname": ":point_right_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f449-1f3ff",
			"fully_qualified": "1f449-1f3ff",
			"non_fully_qualified": "1f449-1f3ff",
			"output": "1f449-1f3ff",
			"default_matches": [
				"1f449-1f3ff"
			],
			"greedy_matches": [
				"1f449-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"dark skin tone",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"1f446": {
		"name": "backhand index pointing up",
		"unicode_version": 6,
		"category": "people",
		"order": 194,
		"display": 1,
		"shortname": ":point_up_2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f446-1f3fb",
			"1f446-1f3fc",
			"1f446-1f3fd",
			"1f446-1f3fe",
			"1f446-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446",
			"fully_qualified": "1f446",
			"non_fully_qualified": "1f446",
			"output": "1f446",
			"default_matches": [
				"1f446"
			],
			"greedy_matches": [
				"1f446"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"point",
			"up"
		]
	},
	"1f446-1f3fb": {
		"name": "backhand index pointing up: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 195,
		"display": 1,
		"shortname": ":point_up_2_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446-1f3fb",
			"fully_qualified": "1f446-1f3fb",
			"non_fully_qualified": "1f446-1f3fb",
			"output": "1f446-1f3fb",
			"default_matches": [
				"1f446-1f3fb"
			],
			"greedy_matches": [
				"1f446-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"light skin tone",
			"point",
			"up"
		]
	},
	"1f446-1f3fc": {
		"name": "backhand index pointing up: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 196,
		"display": 1,
		"shortname": ":point_up_2_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446-1f3fc",
			"fully_qualified": "1f446-1f3fc",
			"non_fully_qualified": "1f446-1f3fc",
			"output": "1f446-1f3fc",
			"default_matches": [
				"1f446-1f3fc"
			],
			"greedy_matches": [
				"1f446-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-light skin tone",
			"point",
			"up"
		]
	},
	"1f446-1f3fd": {
		"name": "backhand index pointing up: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 197,
		"display": 1,
		"shortname": ":point_up_2_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446-1f3fd",
			"fully_qualified": "1f446-1f3fd",
			"non_fully_qualified": "1f446-1f3fd",
			"output": "1f446-1f3fd",
			"default_matches": [
				"1f446-1f3fd"
			],
			"greedy_matches": [
				"1f446-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium skin tone",
			"point",
			"up"
		]
	},
	"1f446-1f3fe": {
		"name": "backhand index pointing up: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 198,
		"display": 1,
		"shortname": ":point_up_2_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446-1f3fe",
			"fully_qualified": "1f446-1f3fe",
			"non_fully_qualified": "1f446-1f3fe",
			"output": "1f446-1f3fe",
			"default_matches": [
				"1f446-1f3fe"
			],
			"greedy_matches": [
				"1f446-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"finger",
			"hand",
			"index",
			"medium-dark skin tone",
			"point",
			"up"
		]
	},
	"1f446-1f3ff": {
		"name": "backhand index pointing up: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 199,
		"display": 1,
		"shortname": ":point_up_2_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f446-1f3ff",
			"fully_qualified": "1f446-1f3ff",
			"non_fully_qualified": "1f446-1f3ff",
			"output": "1f446-1f3ff",
			"default_matches": [
				"1f446-1f3ff"
			],
			"greedy_matches": [
				"1f446-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"dark skin tone",
			"finger",
			"hand",
			"index",
			"point",
			"up"
		]
	},
	"1f447": {
		"name": "backhand index pointing down",
		"unicode_version": 6,
		"category": "people",
		"order": 200,
		"display": 1,
		"shortname": ":point_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f447-1f3fb",
			"1f447-1f3fc",
			"1f447-1f3fd",
			"1f447-1f3fe",
			"1f447-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447",
			"fully_qualified": "1f447",
			"non_fully_qualified": "1f447",
			"output": "1f447",
			"default_matches": [
				"1f447"
			],
			"greedy_matches": [
				"1f447"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"down",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"1f447-1f3fb": {
		"name": "backhand index pointing down: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 201,
		"display": 1,
		"shortname": ":point_down_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447-1f3fb",
			"fully_qualified": "1f447-1f3fb",
			"non_fully_qualified": "1f447-1f3fb",
			"output": "1f447-1f3fb",
			"default_matches": [
				"1f447-1f3fb"
			],
			"greedy_matches": [
				"1f447-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"down",
			"finger",
			"hand",
			"index",
			"light skin tone",
			"point"
		]
	},
	"1f447-1f3fc": {
		"name": "backhand index pointing down: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 202,
		"display": 1,
		"shortname": ":point_down_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447-1f3fc",
			"fully_qualified": "1f447-1f3fc",
			"non_fully_qualified": "1f447-1f3fc",
			"output": "1f447-1f3fc",
			"default_matches": [
				"1f447-1f3fc"
			],
			"greedy_matches": [
				"1f447-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"down",
			"finger",
			"hand",
			"index",
			"medium-light skin tone",
			"point"
		]
	},
	"1f447-1f3fd": {
		"name": "backhand index pointing down: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 203,
		"display": 1,
		"shortname": ":point_down_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447-1f3fd",
			"fully_qualified": "1f447-1f3fd",
			"non_fully_qualified": "1f447-1f3fd",
			"output": "1f447-1f3fd",
			"default_matches": [
				"1f447-1f3fd"
			],
			"greedy_matches": [
				"1f447-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"down",
			"finger",
			"hand",
			"index",
			"medium skin tone",
			"point"
		]
	},
	"1f447-1f3fe": {
		"name": "backhand index pointing down: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 204,
		"display": 1,
		"shortname": ":point_down_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447-1f3fe",
			"fully_qualified": "1f447-1f3fe",
			"non_fully_qualified": "1f447-1f3fe",
			"output": "1f447-1f3fe",
			"default_matches": [
				"1f447-1f3fe"
			],
			"greedy_matches": [
				"1f447-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"down",
			"finger",
			"hand",
			"index",
			"medium-dark skin tone",
			"point"
		]
	},
	"1f447-1f3ff": {
		"name": "backhand index pointing down: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 205,
		"display": 1,
		"shortname": ":point_down_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f447-1f3ff",
			"fully_qualified": "1f447-1f3ff",
			"non_fully_qualified": "1f447-1f3ff",
			"output": "1f447-1f3ff",
			"default_matches": [
				"1f447-1f3ff"
			],
			"greedy_matches": [
				"1f447-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"dark skin tone",
			"down",
			"finger",
			"hand",
			"index",
			"point"
		]
	},
	"261d": {
		"name": "index pointing up",
		"unicode_version": 1.1,
		"category": "people",
		"order": 206,
		"display": 1,
		"shortname": ":point_up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"261d-1f3fb",
			"261d-1f3fc",
			"261d-1f3fd",
			"261d-1f3fe",
			"261d-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d",
			"fully_qualified": "261d-fe0f",
			"non_fully_qualified": "261d",
			"output": "261d-fe0f",
			"default_matches": [
				"261d-fe0f",
				"261d"
			],
			"greedy_matches": [
				"261d-fe0f",
				"261d"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"index",
			"point",
			"up"
		]
	},
	"261d-1f3fb": {
		"name": "index pointing up: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 207,
		"display": 1,
		"shortname": ":point_up_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d-1f3fb",
			"fully_qualified": "261d-1f3fb",
			"non_fully_qualified": "261d-1f3fb",
			"output": "261d-1f3fb",
			"default_matches": [
				"261d-1f3fb",
				"261d-fe0f-1f3fb"
			],
			"greedy_matches": [
				"261d-1f3fb",
				"261d-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"index",
			"light skin tone",
			"point",
			"up"
		]
	},
	"261d-1f3fc": {
		"name": "index pointing up: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 208,
		"display": 1,
		"shortname": ":point_up_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d-1f3fc",
			"fully_qualified": "261d-1f3fc",
			"non_fully_qualified": "261d-1f3fc",
			"output": "261d-1f3fc",
			"default_matches": [
				"261d-1f3fc",
				"261d-fe0f-1f3fc"
			],
			"greedy_matches": [
				"261d-1f3fc",
				"261d-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"index",
			"medium-light skin tone",
			"point",
			"up"
		]
	},
	"261d-1f3fd": {
		"name": "index pointing up: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 209,
		"display": 1,
		"shortname": ":point_up_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d-1f3fd",
			"fully_qualified": "261d-1f3fd",
			"non_fully_qualified": "261d-1f3fd",
			"output": "261d-1f3fd",
			"default_matches": [
				"261d-1f3fd",
				"261d-fe0f-1f3fd"
			],
			"greedy_matches": [
				"261d-1f3fd",
				"261d-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"index",
			"medium skin tone",
			"point",
			"up"
		]
	},
	"261d-1f3fe": {
		"name": "index pointing up: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 210,
		"display": 1,
		"shortname": ":point_up_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d-1f3fe",
			"fully_qualified": "261d-1f3fe",
			"non_fully_qualified": "261d-1f3fe",
			"output": "261d-1f3fe",
			"default_matches": [
				"261d-1f3fe",
				"261d-fe0f-1f3fe"
			],
			"greedy_matches": [
				"261d-1f3fe",
				"261d-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"index",
			"medium-dark skin tone",
			"point",
			"up"
		]
	},
	"261d-1f3ff": {
		"name": "index pointing up: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 211,
		"display": 1,
		"shortname": ":point_up_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "261d-1f3ff",
			"fully_qualified": "261d-1f3ff",
			"non_fully_qualified": "261d-1f3ff",
			"output": "261d-1f3ff",
			"default_matches": [
				"261d-1f3ff",
				"261d-fe0f-1f3ff"
			],
			"greedy_matches": [
				"261d-1f3ff",
				"261d-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"finger",
			"hand",
			"index",
			"point",
			"up"
		]
	},
	"270b": {
		"name": "raised hand",
		"unicode_version": 6,
		"category": "people",
		"order": 212,
		"display": 1,
		"shortname": ":raised_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"270b-1f3fb",
			"270b-1f3fc",
			"270b-1f3fd",
			"270b-1f3fe",
			"270b-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b",
			"fully_qualified": "270b",
			"non_fully_qualified": "270b",
			"output": "270b",
			"default_matches": [
				"270b"
			],
			"greedy_matches": [
				"270b"
			],
			"decimal": ""
		},
		"keywords": [
			"hand"
		]
	},
	"270b-1f3fb": {
		"name": "raised hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 213,
		"display": 1,
		"shortname": ":raised_hand_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b-1f3fb",
			"fully_qualified": "270b-1f3fb",
			"non_fully_qualified": "270b-1f3fb",
			"output": "270b-1f3fb",
			"default_matches": [
				"270b-1f3fb"
			],
			"greedy_matches": [
				"270b-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"light skin tone"
		]
	},
	"270b-1f3fc": {
		"name": "raised hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 214,
		"display": 1,
		"shortname": ":raised_hand_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b-1f3fc",
			"fully_qualified": "270b-1f3fc",
			"non_fully_qualified": "270b-1f3fc",
			"output": "270b-1f3fc",
			"default_matches": [
				"270b-1f3fc"
			],
			"greedy_matches": [
				"270b-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-light skin tone"
		]
	},
	"270b-1f3fd": {
		"name": "raised hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 215,
		"display": 1,
		"shortname": ":raised_hand_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b-1f3fd",
			"fully_qualified": "270b-1f3fd",
			"non_fully_qualified": "270b-1f3fd",
			"output": "270b-1f3fd",
			"default_matches": [
				"270b-1f3fd"
			],
			"greedy_matches": [
				"270b-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium skin tone"
		]
	},
	"270b-1f3fe": {
		"name": "raised hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 216,
		"display": 1,
		"shortname": ":raised_hand_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b-1f3fe",
			"fully_qualified": "270b-1f3fe",
			"non_fully_qualified": "270b-1f3fe",
			"output": "270b-1f3fe",
			"default_matches": [
				"270b-1f3fe"
			],
			"greedy_matches": [
				"270b-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-dark skin tone"
		]
	},
	"270b-1f3ff": {
		"name": "raised hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 217,
		"display": 1,
		"shortname": ":raised_hand_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270b-1f3ff",
			"fully_qualified": "270b-1f3ff",
			"non_fully_qualified": "270b-1f3ff",
			"output": "270b-1f3ff",
			"default_matches": [
				"270b-1f3ff"
			],
			"greedy_matches": [
				"270b-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand"
		]
	},
	"1f91a": {
		"name": "raised back of hand",
		"unicode_version": 9,
		"category": "people",
		"order": 218,
		"display": 1,
		"shortname": ":raised_back_of_hand:",
		"shortname_alternates": [
			":back_of_hand:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f91a-1f3fb",
			"1f91a-1f3fc",
			"1f91a-1f3fd",
			"1f91a-1f3fe",
			"1f91a-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a",
			"fully_qualified": "1f91a",
			"non_fully_qualified": "1f91a",
			"output": "1f91a",
			"default_matches": [
				"1f91a"
			],
			"greedy_matches": [
				"1f91a"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"raised"
		]
	},
	"1f91a-1f3fb": {
		"name": "raised back of hand: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 219,
		"display": 1,
		"shortname": ":raised_back_of_hand_tone1:",
		"shortname_alternates": [
			":back_of_hand_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a-1f3fb",
			"fully_qualified": "1f91a-1f3fb",
			"non_fully_qualified": "1f91a-1f3fb",
			"output": "1f91a-1f3fb",
			"default_matches": [
				"1f91a-1f3fb"
			],
			"greedy_matches": [
				"1f91a-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"light skin tone",
			"raised"
		]
	},
	"1f91a-1f3fc": {
		"name": "raised back of hand: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 220,
		"display": 1,
		"shortname": ":raised_back_of_hand_tone2:",
		"shortname_alternates": [
			":back_of_hand_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a-1f3fc",
			"fully_qualified": "1f91a-1f3fc",
			"non_fully_qualified": "1f91a-1f3fc",
			"output": "1f91a-1f3fc",
			"default_matches": [
				"1f91a-1f3fc"
			],
			"greedy_matches": [
				"1f91a-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"medium-light skin tone",
			"raised"
		]
	},
	"1f91a-1f3fd": {
		"name": "raised back of hand: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 221,
		"display": 1,
		"shortname": ":raised_back_of_hand_tone3:",
		"shortname_alternates": [
			":back_of_hand_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a-1f3fd",
			"fully_qualified": "1f91a-1f3fd",
			"non_fully_qualified": "1f91a-1f3fd",
			"output": "1f91a-1f3fd",
			"default_matches": [
				"1f91a-1f3fd"
			],
			"greedy_matches": [
				"1f91a-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"medium skin tone",
			"raised"
		]
	},
	"1f91a-1f3fe": {
		"name": "raised back of hand: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 222,
		"display": 1,
		"shortname": ":raised_back_of_hand_tone4:",
		"shortname_alternates": [
			":back_of_hand_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a-1f3fe",
			"fully_qualified": "1f91a-1f3fe",
			"non_fully_qualified": "1f91a-1f3fe",
			"output": "1f91a-1f3fe",
			"default_matches": [
				"1f91a-1f3fe"
			],
			"greedy_matches": [
				"1f91a-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"medium-dark skin tone",
			"raised"
		]
	},
	"1f91a-1f3ff": {
		"name": "raised back of hand: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 223,
		"display": 1,
		"shortname": ":raised_back_of_hand_tone5:",
		"shortname_alternates": [
			":back_of_hand_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91a-1f3ff",
			"fully_qualified": "1f91a-1f3ff",
			"non_fully_qualified": "1f91a-1f3ff",
			"output": "1f91a-1f3ff",
			"default_matches": [
				"1f91a-1f3ff"
			],
			"greedy_matches": [
				"1f91a-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"backhand",
			"dark skin tone",
			"raised"
		]
	},
	"1f590": {
		"name": "raised hand with fingers splayed",
		"unicode_version": 7,
		"category": "people",
		"order": 224,
		"display": 1,
		"shortname": ":hand_splayed:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f590-1f3fb",
			"1f590-1f3fc",
			"1f590-1f3fd",
			"1f590-1f3fe",
			"1f590-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590",
			"fully_qualified": "1f590-fe0f",
			"non_fully_qualified": "1f590",
			"output": "1f590-fe0f",
			"default_matches": [
				"1f590-fe0f",
				"1f590"
			],
			"greedy_matches": [
				"1f590-fe0f",
				"1f590"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"splayed"
		]
	},
	"1f590-1f3fb": {
		"name": "raised hand with fingers splayed: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 225,
		"display": 1,
		"shortname": ":hand_splayed_tone1:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590-1f3fb",
			"fully_qualified": "1f590-1f3fb",
			"non_fully_qualified": "1f590-1f3fb",
			"output": "1f590-1f3fb",
			"default_matches": [
				"1f590-1f3fb",
				"1f590-fe0f-1f3fb"
			],
			"greedy_matches": [
				"1f590-1f3fb",
				"1f590-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"light skin tone",
			"splayed"
		]
	},
	"1f590-1f3fc": {
		"name": "raised hand with fingers splayed: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 226,
		"display": 1,
		"shortname": ":hand_splayed_tone2:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590-1f3fc",
			"fully_qualified": "1f590-1f3fc",
			"non_fully_qualified": "1f590-1f3fc",
			"output": "1f590-1f3fc",
			"default_matches": [
				"1f590-1f3fc",
				"1f590-fe0f-1f3fc"
			],
			"greedy_matches": [
				"1f590-1f3fc",
				"1f590-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-light skin tone",
			"splayed"
		]
	},
	"1f590-1f3fd": {
		"name": "raised hand with fingers splayed: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 227,
		"display": 1,
		"shortname": ":hand_splayed_tone3:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590-1f3fd",
			"fully_qualified": "1f590-1f3fd",
			"non_fully_qualified": "1f590-1f3fd",
			"output": "1f590-1f3fd",
			"default_matches": [
				"1f590-1f3fd",
				"1f590-fe0f-1f3fd"
			],
			"greedy_matches": [
				"1f590-1f3fd",
				"1f590-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium skin tone",
			"splayed"
		]
	},
	"1f590-1f3fe": {
		"name": "raised hand with fingers splayed: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 228,
		"display": 1,
		"shortname": ":hand_splayed_tone4:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590-1f3fe",
			"fully_qualified": "1f590-1f3fe",
			"non_fully_qualified": "1f590-1f3fe",
			"output": "1f590-1f3fe",
			"default_matches": [
				"1f590-1f3fe",
				"1f590-fe0f-1f3fe"
			],
			"greedy_matches": [
				"1f590-1f3fe",
				"1f590-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-dark skin tone",
			"splayed"
		]
	},
	"1f590-1f3ff": {
		"name": "raised hand with fingers splayed: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 229,
		"display": 1,
		"shortname": ":hand_splayed_tone5:",
		"shortname_alternates": [
			":raised_hand_with_fingers_splayed_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f590-1f3ff",
			"fully_qualified": "1f590-1f3ff",
			"non_fully_qualified": "1f590-1f3ff",
			"output": "1f590-1f3ff",
			"default_matches": [
				"1f590-1f3ff",
				"1f590-fe0f-1f3ff"
			],
			"greedy_matches": [
				"1f590-1f3ff",
				"1f590-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"finger",
			"hand",
			"splayed"
		]
	},
	"1f596": {
		"name": "vulcan salute",
		"unicode_version": 7,
		"category": "people",
		"order": 230,
		"display": 1,
		"shortname": ":vulcan:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f596-1f3fb",
			"1f596-1f3fc",
			"1f596-1f3fd",
			"1f596-1f3fe",
			"1f596-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596",
			"fully_qualified": "1f596",
			"non_fully_qualified": "1f596",
			"output": "1f596",
			"default_matches": [
				"1f596"
			],
			"greedy_matches": [
				"1f596"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"spock",
			"vulcan"
		]
	},
	"1f596-1f3fb": {
		"name": "vulcan salute: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 231,
		"display": 1,
		"shortname": ":vulcan_tone1:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596-1f3fb",
			"fully_qualified": "1f596-1f3fb",
			"non_fully_qualified": "1f596-1f3fb",
			"output": "1f596-1f3fb",
			"default_matches": [
				"1f596-1f3fb"
			],
			"greedy_matches": [
				"1f596-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"light skin tone",
			"spock",
			"vulcan"
		]
	},
	"1f596-1f3fc": {
		"name": "vulcan salute: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 232,
		"display": 1,
		"shortname": ":vulcan_tone2:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596-1f3fc",
			"fully_qualified": "1f596-1f3fc",
			"non_fully_qualified": "1f596-1f3fc",
			"output": "1f596-1f3fc",
			"default_matches": [
				"1f596-1f3fc"
			],
			"greedy_matches": [
				"1f596-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-light skin tone",
			"spock",
			"vulcan"
		]
	},
	"1f596-1f3fd": {
		"name": "vulcan salute: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 233,
		"display": 1,
		"shortname": ":vulcan_tone3:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596-1f3fd",
			"fully_qualified": "1f596-1f3fd",
			"non_fully_qualified": "1f596-1f3fd",
			"output": "1f596-1f3fd",
			"default_matches": [
				"1f596-1f3fd"
			],
			"greedy_matches": [
				"1f596-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium skin tone",
			"spock",
			"vulcan"
		]
	},
	"1f596-1f3fe": {
		"name": "vulcan salute: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 234,
		"display": 1,
		"shortname": ":vulcan_tone4:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596-1f3fe",
			"fully_qualified": "1f596-1f3fe",
			"non_fully_qualified": "1f596-1f3fe",
			"output": "1f596-1f3fe",
			"default_matches": [
				"1f596-1f3fe"
			],
			"greedy_matches": [
				"1f596-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-dark skin tone",
			"spock",
			"vulcan"
		]
	},
	"1f596-1f3ff": {
		"name": "vulcan salute: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 235,
		"display": 1,
		"shortname": ":vulcan_tone5:",
		"shortname_alternates": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f596-1f3ff",
			"fully_qualified": "1f596-1f3ff",
			"non_fully_qualified": "1f596-1f3ff",
			"output": "1f596-1f3ff",
			"default_matches": [
				"1f596-1f3ff"
			],
			"greedy_matches": [
				"1f596-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"finger",
			"hand",
			"spock",
			"vulcan"
		]
	},
	"1f44b": {
		"name": "waving hand",
		"unicode_version": 6,
		"category": "people",
		"order": 236,
		"display": 1,
		"shortname": ":wave:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f44b-1f3fb",
			"1f44b-1f3fc",
			"1f44b-1f3fd",
			"1f44b-1f3fe",
			"1f44b-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b",
			"fully_qualified": "1f44b",
			"non_fully_qualified": "1f44b",
			"output": "1f44b",
			"default_matches": [
				"1f44b"
			],
			"greedy_matches": [
				"1f44b"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"wave",
			"waving"
		]
	},
	"1f44b-1f3fb": {
		"name": "waving hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 237,
		"display": 1,
		"shortname": ":wave_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b-1f3fb",
			"fully_qualified": "1f44b-1f3fb",
			"non_fully_qualified": "1f44b-1f3fb",
			"output": "1f44b-1f3fb",
			"default_matches": [
				"1f44b-1f3fb"
			],
			"greedy_matches": [
				"1f44b-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"light skin tone",
			"wave",
			"waving"
		]
	},
	"1f44b-1f3fc": {
		"name": "waving hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 238,
		"display": 1,
		"shortname": ":wave_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b-1f3fc",
			"fully_qualified": "1f44b-1f3fc",
			"non_fully_qualified": "1f44b-1f3fc",
			"output": "1f44b-1f3fc",
			"default_matches": [
				"1f44b-1f3fc"
			],
			"greedy_matches": [
				"1f44b-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-light skin tone",
			"wave",
			"waving"
		]
	},
	"1f44b-1f3fd": {
		"name": "waving hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 239,
		"display": 1,
		"shortname": ":wave_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b-1f3fd",
			"fully_qualified": "1f44b-1f3fd",
			"non_fully_qualified": "1f44b-1f3fd",
			"output": "1f44b-1f3fd",
			"default_matches": [
				"1f44b-1f3fd"
			],
			"greedy_matches": [
				"1f44b-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium skin tone",
			"wave",
			"waving"
		]
	},
	"1f44b-1f3fe": {
		"name": "waving hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 240,
		"display": 1,
		"shortname": ":wave_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b-1f3fe",
			"fully_qualified": "1f44b-1f3fe",
			"non_fully_qualified": "1f44b-1f3fe",
			"output": "1f44b-1f3fe",
			"default_matches": [
				"1f44b-1f3fe"
			],
			"greedy_matches": [
				"1f44b-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-dark skin tone",
			"wave",
			"waving"
		]
	},
	"1f44b-1f3ff": {
		"name": "waving hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 241,
		"display": 1,
		"shortname": ":wave_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f44b-1f3ff",
			"fully_qualified": "1f44b-1f3ff",
			"non_fully_qualified": "1f44b-1f3ff",
			"output": "1f44b-1f3ff",
			"default_matches": [
				"1f44b-1f3ff"
			],
			"greedy_matches": [
				"1f44b-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand",
			"wave",
			"waving"
		]
	},
	"1f919": {
		"name": "call me hand",
		"unicode_version": 9,
		"category": "people",
		"order": 242,
		"display": 1,
		"shortname": ":call_me:",
		"shortname_alternates": [
			":call_me_hand:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f919-1f3fb",
			"1f919-1f3fc",
			"1f919-1f3fd",
			"1f919-1f3fe",
			"1f919-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919",
			"fully_qualified": "1f919",
			"non_fully_qualified": "1f919",
			"output": "1f919",
			"default_matches": [
				"1f919"
			],
			"greedy_matches": [
				"1f919"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"hand"
		]
	},
	"1f919-1f3fb": {
		"name": "call me hand: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 243,
		"display": 1,
		"shortname": ":call_me_tone1:",
		"shortname_alternates": [
			":call_me_hand_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919-1f3fb",
			"fully_qualified": "1f919-1f3fb",
			"non_fully_qualified": "1f919-1f3fb",
			"output": "1f919-1f3fb",
			"default_matches": [
				"1f919-1f3fb"
			],
			"greedy_matches": [
				"1f919-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"hand",
			"light skin tone"
		]
	},
	"1f919-1f3fc": {
		"name": "call me hand: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 244,
		"display": 1,
		"shortname": ":call_me_tone2:",
		"shortname_alternates": [
			":call_me_hand_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919-1f3fc",
			"fully_qualified": "1f919-1f3fc",
			"non_fully_qualified": "1f919-1f3fc",
			"output": "1f919-1f3fc",
			"default_matches": [
				"1f919-1f3fc"
			],
			"greedy_matches": [
				"1f919-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f919-1f3fd": {
		"name": "call me hand: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 245,
		"display": 1,
		"shortname": ":call_me_tone3:",
		"shortname_alternates": [
			":call_me_hand_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919-1f3fd",
			"fully_qualified": "1f919-1f3fd",
			"non_fully_qualified": "1f919-1f3fd",
			"output": "1f919-1f3fd",
			"default_matches": [
				"1f919-1f3fd"
			],
			"greedy_matches": [
				"1f919-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"hand",
			"medium skin tone"
		]
	},
	"1f919-1f3fe": {
		"name": "call me hand: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 246,
		"display": 1,
		"shortname": ":call_me_tone4:",
		"shortname_alternates": [
			":call_me_hand_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919-1f3fe",
			"fully_qualified": "1f919-1f3fe",
			"non_fully_qualified": "1f919-1f3fe",
			"output": "1f919-1f3fe",
			"default_matches": [
				"1f919-1f3fe"
			],
			"greedy_matches": [
				"1f919-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f919-1f3ff": {
		"name": "call me hand: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 247,
		"display": 1,
		"shortname": ":call_me_tone5:",
		"shortname_alternates": [
			":call_me_hand_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f919-1f3ff",
			"fully_qualified": "1f919-1f3ff",
			"non_fully_qualified": "1f919-1f3ff",
			"output": "1f919-1f3ff",
			"default_matches": [
				"1f919-1f3ff"
			],
			"greedy_matches": [
				"1f919-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"call",
			"dark skin tone",
			"hand"
		]
	},
	"1f4aa": {
		"name": "flexed biceps",
		"unicode_version": 6,
		"category": "people",
		"order": 248,
		"display": 1,
		"shortname": ":muscle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f4aa-1f3fb",
			"1f4aa-1f3fc",
			"1f4aa-1f3fd",
			"1f4aa-1f3fe",
			"1f4aa-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa",
			"fully_qualified": "1f4aa",
			"non_fully_qualified": "1f4aa",
			"output": "1f4aa",
			"default_matches": [
				"1f4aa"
			],
			"greedy_matches": [
				"1f4aa"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"flex",
			"muscle"
		]
	},
	"1f4aa-1f3fb": {
		"name": "flexed biceps: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 249,
		"display": 1,
		"shortname": ":muscle_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa-1f3fb",
			"fully_qualified": "1f4aa-1f3fb",
			"non_fully_qualified": "1f4aa-1f3fb",
			"output": "1f4aa-1f3fb",
			"default_matches": [
				"1f4aa-1f3fb"
			],
			"greedy_matches": [
				"1f4aa-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"flex",
			"light skin tone",
			"muscle"
		]
	},
	"1f4aa-1f3fc": {
		"name": "flexed biceps: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 250,
		"display": 1,
		"shortname": ":muscle_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa-1f3fc",
			"fully_qualified": "1f4aa-1f3fc",
			"non_fully_qualified": "1f4aa-1f3fc",
			"output": "1f4aa-1f3fc",
			"default_matches": [
				"1f4aa-1f3fc"
			],
			"greedy_matches": [
				"1f4aa-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"flex",
			"medium-light skin tone",
			"muscle"
		]
	},
	"1f4aa-1f3fd": {
		"name": "flexed biceps: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 251,
		"display": 1,
		"shortname": ":muscle_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa-1f3fd",
			"fully_qualified": "1f4aa-1f3fd",
			"non_fully_qualified": "1f4aa-1f3fd",
			"output": "1f4aa-1f3fd",
			"default_matches": [
				"1f4aa-1f3fd"
			],
			"greedy_matches": [
				"1f4aa-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"flex",
			"medium skin tone",
			"muscle"
		]
	},
	"1f4aa-1f3fe": {
		"name": "flexed biceps: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 252,
		"display": 1,
		"shortname": ":muscle_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa-1f3fe",
			"fully_qualified": "1f4aa-1f3fe",
			"non_fully_qualified": "1f4aa-1f3fe",
			"output": "1f4aa-1f3fe",
			"default_matches": [
				"1f4aa-1f3fe"
			],
			"greedy_matches": [
				"1f4aa-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"flex",
			"medium-dark skin tone",
			"muscle"
		]
	},
	"1f4aa-1f3ff": {
		"name": "flexed biceps: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 253,
		"display": 1,
		"shortname": ":muscle_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4aa-1f3ff",
			"fully_qualified": "1f4aa-1f3ff",
			"non_fully_qualified": "1f4aa-1f3ff",
			"output": "1f4aa-1f3ff",
			"default_matches": [
				"1f4aa-1f3ff"
			],
			"greedy_matches": [
				"1f4aa-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"biceps",
			"comic",
			"dark skin tone",
			"flex",
			"muscle"
		]
	},
	"1f595": {
		"name": "middle finger",
		"unicode_version": 7,
		"category": "people",
		"order": 254,
		"display": 1,
		"shortname": ":middle_finger:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f595-1f3fb",
			"1f595-1f3fc",
			"1f595-1f3fd",
			"1f595-1f3fe",
			"1f595-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595",
			"fully_qualified": "1f595",
			"non_fully_qualified": "1f595",
			"output": "1f595",
			"default_matches": [
				"1f595"
			],
			"greedy_matches": [
				"1f595"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand"
		]
	},
	"1f595-1f3fb": {
		"name": "middle finger: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 255,
		"display": 1,
		"shortname": ":middle_finger_tone1:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595-1f3fb",
			"fully_qualified": "1f595-1f3fb",
			"non_fully_qualified": "1f595-1f3fb",
			"output": "1f595-1f3fb",
			"default_matches": [
				"1f595-1f3fb"
			],
			"greedy_matches": [
				"1f595-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"light skin tone"
		]
	},
	"1f595-1f3fc": {
		"name": "middle finger: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 256,
		"display": 1,
		"shortname": ":middle_finger_tone2:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595-1f3fc",
			"fully_qualified": "1f595-1f3fc",
			"non_fully_qualified": "1f595-1f3fc",
			"output": "1f595-1f3fc",
			"default_matches": [
				"1f595-1f3fc"
			],
			"greedy_matches": [
				"1f595-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f595-1f3fd": {
		"name": "middle finger: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 257,
		"display": 1,
		"shortname": ":middle_finger_tone3:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595-1f3fd",
			"fully_qualified": "1f595-1f3fd",
			"non_fully_qualified": "1f595-1f3fd",
			"output": "1f595-1f3fd",
			"default_matches": [
				"1f595-1f3fd"
			],
			"greedy_matches": [
				"1f595-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium skin tone"
		]
	},
	"1f595-1f3fe": {
		"name": "middle finger: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 258,
		"display": 1,
		"shortname": ":middle_finger_tone4:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595-1f3fe",
			"fully_qualified": "1f595-1f3fe",
			"non_fully_qualified": "1f595-1f3fe",
			"output": "1f595-1f3fe",
			"default_matches": [
				"1f595-1f3fe"
			],
			"greedy_matches": [
				"1f595-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"finger",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f595-1f3ff": {
		"name": "middle finger: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 259,
		"display": 1,
		"shortname": ":middle_finger_tone5:",
		"shortname_alternates": [
			":reversed_hand_with_middle_finger_extended_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f595-1f3ff",
			"fully_qualified": "1f595-1f3ff",
			"non_fully_qualified": "1f595-1f3ff",
			"output": "1f595-1f3ff",
			"default_matches": [
				"1f595-1f3ff"
			],
			"greedy_matches": [
				"1f595-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"finger",
			"hand"
		]
	},
	"270d": {
		"name": "writing hand",
		"unicode_version": 1.1,
		"category": "people",
		"order": 260,
		"display": 1,
		"shortname": ":writing_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"270d-1f3fb",
			"270d-1f3fc",
			"270d-1f3fd",
			"270d-1f3fe",
			"270d-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d",
			"fully_qualified": "270d-fe0f",
			"non_fully_qualified": "270d",
			"output": "270d-fe0f",
			"default_matches": [
				"270d-fe0f",
				"270d"
			],
			"greedy_matches": [
				"270d-fe0f",
				"270d"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"write"
		]
	},
	"270d-1f3fb": {
		"name": "writing hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 261,
		"display": 1,
		"shortname": ":writing_hand_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d-1f3fb",
			"fully_qualified": "270d-1f3fb",
			"non_fully_qualified": "270d-1f3fb",
			"output": "270d-1f3fb",
			"default_matches": [
				"270d-1f3fb",
				"270d-fe0f-1f3fb"
			],
			"greedy_matches": [
				"270d-1f3fb",
				"270d-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"light skin tone",
			"write"
		]
	},
	"270d-1f3fc": {
		"name": "writing hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 262,
		"display": 1,
		"shortname": ":writing_hand_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d-1f3fc",
			"fully_qualified": "270d-1f3fc",
			"non_fully_qualified": "270d-1f3fc",
			"output": "270d-1f3fc",
			"default_matches": [
				"270d-1f3fc",
				"270d-fe0f-1f3fc"
			],
			"greedy_matches": [
				"270d-1f3fc",
				"270d-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-light skin tone",
			"write"
		]
	},
	"270d-1f3fd": {
		"name": "writing hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 263,
		"display": 1,
		"shortname": ":writing_hand_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d-1f3fd",
			"fully_qualified": "270d-1f3fd",
			"non_fully_qualified": "270d-1f3fd",
			"output": "270d-1f3fd",
			"default_matches": [
				"270d-1f3fd",
				"270d-fe0f-1f3fd"
			],
			"greedy_matches": [
				"270d-1f3fd",
				"270d-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium skin tone",
			"write"
		]
	},
	"270d-1f3fe": {
		"name": "writing hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 264,
		"display": 1,
		"shortname": ":writing_hand_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d-1f3fe",
			"fully_qualified": "270d-1f3fe",
			"non_fully_qualified": "270d-1f3fe",
			"output": "270d-1f3fe",
			"default_matches": [
				"270d-1f3fe",
				"270d-fe0f-1f3fe"
			],
			"greedy_matches": [
				"270d-1f3fe",
				"270d-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"medium-dark skin tone",
			"write"
		]
	},
	"270d-1f3ff": {
		"name": "writing hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 265,
		"display": 1,
		"shortname": ":writing_hand_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270d-1f3ff",
			"fully_qualified": "270d-1f3ff",
			"non_fully_qualified": "270d-1f3ff",
			"output": "270d-1f3ff",
			"default_matches": [
				"270d-1f3ff",
				"270d-fe0f-1f3ff"
			],
			"greedy_matches": [
				"270d-1f3ff",
				"270d-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand",
			"write"
		]
	},
	"1f933": {
		"name": "selfie",
		"unicode_version": 9,
		"category": "people",
		"order": 266,
		"display": 1,
		"shortname": ":selfie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f933-1f3fb",
			"1f933-1f3fc",
			"1f933-1f3fd",
			"1f933-1f3fe",
			"1f933-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933",
			"fully_qualified": "1f933",
			"non_fully_qualified": "1f933",
			"output": "1f933",
			"default_matches": [
				"1f933"
			],
			"greedy_matches": [
				"1f933"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"phone",
			"selfie"
		]
	},
	"1f933-1f3fb": {
		"name": "selfie: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 267,
		"display": 1,
		"shortname": ":selfie_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933-1f3fb",
			"fully_qualified": "1f933-1f3fb",
			"non_fully_qualified": "1f933-1f3fb",
			"output": "1f933-1f3fb",
			"default_matches": [
				"1f933-1f3fb"
			],
			"greedy_matches": [
				"1f933-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"light skin tone",
			"phone",
			"selfie"
		]
	},
	"1f933-1f3fc": {
		"name": "selfie: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 268,
		"display": 1,
		"shortname": ":selfie_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933-1f3fc",
			"fully_qualified": "1f933-1f3fc",
			"non_fully_qualified": "1f933-1f3fc",
			"output": "1f933-1f3fc",
			"default_matches": [
				"1f933-1f3fc"
			],
			"greedy_matches": [
				"1f933-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"medium-light skin tone",
			"phone",
			"selfie"
		]
	},
	"1f933-1f3fd": {
		"name": "selfie: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 269,
		"display": 1,
		"shortname": ":selfie_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933-1f3fd",
			"fully_qualified": "1f933-1f3fd",
			"non_fully_qualified": "1f933-1f3fd",
			"output": "1f933-1f3fd",
			"default_matches": [
				"1f933-1f3fd"
			],
			"greedy_matches": [
				"1f933-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"medium skin tone",
			"phone",
			"selfie"
		]
	},
	"1f933-1f3fe": {
		"name": "selfie: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 270,
		"display": 1,
		"shortname": ":selfie_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933-1f3fe",
			"fully_qualified": "1f933-1f3fe",
			"non_fully_qualified": "1f933-1f3fe",
			"output": "1f933-1f3fe",
			"default_matches": [
				"1f933-1f3fe"
			],
			"greedy_matches": [
				"1f933-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"medium-dark skin tone",
			"phone",
			"selfie"
		]
	},
	"1f933-1f3ff": {
		"name": "selfie: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 271,
		"display": 1,
		"shortname": ":selfie_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f933-1f3ff",
			"fully_qualified": "1f933-1f3ff",
			"non_fully_qualified": "1f933-1f3ff",
			"output": "1f933-1f3ff",
			"default_matches": [
				"1f933-1f3ff"
			],
			"greedy_matches": [
				"1f933-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"dark skin tone",
			"phone",
			"selfie"
		]
	},
	"1f485": {
		"name": "nail polish",
		"unicode_version": 6,
		"category": "people",
		"order": 272,
		"display": 1,
		"shortname": ":nail_care:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f485-1f3fb",
			"1f485-1f3fc",
			"1f485-1f3fd",
			"1f485-1f3fe",
			"1f485-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485",
			"fully_qualified": "1f485",
			"non_fully_qualified": "1f485",
			"output": "1f485",
			"default_matches": [
				"1f485"
			],
			"greedy_matches": [
				"1f485"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"manicure",
			"nail",
			"polish"
		]
	},
	"1f485-1f3fb": {
		"name": "nail polish: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 273,
		"display": 1,
		"shortname": ":nail_care_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485-1f3fb",
			"fully_qualified": "1f485-1f3fb",
			"non_fully_qualified": "1f485-1f3fb",
			"output": "1f485-1f3fb",
			"default_matches": [
				"1f485-1f3fb"
			],
			"greedy_matches": [
				"1f485-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"light skin tone",
			"manicure",
			"nail",
			"polish"
		]
	},
	"1f485-1f3fc": {
		"name": "nail polish: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 274,
		"display": 1,
		"shortname": ":nail_care_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485-1f3fc",
			"fully_qualified": "1f485-1f3fc",
			"non_fully_qualified": "1f485-1f3fc",
			"output": "1f485-1f3fc",
			"default_matches": [
				"1f485-1f3fc"
			],
			"greedy_matches": [
				"1f485-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"manicure",
			"medium-light skin tone",
			"nail",
			"polish"
		]
	},
	"1f485-1f3fd": {
		"name": "nail polish: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 275,
		"display": 1,
		"shortname": ":nail_care_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485-1f3fd",
			"fully_qualified": "1f485-1f3fd",
			"non_fully_qualified": "1f485-1f3fd",
			"output": "1f485-1f3fd",
			"default_matches": [
				"1f485-1f3fd"
			],
			"greedy_matches": [
				"1f485-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"manicure",
			"medium skin tone",
			"nail",
			"polish"
		]
	},
	"1f485-1f3fe": {
		"name": "nail polish: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 276,
		"display": 1,
		"shortname": ":nail_care_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485-1f3fe",
			"fully_qualified": "1f485-1f3fe",
			"non_fully_qualified": "1f485-1f3fe",
			"output": "1f485-1f3fe",
			"default_matches": [
				"1f485-1f3fe"
			],
			"greedy_matches": [
				"1f485-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"manicure",
			"medium-dark skin tone",
			"nail",
			"polish"
		]
	},
	"1f485-1f3ff": {
		"name": "nail polish: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 277,
		"display": 1,
		"shortname": ":nail_care_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f485-1f3ff",
			"fully_qualified": "1f485-1f3ff",
			"non_fully_qualified": "1f485-1f3ff",
			"output": "1f485-1f3ff",
			"default_matches": [
				"1f485-1f3ff"
			],
			"greedy_matches": [
				"1f485-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"care",
			"cosmetics",
			"dark skin tone",
			"manicure",
			"nail",
			"polish"
		]
	},
	"1f48d": {
		"name": "ring",
		"unicode_version": 6,
		"category": "people",
		"order": 278,
		"display": 1,
		"shortname": ":ring:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48d",
			"fully_qualified": "1f48d",
			"non_fully_qualified": "1f48d",
			"output": "1f48d",
			"default_matches": [
				"1f48d"
			],
			"greedy_matches": [
				"1f48d"
			],
			"decimal": ""
		},
		"keywords": [
			"diamond"
		]
	},
	"1f484": {
		"name": "lipstick",
		"unicode_version": 6,
		"category": "people",
		"order": 279,
		"display": 1,
		"shortname": ":lipstick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f484",
			"fully_qualified": "1f484",
			"non_fully_qualified": "1f484",
			"output": "1f484",
			"default_matches": [
				"1f484"
			],
			"greedy_matches": [
				"1f484"
			],
			"decimal": ""
		},
		"keywords": [
			"cosmetics",
			"makeup"
		]
	},
	"1f48b": {
		"name": "kiss mark",
		"unicode_version": 6,
		"category": "people",
		"order": 280,
		"display": 1,
		"shortname": ":kiss:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48b",
			"fully_qualified": "1f48b",
			"non_fully_qualified": "1f48b",
			"output": "1f48b",
			"default_matches": [
				"1f48b"
			],
			"greedy_matches": [
				"1f48b"
			],
			"decimal": ""
		},
		"keywords": [
			"kiss",
			"lips"
		]
	},
	"1f444": {
		"name": "mouth",
		"unicode_version": 6,
		"category": "people",
		"order": 281,
		"display": 1,
		"shortname": ":lips:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f444",
			"fully_qualified": "1f444",
			"non_fully_qualified": "1f444",
			"output": "1f444",
			"default_matches": [
				"1f444"
			],
			"greedy_matches": [
				"1f444"
			],
			"decimal": ""
		},
		"keywords": [
			"lips"
		]
	},
	"1f445": {
		"name": "tongue",
		"unicode_version": 6,
		"category": "people",
		"order": 282,
		"display": 1,
		"shortname": ":tongue:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f445",
			"fully_qualified": "1f445",
			"non_fully_qualified": "1f445",
			"output": "1f445",
			"default_matches": [
				"1f445"
			],
			"greedy_matches": [
				"1f445"
			],
			"decimal": ""
		},
		"keywords": [
			"body"
		]
	},
	"1f442": {
		"name": "ear",
		"unicode_version": 6,
		"category": "people",
		"order": 283,
		"display": 1,
		"shortname": ":ear:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f442-1f3fb",
			"1f442-1f3fc",
			"1f442-1f3fd",
			"1f442-1f3fe",
			"1f442-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442",
			"fully_qualified": "1f442",
			"non_fully_qualified": "1f442",
			"output": "1f442",
			"default_matches": [
				"1f442"
			],
			"greedy_matches": [
				"1f442"
			],
			"decimal": ""
		},
		"keywords": [
			"body"
		]
	},
	"1f442-1f3fb": {
		"name": "ear: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 284,
		"display": 1,
		"shortname": ":ear_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442-1f3fb",
			"fully_qualified": "1f442-1f3fb",
			"non_fully_qualified": "1f442-1f3fb",
			"output": "1f442-1f3fb",
			"default_matches": [
				"1f442-1f3fb"
			],
			"greedy_matches": [
				"1f442-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"light skin tone"
		]
	},
	"1f442-1f3fc": {
		"name": "ear: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 285,
		"display": 1,
		"shortname": ":ear_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442-1f3fc",
			"fully_qualified": "1f442-1f3fc",
			"non_fully_qualified": "1f442-1f3fc",
			"output": "1f442-1f3fc",
			"default_matches": [
				"1f442-1f3fc"
			],
			"greedy_matches": [
				"1f442-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium-light skin tone"
		]
	},
	"1f442-1f3fd": {
		"name": "ear: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 286,
		"display": 1,
		"shortname": ":ear_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442-1f3fd",
			"fully_qualified": "1f442-1f3fd",
			"non_fully_qualified": "1f442-1f3fd",
			"output": "1f442-1f3fd",
			"default_matches": [
				"1f442-1f3fd"
			],
			"greedy_matches": [
				"1f442-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium skin tone"
		]
	},
	"1f442-1f3fe": {
		"name": "ear: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 287,
		"display": 1,
		"shortname": ":ear_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442-1f3fe",
			"fully_qualified": "1f442-1f3fe",
			"non_fully_qualified": "1f442-1f3fe",
			"output": "1f442-1f3fe",
			"default_matches": [
				"1f442-1f3fe"
			],
			"greedy_matches": [
				"1f442-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium-dark skin tone"
		]
	},
	"1f442-1f3ff": {
		"name": "ear: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 288,
		"display": 1,
		"shortname": ":ear_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f442-1f3ff",
			"fully_qualified": "1f442-1f3ff",
			"non_fully_qualified": "1f442-1f3ff",
			"output": "1f442-1f3ff",
			"default_matches": [
				"1f442-1f3ff"
			],
			"greedy_matches": [
				"1f442-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"dark skin tone"
		]
	},
	"1f443": {
		"name": "nose",
		"unicode_version": 6,
		"category": "people",
		"order": 289,
		"display": 1,
		"shortname": ":nose:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f443-1f3fb",
			"1f443-1f3fc",
			"1f443-1f3fd",
			"1f443-1f3fe",
			"1f443-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443",
			"fully_qualified": "1f443",
			"non_fully_qualified": "1f443",
			"output": "1f443",
			"default_matches": [
				"1f443"
			],
			"greedy_matches": [
				"1f443"
			],
			"decimal": ""
		},
		"keywords": [
			"body"
		]
	},
	"1f443-1f3fb": {
		"name": "nose: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 290,
		"display": 1,
		"shortname": ":nose_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443-1f3fb",
			"fully_qualified": "1f443-1f3fb",
			"non_fully_qualified": "1f443-1f3fb",
			"output": "1f443-1f3fb",
			"default_matches": [
				"1f443-1f3fb"
			],
			"greedy_matches": [
				"1f443-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"light skin tone"
		]
	},
	"1f443-1f3fc": {
		"name": "nose: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 291,
		"display": 1,
		"shortname": ":nose_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443-1f3fc",
			"fully_qualified": "1f443-1f3fc",
			"non_fully_qualified": "1f443-1f3fc",
			"output": "1f443-1f3fc",
			"default_matches": [
				"1f443-1f3fc"
			],
			"greedy_matches": [
				"1f443-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium-light skin tone"
		]
	},
	"1f443-1f3fd": {
		"name": "nose: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 292,
		"display": 1,
		"shortname": ":nose_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443-1f3fd",
			"fully_qualified": "1f443-1f3fd",
			"non_fully_qualified": "1f443-1f3fd",
			"output": "1f443-1f3fd",
			"default_matches": [
				"1f443-1f3fd"
			],
			"greedy_matches": [
				"1f443-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium skin tone"
		]
	},
	"1f443-1f3fe": {
		"name": "nose: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 293,
		"display": 1,
		"shortname": ":nose_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443-1f3fe",
			"fully_qualified": "1f443-1f3fe",
			"non_fully_qualified": "1f443-1f3fe",
			"output": "1f443-1f3fe",
			"default_matches": [
				"1f443-1f3fe"
			],
			"greedy_matches": [
				"1f443-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"medium-dark skin tone"
		]
	},
	"1f443-1f3ff": {
		"name": "nose: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 294,
		"display": 1,
		"shortname": ":nose_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f443-1f3ff",
			"fully_qualified": "1f443-1f3ff",
			"non_fully_qualified": "1f443-1f3ff",
			"output": "1f443-1f3ff",
			"default_matches": [
				"1f443-1f3ff"
			],
			"greedy_matches": [
				"1f443-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"body",
			"dark skin tone"
		]
	},
	"1f463": {
		"name": "footprints",
		"unicode_version": 6,
		"category": "people",
		"order": 295,
		"display": 1,
		"shortname": ":footprints:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f463",
			"fully_qualified": "1f463",
			"non_fully_qualified": "1f463",
			"output": "1f463",
			"default_matches": [
				"1f463"
			],
			"greedy_matches": [
				"1f463"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"footprint",
			"print"
		]
	},
	"1f441": {
		"name": "eye",
		"unicode_version": 7,
		"category": "people",
		"order": 296,
		"display": 1,
		"shortname": ":eye:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f441",
			"fully_qualified": "1f441-fe0f",
			"non_fully_qualified": "1f441",
			"output": "1f441-fe0f",
			"default_matches": [
				"1f441-fe0f",
				"1f441"
			],
			"greedy_matches": [
				"1f441-fe0f",
				"1f441"
			],
			"decimal": ""
		},
		"keywords": [
			"body"
		]
	},
	"1f440": {
		"name": "eyes",
		"unicode_version": 6,
		"category": "people",
		"order": 297,
		"display": 1,
		"shortname": ":eyes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f440",
			"fully_qualified": "1f440",
			"non_fully_qualified": "1f440",
			"output": "1f440",
			"default_matches": [
				"1f440"
			],
			"greedy_matches": [
				"1f440"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"face"
		]
	},
	"1f5e3": {
		"name": "speaking head",
		"unicode_version": 7,
		"category": "people",
		"order": 298,
		"display": 1,
		"shortname": ":speaking_head:",
		"shortname_alternates": [
			":speaking_head_in_silhouette:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5e3",
			"fully_qualified": "1f5e3-fe0f",
			"non_fully_qualified": "1f5e3",
			"output": "1f5e3-fe0f",
			"default_matches": [
				"1f5e3-fe0f",
				"1f5e3"
			],
			"greedy_matches": [
				"1f5e3-fe0f",
				"1f5e3"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"head",
			"silhouette",
			"speak",
			"speaking"
		]
	},
	"1f464": {
		"name": "bust in silhouette",
		"unicode_version": 6,
		"category": "people",
		"order": 299,
		"display": 1,
		"shortname": ":bust_in_silhouette:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f464",
			"fully_qualified": "1f464",
			"non_fully_qualified": "1f464",
			"output": "1f464",
			"default_matches": [
				"1f464"
			],
			"greedy_matches": [
				"1f464"
			],
			"decimal": ""
		},
		"keywords": [
			"bust",
			"silhouette"
		]
	},
	"1f465": {
		"name": "busts in silhouette",
		"unicode_version": 6,
		"category": "people",
		"order": 300,
		"display": 1,
		"shortname": ":busts_in_silhouette:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f465",
			"fully_qualified": "1f465",
			"non_fully_qualified": "1f465",
			"output": "1f465",
			"default_matches": [
				"1f465"
			],
			"greedy_matches": [
				"1f465"
			],
			"decimal": ""
		},
		"keywords": [
			"bust",
			"silhouette"
		]
	},
	"1f476": {
		"name": "baby",
		"unicode_version": 6,
		"category": "people",
		"order": 301,
		"display": 1,
		"shortname": ":baby:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f476-1f3fb",
			"1f476-1f3fc",
			"1f476-1f3fd",
			"1f476-1f3fe",
			"1f476-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476",
			"fully_qualified": "1f476",
			"non_fully_qualified": "1f476",
			"output": "1f476",
			"default_matches": [
				"1f476"
			],
			"greedy_matches": [
				"1f476"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"young"
		]
	},
	"1f476-1f3fb": {
		"name": "baby: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 302,
		"display": 1,
		"shortname": ":baby_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476-1f3fb",
			"fully_qualified": "1f476-1f3fb",
			"non_fully_qualified": "1f476-1f3fb",
			"output": "1f476-1f3fb",
			"default_matches": [
				"1f476-1f3fb"
			],
			"greedy_matches": [
				"1f476-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"light skin tone",
			"young"
		]
	},
	"1f476-1f3fc": {
		"name": "baby: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 303,
		"display": 1,
		"shortname": ":baby_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476-1f3fc",
			"fully_qualified": "1f476-1f3fc",
			"non_fully_qualified": "1f476-1f3fc",
			"output": "1f476-1f3fc",
			"default_matches": [
				"1f476-1f3fc"
			],
			"greedy_matches": [
				"1f476-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"medium-light skin tone",
			"young"
		]
	},
	"1f476-1f3fd": {
		"name": "baby: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 304,
		"display": 1,
		"shortname": ":baby_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476-1f3fd",
			"fully_qualified": "1f476-1f3fd",
			"non_fully_qualified": "1f476-1f3fd",
			"output": "1f476-1f3fd",
			"default_matches": [
				"1f476-1f3fd"
			],
			"greedy_matches": [
				"1f476-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"medium skin tone",
			"young"
		]
	},
	"1f476-1f3fe": {
		"name": "baby: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 305,
		"display": 1,
		"shortname": ":baby_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476-1f3fe",
			"fully_qualified": "1f476-1f3fe",
			"non_fully_qualified": "1f476-1f3fe",
			"output": "1f476-1f3fe",
			"default_matches": [
				"1f476-1f3fe"
			],
			"greedy_matches": [
				"1f476-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"medium-dark skin tone",
			"young"
		]
	},
	"1f476-1f3ff": {
		"name": "baby: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 306,
		"display": 1,
		"shortname": ":baby_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f476-1f3ff",
			"fully_qualified": "1f476-1f3ff",
			"non_fully_qualified": "1f476-1f3ff",
			"output": "1f476-1f3ff",
			"default_matches": [
				"1f476-1f3ff"
			],
			"greedy_matches": [
				"1f476-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"dark skin tone",
			"young"
		]
	},
	"1f466": {
		"name": "boy",
		"unicode_version": 6,
		"category": "people",
		"order": 307,
		"display": 1,
		"shortname": ":boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f466-1f3fb",
			"1f466-1f3fc",
			"1f466-1f3fd",
			"1f466-1f3fe",
			"1f466-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466",
			"fully_qualified": "1f466",
			"non_fully_qualified": "1f466",
			"output": "1f466",
			"default_matches": [
				"1f466"
			],
			"greedy_matches": [
				"1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"young"
		]
	},
	"1f466-1f3fb": {
		"name": "boy: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 308,
		"display": 1,
		"shortname": ":boy_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466-1f3fb",
			"fully_qualified": "1f466-1f3fb",
			"non_fully_qualified": "1f466-1f3fb",
			"output": "1f466-1f3fb",
			"default_matches": [
				"1f466-1f3fb"
			],
			"greedy_matches": [
				"1f466-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"light skin tone",
			"young"
		]
	},
	"1f466-1f3fc": {
		"name": "boy: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 309,
		"display": 1,
		"shortname": ":boy_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466-1f3fc",
			"fully_qualified": "1f466-1f3fc",
			"non_fully_qualified": "1f466-1f3fc",
			"output": "1f466-1f3fc",
			"default_matches": [
				"1f466-1f3fc"
			],
			"greedy_matches": [
				"1f466-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"medium-light skin tone",
			"young"
		]
	},
	"1f466-1f3fd": {
		"name": "boy: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 310,
		"display": 1,
		"shortname": ":boy_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466-1f3fd",
			"fully_qualified": "1f466-1f3fd",
			"non_fully_qualified": "1f466-1f3fd",
			"output": "1f466-1f3fd",
			"default_matches": [
				"1f466-1f3fd"
			],
			"greedy_matches": [
				"1f466-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"medium skin tone",
			"young"
		]
	},
	"1f466-1f3fe": {
		"name": "boy: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 311,
		"display": 1,
		"shortname": ":boy_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466-1f3fe",
			"fully_qualified": "1f466-1f3fe",
			"non_fully_qualified": "1f466-1f3fe",
			"output": "1f466-1f3fe",
			"default_matches": [
				"1f466-1f3fe"
			],
			"greedy_matches": [
				"1f466-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"medium-dark skin tone",
			"young"
		]
	},
	"1f466-1f3ff": {
		"name": "boy: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 312,
		"display": 1,
		"shortname": ":boy_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f466-1f3ff",
			"fully_qualified": "1f466-1f3ff",
			"non_fully_qualified": "1f466-1f3ff",
			"output": "1f466-1f3ff",
			"default_matches": [
				"1f466-1f3ff"
			],
			"greedy_matches": [
				"1f466-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"dark skin tone",
			"young"
		]
	},
	"1f467": {
		"name": "girl",
		"unicode_version": 6,
		"category": "people",
		"order": 313,
		"display": 1,
		"shortname": ":girl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f467-1f3fb",
			"1f467-1f3fc",
			"1f467-1f3fd",
			"1f467-1f3fe",
			"1f467-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467",
			"fully_qualified": "1f467",
			"non_fully_qualified": "1f467",
			"output": "1f467",
			"default_matches": [
				"1f467"
			],
			"greedy_matches": [
				"1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"young",
			"zodiac"
		]
	},
	"1f467-1f3fb": {
		"name": "girl: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 314,
		"display": 1,
		"shortname": ":girl_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467-1f3fb",
			"fully_qualified": "1f467-1f3fb",
			"non_fully_qualified": "1f467-1f3fb",
			"output": "1f467-1f3fb",
			"default_matches": [
				"1f467-1f3fb"
			],
			"greedy_matches": [
				"1f467-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"light skin tone",
			"young",
			"zodiac"
		]
	},
	"1f467-1f3fc": {
		"name": "girl: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 315,
		"display": 1,
		"shortname": ":girl_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467-1f3fc",
			"fully_qualified": "1f467-1f3fc",
			"non_fully_qualified": "1f467-1f3fc",
			"output": "1f467-1f3fc",
			"default_matches": [
				"1f467-1f3fc"
			],
			"greedy_matches": [
				"1f467-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"medium-light skin tone",
			"young",
			"zodiac"
		]
	},
	"1f467-1f3fd": {
		"name": "girl: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 316,
		"display": 1,
		"shortname": ":girl_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467-1f3fd",
			"fully_qualified": "1f467-1f3fd",
			"non_fully_qualified": "1f467-1f3fd",
			"output": "1f467-1f3fd",
			"default_matches": [
				"1f467-1f3fd"
			],
			"greedy_matches": [
				"1f467-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"medium skin tone",
			"young",
			"zodiac"
		]
	},
	"1f467-1f3fe": {
		"name": "girl: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 317,
		"display": 1,
		"shortname": ":girl_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467-1f3fe",
			"fully_qualified": "1f467-1f3fe",
			"non_fully_qualified": "1f467-1f3fe",
			"output": "1f467-1f3fe",
			"default_matches": [
				"1f467-1f3fe"
			],
			"greedy_matches": [
				"1f467-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"medium-dark skin tone",
			"young",
			"zodiac"
		]
	},
	"1f467-1f3ff": {
		"name": "girl: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 318,
		"display": 1,
		"shortname": ":girl_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f467-1f3ff",
			"fully_qualified": "1f467-1f3ff",
			"non_fully_qualified": "1f467-1f3ff",
			"output": "1f467-1f3ff",
			"default_matches": [
				"1f467-1f3ff"
			],
			"greedy_matches": [
				"1f467-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"Virgo",
			"dark skin tone",
			"young",
			"zodiac"
		]
	},
	"1f468": {
		"name": "man",
		"unicode_version": 6,
		"category": "people",
		"order": 319,
		"display": 1,
		"shortname": ":man:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb",
			"1f468-1f3fc",
			"1f468-1f3fd",
			"1f468-1f3fe",
			"1f468-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468",
			"fully_qualified": "1f468",
			"non_fully_qualified": "1f468",
			"output": "1f468",
			"default_matches": [
				"1f468"
			],
			"greedy_matches": [
				"1f468"
			],
			"decimal": ""
		},
		"keywords": [
			"man"
		]
	},
	"1f468-1f3fb": {
		"name": "man: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 320,
		"display": 1,
		"shortname": ":man_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb",
			"fully_qualified": "1f468-1f3fb",
			"non_fully_qualified": "1f468-1f3fb",
			"output": "1f468-1f3fb",
			"default_matches": [
				"1f468-1f3fb"
			],
			"greedy_matches": [
				"1f468-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man"
		]
	},
	"1f468-1f3fc": {
		"name": "man: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 321,
		"display": 1,
		"shortname": ":man_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc",
			"fully_qualified": "1f468-1f3fc",
			"non_fully_qualified": "1f468-1f3fc",
			"output": "1f468-1f3fc",
			"default_matches": [
				"1f468-1f3fc"
			],
			"greedy_matches": [
				"1f468-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone"
		]
	},
	"1f468-1f3fd": {
		"name": "man: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 322,
		"display": 1,
		"shortname": ":man_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd",
			"fully_qualified": "1f468-1f3fd",
			"non_fully_qualified": "1f468-1f3fd",
			"output": "1f468-1f3fd",
			"default_matches": [
				"1f468-1f3fd"
			],
			"greedy_matches": [
				"1f468-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone"
		]
	},
	"1f468-1f3fe": {
		"name": "man: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 323,
		"display": 1,
		"shortname": ":man_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe",
			"fully_qualified": "1f468-1f3fe",
			"non_fully_qualified": "1f468-1f3fe",
			"output": "1f468-1f3fe",
			"default_matches": [
				"1f468-1f3fe"
			],
			"greedy_matches": [
				"1f468-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone"
		]
	},
	"1f468-1f3ff": {
		"name": "man: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 324,
		"display": 1,
		"shortname": ":man_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff",
			"fully_qualified": "1f468-1f3ff",
			"non_fully_qualified": "1f468-1f3ff",
			"output": "1f468-1f3ff",
			"default_matches": [
				"1f468-1f3ff"
			],
			"greedy_matches": [
				"1f468-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man"
		]
	},
	"1f469": {
		"name": "woman",
		"unicode_version": 6,
		"category": "people",
		"order": 325,
		"display": 1,
		"shortname": ":woman:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb",
			"1f469-1f3fc",
			"1f469-1f3fd",
			"1f469-1f3fe",
			"1f469-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469",
			"fully_qualified": "1f469",
			"non_fully_qualified": "1f469",
			"output": "1f469",
			"default_matches": [
				"1f469"
			],
			"greedy_matches": [
				"1f469"
			],
			"decimal": ""
		},
		"keywords": [
			"woman"
		]
	},
	"1f469-1f3fb": {
		"name": "woman: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 326,
		"display": 1,
		"shortname": ":woman_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb",
			"fully_qualified": "1f469-1f3fb",
			"non_fully_qualified": "1f469-1f3fb",
			"output": "1f469-1f3fb",
			"default_matches": [
				"1f469-1f3fb"
			],
			"greedy_matches": [
				"1f469-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"woman"
		]
	},
	"1f469-1f3fc": {
		"name": "woman: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 327,
		"display": 1,
		"shortname": ":woman_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc",
			"fully_qualified": "1f469-1f3fc",
			"non_fully_qualified": "1f469-1f3fc",
			"output": "1f469-1f3fc",
			"default_matches": [
				"1f469-1f3fc"
			],
			"greedy_matches": [
				"1f469-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"woman"
		]
	},
	"1f469-1f3fd": {
		"name": "woman: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 328,
		"display": 1,
		"shortname": ":woman_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd",
			"fully_qualified": "1f469-1f3fd",
			"non_fully_qualified": "1f469-1f3fd",
			"output": "1f469-1f3fd",
			"default_matches": [
				"1f469-1f3fd"
			],
			"greedy_matches": [
				"1f469-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"woman"
		]
	},
	"1f469-1f3fe": {
		"name": "woman: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 329,
		"display": 1,
		"shortname": ":woman_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe",
			"fully_qualified": "1f469-1f3fe",
			"non_fully_qualified": "1f469-1f3fe",
			"output": "1f469-1f3fe",
			"default_matches": [
				"1f469-1f3fe"
			],
			"greedy_matches": [
				"1f469-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f469-1f3ff": {
		"name": "woman: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 330,
		"display": 1,
		"shortname": ":woman_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff",
			"fully_qualified": "1f469-1f3ff",
			"non_fully_qualified": "1f469-1f3ff",
			"output": "1f469-1f3ff",
			"default_matches": [
				"1f469-1f3ff"
			],
			"greedy_matches": [
				"1f469-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"woman"
		]
	},
	"1f471-2640": {
		"name": "blond-haired woman",
		"unicode_version": 6,
		"category": "people",
		"order": 331,
		"display": 1,
		"shortname": ":blond-haired_woman:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f471-1f3fb-2640",
			"1f471-1f3fc-2640",
			"1f471-1f3fd-2640",
			"1f471-1f3fe-2640",
			"1f471-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-2640",
			"fully_qualified": "1f471-200d-2640-fe0f",
			"non_fully_qualified": "1f471-200d-2640",
			"output": "1f471-200d-2640-fe0f",
			"default_matches": [
				"1f471-200d-2640-fe0f",
				"1f471-200d-2640",
				"1f471-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-200d-2640-fe0f",
				"1f471-200d-2640",
				"1f471-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"woman"
		]
	},
	"1f471-1f3fb-2640": {
		"name": "blond-haired woman: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 332,
		"display": 1,
		"shortname": ":blond-haired_woman_tone1:",
		"shortname_alternates": [
			":blond-haired_woman_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fb-2640",
			"fully_qualified": "1f471-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f471-1f3fb-200d-2640",
			"output": "1f471-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f471-1f3fb-200d-2640-fe0f",
				"1f471-1f3fb-200d-2640",
				"1f471-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fb-200d-2640-fe0f",
				"1f471-1f3fb-200d-2640",
				"1f471-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"light skin tone",
			"woman"
		]
	},
	"1f471-1f3fc-2640": {
		"name": "blond-haired woman: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 333,
		"display": 1,
		"shortname": ":blond-haired_woman_tone2:",
		"shortname_alternates": [
			":blond-haired_woman_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fc-2640",
			"fully_qualified": "1f471-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f471-1f3fc-200d-2640",
			"output": "1f471-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f471-1f3fc-200d-2640-fe0f",
				"1f471-1f3fc-200d-2640",
				"1f471-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fc-200d-2640-fe0f",
				"1f471-1f3fc-200d-2640",
				"1f471-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f471-1f3fd-2640": {
		"name": "blond-haired woman: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 334,
		"display": 1,
		"shortname": ":blond-haired_woman_tone3:",
		"shortname_alternates": [
			":blond-haired_woman_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fd-2640",
			"fully_qualified": "1f471-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f471-1f3fd-200d-2640",
			"output": "1f471-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f471-1f3fd-200d-2640-fe0f",
				"1f471-1f3fd-200d-2640",
				"1f471-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fd-200d-2640-fe0f",
				"1f471-1f3fd-200d-2640",
				"1f471-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"medium skin tone",
			"woman"
		]
	},
	"1f471-1f3fe-2640": {
		"name": "blond-haired woman: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 335,
		"display": 1,
		"shortname": ":blond-haired_woman_tone4:",
		"shortname_alternates": [
			":blond-haired_woman_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fe-2640",
			"fully_qualified": "1f471-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f471-1f3fe-200d-2640",
			"output": "1f471-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f471-1f3fe-200d-2640-fe0f",
				"1f471-1f3fe-200d-2640",
				"1f471-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fe-200d-2640-fe0f",
				"1f471-1f3fe-200d-2640",
				"1f471-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f471-1f3ff-2640": {
		"name": "blond-haired woman: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 336,
		"display": 1,
		"shortname": ":blond-haired_woman_tone5:",
		"shortname_alternates": [
			":blond-haired_woman_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3ff-2640",
			"fully_qualified": "1f471-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f471-1f3ff-200d-2640",
			"output": "1f471-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f471-1f3ff-200d-2640-fe0f",
				"1f471-1f3ff-200d-2640",
				"1f471-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3ff-200d-2640-fe0f",
				"1f471-1f3ff-200d-2640",
				"1f471-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blonde",
			"dark skin tone",
			"woman"
		]
	},
	"1f471": {
		"name": "blond-haired person",
		"unicode_version": 6,
		"category": "people",
		"order": 337,
		"display": 1,
		"shortname": ":blond_haired_person:",
		"shortname_alternates": [
			":person_with_blond_hair:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f471-1f3fb",
			"1f471-1f3fc",
			"1f471-1f3fd",
			"1f471-1f3fe",
			"1f471-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f471-2642",
			"1f471-2640"
		],
		"code_points": {
			"base": "1f471",
			"fully_qualified": "1f471",
			"non_fully_qualified": "1f471",
			"output": "1f471",
			"default_matches": [
				"1f471"
			],
			"greedy_matches": [
				"1f471"
			],
			"decimal": ""
		},
		"keywords": [
			"blond"
		]
	},
	"1f471-1f3fb": {
		"name": "blond-haired person: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 338,
		"display": 1,
		"shortname": ":blond_haired_person_tone1:",
		"shortname_alternates": [
			":person_with_blond_hair_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f471-1f3fb-2642",
			"1f471-1f3fb-2640"
		],
		"code_points": {
			"base": "1f471-1f3fb",
			"fully_qualified": "1f471-1f3fb",
			"non_fully_qualified": "1f471-1f3fb",
			"output": "1f471-1f3fb",
			"default_matches": [
				"1f471-1f3fb"
			],
			"greedy_matches": [
				"1f471-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"light skin tone"
		]
	},
	"1f471-1f3fc": {
		"name": "blond-haired person: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 339,
		"display": 1,
		"shortname": ":blond_haired_person_tone2:",
		"shortname_alternates": [
			":person_with_blond_hair_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f471-1f3fc-2642",
			"1f471-1f3fc-2640"
		],
		"code_points": {
			"base": "1f471-1f3fc",
			"fully_qualified": "1f471-1f3fc",
			"non_fully_qualified": "1f471-1f3fc",
			"output": "1f471-1f3fc",
			"default_matches": [
				"1f471-1f3fc"
			],
			"greedy_matches": [
				"1f471-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"medium-light skin tone"
		]
	},
	"1f471-1f3fd": {
		"name": "blond-haired person: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 340,
		"display": 1,
		"shortname": ":blond_haired_person_tone3:",
		"shortname_alternates": [
			":person_with_blond_hair_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f471-1f3fd-2642",
			"1f471-1f3fd-2640"
		],
		"code_points": {
			"base": "1f471-1f3fd",
			"fully_qualified": "1f471-1f3fd",
			"non_fully_qualified": "1f471-1f3fd",
			"output": "1f471-1f3fd",
			"default_matches": [
				"1f471-1f3fd"
			],
			"greedy_matches": [
				"1f471-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"medium skin tone"
		]
	},
	"1f471-1f3fe": {
		"name": "blond-haired person: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 341,
		"display": 1,
		"shortname": ":blond_haired_person_tone4:",
		"shortname_alternates": [
			":person_with_blond_hair_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f471-1f3fe-2642",
			"1f471-1f3fe-2640"
		],
		"code_points": {
			"base": "1f471-1f3fe",
			"fully_qualified": "1f471-1f3fe",
			"non_fully_qualified": "1f471-1f3fe",
			"output": "1f471-1f3fe",
			"default_matches": [
				"1f471-1f3fe"
			],
			"greedy_matches": [
				"1f471-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"medium-dark skin tone"
		]
	},
	"1f471-1f3ff": {
		"name": "blond-haired person: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 342,
		"display": 1,
		"shortname": ":blond_haired_person_tone5:",
		"shortname_alternates": [
			":person_with_blond_hair_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f471-1f3ff-2642",
			"1f471-1f3ff-2640"
		],
		"code_points": {
			"base": "1f471-1f3ff",
			"fully_qualified": "1f471-1f3ff",
			"non_fully_qualified": "1f471-1f3ff",
			"output": "1f471-1f3ff",
			"default_matches": [
				"1f471-1f3ff"
			],
			"greedy_matches": [
				"1f471-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"dark skin tone"
		]
	},
	"1f471-2642": {
		"name": "blond-haired man",
		"unicode_version": 6,
		"category": "people",
		"order": 343,
		"display": 0,
		"shortname": ":blond-haired_man:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f471-1f3fb-2642",
			"1f471-1f3fc-2642",
			"1f471-1f3fd-2642",
			"1f471-1f3fe-2642",
			"1f471-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-2642",
			"fully_qualified": "1f471-200d-2642-fe0f",
			"non_fully_qualified": "1f471-200d-2642",
			"output": "1f471-200d-2642-fe0f",
			"default_matches": [
				"1f471-200d-2642-fe0f",
				"1f471-200d-2642",
				"1f471-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-200d-2642-fe0f",
				"1f471-200d-2642",
				"1f471-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"man"
		]
	},
	"1f471-1f3ff-2642": {
		"name": "blond-haired man: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 344,
		"display": 0,
		"shortname": ":blond-haired_man_tone5:",
		"shortname_alternates": [
			":blond-haired_man_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3ff-2642",
			"fully_qualified": "1f471-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f471-1f3ff-200d-2642",
			"output": "1f471-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f471-1f3ff-200d-2642-fe0f",
				"1f471-1f3ff-200d-2642",
				"1f471-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3ff-200d-2642-fe0f",
				"1f471-1f3ff-200d-2642",
				"1f471-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"dark skin tone",
			"man"
		]
	},
	"1f471-1f3fe-2642": {
		"name": "blond-haired man: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 345,
		"display": 0,
		"shortname": ":blond-haired_man_tone4:",
		"shortname_alternates": [
			":blond-haired_man_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fe-2642",
			"fully_qualified": "1f471-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f471-1f3fe-200d-2642",
			"output": "1f471-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f471-1f3fe-200d-2642-fe0f",
				"1f471-1f3fe-200d-2642",
				"1f471-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fe-200d-2642-fe0f",
				"1f471-1f3fe-200d-2642",
				"1f471-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f471-1f3fd-2642": {
		"name": "blond-haired man: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 346,
		"display": 0,
		"shortname": ":blond-haired_man_tone3:",
		"shortname_alternates": [
			":blond-haired_man_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fd-2642",
			"fully_qualified": "1f471-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f471-1f3fd-200d-2642",
			"output": "1f471-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f471-1f3fd-200d-2642-fe0f",
				"1f471-1f3fd-200d-2642",
				"1f471-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fd-200d-2642-fe0f",
				"1f471-1f3fd-200d-2642",
				"1f471-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"man",
			"medium skin tone"
		]
	},
	"1f471-1f3fc-2642": {
		"name": "blond-haired man: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 347,
		"display": 0,
		"shortname": ":blond-haired_man_tone2:",
		"shortname_alternates": [
			":blond-haired_man_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fc-2642",
			"fully_qualified": "1f471-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f471-1f3fc-200d-2642",
			"output": "1f471-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f471-1f3fc-200d-2642-fe0f",
				"1f471-1f3fc-200d-2642",
				"1f471-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fc-200d-2642-fe0f",
				"1f471-1f3fc-200d-2642",
				"1f471-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"man",
			"medium-light skin tone"
		]
	},
	"1f471-1f3fb-2642": {
		"name": "blond-haired man: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 348,
		"display": 0,
		"shortname": ":blond-haired_man_tone1:",
		"shortname_alternates": [
			":blond-haired_man_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f471-1f3fb-2642",
			"fully_qualified": "1f471-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f471-1f3fb-200d-2642",
			"output": "1f471-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f471-1f3fb-200d-2642-fe0f",
				"1f471-1f3fb-200d-2642",
				"1f471-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f471-1f3fb-200d-2642-fe0f",
				"1f471-1f3fb-200d-2642",
				"1f471-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"blond",
			"light skin tone",
			"man"
		]
	},
	"1f474": {
		"name": "old man",
		"unicode_version": 6,
		"category": "people",
		"order": 349,
		"display": 1,
		"shortname": ":older_man:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f474-1f3fb",
			"1f474-1f3fc",
			"1f474-1f3fd",
			"1f474-1f3fe",
			"1f474-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474",
			"fully_qualified": "1f474",
			"non_fully_qualified": "1f474",
			"output": "1f474",
			"default_matches": [
				"1f474"
			],
			"greedy_matches": [
				"1f474"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"old"
		]
	},
	"1f474-1f3fb": {
		"name": "old man: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 350,
		"display": 1,
		"shortname": ":older_man_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474-1f3fb",
			"fully_qualified": "1f474-1f3fb",
			"non_fully_qualified": "1f474-1f3fb",
			"output": "1f474-1f3fb",
			"default_matches": [
				"1f474-1f3fb"
			],
			"greedy_matches": [
				"1f474-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"old"
		]
	},
	"1f474-1f3fc": {
		"name": "old man: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 351,
		"display": 1,
		"shortname": ":older_man_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474-1f3fc",
			"fully_qualified": "1f474-1f3fc",
			"non_fully_qualified": "1f474-1f3fc",
			"output": "1f474-1f3fc",
			"default_matches": [
				"1f474-1f3fc"
			],
			"greedy_matches": [
				"1f474-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"old"
		]
	},
	"1f474-1f3fd": {
		"name": "old man: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 352,
		"display": 1,
		"shortname": ":older_man_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474-1f3fd",
			"fully_qualified": "1f474-1f3fd",
			"non_fully_qualified": "1f474-1f3fd",
			"output": "1f474-1f3fd",
			"default_matches": [
				"1f474-1f3fd"
			],
			"greedy_matches": [
				"1f474-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"old"
		]
	},
	"1f474-1f3fe": {
		"name": "old man: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 353,
		"display": 1,
		"shortname": ":older_man_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474-1f3fe",
			"fully_qualified": "1f474-1f3fe",
			"non_fully_qualified": "1f474-1f3fe",
			"output": "1f474-1f3fe",
			"default_matches": [
				"1f474-1f3fe"
			],
			"greedy_matches": [
				"1f474-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"old"
		]
	},
	"1f474-1f3ff": {
		"name": "old man: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 354,
		"display": 1,
		"shortname": ":older_man_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f474-1f3ff",
			"fully_qualified": "1f474-1f3ff",
			"non_fully_qualified": "1f474-1f3ff",
			"output": "1f474-1f3ff",
			"default_matches": [
				"1f474-1f3ff"
			],
			"greedy_matches": [
				"1f474-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"old"
		]
	},
	"1f475": {
		"name": "old woman",
		"unicode_version": 6,
		"category": "people",
		"order": 355,
		"display": 1,
		"shortname": ":older_woman:",
		"shortname_alternates": [
			":grandma:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f475-1f3fb",
			"1f475-1f3fc",
			"1f475-1f3fd",
			"1f475-1f3fe",
			"1f475-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475",
			"fully_qualified": "1f475",
			"non_fully_qualified": "1f475",
			"output": "1f475",
			"default_matches": [
				"1f475"
			],
			"greedy_matches": [
				"1f475"
			],
			"decimal": ""
		},
		"keywords": [
			"old",
			"woman"
		]
	},
	"1f475-1f3fb": {
		"name": "old woman: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 356,
		"display": 1,
		"shortname": ":older_woman_tone1:",
		"shortname_alternates": [
			":grandma_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475-1f3fb",
			"fully_qualified": "1f475-1f3fb",
			"non_fully_qualified": "1f475-1f3fb",
			"output": "1f475-1f3fb",
			"default_matches": [
				"1f475-1f3fb"
			],
			"greedy_matches": [
				"1f475-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"old",
			"woman"
		]
	},
	"1f475-1f3fc": {
		"name": "old woman: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 357,
		"display": 1,
		"shortname": ":older_woman_tone2:",
		"shortname_alternates": [
			":grandma_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475-1f3fc",
			"fully_qualified": "1f475-1f3fc",
			"non_fully_qualified": "1f475-1f3fc",
			"output": "1f475-1f3fc",
			"default_matches": [
				"1f475-1f3fc"
			],
			"greedy_matches": [
				"1f475-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"old",
			"woman"
		]
	},
	"1f475-1f3fd": {
		"name": "old woman: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 358,
		"display": 1,
		"shortname": ":older_woman_tone3:",
		"shortname_alternates": [
			":grandma_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475-1f3fd",
			"fully_qualified": "1f475-1f3fd",
			"non_fully_qualified": "1f475-1f3fd",
			"output": "1f475-1f3fd",
			"default_matches": [
				"1f475-1f3fd"
			],
			"greedy_matches": [
				"1f475-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"old",
			"woman"
		]
	},
	"1f475-1f3fe": {
		"name": "old woman: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 359,
		"display": 1,
		"shortname": ":older_woman_tone4:",
		"shortname_alternates": [
			":grandma_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475-1f3fe",
			"fully_qualified": "1f475-1f3fe",
			"non_fully_qualified": "1f475-1f3fe",
			"output": "1f475-1f3fe",
			"default_matches": [
				"1f475-1f3fe"
			],
			"greedy_matches": [
				"1f475-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"old",
			"woman"
		]
	},
	"1f475-1f3ff": {
		"name": "old woman: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 360,
		"display": 1,
		"shortname": ":older_woman_tone5:",
		"shortname_alternates": [
			":grandma_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f475-1f3ff",
			"fully_qualified": "1f475-1f3ff",
			"non_fully_qualified": "1f475-1f3ff",
			"output": "1f475-1f3ff",
			"default_matches": [
				"1f475-1f3ff"
			],
			"greedy_matches": [
				"1f475-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"old",
			"woman"
		]
	},
	"1f472": {
		"name": "man with Chinese cap",
		"unicode_version": 6,
		"category": "people",
		"order": 361,
		"display": 1,
		"shortname": ":man_with_chinese_cap:",
		"shortname_alternates": [
			":man_with_gua_pi_mao:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f472-1f3fb",
			"1f472-1f3fc",
			"1f472-1f3fd",
			"1f472-1f3fe",
			"1f472-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472",
			"fully_qualified": "1f472",
			"non_fully_qualified": "1f472",
			"output": "1f472",
			"default_matches": [
				"1f472"
			],
			"greedy_matches": [
				"1f472"
			],
			"decimal": ""
		},
		"keywords": [
			"gua pi mao",
			"hat",
			"man"
		]
	},
	"1f472-1f3fb": {
		"name": "man with Chinese cap: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 362,
		"display": 1,
		"shortname": ":man_with_chinese_cap_tone1:",
		"shortname_alternates": [
			":man_with_gua_pi_mao_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472-1f3fb",
			"fully_qualified": "1f472-1f3fb",
			"non_fully_qualified": "1f472-1f3fb",
			"output": "1f472-1f3fb",
			"default_matches": [
				"1f472-1f3fb"
			],
			"greedy_matches": [
				"1f472-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gua pi mao",
			"hat",
			"light skin tone",
			"man"
		]
	},
	"1f472-1f3fc": {
		"name": "man with Chinese cap: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 363,
		"display": 1,
		"shortname": ":man_with_chinese_cap_tone2:",
		"shortname_alternates": [
			":man_with_gua_pi_mao_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472-1f3fc",
			"fully_qualified": "1f472-1f3fc",
			"non_fully_qualified": "1f472-1f3fc",
			"output": "1f472-1f3fc",
			"default_matches": [
				"1f472-1f3fc"
			],
			"greedy_matches": [
				"1f472-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gua pi mao",
			"hat",
			"man",
			"medium-light skin tone"
		]
	},
	"1f472-1f3fd": {
		"name": "man with Chinese cap: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 364,
		"display": 1,
		"shortname": ":man_with_chinese_cap_tone3:",
		"shortname_alternates": [
			":man_with_gua_pi_mao_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472-1f3fd",
			"fully_qualified": "1f472-1f3fd",
			"non_fully_qualified": "1f472-1f3fd",
			"output": "1f472-1f3fd",
			"default_matches": [
				"1f472-1f3fd"
			],
			"greedy_matches": [
				"1f472-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gua pi mao",
			"hat",
			"man",
			"medium skin tone"
		]
	},
	"1f472-1f3fe": {
		"name": "man with Chinese cap: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 365,
		"display": 1,
		"shortname": ":man_with_chinese_cap_tone4:",
		"shortname_alternates": [
			":man_with_gua_pi_mao_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472-1f3fe",
			"fully_qualified": "1f472-1f3fe",
			"non_fully_qualified": "1f472-1f3fe",
			"output": "1f472-1f3fe",
			"default_matches": [
				"1f472-1f3fe"
			],
			"greedy_matches": [
				"1f472-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gua pi mao",
			"hat",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f472-1f3ff": {
		"name": "man with Chinese cap: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 366,
		"display": 1,
		"shortname": ":man_with_chinese_cap_tone5:",
		"shortname_alternates": [
			":man_with_gua_pi_mao_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f472-1f3ff",
			"fully_qualified": "1f472-1f3ff",
			"non_fully_qualified": "1f472-1f3ff",
			"output": "1f472-1f3ff",
			"default_matches": [
				"1f472-1f3ff"
			],
			"greedy_matches": [
				"1f472-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gua pi mao",
			"hat",
			"man"
		]
	},
	"1f473-2640": {
		"name": "woman wearing turban",
		"unicode_version": 6,
		"category": "people",
		"order": 367,
		"display": 1,
		"shortname": ":woman_wearing_turban:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f473-1f3fb-2640",
			"1f473-1f3fc-2640",
			"1f473-1f3fd-2640",
			"1f473-1f3fe-2640",
			"1f473-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-2640",
			"fully_qualified": "1f473-200d-2640-fe0f",
			"non_fully_qualified": "1f473-200d-2640",
			"output": "1f473-200d-2640-fe0f",
			"default_matches": [
				"1f473-200d-2640-fe0f",
				"1f473-200d-2640",
				"1f473-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-200d-2640-fe0f",
				"1f473-200d-2640",
				"1f473-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"turban",
			"woman"
		]
	},
	"1f473-1f3fb-2640": {
		"name": "woman wearing turban: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 368,
		"display": 1,
		"shortname": ":woman_wearing_turban_tone1:",
		"shortname_alternates": [
			":woman_wearing_turban_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fb-2640",
			"fully_qualified": "1f473-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f473-1f3fb-200d-2640",
			"output": "1f473-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f473-1f3fb-200d-2640-fe0f",
				"1f473-1f3fb-200d-2640",
				"1f473-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fb-200d-2640-fe0f",
				"1f473-1f3fb-200d-2640",
				"1f473-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"turban",
			"woman"
		]
	},
	"1f473-1f3fc-2640": {
		"name": "woman wearing turban: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 369,
		"display": 1,
		"shortname": ":woman_wearing_turban_tone2:",
		"shortname_alternates": [
			":woman_wearing_turban_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fc-2640",
			"fully_qualified": "1f473-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f473-1f3fc-200d-2640",
			"output": "1f473-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f473-1f3fc-200d-2640-fe0f",
				"1f473-1f3fc-200d-2640",
				"1f473-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fc-200d-2640-fe0f",
				"1f473-1f3fc-200d-2640",
				"1f473-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"turban",
			"woman"
		]
	},
	"1f473-1f3fd-2640": {
		"name": "woman wearing turban: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 370,
		"display": 1,
		"shortname": ":woman_wearing_turban_tone3:",
		"shortname_alternates": [
			":woman_wearing_turban_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fd-2640",
			"fully_qualified": "1f473-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f473-1f3fd-200d-2640",
			"output": "1f473-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f473-1f3fd-200d-2640-fe0f",
				"1f473-1f3fd-200d-2640",
				"1f473-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fd-200d-2640-fe0f",
				"1f473-1f3fd-200d-2640",
				"1f473-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"turban",
			"woman"
		]
	},
	"1f473-1f3fe-2640": {
		"name": "woman wearing turban: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 371,
		"display": 1,
		"shortname": ":woman_wearing_turban_tone4:",
		"shortname_alternates": [
			":woman_wearing_turban_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fe-2640",
			"fully_qualified": "1f473-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f473-1f3fe-200d-2640",
			"output": "1f473-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f473-1f3fe-200d-2640-fe0f",
				"1f473-1f3fe-200d-2640",
				"1f473-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fe-200d-2640-fe0f",
				"1f473-1f3fe-200d-2640",
				"1f473-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"turban",
			"woman"
		]
	},
	"1f473-1f3ff-2640": {
		"name": "woman wearing turban: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 372,
		"display": 1,
		"shortname": ":woman_wearing_turban_tone5:",
		"shortname_alternates": [
			":woman_wearing_turban_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3ff-2640",
			"fully_qualified": "1f473-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f473-1f3ff-200d-2640",
			"output": "1f473-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f473-1f3ff-200d-2640-fe0f",
				"1f473-1f3ff-200d-2640",
				"1f473-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3ff-200d-2640-fe0f",
				"1f473-1f3ff-200d-2640",
				"1f473-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"turban",
			"woman"
		]
	},
	"1f473": {
		"name": "person wearing turban",
		"unicode_version": 6,
		"category": "people",
		"order": 373,
		"display": 1,
		"shortname": ":person_wearing_turban:",
		"shortname_alternates": [
			":man_with_turban:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f473-1f3fb",
			"1f473-1f3fc",
			"1f473-1f3fd",
			"1f473-1f3fe",
			"1f473-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f473-2642",
			"1f473-2640"
		],
		"code_points": {
			"base": "1f473",
			"fully_qualified": "1f473",
			"non_fully_qualified": "1f473",
			"output": "1f473",
			"default_matches": [
				"1f473"
			],
			"greedy_matches": [
				"1f473"
			],
			"decimal": ""
		},
		"keywords": [
			"turban"
		]
	},
	"1f473-1f3fb": {
		"name": "person wearing turban: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 374,
		"display": 1,
		"shortname": ":person_wearing_turban_tone1:",
		"shortname_alternates": [
			":man_with_turban_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f473-1f3fb-2642",
			"1f473-1f3fb-2640"
		],
		"code_points": {
			"base": "1f473-1f3fb",
			"fully_qualified": "1f473-1f3fb",
			"non_fully_qualified": "1f473-1f3fb",
			"output": "1f473-1f3fb",
			"default_matches": [
				"1f473-1f3fb"
			],
			"greedy_matches": [
				"1f473-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"turban"
		]
	},
	"1f473-1f3fc": {
		"name": "person wearing turban: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 375,
		"display": 1,
		"shortname": ":person_wearing_turban_tone2:",
		"shortname_alternates": [
			":man_with_turban_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f473-1f3fc-2642",
			"1f473-1f3fc-2640"
		],
		"code_points": {
			"base": "1f473-1f3fc",
			"fully_qualified": "1f473-1f3fc",
			"non_fully_qualified": "1f473-1f3fc",
			"output": "1f473-1f3fc",
			"default_matches": [
				"1f473-1f3fc"
			],
			"greedy_matches": [
				"1f473-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"turban"
		]
	},
	"1f473-1f3fd": {
		"name": "person wearing turban: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 376,
		"display": 1,
		"shortname": ":person_wearing_turban_tone3:",
		"shortname_alternates": [
			":man_with_turban_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f473-1f3fd-2642",
			"1f473-1f3fd-2640"
		],
		"code_points": {
			"base": "1f473-1f3fd",
			"fully_qualified": "1f473-1f3fd",
			"non_fully_qualified": "1f473-1f3fd",
			"output": "1f473-1f3fd",
			"default_matches": [
				"1f473-1f3fd"
			],
			"greedy_matches": [
				"1f473-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"turban"
		]
	},
	"1f473-1f3fe": {
		"name": "person wearing turban: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 377,
		"display": 1,
		"shortname": ":person_wearing_turban_tone4:",
		"shortname_alternates": [
			":man_with_turban_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f473-1f3fe-2642",
			"1f473-1f3fe-2640"
		],
		"code_points": {
			"base": "1f473-1f3fe",
			"fully_qualified": "1f473-1f3fe",
			"non_fully_qualified": "1f473-1f3fe",
			"output": "1f473-1f3fe",
			"default_matches": [
				"1f473-1f3fe"
			],
			"greedy_matches": [
				"1f473-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"turban"
		]
	},
	"1f473-1f3ff": {
		"name": "person wearing turban: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 378,
		"display": 1,
		"shortname": ":person_wearing_turban_tone5:",
		"shortname_alternates": [
			":man_with_turban_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f473-1f3ff-2642",
			"1f473-1f3ff-2640"
		],
		"code_points": {
			"base": "1f473-1f3ff",
			"fully_qualified": "1f473-1f3ff",
			"non_fully_qualified": "1f473-1f3ff",
			"output": "1f473-1f3ff",
			"default_matches": [
				"1f473-1f3ff"
			],
			"greedy_matches": [
				"1f473-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"turban"
		]
	},
	"1f473-2642": {
		"name": "man wearing turban",
		"unicode_version": 6,
		"category": "people",
		"order": 379,
		"display": 0,
		"shortname": ":man_wearing_turban:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f473-1f3fb-2642",
			"1f473-1f3fc-2642",
			"1f473-1f3fd-2642",
			"1f473-1f3fe-2642",
			"1f473-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-2642",
			"fully_qualified": "1f473-200d-2642-fe0f",
			"non_fully_qualified": "1f473-200d-2642",
			"output": "1f473-200d-2642-fe0f",
			"default_matches": [
				"1f473-200d-2642-fe0f",
				"1f473-200d-2642",
				"1f473-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-200d-2642-fe0f",
				"1f473-200d-2642",
				"1f473-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"turban"
		]
	},
	"1f473-1f3ff-2642": {
		"name": "man wearing turban: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 380,
		"display": 0,
		"shortname": ":man_wearing_turban_tone5:",
		"shortname_alternates": [
			":man_wearing_turban_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3ff-2642",
			"fully_qualified": "1f473-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f473-1f3ff-200d-2642",
			"output": "1f473-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f473-1f3ff-200d-2642-fe0f",
				"1f473-1f3ff-200d-2642",
				"1f473-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3ff-200d-2642-fe0f",
				"1f473-1f3ff-200d-2642",
				"1f473-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"turban"
		]
	},
	"1f473-1f3fe-2642": {
		"name": "man wearing turban: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 381,
		"display": 0,
		"shortname": ":man_wearing_turban_tone4:",
		"shortname_alternates": [
			":man_wearing_turban_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fe-2642",
			"fully_qualified": "1f473-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f473-1f3fe-200d-2642",
			"output": "1f473-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f473-1f3fe-200d-2642-fe0f",
				"1f473-1f3fe-200d-2642",
				"1f473-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fe-200d-2642-fe0f",
				"1f473-1f3fe-200d-2642",
				"1f473-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"turban"
		]
	},
	"1f473-1f3fd-2642": {
		"name": "man wearing turban: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 382,
		"display": 0,
		"shortname": ":man_wearing_turban_tone3:",
		"shortname_alternates": [
			":man_wearing_turban_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fd-2642",
			"fully_qualified": "1f473-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f473-1f3fd-200d-2642",
			"output": "1f473-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f473-1f3fd-200d-2642-fe0f",
				"1f473-1f3fd-200d-2642",
				"1f473-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fd-200d-2642-fe0f",
				"1f473-1f3fd-200d-2642",
				"1f473-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"turban"
		]
	},
	"1f473-1f3fc-2642": {
		"name": "man wearing turban: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 383,
		"display": 0,
		"shortname": ":man_wearing_turban_tone2:",
		"shortname_alternates": [
			":man_wearing_turban_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fc-2642",
			"fully_qualified": "1f473-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f473-1f3fc-200d-2642",
			"output": "1f473-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f473-1f3fc-200d-2642-fe0f",
				"1f473-1f3fc-200d-2642",
				"1f473-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fc-200d-2642-fe0f",
				"1f473-1f3fc-200d-2642",
				"1f473-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"turban"
		]
	},
	"1f473-1f3fb-2642": {
		"name": "man wearing turban: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 384,
		"display": 0,
		"shortname": ":man_wearing_turban_tone1:",
		"shortname_alternates": [
			":man_wearing_turban_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f473-1f3fb-2642",
			"fully_qualified": "1f473-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f473-1f3fb-200d-2642",
			"output": "1f473-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f473-1f3fb-200d-2642-fe0f",
				"1f473-1f3fb-200d-2642",
				"1f473-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f473-1f3fb-200d-2642-fe0f",
				"1f473-1f3fb-200d-2642",
				"1f473-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"turban"
		]
	},
	"1f46e-2640": {
		"name": "woman police officer",
		"unicode_version": 6,
		"category": "people",
		"order": 385,
		"display": 1,
		"shortname": ":woman_police_officer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f46e-1f3fb-2640",
			"1f46e-1f3fc-2640",
			"1f46e-1f3fd-2640",
			"1f46e-1f3fe-2640",
			"1f46e-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-2640",
			"fully_qualified": "1f46e-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-200d-2640",
			"output": "1f46e-200d-2640-fe0f",
			"default_matches": [
				"1f46e-200d-2640-fe0f",
				"1f46e-200d-2640",
				"1f46e-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-200d-2640-fe0f",
				"1f46e-200d-2640",
				"1f46e-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e-1f3fb-2640": {
		"name": "woman police officer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 386,
		"display": 1,
		"shortname": ":woman_police_officer_tone1:",
		"shortname_alternates": [
			":woman_police_officer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fb-2640",
			"fully_qualified": "1f46e-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-1f3fb-200d-2640",
			"output": "1f46e-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f46e-1f3fb-200d-2640-fe0f",
				"1f46e-1f3fb-200d-2640",
				"1f46e-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fb-200d-2640-fe0f",
				"1f46e-1f3fb-200d-2640",
				"1f46e-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"light skin tone",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e-1f3fc-2640": {
		"name": "woman police officer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 387,
		"display": 1,
		"shortname": ":woman_police_officer_tone2:",
		"shortname_alternates": [
			":woman_police_officer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fc-2640",
			"fully_qualified": "1f46e-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-1f3fc-200d-2640",
			"output": "1f46e-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f46e-1f3fc-200d-2640-fe0f",
				"1f46e-1f3fc-200d-2640",
				"1f46e-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fc-200d-2640-fe0f",
				"1f46e-1f3fc-200d-2640",
				"1f46e-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium-light skin tone",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e-1f3fd-2640": {
		"name": "woman police officer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 388,
		"display": 1,
		"shortname": ":woman_police_officer_tone3:",
		"shortname_alternates": [
			":woman_police_officer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fd-2640",
			"fully_qualified": "1f46e-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-1f3fd-200d-2640",
			"output": "1f46e-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f46e-1f3fd-200d-2640-fe0f",
				"1f46e-1f3fd-200d-2640",
				"1f46e-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fd-200d-2640-fe0f",
				"1f46e-1f3fd-200d-2640",
				"1f46e-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium skin tone",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e-1f3fe-2640": {
		"name": "woman police officer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 389,
		"display": 1,
		"shortname": ":woman_police_officer_tone4:",
		"shortname_alternates": [
			":woman_police_officer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fe-2640",
			"fully_qualified": "1f46e-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-1f3fe-200d-2640",
			"output": "1f46e-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f46e-1f3fe-200d-2640-fe0f",
				"1f46e-1f3fe-200d-2640",
				"1f46e-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fe-200d-2640-fe0f",
				"1f46e-1f3fe-200d-2640",
				"1f46e-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium-dark skin tone",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e-1f3ff-2640": {
		"name": "woman police officer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 390,
		"display": 1,
		"shortname": ":woman_police_officer_tone5:",
		"shortname_alternates": [
			":woman_police_officer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3ff-2640",
			"fully_qualified": "1f46e-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f46e-1f3ff-200d-2640",
			"output": "1f46e-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f46e-1f3ff-200d-2640-fe0f",
				"1f46e-1f3ff-200d-2640",
				"1f46e-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3ff-200d-2640-fe0f",
				"1f46e-1f3ff-200d-2640",
				"1f46e-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"dark skin tone",
			"officer",
			"police",
			"woman"
		]
	},
	"1f46e": {
		"name": "police officer",
		"unicode_version": 6,
		"category": "people",
		"order": 391,
		"display": 1,
		"shortname": ":police_officer:",
		"shortname_alternates": [
			":cop:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f46e-1f3fb",
			"1f46e-1f3fc",
			"1f46e-1f3fd",
			"1f46e-1f3fe",
			"1f46e-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f46e-2642",
			"1f46e-2640"
		],
		"code_points": {
			"base": "1f46e",
			"fully_qualified": "1f46e",
			"non_fully_qualified": "1f46e",
			"output": "1f46e",
			"default_matches": [
				"1f46e"
			],
			"greedy_matches": [
				"1f46e"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fb": {
		"name": "police officer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 392,
		"display": 1,
		"shortname": ":police_officer_tone1:",
		"shortname_alternates": [
			":cop_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46e-1f3fb-2642",
			"1f46e-1f3fb-2640"
		],
		"code_points": {
			"base": "1f46e-1f3fb",
			"fully_qualified": "1f46e-1f3fb",
			"non_fully_qualified": "1f46e-1f3fb",
			"output": "1f46e-1f3fb",
			"default_matches": [
				"1f46e-1f3fb"
			],
			"greedy_matches": [
				"1f46e-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"light skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fc": {
		"name": "police officer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 393,
		"display": 1,
		"shortname": ":police_officer_tone2:",
		"shortname_alternates": [
			":cop_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46e-1f3fc-2642",
			"1f46e-1f3fc-2640"
		],
		"code_points": {
			"base": "1f46e-1f3fc",
			"fully_qualified": "1f46e-1f3fc",
			"non_fully_qualified": "1f46e-1f3fc",
			"output": "1f46e-1f3fc",
			"default_matches": [
				"1f46e-1f3fc"
			],
			"greedy_matches": [
				"1f46e-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium-light skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fd": {
		"name": "police officer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 394,
		"display": 1,
		"shortname": ":police_officer_tone3:",
		"shortname_alternates": [
			":cop_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46e-1f3fd-2642",
			"1f46e-1f3fd-2640"
		],
		"code_points": {
			"base": "1f46e-1f3fd",
			"fully_qualified": "1f46e-1f3fd",
			"non_fully_qualified": "1f46e-1f3fd",
			"output": "1f46e-1f3fd",
			"default_matches": [
				"1f46e-1f3fd"
			],
			"greedy_matches": [
				"1f46e-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fe": {
		"name": "police officer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 395,
		"display": 1,
		"shortname": ":police_officer_tone4:",
		"shortname_alternates": [
			":cop_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46e-1f3fe-2642",
			"1f46e-1f3fe-2640"
		],
		"code_points": {
			"base": "1f46e-1f3fe",
			"fully_qualified": "1f46e-1f3fe",
			"non_fully_qualified": "1f46e-1f3fe",
			"output": "1f46e-1f3fe",
			"default_matches": [
				"1f46e-1f3fe"
			],
			"greedy_matches": [
				"1f46e-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"medium-dark skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3ff": {
		"name": "police officer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 396,
		"display": 1,
		"shortname": ":police_officer_tone5:",
		"shortname_alternates": [
			":cop_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46e-1f3ff-2642",
			"1f46e-1f3ff-2640"
		],
		"code_points": {
			"base": "1f46e-1f3ff",
			"fully_qualified": "1f46e-1f3ff",
			"non_fully_qualified": "1f46e-1f3ff",
			"output": "1f46e-1f3ff",
			"default_matches": [
				"1f46e-1f3ff"
			],
			"greedy_matches": [
				"1f46e-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"dark skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-2642": {
		"name": "man police officer",
		"unicode_version": 6,
		"category": "people",
		"order": 397,
		"display": 0,
		"shortname": ":man_police_officer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f46e-1f3fb-2642",
			"1f46e-1f3fc-2642",
			"1f46e-1f3fd-2642",
			"1f46e-1f3fe-2642",
			"1f46e-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-2642",
			"fully_qualified": "1f46e-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-200d-2642",
			"output": "1f46e-200d-2642-fe0f",
			"default_matches": [
				"1f46e-200d-2642-fe0f",
				"1f46e-200d-2642",
				"1f46e-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-200d-2642-fe0f",
				"1f46e-200d-2642",
				"1f46e-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"man",
			"officer",
			"police"
		]
	},
	"1f46e-1f3ff-2642": {
		"name": "man police officer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 398,
		"display": 0,
		"shortname": ":man_police_officer_tone5:",
		"shortname_alternates": [
			":man_police_officer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3ff-2642",
			"fully_qualified": "1f46e-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-1f3ff-200d-2642",
			"output": "1f46e-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f46e-1f3ff-200d-2642-fe0f",
				"1f46e-1f3ff-200d-2642",
				"1f46e-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3ff-200d-2642-fe0f",
				"1f46e-1f3ff-200d-2642",
				"1f46e-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"dark skin tone",
			"man",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fe-2642": {
		"name": "man police officer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 399,
		"display": 0,
		"shortname": ":man_police_officer_tone4:",
		"shortname_alternates": [
			":man_police_officer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fe-2642",
			"fully_qualified": "1f46e-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-1f3fe-200d-2642",
			"output": "1f46e-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f46e-1f3fe-200d-2642-fe0f",
				"1f46e-1f3fe-200d-2642",
				"1f46e-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fe-200d-2642-fe0f",
				"1f46e-1f3fe-200d-2642",
				"1f46e-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"man",
			"medium-dark skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fd-2642": {
		"name": "man police officer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 400,
		"display": 0,
		"shortname": ":man_police_officer_tone3:",
		"shortname_alternates": [
			":man_police_officer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fd-2642",
			"fully_qualified": "1f46e-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-1f3fd-200d-2642",
			"output": "1f46e-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f46e-1f3fd-200d-2642-fe0f",
				"1f46e-1f3fd-200d-2642",
				"1f46e-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fd-200d-2642-fe0f",
				"1f46e-1f3fd-200d-2642",
				"1f46e-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"man",
			"medium skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fc-2642": {
		"name": "man police officer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 401,
		"display": 0,
		"shortname": ":man_police_officer_tone2:",
		"shortname_alternates": [
			":man_police_officer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fc-2642",
			"fully_qualified": "1f46e-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-1f3fc-200d-2642",
			"output": "1f46e-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f46e-1f3fc-200d-2642-fe0f",
				"1f46e-1f3fc-200d-2642",
				"1f46e-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fc-200d-2642-fe0f",
				"1f46e-1f3fc-200d-2642",
				"1f46e-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"man",
			"medium-light skin tone",
			"officer",
			"police"
		]
	},
	"1f46e-1f3fb-2642": {
		"name": "man police officer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 402,
		"display": 0,
		"shortname": ":man_police_officer_tone1:",
		"shortname_alternates": [
			":man_police_officer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46e-1f3fb-2642",
			"fully_qualified": "1f46e-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f46e-1f3fb-200d-2642",
			"output": "1f46e-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f46e-1f3fb-200d-2642-fe0f",
				"1f46e-1f3fb-200d-2642",
				"1f46e-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f46e-1f3fb-200d-2642-fe0f",
				"1f46e-1f3fb-200d-2642",
				"1f46e-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cop",
			"light skin tone",
			"man",
			"officer",
			"police"
		]
	},
	"1f477-2640": {
		"name": "woman construction worker",
		"unicode_version": 6,
		"category": "people",
		"order": 403,
		"display": 1,
		"shortname": ":woman_construction_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f477-1f3fb-2640",
			"1f477-1f3fc-2640",
			"1f477-1f3fd-2640",
			"1f477-1f3fe-2640",
			"1f477-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-2640",
			"fully_qualified": "1f477-200d-2640-fe0f",
			"non_fully_qualified": "1f477-200d-2640",
			"output": "1f477-200d-2640-fe0f",
			"default_matches": [
				"1f477-200d-2640-fe0f",
				"1f477-200d-2640",
				"1f477-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-200d-2640-fe0f",
				"1f477-200d-2640",
				"1f477-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"woman",
			"worker"
		]
	},
	"1f477-1f3fb-2640": {
		"name": "woman construction worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 404,
		"display": 1,
		"shortname": ":woman_construction_worker_tone1:",
		"shortname_alternates": [
			":woman_construction_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fb-2640",
			"fully_qualified": "1f477-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f477-1f3fb-200d-2640",
			"output": "1f477-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f477-1f3fb-200d-2640-fe0f",
				"1f477-1f3fb-200d-2640",
				"1f477-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fb-200d-2640-fe0f",
				"1f477-1f3fb-200d-2640",
				"1f477-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"light skin tone",
			"woman",
			"worker"
		]
	},
	"1f477-1f3fc-2640": {
		"name": "woman construction worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 405,
		"display": 1,
		"shortname": ":woman_construction_worker_tone2:",
		"shortname_alternates": [
			":woman_construction_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fc-2640",
			"fully_qualified": "1f477-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f477-1f3fc-200d-2640",
			"output": "1f477-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f477-1f3fc-200d-2640-fe0f",
				"1f477-1f3fc-200d-2640",
				"1f477-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fc-200d-2640-fe0f",
				"1f477-1f3fc-200d-2640",
				"1f477-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"medium-light skin tone",
			"woman",
			"worker"
		]
	},
	"1f477-1f3fd-2640": {
		"name": "woman construction worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 406,
		"display": 1,
		"shortname": ":woman_construction_worker_tone3:",
		"shortname_alternates": [
			":woman_construction_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fd-2640",
			"fully_qualified": "1f477-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f477-1f3fd-200d-2640",
			"output": "1f477-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f477-1f3fd-200d-2640-fe0f",
				"1f477-1f3fd-200d-2640",
				"1f477-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fd-200d-2640-fe0f",
				"1f477-1f3fd-200d-2640",
				"1f477-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"medium skin tone",
			"woman",
			"worker"
		]
	},
	"1f477-1f3fe-2640": {
		"name": "woman construction worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 407,
		"display": 1,
		"shortname": ":woman_construction_worker_tone4:",
		"shortname_alternates": [
			":woman_construction_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fe-2640",
			"fully_qualified": "1f477-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f477-1f3fe-200d-2640",
			"output": "1f477-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f477-1f3fe-200d-2640-fe0f",
				"1f477-1f3fe-200d-2640",
				"1f477-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fe-200d-2640-fe0f",
				"1f477-1f3fe-200d-2640",
				"1f477-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"medium-dark skin tone",
			"woman",
			"worker"
		]
	},
	"1f477-1f3ff-2640": {
		"name": "woman construction worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 408,
		"display": 1,
		"shortname": ":woman_construction_worker_tone5:",
		"shortname_alternates": [
			":woman_construction_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3ff-2640",
			"fully_qualified": "1f477-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f477-1f3ff-200d-2640",
			"output": "1f477-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f477-1f3ff-200d-2640-fe0f",
				"1f477-1f3ff-200d-2640",
				"1f477-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3ff-200d-2640-fe0f",
				"1f477-1f3ff-200d-2640",
				"1f477-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"dark skin tone",
			"woman",
			"worker"
		]
	},
	"1f477": {
		"name": "construction worker",
		"unicode_version": 6,
		"category": "people",
		"order": 409,
		"display": 1,
		"shortname": ":construction_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f477-1f3fb",
			"1f477-1f3fc",
			"1f477-1f3fd",
			"1f477-1f3fe",
			"1f477-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f477-2642",
			"1f477-2640"
		],
		"code_points": {
			"base": "1f477",
			"fully_qualified": "1f477",
			"non_fully_qualified": "1f477",
			"output": "1f477",
			"default_matches": [
				"1f477"
			],
			"greedy_matches": [
				"1f477"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"hat",
			"worker"
		]
	},
	"1f477-1f3fb": {
		"name": "construction worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 410,
		"display": 1,
		"shortname": ":construction_worker_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f477-1f3fb-2642",
			"1f477-1f3fb-2640"
		],
		"code_points": {
			"base": "1f477-1f3fb",
			"fully_qualified": "1f477-1f3fb",
			"non_fully_qualified": "1f477-1f3fb",
			"output": "1f477-1f3fb",
			"default_matches": [
				"1f477-1f3fb"
			],
			"greedy_matches": [
				"1f477-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"hat",
			"light skin tone",
			"worker"
		]
	},
	"1f477-1f3fc": {
		"name": "construction worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 411,
		"display": 1,
		"shortname": ":construction_worker_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f477-1f3fc-2642",
			"1f477-1f3fc-2640"
		],
		"code_points": {
			"base": "1f477-1f3fc",
			"fully_qualified": "1f477-1f3fc",
			"non_fully_qualified": "1f477-1f3fc",
			"output": "1f477-1f3fc",
			"default_matches": [
				"1f477-1f3fc"
			],
			"greedy_matches": [
				"1f477-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"hat",
			"medium-light skin tone",
			"worker"
		]
	},
	"1f477-1f3fd": {
		"name": "construction worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 412,
		"display": 1,
		"shortname": ":construction_worker_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f477-1f3fd-2642",
			"1f477-1f3fd-2640"
		],
		"code_points": {
			"base": "1f477-1f3fd",
			"fully_qualified": "1f477-1f3fd",
			"non_fully_qualified": "1f477-1f3fd",
			"output": "1f477-1f3fd",
			"default_matches": [
				"1f477-1f3fd"
			],
			"greedy_matches": [
				"1f477-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"hat",
			"medium skin tone",
			"worker"
		]
	},
	"1f477-1f3fe": {
		"name": "construction worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 413,
		"display": 1,
		"shortname": ":construction_worker_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f477-1f3fe-2642",
			"1f477-1f3fe-2640"
		],
		"code_points": {
			"base": "1f477-1f3fe",
			"fully_qualified": "1f477-1f3fe",
			"non_fully_qualified": "1f477-1f3fe",
			"output": "1f477-1f3fe",
			"default_matches": [
				"1f477-1f3fe"
			],
			"greedy_matches": [
				"1f477-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"hat",
			"medium-dark skin tone",
			"worker"
		]
	},
	"1f477-1f3ff": {
		"name": "construction worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 414,
		"display": 1,
		"shortname": ":construction_worker_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f477-1f3ff-2642",
			"1f477-1f3ff-2640"
		],
		"code_points": {
			"base": "1f477-1f3ff",
			"fully_qualified": "1f477-1f3ff",
			"non_fully_qualified": "1f477-1f3ff",
			"output": "1f477-1f3ff",
			"default_matches": [
				"1f477-1f3ff"
			],
			"greedy_matches": [
				"1f477-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"dark skin tone",
			"hat",
			"worker"
		]
	},
	"1f477-2642": {
		"name": "man construction worker",
		"unicode_version": 6,
		"category": "people",
		"order": 415,
		"display": 0,
		"shortname": ":man_construction_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f477-1f3fb-2642",
			"1f477-1f3fc-2642",
			"1f477-1f3fd-2642",
			"1f477-1f3fe-2642",
			"1f477-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-2642",
			"fully_qualified": "1f477-200d-2642-fe0f",
			"non_fully_qualified": "1f477-200d-2642",
			"output": "1f477-200d-2642-fe0f",
			"default_matches": [
				"1f477-200d-2642-fe0f",
				"1f477-200d-2642",
				"1f477-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-200d-2642-fe0f",
				"1f477-200d-2642",
				"1f477-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"man",
			"worker"
		]
	},
	"1f477-1f3ff-2642": {
		"name": "man construction worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 416,
		"display": 0,
		"shortname": ":man_construction_worker_tone5:",
		"shortname_alternates": [
			":man_construction_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3ff-2642",
			"fully_qualified": "1f477-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f477-1f3ff-200d-2642",
			"output": "1f477-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f477-1f3ff-200d-2642-fe0f",
				"1f477-1f3ff-200d-2642",
				"1f477-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3ff-200d-2642-fe0f",
				"1f477-1f3ff-200d-2642",
				"1f477-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"dark skin tone",
			"man",
			"worker"
		]
	},
	"1f477-1f3fe-2642": {
		"name": "man construction worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 417,
		"display": 0,
		"shortname": ":man_construction_worker_tone4:",
		"shortname_alternates": [
			":man_construction_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fe-2642",
			"fully_qualified": "1f477-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f477-1f3fe-200d-2642",
			"output": "1f477-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f477-1f3fe-200d-2642-fe0f",
				"1f477-1f3fe-200d-2642",
				"1f477-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fe-200d-2642-fe0f",
				"1f477-1f3fe-200d-2642",
				"1f477-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"man",
			"medium-dark skin tone",
			"worker"
		]
	},
	"1f477-1f3fd-2642": {
		"name": "man construction worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 418,
		"display": 0,
		"shortname": ":man_construction_worker_tone3:",
		"shortname_alternates": [
			":man_construction_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fd-2642",
			"fully_qualified": "1f477-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f477-1f3fd-200d-2642",
			"output": "1f477-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f477-1f3fd-200d-2642-fe0f",
				"1f477-1f3fd-200d-2642",
				"1f477-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fd-200d-2642-fe0f",
				"1f477-1f3fd-200d-2642",
				"1f477-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"man",
			"medium skin tone",
			"worker"
		]
	},
	"1f477-1f3fc-2642": {
		"name": "man construction worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 419,
		"display": 0,
		"shortname": ":man_construction_worker_tone2:",
		"shortname_alternates": [
			":man_construction_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fc-2642",
			"fully_qualified": "1f477-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f477-1f3fc-200d-2642",
			"output": "1f477-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f477-1f3fc-200d-2642-fe0f",
				"1f477-1f3fc-200d-2642",
				"1f477-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fc-200d-2642-fe0f",
				"1f477-1f3fc-200d-2642",
				"1f477-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"man",
			"medium-light skin tone",
			"worker"
		]
	},
	"1f477-1f3fb-2642": {
		"name": "man construction worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 420,
		"display": 0,
		"shortname": ":man_construction_worker_tone1:",
		"shortname_alternates": [
			":man_construction_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f477-1f3fb-2642",
			"fully_qualified": "1f477-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f477-1f3fb-200d-2642",
			"output": "1f477-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f477-1f3fb-200d-2642-fe0f",
				"1f477-1f3fb-200d-2642",
				"1f477-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f477-1f3fb-200d-2642-fe0f",
				"1f477-1f3fb-200d-2642",
				"1f477-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"construction",
			"light skin tone",
			"man",
			"worker"
		]
	},
	"1f482-2640": {
		"name": "woman guard",
		"unicode_version": 6,
		"category": "people",
		"order": 421,
		"display": 1,
		"shortname": ":woman_guard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f482-1f3fb-2640",
			"1f482-1f3fc-2640",
			"1f482-1f3fd-2640",
			"1f482-1f3fe-2640",
			"1f482-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-2640",
			"fully_qualified": "1f482-200d-2640-fe0f",
			"non_fully_qualified": "1f482-200d-2640",
			"output": "1f482-200d-2640-fe0f",
			"default_matches": [
				"1f482-200d-2640-fe0f",
				"1f482-200d-2640",
				"1f482-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-200d-2640-fe0f",
				"1f482-200d-2640",
				"1f482-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"woman"
		]
	},
	"1f482-1f3fb-2640": {
		"name": "woman guard: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 422,
		"display": 1,
		"shortname": ":woman_guard_tone1:",
		"shortname_alternates": [
			":woman_guard_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fb-2640",
			"fully_qualified": "1f482-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f482-1f3fb-200d-2640",
			"output": "1f482-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f482-1f3fb-200d-2640-fe0f",
				"1f482-1f3fb-200d-2640",
				"1f482-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fb-200d-2640-fe0f",
				"1f482-1f3fb-200d-2640",
				"1f482-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"light skin tone",
			"woman"
		]
	},
	"1f482-1f3fc-2640": {
		"name": "woman guard: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 423,
		"display": 1,
		"shortname": ":woman_guard_tone2:",
		"shortname_alternates": [
			":woman_guard_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fc-2640",
			"fully_qualified": "1f482-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f482-1f3fc-200d-2640",
			"output": "1f482-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f482-1f3fc-200d-2640-fe0f",
				"1f482-1f3fc-200d-2640",
				"1f482-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fc-200d-2640-fe0f",
				"1f482-1f3fc-200d-2640",
				"1f482-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f482-1f3fd-2640": {
		"name": "woman guard: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 424,
		"display": 1,
		"shortname": ":woman_guard_tone3:",
		"shortname_alternates": [
			":woman_guard_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fd-2640",
			"fully_qualified": "1f482-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f482-1f3fd-200d-2640",
			"output": "1f482-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f482-1f3fd-200d-2640-fe0f",
				"1f482-1f3fd-200d-2640",
				"1f482-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fd-200d-2640-fe0f",
				"1f482-1f3fd-200d-2640",
				"1f482-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium skin tone",
			"woman"
		]
	},
	"1f482-1f3fe-2640": {
		"name": "woman guard: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 425,
		"display": 1,
		"shortname": ":woman_guard_tone4:",
		"shortname_alternates": [
			":woman_guard_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fe-2640",
			"fully_qualified": "1f482-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f482-1f3fe-200d-2640",
			"output": "1f482-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f482-1f3fe-200d-2640-fe0f",
				"1f482-1f3fe-200d-2640",
				"1f482-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fe-200d-2640-fe0f",
				"1f482-1f3fe-200d-2640",
				"1f482-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f482-1f3ff-2640": {
		"name": "woman guard: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 426,
		"display": 1,
		"shortname": ":woman_guard_tone5:",
		"shortname_alternates": [
			":woman_guard_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3ff-2640",
			"fully_qualified": "1f482-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f482-1f3ff-200d-2640",
			"output": "1f482-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f482-1f3ff-200d-2640-fe0f",
				"1f482-1f3ff-200d-2640",
				"1f482-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3ff-200d-2640-fe0f",
				"1f482-1f3ff-200d-2640",
				"1f482-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"guard",
			"woman"
		]
	},
	"1f482": {
		"name": "guard",
		"unicode_version": 6,
		"category": "people",
		"order": 427,
		"display": 1,
		"shortname": ":guard:",
		"shortname_alternates": [
			":guardsman:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f482-1f3fb",
			"1f482-1f3fc",
			"1f482-1f3fd",
			"1f482-1f3fe",
			"1f482-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f482-2642",
			"1f482-2640"
		],
		"code_points": {
			"base": "1f482",
			"fully_qualified": "1f482",
			"non_fully_qualified": "1f482",
			"output": "1f482",
			"default_matches": [
				"1f482"
			],
			"greedy_matches": [
				"1f482"
			],
			"decimal": ""
		},
		"keywords": [
			"guard"
		]
	},
	"1f482-1f3fb": {
		"name": "guard: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 428,
		"display": 1,
		"shortname": ":guard_tone1:",
		"shortname_alternates": [
			":guardsman_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f482-1f3fb-2642",
			"1f482-1f3fb-2640"
		],
		"code_points": {
			"base": "1f482-1f3fb",
			"fully_qualified": "1f482-1f3fb",
			"non_fully_qualified": "1f482-1f3fb",
			"output": "1f482-1f3fb",
			"default_matches": [
				"1f482-1f3fb"
			],
			"greedy_matches": [
				"1f482-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"light skin tone"
		]
	},
	"1f482-1f3fc": {
		"name": "guard: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 429,
		"display": 1,
		"shortname": ":guard_tone2:",
		"shortname_alternates": [
			":guardsman_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f482-1f3fc-2642",
			"1f482-1f3fc-2640"
		],
		"code_points": {
			"base": "1f482-1f3fc",
			"fully_qualified": "1f482-1f3fc",
			"non_fully_qualified": "1f482-1f3fc",
			"output": "1f482-1f3fc",
			"default_matches": [
				"1f482-1f3fc"
			],
			"greedy_matches": [
				"1f482-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium-light skin tone"
		]
	},
	"1f482-1f3fd": {
		"name": "guard: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 430,
		"display": 1,
		"shortname": ":guard_tone3:",
		"shortname_alternates": [
			":guardsman_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f482-1f3fd-2642",
			"1f482-1f3fd-2640"
		],
		"code_points": {
			"base": "1f482-1f3fd",
			"fully_qualified": "1f482-1f3fd",
			"non_fully_qualified": "1f482-1f3fd",
			"output": "1f482-1f3fd",
			"default_matches": [
				"1f482-1f3fd"
			],
			"greedy_matches": [
				"1f482-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium skin tone"
		]
	},
	"1f482-1f3fe": {
		"name": "guard: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 431,
		"display": 1,
		"shortname": ":guard_tone4:",
		"shortname_alternates": [
			":guardsman_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f482-1f3fe-2642",
			"1f482-1f3fe-2640"
		],
		"code_points": {
			"base": "1f482-1f3fe",
			"fully_qualified": "1f482-1f3fe",
			"non_fully_qualified": "1f482-1f3fe",
			"output": "1f482-1f3fe",
			"default_matches": [
				"1f482-1f3fe"
			],
			"greedy_matches": [
				"1f482-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"medium-dark skin tone"
		]
	},
	"1f482-1f3ff": {
		"name": "guard: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 432,
		"display": 1,
		"shortname": ":guard_tone5:",
		"shortname_alternates": [
			":guardsman_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f482-1f3ff-2642",
			"1f482-1f3ff-2640"
		],
		"code_points": {
			"base": "1f482-1f3ff",
			"fully_qualified": "1f482-1f3ff",
			"non_fully_qualified": "1f482-1f3ff",
			"output": "1f482-1f3ff",
			"default_matches": [
				"1f482-1f3ff"
			],
			"greedy_matches": [
				"1f482-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"guard"
		]
	},
	"1f482-2642": {
		"name": "man guard",
		"unicode_version": 6,
		"category": "people",
		"order": 433,
		"display": 0,
		"shortname": ":man_guard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f482-1f3fb-2642",
			"1f482-1f3fc-2642",
			"1f482-1f3fd-2642",
			"1f482-1f3fe-2642",
			"1f482-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-2642",
			"fully_qualified": "1f482-200d-2642-fe0f",
			"non_fully_qualified": "1f482-200d-2642",
			"output": "1f482-200d-2642-fe0f",
			"default_matches": [
				"1f482-200d-2642-fe0f",
				"1f482-200d-2642",
				"1f482-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-200d-2642-fe0f",
				"1f482-200d-2642",
				"1f482-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"man"
		]
	},
	"1f482-1f3ff-2642": {
		"name": "man guard: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 434,
		"display": 0,
		"shortname": ":man_guard_tone5:",
		"shortname_alternates": [
			":man_guard_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3ff-2642",
			"fully_qualified": "1f482-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f482-1f3ff-200d-2642",
			"output": "1f482-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f482-1f3ff-200d-2642-fe0f",
				"1f482-1f3ff-200d-2642",
				"1f482-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3ff-200d-2642-fe0f",
				"1f482-1f3ff-200d-2642",
				"1f482-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"guard",
			"man"
		]
	},
	"1f482-1f3fe-2642": {
		"name": "man guard: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 435,
		"display": 0,
		"shortname": ":man_guard_tone4:",
		"shortname_alternates": [
			":man_guard_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fe-2642",
			"fully_qualified": "1f482-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f482-1f3fe-200d-2642",
			"output": "1f482-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f482-1f3fe-200d-2642-fe0f",
				"1f482-1f3fe-200d-2642",
				"1f482-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fe-200d-2642-fe0f",
				"1f482-1f3fe-200d-2642",
				"1f482-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f482-1f3fd-2642": {
		"name": "man guard: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 436,
		"display": 0,
		"shortname": ":man_guard_tone3:",
		"shortname_alternates": [
			":man_guard_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fd-2642",
			"fully_qualified": "1f482-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f482-1f3fd-200d-2642",
			"output": "1f482-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f482-1f3fd-200d-2642-fe0f",
				"1f482-1f3fd-200d-2642",
				"1f482-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fd-200d-2642-fe0f",
				"1f482-1f3fd-200d-2642",
				"1f482-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"man",
			"medium skin tone"
		]
	},
	"1f482-1f3fc-2642": {
		"name": "man guard: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 437,
		"display": 0,
		"shortname": ":man_guard_tone2:",
		"shortname_alternates": [
			":man_guard_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fc-2642",
			"fully_qualified": "1f482-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f482-1f3fc-200d-2642",
			"output": "1f482-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f482-1f3fc-200d-2642-fe0f",
				"1f482-1f3fc-200d-2642",
				"1f482-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fc-200d-2642-fe0f",
				"1f482-1f3fc-200d-2642",
				"1f482-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"man",
			"medium-light skin tone"
		]
	},
	"1f482-1f3fb-2642": {
		"name": "man guard: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 438,
		"display": 0,
		"shortname": ":man_guard_tone1:",
		"shortname_alternates": [
			":man_guard_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f482-1f3fb-2642",
			"fully_qualified": "1f482-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f482-1f3fb-200d-2642",
			"output": "1f482-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f482-1f3fb-200d-2642-fe0f",
				"1f482-1f3fb-200d-2642",
				"1f482-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f482-1f3fb-200d-2642-fe0f",
				"1f482-1f3fb-200d-2642",
				"1f482-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"guard",
			"light skin tone",
			"man"
		]
	},
	"1f575-2640": {
		"name": "woman detective",
		"unicode_version": 7,
		"category": "people",
		"order": 439,
		"display": 1,
		"shortname": ":woman_detective:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f575-1f3fb-2640",
			"1f575-1f3fc-2640",
			"1f575-1f3fd-2640",
			"1f575-1f3fe-2640",
			"1f575-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-2640",
			"fully_qualified": "1f575-fe0f-200d-2640-fe0f",
			"non_fully_qualified": "1f575-200d-2640",
			"output": "1f575-fe0f-200d-2640-fe0f",
			"default_matches": [
				"1f575-fe0f-200d-2640-fe0f",
				"1f575-200d-2640",
				"1f575-fe0f-2640-fe0f",
				"1f575-200d-2640-fe0f",
				"1f575-fe0f-200d-2640"
			],
			"greedy_matches": [
				"1f575-fe0f-200d-2640-fe0f",
				"1f575-200d-2640",
				"1f575-fe0f-2640-fe0f",
				"1f575-200d-2640-fe0f",
				"1f575-fe0f-200d-2640"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575-1f3fb-2640": {
		"name": "woman detective: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 440,
		"display": 1,
		"shortname": ":woman_detective_tone1:",
		"shortname_alternates": [
			":woman_detective_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fb-2640",
			"fully_qualified": "1f575-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f575-1f3fb-200d-2640",
			"output": "1f575-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f575-1f3fb-200d-2640-fe0f",
				"1f575-1f3fb-200d-2640",
				"1f575-fe0f-1f3fb-200d-2640-fe0f",
				"1f575-fe0f-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fb-200d-2640-fe0f",
				"1f575-1f3fb-200d-2640",
				"1f575-fe0f-1f3fb-200d-2640-fe0f",
				"1f575-fe0f-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"light skin tone",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575-1f3fc-2640": {
		"name": "woman detective: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 441,
		"display": 1,
		"shortname": ":woman_detective_tone2:",
		"shortname_alternates": [
			":woman_detective_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fc-2640",
			"fully_qualified": "1f575-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f575-1f3fc-200d-2640",
			"output": "1f575-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f575-1f3fc-200d-2640-fe0f",
				"1f575-1f3fc-200d-2640",
				"1f575-fe0f-1f3fc-200d-2640-fe0f",
				"1f575-fe0f-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fc-200d-2640-fe0f",
				"1f575-1f3fc-200d-2640",
				"1f575-fe0f-1f3fc-200d-2640-fe0f",
				"1f575-fe0f-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium-light skin tone",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575-1f3fd-2640": {
		"name": "woman detective: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 442,
		"display": 1,
		"shortname": ":woman_detective_tone3:",
		"shortname_alternates": [
			":woman_detective_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fd-2640",
			"fully_qualified": "1f575-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f575-1f3fd-200d-2640",
			"output": "1f575-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f575-1f3fd-200d-2640-fe0f",
				"1f575-1f3fd-200d-2640",
				"1f575-fe0f-1f3fd-200d-2640-fe0f",
				"1f575-fe0f-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fd-200d-2640-fe0f",
				"1f575-1f3fd-200d-2640",
				"1f575-fe0f-1f3fd-200d-2640-fe0f",
				"1f575-fe0f-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium skin tone",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575-1f3fe-2640": {
		"name": "woman detective: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 443,
		"display": 1,
		"shortname": ":woman_detective_tone4:",
		"shortname_alternates": [
			":woman_detective_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fe-2640",
			"fully_qualified": "1f575-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f575-1f3fe-200d-2640",
			"output": "1f575-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f575-1f3fe-200d-2640-fe0f",
				"1f575-1f3fe-200d-2640",
				"1f575-fe0f-1f3fe-200d-2640-fe0f",
				"1f575-fe0f-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fe-200d-2640-fe0f",
				"1f575-1f3fe-200d-2640",
				"1f575-fe0f-1f3fe-200d-2640-fe0f",
				"1f575-fe0f-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium-dark skin tone",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575-1f3ff-2640": {
		"name": "woman detective: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 444,
		"display": 1,
		"shortname": ":woman_detective_tone5:",
		"shortname_alternates": [
			":woman_detective_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3ff-2640",
			"fully_qualified": "1f575-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f575-1f3ff-200d-2640",
			"output": "1f575-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f575-1f3ff-200d-2640-fe0f",
				"1f575-1f3ff-200d-2640",
				"1f575-fe0f-1f3ff-200d-2640-fe0f",
				"1f575-fe0f-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3ff-200d-2640-fe0f",
				"1f575-1f3ff-200d-2640",
				"1f575-fe0f-1f3ff-200d-2640-fe0f",
				"1f575-fe0f-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"detective",
			"sleuth",
			"spy",
			"woman"
		]
	},
	"1f575": {
		"name": "detective",
		"unicode_version": 7,
		"category": "people",
		"order": 445,
		"display": 1,
		"shortname": ":detective:",
		"shortname_alternates": [
			":spy:",
			":sleuth_or_spy:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f575-1f3fb",
			"1f575-1f3fc",
			"1f575-1f3fd",
			"1f575-1f3fe",
			"1f575-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f575-2642",
			"1f575-2640"
		],
		"code_points": {
			"base": "1f575",
			"fully_qualified": "1f575-fe0f",
			"non_fully_qualified": "1f575",
			"output": "1f575-fe0f",
			"default_matches": [
				"1f575-fe0f",
				"1f575"
			],
			"greedy_matches": [
				"1f575-fe0f",
				"1f575"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fb": {
		"name": "detective: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 446,
		"display": 1,
		"shortname": ":detective_tone1:",
		"shortname_alternates": [
			":spy_tone1:",
			":sleuth_or_spy_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f575-1f3fb-2642",
			"1f575-1f3fb-2640"
		],
		"code_points": {
			"base": "1f575-1f3fb",
			"fully_qualified": "1f575-1f3fb",
			"non_fully_qualified": "1f575-1f3fb",
			"output": "1f575-1f3fb",
			"default_matches": [
				"1f575-1f3fb",
				"1f575-fe0f-1f3fb"
			],
			"greedy_matches": [
				"1f575-1f3fb",
				"1f575-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"light skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fc": {
		"name": "detective: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 447,
		"display": 1,
		"shortname": ":detective_tone2:",
		"shortname_alternates": [
			":spy_tone2:",
			":sleuth_or_spy_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f575-1f3fc-2642",
			"1f575-1f3fc-2640"
		],
		"code_points": {
			"base": "1f575-1f3fc",
			"fully_qualified": "1f575-1f3fc",
			"non_fully_qualified": "1f575-1f3fc",
			"output": "1f575-1f3fc",
			"default_matches": [
				"1f575-1f3fc",
				"1f575-fe0f-1f3fc"
			],
			"greedy_matches": [
				"1f575-1f3fc",
				"1f575-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium-light skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fd": {
		"name": "detective: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 448,
		"display": 1,
		"shortname": ":detective_tone3:",
		"shortname_alternates": [
			":spy_tone3:",
			":sleuth_or_spy_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f575-1f3fd-2642",
			"1f575-1f3fd-2640"
		],
		"code_points": {
			"base": "1f575-1f3fd",
			"fully_qualified": "1f575-1f3fd",
			"non_fully_qualified": "1f575-1f3fd",
			"output": "1f575-1f3fd",
			"default_matches": [
				"1f575-1f3fd",
				"1f575-fe0f-1f3fd"
			],
			"greedy_matches": [
				"1f575-1f3fd",
				"1f575-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fe": {
		"name": "detective: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 449,
		"display": 1,
		"shortname": ":detective_tone4:",
		"shortname_alternates": [
			":spy_tone4:",
			":sleuth_or_spy_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f575-1f3fe-2642",
			"1f575-1f3fe-2640"
		],
		"code_points": {
			"base": "1f575-1f3fe",
			"fully_qualified": "1f575-1f3fe",
			"non_fully_qualified": "1f575-1f3fe",
			"output": "1f575-1f3fe",
			"default_matches": [
				"1f575-1f3fe",
				"1f575-fe0f-1f3fe"
			],
			"greedy_matches": [
				"1f575-1f3fe",
				"1f575-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"medium-dark skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3ff": {
		"name": "detective: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 450,
		"display": 1,
		"shortname": ":detective_tone5:",
		"shortname_alternates": [
			":spy_tone5:",
			":sleuth_or_spy_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f575-1f3ff-2642",
			"1f575-1f3ff-2640"
		],
		"code_points": {
			"base": "1f575-1f3ff",
			"fully_qualified": "1f575-1f3ff",
			"non_fully_qualified": "1f575-1f3ff",
			"output": "1f575-1f3ff",
			"default_matches": [
				"1f575-1f3ff",
				"1f575-fe0f-1f3ff"
			],
			"greedy_matches": [
				"1f575-1f3ff",
				"1f575-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"detective",
			"sleuth",
			"spy"
		]
	},
	"1f575-2642": {
		"name": "man detective",
		"unicode_version": 7,
		"category": "people",
		"order": 451,
		"display": 0,
		"shortname": ":man_detective:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f575-1f3fb-2642",
			"1f575-1f3fc-2642",
			"1f575-1f3fd-2642",
			"1f575-1f3fe-2642",
			"1f575-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-2642",
			"fully_qualified": "1f575-fe0f-200d-2642-fe0f",
			"non_fully_qualified": "1f575-200d-2642",
			"output": "1f575-fe0f-200d-2642-fe0f",
			"default_matches": [
				"1f575-fe0f-200d-2642-fe0f",
				"1f575-200d-2642",
				"1f575-fe0f-2642-fe0f",
				"1f575-200d-2642-fe0f",
				"1f575-fe0f-200d-2642"
			],
			"greedy_matches": [
				"1f575-fe0f-200d-2642-fe0f",
				"1f575-200d-2642",
				"1f575-fe0f-2642-fe0f",
				"1f575-200d-2642-fe0f",
				"1f575-fe0f-200d-2642"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"man",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3ff-2642": {
		"name": "man detective: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 452,
		"display": 0,
		"shortname": ":man_detective_tone5:",
		"shortname_alternates": [
			":man_detective_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3ff-2642",
			"fully_qualified": "1f575-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f575-1f3ff-200d-2642",
			"output": "1f575-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f575-1f3ff-200d-2642-fe0f",
				"1f575-1f3ff-200d-2642",
				"1f575-fe0f-1f3ff-200d-2642-fe0f",
				"1f575-fe0f-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3ff-200d-2642-fe0f",
				"1f575-1f3ff-200d-2642",
				"1f575-fe0f-1f3ff-200d-2642-fe0f",
				"1f575-fe0f-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"detective",
			"man",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fe-2642": {
		"name": "man detective: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 453,
		"display": 0,
		"shortname": ":man_detective_tone4:",
		"shortname_alternates": [
			":man_detective_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fe-2642",
			"fully_qualified": "1f575-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f575-1f3fe-200d-2642",
			"output": "1f575-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f575-1f3fe-200d-2642-fe0f",
				"1f575-1f3fe-200d-2642",
				"1f575-fe0f-1f3fe-200d-2642-fe0f",
				"1f575-fe0f-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fe-200d-2642-fe0f",
				"1f575-1f3fe-200d-2642",
				"1f575-fe0f-1f3fe-200d-2642-fe0f",
				"1f575-fe0f-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"man",
			"medium-dark skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fd-2642": {
		"name": "man detective: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 454,
		"display": 0,
		"shortname": ":man_detective_tone3:",
		"shortname_alternates": [
			":man_detective_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fd-2642",
			"fully_qualified": "1f575-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f575-1f3fd-200d-2642",
			"output": "1f575-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f575-1f3fd-200d-2642-fe0f",
				"1f575-1f3fd-200d-2642",
				"1f575-fe0f-1f3fd-200d-2642-fe0f",
				"1f575-fe0f-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fd-200d-2642-fe0f",
				"1f575-1f3fd-200d-2642",
				"1f575-fe0f-1f3fd-200d-2642-fe0f",
				"1f575-fe0f-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"man",
			"medium skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fc-2642": {
		"name": "man detective: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 455,
		"display": 0,
		"shortname": ":man_detective_tone2:",
		"shortname_alternates": [
			":man_detective_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fc-2642",
			"fully_qualified": "1f575-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f575-1f3fc-200d-2642",
			"output": "1f575-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f575-1f3fc-200d-2642-fe0f",
				"1f575-1f3fc-200d-2642",
				"1f575-fe0f-1f3fc-200d-2642-fe0f",
				"1f575-fe0f-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fc-200d-2642-fe0f",
				"1f575-1f3fc-200d-2642",
				"1f575-fe0f-1f3fc-200d-2642-fe0f",
				"1f575-fe0f-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"man",
			"medium-light skin tone",
			"sleuth",
			"spy"
		]
	},
	"1f575-1f3fb-2642": {
		"name": "man detective: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 456,
		"display": 0,
		"shortname": ":man_detective_tone1:",
		"shortname_alternates": [
			":man_detective_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f575-1f3fb-2642",
			"fully_qualified": "1f575-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f575-1f3fb-200d-2642",
			"output": "1f575-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f575-1f3fb-200d-2642-fe0f",
				"1f575-1f3fb-200d-2642",
				"1f575-fe0f-1f3fb-200d-2642-fe0f",
				"1f575-fe0f-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f575-1f3fb-200d-2642-fe0f",
				"1f575-1f3fb-200d-2642",
				"1f575-fe0f-1f3fb-200d-2642-fe0f",
				"1f575-fe0f-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"detective",
			"light skin tone",
			"man",
			"sleuth",
			"spy"
		]
	},
	"1f469-2695": {
		"name": "woman health worker",
		"unicode_version": 6,
		"category": "people",
		"order": 457,
		"display": 1,
		"shortname": ":woman_health_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-2695",
			"1f469-1f3fc-2695",
			"1f469-1f3fd-2695",
			"1f469-1f3fe-2695",
			"1f469-1f3ff-2695"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2695",
			"fully_qualified": "1f469-200d-2695-fe0f",
			"non_fully_qualified": "1f469-200d-2695",
			"output": "1f469-200d-2695-fe0f",
			"default_matches": [
				"1f469-200d-2695-fe0f",
				"1f469-200d-2695",
				"1f469-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-200d-2695-fe0f",
				"1f469-200d-2695",
				"1f469-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f469-1f3fb-2695": {
		"name": "woman health worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 458,
		"display": 1,
		"shortname": ":woman_health_worker_tone1:",
		"shortname_alternates": [
			":woman_health_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-2695",
			"fully_qualified": "1f469-1f3fb-200d-2695-fe0f",
			"non_fully_qualified": "1f469-1f3fb-200d-2695",
			"output": "1f469-1f3fb-200d-2695-fe0f",
			"default_matches": [
				"1f469-1f3fb-200d-2695-fe0f",
				"1f469-1f3fb-200d-2695",
				"1f469-1f3fb-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-2695-fe0f",
				"1f469-1f3fb-200d-2695",
				"1f469-1f3fb-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"light skin tone",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f469-1f3fc-2695": {
		"name": "woman health worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 459,
		"display": 1,
		"shortname": ":woman_health_worker_tone2:",
		"shortname_alternates": [
			":woman_health_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-2695",
			"fully_qualified": "1f469-1f3fc-200d-2695-fe0f",
			"non_fully_qualified": "1f469-1f3fc-200d-2695",
			"output": "1f469-1f3fc-200d-2695-fe0f",
			"default_matches": [
				"1f469-1f3fc-200d-2695-fe0f",
				"1f469-1f3fc-200d-2695",
				"1f469-1f3fc-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-2695-fe0f",
				"1f469-1f3fc-200d-2695",
				"1f469-1f3fc-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"medium-light skin tone",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f469-1f3fd-2695": {
		"name": "woman health worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 460,
		"display": 1,
		"shortname": ":woman_health_worker_tone3:",
		"shortname_alternates": [
			":woman_health_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-2695",
			"fully_qualified": "1f469-1f3fd-200d-2695-fe0f",
			"non_fully_qualified": "1f469-1f3fd-200d-2695",
			"output": "1f469-1f3fd-200d-2695-fe0f",
			"default_matches": [
				"1f469-1f3fd-200d-2695-fe0f",
				"1f469-1f3fd-200d-2695",
				"1f469-1f3fd-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-2695-fe0f",
				"1f469-1f3fd-200d-2695",
				"1f469-1f3fd-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"medium skin tone",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f469-1f3fe-2695": {
		"name": "woman health worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 461,
		"display": 1,
		"shortname": ":woman_health_worker_tone4:",
		"shortname_alternates": [
			":woman_health_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-2695",
			"fully_qualified": "1f469-1f3fe-200d-2695-fe0f",
			"non_fully_qualified": "1f469-1f3fe-200d-2695",
			"output": "1f469-1f3fe-200d-2695-fe0f",
			"default_matches": [
				"1f469-1f3fe-200d-2695-fe0f",
				"1f469-1f3fe-200d-2695",
				"1f469-1f3fe-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-2695-fe0f",
				"1f469-1f3fe-200d-2695",
				"1f469-1f3fe-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"medium-dark skin tone",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f469-1f3ff-2695": {
		"name": "woman health worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 462,
		"display": 1,
		"shortname": ":woman_health_worker_tone5:",
		"shortname_alternates": [
			":woman_health_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-2695",
			"fully_qualified": "1f469-1f3ff-200d-2695-fe0f",
			"non_fully_qualified": "1f469-1f3ff-200d-2695",
			"output": "1f469-1f3ff-200d-2695-fe0f",
			"default_matches": [
				"1f469-1f3ff-200d-2695-fe0f",
				"1f469-1f3ff-200d-2695",
				"1f469-1f3ff-2695-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-2695-fe0f",
				"1f469-1f3ff-200d-2695",
				"1f469-1f3ff-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"doctor",
			"healthcare",
			"nurse",
			"therapist",
			"woman"
		]
	},
	"1f468-2695": {
		"name": "man health worker",
		"unicode_version": 6,
		"category": "people",
		"order": 463,
		"display": 1,
		"shortname": ":man_health_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-2695",
			"1f468-1f3fc-2695",
			"1f468-1f3fd-2695",
			"1f468-1f3fe-2695",
			"1f468-1f3ff-2695"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-2695",
			"fully_qualified": "1f468-200d-2695-fe0f",
			"non_fully_qualified": "1f468-200d-2695",
			"output": "1f468-200d-2695-fe0f",
			"default_matches": [
				"1f468-200d-2695-fe0f",
				"1f468-200d-2695",
				"1f468-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-200d-2695-fe0f",
				"1f468-200d-2695",
				"1f468-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"man",
			"nurse",
			"therapist"
		]
	},
	"1f468-1f3fb-2695": {
		"name": "man health worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 464,
		"display": 1,
		"shortname": ":man_health_worker_tone1:",
		"shortname_alternates": [
			":man_health_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-2695",
			"fully_qualified": "1f468-1f3fb-200d-2695-fe0f",
			"non_fully_qualified": "1f468-1f3fb-200d-2695",
			"output": "1f468-1f3fb-200d-2695-fe0f",
			"default_matches": [
				"1f468-1f3fb-200d-2695-fe0f",
				"1f468-1f3fb-200d-2695",
				"1f468-1f3fb-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-2695-fe0f",
				"1f468-1f3fb-200d-2695",
				"1f468-1f3fb-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"light skin tone",
			"man",
			"nurse",
			"therapist"
		]
	},
	"1f468-1f3fc-2695": {
		"name": "man health worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 465,
		"display": 1,
		"shortname": ":man_health_worker_tone2:",
		"shortname_alternates": [
			":man_health_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-2695",
			"fully_qualified": "1f468-1f3fc-200d-2695-fe0f",
			"non_fully_qualified": "1f468-1f3fc-200d-2695",
			"output": "1f468-1f3fc-200d-2695-fe0f",
			"default_matches": [
				"1f468-1f3fc-200d-2695-fe0f",
				"1f468-1f3fc-200d-2695",
				"1f468-1f3fc-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-2695-fe0f",
				"1f468-1f3fc-200d-2695",
				"1f468-1f3fc-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"man",
			"medium-light skin tone",
			"nurse",
			"therapist"
		]
	},
	"1f468-1f3fd-2695": {
		"name": "man health worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 466,
		"display": 1,
		"shortname": ":man_health_worker_tone3:",
		"shortname_alternates": [
			":man_health_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-2695",
			"fully_qualified": "1f468-1f3fd-200d-2695-fe0f",
			"non_fully_qualified": "1f468-1f3fd-200d-2695",
			"output": "1f468-1f3fd-200d-2695-fe0f",
			"default_matches": [
				"1f468-1f3fd-200d-2695-fe0f",
				"1f468-1f3fd-200d-2695",
				"1f468-1f3fd-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-2695-fe0f",
				"1f468-1f3fd-200d-2695",
				"1f468-1f3fd-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"man",
			"medium skin tone",
			"nurse",
			"therapist"
		]
	},
	"1f468-1f3fe-2695": {
		"name": "man health worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 467,
		"display": 1,
		"shortname": ":man_health_worker_tone4:",
		"shortname_alternates": [
			":man_health_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-2695",
			"fully_qualified": "1f468-1f3fe-200d-2695-fe0f",
			"non_fully_qualified": "1f468-1f3fe-200d-2695",
			"output": "1f468-1f3fe-200d-2695-fe0f",
			"default_matches": [
				"1f468-1f3fe-200d-2695-fe0f",
				"1f468-1f3fe-200d-2695",
				"1f468-1f3fe-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-2695-fe0f",
				"1f468-1f3fe-200d-2695",
				"1f468-1f3fe-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"healthcare",
			"man",
			"medium-dark skin tone",
			"nurse",
			"therapist"
		]
	},
	"1f468-1f3ff-2695": {
		"name": "man health worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 468,
		"display": 1,
		"shortname": ":man_health_worker_tone5:",
		"shortname_alternates": [
			":man_health_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-2695",
			"fully_qualified": "1f468-1f3ff-200d-2695-fe0f",
			"non_fully_qualified": "1f468-1f3ff-200d-2695",
			"output": "1f468-1f3ff-200d-2695-fe0f",
			"default_matches": [
				"1f468-1f3ff-200d-2695-fe0f",
				"1f468-1f3ff-200d-2695",
				"1f468-1f3ff-2695-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-2695-fe0f",
				"1f468-1f3ff-200d-2695",
				"1f468-1f3ff-2695-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"doctor",
			"healthcare",
			"man",
			"nurse",
			"therapist"
		]
	},
	"1f469-1f33e": {
		"name": "woman farmer",
		"unicode_version": 6,
		"category": "people",
		"order": 469,
		"display": 1,
		"shortname": ":woman_farmer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f33e",
			"1f469-1f3fc-1f33e",
			"1f469-1f3fd-1f33e",
			"1f469-1f3fe-1f33e",
			"1f469-1f3ff-1f33e"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f33e",
			"fully_qualified": "1f469-200d-1f33e",
			"non_fully_qualified": "1f469-200d-1f33e",
			"output": "1f469-200d-1f33e",
			"default_matches": [
				"1f469-200d-1f33e",
				"1f469-1f33e"
			],
			"greedy_matches": [
				"1f469-200d-1f33e",
				"1f469-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"rancher",
			"woman"
		]
	},
	"1f469-1f3fb-1f33e": {
		"name": "woman farmer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 470,
		"display": 1,
		"shortname": ":woman_farmer_tone1:",
		"shortname_alternates": [
			":woman_farmer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f33e",
			"fully_qualified": "1f469-1f3fb-200d-1f33e",
			"non_fully_qualified": "1f469-1f3fb-200d-1f33e",
			"output": "1f469-1f3fb-200d-1f33e",
			"default_matches": [
				"1f469-1f3fb-200d-1f33e",
				"1f469-1f3fb-1f33e"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f33e",
				"1f469-1f3fb-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"light skin tone",
			"rancher",
			"woman"
		]
	},
	"1f469-1f3fc-1f33e": {
		"name": "woman farmer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 471,
		"display": 1,
		"shortname": ":woman_farmer_tone2:",
		"shortname_alternates": [
			":woman_farmer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f33e",
			"fully_qualified": "1f469-1f3fc-200d-1f33e",
			"non_fully_qualified": "1f469-1f3fc-200d-1f33e",
			"output": "1f469-1f3fc-200d-1f33e",
			"default_matches": [
				"1f469-1f3fc-200d-1f33e",
				"1f469-1f3fc-1f33e"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f33e",
				"1f469-1f3fc-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"medium-light skin tone",
			"rancher",
			"woman"
		]
	},
	"1f469-1f3fd-1f33e": {
		"name": "woman farmer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 472,
		"display": 1,
		"shortname": ":woman_farmer_tone3:",
		"shortname_alternates": [
			":woman_farmer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f33e",
			"fully_qualified": "1f469-1f3fd-200d-1f33e",
			"non_fully_qualified": "1f469-1f3fd-200d-1f33e",
			"output": "1f469-1f3fd-200d-1f33e",
			"default_matches": [
				"1f469-1f3fd-200d-1f33e",
				"1f469-1f3fd-1f33e"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f33e",
				"1f469-1f3fd-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"medium skin tone",
			"rancher",
			"woman"
		]
	},
	"1f469-1f3fe-1f33e": {
		"name": "woman farmer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 473,
		"display": 1,
		"shortname": ":woman_farmer_tone4:",
		"shortname_alternates": [
			":woman_farmer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f33e",
			"fully_qualified": "1f469-1f3fe-200d-1f33e",
			"non_fully_qualified": "1f469-1f3fe-200d-1f33e",
			"output": "1f469-1f3fe-200d-1f33e",
			"default_matches": [
				"1f469-1f3fe-200d-1f33e",
				"1f469-1f3fe-1f33e"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f33e",
				"1f469-1f3fe-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"medium-dark skin tone",
			"rancher",
			"woman"
		]
	},
	"1f469-1f3ff-1f33e": {
		"name": "woman farmer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 474,
		"display": 1,
		"shortname": ":woman_farmer_tone5:",
		"shortname_alternates": [
			":woman_farmer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f33e",
			"fully_qualified": "1f469-1f3ff-200d-1f33e",
			"non_fully_qualified": "1f469-1f3ff-200d-1f33e",
			"output": "1f469-1f3ff-200d-1f33e",
			"default_matches": [
				"1f469-1f3ff-200d-1f33e",
				"1f469-1f3ff-1f33e"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f33e",
				"1f469-1f3ff-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"farmer",
			"gardener",
			"rancher",
			"woman"
		]
	},
	"1f468-1f33e": {
		"name": "man farmer",
		"unicode_version": 6,
		"category": "people",
		"order": 475,
		"display": 1,
		"shortname": ":man_farmer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f33e",
			"1f468-1f3fc-1f33e",
			"1f468-1f3fd-1f33e",
			"1f468-1f3fe-1f33e",
			"1f468-1f3ff-1f33e"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f33e",
			"fully_qualified": "1f468-200d-1f33e",
			"non_fully_qualified": "1f468-200d-1f33e",
			"output": "1f468-200d-1f33e",
			"default_matches": [
				"1f468-200d-1f33e",
				"1f468-1f33e"
			],
			"greedy_matches": [
				"1f468-200d-1f33e",
				"1f468-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"man",
			"rancher"
		]
	},
	"1f468-1f3fb-1f33e": {
		"name": "man farmer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 476,
		"display": 1,
		"shortname": ":man_farmer_tone1:",
		"shortname_alternates": [
			":man_farmer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f33e",
			"fully_qualified": "1f468-1f3fb-200d-1f33e",
			"non_fully_qualified": "1f468-1f3fb-200d-1f33e",
			"output": "1f468-1f3fb-200d-1f33e",
			"default_matches": [
				"1f468-1f3fb-200d-1f33e",
				"1f468-1f3fb-1f33e"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f33e",
				"1f468-1f3fb-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"light skin tone",
			"man",
			"rancher"
		]
	},
	"1f468-1f3fc-1f33e": {
		"name": "man farmer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 477,
		"display": 1,
		"shortname": ":man_farmer_tone2:",
		"shortname_alternates": [
			":man_farmer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f33e",
			"fully_qualified": "1f468-1f3fc-200d-1f33e",
			"non_fully_qualified": "1f468-1f3fc-200d-1f33e",
			"output": "1f468-1f3fc-200d-1f33e",
			"default_matches": [
				"1f468-1f3fc-200d-1f33e",
				"1f468-1f3fc-1f33e"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f33e",
				"1f468-1f3fc-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"man",
			"medium-light skin tone",
			"rancher"
		]
	},
	"1f468-1f3fd-1f33e": {
		"name": "man farmer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 478,
		"display": 1,
		"shortname": ":man_farmer_tone3:",
		"shortname_alternates": [
			":man_farmer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f33e",
			"fully_qualified": "1f468-1f3fd-200d-1f33e",
			"non_fully_qualified": "1f468-1f3fd-200d-1f33e",
			"output": "1f468-1f3fd-200d-1f33e",
			"default_matches": [
				"1f468-1f3fd-200d-1f33e",
				"1f468-1f3fd-1f33e"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f33e",
				"1f468-1f3fd-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"man",
			"medium skin tone",
			"rancher"
		]
	},
	"1f468-1f3fe-1f33e": {
		"name": "man farmer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 479,
		"display": 1,
		"shortname": ":man_farmer_tone4:",
		"shortname_alternates": [
			":man_farmer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f33e",
			"fully_qualified": "1f468-1f3fe-200d-1f33e",
			"non_fully_qualified": "1f468-1f3fe-200d-1f33e",
			"output": "1f468-1f3fe-200d-1f33e",
			"default_matches": [
				"1f468-1f3fe-200d-1f33e",
				"1f468-1f3fe-1f33e"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f33e",
				"1f468-1f3fe-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"farmer",
			"gardener",
			"man",
			"medium-dark skin tone",
			"rancher"
		]
	},
	"1f468-1f3ff-1f33e": {
		"name": "man farmer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 480,
		"display": 1,
		"shortname": ":man_farmer_tone5:",
		"shortname_alternates": [
			":man_farmer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f33e",
			"fully_qualified": "1f468-1f3ff-200d-1f33e",
			"non_fully_qualified": "1f468-1f3ff-200d-1f33e",
			"output": "1f468-1f3ff-200d-1f33e",
			"default_matches": [
				"1f468-1f3ff-200d-1f33e",
				"1f468-1f3ff-1f33e"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f33e",
				"1f468-1f3ff-1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"farmer",
			"gardener",
			"man",
			"rancher"
		]
	},
	"1f469-1f373": {
		"name": "woman cook",
		"unicode_version": 6,
		"category": "people",
		"order": 481,
		"display": 1,
		"shortname": ":woman_cook:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f373",
			"1f469-1f3fc-1f373",
			"1f469-1f3fd-1f373",
			"1f469-1f3fe-1f373",
			"1f469-1f3ff-1f373"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f373",
			"fully_qualified": "1f469-200d-1f373",
			"non_fully_qualified": "1f469-200d-1f373",
			"output": "1f469-200d-1f373",
			"default_matches": [
				"1f469-200d-1f373",
				"1f469-1f373"
			],
			"greedy_matches": [
				"1f469-200d-1f373",
				"1f469-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"woman"
		]
	},
	"1f469-1f3fb-1f373": {
		"name": "woman cook: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 482,
		"display": 1,
		"shortname": ":woman_cook_tone1:",
		"shortname_alternates": [
			":woman_cook_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f373",
			"fully_qualified": "1f469-1f3fb-200d-1f373",
			"non_fully_qualified": "1f469-1f3fb-200d-1f373",
			"output": "1f469-1f3fb-200d-1f373",
			"default_matches": [
				"1f469-1f3fb-200d-1f373",
				"1f469-1f3fb-1f373"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f373",
				"1f469-1f3fb-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"light skin tone",
			"woman"
		]
	},
	"1f469-1f3fc-1f373": {
		"name": "woman cook: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 483,
		"display": 1,
		"shortname": ":woman_cook_tone2:",
		"shortname_alternates": [
			":woman_cook_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f373",
			"fully_qualified": "1f469-1f3fc-200d-1f373",
			"non_fully_qualified": "1f469-1f3fc-200d-1f373",
			"output": "1f469-1f3fc-200d-1f373",
			"default_matches": [
				"1f469-1f3fc-200d-1f373",
				"1f469-1f3fc-1f373"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f373",
				"1f469-1f3fc-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f469-1f3fd-1f373": {
		"name": "woman cook: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 484,
		"display": 1,
		"shortname": ":woman_cook_tone3:",
		"shortname_alternates": [
			":woman_cook_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f373",
			"fully_qualified": "1f469-1f3fd-200d-1f373",
			"non_fully_qualified": "1f469-1f3fd-200d-1f373",
			"output": "1f469-1f3fd-200d-1f373",
			"default_matches": [
				"1f469-1f3fd-200d-1f373",
				"1f469-1f3fd-1f373"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f373",
				"1f469-1f3fd-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"medium skin tone",
			"woman"
		]
	},
	"1f469-1f3fe-1f373": {
		"name": "woman cook: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 485,
		"display": 1,
		"shortname": ":woman_cook_tone4:",
		"shortname_alternates": [
			":woman_cook_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f373",
			"fully_qualified": "1f469-1f3fe-200d-1f373",
			"non_fully_qualified": "1f469-1f3fe-200d-1f373",
			"output": "1f469-1f3fe-200d-1f373",
			"default_matches": [
				"1f469-1f3fe-200d-1f373",
				"1f469-1f3fe-1f373"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f373",
				"1f469-1f3fe-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f469-1f3ff-1f373": {
		"name": "woman cook: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 486,
		"display": 1,
		"shortname": ":woman_cook_tone5:",
		"shortname_alternates": [
			":woman_cook_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f373",
			"fully_qualified": "1f469-1f3ff-200d-1f373",
			"non_fully_qualified": "1f469-1f3ff-200d-1f373",
			"output": "1f469-1f3ff-200d-1f373",
			"default_matches": [
				"1f469-1f3ff-200d-1f373",
				"1f469-1f3ff-1f373"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f373",
				"1f469-1f3ff-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"dark skin tone",
			"woman"
		]
	},
	"1f468-1f373": {
		"name": "man cook",
		"unicode_version": 6,
		"category": "people",
		"order": 487,
		"display": 1,
		"shortname": ":man_cook:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f373",
			"1f468-1f3fc-1f373",
			"1f468-1f3fd-1f373",
			"1f468-1f3fe-1f373",
			"1f468-1f3ff-1f373"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f373",
			"fully_qualified": "1f468-200d-1f373",
			"non_fully_qualified": "1f468-200d-1f373",
			"output": "1f468-200d-1f373",
			"default_matches": [
				"1f468-200d-1f373",
				"1f468-1f373"
			],
			"greedy_matches": [
				"1f468-200d-1f373",
				"1f468-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"man"
		]
	},
	"1f468-1f3fb-1f373": {
		"name": "man cook: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 488,
		"display": 1,
		"shortname": ":man_cook_tone1:",
		"shortname_alternates": [
			":man_cook_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f373",
			"fully_qualified": "1f468-1f3fb-200d-1f373",
			"non_fully_qualified": "1f468-1f3fb-200d-1f373",
			"output": "1f468-1f3fb-200d-1f373",
			"default_matches": [
				"1f468-1f3fb-200d-1f373",
				"1f468-1f3fb-1f373"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f373",
				"1f468-1f3fb-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"light skin tone",
			"man"
		]
	},
	"1f468-1f3fc-1f373": {
		"name": "man cook: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 489,
		"display": 1,
		"shortname": ":man_cook_tone2:",
		"shortname_alternates": [
			":man_cook_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f373",
			"fully_qualified": "1f468-1f3fc-200d-1f373",
			"non_fully_qualified": "1f468-1f3fc-200d-1f373",
			"output": "1f468-1f3fc-200d-1f373",
			"default_matches": [
				"1f468-1f3fc-200d-1f373",
				"1f468-1f3fc-1f373"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f373",
				"1f468-1f3fc-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"man",
			"medium-light skin tone"
		]
	},
	"1f468-1f3fd-1f373": {
		"name": "man cook: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 490,
		"display": 1,
		"shortname": ":man_cook_tone3:",
		"shortname_alternates": [
			":man_cook_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f373",
			"fully_qualified": "1f468-1f3fd-200d-1f373",
			"non_fully_qualified": "1f468-1f3fd-200d-1f373",
			"output": "1f468-1f3fd-200d-1f373",
			"default_matches": [
				"1f468-1f3fd-200d-1f373",
				"1f468-1f3fd-1f373"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f373",
				"1f468-1f3fd-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"man",
			"medium skin tone"
		]
	},
	"1f468-1f3fe-1f373": {
		"name": "man cook: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 491,
		"display": 1,
		"shortname": ":man_cook_tone4:",
		"shortname_alternates": [
			":man_cook_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f373",
			"fully_qualified": "1f468-1f3fe-200d-1f373",
			"non_fully_qualified": "1f468-1f3fe-200d-1f373",
			"output": "1f468-1f3fe-200d-1f373",
			"default_matches": [
				"1f468-1f3fe-200d-1f373",
				"1f468-1f3fe-1f373"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f373",
				"1f468-1f3fe-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f468-1f3ff-1f373": {
		"name": "man cook: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 492,
		"display": 1,
		"shortname": ":man_cook_tone5:",
		"shortname_alternates": [
			":man_cook_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f373",
			"fully_qualified": "1f468-1f3ff-200d-1f373",
			"non_fully_qualified": "1f468-1f3ff-200d-1f373",
			"output": "1f468-1f3ff-200d-1f373",
			"default_matches": [
				"1f468-1f3ff-200d-1f373",
				"1f468-1f3ff-1f373"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f373",
				"1f468-1f3ff-1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"chef",
			"cook",
			"dark skin tone",
			"man"
		]
	},
	"1f469-1f393": {
		"name": "woman student",
		"unicode_version": 6,
		"category": "people",
		"order": 493,
		"display": 1,
		"shortname": ":woman_student:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f393",
			"1f469-1f3fc-1f393",
			"1f469-1f3fd-1f393",
			"1f469-1f3fe-1f393",
			"1f469-1f3ff-1f393"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f393",
			"fully_qualified": "1f469-200d-1f393",
			"non_fully_qualified": "1f469-200d-1f393",
			"output": "1f469-200d-1f393",
			"default_matches": [
				"1f469-200d-1f393",
				"1f469-1f393"
			],
			"greedy_matches": [
				"1f469-200d-1f393",
				"1f469-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"student",
			"woman"
		]
	},
	"1f469-1f3fb-1f393": {
		"name": "woman student: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 494,
		"display": 1,
		"shortname": ":woman_student_tone1:",
		"shortname_alternates": [
			":woman_student_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f393",
			"fully_qualified": "1f469-1f3fb-200d-1f393",
			"non_fully_qualified": "1f469-1f3fb-200d-1f393",
			"output": "1f469-1f3fb-200d-1f393",
			"default_matches": [
				"1f469-1f3fb-200d-1f393",
				"1f469-1f3fb-1f393"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f393",
				"1f469-1f3fb-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"light skin tone",
			"student",
			"woman"
		]
	},
	"1f469-1f3fc-1f393": {
		"name": "woman student: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 495,
		"display": 1,
		"shortname": ":woman_student_tone2:",
		"shortname_alternates": [
			":woman_student_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f393",
			"fully_qualified": "1f469-1f3fc-200d-1f393",
			"non_fully_qualified": "1f469-1f3fc-200d-1f393",
			"output": "1f469-1f3fc-200d-1f393",
			"default_matches": [
				"1f469-1f3fc-200d-1f393",
				"1f469-1f3fc-1f393"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f393",
				"1f469-1f3fc-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"medium-light skin tone",
			"student",
			"woman"
		]
	},
	"1f469-1f3fd-1f393": {
		"name": "woman student: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 496,
		"display": 1,
		"shortname": ":woman_student_tone3:",
		"shortname_alternates": [
			":woman_student_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f393",
			"fully_qualified": "1f469-1f3fd-200d-1f393",
			"non_fully_qualified": "1f469-1f3fd-200d-1f393",
			"output": "1f469-1f3fd-200d-1f393",
			"default_matches": [
				"1f469-1f3fd-200d-1f393",
				"1f469-1f3fd-1f393"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f393",
				"1f469-1f3fd-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"medium skin tone",
			"student",
			"woman"
		]
	},
	"1f469-1f3fe-1f393": {
		"name": "woman student: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 497,
		"display": 1,
		"shortname": ":woman_student_tone4:",
		"shortname_alternates": [
			":woman_student_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f393",
			"fully_qualified": "1f469-1f3fe-200d-1f393",
			"non_fully_qualified": "1f469-1f3fe-200d-1f393",
			"output": "1f469-1f3fe-200d-1f393",
			"default_matches": [
				"1f469-1f3fe-200d-1f393",
				"1f469-1f3fe-1f393"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f393",
				"1f469-1f3fe-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"medium-dark skin tone",
			"student",
			"woman"
		]
	},
	"1f469-1f3ff-1f393": {
		"name": "woman student: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 498,
		"display": 1,
		"shortname": ":woman_student_tone5:",
		"shortname_alternates": [
			":woman_student_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f393",
			"fully_qualified": "1f469-1f3ff-200d-1f393",
			"non_fully_qualified": "1f469-1f3ff-200d-1f393",
			"output": "1f469-1f3ff-200d-1f393",
			"default_matches": [
				"1f469-1f3ff-200d-1f393",
				"1f469-1f3ff-1f393"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f393",
				"1f469-1f3ff-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"graduate",
			"student",
			"woman"
		]
	},
	"1f468-1f393": {
		"name": "man student",
		"unicode_version": 6,
		"category": "people",
		"order": 499,
		"display": 1,
		"shortname": ":man_student:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f393",
			"1f468-1f3fc-1f393",
			"1f468-1f3fd-1f393",
			"1f468-1f3fe-1f393",
			"1f468-1f3ff-1f393"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f393",
			"fully_qualified": "1f468-200d-1f393",
			"non_fully_qualified": "1f468-200d-1f393",
			"output": "1f468-200d-1f393",
			"default_matches": [
				"1f468-200d-1f393",
				"1f468-1f393"
			],
			"greedy_matches": [
				"1f468-200d-1f393",
				"1f468-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"man",
			"student"
		]
	},
	"1f468-1f3fb-1f393": {
		"name": "man student: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 500,
		"display": 1,
		"shortname": ":man_student_tone1:",
		"shortname_alternates": [
			":man_student_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f393",
			"fully_qualified": "1f468-1f3fb-200d-1f393",
			"non_fully_qualified": "1f468-1f3fb-200d-1f393",
			"output": "1f468-1f3fb-200d-1f393",
			"default_matches": [
				"1f468-1f3fb-200d-1f393",
				"1f468-1f3fb-1f393"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f393",
				"1f468-1f3fb-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"light skin tone",
			"man",
			"student"
		]
	},
	"1f468-1f3fc-1f393": {
		"name": "man student: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 501,
		"display": 1,
		"shortname": ":man_student_tone2:",
		"shortname_alternates": [
			":man_student_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f393",
			"fully_qualified": "1f468-1f3fc-200d-1f393",
			"non_fully_qualified": "1f468-1f3fc-200d-1f393",
			"output": "1f468-1f3fc-200d-1f393",
			"default_matches": [
				"1f468-1f3fc-200d-1f393",
				"1f468-1f3fc-1f393"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f393",
				"1f468-1f3fc-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"man",
			"medium-light skin tone",
			"student"
		]
	},
	"1f468-1f3fd-1f393": {
		"name": "man student: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 502,
		"display": 1,
		"shortname": ":man_student_tone3:",
		"shortname_alternates": [
			":man_student_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f393",
			"fully_qualified": "1f468-1f3fd-200d-1f393",
			"non_fully_qualified": "1f468-1f3fd-200d-1f393",
			"output": "1f468-1f3fd-200d-1f393",
			"default_matches": [
				"1f468-1f3fd-200d-1f393",
				"1f468-1f3fd-1f393"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f393",
				"1f468-1f3fd-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"man",
			"medium skin tone",
			"student"
		]
	},
	"1f468-1f3fe-1f393": {
		"name": "man student: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 503,
		"display": 1,
		"shortname": ":man_student_tone4:",
		"shortname_alternates": [
			":man_student_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f393",
			"fully_qualified": "1f468-1f3fe-200d-1f393",
			"non_fully_qualified": "1f468-1f3fe-200d-1f393",
			"output": "1f468-1f3fe-200d-1f393",
			"default_matches": [
				"1f468-1f3fe-200d-1f393",
				"1f468-1f3fe-1f393"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f393",
				"1f468-1f3fe-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"graduate",
			"man",
			"medium-dark skin tone",
			"student"
		]
	},
	"1f468-1f3ff-1f393": {
		"name": "man student: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 504,
		"display": 1,
		"shortname": ":man_student_tone5:",
		"shortname_alternates": [
			":man_student_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f393",
			"fully_qualified": "1f468-1f3ff-200d-1f393",
			"non_fully_qualified": "1f468-1f3ff-200d-1f393",
			"output": "1f468-1f3ff-200d-1f393",
			"default_matches": [
				"1f468-1f3ff-200d-1f393",
				"1f468-1f3ff-1f393"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f393",
				"1f468-1f3ff-1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"graduate",
			"man",
			"student"
		]
	},
	"1f469-1f3a4": {
		"name": "woman singer",
		"unicode_version": 6,
		"category": "people",
		"order": 505,
		"display": 1,
		"shortname": ":woman_singer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f3a4",
			"1f469-1f3fc-1f3a4",
			"1f469-1f3fd-1f3a4",
			"1f469-1f3fe-1f3a4",
			"1f469-1f3ff-1f3a4"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3a4",
			"fully_qualified": "1f469-200d-1f3a4",
			"non_fully_qualified": "1f469-200d-1f3a4",
			"output": "1f469-200d-1f3a4",
			"default_matches": [
				"1f469-200d-1f3a4",
				"1f469-1f3a4"
			],
			"greedy_matches": [
				"1f469-200d-1f3a4",
				"1f469-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f469-1f3fb-1f3a4": {
		"name": "woman singer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 506,
		"display": 1,
		"shortname": ":woman_singer_tone1:",
		"shortname_alternates": [
			":woman_singer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f3a4",
			"fully_qualified": "1f469-1f3fb-200d-1f3a4",
			"non_fully_qualified": "1f469-1f3fb-200d-1f3a4",
			"output": "1f469-1f3fb-200d-1f3a4",
			"default_matches": [
				"1f469-1f3fb-200d-1f3a4",
				"1f469-1f3fb-1f3a4"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f3a4",
				"1f469-1f3fb-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"light skin tone",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f469-1f3fc-1f3a4": {
		"name": "woman singer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 507,
		"display": 1,
		"shortname": ":woman_singer_tone2:",
		"shortname_alternates": [
			":woman_singer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f3a4",
			"fully_qualified": "1f469-1f3fc-200d-1f3a4",
			"non_fully_qualified": "1f469-1f3fc-200d-1f3a4",
			"output": "1f469-1f3fc-200d-1f3a4",
			"default_matches": [
				"1f469-1f3fc-200d-1f3a4",
				"1f469-1f3fc-1f3a4"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f3a4",
				"1f469-1f3fc-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"medium-light skin tone",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f469-1f3fd-1f3a4": {
		"name": "woman singer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 508,
		"display": 1,
		"shortname": ":woman_singer_tone3:",
		"shortname_alternates": [
			":woman_singer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f3a4",
			"fully_qualified": "1f469-1f3fd-200d-1f3a4",
			"non_fully_qualified": "1f469-1f3fd-200d-1f3a4",
			"output": "1f469-1f3fd-200d-1f3a4",
			"default_matches": [
				"1f469-1f3fd-200d-1f3a4",
				"1f469-1f3fd-1f3a4"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f3a4",
				"1f469-1f3fd-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"medium skin tone",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f469-1f3fe-1f3a4": {
		"name": "woman singer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 509,
		"display": 1,
		"shortname": ":woman_singer_tone4:",
		"shortname_alternates": [
			":woman_singer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f3a4",
			"fully_qualified": "1f469-1f3fe-200d-1f3a4",
			"non_fully_qualified": "1f469-1f3fe-200d-1f3a4",
			"output": "1f469-1f3fe-200d-1f3a4",
			"default_matches": [
				"1f469-1f3fe-200d-1f3a4",
				"1f469-1f3fe-1f3a4"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f3a4",
				"1f469-1f3fe-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"medium-dark skin tone",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f469-1f3ff-1f3a4": {
		"name": "woman singer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 510,
		"display": 1,
		"shortname": ":woman_singer_tone5:",
		"shortname_alternates": [
			":woman_singer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f3a4",
			"fully_qualified": "1f469-1f3ff-200d-1f3a4",
			"non_fully_qualified": "1f469-1f3ff-200d-1f3a4",
			"output": "1f469-1f3ff-200d-1f3a4",
			"default_matches": [
				"1f469-1f3ff-200d-1f3a4",
				"1f469-1f3ff-1f3a4"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f3a4",
				"1f469-1f3ff-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"dark skin tone",
			"entertainer",
			"rock",
			"singer",
			"star",
			"woman"
		]
	},
	"1f468-1f3a4": {
		"name": "man singer",
		"unicode_version": 6,
		"category": "people",
		"order": 511,
		"display": 1,
		"shortname": ":man_singer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f3a4",
			"1f468-1f3fc-1f3a4",
			"1f468-1f3fd-1f3a4",
			"1f468-1f3fe-1f3a4",
			"1f468-1f3ff-1f3a4"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3a4",
			"fully_qualified": "1f468-200d-1f3a4",
			"non_fully_qualified": "1f468-200d-1f3a4",
			"output": "1f468-200d-1f3a4",
			"default_matches": [
				"1f468-200d-1f3a4",
				"1f468-1f3a4"
			],
			"greedy_matches": [
				"1f468-200d-1f3a4",
				"1f468-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"man",
			"rock",
			"singer",
			"star"
		]
	},
	"1f468-1f3fb-1f3a4": {
		"name": "man singer: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 512,
		"display": 1,
		"shortname": ":man_singer_tone1:",
		"shortname_alternates": [
			":man_singer_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f3a4",
			"fully_qualified": "1f468-1f3fb-200d-1f3a4",
			"non_fully_qualified": "1f468-1f3fb-200d-1f3a4",
			"output": "1f468-1f3fb-200d-1f3a4",
			"default_matches": [
				"1f468-1f3fb-200d-1f3a4",
				"1f468-1f3fb-1f3a4"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f3a4",
				"1f468-1f3fb-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"light skin tone",
			"man",
			"rock",
			"singer",
			"star"
		]
	},
	"1f468-1f3fc-1f3a4": {
		"name": "man singer: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 513,
		"display": 1,
		"shortname": ":man_singer_tone2:",
		"shortname_alternates": [
			":man_singer_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f3a4",
			"fully_qualified": "1f468-1f3fc-200d-1f3a4",
			"non_fully_qualified": "1f468-1f3fc-200d-1f3a4",
			"output": "1f468-1f3fc-200d-1f3a4",
			"default_matches": [
				"1f468-1f3fc-200d-1f3a4",
				"1f468-1f3fc-1f3a4"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f3a4",
				"1f468-1f3fc-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"man",
			"medium-light skin tone",
			"rock",
			"singer",
			"star"
		]
	},
	"1f468-1f3fd-1f3a4": {
		"name": "man singer: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 514,
		"display": 1,
		"shortname": ":man_singer_tone3:",
		"shortname_alternates": [
			":man_singer_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f3a4",
			"fully_qualified": "1f468-1f3fd-200d-1f3a4",
			"non_fully_qualified": "1f468-1f3fd-200d-1f3a4",
			"output": "1f468-1f3fd-200d-1f3a4",
			"default_matches": [
				"1f468-1f3fd-200d-1f3a4",
				"1f468-1f3fd-1f3a4"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f3a4",
				"1f468-1f3fd-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"man",
			"medium skin tone",
			"rock",
			"singer",
			"star"
		]
	},
	"1f468-1f3fe-1f3a4": {
		"name": "man singer: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 515,
		"display": 1,
		"shortname": ":man_singer_tone4:",
		"shortname_alternates": [
			":man_singer_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f3a4",
			"fully_qualified": "1f468-1f3fe-200d-1f3a4",
			"non_fully_qualified": "1f468-1f3fe-200d-1f3a4",
			"output": "1f468-1f3fe-200d-1f3a4",
			"default_matches": [
				"1f468-1f3fe-200d-1f3a4",
				"1f468-1f3fe-1f3a4"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f3a4",
				"1f468-1f3fe-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"entertainer",
			"man",
			"medium-dark skin tone",
			"rock",
			"singer",
			"star"
		]
	},
	"1f468-1f3ff-1f3a4": {
		"name": "man singer: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 516,
		"display": 1,
		"shortname": ":man_singer_tone5:",
		"shortname_alternates": [
			":man_singer_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f3a4",
			"fully_qualified": "1f468-1f3ff-200d-1f3a4",
			"non_fully_qualified": "1f468-1f3ff-200d-1f3a4",
			"output": "1f468-1f3ff-200d-1f3a4",
			"default_matches": [
				"1f468-1f3ff-200d-1f3a4",
				"1f468-1f3ff-1f3a4"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f3a4",
				"1f468-1f3ff-1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"actor",
			"dark skin tone",
			"entertainer",
			"man",
			"rock",
			"singer",
			"star"
		]
	},
	"1f469-1f3eb": {
		"name": "woman teacher",
		"unicode_version": 6,
		"category": "people",
		"order": 517,
		"display": 1,
		"shortname": ":woman_teacher:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f3eb",
			"1f469-1f3fc-1f3eb",
			"1f469-1f3fd-1f3eb",
			"1f469-1f3fe-1f3eb",
			"1f469-1f3ff-1f3eb"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3eb",
			"fully_qualified": "1f469-200d-1f3eb",
			"non_fully_qualified": "1f469-200d-1f3eb",
			"output": "1f469-200d-1f3eb",
			"default_matches": [
				"1f469-200d-1f3eb",
				"1f469-1f3eb"
			],
			"greedy_matches": [
				"1f469-200d-1f3eb",
				"1f469-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f469-1f3fb-1f3eb": {
		"name": "woman teacher: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 518,
		"display": 1,
		"shortname": ":woman_teacher_tone1:",
		"shortname_alternates": [
			":woman_teacher_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f3eb",
			"fully_qualified": "1f469-1f3fb-200d-1f3eb",
			"non_fully_qualified": "1f469-1f3fb-200d-1f3eb",
			"output": "1f469-1f3fb-200d-1f3eb",
			"default_matches": [
				"1f469-1f3fb-200d-1f3eb",
				"1f469-1f3fb-1f3eb"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f3eb",
				"1f469-1f3fb-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"light skin tone",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f469-1f3fc-1f3eb": {
		"name": "woman teacher: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 519,
		"display": 1,
		"shortname": ":woman_teacher_tone2:",
		"shortname_alternates": [
			":woman_teacher_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f3eb",
			"fully_qualified": "1f469-1f3fc-200d-1f3eb",
			"non_fully_qualified": "1f469-1f3fc-200d-1f3eb",
			"output": "1f469-1f3fc-200d-1f3eb",
			"default_matches": [
				"1f469-1f3fc-200d-1f3eb",
				"1f469-1f3fc-1f3eb"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f3eb",
				"1f469-1f3fc-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"medium-light skin tone",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f469-1f3fd-1f3eb": {
		"name": "woman teacher: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 520,
		"display": 1,
		"shortname": ":woman_teacher_tone3:",
		"shortname_alternates": [
			":woman_teacher_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f3eb",
			"fully_qualified": "1f469-1f3fd-200d-1f3eb",
			"non_fully_qualified": "1f469-1f3fd-200d-1f3eb",
			"output": "1f469-1f3fd-200d-1f3eb",
			"default_matches": [
				"1f469-1f3fd-200d-1f3eb",
				"1f469-1f3fd-1f3eb"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f3eb",
				"1f469-1f3fd-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"medium skin tone",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f469-1f3fe-1f3eb": {
		"name": "woman teacher: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 521,
		"display": 1,
		"shortname": ":woman_teacher_tone4:",
		"shortname_alternates": [
			":woman_teacher_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f3eb",
			"fully_qualified": "1f469-1f3fe-200d-1f3eb",
			"non_fully_qualified": "1f469-1f3fe-200d-1f3eb",
			"output": "1f469-1f3fe-200d-1f3eb",
			"default_matches": [
				"1f469-1f3fe-200d-1f3eb",
				"1f469-1f3fe-1f3eb"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f3eb",
				"1f469-1f3fe-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"medium-dark skin tone",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f469-1f3ff-1f3eb": {
		"name": "woman teacher: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 522,
		"display": 1,
		"shortname": ":woman_teacher_tone5:",
		"shortname_alternates": [
			":woman_teacher_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f3eb",
			"fully_qualified": "1f469-1f3ff-200d-1f3eb",
			"non_fully_qualified": "1f469-1f3ff-200d-1f3eb",
			"output": "1f469-1f3ff-200d-1f3eb",
			"default_matches": [
				"1f469-1f3ff-200d-1f3eb",
				"1f469-1f3ff-1f3eb"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f3eb",
				"1f469-1f3ff-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"instructor",
			"professor",
			"teacher",
			"woman"
		]
	},
	"1f468-1f3eb": {
		"name": "man teacher",
		"unicode_version": 6,
		"category": "people",
		"order": 523,
		"display": 1,
		"shortname": ":man_teacher:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f3eb",
			"1f468-1f3fc-1f3eb",
			"1f468-1f3fd-1f3eb",
			"1f468-1f3fe-1f3eb",
			"1f468-1f3ff-1f3eb"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3eb",
			"fully_qualified": "1f468-200d-1f3eb",
			"non_fully_qualified": "1f468-200d-1f3eb",
			"output": "1f468-200d-1f3eb",
			"default_matches": [
				"1f468-200d-1f3eb",
				"1f468-1f3eb"
			],
			"greedy_matches": [
				"1f468-200d-1f3eb",
				"1f468-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"man",
			"professor",
			"teacher"
		]
	},
	"1f468-1f3fb-1f3eb": {
		"name": "man teacher: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 524,
		"display": 1,
		"shortname": ":man_teacher_tone1:",
		"shortname_alternates": [
			":man_teacher_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f3eb",
			"fully_qualified": "1f468-1f3fb-200d-1f3eb",
			"non_fully_qualified": "1f468-1f3fb-200d-1f3eb",
			"output": "1f468-1f3fb-200d-1f3eb",
			"default_matches": [
				"1f468-1f3fb-200d-1f3eb",
				"1f468-1f3fb-1f3eb"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f3eb",
				"1f468-1f3fb-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"light skin tone",
			"man",
			"professor",
			"teacher"
		]
	},
	"1f468-1f3fc-1f3eb": {
		"name": "man teacher: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 525,
		"display": 1,
		"shortname": ":man_teacher_tone2:",
		"shortname_alternates": [
			":man_teacher_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f3eb",
			"fully_qualified": "1f468-1f3fc-200d-1f3eb",
			"non_fully_qualified": "1f468-1f3fc-200d-1f3eb",
			"output": "1f468-1f3fc-200d-1f3eb",
			"default_matches": [
				"1f468-1f3fc-200d-1f3eb",
				"1f468-1f3fc-1f3eb"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f3eb",
				"1f468-1f3fc-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"man",
			"medium-light skin tone",
			"professor",
			"teacher"
		]
	},
	"1f468-1f3fd-1f3eb": {
		"name": "man teacher: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 526,
		"display": 1,
		"shortname": ":man_teacher_tone3:",
		"shortname_alternates": [
			":man_teacher_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f3eb",
			"fully_qualified": "1f468-1f3fd-200d-1f3eb",
			"non_fully_qualified": "1f468-1f3fd-200d-1f3eb",
			"output": "1f468-1f3fd-200d-1f3eb",
			"default_matches": [
				"1f468-1f3fd-200d-1f3eb",
				"1f468-1f3fd-1f3eb"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f3eb",
				"1f468-1f3fd-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"man",
			"medium skin tone",
			"professor",
			"teacher"
		]
	},
	"1f468-1f3fe-1f3eb": {
		"name": "man teacher: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 527,
		"display": 1,
		"shortname": ":man_teacher_tone4:",
		"shortname_alternates": [
			":man_teacher_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f3eb",
			"fully_qualified": "1f468-1f3fe-200d-1f3eb",
			"non_fully_qualified": "1f468-1f3fe-200d-1f3eb",
			"output": "1f468-1f3fe-200d-1f3eb",
			"default_matches": [
				"1f468-1f3fe-200d-1f3eb",
				"1f468-1f3fe-1f3eb"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f3eb",
				"1f468-1f3fe-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"instructor",
			"man",
			"medium-dark skin tone",
			"professor",
			"teacher"
		]
	},
	"1f468-1f3ff-1f3eb": {
		"name": "man teacher: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 528,
		"display": 1,
		"shortname": ":man_teacher_tone5:",
		"shortname_alternates": [
			":man_teacher_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f3eb",
			"fully_qualified": "1f468-1f3ff-200d-1f3eb",
			"non_fully_qualified": "1f468-1f3ff-200d-1f3eb",
			"output": "1f468-1f3ff-200d-1f3eb",
			"default_matches": [
				"1f468-1f3ff-200d-1f3eb",
				"1f468-1f3ff-1f3eb"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f3eb",
				"1f468-1f3ff-1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"instructor",
			"man",
			"professor",
			"teacher"
		]
	},
	"1f469-1f3ed": {
		"name": "woman factory worker",
		"unicode_version": 6,
		"category": "people",
		"order": 529,
		"display": 1,
		"shortname": ":woman_factory_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f3ed",
			"1f469-1f3fc-1f3ed",
			"1f469-1f3fd-1f3ed",
			"1f469-1f3fe-1f3ed",
			"1f469-1f3ff-1f3ed"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ed",
			"fully_qualified": "1f469-200d-1f3ed",
			"non_fully_qualified": "1f469-200d-1f3ed",
			"output": "1f469-200d-1f3ed",
			"default_matches": [
				"1f469-200d-1f3ed",
				"1f469-1f3ed"
			],
			"greedy_matches": [
				"1f469-200d-1f3ed",
				"1f469-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"woman",
			"worker"
		]
	},
	"1f469-1f3fb-1f3ed": {
		"name": "woman factory worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 530,
		"display": 1,
		"shortname": ":woman_factory_worker_tone1:",
		"shortname_alternates": [
			":woman_factory_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f3ed",
			"fully_qualified": "1f469-1f3fb-200d-1f3ed",
			"non_fully_qualified": "1f469-1f3fb-200d-1f3ed",
			"output": "1f469-1f3fb-200d-1f3ed",
			"default_matches": [
				"1f469-1f3fb-200d-1f3ed",
				"1f469-1f3fb-1f3ed"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f3ed",
				"1f469-1f3fb-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"light skin tone",
			"woman",
			"worker"
		]
	},
	"1f469-1f3fc-1f3ed": {
		"name": "woman factory worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 531,
		"display": 1,
		"shortname": ":woman_factory_worker_tone2:",
		"shortname_alternates": [
			":woman_factory_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f3ed",
			"fully_qualified": "1f469-1f3fc-200d-1f3ed",
			"non_fully_qualified": "1f469-1f3fc-200d-1f3ed",
			"output": "1f469-1f3fc-200d-1f3ed",
			"default_matches": [
				"1f469-1f3fc-200d-1f3ed",
				"1f469-1f3fc-1f3ed"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f3ed",
				"1f469-1f3fc-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"medium-light skin tone",
			"woman",
			"worker"
		]
	},
	"1f469-1f3fd-1f3ed": {
		"name": "woman factory worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 532,
		"display": 1,
		"shortname": ":woman_factory_worker_tone3:",
		"shortname_alternates": [
			":woman_factory_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f3ed",
			"fully_qualified": "1f469-1f3fd-200d-1f3ed",
			"non_fully_qualified": "1f469-1f3fd-200d-1f3ed",
			"output": "1f469-1f3fd-200d-1f3ed",
			"default_matches": [
				"1f469-1f3fd-200d-1f3ed",
				"1f469-1f3fd-1f3ed"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f3ed",
				"1f469-1f3fd-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"medium skin tone",
			"woman",
			"worker"
		]
	},
	"1f469-1f3fe-1f3ed": {
		"name": "woman factory worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 533,
		"display": 1,
		"shortname": ":woman_factory_worker_tone4:",
		"shortname_alternates": [
			":woman_factory_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f3ed",
			"fully_qualified": "1f469-1f3fe-200d-1f3ed",
			"non_fully_qualified": "1f469-1f3fe-200d-1f3ed",
			"output": "1f469-1f3fe-200d-1f3ed",
			"default_matches": [
				"1f469-1f3fe-200d-1f3ed",
				"1f469-1f3fe-1f3ed"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f3ed",
				"1f469-1f3fe-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"medium-dark skin tone",
			"woman",
			"worker"
		]
	},
	"1f469-1f3ff-1f3ed": {
		"name": "woman factory worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 534,
		"display": 1,
		"shortname": ":woman_factory_worker_tone5:",
		"shortname_alternates": [
			":woman_factory_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f3ed",
			"fully_qualified": "1f469-1f3ff-200d-1f3ed",
			"non_fully_qualified": "1f469-1f3ff-200d-1f3ed",
			"output": "1f469-1f3ff-200d-1f3ed",
			"default_matches": [
				"1f469-1f3ff-200d-1f3ed",
				"1f469-1f3ff-1f3ed"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f3ed",
				"1f469-1f3ff-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"dark skin tone",
			"factory",
			"industrial",
			"woman",
			"worker"
		]
	},
	"1f468-1f3ed": {
		"name": "man factory worker",
		"unicode_version": 6,
		"category": "people",
		"order": 535,
		"display": 1,
		"shortname": ":man_factory_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f3ed",
			"1f468-1f3fc-1f3ed",
			"1f468-1f3fd-1f3ed",
			"1f468-1f3fe-1f3ed",
			"1f468-1f3ff-1f3ed"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ed",
			"fully_qualified": "1f468-200d-1f3ed",
			"non_fully_qualified": "1f468-200d-1f3ed",
			"output": "1f468-200d-1f3ed",
			"default_matches": [
				"1f468-200d-1f3ed",
				"1f468-1f3ed"
			],
			"greedy_matches": [
				"1f468-200d-1f3ed",
				"1f468-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"man",
			"worker"
		]
	},
	"1f468-1f3fb-1f3ed": {
		"name": "man factory worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 536,
		"display": 1,
		"shortname": ":man_factory_worker_tone1:",
		"shortname_alternates": [
			":man_factory_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f3ed",
			"fully_qualified": "1f468-1f3fb-200d-1f3ed",
			"non_fully_qualified": "1f468-1f3fb-200d-1f3ed",
			"output": "1f468-1f3fb-200d-1f3ed",
			"default_matches": [
				"1f468-1f3fb-200d-1f3ed",
				"1f468-1f3fb-1f3ed"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f3ed",
				"1f468-1f3fb-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"light skin tone",
			"man",
			"worker"
		]
	},
	"1f468-1f3fc-1f3ed": {
		"name": "man factory worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 537,
		"display": 1,
		"shortname": ":man_factory_worker_tone2:",
		"shortname_alternates": [
			":man_factory_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f3ed",
			"fully_qualified": "1f468-1f3fc-200d-1f3ed",
			"non_fully_qualified": "1f468-1f3fc-200d-1f3ed",
			"output": "1f468-1f3fc-200d-1f3ed",
			"default_matches": [
				"1f468-1f3fc-200d-1f3ed",
				"1f468-1f3fc-1f3ed"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f3ed",
				"1f468-1f3fc-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"man",
			"medium-light skin tone",
			"worker"
		]
	},
	"1f468-1f3fd-1f3ed": {
		"name": "man factory worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 538,
		"display": 1,
		"shortname": ":man_factory_worker_tone3:",
		"shortname_alternates": [
			":man_factory_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f3ed",
			"fully_qualified": "1f468-1f3fd-200d-1f3ed",
			"non_fully_qualified": "1f468-1f3fd-200d-1f3ed",
			"output": "1f468-1f3fd-200d-1f3ed",
			"default_matches": [
				"1f468-1f3fd-200d-1f3ed",
				"1f468-1f3fd-1f3ed"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f3ed",
				"1f468-1f3fd-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"man",
			"medium skin tone",
			"worker"
		]
	},
	"1f468-1f3fe-1f3ed": {
		"name": "man factory worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 539,
		"display": 1,
		"shortname": ":man_factory_worker_tone4:",
		"shortname_alternates": [
			":man_factory_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f3ed",
			"fully_qualified": "1f468-1f3fe-200d-1f3ed",
			"non_fully_qualified": "1f468-1f3fe-200d-1f3ed",
			"output": "1f468-1f3fe-200d-1f3ed",
			"default_matches": [
				"1f468-1f3fe-200d-1f3ed",
				"1f468-1f3fe-1f3ed"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f3ed",
				"1f468-1f3fe-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"factory",
			"industrial",
			"man",
			"medium-dark skin tone",
			"worker"
		]
	},
	"1f468-1f3ff-1f3ed": {
		"name": "man factory worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 540,
		"display": 1,
		"shortname": ":man_factory_worker_tone5:",
		"shortname_alternates": [
			":man_factory_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f3ed",
			"fully_qualified": "1f468-1f3ff-200d-1f3ed",
			"non_fully_qualified": "1f468-1f3ff-200d-1f3ed",
			"output": "1f468-1f3ff-200d-1f3ed",
			"default_matches": [
				"1f468-1f3ff-200d-1f3ed",
				"1f468-1f3ff-1f3ed"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f3ed",
				"1f468-1f3ff-1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"assembly",
			"dark skin tone",
			"factory",
			"industrial",
			"man",
			"worker"
		]
	},
	"1f469-1f4bb": {
		"name": "woman technologist",
		"unicode_version": 6,
		"category": "people",
		"order": 541,
		"display": 1,
		"shortname": ":woman_technologist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f4bb",
			"1f469-1f3fc-1f4bb",
			"1f469-1f3fd-1f4bb",
			"1f469-1f3fe-1f4bb",
			"1f469-1f3ff-1f4bb"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f4bb",
			"fully_qualified": "1f469-200d-1f4bb",
			"non_fully_qualified": "1f469-200d-1f4bb",
			"output": "1f469-200d-1f4bb",
			"default_matches": [
				"1f469-200d-1f4bb",
				"1f469-1f4bb"
			],
			"greedy_matches": [
				"1f469-200d-1f4bb",
				"1f469-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f469-1f3fb-1f4bb": {
		"name": "woman technologist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 542,
		"display": 1,
		"shortname": ":woman_technologist_tone1:",
		"shortname_alternates": [
			":woman_technologist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f4bb",
			"fully_qualified": "1f469-1f3fb-200d-1f4bb",
			"non_fully_qualified": "1f469-1f3fb-200d-1f4bb",
			"output": "1f469-1f3fb-200d-1f4bb",
			"default_matches": [
				"1f469-1f3fb-200d-1f4bb",
				"1f469-1f3fb-1f4bb"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f4bb",
				"1f469-1f3fb-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"light skin tone",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f469-1f3fc-1f4bb": {
		"name": "woman technologist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 543,
		"display": 1,
		"shortname": ":woman_technologist_tone2:",
		"shortname_alternates": [
			":woman_technologist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f4bb",
			"fully_qualified": "1f469-1f3fc-200d-1f4bb",
			"non_fully_qualified": "1f469-1f3fc-200d-1f4bb",
			"output": "1f469-1f3fc-200d-1f4bb",
			"default_matches": [
				"1f469-1f3fc-200d-1f4bb",
				"1f469-1f3fc-1f4bb"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f4bb",
				"1f469-1f3fc-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"medium-light skin tone",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f469-1f3fd-1f4bb": {
		"name": "woman technologist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 544,
		"display": 1,
		"shortname": ":woman_technologist_tone3:",
		"shortname_alternates": [
			":woman_technologist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f4bb",
			"fully_qualified": "1f469-1f3fd-200d-1f4bb",
			"non_fully_qualified": "1f469-1f3fd-200d-1f4bb",
			"output": "1f469-1f3fd-200d-1f4bb",
			"default_matches": [
				"1f469-1f3fd-200d-1f4bb",
				"1f469-1f3fd-1f4bb"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f4bb",
				"1f469-1f3fd-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"medium skin tone",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f469-1f3fe-1f4bb": {
		"name": "woman technologist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 545,
		"display": 1,
		"shortname": ":woman_technologist_tone4:",
		"shortname_alternates": [
			":woman_technologist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f4bb",
			"fully_qualified": "1f469-1f3fe-200d-1f4bb",
			"non_fully_qualified": "1f469-1f3fe-200d-1f4bb",
			"output": "1f469-1f3fe-200d-1f4bb",
			"default_matches": [
				"1f469-1f3fe-200d-1f4bb",
				"1f469-1f3fe-1f4bb"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f4bb",
				"1f469-1f3fe-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"medium-dark skin tone",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f469-1f3ff-1f4bb": {
		"name": "woman technologist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 546,
		"display": 1,
		"shortname": ":woman_technologist_tone5:",
		"shortname_alternates": [
			":woman_technologist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f4bb",
			"fully_qualified": "1f469-1f3ff-200d-1f4bb",
			"non_fully_qualified": "1f469-1f3ff-200d-1f4bb",
			"output": "1f469-1f3ff-200d-1f4bb",
			"default_matches": [
				"1f469-1f3ff-200d-1f4bb",
				"1f469-1f3ff-1f4bb"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f4bb",
				"1f469-1f3ff-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"dark skin tone",
			"developer",
			"inventor",
			"software",
			"technologist",
			"woman"
		]
	},
	"1f468-1f4bb": {
		"name": "man technologist",
		"unicode_version": 6,
		"category": "people",
		"order": 547,
		"display": 1,
		"shortname": ":man_technologist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f4bb",
			"1f468-1f3fc-1f4bb",
			"1f468-1f3fd-1f4bb",
			"1f468-1f3fe-1f4bb",
			"1f468-1f3ff-1f4bb"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f4bb",
			"fully_qualified": "1f468-200d-1f4bb",
			"non_fully_qualified": "1f468-200d-1f4bb",
			"output": "1f468-200d-1f4bb",
			"default_matches": [
				"1f468-200d-1f4bb",
				"1f468-1f4bb"
			],
			"greedy_matches": [
				"1f468-200d-1f4bb",
				"1f468-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"man",
			"software",
			"technologist"
		]
	},
	"1f468-1f3fb-1f4bb": {
		"name": "man technologist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 548,
		"display": 1,
		"shortname": ":man_technologist_tone1:",
		"shortname_alternates": [
			":man_technologist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f4bb",
			"fully_qualified": "1f468-1f3fb-200d-1f4bb",
			"non_fully_qualified": "1f468-1f3fb-200d-1f4bb",
			"output": "1f468-1f3fb-200d-1f4bb",
			"default_matches": [
				"1f468-1f3fb-200d-1f4bb",
				"1f468-1f3fb-1f4bb"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f4bb",
				"1f468-1f3fb-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"light skin tone",
			"man",
			"software",
			"technologist"
		]
	},
	"1f468-1f3fc-1f4bb": {
		"name": "man technologist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 549,
		"display": 1,
		"shortname": ":man_technologist_tone2:",
		"shortname_alternates": [
			":man_technologist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f4bb",
			"fully_qualified": "1f468-1f3fc-200d-1f4bb",
			"non_fully_qualified": "1f468-1f3fc-200d-1f4bb",
			"output": "1f468-1f3fc-200d-1f4bb",
			"default_matches": [
				"1f468-1f3fc-200d-1f4bb",
				"1f468-1f3fc-1f4bb"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f4bb",
				"1f468-1f3fc-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"man",
			"medium-light skin tone",
			"software",
			"technologist"
		]
	},
	"1f468-1f3fd-1f4bb": {
		"name": "man technologist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 550,
		"display": 1,
		"shortname": ":man_technologist_tone3:",
		"shortname_alternates": [
			":man_technologist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f4bb",
			"fully_qualified": "1f468-1f3fd-200d-1f4bb",
			"non_fully_qualified": "1f468-1f3fd-200d-1f4bb",
			"output": "1f468-1f3fd-200d-1f4bb",
			"default_matches": [
				"1f468-1f3fd-200d-1f4bb",
				"1f468-1f3fd-1f4bb"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f4bb",
				"1f468-1f3fd-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"man",
			"medium skin tone",
			"software",
			"technologist"
		]
	},
	"1f468-1f3fe-1f4bb": {
		"name": "man technologist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 551,
		"display": 1,
		"shortname": ":man_technologist_tone4:",
		"shortname_alternates": [
			":man_technologist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f4bb",
			"fully_qualified": "1f468-1f3fe-200d-1f4bb",
			"non_fully_qualified": "1f468-1f3fe-200d-1f4bb",
			"output": "1f468-1f3fe-200d-1f4bb",
			"default_matches": [
				"1f468-1f3fe-200d-1f4bb",
				"1f468-1f3fe-1f4bb"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f4bb",
				"1f468-1f3fe-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"developer",
			"inventor",
			"man",
			"medium-dark skin tone",
			"software",
			"technologist"
		]
	},
	"1f468-1f3ff-1f4bb": {
		"name": "man technologist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 552,
		"display": 1,
		"shortname": ":man_technologist_tone5:",
		"shortname_alternates": [
			":man_technologist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f4bb",
			"fully_qualified": "1f468-1f3ff-200d-1f4bb",
			"non_fully_qualified": "1f468-1f3ff-200d-1f4bb",
			"output": "1f468-1f3ff-200d-1f4bb",
			"default_matches": [
				"1f468-1f3ff-200d-1f4bb",
				"1f468-1f3ff-1f4bb"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f4bb",
				"1f468-1f3ff-1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"coder",
			"dark skin tone",
			"developer",
			"inventor",
			"man",
			"software",
			"technologist"
		]
	},
	"1f469-1f4bc": {
		"name": "woman office worker",
		"unicode_version": 6,
		"category": "people",
		"order": 553,
		"display": 1,
		"shortname": ":woman_office_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f4bc",
			"1f469-1f3fc-1f4bc",
			"1f469-1f3fd-1f4bc",
			"1f469-1f3fe-1f4bc",
			"1f469-1f3ff-1f4bc"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f4bc",
			"fully_qualified": "1f469-200d-1f4bc",
			"non_fully_qualified": "1f469-200d-1f4bc",
			"output": "1f469-200d-1f4bc",
			"default_matches": [
				"1f469-200d-1f4bc",
				"1f469-1f4bc"
			],
			"greedy_matches": [
				"1f469-200d-1f4bc",
				"1f469-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"manager",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f469-1f3fb-1f4bc": {
		"name": "woman office worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 554,
		"display": 1,
		"shortname": ":woman_office_worker_tone1:",
		"shortname_alternates": [
			":woman_office_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f4bc",
			"fully_qualified": "1f469-1f3fb-200d-1f4bc",
			"non_fully_qualified": "1f469-1f3fb-200d-1f4bc",
			"output": "1f469-1f3fb-200d-1f4bc",
			"default_matches": [
				"1f469-1f3fb-200d-1f4bc",
				"1f469-1f3fb-1f4bc"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f4bc",
				"1f469-1f3fb-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"light skin tone",
			"manager",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f469-1f3fc-1f4bc": {
		"name": "woman office worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 555,
		"display": 1,
		"shortname": ":woman_office_worker_tone2:",
		"shortname_alternates": [
			":woman_office_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f4bc",
			"fully_qualified": "1f469-1f3fc-200d-1f4bc",
			"non_fully_qualified": "1f469-1f3fc-200d-1f4bc",
			"output": "1f469-1f3fc-200d-1f4bc",
			"default_matches": [
				"1f469-1f3fc-200d-1f4bc",
				"1f469-1f3fc-1f4bc"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f4bc",
				"1f469-1f3fc-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"manager",
			"medium-light skin tone",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f469-1f3fd-1f4bc": {
		"name": "woman office worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 556,
		"display": 1,
		"shortname": ":woman_office_worker_tone3:",
		"shortname_alternates": [
			":woman_office_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f4bc",
			"fully_qualified": "1f469-1f3fd-200d-1f4bc",
			"non_fully_qualified": "1f469-1f3fd-200d-1f4bc",
			"output": "1f469-1f3fd-200d-1f4bc",
			"default_matches": [
				"1f469-1f3fd-200d-1f4bc",
				"1f469-1f3fd-1f4bc"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f4bc",
				"1f469-1f3fd-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"manager",
			"medium skin tone",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f469-1f3fe-1f4bc": {
		"name": "woman office worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 557,
		"display": 1,
		"shortname": ":woman_office_worker_tone4:",
		"shortname_alternates": [
			":woman_office_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f4bc",
			"fully_qualified": "1f469-1f3fe-200d-1f4bc",
			"non_fully_qualified": "1f469-1f3fe-200d-1f4bc",
			"output": "1f469-1f3fe-200d-1f4bc",
			"default_matches": [
				"1f469-1f3fe-200d-1f4bc",
				"1f469-1f3fe-1f4bc"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f4bc",
				"1f469-1f3fe-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"manager",
			"medium-dark skin tone",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f469-1f3ff-1f4bc": {
		"name": "woman office worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 558,
		"display": 1,
		"shortname": ":woman_office_worker_tone5:",
		"shortname_alternates": [
			":woman_office_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f4bc",
			"fully_qualified": "1f469-1f3ff-200d-1f4bc",
			"non_fully_qualified": "1f469-1f3ff-200d-1f4bc",
			"output": "1f469-1f3ff-200d-1f4bc",
			"default_matches": [
				"1f469-1f3ff-200d-1f4bc",
				"1f469-1f3ff-1f4bc"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f4bc",
				"1f469-1f3ff-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"dark skin tone",
			"manager",
			"office",
			"white-collar",
			"woman"
		]
	},
	"1f468-1f4bc": {
		"name": "man office worker",
		"unicode_version": 6,
		"category": "people",
		"order": 559,
		"display": 1,
		"shortname": ":man_office_worker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f4bc",
			"1f468-1f3fc-1f4bc",
			"1f468-1f3fd-1f4bc",
			"1f468-1f3fe-1f4bc",
			"1f468-1f3ff-1f4bc"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f4bc",
			"fully_qualified": "1f468-200d-1f4bc",
			"non_fully_qualified": "1f468-200d-1f4bc",
			"output": "1f468-200d-1f4bc",
			"default_matches": [
				"1f468-200d-1f4bc",
				"1f468-1f4bc"
			],
			"greedy_matches": [
				"1f468-200d-1f4bc",
				"1f468-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"man",
			"manager",
			"office",
			"white-collar"
		]
	},
	"1f468-1f3fb-1f4bc": {
		"name": "man office worker: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 560,
		"display": 1,
		"shortname": ":man_office_worker_tone1:",
		"shortname_alternates": [
			":man_office_worker_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f4bc",
			"fully_qualified": "1f468-1f3fb-200d-1f4bc",
			"non_fully_qualified": "1f468-1f3fb-200d-1f4bc",
			"output": "1f468-1f3fb-200d-1f4bc",
			"default_matches": [
				"1f468-1f3fb-200d-1f4bc",
				"1f468-1f3fb-1f4bc"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f4bc",
				"1f468-1f3fb-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"light skin tone",
			"man",
			"manager",
			"office",
			"white-collar"
		]
	},
	"1f468-1f3fc-1f4bc": {
		"name": "man office worker: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 561,
		"display": 1,
		"shortname": ":man_office_worker_tone2:",
		"shortname_alternates": [
			":man_office_worker_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f4bc",
			"fully_qualified": "1f468-1f3fc-200d-1f4bc",
			"non_fully_qualified": "1f468-1f3fc-200d-1f4bc",
			"output": "1f468-1f3fc-200d-1f4bc",
			"default_matches": [
				"1f468-1f3fc-200d-1f4bc",
				"1f468-1f3fc-1f4bc"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f4bc",
				"1f468-1f3fc-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"man",
			"manager",
			"medium-light skin tone",
			"office",
			"white-collar"
		]
	},
	"1f468-1f3fd-1f4bc": {
		"name": "man office worker: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 562,
		"display": 1,
		"shortname": ":man_office_worker_tone3:",
		"shortname_alternates": [
			":man_office_worker_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f4bc",
			"fully_qualified": "1f468-1f3fd-200d-1f4bc",
			"non_fully_qualified": "1f468-1f3fd-200d-1f4bc",
			"output": "1f468-1f3fd-200d-1f4bc",
			"default_matches": [
				"1f468-1f3fd-200d-1f4bc",
				"1f468-1f3fd-1f4bc"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f4bc",
				"1f468-1f3fd-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"man",
			"manager",
			"medium skin tone",
			"office",
			"white-collar"
		]
	},
	"1f468-1f3fe-1f4bc": {
		"name": "man office worker: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 563,
		"display": 1,
		"shortname": ":man_office_worker_tone4:",
		"shortname_alternates": [
			":man_office_worker_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f4bc",
			"fully_qualified": "1f468-1f3fe-200d-1f4bc",
			"non_fully_qualified": "1f468-1f3fe-200d-1f4bc",
			"output": "1f468-1f3fe-200d-1f4bc",
			"default_matches": [
				"1f468-1f3fe-200d-1f4bc",
				"1f468-1f3fe-1f4bc"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f4bc",
				"1f468-1f3fe-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"man",
			"manager",
			"medium-dark skin tone",
			"office",
			"white-collar"
		]
	},
	"1f468-1f3ff-1f4bc": {
		"name": "man office worker: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 564,
		"display": 1,
		"shortname": ":man_office_worker_tone5:",
		"shortname_alternates": [
			":man_office_worker_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f4bc",
			"fully_qualified": "1f468-1f3ff-200d-1f4bc",
			"non_fully_qualified": "1f468-1f3ff-200d-1f4bc",
			"output": "1f468-1f3ff-200d-1f4bc",
			"default_matches": [
				"1f468-1f3ff-200d-1f4bc",
				"1f468-1f3ff-1f4bc"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f4bc",
				"1f468-1f3ff-1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"architect",
			"business",
			"dark skin tone",
			"man",
			"manager",
			"office",
			"white-collar"
		]
	},
	"1f469-1f527": {
		"name": "woman mechanic",
		"unicode_version": 6,
		"category": "people",
		"order": 565,
		"display": 1,
		"shortname": ":woman_mechanic:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f527",
			"1f469-1f3fc-1f527",
			"1f469-1f3fd-1f527",
			"1f469-1f3fe-1f527",
			"1f469-1f3ff-1f527"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f527",
			"fully_qualified": "1f469-200d-1f527",
			"non_fully_qualified": "1f469-200d-1f527",
			"output": "1f469-200d-1f527",
			"default_matches": [
				"1f469-200d-1f527",
				"1f469-1f527"
			],
			"greedy_matches": [
				"1f469-200d-1f527",
				"1f469-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"mechanic",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f469-1f3fb-1f527": {
		"name": "woman mechanic: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 566,
		"display": 1,
		"shortname": ":woman_mechanic_tone1:",
		"shortname_alternates": [
			":woman_mechanic_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f527",
			"fully_qualified": "1f469-1f3fb-200d-1f527",
			"non_fully_qualified": "1f469-1f3fb-200d-1f527",
			"output": "1f469-1f3fb-200d-1f527",
			"default_matches": [
				"1f469-1f3fb-200d-1f527",
				"1f469-1f3fb-1f527"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f527",
				"1f469-1f3fb-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"light skin tone",
			"mechanic",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f469-1f3fc-1f527": {
		"name": "woman mechanic: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 567,
		"display": 1,
		"shortname": ":woman_mechanic_tone2:",
		"shortname_alternates": [
			":woman_mechanic_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f527",
			"fully_qualified": "1f469-1f3fc-200d-1f527",
			"non_fully_qualified": "1f469-1f3fc-200d-1f527",
			"output": "1f469-1f3fc-200d-1f527",
			"default_matches": [
				"1f469-1f3fc-200d-1f527",
				"1f469-1f3fc-1f527"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f527",
				"1f469-1f3fc-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"mechanic",
			"medium-light skin tone",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f469-1f3fd-1f527": {
		"name": "woman mechanic: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 568,
		"display": 1,
		"shortname": ":woman_mechanic_tone3:",
		"shortname_alternates": [
			":woman_mechanic_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f527",
			"fully_qualified": "1f469-1f3fd-200d-1f527",
			"non_fully_qualified": "1f469-1f3fd-200d-1f527",
			"output": "1f469-1f3fd-200d-1f527",
			"default_matches": [
				"1f469-1f3fd-200d-1f527",
				"1f469-1f3fd-1f527"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f527",
				"1f469-1f3fd-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"mechanic",
			"medium skin tone",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f469-1f3fe-1f527": {
		"name": "woman mechanic: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 569,
		"display": 1,
		"shortname": ":woman_mechanic_tone4:",
		"shortname_alternates": [
			":woman_mechanic_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f527",
			"fully_qualified": "1f469-1f3fe-200d-1f527",
			"non_fully_qualified": "1f469-1f3fe-200d-1f527",
			"output": "1f469-1f3fe-200d-1f527",
			"default_matches": [
				"1f469-1f3fe-200d-1f527",
				"1f469-1f3fe-1f527"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f527",
				"1f469-1f3fe-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"mechanic",
			"medium-dark skin tone",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f469-1f3ff-1f527": {
		"name": "woman mechanic: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 570,
		"display": 1,
		"shortname": ":woman_mechanic_tone5:",
		"shortname_alternates": [
			":woman_mechanic_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f527",
			"fully_qualified": "1f469-1f3ff-200d-1f527",
			"non_fully_qualified": "1f469-1f3ff-200d-1f527",
			"output": "1f469-1f3ff-200d-1f527",
			"default_matches": [
				"1f469-1f3ff-200d-1f527",
				"1f469-1f3ff-1f527"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f527",
				"1f469-1f3ff-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"electrician",
			"mechanic",
			"plumber",
			"tradesperson",
			"woman"
		]
	},
	"1f468-1f527": {
		"name": "man mechanic",
		"unicode_version": 6,
		"category": "people",
		"order": 571,
		"display": 1,
		"shortname": ":man_mechanic:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f527",
			"1f468-1f3fc-1f527",
			"1f468-1f3fd-1f527",
			"1f468-1f3fe-1f527",
			"1f468-1f3ff-1f527"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f527",
			"fully_qualified": "1f468-200d-1f527",
			"non_fully_qualified": "1f468-200d-1f527",
			"output": "1f468-200d-1f527",
			"default_matches": [
				"1f468-200d-1f527",
				"1f468-1f527"
			],
			"greedy_matches": [
				"1f468-200d-1f527",
				"1f468-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"man",
			"mechanic",
			"plumber",
			"tradesperson"
		]
	},
	"1f468-1f3fb-1f527": {
		"name": "man mechanic: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 572,
		"display": 1,
		"shortname": ":man_mechanic_tone1:",
		"shortname_alternates": [
			":man_mechanic_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f527",
			"fully_qualified": "1f468-1f3fb-200d-1f527",
			"non_fully_qualified": "1f468-1f3fb-200d-1f527",
			"output": "1f468-1f3fb-200d-1f527",
			"default_matches": [
				"1f468-1f3fb-200d-1f527",
				"1f468-1f3fb-1f527"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f527",
				"1f468-1f3fb-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"light skin tone",
			"man",
			"mechanic",
			"plumber",
			"tradesperson"
		]
	},
	"1f468-1f3fc-1f527": {
		"name": "man mechanic: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 573,
		"display": 1,
		"shortname": ":man_mechanic_tone2:",
		"shortname_alternates": [
			":man_mechanic_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f527",
			"fully_qualified": "1f468-1f3fc-200d-1f527",
			"non_fully_qualified": "1f468-1f3fc-200d-1f527",
			"output": "1f468-1f3fc-200d-1f527",
			"default_matches": [
				"1f468-1f3fc-200d-1f527",
				"1f468-1f3fc-1f527"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f527",
				"1f468-1f3fc-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"man",
			"mechanic",
			"medium-light skin tone",
			"plumber",
			"tradesperson"
		]
	},
	"1f468-1f3fd-1f527": {
		"name": "man mechanic: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 574,
		"display": 1,
		"shortname": ":man_mechanic_tone3:",
		"shortname_alternates": [
			":man_mechanic_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f527",
			"fully_qualified": "1f468-1f3fd-200d-1f527",
			"non_fully_qualified": "1f468-1f3fd-200d-1f527",
			"output": "1f468-1f3fd-200d-1f527",
			"default_matches": [
				"1f468-1f3fd-200d-1f527",
				"1f468-1f3fd-1f527"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f527",
				"1f468-1f3fd-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"man",
			"mechanic",
			"medium skin tone",
			"plumber",
			"tradesperson"
		]
	},
	"1f468-1f3fe-1f527": {
		"name": "man mechanic: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 575,
		"display": 1,
		"shortname": ":man_mechanic_tone4:",
		"shortname_alternates": [
			":man_mechanic_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f527",
			"fully_qualified": "1f468-1f3fe-200d-1f527",
			"non_fully_qualified": "1f468-1f3fe-200d-1f527",
			"output": "1f468-1f3fe-200d-1f527",
			"default_matches": [
				"1f468-1f3fe-200d-1f527",
				"1f468-1f3fe-1f527"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f527",
				"1f468-1f3fe-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"electrician",
			"man",
			"mechanic",
			"medium-dark skin tone",
			"plumber",
			"tradesperson"
		]
	},
	"1f468-1f3ff-1f527": {
		"name": "man mechanic: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 576,
		"display": 1,
		"shortname": ":man_mechanic_tone5:",
		"shortname_alternates": [
			":man_mechanic_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f527",
			"fully_qualified": "1f468-1f3ff-200d-1f527",
			"non_fully_qualified": "1f468-1f3ff-200d-1f527",
			"output": "1f468-1f3ff-200d-1f527",
			"default_matches": [
				"1f468-1f3ff-200d-1f527",
				"1f468-1f3ff-1f527"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f527",
				"1f468-1f3ff-1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"electrician",
			"man",
			"mechanic",
			"plumber",
			"tradesperson"
		]
	},
	"1f469-1f52c": {
		"name": "woman scientist",
		"unicode_version": 6,
		"category": "people",
		"order": 577,
		"display": 1,
		"shortname": ":woman_scientist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f52c",
			"1f469-1f3fc-1f52c",
			"1f469-1f3fd-1f52c",
			"1f469-1f3fe-1f52c",
			"1f469-1f3ff-1f52c"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f52c",
			"fully_qualified": "1f469-200d-1f52c",
			"non_fully_qualified": "1f469-200d-1f52c",
			"output": "1f469-200d-1f52c",
			"default_matches": [
				"1f469-200d-1f52c",
				"1f469-1f52c"
			],
			"greedy_matches": [
				"1f469-200d-1f52c",
				"1f469-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"mathematician",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f469-1f3fb-1f52c": {
		"name": "woman scientist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 578,
		"display": 1,
		"shortname": ":woman_scientist_tone1:",
		"shortname_alternates": [
			":woman_scientist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f52c",
			"fully_qualified": "1f469-1f3fb-200d-1f52c",
			"non_fully_qualified": "1f469-1f3fb-200d-1f52c",
			"output": "1f469-1f3fb-200d-1f52c",
			"default_matches": [
				"1f469-1f3fb-200d-1f52c",
				"1f469-1f3fb-1f52c"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f52c",
				"1f469-1f3fb-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"light skin tone",
			"mathematician",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f469-1f3fc-1f52c": {
		"name": "woman scientist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 579,
		"display": 1,
		"shortname": ":woman_scientist_tone2:",
		"shortname_alternates": [
			":woman_scientist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f52c",
			"fully_qualified": "1f469-1f3fc-200d-1f52c",
			"non_fully_qualified": "1f469-1f3fc-200d-1f52c",
			"output": "1f469-1f3fc-200d-1f52c",
			"default_matches": [
				"1f469-1f3fc-200d-1f52c",
				"1f469-1f3fc-1f52c"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f52c",
				"1f469-1f3fc-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"mathematician",
			"medium-light skin tone",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f469-1f3fd-1f52c": {
		"name": "woman scientist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 580,
		"display": 1,
		"shortname": ":woman_scientist_tone3:",
		"shortname_alternates": [
			":woman_scientist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f52c",
			"fully_qualified": "1f469-1f3fd-200d-1f52c",
			"non_fully_qualified": "1f469-1f3fd-200d-1f52c",
			"output": "1f469-1f3fd-200d-1f52c",
			"default_matches": [
				"1f469-1f3fd-200d-1f52c",
				"1f469-1f3fd-1f52c"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f52c",
				"1f469-1f3fd-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"mathematician",
			"medium skin tone",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f469-1f3fe-1f52c": {
		"name": "woman scientist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 581,
		"display": 1,
		"shortname": ":woman_scientist_tone4:",
		"shortname_alternates": [
			":woman_scientist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f52c",
			"fully_qualified": "1f469-1f3fe-200d-1f52c",
			"non_fully_qualified": "1f469-1f3fe-200d-1f52c",
			"output": "1f469-1f3fe-200d-1f52c",
			"default_matches": [
				"1f469-1f3fe-200d-1f52c",
				"1f469-1f3fe-1f52c"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f52c",
				"1f469-1f3fe-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"mathematician",
			"medium-dark skin tone",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f469-1f3ff-1f52c": {
		"name": "woman scientist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 582,
		"display": 1,
		"shortname": ":woman_scientist_tone5:",
		"shortname_alternates": [
			":woman_scientist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f52c",
			"fully_qualified": "1f469-1f3ff-200d-1f52c",
			"non_fully_qualified": "1f469-1f3ff-200d-1f52c",
			"output": "1f469-1f3ff-200d-1f52c",
			"default_matches": [
				"1f469-1f3ff-200d-1f52c",
				"1f469-1f3ff-1f52c"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f52c",
				"1f469-1f3ff-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"dark skin tone",
			"engineer",
			"mathematician",
			"physicist",
			"scientist",
			"woman"
		]
	},
	"1f468-1f52c": {
		"name": "man scientist",
		"unicode_version": 6,
		"category": "people",
		"order": 583,
		"display": 1,
		"shortname": ":man_scientist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f52c",
			"1f468-1f3fc-1f52c",
			"1f468-1f3fd-1f52c",
			"1f468-1f3fe-1f52c",
			"1f468-1f3ff-1f52c"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f52c",
			"fully_qualified": "1f468-200d-1f52c",
			"non_fully_qualified": "1f468-200d-1f52c",
			"output": "1f468-200d-1f52c",
			"default_matches": [
				"1f468-200d-1f52c",
				"1f468-1f52c"
			],
			"greedy_matches": [
				"1f468-200d-1f52c",
				"1f468-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"man",
			"mathematician",
			"physicist",
			"scientist"
		]
	},
	"1f468-1f3fb-1f52c": {
		"name": "man scientist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 584,
		"display": 1,
		"shortname": ":man_scientist_tone1:",
		"shortname_alternates": [
			":man_scientist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f52c",
			"fully_qualified": "1f468-1f3fb-200d-1f52c",
			"non_fully_qualified": "1f468-1f3fb-200d-1f52c",
			"output": "1f468-1f3fb-200d-1f52c",
			"default_matches": [
				"1f468-1f3fb-200d-1f52c",
				"1f468-1f3fb-1f52c"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f52c",
				"1f468-1f3fb-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"light skin tone",
			"man",
			"mathematician",
			"physicist",
			"scientist"
		]
	},
	"1f468-1f3fc-1f52c": {
		"name": "man scientist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 585,
		"display": 1,
		"shortname": ":man_scientist_tone2:",
		"shortname_alternates": [
			":man_scientist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f52c",
			"fully_qualified": "1f468-1f3fc-200d-1f52c",
			"non_fully_qualified": "1f468-1f3fc-200d-1f52c",
			"output": "1f468-1f3fc-200d-1f52c",
			"default_matches": [
				"1f468-1f3fc-200d-1f52c",
				"1f468-1f3fc-1f52c"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f52c",
				"1f468-1f3fc-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"man",
			"mathematician",
			"medium-light skin tone",
			"physicist",
			"scientist"
		]
	},
	"1f468-1f3fd-1f52c": {
		"name": "man scientist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 586,
		"display": 1,
		"shortname": ":man_scientist_tone3:",
		"shortname_alternates": [
			":man_scientist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f52c",
			"fully_qualified": "1f468-1f3fd-200d-1f52c",
			"non_fully_qualified": "1f468-1f3fd-200d-1f52c",
			"output": "1f468-1f3fd-200d-1f52c",
			"default_matches": [
				"1f468-1f3fd-200d-1f52c",
				"1f468-1f3fd-1f52c"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f52c",
				"1f468-1f3fd-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"man",
			"mathematician",
			"medium skin tone",
			"physicist",
			"scientist"
		]
	},
	"1f468-1f3fe-1f52c": {
		"name": "man scientist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 587,
		"display": 1,
		"shortname": ":man_scientist_tone4:",
		"shortname_alternates": [
			":man_scientist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f52c",
			"fully_qualified": "1f468-1f3fe-200d-1f52c",
			"non_fully_qualified": "1f468-1f3fe-200d-1f52c",
			"output": "1f468-1f3fe-200d-1f52c",
			"default_matches": [
				"1f468-1f3fe-200d-1f52c",
				"1f468-1f3fe-1f52c"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f52c",
				"1f468-1f3fe-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"engineer",
			"man",
			"mathematician",
			"medium-dark skin tone",
			"physicist",
			"scientist"
		]
	},
	"1f468-1f3ff-1f52c": {
		"name": "man scientist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 588,
		"display": 1,
		"shortname": ":man_scientist_tone5:",
		"shortname_alternates": [
			":man_scientist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f52c",
			"fully_qualified": "1f468-1f3ff-200d-1f52c",
			"non_fully_qualified": "1f468-1f3ff-200d-1f52c",
			"output": "1f468-1f3ff-200d-1f52c",
			"default_matches": [
				"1f468-1f3ff-200d-1f52c",
				"1f468-1f3ff-1f52c"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f52c",
				"1f468-1f3ff-1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"biologist",
			"chemist",
			"dark skin tone",
			"engineer",
			"man",
			"mathematician",
			"physicist",
			"scientist"
		]
	},
	"1f469-1f3a8": {
		"name": "woman artist",
		"unicode_version": 6,
		"category": "people",
		"order": 589,
		"display": 1,
		"shortname": ":woman_artist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f3a8",
			"1f469-1f3fc-1f3a8",
			"1f469-1f3fd-1f3a8",
			"1f469-1f3fe-1f3a8",
			"1f469-1f3ff-1f3a8"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3a8",
			"fully_qualified": "1f469-200d-1f3a8",
			"non_fully_qualified": "1f469-200d-1f3a8",
			"output": "1f469-200d-1f3a8",
			"default_matches": [
				"1f469-200d-1f3a8",
				"1f469-1f3a8"
			],
			"greedy_matches": [
				"1f469-200d-1f3a8",
				"1f469-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"palette",
			"woman"
		]
	},
	"1f469-1f3fb-1f3a8": {
		"name": "woman artist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 590,
		"display": 1,
		"shortname": ":woman_artist_tone1:",
		"shortname_alternates": [
			":woman_artist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f3a8",
			"fully_qualified": "1f469-1f3fb-200d-1f3a8",
			"non_fully_qualified": "1f469-1f3fb-200d-1f3a8",
			"output": "1f469-1f3fb-200d-1f3a8",
			"default_matches": [
				"1f469-1f3fb-200d-1f3a8",
				"1f469-1f3fb-1f3a8"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f3a8",
				"1f469-1f3fb-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"light skin tone",
			"palette",
			"woman"
		]
	},
	"1f469-1f3fc-1f3a8": {
		"name": "woman artist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 591,
		"display": 1,
		"shortname": ":woman_artist_tone2:",
		"shortname_alternates": [
			":woman_artist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f3a8",
			"fully_qualified": "1f469-1f3fc-200d-1f3a8",
			"non_fully_qualified": "1f469-1f3fc-200d-1f3a8",
			"output": "1f469-1f3fc-200d-1f3a8",
			"default_matches": [
				"1f469-1f3fc-200d-1f3a8",
				"1f469-1f3fc-1f3a8"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f3a8",
				"1f469-1f3fc-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"medium-light skin tone",
			"palette",
			"woman"
		]
	},
	"1f469-1f3fd-1f3a8": {
		"name": "woman artist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 592,
		"display": 1,
		"shortname": ":woman_artist_tone3:",
		"shortname_alternates": [
			":woman_artist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f3a8",
			"fully_qualified": "1f469-1f3fd-200d-1f3a8",
			"non_fully_qualified": "1f469-1f3fd-200d-1f3a8",
			"output": "1f469-1f3fd-200d-1f3a8",
			"default_matches": [
				"1f469-1f3fd-200d-1f3a8",
				"1f469-1f3fd-1f3a8"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f3a8",
				"1f469-1f3fd-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"medium skin tone",
			"palette",
			"woman"
		]
	},
	"1f469-1f3fe-1f3a8": {
		"name": "woman artist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 593,
		"display": 1,
		"shortname": ":woman_artist_tone4:",
		"shortname_alternates": [
			":woman_artist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f3a8",
			"fully_qualified": "1f469-1f3fe-200d-1f3a8",
			"non_fully_qualified": "1f469-1f3fe-200d-1f3a8",
			"output": "1f469-1f3fe-200d-1f3a8",
			"default_matches": [
				"1f469-1f3fe-200d-1f3a8",
				"1f469-1f3fe-1f3a8"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f3a8",
				"1f469-1f3fe-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"medium-dark skin tone",
			"palette",
			"woman"
		]
	},
	"1f469-1f3ff-1f3a8": {
		"name": "woman artist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 594,
		"display": 1,
		"shortname": ":woman_artist_tone5:",
		"shortname_alternates": [
			":woman_artist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f3a8",
			"fully_qualified": "1f469-1f3ff-200d-1f3a8",
			"non_fully_qualified": "1f469-1f3ff-200d-1f3a8",
			"output": "1f469-1f3ff-200d-1f3a8",
			"default_matches": [
				"1f469-1f3ff-200d-1f3a8",
				"1f469-1f3ff-1f3a8"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f3a8",
				"1f469-1f3ff-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"dark skin tone",
			"palette",
			"woman"
		]
	},
	"1f468-1f3a8": {
		"name": "man artist",
		"unicode_version": 6,
		"category": "people",
		"order": 595,
		"display": 1,
		"shortname": ":man_artist:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f3a8",
			"1f468-1f3fc-1f3a8",
			"1f468-1f3fd-1f3a8",
			"1f468-1f3fe-1f3a8",
			"1f468-1f3ff-1f3a8"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3a8",
			"fully_qualified": "1f468-200d-1f3a8",
			"non_fully_qualified": "1f468-200d-1f3a8",
			"output": "1f468-200d-1f3a8",
			"default_matches": [
				"1f468-200d-1f3a8",
				"1f468-1f3a8"
			],
			"greedy_matches": [
				"1f468-200d-1f3a8",
				"1f468-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"man",
			"palette"
		]
	},
	"1f468-1f3fb-1f3a8": {
		"name": "man artist: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 596,
		"display": 1,
		"shortname": ":man_artist_tone1:",
		"shortname_alternates": [
			":man_artist_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f3a8",
			"fully_qualified": "1f468-1f3fb-200d-1f3a8",
			"non_fully_qualified": "1f468-1f3fb-200d-1f3a8",
			"output": "1f468-1f3fb-200d-1f3a8",
			"default_matches": [
				"1f468-1f3fb-200d-1f3a8",
				"1f468-1f3fb-1f3a8"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f3a8",
				"1f468-1f3fb-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"light skin tone",
			"man",
			"palette"
		]
	},
	"1f468-1f3fc-1f3a8": {
		"name": "man artist: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 597,
		"display": 1,
		"shortname": ":man_artist_tone2:",
		"shortname_alternates": [
			":man_artist_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f3a8",
			"fully_qualified": "1f468-1f3fc-200d-1f3a8",
			"non_fully_qualified": "1f468-1f3fc-200d-1f3a8",
			"output": "1f468-1f3fc-200d-1f3a8",
			"default_matches": [
				"1f468-1f3fc-200d-1f3a8",
				"1f468-1f3fc-1f3a8"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f3a8",
				"1f468-1f3fc-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"man",
			"medium-light skin tone",
			"palette"
		]
	},
	"1f468-1f3fd-1f3a8": {
		"name": "man artist: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 598,
		"display": 1,
		"shortname": ":man_artist_tone3:",
		"shortname_alternates": [
			":man_artist_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f3a8",
			"fully_qualified": "1f468-1f3fd-200d-1f3a8",
			"non_fully_qualified": "1f468-1f3fd-200d-1f3a8",
			"output": "1f468-1f3fd-200d-1f3a8",
			"default_matches": [
				"1f468-1f3fd-200d-1f3a8",
				"1f468-1f3fd-1f3a8"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f3a8",
				"1f468-1f3fd-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"man",
			"medium skin tone",
			"palette"
		]
	},
	"1f468-1f3fe-1f3a8": {
		"name": "man artist: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 599,
		"display": 1,
		"shortname": ":man_artist_tone4:",
		"shortname_alternates": [
			":man_artist_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f3a8",
			"fully_qualified": "1f468-1f3fe-200d-1f3a8",
			"non_fully_qualified": "1f468-1f3fe-200d-1f3a8",
			"output": "1f468-1f3fe-200d-1f3a8",
			"default_matches": [
				"1f468-1f3fe-200d-1f3a8",
				"1f468-1f3fe-1f3a8"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f3a8",
				"1f468-1f3fe-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"man",
			"medium-dark skin tone",
			"palette"
		]
	},
	"1f468-1f3ff-1f3a8": {
		"name": "man artist: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 600,
		"display": 1,
		"shortname": ":man_artist_tone5:",
		"shortname_alternates": [
			":man_artist_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f3a8",
			"fully_qualified": "1f468-1f3ff-200d-1f3a8",
			"non_fully_qualified": "1f468-1f3ff-200d-1f3a8",
			"output": "1f468-1f3ff-200d-1f3a8",
			"default_matches": [
				"1f468-1f3ff-200d-1f3a8",
				"1f468-1f3ff-1f3a8"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f3a8",
				"1f468-1f3ff-1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"artist",
			"dark skin tone",
			"man",
			"palette"
		]
	},
	"1f469-1f692": {
		"name": "woman firefighter",
		"unicode_version": 6,
		"category": "people",
		"order": 601,
		"display": 1,
		"shortname": ":woman_firefighter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f692",
			"1f469-1f3fc-1f692",
			"1f469-1f3fd-1f692",
			"1f469-1f3fe-1f692",
			"1f469-1f3ff-1f692"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f692",
			"fully_qualified": "1f469-200d-1f692",
			"non_fully_qualified": "1f469-200d-1f692",
			"output": "1f469-200d-1f692",
			"default_matches": [
				"1f469-200d-1f692",
				"1f469-1f692"
			],
			"greedy_matches": [
				"1f469-200d-1f692",
				"1f469-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"woman"
		]
	},
	"1f469-1f3fb-1f692": {
		"name": "woman firefighter: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 602,
		"display": 1,
		"shortname": ":woman_firefighter_tone1:",
		"shortname_alternates": [
			":woman_firefighter_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f692",
			"fully_qualified": "1f469-1f3fb-200d-1f692",
			"non_fully_qualified": "1f469-1f3fb-200d-1f692",
			"output": "1f469-1f3fb-200d-1f692",
			"default_matches": [
				"1f469-1f3fb-200d-1f692",
				"1f469-1f3fb-1f692"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f692",
				"1f469-1f3fb-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"light skin tone",
			"woman"
		]
	},
	"1f469-1f3fc-1f692": {
		"name": "woman firefighter: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 603,
		"display": 1,
		"shortname": ":woman_firefighter_tone2:",
		"shortname_alternates": [
			":woman_firefighter_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f692",
			"fully_qualified": "1f469-1f3fc-200d-1f692",
			"non_fully_qualified": "1f469-1f3fc-200d-1f692",
			"output": "1f469-1f3fc-200d-1f692",
			"default_matches": [
				"1f469-1f3fc-200d-1f692",
				"1f469-1f3fc-1f692"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f692",
				"1f469-1f3fc-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f469-1f3fd-1f692": {
		"name": "woman firefighter: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 604,
		"display": 1,
		"shortname": ":woman_firefighter_tone3:",
		"shortname_alternates": [
			":woman_firefighter_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f692",
			"fully_qualified": "1f469-1f3fd-200d-1f692",
			"non_fully_qualified": "1f469-1f3fd-200d-1f692",
			"output": "1f469-1f3fd-200d-1f692",
			"default_matches": [
				"1f469-1f3fd-200d-1f692",
				"1f469-1f3fd-1f692"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f692",
				"1f469-1f3fd-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"medium skin tone",
			"woman"
		]
	},
	"1f469-1f3fe-1f692": {
		"name": "woman firefighter: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 605,
		"display": 1,
		"shortname": ":woman_firefighter_tone4:",
		"shortname_alternates": [
			":woman_firefighter_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f692",
			"fully_qualified": "1f469-1f3fe-200d-1f692",
			"non_fully_qualified": "1f469-1f3fe-200d-1f692",
			"output": "1f469-1f3fe-200d-1f692",
			"default_matches": [
				"1f469-1f3fe-200d-1f692",
				"1f469-1f3fe-1f692"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f692",
				"1f469-1f3fe-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f469-1f3ff-1f692": {
		"name": "woman firefighter: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 606,
		"display": 1,
		"shortname": ":woman_firefighter_tone5:",
		"shortname_alternates": [
			":woman_firefighter_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f692",
			"fully_qualified": "1f469-1f3ff-200d-1f692",
			"non_fully_qualified": "1f469-1f3ff-200d-1f692",
			"output": "1f469-1f3ff-200d-1f692",
			"default_matches": [
				"1f469-1f3ff-200d-1f692",
				"1f469-1f3ff-1f692"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f692",
				"1f469-1f3ff-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"firefighter",
			"firetruck",
			"woman"
		]
	},
	"1f468-1f692": {
		"name": "man firefighter",
		"unicode_version": 6,
		"category": "people",
		"order": 607,
		"display": 1,
		"shortname": ":man_firefighter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f692",
			"1f468-1f3fc-1f692",
			"1f468-1f3fd-1f692",
			"1f468-1f3fe-1f692",
			"1f468-1f3ff-1f692"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f692",
			"fully_qualified": "1f468-200d-1f692",
			"non_fully_qualified": "1f468-200d-1f692",
			"output": "1f468-200d-1f692",
			"default_matches": [
				"1f468-200d-1f692",
				"1f468-1f692"
			],
			"greedy_matches": [
				"1f468-200d-1f692",
				"1f468-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"man"
		]
	},
	"1f468-1f3fb-1f692": {
		"name": "man firefighter: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 608,
		"display": 1,
		"shortname": ":man_firefighter_tone1:",
		"shortname_alternates": [
			":man_firefighter_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f692",
			"fully_qualified": "1f468-1f3fb-200d-1f692",
			"non_fully_qualified": "1f468-1f3fb-200d-1f692",
			"output": "1f468-1f3fb-200d-1f692",
			"default_matches": [
				"1f468-1f3fb-200d-1f692",
				"1f468-1f3fb-1f692"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f692",
				"1f468-1f3fb-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"light skin tone",
			"man"
		]
	},
	"1f468-1f3fc-1f692": {
		"name": "man firefighter: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 609,
		"display": 1,
		"shortname": ":man_firefighter_tone2:",
		"shortname_alternates": [
			":man_firefighter_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f692",
			"fully_qualified": "1f468-1f3fc-200d-1f692",
			"non_fully_qualified": "1f468-1f3fc-200d-1f692",
			"output": "1f468-1f3fc-200d-1f692",
			"default_matches": [
				"1f468-1f3fc-200d-1f692",
				"1f468-1f3fc-1f692"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f692",
				"1f468-1f3fc-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"man",
			"medium-light skin tone"
		]
	},
	"1f468-1f3fd-1f692": {
		"name": "man firefighter: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 610,
		"display": 1,
		"shortname": ":man_firefighter_tone3:",
		"shortname_alternates": [
			":man_firefighter_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f692",
			"fully_qualified": "1f468-1f3fd-200d-1f692",
			"non_fully_qualified": "1f468-1f3fd-200d-1f692",
			"output": "1f468-1f3fd-200d-1f692",
			"default_matches": [
				"1f468-1f3fd-200d-1f692",
				"1f468-1f3fd-1f692"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f692",
				"1f468-1f3fd-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"man",
			"medium skin tone"
		]
	},
	"1f468-1f3fe-1f692": {
		"name": "man firefighter: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 611,
		"display": 1,
		"shortname": ":man_firefighter_tone4:",
		"shortname_alternates": [
			":man_firefighter_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f692",
			"fully_qualified": "1f468-1f3fe-200d-1f692",
			"non_fully_qualified": "1f468-1f3fe-200d-1f692",
			"output": "1f468-1f3fe-200d-1f692",
			"default_matches": [
				"1f468-1f3fe-200d-1f692",
				"1f468-1f3fe-1f692"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f692",
				"1f468-1f3fe-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"firefighter",
			"firetruck",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f468-1f3ff-1f692": {
		"name": "man firefighter: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 612,
		"display": 1,
		"shortname": ":man_firefighter_tone5:",
		"shortname_alternates": [
			":man_firefighter_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f692",
			"fully_qualified": "1f468-1f3ff-200d-1f692",
			"non_fully_qualified": "1f468-1f3ff-200d-1f692",
			"output": "1f468-1f3ff-200d-1f692",
			"default_matches": [
				"1f468-1f3ff-200d-1f692",
				"1f468-1f3ff-1f692"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f692",
				"1f468-1f3ff-1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"firefighter",
			"firetruck",
			"man"
		]
	},
	"1f469-2708": {
		"name": "woman pilot",
		"unicode_version": 6,
		"category": "people",
		"order": 613,
		"display": 1,
		"shortname": ":woman_pilot:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-2708",
			"1f469-1f3fc-2708",
			"1f469-1f3fd-2708",
			"1f469-1f3fe-2708",
			"1f469-1f3ff-2708"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2708",
			"fully_qualified": "1f469-200d-2708-fe0f",
			"non_fully_qualified": "1f469-200d-2708",
			"output": "1f469-200d-2708-fe0f",
			"default_matches": [
				"1f469-200d-2708-fe0f",
				"1f469-200d-2708",
				"1f469-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-200d-2708-fe0f",
				"1f469-200d-2708",
				"1f469-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f469-1f3fb-2708": {
		"name": "woman pilot: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 614,
		"display": 1,
		"shortname": ":woman_pilot_tone1:",
		"shortname_alternates": [
			":woman_pilot_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-2708",
			"fully_qualified": "1f469-1f3fb-200d-2708-fe0f",
			"non_fully_qualified": "1f469-1f3fb-200d-2708",
			"output": "1f469-1f3fb-200d-2708-fe0f",
			"default_matches": [
				"1f469-1f3fb-200d-2708-fe0f",
				"1f469-1f3fb-200d-2708",
				"1f469-1f3fb-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-2708-fe0f",
				"1f469-1f3fb-200d-2708",
				"1f469-1f3fb-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f469-1f3fc-2708": {
		"name": "woman pilot: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 615,
		"display": 1,
		"shortname": ":woman_pilot_tone2:",
		"shortname_alternates": [
			":woman_pilot_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-2708",
			"fully_qualified": "1f469-1f3fc-200d-2708-fe0f",
			"non_fully_qualified": "1f469-1f3fc-200d-2708",
			"output": "1f469-1f3fc-200d-2708-fe0f",
			"default_matches": [
				"1f469-1f3fc-200d-2708-fe0f",
				"1f469-1f3fc-200d-2708",
				"1f469-1f3fc-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-2708-fe0f",
				"1f469-1f3fc-200d-2708",
				"1f469-1f3fc-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f469-1f3fd-2708": {
		"name": "woman pilot: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 616,
		"display": 1,
		"shortname": ":woman_pilot_tone3:",
		"shortname_alternates": [
			":woman_pilot_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-2708",
			"fully_qualified": "1f469-1f3fd-200d-2708-fe0f",
			"non_fully_qualified": "1f469-1f3fd-200d-2708",
			"output": "1f469-1f3fd-200d-2708-fe0f",
			"default_matches": [
				"1f469-1f3fd-200d-2708-fe0f",
				"1f469-1f3fd-200d-2708",
				"1f469-1f3fd-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-2708-fe0f",
				"1f469-1f3fd-200d-2708",
				"1f469-1f3fd-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f469-1f3fe-2708": {
		"name": "woman pilot: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 617,
		"display": 1,
		"shortname": ":woman_pilot_tone4:",
		"shortname_alternates": [
			":woman_pilot_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-2708",
			"fully_qualified": "1f469-1f3fe-200d-2708-fe0f",
			"non_fully_qualified": "1f469-1f3fe-200d-2708",
			"output": "1f469-1f3fe-200d-2708-fe0f",
			"default_matches": [
				"1f469-1f3fe-200d-2708-fe0f",
				"1f469-1f3fe-200d-2708",
				"1f469-1f3fe-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-2708-fe0f",
				"1f469-1f3fe-200d-2708",
				"1f469-1f3fe-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f469-1f3ff-2708": {
		"name": "woman pilot: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 618,
		"display": 1,
		"shortname": ":woman_pilot_tone5:",
		"shortname_alternates": [
			":woman_pilot_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-2708",
			"fully_qualified": "1f469-1f3ff-200d-2708-fe0f",
			"non_fully_qualified": "1f469-1f3ff-200d-2708",
			"output": "1f469-1f3ff-200d-2708-fe0f",
			"default_matches": [
				"1f469-1f3ff-200d-2708-fe0f",
				"1f469-1f3ff-200d-2708",
				"1f469-1f3ff-2708-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-2708-fe0f",
				"1f469-1f3ff-200d-2708",
				"1f469-1f3ff-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"pilot",
			"plane",
			"woman"
		]
	},
	"1f468-2708": {
		"name": "man pilot",
		"unicode_version": 6,
		"category": "people",
		"order": 619,
		"display": 1,
		"shortname": ":man_pilot:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-2708",
			"1f468-1f3fc-2708",
			"1f468-1f3fd-2708",
			"1f468-1f3fe-2708",
			"1f468-1f3ff-2708"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-2708",
			"fully_qualified": "1f468-200d-2708-fe0f",
			"non_fully_qualified": "1f468-200d-2708",
			"output": "1f468-200d-2708-fe0f",
			"default_matches": [
				"1f468-200d-2708-fe0f",
				"1f468-200d-2708",
				"1f468-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-200d-2708-fe0f",
				"1f468-200d-2708",
				"1f468-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"pilot",
			"plane"
		]
	},
	"1f468-1f3fb-2708": {
		"name": "man pilot: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 620,
		"display": 1,
		"shortname": ":man_pilot_tone1:",
		"shortname_alternates": [
			":man_pilot_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-2708",
			"fully_qualified": "1f468-1f3fb-200d-2708-fe0f",
			"non_fully_qualified": "1f468-1f3fb-200d-2708",
			"output": "1f468-1f3fb-200d-2708-fe0f",
			"default_matches": [
				"1f468-1f3fb-200d-2708-fe0f",
				"1f468-1f3fb-200d-2708",
				"1f468-1f3fb-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-2708-fe0f",
				"1f468-1f3fb-200d-2708",
				"1f468-1f3fb-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"pilot",
			"plane"
		]
	},
	"1f468-1f3fc-2708": {
		"name": "man pilot: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 621,
		"display": 1,
		"shortname": ":man_pilot_tone2:",
		"shortname_alternates": [
			":man_pilot_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-2708",
			"fully_qualified": "1f468-1f3fc-200d-2708-fe0f",
			"non_fully_qualified": "1f468-1f3fc-200d-2708",
			"output": "1f468-1f3fc-200d-2708-fe0f",
			"default_matches": [
				"1f468-1f3fc-200d-2708-fe0f",
				"1f468-1f3fc-200d-2708",
				"1f468-1f3fc-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-2708-fe0f",
				"1f468-1f3fc-200d-2708",
				"1f468-1f3fc-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"pilot",
			"plane"
		]
	},
	"1f468-1f3fd-2708": {
		"name": "man pilot: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 622,
		"display": 1,
		"shortname": ":man_pilot_tone3:",
		"shortname_alternates": [
			":man_pilot_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-2708",
			"fully_qualified": "1f468-1f3fd-200d-2708-fe0f",
			"non_fully_qualified": "1f468-1f3fd-200d-2708",
			"output": "1f468-1f3fd-200d-2708-fe0f",
			"default_matches": [
				"1f468-1f3fd-200d-2708-fe0f",
				"1f468-1f3fd-200d-2708",
				"1f468-1f3fd-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-2708-fe0f",
				"1f468-1f3fd-200d-2708",
				"1f468-1f3fd-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"pilot",
			"plane"
		]
	},
	"1f468-1f3fe-2708": {
		"name": "man pilot: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 623,
		"display": 1,
		"shortname": ":man_pilot_tone4:",
		"shortname_alternates": [
			":man_pilot_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-2708",
			"fully_qualified": "1f468-1f3fe-200d-2708-fe0f",
			"non_fully_qualified": "1f468-1f3fe-200d-2708",
			"output": "1f468-1f3fe-200d-2708-fe0f",
			"default_matches": [
				"1f468-1f3fe-200d-2708-fe0f",
				"1f468-1f3fe-200d-2708",
				"1f468-1f3fe-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-2708-fe0f",
				"1f468-1f3fe-200d-2708",
				"1f468-1f3fe-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"pilot",
			"plane"
		]
	},
	"1f468-1f3ff-2708": {
		"name": "man pilot: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 624,
		"display": 1,
		"shortname": ":man_pilot_tone5:",
		"shortname_alternates": [
			":man_pilot_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-2708",
			"fully_qualified": "1f468-1f3ff-200d-2708-fe0f",
			"non_fully_qualified": "1f468-1f3ff-200d-2708",
			"output": "1f468-1f3ff-200d-2708-fe0f",
			"default_matches": [
				"1f468-1f3ff-200d-2708-fe0f",
				"1f468-1f3ff-200d-2708",
				"1f468-1f3ff-2708-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-2708-fe0f",
				"1f468-1f3ff-200d-2708",
				"1f468-1f3ff-2708-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"pilot",
			"plane"
		]
	},
	"1f469-1f680": {
		"name": "woman astronaut",
		"unicode_version": 6,
		"category": "people",
		"order": 625,
		"display": 1,
		"shortname": ":woman_astronaut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-1f680",
			"1f469-1f3fc-1f680",
			"1f469-1f3fd-1f680",
			"1f469-1f3fe-1f680",
			"1f469-1f3ff-1f680"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f680",
			"fully_qualified": "1f469-200d-1f680",
			"non_fully_qualified": "1f469-200d-1f680",
			"output": "1f469-200d-1f680",
			"default_matches": [
				"1f469-200d-1f680",
				"1f469-1f680"
			],
			"greedy_matches": [
				"1f469-200d-1f680",
				"1f469-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"rocket",
			"woman"
		]
	},
	"1f469-1f3fb-1f680": {
		"name": "woman astronaut: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 626,
		"display": 1,
		"shortname": ":woman_astronaut_tone1:",
		"shortname_alternates": [
			":woman_astronaut_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-1f680",
			"fully_qualified": "1f469-1f3fb-200d-1f680",
			"non_fully_qualified": "1f469-1f3fb-200d-1f680",
			"output": "1f469-1f3fb-200d-1f680",
			"default_matches": [
				"1f469-1f3fb-200d-1f680",
				"1f469-1f3fb-1f680"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-1f680",
				"1f469-1f3fb-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"light skin tone",
			"rocket",
			"woman"
		]
	},
	"1f469-1f3fc-1f680": {
		"name": "woman astronaut: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 627,
		"display": 1,
		"shortname": ":woman_astronaut_tone2:",
		"shortname_alternates": [
			":woman_astronaut_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-1f680",
			"fully_qualified": "1f469-1f3fc-200d-1f680",
			"non_fully_qualified": "1f469-1f3fc-200d-1f680",
			"output": "1f469-1f3fc-200d-1f680",
			"default_matches": [
				"1f469-1f3fc-200d-1f680",
				"1f469-1f3fc-1f680"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-1f680",
				"1f469-1f3fc-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"medium-light skin tone",
			"rocket",
			"woman"
		]
	},
	"1f469-1f3fd-1f680": {
		"name": "woman astronaut: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 628,
		"display": 1,
		"shortname": ":woman_astronaut_tone3:",
		"shortname_alternates": [
			":woman_astronaut_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-1f680",
			"fully_qualified": "1f469-1f3fd-200d-1f680",
			"non_fully_qualified": "1f469-1f3fd-200d-1f680",
			"output": "1f469-1f3fd-200d-1f680",
			"default_matches": [
				"1f469-1f3fd-200d-1f680",
				"1f469-1f3fd-1f680"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-1f680",
				"1f469-1f3fd-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"medium skin tone",
			"rocket",
			"woman"
		]
	},
	"1f469-1f3fe-1f680": {
		"name": "woman astronaut: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 629,
		"display": 1,
		"shortname": ":woman_astronaut_tone4:",
		"shortname_alternates": [
			":woman_astronaut_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-1f680",
			"fully_qualified": "1f469-1f3fe-200d-1f680",
			"non_fully_qualified": "1f469-1f3fe-200d-1f680",
			"output": "1f469-1f3fe-200d-1f680",
			"default_matches": [
				"1f469-1f3fe-200d-1f680",
				"1f469-1f3fe-1f680"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-1f680",
				"1f469-1f3fe-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"medium-dark skin tone",
			"rocket",
			"woman"
		]
	},
	"1f469-1f3ff-1f680": {
		"name": "woman astronaut: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 630,
		"display": 1,
		"shortname": ":woman_astronaut_tone5:",
		"shortname_alternates": [
			":woman_astronaut_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-1f680",
			"fully_qualified": "1f469-1f3ff-200d-1f680",
			"non_fully_qualified": "1f469-1f3ff-200d-1f680",
			"output": "1f469-1f3ff-200d-1f680",
			"default_matches": [
				"1f469-1f3ff-200d-1f680",
				"1f469-1f3ff-1f680"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-1f680",
				"1f469-1f3ff-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"dark skin tone",
			"rocket",
			"woman"
		]
	},
	"1f468-1f680": {
		"name": "man astronaut",
		"unicode_version": 6,
		"category": "people",
		"order": 631,
		"display": 1,
		"shortname": ":man_astronaut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-1f680",
			"1f468-1f3fc-1f680",
			"1f468-1f3fd-1f680",
			"1f468-1f3fe-1f680",
			"1f468-1f3ff-1f680"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f680",
			"fully_qualified": "1f468-200d-1f680",
			"non_fully_qualified": "1f468-200d-1f680",
			"output": "1f468-200d-1f680",
			"default_matches": [
				"1f468-200d-1f680",
				"1f468-1f680"
			],
			"greedy_matches": [
				"1f468-200d-1f680",
				"1f468-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"man",
			"rocket"
		]
	},
	"1f468-1f3fb-1f680": {
		"name": "man astronaut: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 632,
		"display": 1,
		"shortname": ":man_astronaut_tone1:",
		"shortname_alternates": [
			":man_astronaut_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-1f680",
			"fully_qualified": "1f468-1f3fb-200d-1f680",
			"non_fully_qualified": "1f468-1f3fb-200d-1f680",
			"output": "1f468-1f3fb-200d-1f680",
			"default_matches": [
				"1f468-1f3fb-200d-1f680",
				"1f468-1f3fb-1f680"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-1f680",
				"1f468-1f3fb-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"light skin tone",
			"man",
			"rocket"
		]
	},
	"1f468-1f3fc-1f680": {
		"name": "man astronaut: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 633,
		"display": 1,
		"shortname": ":man_astronaut_tone2:",
		"shortname_alternates": [
			":man_astronaut_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-1f680",
			"fully_qualified": "1f468-1f3fc-200d-1f680",
			"non_fully_qualified": "1f468-1f3fc-200d-1f680",
			"output": "1f468-1f3fc-200d-1f680",
			"default_matches": [
				"1f468-1f3fc-200d-1f680",
				"1f468-1f3fc-1f680"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-1f680",
				"1f468-1f3fc-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"man",
			"medium-light skin tone",
			"rocket"
		]
	},
	"1f468-1f3fd-1f680": {
		"name": "man astronaut: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 634,
		"display": 1,
		"shortname": ":man_astronaut_tone3:",
		"shortname_alternates": [
			":man_astronaut_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-1f680",
			"fully_qualified": "1f468-1f3fd-200d-1f680",
			"non_fully_qualified": "1f468-1f3fd-200d-1f680",
			"output": "1f468-1f3fd-200d-1f680",
			"default_matches": [
				"1f468-1f3fd-200d-1f680",
				"1f468-1f3fd-1f680"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-1f680",
				"1f468-1f3fd-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"man",
			"medium skin tone",
			"rocket"
		]
	},
	"1f468-1f3fe-1f680": {
		"name": "man astronaut: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 635,
		"display": 1,
		"shortname": ":man_astronaut_tone4:",
		"shortname_alternates": [
			":man_astronaut_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-1f680",
			"fully_qualified": "1f468-1f3fe-200d-1f680",
			"non_fully_qualified": "1f468-1f3fe-200d-1f680",
			"output": "1f468-1f3fe-200d-1f680",
			"default_matches": [
				"1f468-1f3fe-200d-1f680",
				"1f468-1f3fe-1f680"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-1f680",
				"1f468-1f3fe-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"man",
			"medium-dark skin tone",
			"rocket"
		]
	},
	"1f468-1f3ff-1f680": {
		"name": "man astronaut: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 636,
		"display": 1,
		"shortname": ":man_astronaut_tone5:",
		"shortname_alternates": [
			":man_astronaut_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-1f680",
			"fully_qualified": "1f468-1f3ff-200d-1f680",
			"non_fully_qualified": "1f468-1f3ff-200d-1f680",
			"output": "1f468-1f3ff-200d-1f680",
			"default_matches": [
				"1f468-1f3ff-200d-1f680",
				"1f468-1f3ff-1f680"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-1f680",
				"1f468-1f3ff-1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"astronaut",
			"dark skin tone",
			"man",
			"rocket"
		]
	},
	"1f469-2696": {
		"name": "woman judge",
		"unicode_version": 6,
		"category": "people",
		"order": 637,
		"display": 1,
		"shortname": ":woman_judge:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f469-1f3fb-2696",
			"1f469-1f3fc-2696",
			"1f469-1f3fd-2696",
			"1f469-1f3fe-2696",
			"1f469-1f3ff-2696"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2696",
			"fully_qualified": "1f469-200d-2696-fe0f",
			"non_fully_qualified": "1f469-200d-2696",
			"output": "1f469-200d-2696-fe0f",
			"default_matches": [
				"1f469-200d-2696-fe0f",
				"1f469-200d-2696",
				"1f469-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-200d-2696-fe0f",
				"1f469-200d-2696",
				"1f469-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"judge",
			"scales",
			"woman"
		]
	},
	"1f469-1f3fb-2696": {
		"name": "woman judge: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 638,
		"display": 1,
		"shortname": ":woman_judge_tone1:",
		"shortname_alternates": [
			":woman_judge_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fb-2696",
			"fully_qualified": "1f469-1f3fb-200d-2696-fe0f",
			"non_fully_qualified": "1f469-1f3fb-200d-2696",
			"output": "1f469-1f3fb-200d-2696-fe0f",
			"default_matches": [
				"1f469-1f3fb-200d-2696-fe0f",
				"1f469-1f3fb-200d-2696",
				"1f469-1f3fb-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fb-200d-2696-fe0f",
				"1f469-1f3fb-200d-2696",
				"1f469-1f3fb-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"judge",
			"light skin tone",
			"scales",
			"woman"
		]
	},
	"1f469-1f3fc-2696": {
		"name": "woman judge: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 639,
		"display": 1,
		"shortname": ":woman_judge_tone2:",
		"shortname_alternates": [
			":woman_judge_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fc-2696",
			"fully_qualified": "1f469-1f3fc-200d-2696-fe0f",
			"non_fully_qualified": "1f469-1f3fc-200d-2696",
			"output": "1f469-1f3fc-200d-2696-fe0f",
			"default_matches": [
				"1f469-1f3fc-200d-2696-fe0f",
				"1f469-1f3fc-200d-2696",
				"1f469-1f3fc-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fc-200d-2696-fe0f",
				"1f469-1f3fc-200d-2696",
				"1f469-1f3fc-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"judge",
			"medium-light skin tone",
			"scales",
			"woman"
		]
	},
	"1f469-1f3fd-2696": {
		"name": "woman judge: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 640,
		"display": 1,
		"shortname": ":woman_judge_tone3:",
		"shortname_alternates": [
			":woman_judge_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fd-2696",
			"fully_qualified": "1f469-1f3fd-200d-2696-fe0f",
			"non_fully_qualified": "1f469-1f3fd-200d-2696",
			"output": "1f469-1f3fd-200d-2696-fe0f",
			"default_matches": [
				"1f469-1f3fd-200d-2696-fe0f",
				"1f469-1f3fd-200d-2696",
				"1f469-1f3fd-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fd-200d-2696-fe0f",
				"1f469-1f3fd-200d-2696",
				"1f469-1f3fd-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"judge",
			"medium skin tone",
			"scales",
			"woman"
		]
	},
	"1f469-1f3fe-2696": {
		"name": "woman judge: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 641,
		"display": 1,
		"shortname": ":woman_judge_tone4:",
		"shortname_alternates": [
			":woman_judge_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3fe-2696",
			"fully_qualified": "1f469-1f3fe-200d-2696-fe0f",
			"non_fully_qualified": "1f469-1f3fe-200d-2696",
			"output": "1f469-1f3fe-200d-2696-fe0f",
			"default_matches": [
				"1f469-1f3fe-200d-2696-fe0f",
				"1f469-1f3fe-200d-2696",
				"1f469-1f3fe-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3fe-200d-2696-fe0f",
				"1f469-1f3fe-200d-2696",
				"1f469-1f3fe-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"judge",
			"medium-dark skin tone",
			"scales",
			"woman"
		]
	},
	"1f469-1f3ff-2696": {
		"name": "woman judge: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 642,
		"display": 1,
		"shortname": ":woman_judge_tone5:",
		"shortname_alternates": [
			":woman_judge_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f3ff-2696",
			"fully_qualified": "1f469-1f3ff-200d-2696-fe0f",
			"non_fully_qualified": "1f469-1f3ff-200d-2696",
			"output": "1f469-1f3ff-200d-2696-fe0f",
			"default_matches": [
				"1f469-1f3ff-200d-2696-fe0f",
				"1f469-1f3ff-200d-2696",
				"1f469-1f3ff-2696-fe0f"
			],
			"greedy_matches": [
				"1f469-1f3ff-200d-2696-fe0f",
				"1f469-1f3ff-200d-2696",
				"1f469-1f3ff-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"judge",
			"scales",
			"woman"
		]
	},
	"1f468-2696": {
		"name": "man judge",
		"unicode_version": 6,
		"category": "people",
		"order": 643,
		"display": 1,
		"shortname": ":man_judge:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f468-1f3fb-2696",
			"1f468-1f3fc-2696",
			"1f468-1f3fd-2696",
			"1f468-1f3fe-2696",
			"1f468-1f3ff-2696"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-2696",
			"fully_qualified": "1f468-200d-2696-fe0f",
			"non_fully_qualified": "1f468-200d-2696",
			"output": "1f468-200d-2696-fe0f",
			"default_matches": [
				"1f468-200d-2696-fe0f",
				"1f468-200d-2696",
				"1f468-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-200d-2696-fe0f",
				"1f468-200d-2696",
				"1f468-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"justice",
			"man",
			"scales"
		]
	},
	"1f468-1f3fb-2696": {
		"name": "man judge: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 644,
		"display": 1,
		"shortname": ":man_judge_tone1:",
		"shortname_alternates": [
			":man_judge_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fb-2696",
			"fully_qualified": "1f468-1f3fb-200d-2696-fe0f",
			"non_fully_qualified": "1f468-1f3fb-200d-2696",
			"output": "1f468-1f3fb-200d-2696-fe0f",
			"default_matches": [
				"1f468-1f3fb-200d-2696-fe0f",
				"1f468-1f3fb-200d-2696",
				"1f468-1f3fb-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fb-200d-2696-fe0f",
				"1f468-1f3fb-200d-2696",
				"1f468-1f3fb-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"justice",
			"light skin tone",
			"man",
			"scales"
		]
	},
	"1f468-1f3fc-2696": {
		"name": "man judge: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 645,
		"display": 1,
		"shortname": ":man_judge_tone2:",
		"shortname_alternates": [
			":man_judge_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fc-2696",
			"fully_qualified": "1f468-1f3fc-200d-2696-fe0f",
			"non_fully_qualified": "1f468-1f3fc-200d-2696",
			"output": "1f468-1f3fc-200d-2696-fe0f",
			"default_matches": [
				"1f468-1f3fc-200d-2696-fe0f",
				"1f468-1f3fc-200d-2696",
				"1f468-1f3fc-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fc-200d-2696-fe0f",
				"1f468-1f3fc-200d-2696",
				"1f468-1f3fc-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"justice",
			"man",
			"medium-light skin tone",
			"scales"
		]
	},
	"1f468-1f3fd-2696": {
		"name": "man judge: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 646,
		"display": 1,
		"shortname": ":man_judge_tone3:",
		"shortname_alternates": [
			":man_judge_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fd-2696",
			"fully_qualified": "1f468-1f3fd-200d-2696-fe0f",
			"non_fully_qualified": "1f468-1f3fd-200d-2696",
			"output": "1f468-1f3fd-200d-2696-fe0f",
			"default_matches": [
				"1f468-1f3fd-200d-2696-fe0f",
				"1f468-1f3fd-200d-2696",
				"1f468-1f3fd-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fd-200d-2696-fe0f",
				"1f468-1f3fd-200d-2696",
				"1f468-1f3fd-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"justice",
			"man",
			"medium skin tone",
			"scales"
		]
	},
	"1f468-1f3fe-2696": {
		"name": "man judge: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 647,
		"display": 1,
		"shortname": ":man_judge_tone4:",
		"shortname_alternates": [
			":man_judge_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3fe-2696",
			"fully_qualified": "1f468-1f3fe-200d-2696-fe0f",
			"non_fully_qualified": "1f468-1f3fe-200d-2696",
			"output": "1f468-1f3fe-200d-2696-fe0f",
			"default_matches": [
				"1f468-1f3fe-200d-2696-fe0f",
				"1f468-1f3fe-200d-2696",
				"1f468-1f3fe-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3fe-200d-2696-fe0f",
				"1f468-1f3fe-200d-2696",
				"1f468-1f3fe-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"justice",
			"man",
			"medium-dark skin tone",
			"scales"
		]
	},
	"1f468-1f3ff-2696": {
		"name": "man judge: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 648,
		"display": 1,
		"shortname": ":man_judge_tone5:",
		"shortname_alternates": [
			":man_judge_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f3ff-2696",
			"fully_qualified": "1f468-1f3ff-200d-2696-fe0f",
			"non_fully_qualified": "1f468-1f3ff-200d-2696",
			"output": "1f468-1f3ff-200d-2696-fe0f",
			"default_matches": [
				"1f468-1f3ff-200d-2696-fe0f",
				"1f468-1f3ff-200d-2696",
				"1f468-1f3ff-2696-fe0f"
			],
			"greedy_matches": [
				"1f468-1f3ff-200d-2696-fe0f",
				"1f468-1f3ff-200d-2696",
				"1f468-1f3ff-2696-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"justice",
			"man",
			"scales"
		]
	},
	"1f936": {
		"name": "Mrs. Claus",
		"unicode_version": 9,
		"category": "people",
		"order": 649,
		"display": 1,
		"shortname": ":mrs_claus:",
		"shortname_alternates": [
			":mother_christmas:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f936-1f3fb",
			"1f936-1f3fc",
			"1f936-1f3fd",
			"1f936-1f3fe",
			"1f936-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936",
			"fully_qualified": "1f936",
			"non_fully_qualified": "1f936",
			"output": "1f936",
			"default_matches": [
				"1f936"
			],
			"greedy_matches": [
				"1f936"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"mother"
		]
	},
	"1f936-1f3fb": {
		"name": "Mrs. Claus: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 650,
		"display": 1,
		"shortname": ":mrs_claus_tone1:",
		"shortname_alternates": [
			":mother_christmas_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936-1f3fb",
			"fully_qualified": "1f936-1f3fb",
			"non_fully_qualified": "1f936-1f3fb",
			"output": "1f936-1f3fb",
			"default_matches": [
				"1f936-1f3fb"
			],
			"greedy_matches": [
				"1f936-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"light skin tone",
			"mother"
		]
	},
	"1f936-1f3fc": {
		"name": "Mrs. Claus: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 651,
		"display": 1,
		"shortname": ":mrs_claus_tone2:",
		"shortname_alternates": [
			":mother_christmas_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936-1f3fc",
			"fully_qualified": "1f936-1f3fc",
			"non_fully_qualified": "1f936-1f3fc",
			"output": "1f936-1f3fc",
			"default_matches": [
				"1f936-1f3fc"
			],
			"greedy_matches": [
				"1f936-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"medium-light skin tone",
			"mother"
		]
	},
	"1f936-1f3fd": {
		"name": "Mrs. Claus: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 652,
		"display": 1,
		"shortname": ":mrs_claus_tone3:",
		"shortname_alternates": [
			":mother_christmas_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936-1f3fd",
			"fully_qualified": "1f936-1f3fd",
			"non_fully_qualified": "1f936-1f3fd",
			"output": "1f936-1f3fd",
			"default_matches": [
				"1f936-1f3fd"
			],
			"greedy_matches": [
				"1f936-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"medium skin tone",
			"mother"
		]
	},
	"1f936-1f3fe": {
		"name": "Mrs. Claus: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 653,
		"display": 1,
		"shortname": ":mrs_claus_tone4:",
		"shortname_alternates": [
			":mother_christmas_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936-1f3fe",
			"fully_qualified": "1f936-1f3fe",
			"non_fully_qualified": "1f936-1f3fe",
			"output": "1f936-1f3fe",
			"default_matches": [
				"1f936-1f3fe"
			],
			"greedy_matches": [
				"1f936-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"medium-dark skin tone",
			"mother"
		]
	},
	"1f936-1f3ff": {
		"name": "Mrs. Claus: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 654,
		"display": 1,
		"shortname": ":mrs_claus_tone5:",
		"shortname_alternates": [
			":mother_christmas_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f936-1f3ff",
			"fully_qualified": "1f936-1f3ff",
			"non_fully_qualified": "1f936-1f3ff",
			"output": "1f936-1f3ff",
			"default_matches": [
				"1f936-1f3ff"
			],
			"greedy_matches": [
				"1f936-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"Mrs.",
			"celebration",
			"claus",
			"dark skin tone",
			"mother"
		]
	},
	"1f385": {
		"name": "Santa Claus",
		"unicode_version": 6,
		"category": "people",
		"order": 655,
		"display": 1,
		"shortname": ":santa:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f385-1f3fb",
			"1f385-1f3fc",
			"1f385-1f3fd",
			"1f385-1f3fe",
			"1f385-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385",
			"fully_qualified": "1f385",
			"non_fully_qualified": "1f385",
			"output": "1f385",
			"default_matches": [
				"1f385"
			],
			"greedy_matches": [
				"1f385"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"father",
			"santa"
		]
	},
	"1f385-1f3fb": {
		"name": "Santa Claus: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 656,
		"display": 1,
		"shortname": ":santa_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385-1f3fb",
			"fully_qualified": "1f385-1f3fb",
			"non_fully_qualified": "1f385-1f3fb",
			"output": "1f385-1f3fb",
			"default_matches": [
				"1f385-1f3fb"
			],
			"greedy_matches": [
				"1f385-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"father",
			"light skin tone",
			"santa"
		]
	},
	"1f385-1f3fc": {
		"name": "Santa Claus: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 657,
		"display": 1,
		"shortname": ":santa_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385-1f3fc",
			"fully_qualified": "1f385-1f3fc",
			"non_fully_qualified": "1f385-1f3fc",
			"output": "1f385-1f3fc",
			"default_matches": [
				"1f385-1f3fc"
			],
			"greedy_matches": [
				"1f385-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"father",
			"medium-light skin tone",
			"santa"
		]
	},
	"1f385-1f3fd": {
		"name": "Santa Claus: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 658,
		"display": 1,
		"shortname": ":santa_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385-1f3fd",
			"fully_qualified": "1f385-1f3fd",
			"non_fully_qualified": "1f385-1f3fd",
			"output": "1f385-1f3fd",
			"default_matches": [
				"1f385-1f3fd"
			],
			"greedy_matches": [
				"1f385-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"father",
			"medium skin tone",
			"santa"
		]
	},
	"1f385-1f3fe": {
		"name": "Santa Claus: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 659,
		"display": 1,
		"shortname": ":santa_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385-1f3fe",
			"fully_qualified": "1f385-1f3fe",
			"non_fully_qualified": "1f385-1f3fe",
			"output": "1f385-1f3fe",
			"default_matches": [
				"1f385-1f3fe"
			],
			"greedy_matches": [
				"1f385-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"father",
			"medium-dark skin tone",
			"santa"
		]
	},
	"1f385-1f3ff": {
		"name": "Santa Claus: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 660,
		"display": 1,
		"shortname": ":santa_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f385-1f3ff",
			"fully_qualified": "1f385-1f3ff",
			"non_fully_qualified": "1f385-1f3ff",
			"output": "1f385-1f3ff",
			"default_matches": [
				"1f385-1f3ff"
			],
			"greedy_matches": [
				"1f385-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"claus",
			"dark skin tone",
			"father",
			"santa"
		]
	},
	"1f478": {
		"name": "princess",
		"unicode_version": 6,
		"category": "people",
		"order": 661,
		"display": 1,
		"shortname": ":princess:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f478-1f3fb",
			"1f478-1f3fc",
			"1f478-1f3fd",
			"1f478-1f3fe",
			"1f478-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478",
			"fully_qualified": "1f478",
			"non_fully_qualified": "1f478",
			"output": "1f478",
			"default_matches": [
				"1f478"
			],
			"greedy_matches": [
				"1f478"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale",
			"fantasy"
		]
	},
	"1f478-1f3fb": {
		"name": "princess: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 662,
		"display": 1,
		"shortname": ":princess_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478-1f3fb",
			"fully_qualified": "1f478-1f3fb",
			"non_fully_qualified": "1f478-1f3fb",
			"output": "1f478-1f3fb",
			"default_matches": [
				"1f478-1f3fb"
			],
			"greedy_matches": [
				"1f478-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale",
			"fantasy",
			"light skin tone"
		]
	},
	"1f478-1f3fc": {
		"name": "princess: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 663,
		"display": 1,
		"shortname": ":princess_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478-1f3fc",
			"fully_qualified": "1f478-1f3fc",
			"non_fully_qualified": "1f478-1f3fc",
			"output": "1f478-1f3fc",
			"default_matches": [
				"1f478-1f3fc"
			],
			"greedy_matches": [
				"1f478-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale",
			"fantasy",
			"medium-light skin tone"
		]
	},
	"1f478-1f3fd": {
		"name": "princess: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 664,
		"display": 1,
		"shortname": ":princess_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478-1f3fd",
			"fully_qualified": "1f478-1f3fd",
			"non_fully_qualified": "1f478-1f3fd",
			"output": "1f478-1f3fd",
			"default_matches": [
				"1f478-1f3fd"
			],
			"greedy_matches": [
				"1f478-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale",
			"fantasy",
			"medium skin tone"
		]
	},
	"1f478-1f3fe": {
		"name": "princess: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 665,
		"display": 1,
		"shortname": ":princess_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478-1f3fe",
			"fully_qualified": "1f478-1f3fe",
			"non_fully_qualified": "1f478-1f3fe",
			"output": "1f478-1f3fe",
			"default_matches": [
				"1f478-1f3fe"
			],
			"greedy_matches": [
				"1f478-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale",
			"fantasy",
			"medium-dark skin tone"
		]
	},
	"1f478-1f3ff": {
		"name": "princess: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 666,
		"display": 1,
		"shortname": ":princess_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f478-1f3ff",
			"fully_qualified": "1f478-1f3ff",
			"non_fully_qualified": "1f478-1f3ff",
			"output": "1f478-1f3ff",
			"default_matches": [
				"1f478-1f3ff"
			],
			"greedy_matches": [
				"1f478-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"fairy tale",
			"fantasy"
		]
	},
	"1f934": {
		"name": "prince",
		"unicode_version": 9,
		"category": "people",
		"order": 667,
		"display": 1,
		"shortname": ":prince:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f934-1f3fb",
			"1f934-1f3fc",
			"1f934-1f3fd",
			"1f934-1f3fe",
			"1f934-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934",
			"fully_qualified": "1f934",
			"non_fully_qualified": "1f934",
			"output": "1f934",
			"default_matches": [
				"1f934"
			],
			"greedy_matches": [
				"1f934"
			],
			"decimal": ""
		},
		"keywords": [
			"prince"
		]
	},
	"1f934-1f3fb": {
		"name": "prince: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 668,
		"display": 1,
		"shortname": ":prince_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934-1f3fb",
			"fully_qualified": "1f934-1f3fb",
			"non_fully_qualified": "1f934-1f3fb",
			"output": "1f934-1f3fb",
			"default_matches": [
				"1f934-1f3fb"
			],
			"greedy_matches": [
				"1f934-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"prince"
		]
	},
	"1f934-1f3fc": {
		"name": "prince: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 669,
		"display": 1,
		"shortname": ":prince_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934-1f3fc",
			"fully_qualified": "1f934-1f3fc",
			"non_fully_qualified": "1f934-1f3fc",
			"output": "1f934-1f3fc",
			"default_matches": [
				"1f934-1f3fc"
			],
			"greedy_matches": [
				"1f934-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"prince"
		]
	},
	"1f934-1f3fd": {
		"name": "prince: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 670,
		"display": 1,
		"shortname": ":prince_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934-1f3fd",
			"fully_qualified": "1f934-1f3fd",
			"non_fully_qualified": "1f934-1f3fd",
			"output": "1f934-1f3fd",
			"default_matches": [
				"1f934-1f3fd"
			],
			"greedy_matches": [
				"1f934-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"prince"
		]
	},
	"1f934-1f3fe": {
		"name": "prince: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 671,
		"display": 1,
		"shortname": ":prince_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934-1f3fe",
			"fully_qualified": "1f934-1f3fe",
			"non_fully_qualified": "1f934-1f3fe",
			"output": "1f934-1f3fe",
			"default_matches": [
				"1f934-1f3fe"
			],
			"greedy_matches": [
				"1f934-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"prince"
		]
	},
	"1f934-1f3ff": {
		"name": "prince: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 672,
		"display": 1,
		"shortname": ":prince_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f934-1f3ff",
			"fully_qualified": "1f934-1f3ff",
			"non_fully_qualified": "1f934-1f3ff",
			"output": "1f934-1f3ff",
			"default_matches": [
				"1f934-1f3ff"
			],
			"greedy_matches": [
				"1f934-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"prince"
		]
	},
	"1f470": {
		"name": "bride with veil",
		"unicode_version": 6,
		"category": "people",
		"order": 673,
		"display": 1,
		"shortname": ":bride_with_veil:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f470-1f3fb",
			"1f470-1f3fc",
			"1f470-1f3fd",
			"1f470-1f3fe",
			"1f470-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470",
			"fully_qualified": "1f470",
			"non_fully_qualified": "1f470",
			"output": "1f470",
			"default_matches": [
				"1f470"
			],
			"greedy_matches": [
				"1f470"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"veil",
			"wedding"
		]
	},
	"1f470-1f3fb": {
		"name": "bride with veil: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 674,
		"display": 1,
		"shortname": ":bride_with_veil_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470-1f3fb",
			"fully_qualified": "1f470-1f3fb",
			"non_fully_qualified": "1f470-1f3fb",
			"output": "1f470-1f3fb",
			"default_matches": [
				"1f470-1f3fb"
			],
			"greedy_matches": [
				"1f470-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"light skin tone",
			"veil",
			"wedding"
		]
	},
	"1f470-1f3fc": {
		"name": "bride with veil: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 675,
		"display": 1,
		"shortname": ":bride_with_veil_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470-1f3fc",
			"fully_qualified": "1f470-1f3fc",
			"non_fully_qualified": "1f470-1f3fc",
			"output": "1f470-1f3fc",
			"default_matches": [
				"1f470-1f3fc"
			],
			"greedy_matches": [
				"1f470-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"medium-light skin tone",
			"veil",
			"wedding"
		]
	},
	"1f470-1f3fd": {
		"name": "bride with veil: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 676,
		"display": 1,
		"shortname": ":bride_with_veil_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470-1f3fd",
			"fully_qualified": "1f470-1f3fd",
			"non_fully_qualified": "1f470-1f3fd",
			"output": "1f470-1f3fd",
			"default_matches": [
				"1f470-1f3fd"
			],
			"greedy_matches": [
				"1f470-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"medium skin tone",
			"veil",
			"wedding"
		]
	},
	"1f470-1f3fe": {
		"name": "bride with veil: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 677,
		"display": 1,
		"shortname": ":bride_with_veil_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470-1f3fe",
			"fully_qualified": "1f470-1f3fe",
			"non_fully_qualified": "1f470-1f3fe",
			"output": "1f470-1f3fe",
			"default_matches": [
				"1f470-1f3fe"
			],
			"greedy_matches": [
				"1f470-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"medium-dark skin tone",
			"veil",
			"wedding"
		]
	},
	"1f470-1f3ff": {
		"name": "bride with veil: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 678,
		"display": 1,
		"shortname": ":bride_with_veil_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f470-1f3ff",
			"fully_qualified": "1f470-1f3ff",
			"non_fully_qualified": "1f470-1f3ff",
			"output": "1f470-1f3ff",
			"default_matches": [
				"1f470-1f3ff"
			],
			"greedy_matches": [
				"1f470-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"bride",
			"dark skin tone",
			"veil",
			"wedding"
		]
	},
	"1f935": {
		"name": "man in tuxedo",
		"unicode_version": 9,
		"category": "people",
		"order": 679,
		"display": 1,
		"shortname": ":man_in_tuxedo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f935-1f3fb",
			"1f935-1f3fc",
			"1f935-1f3fd",
			"1f935-1f3fe",
			"1f935-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935",
			"fully_qualified": "1f935",
			"non_fully_qualified": "1f935",
			"output": "1f935",
			"default_matches": [
				"1f935"
			],
			"greedy_matches": [
				"1f935"
			],
			"decimal": ""
		},
		"keywords": [
			"groom",
			"man",
			"tuxedo"
		]
	},
	"1f935-1f3fb": {
		"name": "man in tuxedo: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 680,
		"display": 1,
		"shortname": ":man_in_tuxedo_tone1:",
		"shortname_alternates": [
			":tuxedo_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935-1f3fb",
			"fully_qualified": "1f935-1f3fb",
			"non_fully_qualified": "1f935-1f3fb",
			"output": "1f935-1f3fb",
			"default_matches": [
				"1f935-1f3fb"
			],
			"greedy_matches": [
				"1f935-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"groom",
			"light skin tone",
			"man",
			"tuxedo"
		]
	},
	"1f935-1f3fc": {
		"name": "man in tuxedo: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 681,
		"display": 1,
		"shortname": ":man_in_tuxedo_tone2:",
		"shortname_alternates": [
			":tuxedo_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935-1f3fc",
			"fully_qualified": "1f935-1f3fc",
			"non_fully_qualified": "1f935-1f3fc",
			"output": "1f935-1f3fc",
			"default_matches": [
				"1f935-1f3fc"
			],
			"greedy_matches": [
				"1f935-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"groom",
			"man",
			"medium-light skin tone",
			"tuxedo"
		]
	},
	"1f935-1f3fd": {
		"name": "man in tuxedo: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 682,
		"display": 1,
		"shortname": ":man_in_tuxedo_tone3:",
		"shortname_alternates": [
			":tuxedo_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935-1f3fd",
			"fully_qualified": "1f935-1f3fd",
			"non_fully_qualified": "1f935-1f3fd",
			"output": "1f935-1f3fd",
			"default_matches": [
				"1f935-1f3fd"
			],
			"greedy_matches": [
				"1f935-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"groom",
			"man",
			"medium skin tone",
			"tuxedo"
		]
	},
	"1f935-1f3fe": {
		"name": "man in tuxedo: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 683,
		"display": 1,
		"shortname": ":man_in_tuxedo_tone4:",
		"shortname_alternates": [
			":tuxedo_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935-1f3fe",
			"fully_qualified": "1f935-1f3fe",
			"non_fully_qualified": "1f935-1f3fe",
			"output": "1f935-1f3fe",
			"default_matches": [
				"1f935-1f3fe"
			],
			"greedy_matches": [
				"1f935-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"groom",
			"man",
			"medium-dark skin tone",
			"tuxedo"
		]
	},
	"1f935-1f3ff": {
		"name": "man in tuxedo: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 684,
		"display": 1,
		"shortname": ":man_in_tuxedo_tone5:",
		"shortname_alternates": [
			":tuxedo_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f935-1f3ff",
			"fully_qualified": "1f935-1f3ff",
			"non_fully_qualified": "1f935-1f3ff",
			"output": "1f935-1f3ff",
			"default_matches": [
				"1f935-1f3ff"
			],
			"greedy_matches": [
				"1f935-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"groom",
			"man",
			"tuxedo"
		]
	},
	"1f47c": {
		"name": "baby angel",
		"unicode_version": 6,
		"category": "people",
		"order": 685,
		"display": 1,
		"shortname": ":angel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f47c-1f3fb",
			"1f47c-1f3fc",
			"1f47c-1f3fd",
			"1f47c-1f3fe",
			"1f47c-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c",
			"fully_qualified": "1f47c",
			"non_fully_qualified": "1f47c",
			"output": "1f47c",
			"default_matches": [
				"1f47c"
			],
			"greedy_matches": [
				"1f47c"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"face",
			"fairy tale",
			"fantasy"
		]
	},
	"1f47c-1f3fb": {
		"name": "baby angel: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 686,
		"display": 1,
		"shortname": ":angel_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c-1f3fb",
			"fully_qualified": "1f47c-1f3fb",
			"non_fully_qualified": "1f47c-1f3fb",
			"output": "1f47c-1f3fb",
			"default_matches": [
				"1f47c-1f3fb"
			],
			"greedy_matches": [
				"1f47c-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"face",
			"fairy tale",
			"fantasy",
			"light skin tone"
		]
	},
	"1f47c-1f3fc": {
		"name": "baby angel: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 687,
		"display": 1,
		"shortname": ":angel_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c-1f3fc",
			"fully_qualified": "1f47c-1f3fc",
			"non_fully_qualified": "1f47c-1f3fc",
			"output": "1f47c-1f3fc",
			"default_matches": [
				"1f47c-1f3fc"
			],
			"greedy_matches": [
				"1f47c-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"face",
			"fairy tale",
			"fantasy",
			"medium-light skin tone"
		]
	},
	"1f47c-1f3fd": {
		"name": "baby angel: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 688,
		"display": 1,
		"shortname": ":angel_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c-1f3fd",
			"fully_qualified": "1f47c-1f3fd",
			"non_fully_qualified": "1f47c-1f3fd",
			"output": "1f47c-1f3fd",
			"default_matches": [
				"1f47c-1f3fd"
			],
			"greedy_matches": [
				"1f47c-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"face",
			"fairy tale",
			"fantasy",
			"medium skin tone"
		]
	},
	"1f47c-1f3fe": {
		"name": "baby angel: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 689,
		"display": 1,
		"shortname": ":angel_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c-1f3fe",
			"fully_qualified": "1f47c-1f3fe",
			"non_fully_qualified": "1f47c-1f3fe",
			"output": "1f47c-1f3fe",
			"default_matches": [
				"1f47c-1f3fe"
			],
			"greedy_matches": [
				"1f47c-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"face",
			"fairy tale",
			"fantasy",
			"medium-dark skin tone"
		]
	},
	"1f47c-1f3ff": {
		"name": "baby angel: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 690,
		"display": 1,
		"shortname": ":angel_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f47c-1f3ff",
			"fully_qualified": "1f47c-1f3ff",
			"non_fully_qualified": "1f47c-1f3ff",
			"output": "1f47c-1f3ff",
			"default_matches": [
				"1f47c-1f3ff"
			],
			"greedy_matches": [
				"1f47c-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"angel",
			"baby",
			"dark skin tone",
			"face",
			"fairy tale",
			"fantasy"
		]
	},
	"1f930": {
		"name": "pregnant woman",
		"unicode_version": 9,
		"category": "people",
		"order": 691,
		"display": 1,
		"shortname": ":pregnant_woman:",
		"shortname_alternates": [
			":expecting_woman:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f930-1f3fb",
			"1f930-1f3fc",
			"1f930-1f3fd",
			"1f930-1f3fe",
			"1f930-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930",
			"fully_qualified": "1f930",
			"non_fully_qualified": "1f930",
			"output": "1f930",
			"default_matches": [
				"1f930"
			],
			"greedy_matches": [
				"1f930"
			],
			"decimal": ""
		},
		"keywords": [
			"pregnant",
			"woman"
		]
	},
	"1f930-1f3fb": {
		"name": "pregnant woman: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 692,
		"display": 1,
		"shortname": ":pregnant_woman_tone1:",
		"shortname_alternates": [
			":expecting_woman_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930-1f3fb",
			"fully_qualified": "1f930-1f3fb",
			"non_fully_qualified": "1f930-1f3fb",
			"output": "1f930-1f3fb",
			"default_matches": [
				"1f930-1f3fb"
			],
			"greedy_matches": [
				"1f930-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"pregnant",
			"woman"
		]
	},
	"1f930-1f3fc": {
		"name": "pregnant woman: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 693,
		"display": 1,
		"shortname": ":pregnant_woman_tone2:",
		"shortname_alternates": [
			":expecting_woman_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930-1f3fc",
			"fully_qualified": "1f930-1f3fc",
			"non_fully_qualified": "1f930-1f3fc",
			"output": "1f930-1f3fc",
			"default_matches": [
				"1f930-1f3fc"
			],
			"greedy_matches": [
				"1f930-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"pregnant",
			"woman"
		]
	},
	"1f930-1f3fd": {
		"name": "pregnant woman: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 694,
		"display": 1,
		"shortname": ":pregnant_woman_tone3:",
		"shortname_alternates": [
			":expecting_woman_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930-1f3fd",
			"fully_qualified": "1f930-1f3fd",
			"non_fully_qualified": "1f930-1f3fd",
			"output": "1f930-1f3fd",
			"default_matches": [
				"1f930-1f3fd"
			],
			"greedy_matches": [
				"1f930-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"pregnant",
			"woman"
		]
	},
	"1f930-1f3fe": {
		"name": "pregnant woman: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 695,
		"display": 1,
		"shortname": ":pregnant_woman_tone4:",
		"shortname_alternates": [
			":expecting_woman_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930-1f3fe",
			"fully_qualified": "1f930-1f3fe",
			"non_fully_qualified": "1f930-1f3fe",
			"output": "1f930-1f3fe",
			"default_matches": [
				"1f930-1f3fe"
			],
			"greedy_matches": [
				"1f930-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"pregnant",
			"woman"
		]
	},
	"1f930-1f3ff": {
		"name": "pregnant woman: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 696,
		"display": 1,
		"shortname": ":pregnant_woman_tone5:",
		"shortname_alternates": [
			":expecting_woman_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f930-1f3ff",
			"fully_qualified": "1f930-1f3ff",
			"non_fully_qualified": "1f930-1f3ff",
			"output": "1f930-1f3ff",
			"default_matches": [
				"1f930-1f3ff"
			],
			"greedy_matches": [
				"1f930-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"pregnant",
			"woman"
		]
	},
	"1f647-2640": {
		"name": "woman bowing",
		"unicode_version": 6,
		"category": "people",
		"order": 697,
		"display": 1,
		"shortname": ":woman_bowing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f647-1f3fb-2640",
			"1f647-1f3fc-2640",
			"1f647-1f3fd-2640",
			"1f647-1f3fe-2640",
			"1f647-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-2640",
			"fully_qualified": "1f647-200d-2640-fe0f",
			"non_fully_qualified": "1f647-200d-2640",
			"output": "1f647-200d-2640-fe0f",
			"default_matches": [
				"1f647-200d-2640-fe0f",
				"1f647-200d-2640",
				"1f647-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-200d-2640-fe0f",
				"1f647-200d-2640",
				"1f647-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"sorry",
			"woman"
		]
	},
	"1f647-1f3fb-2640": {
		"name": "woman bowing: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 698,
		"display": 1,
		"shortname": ":woman_bowing_tone1:",
		"shortname_alternates": [
			":woman_bowing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fb-2640",
			"fully_qualified": "1f647-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f647-1f3fb-200d-2640",
			"output": "1f647-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f647-1f3fb-200d-2640-fe0f",
				"1f647-1f3fb-200d-2640",
				"1f647-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fb-200d-2640-fe0f",
				"1f647-1f3fb-200d-2640",
				"1f647-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"light skin tone",
			"sorry",
			"woman"
		]
	},
	"1f647-1f3fc-2640": {
		"name": "woman bowing: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 699,
		"display": 1,
		"shortname": ":woman_bowing_tone2:",
		"shortname_alternates": [
			":woman_bowing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fc-2640",
			"fully_qualified": "1f647-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f647-1f3fc-200d-2640",
			"output": "1f647-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f647-1f3fc-200d-2640-fe0f",
				"1f647-1f3fc-200d-2640",
				"1f647-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fc-200d-2640-fe0f",
				"1f647-1f3fc-200d-2640",
				"1f647-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"medium-light skin tone",
			"sorry",
			"woman"
		]
	},
	"1f647-1f3fd-2640": {
		"name": "woman bowing: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 700,
		"display": 1,
		"shortname": ":woman_bowing_tone3:",
		"shortname_alternates": [
			":woman_bowing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fd-2640",
			"fully_qualified": "1f647-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f647-1f3fd-200d-2640",
			"output": "1f647-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f647-1f3fd-200d-2640-fe0f",
				"1f647-1f3fd-200d-2640",
				"1f647-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fd-200d-2640-fe0f",
				"1f647-1f3fd-200d-2640",
				"1f647-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"medium skin tone",
			"sorry",
			"woman"
		]
	},
	"1f647-1f3fe-2640": {
		"name": "woman bowing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 701,
		"display": 1,
		"shortname": ":woman_bowing_tone4:",
		"shortname_alternates": [
			":woman_bowing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fe-2640",
			"fully_qualified": "1f647-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f647-1f3fe-200d-2640",
			"output": "1f647-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f647-1f3fe-200d-2640-fe0f",
				"1f647-1f3fe-200d-2640",
				"1f647-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fe-200d-2640-fe0f",
				"1f647-1f3fe-200d-2640",
				"1f647-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"medium-dark skin tone",
			"sorry",
			"woman"
		]
	},
	"1f647-1f3ff-2640": {
		"name": "woman bowing: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 702,
		"display": 1,
		"shortname": ":woman_bowing_tone5:",
		"shortname_alternates": [
			":woman_bowing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3ff-2640",
			"fully_qualified": "1f647-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f647-1f3ff-200d-2640",
			"output": "1f647-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f647-1f3ff-200d-2640-fe0f",
				"1f647-1f3ff-200d-2640",
				"1f647-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3ff-200d-2640-fe0f",
				"1f647-1f3ff-200d-2640",
				"1f647-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"dark skin tone",
			"favor",
			"gesture",
			"sorry",
			"woman"
		]
	},
	"1f647": {
		"name": "person bowing",
		"unicode_version": 6,
		"category": "people",
		"order": 703,
		"display": 1,
		"shortname": ":person_bowing:",
		"shortname_alternates": [
			":bow:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f647-1f3fb",
			"1f647-1f3fc",
			"1f647-1f3fd",
			"1f647-1f3fe",
			"1f647-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f647-2642",
			"1f647-2640"
		],
		"code_points": {
			"base": "1f647",
			"fully_qualified": "1f647",
			"non_fully_qualified": "1f647",
			"output": "1f647",
			"default_matches": [
				"1f647"
			],
			"greedy_matches": [
				"1f647"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"gesture",
			"sorry"
		]
	},
	"1f647-1f3fb": {
		"name": "person bowing: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 704,
		"display": 1,
		"shortname": ":person_bowing_tone1:",
		"shortname_alternates": [
			":bow_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f647-1f3fb-2642",
			"1f647-1f3fb-2640"
		],
		"code_points": {
			"base": "1f647-1f3fb",
			"fully_qualified": "1f647-1f3fb",
			"non_fully_qualified": "1f647-1f3fb",
			"output": "1f647-1f3fb",
			"default_matches": [
				"1f647-1f3fb"
			],
			"greedy_matches": [
				"1f647-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"gesture",
			"light skin tone",
			"sorry"
		]
	},
	"1f647-1f3fc": {
		"name": "person bowing: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 705,
		"display": 1,
		"shortname": ":person_bowing_tone2:",
		"shortname_alternates": [
			":bow_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f647-1f3fc-2642",
			"1f647-1f3fc-2640"
		],
		"code_points": {
			"base": "1f647-1f3fc",
			"fully_qualified": "1f647-1f3fc",
			"non_fully_qualified": "1f647-1f3fc",
			"output": "1f647-1f3fc",
			"default_matches": [
				"1f647-1f3fc"
			],
			"greedy_matches": [
				"1f647-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"gesture",
			"medium-light skin tone",
			"sorry"
		]
	},
	"1f647-1f3fd": {
		"name": "person bowing: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 706,
		"display": 1,
		"shortname": ":person_bowing_tone3:",
		"shortname_alternates": [
			":bow_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f647-1f3fd-2642",
			"1f647-1f3fd-2640"
		],
		"code_points": {
			"base": "1f647-1f3fd",
			"fully_qualified": "1f647-1f3fd",
			"non_fully_qualified": "1f647-1f3fd",
			"output": "1f647-1f3fd",
			"default_matches": [
				"1f647-1f3fd"
			],
			"greedy_matches": [
				"1f647-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"gesture",
			"medium skin tone",
			"sorry"
		]
	},
	"1f647-1f3fe": {
		"name": "person bowing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 707,
		"display": 1,
		"shortname": ":person_bowing_tone4:",
		"shortname_alternates": [
			":bow_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f647-1f3fe-2642",
			"1f647-1f3fe-2640"
		],
		"code_points": {
			"base": "1f647-1f3fe",
			"fully_qualified": "1f647-1f3fe",
			"non_fully_qualified": "1f647-1f3fe",
			"output": "1f647-1f3fe",
			"default_matches": [
				"1f647-1f3fe"
			],
			"greedy_matches": [
				"1f647-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"gesture",
			"medium-dark skin tone",
			"sorry"
		]
	},
	"1f647-1f3ff": {
		"name": "person bowing: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 708,
		"display": 1,
		"shortname": ":person_bowing_tone5:",
		"shortname_alternates": [
			":bow_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f647-1f3ff-2642",
			"1f647-1f3ff-2640"
		],
		"code_points": {
			"base": "1f647-1f3ff",
			"fully_qualified": "1f647-1f3ff",
			"non_fully_qualified": "1f647-1f3ff",
			"output": "1f647-1f3ff",
			"default_matches": [
				"1f647-1f3ff"
			],
			"greedy_matches": [
				"1f647-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bow",
			"dark skin tone",
			"gesture",
			"sorry"
		]
	},
	"1f647-2642": {
		"name": "man bowing",
		"unicode_version": 6,
		"category": "people",
		"order": 709,
		"display": 0,
		"shortname": ":man_bowing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f647-1f3fb-2642",
			"1f647-1f3fc-2642",
			"1f647-1f3fd-2642",
			"1f647-1f3fe-2642",
			"1f647-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-2642",
			"fully_qualified": "1f647-200d-2642-fe0f",
			"non_fully_qualified": "1f647-200d-2642",
			"output": "1f647-200d-2642-fe0f",
			"default_matches": [
				"1f647-200d-2642-fe0f",
				"1f647-200d-2642",
				"1f647-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-200d-2642-fe0f",
				"1f647-200d-2642",
				"1f647-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"man",
			"sorry"
		]
	},
	"1f647-1f3ff-2642": {
		"name": "man bowing: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 710,
		"display": 0,
		"shortname": ":man_bowing_tone5:",
		"shortname_alternates": [
			":man_bowing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3ff-2642",
			"fully_qualified": "1f647-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f647-1f3ff-200d-2642",
			"output": "1f647-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f647-1f3ff-200d-2642-fe0f",
				"1f647-1f3ff-200d-2642",
				"1f647-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3ff-200d-2642-fe0f",
				"1f647-1f3ff-200d-2642",
				"1f647-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"dark skin tone",
			"favor",
			"gesture",
			"man",
			"sorry"
		]
	},
	"1f647-1f3fe-2642": {
		"name": "man bowing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 711,
		"display": 0,
		"shortname": ":man_bowing_tone4:",
		"shortname_alternates": [
			":man_bowing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fe-2642",
			"fully_qualified": "1f647-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f647-1f3fe-200d-2642",
			"output": "1f647-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f647-1f3fe-200d-2642-fe0f",
				"1f647-1f3fe-200d-2642",
				"1f647-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fe-200d-2642-fe0f",
				"1f647-1f3fe-200d-2642",
				"1f647-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"man",
			"medium-dark skin tone",
			"sorry"
		]
	},
	"1f647-1f3fd-2642": {
		"name": "man bowing: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 712,
		"display": 0,
		"shortname": ":man_bowing_tone3:",
		"shortname_alternates": [
			":man_bowing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fd-2642",
			"fully_qualified": "1f647-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f647-1f3fd-200d-2642",
			"output": "1f647-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f647-1f3fd-200d-2642-fe0f",
				"1f647-1f3fd-200d-2642",
				"1f647-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fd-200d-2642-fe0f",
				"1f647-1f3fd-200d-2642",
				"1f647-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"man",
			"medium skin tone",
			"sorry"
		]
	},
	"1f647-1f3fc-2642": {
		"name": "man bowing: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 713,
		"display": 0,
		"shortname": ":man_bowing_tone2:",
		"shortname_alternates": [
			":man_bowing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fc-2642",
			"fully_qualified": "1f647-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f647-1f3fc-200d-2642",
			"output": "1f647-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f647-1f3fc-200d-2642-fe0f",
				"1f647-1f3fc-200d-2642",
				"1f647-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fc-200d-2642-fe0f",
				"1f647-1f3fc-200d-2642",
				"1f647-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"man",
			"medium-light skin tone",
			"sorry"
		]
	},
	"1f647-1f3fb-2642": {
		"name": "man bowing: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 714,
		"display": 0,
		"shortname": ":man_bowing_tone1:",
		"shortname_alternates": [
			":man_bowing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f647-1f3fb-2642",
			"fully_qualified": "1f647-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f647-1f3fb-200d-2642",
			"output": "1f647-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f647-1f3fb-200d-2642-fe0f",
				"1f647-1f3fb-200d-2642",
				"1f647-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f647-1f3fb-200d-2642-fe0f",
				"1f647-1f3fb-200d-2642",
				"1f647-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"apology",
			"bowing",
			"favor",
			"gesture",
			"light skin tone",
			"man",
			"sorry"
		]
	},
	"1f481": {
		"name": "person tipping hand",
		"unicode_version": 6,
		"category": "people",
		"order": 715,
		"display": 1,
		"shortname": ":person_tipping_hand:",
		"shortname_alternates": [
			":information_desk_person:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f481-1f3fb",
			"1f481-1f3fc",
			"1f481-1f3fd",
			"1f481-1f3fe",
			"1f481-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f481-2642",
			"1f481-2640"
		],
		"code_points": {
			"base": "1f481",
			"fully_qualified": "1f481",
			"non_fully_qualified": "1f481",
			"output": "1f481",
			"default_matches": [
				"1f481"
			],
			"greedy_matches": [
				"1f481"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"help",
			"information",
			"sassy",
			"tipping"
		]
	},
	"1f481-1f3fb": {
		"name": "person tipping hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 716,
		"display": 1,
		"shortname": ":person_tipping_hand_tone1:",
		"shortname_alternates": [
			":information_desk_person_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f481-1f3fb-2642",
			"1f481-1f3fb-2640"
		],
		"code_points": {
			"base": "1f481-1f3fb",
			"fully_qualified": "1f481-1f3fb",
			"non_fully_qualified": "1f481-1f3fb",
			"output": "1f481-1f3fb",
			"default_matches": [
				"1f481-1f3fb"
			],
			"greedy_matches": [
				"1f481-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"help",
			"information",
			"light skin tone",
			"sassy",
			"tipping"
		]
	},
	"1f481-1f3fc": {
		"name": "person tipping hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 717,
		"display": 1,
		"shortname": ":person_tipping_hand_tone2:",
		"shortname_alternates": [
			":information_desk_person_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f481-1f3fc-2642",
			"1f481-1f3fc-2640"
		],
		"code_points": {
			"base": "1f481-1f3fc",
			"fully_qualified": "1f481-1f3fc",
			"non_fully_qualified": "1f481-1f3fc",
			"output": "1f481-1f3fc",
			"default_matches": [
				"1f481-1f3fc"
			],
			"greedy_matches": [
				"1f481-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"help",
			"information",
			"medium-light skin tone",
			"sassy",
			"tipping"
		]
	},
	"1f481-1f3fd": {
		"name": "person tipping hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 718,
		"display": 1,
		"shortname": ":person_tipping_hand_tone3:",
		"shortname_alternates": [
			":information_desk_person_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f481-1f3fd-2642",
			"1f481-1f3fd-2640"
		],
		"code_points": {
			"base": "1f481-1f3fd",
			"fully_qualified": "1f481-1f3fd",
			"non_fully_qualified": "1f481-1f3fd",
			"output": "1f481-1f3fd",
			"default_matches": [
				"1f481-1f3fd"
			],
			"greedy_matches": [
				"1f481-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"help",
			"information",
			"medium skin tone",
			"sassy",
			"tipping"
		]
	},
	"1f481-1f3fe": {
		"name": "person tipping hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 719,
		"display": 1,
		"shortname": ":person_tipping_hand_tone4:",
		"shortname_alternates": [
			":information_desk_person_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f481-1f3fe-2642",
			"1f481-1f3fe-2640"
		],
		"code_points": {
			"base": "1f481-1f3fe",
			"fully_qualified": "1f481-1f3fe",
			"non_fully_qualified": "1f481-1f3fe",
			"output": "1f481-1f3fe",
			"default_matches": [
				"1f481-1f3fe"
			],
			"greedy_matches": [
				"1f481-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hand",
			"help",
			"information",
			"medium-dark skin tone",
			"sassy",
			"tipping"
		]
	},
	"1f481-1f3ff": {
		"name": "person tipping hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 720,
		"display": 1,
		"shortname": ":person_tipping_hand_tone5:",
		"shortname_alternates": [
			":information_desk_person_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f481-1f3ff-2642",
			"1f481-1f3ff-2640"
		],
		"code_points": {
			"base": "1f481-1f3ff",
			"fully_qualified": "1f481-1f3ff",
			"non_fully_qualified": "1f481-1f3ff",
			"output": "1f481-1f3ff",
			"default_matches": [
				"1f481-1f3ff"
			],
			"greedy_matches": [
				"1f481-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hand",
			"help",
			"information",
			"sassy",
			"tipping"
		]
	},
	"1f481-2642": {
		"name": "man tipping hand",
		"unicode_version": 6,
		"category": "people",
		"order": 721,
		"display": 1,
		"shortname": ":man_tipping_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f481-1f3fb-2642",
			"1f481-1f3fc-2642",
			"1f481-1f3fd-2642",
			"1f481-1f3fe-2642",
			"1f481-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-2642",
			"fully_qualified": "1f481-200d-2642-fe0f",
			"non_fully_qualified": "1f481-200d-2642",
			"output": "1f481-200d-2642-fe0f",
			"default_matches": [
				"1f481-200d-2642-fe0f",
				"1f481-200d-2642",
				"1f481-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-200d-2642-fe0f",
				"1f481-200d-2642",
				"1f481-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-1f3fb-2642": {
		"name": "man tipping hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 722,
		"display": 1,
		"shortname": ":man_tipping_hand_tone1:",
		"shortname_alternates": [
			":man_tipping_hand_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fb-2642",
			"fully_qualified": "1f481-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f481-1f3fb-200d-2642",
			"output": "1f481-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f481-1f3fb-200d-2642-fe0f",
				"1f481-1f3fb-200d-2642",
				"1f481-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fb-200d-2642-fe0f",
				"1f481-1f3fb-200d-2642",
				"1f481-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-1f3fc-2642": {
		"name": "man tipping hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 723,
		"display": 1,
		"shortname": ":man_tipping_hand_tone2:",
		"shortname_alternates": [
			":man_tipping_hand_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fc-2642",
			"fully_qualified": "1f481-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f481-1f3fc-200d-2642",
			"output": "1f481-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f481-1f3fc-200d-2642-fe0f",
				"1f481-1f3fc-200d-2642",
				"1f481-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fc-200d-2642-fe0f",
				"1f481-1f3fc-200d-2642",
				"1f481-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-1f3fd-2642": {
		"name": "man tipping hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 724,
		"display": 1,
		"shortname": ":man_tipping_hand_tone3:",
		"shortname_alternates": [
			":man_tipping_hand_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fd-2642",
			"fully_qualified": "1f481-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f481-1f3fd-200d-2642",
			"output": "1f481-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f481-1f3fd-200d-2642-fe0f",
				"1f481-1f3fd-200d-2642",
				"1f481-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fd-200d-2642-fe0f",
				"1f481-1f3fd-200d-2642",
				"1f481-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-1f3fe-2642": {
		"name": "man tipping hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 725,
		"display": 1,
		"shortname": ":man_tipping_hand_tone4:",
		"shortname_alternates": [
			":man_tipping_hand_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fe-2642",
			"fully_qualified": "1f481-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f481-1f3fe-200d-2642",
			"output": "1f481-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f481-1f3fe-200d-2642-fe0f",
				"1f481-1f3fe-200d-2642",
				"1f481-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fe-200d-2642-fe0f",
				"1f481-1f3fe-200d-2642",
				"1f481-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-1f3ff-2642": {
		"name": "man tipping hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 726,
		"display": 1,
		"shortname": ":man_tipping_hand_tone5:",
		"shortname_alternates": [
			":man_tipping_hand_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3ff-2642",
			"fully_qualified": "1f481-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f481-1f3ff-200d-2642",
			"output": "1f481-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f481-1f3ff-200d-2642-fe0f",
				"1f481-1f3ff-200d-2642",
				"1f481-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3ff-200d-2642-fe0f",
				"1f481-1f3ff-200d-2642",
				"1f481-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"sassy",
			"tipping hand"
		]
	},
	"1f481-2640": {
		"name": "woman tipping hand",
		"unicode_version": 6,
		"category": "people",
		"order": 727,
		"display": 0,
		"shortname": ":woman_tipping_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f481-1f3fb-2640",
			"1f481-1f3fc-2640",
			"1f481-1f3fd-2640",
			"1f481-1f3fe-2640",
			"1f481-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-2640",
			"fully_qualified": "1f481-200d-2640-fe0f",
			"non_fully_qualified": "1f481-200d-2640",
			"output": "1f481-200d-2640-fe0f",
			"default_matches": [
				"1f481-200d-2640-fe0f",
				"1f481-200d-2640",
				"1f481-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-200d-2640-fe0f",
				"1f481-200d-2640",
				"1f481-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f481-1f3ff-2640": {
		"name": "woman tipping hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 728,
		"display": 0,
		"shortname": ":woman_tipping_hand_tone5:",
		"shortname_alternates": [
			":woman_tipping_hand_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3ff-2640",
			"fully_qualified": "1f481-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f481-1f3ff-200d-2640",
			"output": "1f481-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f481-1f3ff-200d-2640-fe0f",
				"1f481-1f3ff-200d-2640",
				"1f481-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3ff-200d-2640-fe0f",
				"1f481-1f3ff-200d-2640",
				"1f481-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f481-1f3fe-2640": {
		"name": "woman tipping hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 729,
		"display": 0,
		"shortname": ":woman_tipping_hand_tone4:",
		"shortname_alternates": [
			":woman_tipping_hand_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fe-2640",
			"fully_qualified": "1f481-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f481-1f3fe-200d-2640",
			"output": "1f481-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f481-1f3fe-200d-2640-fe0f",
				"1f481-1f3fe-200d-2640",
				"1f481-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fe-200d-2640-fe0f",
				"1f481-1f3fe-200d-2640",
				"1f481-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f481-1f3fd-2640": {
		"name": "woman tipping hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 730,
		"display": 0,
		"shortname": ":woman_tipping_hand_tone3:",
		"shortname_alternates": [
			":woman_tipping_hand_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fd-2640",
			"fully_qualified": "1f481-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f481-1f3fd-200d-2640",
			"output": "1f481-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f481-1f3fd-200d-2640-fe0f",
				"1f481-1f3fd-200d-2640",
				"1f481-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fd-200d-2640-fe0f",
				"1f481-1f3fd-200d-2640",
				"1f481-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f481-1f3fc-2640": {
		"name": "woman tipping hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 731,
		"display": 0,
		"shortname": ":woman_tipping_hand_tone2:",
		"shortname_alternates": [
			":woman_tipping_hand_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fc-2640",
			"fully_qualified": "1f481-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f481-1f3fc-200d-2640",
			"output": "1f481-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f481-1f3fc-200d-2640-fe0f",
				"1f481-1f3fc-200d-2640",
				"1f481-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fc-200d-2640-fe0f",
				"1f481-1f3fc-200d-2640",
				"1f481-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f481-1f3fb-2640": {
		"name": "woman tipping hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 732,
		"display": 0,
		"shortname": ":woman_tipping_hand_tone1:",
		"shortname_alternates": [
			":woman_tipping_hand_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f481-1f3fb-2640",
			"fully_qualified": "1f481-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f481-1f3fb-200d-2640",
			"output": "1f481-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f481-1f3fb-200d-2640-fe0f",
				"1f481-1f3fb-200d-2640",
				"1f481-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f481-1f3fb-200d-2640-fe0f",
				"1f481-1f3fb-200d-2640",
				"1f481-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sassy",
			"tipping hand",
			"woman"
		]
	},
	"1f645": {
		"name": "person gesturing NO",
		"unicode_version": 6,
		"category": "people",
		"order": 733,
		"display": 1,
		"shortname": ":person_gesturing_no:",
		"shortname_alternates": [
			":no_good:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f645-1f3fb",
			"1f645-1f3fc",
			"1f645-1f3fd",
			"1f645-1f3fe",
			"1f645-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f645-2642",
			"1f645-2640"
		],
		"code_points": {
			"base": "1f645",
			"fully_qualified": "1f645",
			"non_fully_qualified": "1f645",
			"output": "1f645",
			"default_matches": [
				"1f645"
			],
			"greedy_matches": [
				"1f645"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-1f3fb": {
		"name": "person gesturing NO: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 734,
		"display": 1,
		"shortname": ":person_gesturing_no_tone1:",
		"shortname_alternates": [
			":no_good_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f645-1f3fb-2642",
			"1f645-1f3fb-2640"
		],
		"code_points": {
			"base": "1f645-1f3fb",
			"fully_qualified": "1f645-1f3fb",
			"non_fully_qualified": "1f645-1f3fb",
			"output": "1f645-1f3fb",
			"default_matches": [
				"1f645-1f3fb"
			],
			"greedy_matches": [
				"1f645-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"light skin tone",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-1f3fc": {
		"name": "person gesturing NO: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 735,
		"display": 1,
		"shortname": ":person_gesturing_no_tone2:",
		"shortname_alternates": [
			":no_good_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f645-1f3fc-2642",
			"1f645-1f3fc-2640"
		],
		"code_points": {
			"base": "1f645-1f3fc",
			"fully_qualified": "1f645-1f3fc",
			"non_fully_qualified": "1f645-1f3fc",
			"output": "1f645-1f3fc",
			"default_matches": [
				"1f645-1f3fc"
			],
			"greedy_matches": [
				"1f645-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium-light skin tone",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-1f3fd": {
		"name": "person gesturing NO: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 736,
		"display": 1,
		"shortname": ":person_gesturing_no_tone3:",
		"shortname_alternates": [
			":no_good_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f645-1f3fd-2642",
			"1f645-1f3fd-2640"
		],
		"code_points": {
			"base": "1f645-1f3fd",
			"fully_qualified": "1f645-1f3fd",
			"non_fully_qualified": "1f645-1f3fd",
			"output": "1f645-1f3fd",
			"default_matches": [
				"1f645-1f3fd"
			],
			"greedy_matches": [
				"1f645-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium skin tone",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-1f3fe": {
		"name": "person gesturing NO: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 737,
		"display": 1,
		"shortname": ":person_gesturing_no_tone4:",
		"shortname_alternates": [
			":no_good_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f645-1f3fe-2642",
			"1f645-1f3fe-2640"
		],
		"code_points": {
			"base": "1f645-1f3fe",
			"fully_qualified": "1f645-1f3fe",
			"non_fully_qualified": "1f645-1f3fe",
			"output": "1f645-1f3fe",
			"default_matches": [
				"1f645-1f3fe"
			],
			"greedy_matches": [
				"1f645-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium-dark skin tone",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-1f3ff": {
		"name": "person gesturing NO: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 738,
		"display": 1,
		"shortname": ":person_gesturing_no_tone5:",
		"shortname_alternates": [
			":no_good_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f645-1f3ff-2642",
			"1f645-1f3ff-2640"
		],
		"code_points": {
			"base": "1f645-1f3ff",
			"fully_qualified": "1f645-1f3ff",
			"non_fully_qualified": "1f645-1f3ff",
			"output": "1f645-1f3ff",
			"default_matches": [
				"1f645-1f3ff"
			],
			"greedy_matches": [
				"1f645-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"forbidden",
			"gesture",
			"hand",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f645-2642": {
		"name": "man gesturing NO",
		"unicode_version": 6,
		"category": "people",
		"order": 739,
		"display": 1,
		"shortname": ":man_gesturing_no:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f645-1f3fb-2642",
			"1f645-1f3fc-2642",
			"1f645-1f3fd-2642",
			"1f645-1f3fe-2642",
			"1f645-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-2642",
			"fully_qualified": "1f645-200d-2642-fe0f",
			"non_fully_qualified": "1f645-200d-2642",
			"output": "1f645-200d-2642-fe0f",
			"default_matches": [
				"1f645-200d-2642-fe0f",
				"1f645-200d-2642",
				"1f645-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-200d-2642-fe0f",
				"1f645-200d-2642",
				"1f645-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"man",
			"no",
			"prohibited"
		]
	},
	"1f645-1f3fb-2642": {
		"name": "man gesturing NO: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 740,
		"display": 1,
		"shortname": ":man_gesturing_no_tone1:",
		"shortname_alternates": [
			":man_gesturing_no_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fb-2642",
			"fully_qualified": "1f645-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f645-1f3fb-200d-2642",
			"output": "1f645-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f645-1f3fb-200d-2642-fe0f",
				"1f645-1f3fb-200d-2642",
				"1f645-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fb-200d-2642-fe0f",
				"1f645-1f3fb-200d-2642",
				"1f645-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"light skin tone",
			"man",
			"no",
			"prohibited"
		]
	},
	"1f645-1f3fc-2642": {
		"name": "man gesturing NO: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 741,
		"display": 1,
		"shortname": ":man_gesturing_no_tone2:",
		"shortname_alternates": [
			":man_gesturing_no_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fc-2642",
			"fully_qualified": "1f645-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f645-1f3fc-200d-2642",
			"output": "1f645-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f645-1f3fc-200d-2642-fe0f",
				"1f645-1f3fc-200d-2642",
				"1f645-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fc-200d-2642-fe0f",
				"1f645-1f3fc-200d-2642",
				"1f645-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"man",
			"medium-light skin tone",
			"no",
			"prohibited"
		]
	},
	"1f645-1f3fd-2642": {
		"name": "man gesturing NO: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 742,
		"display": 1,
		"shortname": ":man_gesturing_no_tone3:",
		"shortname_alternates": [
			":man_gesturing_no_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fd-2642",
			"fully_qualified": "1f645-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f645-1f3fd-200d-2642",
			"output": "1f645-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f645-1f3fd-200d-2642-fe0f",
				"1f645-1f3fd-200d-2642",
				"1f645-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fd-200d-2642-fe0f",
				"1f645-1f3fd-200d-2642",
				"1f645-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"man",
			"medium skin tone",
			"no",
			"prohibited"
		]
	},
	"1f645-1f3fe-2642": {
		"name": "man gesturing NO: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 743,
		"display": 1,
		"shortname": ":man_gesturing_no_tone4:",
		"shortname_alternates": [
			":man_gesturing_no_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fe-2642",
			"fully_qualified": "1f645-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f645-1f3fe-200d-2642",
			"output": "1f645-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f645-1f3fe-200d-2642-fe0f",
				"1f645-1f3fe-200d-2642",
				"1f645-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fe-200d-2642-fe0f",
				"1f645-1f3fe-200d-2642",
				"1f645-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"man",
			"medium-dark skin tone",
			"no",
			"prohibited"
		]
	},
	"1f645-1f3ff-2642": {
		"name": "man gesturing NO: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 744,
		"display": 1,
		"shortname": ":man_gesturing_no_tone5:",
		"shortname_alternates": [
			":man_gesturing_no_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3ff-2642",
			"fully_qualified": "1f645-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f645-1f3ff-200d-2642",
			"output": "1f645-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f645-1f3ff-200d-2642-fe0f",
				"1f645-1f3ff-200d-2642",
				"1f645-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3ff-200d-2642-fe0f",
				"1f645-1f3ff-200d-2642",
				"1f645-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"forbidden",
			"gesture",
			"hand",
			"man",
			"no",
			"prohibited"
		]
	},
	"1f645-2640": {
		"name": "woman gesturing NO",
		"unicode_version": 6,
		"category": "people",
		"order": 745,
		"display": 0,
		"shortname": ":woman_gesturing_no:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f645-1f3fb-2640",
			"1f645-1f3fc-2640",
			"1f645-1f3fd-2640",
			"1f645-1f3fe-2640",
			"1f645-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-2640",
			"fully_qualified": "1f645-200d-2640-fe0f",
			"non_fully_qualified": "1f645-200d-2640",
			"output": "1f645-200d-2640-fe0f",
			"default_matches": [
				"1f645-200d-2640-fe0f",
				"1f645-200d-2640",
				"1f645-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-200d-2640-fe0f",
				"1f645-200d-2640",
				"1f645-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f645-1f3ff-2640": {
		"name": "woman gesturing NO: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 746,
		"display": 0,
		"shortname": ":woman_gesturing_no_tone5:",
		"shortname_alternates": [
			":woman_gesturing_no_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3ff-2640",
			"fully_qualified": "1f645-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f645-1f3ff-200d-2640",
			"output": "1f645-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f645-1f3ff-200d-2640-fe0f",
				"1f645-1f3ff-200d-2640",
				"1f645-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3ff-200d-2640-fe0f",
				"1f645-1f3ff-200d-2640",
				"1f645-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"forbidden",
			"gesture",
			"hand",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f645-1f3fe-2640": {
		"name": "woman gesturing NO: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 747,
		"display": 0,
		"shortname": ":woman_gesturing_no_tone4:",
		"shortname_alternates": [
			":woman_gesturing_no_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fe-2640",
			"fully_qualified": "1f645-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f645-1f3fe-200d-2640",
			"output": "1f645-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f645-1f3fe-200d-2640-fe0f",
				"1f645-1f3fe-200d-2640",
				"1f645-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fe-200d-2640-fe0f",
				"1f645-1f3fe-200d-2640",
				"1f645-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium-dark skin tone",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f645-1f3fd-2640": {
		"name": "woman gesturing NO: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 748,
		"display": 0,
		"shortname": ":woman_gesturing_no_tone3:",
		"shortname_alternates": [
			":woman_gesturing_no_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fd-2640",
			"fully_qualified": "1f645-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f645-1f3fd-200d-2640",
			"output": "1f645-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f645-1f3fd-200d-2640-fe0f",
				"1f645-1f3fd-200d-2640",
				"1f645-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fd-200d-2640-fe0f",
				"1f645-1f3fd-200d-2640",
				"1f645-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium skin tone",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f645-1f3fc-2640": {
		"name": "woman gesturing NO: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 749,
		"display": 0,
		"shortname": ":woman_gesturing_no_tone2:",
		"shortname_alternates": [
			":woman_gesturing_no_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fc-2640",
			"fully_qualified": "1f645-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f645-1f3fc-200d-2640",
			"output": "1f645-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f645-1f3fc-200d-2640-fe0f",
				"1f645-1f3fc-200d-2640",
				"1f645-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fc-200d-2640-fe0f",
				"1f645-1f3fc-200d-2640",
				"1f645-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"medium-light skin tone",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f645-1f3fb-2640": {
		"name": "woman gesturing NO: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 750,
		"display": 0,
		"shortname": ":woman_gesturing_no_tone1:",
		"shortname_alternates": [
			":woman_gesturing_no_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f645-1f3fb-2640",
			"fully_qualified": "1f645-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f645-1f3fb-200d-2640",
			"output": "1f645-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f645-1f3fb-200d-2640-fe0f",
				"1f645-1f3fb-200d-2640",
				"1f645-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f645-1f3fb-200d-2640-fe0f",
				"1f645-1f3fb-200d-2640",
				"1f645-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"gesture",
			"hand",
			"light skin tone",
			"no",
			"prohibited",
			"woman"
		]
	},
	"1f646": {
		"name": "person gesturing OK",
		"unicode_version": 6,
		"category": "people",
		"order": 751,
		"display": 1,
		"shortname": ":person_gesturing_ok:",
		"shortname_alternates": [
			":ok_woman:"
		],
		"ascii": [
			"*\\0/*",
			"\\0/",
			"*\\O/*",
			"\\O/"
		],
		"diversity": null,
		"diversities": [
			"1f646-1f3fb",
			"1f646-1f3fc",
			"1f646-1f3fd",
			"1f646-1f3fe",
			"1f646-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f646-2642",
			"1f646-2640"
		],
		"code_points": {
			"base": "1f646",
			"fully_qualified": "1f646",
			"non_fully_qualified": "1f646",
			"output": "1f646",
			"default_matches": [
				"1f646"
			],
			"greedy_matches": [
				"1f646"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand"
		]
	},
	"1f646-1f3fb": {
		"name": "person gesturing OK: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 752,
		"display": 1,
		"shortname": ":person_gesturing_ok_tone1:",
		"shortname_alternates": [
			":ok_woman_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f646-1f3fb-2642",
			"1f646-1f3fb-2640"
		],
		"code_points": {
			"base": "1f646-1f3fb",
			"fully_qualified": "1f646-1f3fb",
			"non_fully_qualified": "1f646-1f3fb",
			"output": "1f646-1f3fb",
			"default_matches": [
				"1f646-1f3fb"
			],
			"greedy_matches": [
				"1f646-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"light skin tone"
		]
	},
	"1f646-1f3fc": {
		"name": "person gesturing OK: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 753,
		"display": 1,
		"shortname": ":person_gesturing_ok_tone2:",
		"shortname_alternates": [
			":ok_woman_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f646-1f3fc-2642",
			"1f646-1f3fc-2640"
		],
		"code_points": {
			"base": "1f646-1f3fc",
			"fully_qualified": "1f646-1f3fc",
			"non_fully_qualified": "1f646-1f3fc",
			"output": "1f646-1f3fc",
			"default_matches": [
				"1f646-1f3fc"
			],
			"greedy_matches": [
				"1f646-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f646-1f3fd": {
		"name": "person gesturing OK: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 754,
		"display": 1,
		"shortname": ":person_gesturing_ok_tone3:",
		"shortname_alternates": [
			":ok_woman_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f646-1f3fd-2642",
			"1f646-1f3fd-2640"
		],
		"code_points": {
			"base": "1f646-1f3fd",
			"fully_qualified": "1f646-1f3fd",
			"non_fully_qualified": "1f646-1f3fd",
			"output": "1f646-1f3fd",
			"default_matches": [
				"1f646-1f3fd"
			],
			"greedy_matches": [
				"1f646-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium skin tone"
		]
	},
	"1f646-1f3fe": {
		"name": "person gesturing OK: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 755,
		"display": 1,
		"shortname": ":person_gesturing_ok_tone4:",
		"shortname_alternates": [
			":ok_woman_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f646-1f3fe-2642",
			"1f646-1f3fe-2640"
		],
		"code_points": {
			"base": "1f646-1f3fe",
			"fully_qualified": "1f646-1f3fe",
			"non_fully_qualified": "1f646-1f3fe",
			"output": "1f646-1f3fe",
			"default_matches": [
				"1f646-1f3fe"
			],
			"greedy_matches": [
				"1f646-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f646-1f3ff": {
		"name": "person gesturing OK: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 756,
		"display": 1,
		"shortname": ":person_gesturing_ok_tone5:",
		"shortname_alternates": [
			":ok_woman_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f646-1f3ff-2642",
			"1f646-1f3ff-2640"
		],
		"code_points": {
			"base": "1f646-1f3ff",
			"fully_qualified": "1f646-1f3ff",
			"non_fully_qualified": "1f646-1f3ff",
			"output": "1f646-1f3ff",
			"default_matches": [
				"1f646-1f3ff"
			],
			"greedy_matches": [
				"1f646-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"dark skin tone",
			"gesture",
			"hand"
		]
	},
	"1f646-2642": {
		"name": "man gesturing OK",
		"unicode_version": 6,
		"category": "people",
		"order": 757,
		"display": 1,
		"shortname": ":man_gesturing_ok:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f646-1f3fb-2642",
			"1f646-1f3fc-2642",
			"1f646-1f3fd-2642",
			"1f646-1f3fe-2642",
			"1f646-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-2642",
			"fully_qualified": "1f646-200d-2642-fe0f",
			"non_fully_qualified": "1f646-200d-2642",
			"output": "1f646-200d-2642-fe0f",
			"default_matches": [
				"1f646-200d-2642-fe0f",
				"1f646-200d-2642",
				"1f646-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-200d-2642-fe0f",
				"1f646-200d-2642",
				"1f646-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"man"
		]
	},
	"1f646-1f3fb-2642": {
		"name": "man gesturing OK: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 758,
		"display": 1,
		"shortname": ":man_gesturing_ok_tone1:",
		"shortname_alternates": [
			":man_gesturing_ok_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fb-2642",
			"fully_qualified": "1f646-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f646-1f3fb-200d-2642",
			"output": "1f646-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f646-1f3fb-200d-2642-fe0f",
				"1f646-1f3fb-200d-2642",
				"1f646-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fb-200d-2642-fe0f",
				"1f646-1f3fb-200d-2642",
				"1f646-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"light skin tone",
			"man"
		]
	},
	"1f646-1f3fc-2642": {
		"name": "man gesturing OK: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 759,
		"display": 1,
		"shortname": ":man_gesturing_ok_tone2:",
		"shortname_alternates": [
			":man_gesturing_ok_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fc-2642",
			"fully_qualified": "1f646-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f646-1f3fc-200d-2642",
			"output": "1f646-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f646-1f3fc-200d-2642-fe0f",
				"1f646-1f3fc-200d-2642",
				"1f646-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fc-200d-2642-fe0f",
				"1f646-1f3fc-200d-2642",
				"1f646-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"man",
			"medium-light skin tone"
		]
	},
	"1f646-1f3fd-2642": {
		"name": "man gesturing OK: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 760,
		"display": 1,
		"shortname": ":man_gesturing_ok_tone3:",
		"shortname_alternates": [
			":man_gesturing_ok_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fd-2642",
			"fully_qualified": "1f646-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f646-1f3fd-200d-2642",
			"output": "1f646-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f646-1f3fd-200d-2642-fe0f",
				"1f646-1f3fd-200d-2642",
				"1f646-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fd-200d-2642-fe0f",
				"1f646-1f3fd-200d-2642",
				"1f646-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"man",
			"medium skin tone"
		]
	},
	"1f646-1f3fe-2642": {
		"name": "man gesturing OK: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 761,
		"display": 1,
		"shortname": ":man_gesturing_ok_tone4:",
		"shortname_alternates": [
			":man_gesturing_ok_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fe-2642",
			"fully_qualified": "1f646-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f646-1f3fe-200d-2642",
			"output": "1f646-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f646-1f3fe-200d-2642-fe0f",
				"1f646-1f3fe-200d-2642",
				"1f646-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fe-200d-2642-fe0f",
				"1f646-1f3fe-200d-2642",
				"1f646-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f646-1f3ff-2642": {
		"name": "man gesturing OK: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 762,
		"display": 1,
		"shortname": ":man_gesturing_ok_tone5:",
		"shortname_alternates": [
			":man_gesturing_ok_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3ff-2642",
			"fully_qualified": "1f646-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f646-1f3ff-200d-2642",
			"output": "1f646-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f646-1f3ff-200d-2642-fe0f",
				"1f646-1f3ff-200d-2642",
				"1f646-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3ff-200d-2642-fe0f",
				"1f646-1f3ff-200d-2642",
				"1f646-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"dark skin tone",
			"gesture",
			"hand",
			"man"
		]
	},
	"1f646-2640": {
		"name": "woman gesturing OK",
		"unicode_version": 6,
		"category": "people",
		"order": 763,
		"display": 0,
		"shortname": ":woman_gesturing_ok:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f646-1f3fb-2640",
			"1f646-1f3fc-2640",
			"1f646-1f3fd-2640",
			"1f646-1f3fe-2640",
			"1f646-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-2640",
			"fully_qualified": "1f646-200d-2640-fe0f",
			"non_fully_qualified": "1f646-200d-2640",
			"output": "1f646-200d-2640-fe0f",
			"default_matches": [
				"1f646-200d-2640-fe0f",
				"1f646-200d-2640",
				"1f646-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-200d-2640-fe0f",
				"1f646-200d-2640",
				"1f646-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"woman"
		]
	},
	"1f646-1f3ff-2640": {
		"name": "woman gesturing OK: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 764,
		"display": 0,
		"shortname": ":woman_gesturing_ok_tone5:",
		"shortname_alternates": [
			":woman_gesturing_ok_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3ff-2640",
			"fully_qualified": "1f646-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f646-1f3ff-200d-2640",
			"output": "1f646-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f646-1f3ff-200d-2640-fe0f",
				"1f646-1f3ff-200d-2640",
				"1f646-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3ff-200d-2640-fe0f",
				"1f646-1f3ff-200d-2640",
				"1f646-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"dark skin tone",
			"gesture",
			"hand",
			"woman"
		]
	},
	"1f646-1f3fe-2640": {
		"name": "woman gesturing OK: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 765,
		"display": 0,
		"shortname": ":woman_gesturing_ok_tone4:",
		"shortname_alternates": [
			":woman_gesturing_ok_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fe-2640",
			"fully_qualified": "1f646-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f646-1f3fe-200d-2640",
			"output": "1f646-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f646-1f3fe-200d-2640-fe0f",
				"1f646-1f3fe-200d-2640",
				"1f646-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fe-200d-2640-fe0f",
				"1f646-1f3fe-200d-2640",
				"1f646-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f646-1f3fd-2640": {
		"name": "woman gesturing OK: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 766,
		"display": 0,
		"shortname": ":woman_gesturing_ok_tone3:",
		"shortname_alternates": [
			":woman_gesturing_ok_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fd-2640",
			"fully_qualified": "1f646-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f646-1f3fd-200d-2640",
			"output": "1f646-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f646-1f3fd-200d-2640-fe0f",
				"1f646-1f3fd-200d-2640",
				"1f646-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fd-200d-2640-fe0f",
				"1f646-1f3fd-200d-2640",
				"1f646-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium skin tone",
			"woman"
		]
	},
	"1f646-1f3fc-2640": {
		"name": "woman gesturing OK: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 767,
		"display": 0,
		"shortname": ":woman_gesturing_ok_tone2:",
		"shortname_alternates": [
			":woman_gesturing_ok_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fc-2640",
			"fully_qualified": "1f646-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f646-1f3fc-200d-2640",
			"output": "1f646-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f646-1f3fc-200d-2640-fe0f",
				"1f646-1f3fc-200d-2640",
				"1f646-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fc-200d-2640-fe0f",
				"1f646-1f3fc-200d-2640",
				"1f646-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f646-1f3fb-2640": {
		"name": "woman gesturing OK: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 768,
		"display": 0,
		"shortname": ":woman_gesturing_ok_tone1:",
		"shortname_alternates": [
			":woman_gesturing_ok_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f646-1f3fb-2640",
			"fully_qualified": "1f646-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f646-1f3fb-200d-2640",
			"output": "1f646-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f646-1f3fb-200d-2640-fe0f",
				"1f646-1f3fb-200d-2640",
				"1f646-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f646-1f3fb-200d-2640-fe0f",
				"1f646-1f3fb-200d-2640",
				"1f646-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"OK",
			"gesture",
			"hand",
			"light skin tone",
			"woman"
		]
	},
	"1f64b": {
		"name": "person raising hand",
		"unicode_version": 6,
		"category": "people",
		"order": 769,
		"display": 1,
		"shortname": ":person_raising_hand:",
		"shortname_alternates": [
			":raising_hand:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64b-1f3fb",
			"1f64b-1f3fc",
			"1f64b-1f3fd",
			"1f64b-1f3fe",
			"1f64b-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f64b-2642",
			"1f64b-2640"
		],
		"code_points": {
			"base": "1f64b",
			"fully_qualified": "1f64b",
			"non_fully_qualified": "1f64b",
			"output": "1f64b",
			"default_matches": [
				"1f64b"
			],
			"greedy_matches": [
				"1f64b"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"hand",
			"happy",
			"raised"
		]
	},
	"1f64b-1f3fb": {
		"name": "person raising hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 770,
		"display": 1,
		"shortname": ":person_raising_hand_tone1:",
		"shortname_alternates": [
			":raising_hand_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64b-1f3fb-2642",
			"1f64b-1f3fb-2640"
		],
		"code_points": {
			"base": "1f64b-1f3fb",
			"fully_qualified": "1f64b-1f3fb",
			"non_fully_qualified": "1f64b-1f3fb",
			"output": "1f64b-1f3fb",
			"default_matches": [
				"1f64b-1f3fb"
			],
			"greedy_matches": [
				"1f64b-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"hand",
			"happy",
			"light skin tone",
			"raised"
		]
	},
	"1f64b-1f3fc": {
		"name": "person raising hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 771,
		"display": 1,
		"shortname": ":person_raising_hand_tone2:",
		"shortname_alternates": [
			":raising_hand_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64b-1f3fc-2642",
			"1f64b-1f3fc-2640"
		],
		"code_points": {
			"base": "1f64b-1f3fc",
			"fully_qualified": "1f64b-1f3fc",
			"non_fully_qualified": "1f64b-1f3fc",
			"output": "1f64b-1f3fc",
			"default_matches": [
				"1f64b-1f3fc"
			],
			"greedy_matches": [
				"1f64b-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"hand",
			"happy",
			"medium-light skin tone",
			"raised"
		]
	},
	"1f64b-1f3fd": {
		"name": "person raising hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 772,
		"display": 1,
		"shortname": ":person_raising_hand_tone3:",
		"shortname_alternates": [
			":raising_hand_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64b-1f3fd-2642",
			"1f64b-1f3fd-2640"
		],
		"code_points": {
			"base": "1f64b-1f3fd",
			"fully_qualified": "1f64b-1f3fd",
			"non_fully_qualified": "1f64b-1f3fd",
			"output": "1f64b-1f3fd",
			"default_matches": [
				"1f64b-1f3fd"
			],
			"greedy_matches": [
				"1f64b-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"hand",
			"happy",
			"medium skin tone",
			"raised"
		]
	},
	"1f64b-1f3fe": {
		"name": "person raising hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 773,
		"display": 1,
		"shortname": ":person_raising_hand_tone4:",
		"shortname_alternates": [
			":raising_hand_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64b-1f3fe-2642",
			"1f64b-1f3fe-2640"
		],
		"code_points": {
			"base": "1f64b-1f3fe",
			"fully_qualified": "1f64b-1f3fe",
			"non_fully_qualified": "1f64b-1f3fe",
			"output": "1f64b-1f3fe",
			"default_matches": [
				"1f64b-1f3fe"
			],
			"greedy_matches": [
				"1f64b-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"hand",
			"happy",
			"medium-dark skin tone",
			"raised"
		]
	},
	"1f64b-1f3ff": {
		"name": "person raising hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 774,
		"display": 1,
		"shortname": ":person_raising_hand_tone5:",
		"shortname_alternates": [
			":raising_hand_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64b-1f3ff-2642",
			"1f64b-1f3ff-2640"
		],
		"code_points": {
			"base": "1f64b-1f3ff",
			"fully_qualified": "1f64b-1f3ff",
			"non_fully_qualified": "1f64b-1f3ff",
			"output": "1f64b-1f3ff",
			"default_matches": [
				"1f64b-1f3ff"
			],
			"greedy_matches": [
				"1f64b-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"hand",
			"happy",
			"raised"
		]
	},
	"1f64b-2642": {
		"name": "man raising hand",
		"unicode_version": 6,
		"category": "people",
		"order": 775,
		"display": 1,
		"shortname": ":man_raising_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64b-1f3fb-2642",
			"1f64b-1f3fc-2642",
			"1f64b-1f3fd-2642",
			"1f64b-1f3fe-2642",
			"1f64b-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-2642",
			"fully_qualified": "1f64b-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-200d-2642",
			"output": "1f64b-200d-2642-fe0f",
			"default_matches": [
				"1f64b-200d-2642-fe0f",
				"1f64b-200d-2642",
				"1f64b-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-200d-2642-fe0f",
				"1f64b-200d-2642",
				"1f64b-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"raising hand"
		]
	},
	"1f64b-1f3fb-2642": {
		"name": "man raising hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 776,
		"display": 1,
		"shortname": ":man_raising_hand_tone1:",
		"shortname_alternates": [
			":man_raising_hand_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fb-2642",
			"fully_qualified": "1f64b-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-1f3fb-200d-2642",
			"output": "1f64b-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f64b-1f3fb-200d-2642-fe0f",
				"1f64b-1f3fb-200d-2642",
				"1f64b-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fb-200d-2642-fe0f",
				"1f64b-1f3fb-200d-2642",
				"1f64b-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"light skin tone",
			"man",
			"raising hand"
		]
	},
	"1f64b-1f3fc-2642": {
		"name": "man raising hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 777,
		"display": 1,
		"shortname": ":man_raising_hand_tone2:",
		"shortname_alternates": [
			":man_raising_hand_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fc-2642",
			"fully_qualified": "1f64b-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-1f3fc-200d-2642",
			"output": "1f64b-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f64b-1f3fc-200d-2642-fe0f",
				"1f64b-1f3fc-200d-2642",
				"1f64b-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fc-200d-2642-fe0f",
				"1f64b-1f3fc-200d-2642",
				"1f64b-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium-light skin tone",
			"raising hand"
		]
	},
	"1f64b-1f3fd-2642": {
		"name": "man raising hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 778,
		"display": 1,
		"shortname": ":man_raising_hand_tone3:",
		"shortname_alternates": [
			":man_raising_hand_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fd-2642",
			"fully_qualified": "1f64b-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-1f3fd-200d-2642",
			"output": "1f64b-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f64b-1f3fd-200d-2642-fe0f",
				"1f64b-1f3fd-200d-2642",
				"1f64b-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fd-200d-2642-fe0f",
				"1f64b-1f3fd-200d-2642",
				"1f64b-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium skin tone",
			"raising hand"
		]
	},
	"1f64b-1f3fe-2642": {
		"name": "man raising hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 779,
		"display": 1,
		"shortname": ":man_raising_hand_tone4:",
		"shortname_alternates": [
			":man_raising_hand_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fe-2642",
			"fully_qualified": "1f64b-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-1f3fe-200d-2642",
			"output": "1f64b-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f64b-1f3fe-200d-2642-fe0f",
				"1f64b-1f3fe-200d-2642",
				"1f64b-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fe-200d-2642-fe0f",
				"1f64b-1f3fe-200d-2642",
				"1f64b-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium-dark skin tone",
			"raising hand"
		]
	},
	"1f64b-1f3ff-2642": {
		"name": "man raising hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 780,
		"display": 1,
		"shortname": ":man_raising_hand_tone5:",
		"shortname_alternates": [
			":man_raising_hand_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3ff-2642",
			"fully_qualified": "1f64b-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f64b-1f3ff-200d-2642",
			"output": "1f64b-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f64b-1f3ff-200d-2642-fe0f",
				"1f64b-1f3ff-200d-2642",
				"1f64b-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3ff-200d-2642-fe0f",
				"1f64b-1f3ff-200d-2642",
				"1f64b-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"man",
			"raising hand"
		]
	},
	"1f64b-2640": {
		"name": "woman raising hand",
		"unicode_version": 6,
		"category": "people",
		"order": 781,
		"display": 0,
		"shortname": ":woman_raising_hand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64b-1f3fb-2640",
			"1f64b-1f3fc-2640",
			"1f64b-1f3fd-2640",
			"1f64b-1f3fe-2640",
			"1f64b-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-2640",
			"fully_qualified": "1f64b-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-200d-2640",
			"output": "1f64b-200d-2640-fe0f",
			"default_matches": [
				"1f64b-200d-2640-fe0f",
				"1f64b-200d-2640",
				"1f64b-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-200d-2640-fe0f",
				"1f64b-200d-2640",
				"1f64b-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"raising hand",
			"woman"
		]
	},
	"1f64b-1f3ff-2640": {
		"name": "woman raising hand: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 782,
		"display": 0,
		"shortname": ":woman_raising_hand_tone5:",
		"shortname_alternates": [
			":woman_raising_hand_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3ff-2640",
			"fully_qualified": "1f64b-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-1f3ff-200d-2640",
			"output": "1f64b-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f64b-1f3ff-200d-2640-fe0f",
				"1f64b-1f3ff-200d-2640",
				"1f64b-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3ff-200d-2640-fe0f",
				"1f64b-1f3ff-200d-2640",
				"1f64b-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"raising hand",
			"woman"
		]
	},
	"1f64b-1f3fe-2640": {
		"name": "woman raising hand: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 783,
		"display": 0,
		"shortname": ":woman_raising_hand_tone4:",
		"shortname_alternates": [
			":woman_raising_hand_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fe-2640",
			"fully_qualified": "1f64b-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-1f3fe-200d-2640",
			"output": "1f64b-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f64b-1f3fe-200d-2640-fe0f",
				"1f64b-1f3fe-200d-2640",
				"1f64b-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fe-200d-2640-fe0f",
				"1f64b-1f3fe-200d-2640",
				"1f64b-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-dark skin tone",
			"raising hand",
			"woman"
		]
	},
	"1f64b-1f3fd-2640": {
		"name": "woman raising hand: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 784,
		"display": 0,
		"shortname": ":woman_raising_hand_tone3:",
		"shortname_alternates": [
			":woman_raising_hand_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fd-2640",
			"fully_qualified": "1f64b-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-1f3fd-200d-2640",
			"output": "1f64b-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f64b-1f3fd-200d-2640-fe0f",
				"1f64b-1f3fd-200d-2640",
				"1f64b-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fd-200d-2640-fe0f",
				"1f64b-1f3fd-200d-2640",
				"1f64b-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium skin tone",
			"raising hand",
			"woman"
		]
	},
	"1f64b-1f3fc-2640": {
		"name": "woman raising hand: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 785,
		"display": 0,
		"shortname": ":woman_raising_hand_tone2:",
		"shortname_alternates": [
			":woman_raising_hand_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fc-2640",
			"fully_qualified": "1f64b-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-1f3fc-200d-2640",
			"output": "1f64b-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f64b-1f3fc-200d-2640-fe0f",
				"1f64b-1f3fc-200d-2640",
				"1f64b-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fc-200d-2640-fe0f",
				"1f64b-1f3fc-200d-2640",
				"1f64b-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-light skin tone",
			"raising hand",
			"woman"
		]
	},
	"1f64b-1f3fb-2640": {
		"name": "woman raising hand: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 786,
		"display": 0,
		"shortname": ":woman_raising_hand_tone1:",
		"shortname_alternates": [
			":woman_raising_hand_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64b-1f3fb-2640",
			"fully_qualified": "1f64b-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f64b-1f3fb-200d-2640",
			"output": "1f64b-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f64b-1f3fb-200d-2640-fe0f",
				"1f64b-1f3fb-200d-2640",
				"1f64b-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f64b-1f3fb-200d-2640-fe0f",
				"1f64b-1f3fb-200d-2640",
				"1f64b-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"light skin tone",
			"raising hand",
			"woman"
		]
	},
	"1f926-2640": {
		"name": "woman facepalming",
		"unicode_version": 9,
		"category": "people",
		"order": 787,
		"display": 1,
		"shortname": ":woman_facepalming:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f926-1f3fb-2640",
			"1f926-1f3fc-2640",
			"1f926-1f3fd-2640",
			"1f926-1f3fe-2640",
			"1f926-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-2640",
			"fully_qualified": "1f926-200d-2640-fe0f",
			"non_fully_qualified": "1f926-200d-2640",
			"output": "1f926-200d-2640-fe0f",
			"default_matches": [
				"1f926-200d-2640-fe0f",
				"1f926-200d-2640",
				"1f926-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-200d-2640-fe0f",
				"1f926-200d-2640",
				"1f926-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"woman"
		]
	},
	"1f926-1f3fb-2640": {
		"name": "woman facepalming: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 788,
		"display": 1,
		"shortname": ":woman_facepalming_tone1:",
		"shortname_alternates": [
			":woman_facepalming_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fb-2640",
			"fully_qualified": "1f926-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f926-1f3fb-200d-2640",
			"output": "1f926-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f926-1f3fb-200d-2640-fe0f",
				"1f926-1f3fb-200d-2640",
				"1f926-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fb-200d-2640-fe0f",
				"1f926-1f3fb-200d-2640",
				"1f926-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"light skin tone",
			"woman"
		]
	},
	"1f926-1f3fc-2640": {
		"name": "woman facepalming: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 789,
		"display": 1,
		"shortname": ":woman_facepalming_tone2:",
		"shortname_alternates": [
			":woman_facepalming_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fc-2640",
			"fully_qualified": "1f926-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f926-1f3fc-200d-2640",
			"output": "1f926-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f926-1f3fc-200d-2640-fe0f",
				"1f926-1f3fc-200d-2640",
				"1f926-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fc-200d-2640-fe0f",
				"1f926-1f3fc-200d-2640",
				"1f926-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f926-1f3fd-2640": {
		"name": "woman facepalming: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 790,
		"display": 1,
		"shortname": ":woman_facepalming_tone3:",
		"shortname_alternates": [
			":woman_facepalming_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fd-2640",
			"fully_qualified": "1f926-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f926-1f3fd-200d-2640",
			"output": "1f926-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f926-1f3fd-200d-2640-fe0f",
				"1f926-1f3fd-200d-2640",
				"1f926-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fd-200d-2640-fe0f",
				"1f926-1f3fd-200d-2640",
				"1f926-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"medium skin tone",
			"woman"
		]
	},
	"1f926-1f3fe-2640": {
		"name": "woman facepalming: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 791,
		"display": 1,
		"shortname": ":woman_facepalming_tone4:",
		"shortname_alternates": [
			":woman_facepalming_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fe-2640",
			"fully_qualified": "1f926-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f926-1f3fe-200d-2640",
			"output": "1f926-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f926-1f3fe-200d-2640-fe0f",
				"1f926-1f3fe-200d-2640",
				"1f926-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fe-200d-2640-fe0f",
				"1f926-1f3fe-200d-2640",
				"1f926-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f926-1f3ff-2640": {
		"name": "woman facepalming: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 792,
		"display": 1,
		"shortname": ":woman_facepalming_tone5:",
		"shortname_alternates": [
			":woman_facepalming_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3ff-2640",
			"fully_qualified": "1f926-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f926-1f3ff-200d-2640",
			"output": "1f926-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f926-1f3ff-200d-2640-fe0f",
				"1f926-1f3ff-200d-2640",
				"1f926-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3ff-200d-2640-fe0f",
				"1f926-1f3ff-200d-2640",
				"1f926-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"disbelief",
			"exasperation",
			"facepalm",
			"woman"
		]
	},
	"1f926-2642": {
		"name": "man facepalming",
		"unicode_version": 9,
		"category": "people",
		"order": 793,
		"display": 1,
		"shortname": ":man_facepalming:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f926-1f3fb-2642",
			"1f926-1f3fc-2642",
			"1f926-1f3fd-2642",
			"1f926-1f3fe-2642",
			"1f926-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-2642",
			"fully_qualified": "1f926-200d-2642-fe0f",
			"non_fully_qualified": "1f926-200d-2642",
			"output": "1f926-200d-2642-fe0f",
			"default_matches": [
				"1f926-200d-2642-fe0f",
				"1f926-200d-2642",
				"1f926-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-200d-2642-fe0f",
				"1f926-200d-2642",
				"1f926-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"man"
		]
	},
	"1f926-1f3fb-2642": {
		"name": "man facepalming: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 794,
		"display": 1,
		"shortname": ":man_facepalming_tone1:",
		"shortname_alternates": [
			":man_facepalming_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fb-2642",
			"fully_qualified": "1f926-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f926-1f3fb-200d-2642",
			"output": "1f926-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f926-1f3fb-200d-2642-fe0f",
				"1f926-1f3fb-200d-2642",
				"1f926-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fb-200d-2642-fe0f",
				"1f926-1f3fb-200d-2642",
				"1f926-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"light skin tone",
			"man"
		]
	},
	"1f926-1f3fc-2642": {
		"name": "man facepalming: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 795,
		"display": 1,
		"shortname": ":man_facepalming_tone2:",
		"shortname_alternates": [
			":man_facepalming_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fc-2642",
			"fully_qualified": "1f926-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f926-1f3fc-200d-2642",
			"output": "1f926-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f926-1f3fc-200d-2642-fe0f",
				"1f926-1f3fc-200d-2642",
				"1f926-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fc-200d-2642-fe0f",
				"1f926-1f3fc-200d-2642",
				"1f926-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"man",
			"medium-light skin tone"
		]
	},
	"1f926-1f3fd-2642": {
		"name": "man facepalming: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 796,
		"display": 1,
		"shortname": ":man_facepalming_tone3:",
		"shortname_alternates": [
			":man_facepalming_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fd-2642",
			"fully_qualified": "1f926-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f926-1f3fd-200d-2642",
			"output": "1f926-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f926-1f3fd-200d-2642-fe0f",
				"1f926-1f3fd-200d-2642",
				"1f926-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fd-200d-2642-fe0f",
				"1f926-1f3fd-200d-2642",
				"1f926-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"man",
			"medium skin tone"
		]
	},
	"1f926-1f3fe-2642": {
		"name": "man facepalming: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 797,
		"display": 1,
		"shortname": ":man_facepalming_tone4:",
		"shortname_alternates": [
			":man_facepalming_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3fe-2642",
			"fully_qualified": "1f926-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f926-1f3fe-200d-2642",
			"output": "1f926-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f926-1f3fe-200d-2642-fe0f",
				"1f926-1f3fe-200d-2642",
				"1f926-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3fe-200d-2642-fe0f",
				"1f926-1f3fe-200d-2642",
				"1f926-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"facepalm",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f926-1f3ff-2642": {
		"name": "man facepalming: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 798,
		"display": 1,
		"shortname": ":man_facepalming_tone5:",
		"shortname_alternates": [
			":man_facepalming_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f926-1f3ff-2642",
			"fully_qualified": "1f926-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f926-1f3ff-200d-2642",
			"output": "1f926-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f926-1f3ff-200d-2642-fe0f",
				"1f926-1f3ff-200d-2642",
				"1f926-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f926-1f3ff-200d-2642-fe0f",
				"1f926-1f3ff-200d-2642",
				"1f926-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"disbelief",
			"exasperation",
			"facepalm",
			"man"
		]
	},
	"1f926": {
		"name": "person facepalming",
		"unicode_version": 9,
		"category": "people",
		"order": 799,
		"display": 0,
		"shortname": ":person_facepalming:",
		"shortname_alternates": [
			":face_palm:",
			":facepalm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f926-1f3fb",
			"1f926-1f3fc",
			"1f926-1f3fd",
			"1f926-1f3fe",
			"1f926-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f926-2642",
			"1f926-2640"
		],
		"code_points": {
			"base": "1f926",
			"fully_qualified": "1f926",
			"non_fully_qualified": "1f926",
			"output": "1f926",
			"default_matches": [
				"1f926"
			],
			"greedy_matches": [
				"1f926"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"face",
			"palm"
		]
	},
	"1f926-1f3fb": {
		"name": "person facepalming: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 800,
		"display": 0,
		"shortname": ":person_facepalming_tone1:",
		"shortname_alternates": [
			":face_palm_tone1:",
			":facepalm_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f926-1f3fb-2642",
			"1f926-1f3fb-2640"
		],
		"code_points": {
			"base": "1f926-1f3fb",
			"fully_qualified": "1f926-1f3fb",
			"non_fully_qualified": "1f926-1f3fb",
			"output": "1f926-1f3fb",
			"default_matches": [
				"1f926-1f3fb"
			],
			"greedy_matches": [
				"1f926-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"face",
			"light skin tone",
			"palm"
		]
	},
	"1f926-1f3fc": {
		"name": "person facepalming: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 801,
		"display": 0,
		"shortname": ":person_facepalming_tone2:",
		"shortname_alternates": [
			":face_palm_tone2:",
			":facepalm_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f926-1f3fc-2642",
			"1f926-1f3fc-2640"
		],
		"code_points": {
			"base": "1f926-1f3fc",
			"fully_qualified": "1f926-1f3fc",
			"non_fully_qualified": "1f926-1f3fc",
			"output": "1f926-1f3fc",
			"default_matches": [
				"1f926-1f3fc"
			],
			"greedy_matches": [
				"1f926-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"face",
			"medium-light skin tone",
			"palm"
		]
	},
	"1f926-1f3fd": {
		"name": "person facepalming: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 802,
		"display": 0,
		"shortname": ":person_facepalming_tone3:",
		"shortname_alternates": [
			":face_palm_tone3:",
			":facepalm_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f926-1f3fd-2642",
			"1f926-1f3fd-2640"
		],
		"code_points": {
			"base": "1f926-1f3fd",
			"fully_qualified": "1f926-1f3fd",
			"non_fully_qualified": "1f926-1f3fd",
			"output": "1f926-1f3fd",
			"default_matches": [
				"1f926-1f3fd"
			],
			"greedy_matches": [
				"1f926-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"face",
			"medium skin tone",
			"palm"
		]
	},
	"1f926-1f3fe": {
		"name": "person facepalming: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 803,
		"display": 0,
		"shortname": ":person_facepalming_tone4:",
		"shortname_alternates": [
			":face_palm_tone4:",
			":facepalm_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f926-1f3fe-2642",
			"1f926-1f3fe-2640"
		],
		"code_points": {
			"base": "1f926-1f3fe",
			"fully_qualified": "1f926-1f3fe",
			"non_fully_qualified": "1f926-1f3fe",
			"output": "1f926-1f3fe",
			"default_matches": [
				"1f926-1f3fe"
			],
			"greedy_matches": [
				"1f926-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"disbelief",
			"exasperation",
			"face",
			"medium-dark skin tone",
			"palm"
		]
	},
	"1f926-1f3ff": {
		"name": "person facepalming: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 804,
		"display": 0,
		"shortname": ":person_facepalming_tone5:",
		"shortname_alternates": [
			":face_palm_tone5:",
			":facepalm_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f926-1f3ff-2642",
			"1f926-1f3ff-2640"
		],
		"code_points": {
			"base": "1f926-1f3ff",
			"fully_qualified": "1f926-1f3ff",
			"non_fully_qualified": "1f926-1f3ff",
			"output": "1f926-1f3ff",
			"default_matches": [
				"1f926-1f3ff"
			],
			"greedy_matches": [
				"1f926-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"disbelief",
			"exasperation",
			"face",
			"palm"
		]
	},
	"1f937-2640": {
		"name": "woman shrugging",
		"unicode_version": 9,
		"category": "people",
		"order": 805,
		"display": 1,
		"shortname": ":woman_shrugging:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f937-1f3fb-2640",
			"1f937-1f3fc-2640",
			"1f937-1f3fd-2640",
			"1f937-1f3fe-2640",
			"1f937-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-2640",
			"fully_qualified": "1f937-200d-2640-fe0f",
			"non_fully_qualified": "1f937-200d-2640",
			"output": "1f937-200d-2640-fe0f",
			"default_matches": [
				"1f937-200d-2640-fe0f",
				"1f937-200d-2640",
				"1f937-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-200d-2640-fe0f",
				"1f937-200d-2640",
				"1f937-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"shrug",
			"woman"
		]
	},
	"1f937-1f3fb-2640": {
		"name": "woman shrugging: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 806,
		"display": 1,
		"shortname": ":woman_shrugging_tone1:",
		"shortname_alternates": [
			":woman_shrugging_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fb-2640",
			"fully_qualified": "1f937-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f937-1f3fb-200d-2640",
			"output": "1f937-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f937-1f3fb-200d-2640-fe0f",
				"1f937-1f3fb-200d-2640",
				"1f937-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fb-200d-2640-fe0f",
				"1f937-1f3fb-200d-2640",
				"1f937-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"light skin tone",
			"shrug",
			"woman"
		]
	},
	"1f937-1f3fc-2640": {
		"name": "woman shrugging: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 807,
		"display": 1,
		"shortname": ":woman_shrugging_tone2:",
		"shortname_alternates": [
			":woman_shrugging_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fc-2640",
			"fully_qualified": "1f937-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f937-1f3fc-200d-2640",
			"output": "1f937-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f937-1f3fc-200d-2640-fe0f",
				"1f937-1f3fc-200d-2640",
				"1f937-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fc-200d-2640-fe0f",
				"1f937-1f3fc-200d-2640",
				"1f937-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium-light skin tone",
			"shrug",
			"woman"
		]
	},
	"1f937-1f3fd-2640": {
		"name": "woman shrugging: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 808,
		"display": 1,
		"shortname": ":woman_shrugging_tone3:",
		"shortname_alternates": [
			":woman_shrugging_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fd-2640",
			"fully_qualified": "1f937-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f937-1f3fd-200d-2640",
			"output": "1f937-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f937-1f3fd-200d-2640-fe0f",
				"1f937-1f3fd-200d-2640",
				"1f937-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fd-200d-2640-fe0f",
				"1f937-1f3fd-200d-2640",
				"1f937-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium skin tone",
			"shrug",
			"woman"
		]
	},
	"1f937-1f3fe-2640": {
		"name": "woman shrugging: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 809,
		"display": 1,
		"shortname": ":woman_shrugging_tone4:",
		"shortname_alternates": [
			":woman_shrugging_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fe-2640",
			"fully_qualified": "1f937-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f937-1f3fe-200d-2640",
			"output": "1f937-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f937-1f3fe-200d-2640-fe0f",
				"1f937-1f3fe-200d-2640",
				"1f937-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fe-200d-2640-fe0f",
				"1f937-1f3fe-200d-2640",
				"1f937-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium-dark skin tone",
			"shrug",
			"woman"
		]
	},
	"1f937-1f3ff-2640": {
		"name": "woman shrugging: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 810,
		"display": 1,
		"shortname": ":woman_shrugging_tone5:",
		"shortname_alternates": [
			":woman_shrugging_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3ff-2640",
			"fully_qualified": "1f937-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f937-1f3ff-200d-2640",
			"output": "1f937-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f937-1f3ff-200d-2640-fe0f",
				"1f937-1f3ff-200d-2640",
				"1f937-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3ff-200d-2640-fe0f",
				"1f937-1f3ff-200d-2640",
				"1f937-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"doubt",
			"ignorance",
			"indifference",
			"shrug",
			"woman"
		]
	},
	"1f937-2642": {
		"name": "man shrugging",
		"unicode_version": 9,
		"category": "people",
		"order": 811,
		"display": 1,
		"shortname": ":man_shrugging:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f937-1f3fb-2642",
			"1f937-1f3fc-2642",
			"1f937-1f3fd-2642",
			"1f937-1f3fe-2642",
			"1f937-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-2642",
			"fully_qualified": "1f937-200d-2642-fe0f",
			"non_fully_qualified": "1f937-200d-2642",
			"output": "1f937-200d-2642-fe0f",
			"default_matches": [
				"1f937-200d-2642-fe0f",
				"1f937-200d-2642",
				"1f937-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-200d-2642-fe0f",
				"1f937-200d-2642",
				"1f937-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"man",
			"shrug"
		]
	},
	"1f937-1f3fb-2642": {
		"name": "man shrugging: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 812,
		"display": 1,
		"shortname": ":man_shrugging_tone1:",
		"shortname_alternates": [
			":man_shrugging_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fb-2642",
			"fully_qualified": "1f937-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f937-1f3fb-200d-2642",
			"output": "1f937-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f937-1f3fb-200d-2642-fe0f",
				"1f937-1f3fb-200d-2642",
				"1f937-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fb-200d-2642-fe0f",
				"1f937-1f3fb-200d-2642",
				"1f937-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"light skin tone",
			"man",
			"shrug"
		]
	},
	"1f937-1f3fc-2642": {
		"name": "man shrugging: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 813,
		"display": 1,
		"shortname": ":man_shrugging_tone2:",
		"shortname_alternates": [
			":man_shrugging_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fc-2642",
			"fully_qualified": "1f937-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f937-1f3fc-200d-2642",
			"output": "1f937-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f937-1f3fc-200d-2642-fe0f",
				"1f937-1f3fc-200d-2642",
				"1f937-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fc-200d-2642-fe0f",
				"1f937-1f3fc-200d-2642",
				"1f937-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"man",
			"medium-light skin tone",
			"shrug"
		]
	},
	"1f937-1f3fd-2642": {
		"name": "man shrugging: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 814,
		"display": 1,
		"shortname": ":man_shrugging_tone3:",
		"shortname_alternates": [
			":man_shrugging_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fd-2642",
			"fully_qualified": "1f937-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f937-1f3fd-200d-2642",
			"output": "1f937-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f937-1f3fd-200d-2642-fe0f",
				"1f937-1f3fd-200d-2642",
				"1f937-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fd-200d-2642-fe0f",
				"1f937-1f3fd-200d-2642",
				"1f937-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"man",
			"medium skin tone",
			"shrug"
		]
	},
	"1f937-1f3fe-2642": {
		"name": "man shrugging: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 815,
		"display": 1,
		"shortname": ":man_shrugging_tone4:",
		"shortname_alternates": [
			":man_shrugging_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3fe-2642",
			"fully_qualified": "1f937-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f937-1f3fe-200d-2642",
			"output": "1f937-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f937-1f3fe-200d-2642-fe0f",
				"1f937-1f3fe-200d-2642",
				"1f937-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3fe-200d-2642-fe0f",
				"1f937-1f3fe-200d-2642",
				"1f937-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"man",
			"medium-dark skin tone",
			"shrug"
		]
	},
	"1f937-1f3ff-2642": {
		"name": "man shrugging: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 816,
		"display": 1,
		"shortname": ":man_shrugging_tone5:",
		"shortname_alternates": [
			":man_shrugging_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f937-1f3ff-2642",
			"fully_qualified": "1f937-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f937-1f3ff-200d-2642",
			"output": "1f937-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f937-1f3ff-200d-2642-fe0f",
				"1f937-1f3ff-200d-2642",
				"1f937-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f937-1f3ff-200d-2642-fe0f",
				"1f937-1f3ff-200d-2642",
				"1f937-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"doubt",
			"ignorance",
			"indifference",
			"man",
			"shrug"
		]
	},
	"1f937": {
		"name": "person shrugging",
		"unicode_version": 9,
		"category": "people",
		"order": 817,
		"display": 0,
		"shortname": ":person_shrugging:",
		"shortname_alternates": [
			":shrug:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f937-1f3fb",
			"1f937-1f3fc",
			"1f937-1f3fd",
			"1f937-1f3fe",
			"1f937-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f937-2642",
			"1f937-2640"
		],
		"code_points": {
			"base": "1f937",
			"fully_qualified": "1f937",
			"non_fully_qualified": "1f937",
			"output": "1f937",
			"default_matches": [
				"1f937"
			],
			"greedy_matches": [
				"1f937"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"shrug"
		]
	},
	"1f937-1f3fb": {
		"name": "person shrugging: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 818,
		"display": 0,
		"shortname": ":person_shrugging_tone1:",
		"shortname_alternates": [
			":shrug_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f937-1f3fb-2642",
			"1f937-1f3fb-2640"
		],
		"code_points": {
			"base": "1f937-1f3fb",
			"fully_qualified": "1f937-1f3fb",
			"non_fully_qualified": "1f937-1f3fb",
			"output": "1f937-1f3fb",
			"default_matches": [
				"1f937-1f3fb"
			],
			"greedy_matches": [
				"1f937-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"light skin tone",
			"shrug"
		]
	},
	"1f937-1f3fc": {
		"name": "person shrugging: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 819,
		"display": 0,
		"shortname": ":person_shrugging_tone2:",
		"shortname_alternates": [
			":shrug_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f937-1f3fc-2642",
			"1f937-1f3fc-2640"
		],
		"code_points": {
			"base": "1f937-1f3fc",
			"fully_qualified": "1f937-1f3fc",
			"non_fully_qualified": "1f937-1f3fc",
			"output": "1f937-1f3fc",
			"default_matches": [
				"1f937-1f3fc"
			],
			"greedy_matches": [
				"1f937-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium-light skin tone",
			"shrug"
		]
	},
	"1f937-1f3fd": {
		"name": "person shrugging: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 820,
		"display": 0,
		"shortname": ":person_shrugging_tone3:",
		"shortname_alternates": [
			":shrug_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f937-1f3fd-2642",
			"1f937-1f3fd-2640"
		],
		"code_points": {
			"base": "1f937-1f3fd",
			"fully_qualified": "1f937-1f3fd",
			"non_fully_qualified": "1f937-1f3fd",
			"output": "1f937-1f3fd",
			"default_matches": [
				"1f937-1f3fd"
			],
			"greedy_matches": [
				"1f937-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium skin tone",
			"shrug"
		]
	},
	"1f937-1f3fe": {
		"name": "person shrugging: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 821,
		"display": 0,
		"shortname": ":person_shrugging_tone4:",
		"shortname_alternates": [
			":shrug_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f937-1f3fe-2642",
			"1f937-1f3fe-2640"
		],
		"code_points": {
			"base": "1f937-1f3fe",
			"fully_qualified": "1f937-1f3fe",
			"non_fully_qualified": "1f937-1f3fe",
			"output": "1f937-1f3fe",
			"default_matches": [
				"1f937-1f3fe"
			],
			"greedy_matches": [
				"1f937-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"doubt",
			"ignorance",
			"indifference",
			"medium-dark skin tone",
			"shrug"
		]
	},
	"1f937-1f3ff": {
		"name": "person shrugging: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 822,
		"display": 0,
		"shortname": ":person_shrugging_tone5:",
		"shortname_alternates": [
			":shrug_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f937-1f3ff-2642",
			"1f937-1f3ff-2640"
		],
		"code_points": {
			"base": "1f937-1f3ff",
			"fully_qualified": "1f937-1f3ff",
			"non_fully_qualified": "1f937-1f3ff",
			"output": "1f937-1f3ff",
			"default_matches": [
				"1f937-1f3ff"
			],
			"greedy_matches": [
				"1f937-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"doubt",
			"ignorance",
			"indifference",
			"shrug"
		]
	},
	"1f64e": {
		"name": "person pouting",
		"unicode_version": 6,
		"category": "people",
		"order": 823,
		"display": 1,
		"shortname": ":person_pouting:",
		"shortname_alternates": [
			":person_with_pouting_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64e-1f3fb",
			"1f64e-1f3fc",
			"1f64e-1f3fd",
			"1f64e-1f3fe",
			"1f64e-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f64e-2642",
			"1f64e-2640"
		],
		"code_points": {
			"base": "1f64e",
			"fully_qualified": "1f64e",
			"non_fully_qualified": "1f64e",
			"output": "1f64e",
			"default_matches": [
				"1f64e"
			],
			"greedy_matches": [
				"1f64e"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"pouting"
		]
	},
	"1f64e-1f3fb": {
		"name": "person pouting: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 824,
		"display": 1,
		"shortname": ":person_pouting_tone1:",
		"shortname_alternates": [
			":person_with_pouting_face_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64e-1f3fb-2642",
			"1f64e-1f3fb-2640"
		],
		"code_points": {
			"base": "1f64e-1f3fb",
			"fully_qualified": "1f64e-1f3fb",
			"non_fully_qualified": "1f64e-1f3fb",
			"output": "1f64e-1f3fb",
			"default_matches": [
				"1f64e-1f3fb"
			],
			"greedy_matches": [
				"1f64e-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"light skin tone",
			"pouting"
		]
	},
	"1f64e-1f3fc": {
		"name": "person pouting: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 825,
		"display": 1,
		"shortname": ":person_pouting_tone2:",
		"shortname_alternates": [
			":person_with_pouting_face_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64e-1f3fc-2642",
			"1f64e-1f3fc-2640"
		],
		"code_points": {
			"base": "1f64e-1f3fc",
			"fully_qualified": "1f64e-1f3fc",
			"non_fully_qualified": "1f64e-1f3fc",
			"output": "1f64e-1f3fc",
			"default_matches": [
				"1f64e-1f3fc"
			],
			"greedy_matches": [
				"1f64e-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-light skin tone",
			"pouting"
		]
	},
	"1f64e-1f3fd": {
		"name": "person pouting: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 826,
		"display": 1,
		"shortname": ":person_pouting_tone3:",
		"shortname_alternates": [
			":person_with_pouting_face_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64e-1f3fd-2642",
			"1f64e-1f3fd-2640"
		],
		"code_points": {
			"base": "1f64e-1f3fd",
			"fully_qualified": "1f64e-1f3fd",
			"non_fully_qualified": "1f64e-1f3fd",
			"output": "1f64e-1f3fd",
			"default_matches": [
				"1f64e-1f3fd"
			],
			"greedy_matches": [
				"1f64e-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium skin tone",
			"pouting"
		]
	},
	"1f64e-1f3fe": {
		"name": "person pouting: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 827,
		"display": 1,
		"shortname": ":person_pouting_tone4:",
		"shortname_alternates": [
			":person_with_pouting_face_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64e-1f3fe-2642",
			"1f64e-1f3fe-2640"
		],
		"code_points": {
			"base": "1f64e-1f3fe",
			"fully_qualified": "1f64e-1f3fe",
			"non_fully_qualified": "1f64e-1f3fe",
			"output": "1f64e-1f3fe",
			"default_matches": [
				"1f64e-1f3fe"
			],
			"greedy_matches": [
				"1f64e-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-dark skin tone",
			"pouting"
		]
	},
	"1f64e-1f3ff": {
		"name": "person pouting: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 828,
		"display": 1,
		"shortname": ":person_pouting_tone5:",
		"shortname_alternates": [
			":person_with_pouting_face_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64e-1f3ff-2642",
			"1f64e-1f3ff-2640"
		],
		"code_points": {
			"base": "1f64e-1f3ff",
			"fully_qualified": "1f64e-1f3ff",
			"non_fully_qualified": "1f64e-1f3ff",
			"output": "1f64e-1f3ff",
			"default_matches": [
				"1f64e-1f3ff"
			],
			"greedy_matches": [
				"1f64e-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"pouting"
		]
	},
	"1f64e-2642": {
		"name": "man pouting",
		"unicode_version": 6,
		"category": "people",
		"order": 829,
		"display": 1,
		"shortname": ":man_pouting:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64e-1f3fb-2642",
			"1f64e-1f3fc-2642",
			"1f64e-1f3fd-2642",
			"1f64e-1f3fe-2642",
			"1f64e-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-2642",
			"fully_qualified": "1f64e-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-200d-2642",
			"output": "1f64e-200d-2642-fe0f",
			"default_matches": [
				"1f64e-200d-2642-fe0f",
				"1f64e-200d-2642",
				"1f64e-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-200d-2642-fe0f",
				"1f64e-200d-2642",
				"1f64e-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"pouting"
		]
	},
	"1f64e-1f3fb-2642": {
		"name": "man pouting: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 830,
		"display": 1,
		"shortname": ":man_pouting_tone1:",
		"shortname_alternates": [
			":man_pouting_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fb-2642",
			"fully_qualified": "1f64e-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-1f3fb-200d-2642",
			"output": "1f64e-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f64e-1f3fb-200d-2642-fe0f",
				"1f64e-1f3fb-200d-2642",
				"1f64e-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fb-200d-2642-fe0f",
				"1f64e-1f3fb-200d-2642",
				"1f64e-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"light skin tone",
			"man",
			"pouting"
		]
	},
	"1f64e-1f3fc-2642": {
		"name": "man pouting: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 831,
		"display": 1,
		"shortname": ":man_pouting_tone2:",
		"shortname_alternates": [
			":man_pouting_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fc-2642",
			"fully_qualified": "1f64e-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-1f3fc-200d-2642",
			"output": "1f64e-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f64e-1f3fc-200d-2642-fe0f",
				"1f64e-1f3fc-200d-2642",
				"1f64e-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fc-200d-2642-fe0f",
				"1f64e-1f3fc-200d-2642",
				"1f64e-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium-light skin tone",
			"pouting"
		]
	},
	"1f64e-1f3fd-2642": {
		"name": "man pouting: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 832,
		"display": 1,
		"shortname": ":man_pouting_tone3:",
		"shortname_alternates": [
			":man_pouting_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fd-2642",
			"fully_qualified": "1f64e-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-1f3fd-200d-2642",
			"output": "1f64e-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f64e-1f3fd-200d-2642-fe0f",
				"1f64e-1f3fd-200d-2642",
				"1f64e-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fd-200d-2642-fe0f",
				"1f64e-1f3fd-200d-2642",
				"1f64e-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium skin tone",
			"pouting"
		]
	},
	"1f64e-1f3fe-2642": {
		"name": "man pouting: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 833,
		"display": 1,
		"shortname": ":man_pouting_tone4:",
		"shortname_alternates": [
			":man_pouting_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fe-2642",
			"fully_qualified": "1f64e-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-1f3fe-200d-2642",
			"output": "1f64e-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f64e-1f3fe-200d-2642-fe0f",
				"1f64e-1f3fe-200d-2642",
				"1f64e-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fe-200d-2642-fe0f",
				"1f64e-1f3fe-200d-2642",
				"1f64e-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"man",
			"medium-dark skin tone",
			"pouting"
		]
	},
	"1f64e-1f3ff-2642": {
		"name": "man pouting: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 834,
		"display": 1,
		"shortname": ":man_pouting_tone5:",
		"shortname_alternates": [
			":man_pouting_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3ff-2642",
			"fully_qualified": "1f64e-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f64e-1f3ff-200d-2642",
			"output": "1f64e-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f64e-1f3ff-200d-2642-fe0f",
				"1f64e-1f3ff-200d-2642",
				"1f64e-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3ff-200d-2642-fe0f",
				"1f64e-1f3ff-200d-2642",
				"1f64e-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"man",
			"pouting"
		]
	},
	"1f64e-2640": {
		"name": "woman pouting",
		"unicode_version": 6,
		"category": "people",
		"order": 835,
		"display": 0,
		"shortname": ":woman_pouting:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64e-1f3fb-2640",
			"1f64e-1f3fc-2640",
			"1f64e-1f3fd-2640",
			"1f64e-1f3fe-2640",
			"1f64e-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-2640",
			"fully_qualified": "1f64e-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-200d-2640",
			"output": "1f64e-200d-2640-fe0f",
			"default_matches": [
				"1f64e-200d-2640-fe0f",
				"1f64e-200d-2640",
				"1f64e-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-200d-2640-fe0f",
				"1f64e-200d-2640",
				"1f64e-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"pouting",
			"woman"
		]
	},
	"1f64e-1f3ff-2640": {
		"name": "woman pouting: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 836,
		"display": 0,
		"shortname": ":woman_pouting_tone5:",
		"shortname_alternates": [
			":woman_pouting_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3ff-2640",
			"fully_qualified": "1f64e-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-1f3ff-200d-2640",
			"output": "1f64e-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f64e-1f3ff-200d-2640-fe0f",
				"1f64e-1f3ff-200d-2640",
				"1f64e-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3ff-200d-2640-fe0f",
				"1f64e-1f3ff-200d-2640",
				"1f64e-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gesture",
			"pouting",
			"woman"
		]
	},
	"1f64e-1f3fe-2640": {
		"name": "woman pouting: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 837,
		"display": 0,
		"shortname": ":woman_pouting_tone4:",
		"shortname_alternates": [
			":woman_pouting_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fe-2640",
			"fully_qualified": "1f64e-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-1f3fe-200d-2640",
			"output": "1f64e-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f64e-1f3fe-200d-2640-fe0f",
				"1f64e-1f3fe-200d-2640",
				"1f64e-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fe-200d-2640-fe0f",
				"1f64e-1f3fe-200d-2640",
				"1f64e-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-dark skin tone",
			"pouting",
			"woman"
		]
	},
	"1f64e-1f3fd-2640": {
		"name": "woman pouting: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 838,
		"display": 0,
		"shortname": ":woman_pouting_tone3:",
		"shortname_alternates": [
			":woman_pouting_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fd-2640",
			"fully_qualified": "1f64e-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-1f3fd-200d-2640",
			"output": "1f64e-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f64e-1f3fd-200d-2640-fe0f",
				"1f64e-1f3fd-200d-2640",
				"1f64e-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fd-200d-2640-fe0f",
				"1f64e-1f3fd-200d-2640",
				"1f64e-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium skin tone",
			"pouting",
			"woman"
		]
	},
	"1f64e-1f3fc-2640": {
		"name": "woman pouting: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 839,
		"display": 0,
		"shortname": ":woman_pouting_tone2:",
		"shortname_alternates": [
			":woman_pouting_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fc-2640",
			"fully_qualified": "1f64e-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-1f3fc-200d-2640",
			"output": "1f64e-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f64e-1f3fc-200d-2640-fe0f",
				"1f64e-1f3fc-200d-2640",
				"1f64e-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fc-200d-2640-fe0f",
				"1f64e-1f3fc-200d-2640",
				"1f64e-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"medium-light skin tone",
			"pouting",
			"woman"
		]
	},
	"1f64e-1f3fb-2640": {
		"name": "woman pouting: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 840,
		"display": 0,
		"shortname": ":woman_pouting_tone1:",
		"shortname_alternates": [
			":woman_pouting_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64e-1f3fb-2640",
			"fully_qualified": "1f64e-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f64e-1f3fb-200d-2640",
			"output": "1f64e-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f64e-1f3fb-200d-2640-fe0f",
				"1f64e-1f3fb-200d-2640",
				"1f64e-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f64e-1f3fb-200d-2640-fe0f",
				"1f64e-1f3fb-200d-2640",
				"1f64e-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"gesture",
			"light skin tone",
			"pouting",
			"woman"
		]
	},
	"1f64d": {
		"name": "person frowning",
		"unicode_version": 6,
		"category": "people",
		"order": 841,
		"display": 1,
		"shortname": ":person_frowning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64d-1f3fb",
			"1f64d-1f3fc",
			"1f64d-1f3fd",
			"1f64d-1f3fe",
			"1f64d-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f64d-2642",
			"1f64d-2640"
		],
		"code_points": {
			"base": "1f64d",
			"fully_qualified": "1f64d",
			"non_fully_qualified": "1f64d",
			"output": "1f64d",
			"default_matches": [
				"1f64d"
			],
			"greedy_matches": [
				"1f64d"
			],
			"decimal": ""
		},
		"keywords": [
			"frown",
			"gesture"
		]
	},
	"1f64d-1f3fb": {
		"name": "person frowning: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 842,
		"display": 1,
		"shortname": ":person_frowning_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64d-1f3fb-2642",
			"1f64d-1f3fb-2640"
		],
		"code_points": {
			"base": "1f64d-1f3fb",
			"fully_qualified": "1f64d-1f3fb",
			"non_fully_qualified": "1f64d-1f3fb",
			"output": "1f64d-1f3fb",
			"default_matches": [
				"1f64d-1f3fb"
			],
			"greedy_matches": [
				"1f64d-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"frown",
			"gesture",
			"light skin tone"
		]
	},
	"1f64d-1f3fc": {
		"name": "person frowning: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 843,
		"display": 1,
		"shortname": ":person_frowning_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64d-1f3fc-2642",
			"1f64d-1f3fc-2640"
		],
		"code_points": {
			"base": "1f64d-1f3fc",
			"fully_qualified": "1f64d-1f3fc",
			"non_fully_qualified": "1f64d-1f3fc",
			"output": "1f64d-1f3fc",
			"default_matches": [
				"1f64d-1f3fc"
			],
			"greedy_matches": [
				"1f64d-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"frown",
			"gesture",
			"medium-light skin tone"
		]
	},
	"1f64d-1f3fd": {
		"name": "person frowning: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 844,
		"display": 1,
		"shortname": ":person_frowning_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64d-1f3fd-2642",
			"1f64d-1f3fd-2640"
		],
		"code_points": {
			"base": "1f64d-1f3fd",
			"fully_qualified": "1f64d-1f3fd",
			"non_fully_qualified": "1f64d-1f3fd",
			"output": "1f64d-1f3fd",
			"default_matches": [
				"1f64d-1f3fd"
			],
			"greedy_matches": [
				"1f64d-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"frown",
			"gesture",
			"medium skin tone"
		]
	},
	"1f64d-1f3fe": {
		"name": "person frowning: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 845,
		"display": 1,
		"shortname": ":person_frowning_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64d-1f3fe-2642",
			"1f64d-1f3fe-2640"
		],
		"code_points": {
			"base": "1f64d-1f3fe",
			"fully_qualified": "1f64d-1f3fe",
			"non_fully_qualified": "1f64d-1f3fe",
			"output": "1f64d-1f3fe",
			"default_matches": [
				"1f64d-1f3fe"
			],
			"greedy_matches": [
				"1f64d-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"frown",
			"gesture",
			"medium-dark skin tone"
		]
	},
	"1f64d-1f3ff": {
		"name": "person frowning: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 846,
		"display": 1,
		"shortname": ":person_frowning_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f64d-1f3ff-2642",
			"1f64d-1f3ff-2640"
		],
		"code_points": {
			"base": "1f64d-1f3ff",
			"fully_qualified": "1f64d-1f3ff",
			"non_fully_qualified": "1f64d-1f3ff",
			"output": "1f64d-1f3ff",
			"default_matches": [
				"1f64d-1f3ff"
			],
			"greedy_matches": [
				"1f64d-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"frown",
			"gesture"
		]
	},
	"1f64d-2642": {
		"name": "man frowning",
		"unicode_version": 6,
		"category": "people",
		"order": 847,
		"display": 1,
		"shortname": ":man_frowning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64d-1f3fb-2642",
			"1f64d-1f3fc-2642",
			"1f64d-1f3fd-2642",
			"1f64d-1f3fe-2642",
			"1f64d-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-2642",
			"fully_qualified": "1f64d-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-200d-2642",
			"output": "1f64d-200d-2642-fe0f",
			"default_matches": [
				"1f64d-200d-2642-fe0f",
				"1f64d-200d-2642",
				"1f64d-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-200d-2642-fe0f",
				"1f64d-200d-2642",
				"1f64d-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"man"
		]
	},
	"1f64d-1f3fb-2642": {
		"name": "man frowning: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 848,
		"display": 1,
		"shortname": ":man_frowning_tone1:",
		"shortname_alternates": [
			":man_frowning_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fb-2642",
			"fully_qualified": "1f64d-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-1f3fb-200d-2642",
			"output": "1f64d-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f64d-1f3fb-200d-2642-fe0f",
				"1f64d-1f3fb-200d-2642",
				"1f64d-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fb-200d-2642-fe0f",
				"1f64d-1f3fb-200d-2642",
				"1f64d-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"light skin tone",
			"man"
		]
	},
	"1f64d-1f3fc-2642": {
		"name": "man frowning: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 849,
		"display": 1,
		"shortname": ":man_frowning_tone2:",
		"shortname_alternates": [
			":man_frowning_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fc-2642",
			"fully_qualified": "1f64d-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-1f3fc-200d-2642",
			"output": "1f64d-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f64d-1f3fc-200d-2642-fe0f",
				"1f64d-1f3fc-200d-2642",
				"1f64d-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fc-200d-2642-fe0f",
				"1f64d-1f3fc-200d-2642",
				"1f64d-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"man",
			"medium-light skin tone"
		]
	},
	"1f64d-1f3fd-2642": {
		"name": "man frowning: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 850,
		"display": 1,
		"shortname": ":man_frowning_tone3:",
		"shortname_alternates": [
			":man_frowning_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fd-2642",
			"fully_qualified": "1f64d-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-1f3fd-200d-2642",
			"output": "1f64d-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f64d-1f3fd-200d-2642-fe0f",
				"1f64d-1f3fd-200d-2642",
				"1f64d-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fd-200d-2642-fe0f",
				"1f64d-1f3fd-200d-2642",
				"1f64d-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"man",
			"medium skin tone"
		]
	},
	"1f64d-1f3fe-2642": {
		"name": "man frowning: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 851,
		"display": 1,
		"shortname": ":man_frowning_tone4:",
		"shortname_alternates": [
			":man_frowning_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fe-2642",
			"fully_qualified": "1f64d-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-1f3fe-200d-2642",
			"output": "1f64d-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f64d-1f3fe-200d-2642-fe0f",
				"1f64d-1f3fe-200d-2642",
				"1f64d-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fe-200d-2642-fe0f",
				"1f64d-1f3fe-200d-2642",
				"1f64d-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f64d-1f3ff-2642": {
		"name": "man frowning: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 852,
		"display": 1,
		"shortname": ":man_frowning_tone5:",
		"shortname_alternates": [
			":man_frowning_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3ff-2642",
			"fully_qualified": "1f64d-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f64d-1f3ff-200d-2642",
			"output": "1f64d-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f64d-1f3ff-200d-2642-fe0f",
				"1f64d-1f3ff-200d-2642",
				"1f64d-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3ff-200d-2642-fe0f",
				"1f64d-1f3ff-200d-2642",
				"1f64d-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"frowning",
			"gesture",
			"man"
		]
	},
	"1f64d-2640": {
		"name": "woman frowning",
		"unicode_version": 6,
		"category": "people",
		"order": 853,
		"display": 0,
		"shortname": ":woman_frowning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f64d-1f3fb-2640",
			"1f64d-1f3fc-2640",
			"1f64d-1f3fd-2640",
			"1f64d-1f3fe-2640",
			"1f64d-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-2640",
			"fully_qualified": "1f64d-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-200d-2640",
			"output": "1f64d-200d-2640-fe0f",
			"default_matches": [
				"1f64d-200d-2640-fe0f",
				"1f64d-200d-2640",
				"1f64d-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-200d-2640-fe0f",
				"1f64d-200d-2640",
				"1f64d-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"woman"
		]
	},
	"1f64d-1f3ff-2640": {
		"name": "woman frowning: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 854,
		"display": 0,
		"shortname": ":woman_frowning_tone5:",
		"shortname_alternates": [
			":woman_frowning_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3ff-2640",
			"fully_qualified": "1f64d-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-1f3ff-200d-2640",
			"output": "1f64d-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f64d-1f3ff-200d-2640-fe0f",
				"1f64d-1f3ff-200d-2640",
				"1f64d-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3ff-200d-2640-fe0f",
				"1f64d-1f3ff-200d-2640",
				"1f64d-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"frowning",
			"gesture",
			"woman"
		]
	},
	"1f64d-1f3fe-2640": {
		"name": "woman frowning: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 855,
		"display": 0,
		"shortname": ":woman_frowning_tone4:",
		"shortname_alternates": [
			":woman_frowning_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fe-2640",
			"fully_qualified": "1f64d-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-1f3fe-200d-2640",
			"output": "1f64d-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f64d-1f3fe-200d-2640-fe0f",
				"1f64d-1f3fe-200d-2640",
				"1f64d-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fe-200d-2640-fe0f",
				"1f64d-1f3fe-200d-2640",
				"1f64d-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f64d-1f3fd-2640": {
		"name": "woman frowning: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 856,
		"display": 0,
		"shortname": ":woman_frowning_tone3:",
		"shortname_alternates": [
			":woman_frowning_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fd-2640",
			"fully_qualified": "1f64d-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-1f3fd-200d-2640",
			"output": "1f64d-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f64d-1f3fd-200d-2640-fe0f",
				"1f64d-1f3fd-200d-2640",
				"1f64d-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fd-200d-2640-fe0f",
				"1f64d-1f3fd-200d-2640",
				"1f64d-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"medium skin tone",
			"woman"
		]
	},
	"1f64d-1f3fc-2640": {
		"name": "woman frowning: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 857,
		"display": 0,
		"shortname": ":woman_frowning_tone2:",
		"shortname_alternates": [
			":woman_frowning_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fc-2640",
			"fully_qualified": "1f64d-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-1f3fc-200d-2640",
			"output": "1f64d-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f64d-1f3fc-200d-2640-fe0f",
				"1f64d-1f3fc-200d-2640",
				"1f64d-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fc-200d-2640-fe0f",
				"1f64d-1f3fc-200d-2640",
				"1f64d-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f64d-1f3fb-2640": {
		"name": "woman frowning: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 858,
		"display": 0,
		"shortname": ":woman_frowning_tone1:",
		"shortname_alternates": [
			":woman_frowning_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f64d-1f3fb-2640",
			"fully_qualified": "1f64d-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f64d-1f3fb-200d-2640",
			"output": "1f64d-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f64d-1f3fb-200d-2640-fe0f",
				"1f64d-1f3fb-200d-2640",
				"1f64d-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f64d-1f3fb-200d-2640-fe0f",
				"1f64d-1f3fb-200d-2640",
				"1f64d-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"frowning",
			"gesture",
			"light skin tone",
			"woman"
		]
	},
	"1f487": {
		"name": "person getting haircut",
		"unicode_version": 6,
		"category": "people",
		"order": 859,
		"display": 1,
		"shortname": ":person_getting_haircut:",
		"shortname_alternates": [
			":haircut:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f487-1f3fb",
			"1f487-1f3fc",
			"1f487-1f3fd",
			"1f487-1f3fe",
			"1f487-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f487-2642",
			"1f487-2640"
		],
		"code_points": {
			"base": "1f487",
			"fully_qualified": "1f487",
			"non_fully_qualified": "1f487",
			"output": "1f487",
			"default_matches": [
				"1f487"
			],
			"greedy_matches": [
				"1f487"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"haircut",
			"parlor"
		]
	},
	"1f487-1f3fb": {
		"name": "person getting haircut: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 860,
		"display": 1,
		"shortname": ":person_getting_haircut_tone1:",
		"shortname_alternates": [
			":haircut_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f487-1f3fb-2642",
			"1f487-1f3fb-2640"
		],
		"code_points": {
			"base": "1f487-1f3fb",
			"fully_qualified": "1f487-1f3fb",
			"non_fully_qualified": "1f487-1f3fb",
			"output": "1f487-1f3fb",
			"default_matches": [
				"1f487-1f3fb"
			],
			"greedy_matches": [
				"1f487-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"haircut",
			"light skin tone",
			"parlor"
		]
	},
	"1f487-1f3fc": {
		"name": "person getting haircut: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 861,
		"display": 1,
		"shortname": ":person_getting_haircut_tone2:",
		"shortname_alternates": [
			":haircut_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f487-1f3fc-2642",
			"1f487-1f3fc-2640"
		],
		"code_points": {
			"base": "1f487-1f3fc",
			"fully_qualified": "1f487-1f3fc",
			"non_fully_qualified": "1f487-1f3fc",
			"output": "1f487-1f3fc",
			"default_matches": [
				"1f487-1f3fc"
			],
			"greedy_matches": [
				"1f487-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"haircut",
			"medium-light skin tone",
			"parlor"
		]
	},
	"1f487-1f3fd": {
		"name": "person getting haircut: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 862,
		"display": 1,
		"shortname": ":person_getting_haircut_tone3:",
		"shortname_alternates": [
			":haircut_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f487-1f3fd-2642",
			"1f487-1f3fd-2640"
		],
		"code_points": {
			"base": "1f487-1f3fd",
			"fully_qualified": "1f487-1f3fd",
			"non_fully_qualified": "1f487-1f3fd",
			"output": "1f487-1f3fd",
			"default_matches": [
				"1f487-1f3fd"
			],
			"greedy_matches": [
				"1f487-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"haircut",
			"medium skin tone",
			"parlor"
		]
	},
	"1f487-1f3fe": {
		"name": "person getting haircut: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 863,
		"display": 1,
		"shortname": ":person_getting_haircut_tone4:",
		"shortname_alternates": [
			":haircut_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f487-1f3fe-2642",
			"1f487-1f3fe-2640"
		],
		"code_points": {
			"base": "1f487-1f3fe",
			"fully_qualified": "1f487-1f3fe",
			"non_fully_qualified": "1f487-1f3fe",
			"output": "1f487-1f3fe",
			"default_matches": [
				"1f487-1f3fe"
			],
			"greedy_matches": [
				"1f487-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"haircut",
			"medium-dark skin tone",
			"parlor"
		]
	},
	"1f487-1f3ff": {
		"name": "person getting haircut: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 864,
		"display": 1,
		"shortname": ":person_getting_haircut_tone5:",
		"shortname_alternates": [
			":haircut_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f487-1f3ff-2642",
			"1f487-1f3ff-2640"
		],
		"code_points": {
			"base": "1f487-1f3ff",
			"fully_qualified": "1f487-1f3ff",
			"non_fully_qualified": "1f487-1f3ff",
			"output": "1f487-1f3ff",
			"default_matches": [
				"1f487-1f3ff"
			],
			"greedy_matches": [
				"1f487-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"beauty",
			"dark skin tone",
			"haircut",
			"parlor"
		]
	},
	"1f487-2642": {
		"name": "man getting haircut",
		"unicode_version": 6,
		"category": "people",
		"order": 865,
		"display": 1,
		"shortname": ":man_getting_haircut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f487-1f3fb-2642",
			"1f487-1f3fc-2642",
			"1f487-1f3fd-2642",
			"1f487-1f3fe-2642",
			"1f487-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-2642",
			"fully_qualified": "1f487-200d-2642-fe0f",
			"non_fully_qualified": "1f487-200d-2642",
			"output": "1f487-200d-2642-fe0f",
			"default_matches": [
				"1f487-200d-2642-fe0f",
				"1f487-200d-2642",
				"1f487-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-200d-2642-fe0f",
				"1f487-200d-2642",
				"1f487-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"man"
		]
	},
	"1f487-1f3fb-2642": {
		"name": "man getting haircut: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 866,
		"display": 1,
		"shortname": ":man_getting_haircut_tone1:",
		"shortname_alternates": [
			":man_getting_haircut_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fb-2642",
			"fully_qualified": "1f487-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f487-1f3fb-200d-2642",
			"output": "1f487-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f487-1f3fb-200d-2642-fe0f",
				"1f487-1f3fb-200d-2642",
				"1f487-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fb-200d-2642-fe0f",
				"1f487-1f3fb-200d-2642",
				"1f487-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"light skin tone",
			"man"
		]
	},
	"1f487-1f3fc-2642": {
		"name": "man getting haircut: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 867,
		"display": 1,
		"shortname": ":man_getting_haircut_tone2:",
		"shortname_alternates": [
			":man_getting_haircut_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fc-2642",
			"fully_qualified": "1f487-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f487-1f3fc-200d-2642",
			"output": "1f487-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f487-1f3fc-200d-2642-fe0f",
				"1f487-1f3fc-200d-2642",
				"1f487-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fc-200d-2642-fe0f",
				"1f487-1f3fc-200d-2642",
				"1f487-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"man",
			"medium-light skin tone"
		]
	},
	"1f487-1f3fd-2642": {
		"name": "man getting haircut: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 868,
		"display": 1,
		"shortname": ":man_getting_haircut_tone3:",
		"shortname_alternates": [
			":man_getting_haircut_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fd-2642",
			"fully_qualified": "1f487-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f487-1f3fd-200d-2642",
			"output": "1f487-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f487-1f3fd-200d-2642-fe0f",
				"1f487-1f3fd-200d-2642",
				"1f487-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fd-200d-2642-fe0f",
				"1f487-1f3fd-200d-2642",
				"1f487-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"man",
			"medium skin tone"
		]
	},
	"1f487-1f3fe-2642": {
		"name": "man getting haircut: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 869,
		"display": 1,
		"shortname": ":man_getting_haircut_tone4:",
		"shortname_alternates": [
			":man_getting_haircut_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fe-2642",
			"fully_qualified": "1f487-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f487-1f3fe-200d-2642",
			"output": "1f487-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f487-1f3fe-200d-2642-fe0f",
				"1f487-1f3fe-200d-2642",
				"1f487-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fe-200d-2642-fe0f",
				"1f487-1f3fe-200d-2642",
				"1f487-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f487-1f3ff-2642": {
		"name": "man getting haircut: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 870,
		"display": 1,
		"shortname": ":man_getting_haircut_tone5:",
		"shortname_alternates": [
			":man_getting_haircut_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3ff-2642",
			"fully_qualified": "1f487-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f487-1f3ff-200d-2642",
			"output": "1f487-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f487-1f3ff-200d-2642-fe0f",
				"1f487-1f3ff-200d-2642",
				"1f487-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3ff-200d-2642-fe0f",
				"1f487-1f3ff-200d-2642",
				"1f487-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"haircut",
			"man"
		]
	},
	"1f487-2640": {
		"name": "woman getting haircut",
		"unicode_version": 6,
		"category": "people",
		"order": 871,
		"display": 0,
		"shortname": ":woman_getting_haircut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f487-1f3fb-2640",
			"1f487-1f3fc-2640",
			"1f487-1f3fd-2640",
			"1f487-1f3fe-2640",
			"1f487-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-2640",
			"fully_qualified": "1f487-200d-2640-fe0f",
			"non_fully_qualified": "1f487-200d-2640",
			"output": "1f487-200d-2640-fe0f",
			"default_matches": [
				"1f487-200d-2640-fe0f",
				"1f487-200d-2640",
				"1f487-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-200d-2640-fe0f",
				"1f487-200d-2640",
				"1f487-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"woman"
		]
	},
	"1f487-1f3ff-2640": {
		"name": "woman getting haircut: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 872,
		"display": 0,
		"shortname": ":woman_getting_haircut_tone5:",
		"shortname_alternates": [
			":woman_getting_haircut_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3ff-2640",
			"fully_qualified": "1f487-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f487-1f3ff-200d-2640",
			"output": "1f487-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f487-1f3ff-200d-2640-fe0f",
				"1f487-1f3ff-200d-2640",
				"1f487-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3ff-200d-2640-fe0f",
				"1f487-1f3ff-200d-2640",
				"1f487-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"haircut",
			"woman"
		]
	},
	"1f487-1f3fe-2640": {
		"name": "woman getting haircut: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 873,
		"display": 0,
		"shortname": ":woman_getting_haircut_tone4:",
		"shortname_alternates": [
			":woman_getting_haircut_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fe-2640",
			"fully_qualified": "1f487-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f487-1f3fe-200d-2640",
			"output": "1f487-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f487-1f3fe-200d-2640-fe0f",
				"1f487-1f3fe-200d-2640",
				"1f487-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fe-200d-2640-fe0f",
				"1f487-1f3fe-200d-2640",
				"1f487-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f487-1f3fd-2640": {
		"name": "woman getting haircut: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 874,
		"display": 0,
		"shortname": ":woman_getting_haircut_tone3:",
		"shortname_alternates": [
			":woman_getting_haircut_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fd-2640",
			"fully_qualified": "1f487-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f487-1f3fd-200d-2640",
			"output": "1f487-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f487-1f3fd-200d-2640-fe0f",
				"1f487-1f3fd-200d-2640",
				"1f487-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fd-200d-2640-fe0f",
				"1f487-1f3fd-200d-2640",
				"1f487-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"medium skin tone",
			"woman"
		]
	},
	"1f487-1f3fc-2640": {
		"name": "woman getting haircut: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 875,
		"display": 0,
		"shortname": ":woman_getting_haircut_tone2:",
		"shortname_alternates": [
			":woman_getting_haircut_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fc-2640",
			"fully_qualified": "1f487-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f487-1f3fc-200d-2640",
			"output": "1f487-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f487-1f3fc-200d-2640-fe0f",
				"1f487-1f3fc-200d-2640",
				"1f487-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fc-200d-2640-fe0f",
				"1f487-1f3fc-200d-2640",
				"1f487-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f487-1f3fb-2640": {
		"name": "woman getting haircut: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 876,
		"display": 0,
		"shortname": ":woman_getting_haircut_tone1:",
		"shortname_alternates": [
			":woman_getting_haircut_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f487-1f3fb-2640",
			"fully_qualified": "1f487-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f487-1f3fb-200d-2640",
			"output": "1f487-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f487-1f3fb-200d-2640-fe0f",
				"1f487-1f3fb-200d-2640",
				"1f487-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f487-1f3fb-200d-2640-fe0f",
				"1f487-1f3fb-200d-2640",
				"1f487-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"haircut",
			"light skin tone",
			"woman"
		]
	},
	"1f486": {
		"name": "person getting massage",
		"unicode_version": 6,
		"category": "people",
		"order": 877,
		"display": 1,
		"shortname": ":person_getting_massage:",
		"shortname_alternates": [
			":massage:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f486-1f3fb",
			"1f486-1f3fc",
			"1f486-1f3fd",
			"1f486-1f3fe",
			"1f486-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f486-2642",
			"1f486-2640"
		],
		"code_points": {
			"base": "1f486",
			"fully_qualified": "1f486",
			"non_fully_qualified": "1f486",
			"output": "1f486",
			"default_matches": [
				"1f486"
			],
			"greedy_matches": [
				"1f486"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"salon"
		]
	},
	"1f486-1f3fb": {
		"name": "person getting massage: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 878,
		"display": 1,
		"shortname": ":person_getting_massage_tone1:",
		"shortname_alternates": [
			":massage_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f486-1f3fb-2642",
			"1f486-1f3fb-2640"
		],
		"code_points": {
			"base": "1f486-1f3fb",
			"fully_qualified": "1f486-1f3fb",
			"non_fully_qualified": "1f486-1f3fb",
			"output": "1f486-1f3fb",
			"default_matches": [
				"1f486-1f3fb"
			],
			"greedy_matches": [
				"1f486-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"light skin tone",
			"massage",
			"salon"
		]
	},
	"1f486-1f3fc": {
		"name": "person getting massage: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 879,
		"display": 1,
		"shortname": ":person_getting_massage_tone2:",
		"shortname_alternates": [
			":massage_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f486-1f3fc-2642",
			"1f486-1f3fc-2640"
		],
		"code_points": {
			"base": "1f486-1f3fc",
			"fully_qualified": "1f486-1f3fc",
			"non_fully_qualified": "1f486-1f3fc",
			"output": "1f486-1f3fc",
			"default_matches": [
				"1f486-1f3fc"
			],
			"greedy_matches": [
				"1f486-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium-light skin tone",
			"salon"
		]
	},
	"1f486-1f3fd": {
		"name": "person getting massage: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 880,
		"display": 1,
		"shortname": ":person_getting_massage_tone3:",
		"shortname_alternates": [
			":massage_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f486-1f3fd-2642",
			"1f486-1f3fd-2640"
		],
		"code_points": {
			"base": "1f486-1f3fd",
			"fully_qualified": "1f486-1f3fd",
			"non_fully_qualified": "1f486-1f3fd",
			"output": "1f486-1f3fd",
			"default_matches": [
				"1f486-1f3fd"
			],
			"greedy_matches": [
				"1f486-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium skin tone",
			"salon"
		]
	},
	"1f486-1f3fe": {
		"name": "person getting massage: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 881,
		"display": 1,
		"shortname": ":person_getting_massage_tone4:",
		"shortname_alternates": [
			":massage_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f486-1f3fe-2642",
			"1f486-1f3fe-2640"
		],
		"code_points": {
			"base": "1f486-1f3fe",
			"fully_qualified": "1f486-1f3fe",
			"non_fully_qualified": "1f486-1f3fe",
			"output": "1f486-1f3fe",
			"default_matches": [
				"1f486-1f3fe"
			],
			"greedy_matches": [
				"1f486-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium-dark skin tone",
			"salon"
		]
	},
	"1f486-1f3ff": {
		"name": "person getting massage: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 882,
		"display": 1,
		"shortname": ":person_getting_massage_tone5:",
		"shortname_alternates": [
			":massage_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f486-1f3ff-2642",
			"1f486-1f3ff-2640"
		],
		"code_points": {
			"base": "1f486-1f3ff",
			"fully_qualified": "1f486-1f3ff",
			"non_fully_qualified": "1f486-1f3ff",
			"output": "1f486-1f3ff",
			"default_matches": [
				"1f486-1f3ff"
			],
			"greedy_matches": [
				"1f486-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"face",
			"massage",
			"salon"
		]
	},
	"1f486-2642": {
		"name": "man getting massage",
		"unicode_version": 6,
		"category": "people",
		"order": 883,
		"display": 1,
		"shortname": ":man_getting_face_massage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f486-1f3fb-2642",
			"1f486-1f3fc-2642",
			"1f486-1f3fd-2642",
			"1f486-1f3fe-2642",
			"1f486-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-2642",
			"fully_qualified": "1f486-200d-2642-fe0f",
			"non_fully_qualified": "1f486-200d-2642",
			"output": "1f486-200d-2642-fe0f",
			"default_matches": [
				"1f486-200d-2642-fe0f",
				"1f486-200d-2642",
				"1f486-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-200d-2642-fe0f",
				"1f486-200d-2642",
				"1f486-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"man",
			"massage"
		]
	},
	"1f486-1f3fb-2642": {
		"name": "man getting massage: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 884,
		"display": 1,
		"shortname": ":man_getting_face_massage_tone1:",
		"shortname_alternates": [
			":man_getting_face_massage_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fb-2642",
			"fully_qualified": "1f486-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f486-1f3fb-200d-2642",
			"output": "1f486-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f486-1f3fb-200d-2642-fe0f",
				"1f486-1f3fb-200d-2642",
				"1f486-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fb-200d-2642-fe0f",
				"1f486-1f3fb-200d-2642",
				"1f486-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"light skin tone",
			"man",
			"massage"
		]
	},
	"1f486-1f3fc-2642": {
		"name": "man getting massage: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 885,
		"display": 1,
		"shortname": ":man_getting_face_massage_tone2:",
		"shortname_alternates": [
			":man_getting_face_massage_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fc-2642",
			"fully_qualified": "1f486-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f486-1f3fc-200d-2642",
			"output": "1f486-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f486-1f3fc-200d-2642-fe0f",
				"1f486-1f3fc-200d-2642",
				"1f486-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fc-200d-2642-fe0f",
				"1f486-1f3fc-200d-2642",
				"1f486-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"man",
			"massage",
			"medium-light skin tone"
		]
	},
	"1f486-1f3fd-2642": {
		"name": "man getting massage: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 886,
		"display": 1,
		"shortname": ":man_getting_face_massage_tone3:",
		"shortname_alternates": [
			":man_getting_face_massage_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fd-2642",
			"fully_qualified": "1f486-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f486-1f3fd-200d-2642",
			"output": "1f486-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f486-1f3fd-200d-2642-fe0f",
				"1f486-1f3fd-200d-2642",
				"1f486-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fd-200d-2642-fe0f",
				"1f486-1f3fd-200d-2642",
				"1f486-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"man",
			"massage",
			"medium skin tone"
		]
	},
	"1f486-1f3fe-2642": {
		"name": "man getting massage: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 887,
		"display": 1,
		"shortname": ":man_getting_face_massage_tone4:",
		"shortname_alternates": [
			":man_getting_face_massage_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fe-2642",
			"fully_qualified": "1f486-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f486-1f3fe-200d-2642",
			"output": "1f486-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f486-1f3fe-200d-2642-fe0f",
				"1f486-1f3fe-200d-2642",
				"1f486-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fe-200d-2642-fe0f",
				"1f486-1f3fe-200d-2642",
				"1f486-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"man",
			"massage",
			"medium-dark skin tone"
		]
	},
	"1f486-1f3ff-2642": {
		"name": "man getting massage: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 888,
		"display": 1,
		"shortname": ":man_getting_face_massage_tone5:",
		"shortname_alternates": [
			":man_getting_face_massage_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3ff-2642",
			"fully_qualified": "1f486-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f486-1f3ff-200d-2642",
			"output": "1f486-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f486-1f3ff-200d-2642-fe0f",
				"1f486-1f3ff-200d-2642",
				"1f486-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3ff-200d-2642-fe0f",
				"1f486-1f3ff-200d-2642",
				"1f486-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"face",
			"man",
			"massage"
		]
	},
	"1f486-2640": {
		"name": "woman getting massage",
		"unicode_version": 6,
		"category": "people",
		"order": 889,
		"display": 0,
		"shortname": ":woman_getting_face_massage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f486-1f3fb-2640",
			"1f486-1f3fc-2640",
			"1f486-1f3fd-2640",
			"1f486-1f3fe-2640",
			"1f486-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-2640",
			"fully_qualified": "1f486-200d-2640-fe0f",
			"non_fully_qualified": "1f486-200d-2640",
			"output": "1f486-200d-2640-fe0f",
			"default_matches": [
				"1f486-200d-2640-fe0f",
				"1f486-200d-2640",
				"1f486-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-200d-2640-fe0f",
				"1f486-200d-2640",
				"1f486-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"woman"
		]
	},
	"1f486-1f3ff-2640": {
		"name": "woman getting massage: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 890,
		"display": 0,
		"shortname": ":woman_getting_face_massage_tone5:",
		"shortname_alternates": [
			":woman_getting_face_massage_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3ff-2640",
			"fully_qualified": "1f486-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f486-1f3ff-200d-2640",
			"output": "1f486-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f486-1f3ff-200d-2640-fe0f",
				"1f486-1f3ff-200d-2640",
				"1f486-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3ff-200d-2640-fe0f",
				"1f486-1f3ff-200d-2640",
				"1f486-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"face",
			"massage",
			"woman"
		]
	},
	"1f486-1f3fe-2640": {
		"name": "woman getting massage: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 891,
		"display": 0,
		"shortname": ":woman_getting_face_massage_tone4:",
		"shortname_alternates": [
			":woman_getting_face_massage_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fe-2640",
			"fully_qualified": "1f486-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f486-1f3fe-200d-2640",
			"output": "1f486-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f486-1f3fe-200d-2640-fe0f",
				"1f486-1f3fe-200d-2640",
				"1f486-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fe-200d-2640-fe0f",
				"1f486-1f3fe-200d-2640",
				"1f486-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f486-1f3fd-2640": {
		"name": "woman getting massage: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 892,
		"display": 0,
		"shortname": ":woman_getting_face_massage_tone3:",
		"shortname_alternates": [
			":woman_getting_face_massage_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fd-2640",
			"fully_qualified": "1f486-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f486-1f3fd-200d-2640",
			"output": "1f486-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f486-1f3fd-200d-2640-fe0f",
				"1f486-1f3fd-200d-2640",
				"1f486-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fd-200d-2640-fe0f",
				"1f486-1f3fd-200d-2640",
				"1f486-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium skin tone",
			"woman"
		]
	},
	"1f486-1f3fc-2640": {
		"name": "woman getting massage: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 893,
		"display": 0,
		"shortname": ":woman_getting_face_massage_tone2:",
		"shortname_alternates": [
			":woman_getting_face_massage_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fc-2640",
			"fully_qualified": "1f486-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f486-1f3fc-200d-2640",
			"output": "1f486-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f486-1f3fc-200d-2640-fe0f",
				"1f486-1f3fc-200d-2640",
				"1f486-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fc-200d-2640-fe0f",
				"1f486-1f3fc-200d-2640",
				"1f486-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"massage",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f486-1f3fb-2640": {
		"name": "woman getting massage: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 894,
		"display": 0,
		"shortname": ":woman_getting_face_massage_tone1:",
		"shortname_alternates": [
			":woman_getting_face_massage_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f486-1f3fb-2640",
			"fully_qualified": "1f486-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f486-1f3fb-200d-2640",
			"output": "1f486-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f486-1f3fb-200d-2640-fe0f",
				"1f486-1f3fb-200d-2640",
				"1f486-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f486-1f3fb-200d-2640-fe0f",
				"1f486-1f3fb-200d-2640",
				"1f486-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"light skin tone",
			"massage",
			"woman"
		]
	},
	"1f574": {
		"name": "man in business suit levitating",
		"unicode_version": 7,
		"category": "people",
		"order": 895,
		"display": 1,
		"shortname": ":levitate:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f574-1f3fb",
			"1f574-1f3fc",
			"1f574-1f3fd",
			"1f574-1f3fe",
			"1f574-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574",
			"fully_qualified": "1f574-fe0f",
			"non_fully_qualified": "1f574",
			"output": "1f574-fe0f",
			"default_matches": [
				"1f574-fe0f",
				"1f574"
			],
			"greedy_matches": [
				"1f574-fe0f",
				"1f574"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"man",
			"suit"
		]
	},
	"1f574-1f3fb": {
		"name": "man in business suit levitating: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 896,
		"display": 1,
		"shortname": ":man_in_business_suit_levitating_tone1:",
		"shortname_alternates": [
			":man_in_business_suit_levitating_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574-1f3fb",
			"fully_qualified": "1f574-1f3fb",
			"non_fully_qualified": "1f574-1f3fb",
			"output": "1f574-1f3fb",
			"default_matches": [
				"1f574-1f3fb",
				"1f574-fe0f-1f3fb"
			],
			"greedy_matches": [
				"1f574-1f3fb",
				"1f574-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"light skin tone",
			"man",
			"suit"
		]
	},
	"1f574-1f3fc": {
		"name": "man in business suit levitating: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 897,
		"display": 1,
		"shortname": ":man_in_business_suit_levitating_tone2:",
		"shortname_alternates": [
			":man_in_business_suit_levitating_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574-1f3fc",
			"fully_qualified": "1f574-1f3fc",
			"non_fully_qualified": "1f574-1f3fc",
			"output": "1f574-1f3fc",
			"default_matches": [
				"1f574-1f3fc",
				"1f574-fe0f-1f3fc"
			],
			"greedy_matches": [
				"1f574-1f3fc",
				"1f574-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"man",
			"medium-light skin tone",
			"suit"
		]
	},
	"1f574-1f3fd": {
		"name": "man in business suit levitating: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 898,
		"display": 1,
		"shortname": ":man_in_business_suit_levitating_tone3:",
		"shortname_alternates": [
			":man_in_business_suit_levitating_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574-1f3fd",
			"fully_qualified": "1f574-1f3fd",
			"non_fully_qualified": "1f574-1f3fd",
			"output": "1f574-1f3fd",
			"default_matches": [
				"1f574-1f3fd",
				"1f574-fe0f-1f3fd"
			],
			"greedy_matches": [
				"1f574-1f3fd",
				"1f574-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"man",
			"medium skin tone",
			"suit"
		]
	},
	"1f574-1f3fe": {
		"name": "man in business suit levitating: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 899,
		"display": 1,
		"shortname": ":man_in_business_suit_levitating_tone4:",
		"shortname_alternates": [
			":man_in_business_suit_levitating_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574-1f3fe",
			"fully_qualified": "1f574-1f3fe",
			"non_fully_qualified": "1f574-1f3fe",
			"output": "1f574-1f3fe",
			"default_matches": [
				"1f574-1f3fe",
				"1f574-fe0f-1f3fe"
			],
			"greedy_matches": [
				"1f574-1f3fe",
				"1f574-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"man",
			"medium-dark skin tone",
			"suit"
		]
	},
	"1f574-1f3ff": {
		"name": "man in business suit levitating: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 900,
		"display": 1,
		"shortname": ":man_in_business_suit_levitating_tone5:",
		"shortname_alternates": [
			":man_in_business_suit_levitating_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f574-1f3ff",
			"fully_qualified": "1f574-1f3ff",
			"non_fully_qualified": "1f574-1f3ff",
			"output": "1f574-1f3ff",
			"default_matches": [
				"1f574-1f3ff",
				"1f574-fe0f-1f3ff"
			],
			"greedy_matches": [
				"1f574-1f3ff",
				"1f574-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"business",
			"dark skin tone",
			"man",
			"suit"
		]
	},
	"1f483": {
		"name": "woman dancing",
		"unicode_version": 6,
		"category": "people",
		"order": 901,
		"display": 1,
		"shortname": ":dancer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f483-1f3fb",
			"1f483-1f3fc",
			"1f483-1f3fd",
			"1f483-1f3fe",
			"1f483-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483",
			"fully_qualified": "1f483",
			"non_fully_qualified": "1f483",
			"output": "1f483",
			"default_matches": [
				"1f483"
			],
			"greedy_matches": [
				"1f483"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"woman"
		]
	},
	"1f483-1f3fb": {
		"name": "woman dancing: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 902,
		"display": 1,
		"shortname": ":dancer_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483-1f3fb",
			"fully_qualified": "1f483-1f3fb",
			"non_fully_qualified": "1f483-1f3fb",
			"output": "1f483-1f3fb",
			"default_matches": [
				"1f483-1f3fb"
			],
			"greedy_matches": [
				"1f483-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"light skin tone",
			"woman"
		]
	},
	"1f483-1f3fc": {
		"name": "woman dancing: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 903,
		"display": 1,
		"shortname": ":dancer_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483-1f3fc",
			"fully_qualified": "1f483-1f3fc",
			"non_fully_qualified": "1f483-1f3fc",
			"output": "1f483-1f3fc",
			"default_matches": [
				"1f483-1f3fc"
			],
			"greedy_matches": [
				"1f483-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f483-1f3fd": {
		"name": "woman dancing: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 904,
		"display": 1,
		"shortname": ":dancer_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483-1f3fd",
			"fully_qualified": "1f483-1f3fd",
			"non_fully_qualified": "1f483-1f3fd",
			"output": "1f483-1f3fd",
			"default_matches": [
				"1f483-1f3fd"
			],
			"greedy_matches": [
				"1f483-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"medium skin tone",
			"woman"
		]
	},
	"1f483-1f3fe": {
		"name": "woman dancing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 905,
		"display": 1,
		"shortname": ":dancer_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483-1f3fe",
			"fully_qualified": "1f483-1f3fe",
			"non_fully_qualified": "1f483-1f3fe",
			"output": "1f483-1f3fe",
			"default_matches": [
				"1f483-1f3fe"
			],
			"greedy_matches": [
				"1f483-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f483-1f3ff": {
		"name": "woman dancing: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 906,
		"display": 1,
		"shortname": ":dancer_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f483-1f3ff",
			"fully_qualified": "1f483-1f3ff",
			"non_fully_qualified": "1f483-1f3ff",
			"output": "1f483-1f3ff",
			"default_matches": [
				"1f483-1f3ff"
			],
			"greedy_matches": [
				"1f483-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dancing",
			"dark skin tone",
			"woman"
		]
	},
	"1f57a": {
		"name": "man dancing",
		"unicode_version": 9,
		"category": "people",
		"order": 907,
		"display": 1,
		"shortname": ":man_dancing:",
		"shortname_alternates": [
			":male_dancer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f57a-1f3fb",
			"1f57a-1f3fc",
			"1f57a-1f3fd",
			"1f57a-1f3fe",
			"1f57a-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a",
			"fully_qualified": "1f57a",
			"non_fully_qualified": "1f57a",
			"output": "1f57a",
			"default_matches": [
				"1f57a"
			],
			"greedy_matches": [
				"1f57a"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"man"
		]
	},
	"1f57a-1f3fb": {
		"name": "man dancing: light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 908,
		"display": 1,
		"shortname": ":man_dancing_tone1:",
		"shortname_alternates": [
			":male_dancer_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a-1f3fb",
			"fully_qualified": "1f57a-1f3fb",
			"non_fully_qualified": "1f57a-1f3fb",
			"output": "1f57a-1f3fb",
			"default_matches": [
				"1f57a-1f3fb"
			],
			"greedy_matches": [
				"1f57a-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"light skin tone",
			"man"
		]
	},
	"1f57a-1f3fc": {
		"name": "man dancing: medium-light skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 909,
		"display": 1,
		"shortname": ":man_dancing_tone2:",
		"shortname_alternates": [
			":male_dancer_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a-1f3fc",
			"fully_qualified": "1f57a-1f3fc",
			"non_fully_qualified": "1f57a-1f3fc",
			"output": "1f57a-1f3fc",
			"default_matches": [
				"1f57a-1f3fc"
			],
			"greedy_matches": [
				"1f57a-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"man",
			"medium-light skin tone"
		]
	},
	"1f57a-1f3fd": {
		"name": "man dancing: medium skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 910,
		"display": 1,
		"shortname": ":man_dancing_tone3:",
		"shortname_alternates": [
			":male_dancer_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a-1f3fd",
			"fully_qualified": "1f57a-1f3fd",
			"non_fully_qualified": "1f57a-1f3fd",
			"output": "1f57a-1f3fd",
			"default_matches": [
				"1f57a-1f3fd"
			],
			"greedy_matches": [
				"1f57a-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"man",
			"medium skin tone"
		]
	},
	"1f57a-1f3fe": {
		"name": "man dancing: medium-dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 911,
		"display": 1,
		"shortname": ":man_dancing_tone4:",
		"shortname_alternates": [
			":male_dancer_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a-1f3fe",
			"fully_qualified": "1f57a-1f3fe",
			"non_fully_qualified": "1f57a-1f3fe",
			"output": "1f57a-1f3fe",
			"default_matches": [
				"1f57a-1f3fe"
			],
			"greedy_matches": [
				"1f57a-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f57a-1f3ff": {
		"name": "man dancing: dark skin tone",
		"unicode_version": 9,
		"category": "people",
		"order": 912,
		"display": 1,
		"shortname": ":man_dancing_tone5:",
		"shortname_alternates": [
			":male_dancer_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f57a-1f3ff",
			"fully_qualified": "1f57a-1f3ff",
			"non_fully_qualified": "1f57a-1f3ff",
			"output": "1f57a-1f3ff",
			"default_matches": [
				"1f57a-1f3ff"
			],
			"greedy_matches": [
				"1f57a-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dance",
			"dark skin tone",
			"man"
		]
	},
	"1f46f": {
		"name": "people with bunny ears partying",
		"unicode_version": 6,
		"category": "people",
		"order": 913,
		"display": 1,
		"shortname": ":people_with_bunny_ears_partying:",
		"shortname_alternates": [
			":dancers:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [
			"1f46f-2642",
			"1f46f-2640"
		],
		"code_points": {
			"base": "1f46f",
			"fully_qualified": "1f46f",
			"non_fully_qualified": "1f46f",
			"output": "1f46f",
			"default_matches": [
				"1f46f"
			],
			"greedy_matches": [
				"1f46f"
			],
			"decimal": ""
		},
		"keywords": [
			"bunny ear",
			"dancer",
			"partying"
		]
	},
	"1f46f-2642": {
		"name": "men with bunny ears partying",
		"unicode_version": 6,
		"category": "people",
		"order": 914,
		"display": 1,
		"shortname": ":men_with_bunny_ears_partying:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f46f-2642",
			"fully_qualified": "1f46f-200d-2642-fe0f",
			"non_fully_qualified": "1f46f-200d-2642",
			"output": "1f46f-200d-2642-fe0f",
			"default_matches": [
				"1f46f-200d-2642-fe0f",
				"1f46f-200d-2642",
				"1f46f-2642-fe0f"
			],
			"greedy_matches": [
				"1f46f-200d-2642-fe0f",
				"1f46f-200d-2642",
				"1f46f-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bunny ear",
			"dancer",
			"men",
			"partying"
		]
	},
	"1f46f-2640": {
		"name": "women with bunny ears partying",
		"unicode_version": 6,
		"category": "people",
		"order": 915,
		"display": 0,
		"shortname": ":women_with_bunny_ears_partying:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f46f-2640",
			"fully_qualified": "1f46f-200d-2640-fe0f",
			"non_fully_qualified": "1f46f-200d-2640",
			"output": "1f46f-200d-2640-fe0f",
			"default_matches": [
				"1f46f-200d-2640-fe0f",
				"1f46f-200d-2640",
				"1f46f-2640-fe0f"
			],
			"greedy_matches": [
				"1f46f-200d-2640-fe0f",
				"1f46f-200d-2640",
				"1f46f-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bunny ear",
			"dancer",
			"partying",
			"women"
		]
	},
	"1f6b6-2640": {
		"name": "woman walking",
		"unicode_version": 6,
		"category": "people",
		"order": 916,
		"display": 1,
		"shortname": ":woman_walking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b6-1f3fb-2640",
			"1f6b6-1f3fc-2640",
			"1f6b6-1f3fd-2640",
			"1f6b6-1f3fe-2640",
			"1f6b6-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-2640",
			"fully_qualified": "1f6b6-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-200d-2640",
			"output": "1f6b6-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-200d-2640-fe0f",
				"1f6b6-200d-2640",
				"1f6b6-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-200d-2640-fe0f",
				"1f6b6-200d-2640",
				"1f6b6-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"walk",
			"woman"
		]
	},
	"1f6b6-1f3fb-2640": {
		"name": "woman walking: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 917,
		"display": 1,
		"shortname": ":woman_walking_tone1:",
		"shortname_alternates": [
			":woman_walking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fb-2640",
			"fully_qualified": "1f6b6-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-1f3fb-200d-2640",
			"output": "1f6b6-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-1f3fb-200d-2640-fe0f",
				"1f6b6-1f3fb-200d-2640",
				"1f6b6-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fb-200d-2640-fe0f",
				"1f6b6-1f3fb-200d-2640",
				"1f6b6-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"light skin tone",
			"walk",
			"woman"
		]
	},
	"1f6b6-1f3fc-2640": {
		"name": "woman walking: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 918,
		"display": 1,
		"shortname": ":woman_walking_tone2:",
		"shortname_alternates": [
			":woman_walking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fc-2640",
			"fully_qualified": "1f6b6-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-1f3fc-200d-2640",
			"output": "1f6b6-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-1f3fc-200d-2640-fe0f",
				"1f6b6-1f3fc-200d-2640",
				"1f6b6-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fc-200d-2640-fe0f",
				"1f6b6-1f3fc-200d-2640",
				"1f6b6-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium-light skin tone",
			"walk",
			"woman"
		]
	},
	"1f6b6-1f3fd-2640": {
		"name": "woman walking: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 919,
		"display": 1,
		"shortname": ":woman_walking_tone3:",
		"shortname_alternates": [
			":woman_walking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fd-2640",
			"fully_qualified": "1f6b6-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-1f3fd-200d-2640",
			"output": "1f6b6-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-1f3fd-200d-2640-fe0f",
				"1f6b6-1f3fd-200d-2640",
				"1f6b6-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fd-200d-2640-fe0f",
				"1f6b6-1f3fd-200d-2640",
				"1f6b6-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium skin tone",
			"walk",
			"woman"
		]
	},
	"1f6b6-1f3fe-2640": {
		"name": "woman walking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 920,
		"display": 1,
		"shortname": ":woman_walking_tone4:",
		"shortname_alternates": [
			":woman_walking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fe-2640",
			"fully_qualified": "1f6b6-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-1f3fe-200d-2640",
			"output": "1f6b6-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-1f3fe-200d-2640-fe0f",
				"1f6b6-1f3fe-200d-2640",
				"1f6b6-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fe-200d-2640-fe0f",
				"1f6b6-1f3fe-200d-2640",
				"1f6b6-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium-dark skin tone",
			"walk",
			"woman"
		]
	},
	"1f6b6-1f3ff-2640": {
		"name": "woman walking: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 921,
		"display": 1,
		"shortname": ":woman_walking_tone5:",
		"shortname_alternates": [
			":woman_walking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3ff-2640",
			"fully_qualified": "1f6b6-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f6b6-1f3ff-200d-2640",
			"output": "1f6b6-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f6b6-1f3ff-200d-2640-fe0f",
				"1f6b6-1f3ff-200d-2640",
				"1f6b6-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3ff-200d-2640-fe0f",
				"1f6b6-1f3ff-200d-2640",
				"1f6b6-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hike",
			"walk",
			"woman"
		]
	},
	"1f6b6": {
		"name": "person walking",
		"unicode_version": 6,
		"category": "people",
		"order": 922,
		"display": 1,
		"shortname": ":person_walking:",
		"shortname_alternates": [
			":walking:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b6-1f3fb",
			"1f6b6-1f3fc",
			"1f6b6-1f3fd",
			"1f6b6-1f3fe",
			"1f6b6-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f6b6-2642",
			"1f6b6-2640"
		],
		"code_points": {
			"base": "1f6b6",
			"fully_qualified": "1f6b6",
			"non_fully_qualified": "1f6b6",
			"output": "1f6b6",
			"default_matches": [
				"1f6b6"
			],
			"greedy_matches": [
				"1f6b6"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"walk",
			"walking"
		]
	},
	"1f6b6-1f3fb": {
		"name": "person walking: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 923,
		"display": 1,
		"shortname": ":person_walking_tone1:",
		"shortname_alternates": [
			":walking_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b6-1f3fb-2642",
			"1f6b6-1f3fb-2640"
		],
		"code_points": {
			"base": "1f6b6-1f3fb",
			"fully_qualified": "1f6b6-1f3fb",
			"non_fully_qualified": "1f6b6-1f3fb",
			"output": "1f6b6-1f3fb",
			"default_matches": [
				"1f6b6-1f3fb"
			],
			"greedy_matches": [
				"1f6b6-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"light skin tone",
			"walk",
			"walking"
		]
	},
	"1f6b6-1f3fc": {
		"name": "person walking: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 924,
		"display": 1,
		"shortname": ":person_walking_tone2:",
		"shortname_alternates": [
			":walking_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b6-1f3fc-2642",
			"1f6b6-1f3fc-2640"
		],
		"code_points": {
			"base": "1f6b6-1f3fc",
			"fully_qualified": "1f6b6-1f3fc",
			"non_fully_qualified": "1f6b6-1f3fc",
			"output": "1f6b6-1f3fc",
			"default_matches": [
				"1f6b6-1f3fc"
			],
			"greedy_matches": [
				"1f6b6-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium-light skin tone",
			"walk",
			"walking"
		]
	},
	"1f6b6-1f3fd": {
		"name": "person walking: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 925,
		"display": 1,
		"shortname": ":person_walking_tone3:",
		"shortname_alternates": [
			":walking_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b6-1f3fd-2642",
			"1f6b6-1f3fd-2640"
		],
		"code_points": {
			"base": "1f6b6-1f3fd",
			"fully_qualified": "1f6b6-1f3fd",
			"non_fully_qualified": "1f6b6-1f3fd",
			"output": "1f6b6-1f3fd",
			"default_matches": [
				"1f6b6-1f3fd"
			],
			"greedy_matches": [
				"1f6b6-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium skin tone",
			"walk",
			"walking"
		]
	},
	"1f6b6-1f3fe": {
		"name": "person walking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 926,
		"display": 1,
		"shortname": ":person_walking_tone4:",
		"shortname_alternates": [
			":walking_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b6-1f3fe-2642",
			"1f6b6-1f3fe-2640"
		],
		"code_points": {
			"base": "1f6b6-1f3fe",
			"fully_qualified": "1f6b6-1f3fe",
			"non_fully_qualified": "1f6b6-1f3fe",
			"output": "1f6b6-1f3fe",
			"default_matches": [
				"1f6b6-1f3fe"
			],
			"greedy_matches": [
				"1f6b6-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"medium-dark skin tone",
			"walk",
			"walking"
		]
	},
	"1f6b6-1f3ff": {
		"name": "person walking: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 927,
		"display": 1,
		"shortname": ":person_walking_tone5:",
		"shortname_alternates": [
			":walking_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b6-1f3ff-2642",
			"1f6b6-1f3ff-2640"
		],
		"code_points": {
			"base": "1f6b6-1f3ff",
			"fully_qualified": "1f6b6-1f3ff",
			"non_fully_qualified": "1f6b6-1f3ff",
			"output": "1f6b6-1f3ff",
			"default_matches": [
				"1f6b6-1f3ff"
			],
			"greedy_matches": [
				"1f6b6-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hike",
			"walk",
			"walking"
		]
	},
	"1f6b6-2642": {
		"name": "man walking",
		"unicode_version": 6,
		"category": "people",
		"order": 928,
		"display": 0,
		"shortname": ":man_walking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b6-1f3fb-2642",
			"1f6b6-1f3fc-2642",
			"1f6b6-1f3fd-2642",
			"1f6b6-1f3fe-2642",
			"1f6b6-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-2642",
			"fully_qualified": "1f6b6-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-200d-2642",
			"output": "1f6b6-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-200d-2642-fe0f",
				"1f6b6-200d-2642",
				"1f6b6-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-200d-2642-fe0f",
				"1f6b6-200d-2642",
				"1f6b6-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"man",
			"walk"
		]
	},
	"1f6b6-1f3ff-2642": {
		"name": "man walking: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 929,
		"display": 0,
		"shortname": ":man_walking_tone5:",
		"shortname_alternates": [
			":man_walking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3ff-2642",
			"fully_qualified": "1f6b6-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-1f3ff-200d-2642",
			"output": "1f6b6-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-1f3ff-200d-2642-fe0f",
				"1f6b6-1f3ff-200d-2642",
				"1f6b6-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3ff-200d-2642-fe0f",
				"1f6b6-1f3ff-200d-2642",
				"1f6b6-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hike",
			"man",
			"walk"
		]
	},
	"1f6b6-1f3fe-2642": {
		"name": "man walking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 930,
		"display": 0,
		"shortname": ":man_walking_tone4:",
		"shortname_alternates": [
			":man_walking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fe-2642",
			"fully_qualified": "1f6b6-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-1f3fe-200d-2642",
			"output": "1f6b6-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-1f3fe-200d-2642-fe0f",
				"1f6b6-1f3fe-200d-2642",
				"1f6b6-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fe-200d-2642-fe0f",
				"1f6b6-1f3fe-200d-2642",
				"1f6b6-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"man",
			"medium-dark skin tone",
			"walk"
		]
	},
	"1f6b6-1f3fd-2642": {
		"name": "man walking: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 931,
		"display": 0,
		"shortname": ":man_walking_tone3:",
		"shortname_alternates": [
			":man_walking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fd-2642",
			"fully_qualified": "1f6b6-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-1f3fd-200d-2642",
			"output": "1f6b6-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-1f3fd-200d-2642-fe0f",
				"1f6b6-1f3fd-200d-2642",
				"1f6b6-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fd-200d-2642-fe0f",
				"1f6b6-1f3fd-200d-2642",
				"1f6b6-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"man",
			"medium skin tone",
			"walk"
		]
	},
	"1f6b6-1f3fc-2642": {
		"name": "man walking: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 932,
		"display": 0,
		"shortname": ":man_walking_tone2:",
		"shortname_alternates": [
			":man_walking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fc-2642",
			"fully_qualified": "1f6b6-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-1f3fc-200d-2642",
			"output": "1f6b6-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-1f3fc-200d-2642-fe0f",
				"1f6b6-1f3fc-200d-2642",
				"1f6b6-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fc-200d-2642-fe0f",
				"1f6b6-1f3fc-200d-2642",
				"1f6b6-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"man",
			"medium-light skin tone",
			"walk"
		]
	},
	"1f6b6-1f3fb-2642": {
		"name": "man walking: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 933,
		"display": 0,
		"shortname": ":man_walking_tone1:",
		"shortname_alternates": [
			":man_walking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b6-1f3fb-2642",
			"fully_qualified": "1f6b6-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f6b6-1f3fb-200d-2642",
			"output": "1f6b6-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f6b6-1f3fb-200d-2642-fe0f",
				"1f6b6-1f3fb-200d-2642",
				"1f6b6-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b6-1f3fb-200d-2642-fe0f",
				"1f6b6-1f3fb-200d-2642",
				"1f6b6-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"hike",
			"light skin tone",
			"man",
			"walk"
		]
	},
	"1f3c3-2640": {
		"name": "woman running",
		"unicode_version": 6,
		"category": "people",
		"order": 934,
		"display": 1,
		"shortname": ":woman_running:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c3-1f3fb-2640",
			"1f3c3-1f3fc-2640",
			"1f3c3-1f3fd-2640",
			"1f3c3-1f3fe-2640",
			"1f3c3-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-2640",
			"fully_qualified": "1f3c3-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-200d-2640",
			"output": "1f3c3-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-200d-2640-fe0f",
				"1f3c3-200d-2640",
				"1f3c3-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-200d-2640-fe0f",
				"1f3c3-200d-2640",
				"1f3c3-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3-1f3fb-2640": {
		"name": "woman running: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 935,
		"display": 1,
		"shortname": ":woman_running_tone1:",
		"shortname_alternates": [
			":woman_running_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fb-2640",
			"fully_qualified": "1f3c3-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-1f3fb-200d-2640",
			"output": "1f3c3-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-1f3fb-200d-2640-fe0f",
				"1f3c3-1f3fb-200d-2640",
				"1f3c3-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fb-200d-2640-fe0f",
				"1f3c3-1f3fb-200d-2640",
				"1f3c3-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"marathon",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3-1f3fc-2640": {
		"name": "woman running: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 936,
		"display": 1,
		"shortname": ":woman_running_tone2:",
		"shortname_alternates": [
			":woman_running_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fc-2640",
			"fully_qualified": "1f3c3-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-1f3fc-200d-2640",
			"output": "1f3c3-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-1f3fc-200d-2640-fe0f",
				"1f3c3-1f3fc-200d-2640",
				"1f3c3-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fc-200d-2640-fe0f",
				"1f3c3-1f3fc-200d-2640",
				"1f3c3-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium-light skin tone",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3-1f3fd-2640": {
		"name": "woman running: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 937,
		"display": 1,
		"shortname": ":woman_running_tone3:",
		"shortname_alternates": [
			":woman_running_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fd-2640",
			"fully_qualified": "1f3c3-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-1f3fd-200d-2640",
			"output": "1f3c3-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-1f3fd-200d-2640-fe0f",
				"1f3c3-1f3fd-200d-2640",
				"1f3c3-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fd-200d-2640-fe0f",
				"1f3c3-1f3fd-200d-2640",
				"1f3c3-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium skin tone",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3-1f3fe-2640": {
		"name": "woman running: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 938,
		"display": 1,
		"shortname": ":woman_running_tone4:",
		"shortname_alternates": [
			":woman_running_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fe-2640",
			"fully_qualified": "1f3c3-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-1f3fe-200d-2640",
			"output": "1f3c3-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-1f3fe-200d-2640-fe0f",
				"1f3c3-1f3fe-200d-2640",
				"1f3c3-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fe-200d-2640-fe0f",
				"1f3c3-1f3fe-200d-2640",
				"1f3c3-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium-dark skin tone",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3-1f3ff-2640": {
		"name": "woman running: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 939,
		"display": 1,
		"shortname": ":woman_running_tone5:",
		"shortname_alternates": [
			":woman_running_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3ff-2640",
			"fully_qualified": "1f3c3-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f3c3-1f3ff-200d-2640",
			"output": "1f3c3-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f3c3-1f3ff-200d-2640-fe0f",
				"1f3c3-1f3ff-200d-2640",
				"1f3c3-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3ff-200d-2640-fe0f",
				"1f3c3-1f3ff-200d-2640",
				"1f3c3-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"marathon",
			"racing",
			"running",
			"woman"
		]
	},
	"1f3c3": {
		"name": "person running",
		"unicode_version": 6,
		"category": "people",
		"order": 940,
		"display": 1,
		"shortname": ":person_running:",
		"shortname_alternates": [
			":runner:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c3-1f3fb",
			"1f3c3-1f3fc",
			"1f3c3-1f3fd",
			"1f3c3-1f3fe",
			"1f3c3-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f3c3-2642",
			"1f3c3-2640"
		],
		"code_points": {
			"base": "1f3c3",
			"fully_qualified": "1f3c3",
			"non_fully_qualified": "1f3c3",
			"output": "1f3c3",
			"default_matches": [
				"1f3c3"
			],
			"greedy_matches": [
				"1f3c3"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"running"
		]
	},
	"1f3c3-1f3fb": {
		"name": "person running: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 941,
		"display": 1,
		"shortname": ":person_running_tone1:",
		"shortname_alternates": [
			":runner_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c3-1f3fb-2642",
			"1f3c3-1f3fb-2640"
		],
		"code_points": {
			"base": "1f3c3-1f3fb",
			"fully_qualified": "1f3c3-1f3fb",
			"non_fully_qualified": "1f3c3-1f3fb",
			"output": "1f3c3-1f3fb",
			"default_matches": [
				"1f3c3-1f3fb"
			],
			"greedy_matches": [
				"1f3c3-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"marathon",
			"running"
		]
	},
	"1f3c3-1f3fc": {
		"name": "person running: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 942,
		"display": 1,
		"shortname": ":person_running_tone2:",
		"shortname_alternates": [
			":runner_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c3-1f3fc-2642",
			"1f3c3-1f3fc-2640"
		],
		"code_points": {
			"base": "1f3c3-1f3fc",
			"fully_qualified": "1f3c3-1f3fc",
			"non_fully_qualified": "1f3c3-1f3fc",
			"output": "1f3c3-1f3fc",
			"default_matches": [
				"1f3c3-1f3fc"
			],
			"greedy_matches": [
				"1f3c3-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium-light skin tone",
			"running"
		]
	},
	"1f3c3-1f3fd": {
		"name": "person running: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 943,
		"display": 1,
		"shortname": ":person_running_tone3:",
		"shortname_alternates": [
			":runner_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c3-1f3fd-2642",
			"1f3c3-1f3fd-2640"
		],
		"code_points": {
			"base": "1f3c3-1f3fd",
			"fully_qualified": "1f3c3-1f3fd",
			"non_fully_qualified": "1f3c3-1f3fd",
			"output": "1f3c3-1f3fd",
			"default_matches": [
				"1f3c3-1f3fd"
			],
			"greedy_matches": [
				"1f3c3-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium skin tone",
			"running"
		]
	},
	"1f3c3-1f3fe": {
		"name": "person running: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 944,
		"display": 1,
		"shortname": ":person_running_tone4:",
		"shortname_alternates": [
			":runner_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c3-1f3fe-2642",
			"1f3c3-1f3fe-2640"
		],
		"code_points": {
			"base": "1f3c3-1f3fe",
			"fully_qualified": "1f3c3-1f3fe",
			"non_fully_qualified": "1f3c3-1f3fe",
			"output": "1f3c3-1f3fe",
			"default_matches": [
				"1f3c3-1f3fe"
			],
			"greedy_matches": [
				"1f3c3-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"marathon",
			"medium-dark skin tone",
			"running"
		]
	},
	"1f3c3-1f3ff": {
		"name": "person running: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 945,
		"display": 1,
		"shortname": ":person_running_tone5:",
		"shortname_alternates": [
			":runner_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c3-1f3ff-2642",
			"1f3c3-1f3ff-2640"
		],
		"code_points": {
			"base": "1f3c3-1f3ff",
			"fully_qualified": "1f3c3-1f3ff",
			"non_fully_qualified": "1f3c3-1f3ff",
			"output": "1f3c3-1f3ff",
			"default_matches": [
				"1f3c3-1f3ff"
			],
			"greedy_matches": [
				"1f3c3-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"marathon",
			"running"
		]
	},
	"1f3c3-2642": {
		"name": "man running",
		"unicode_version": 6,
		"category": "people",
		"order": 946,
		"display": 0,
		"shortname": ":man_running:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c3-1f3fb-2642",
			"1f3c3-1f3fc-2642",
			"1f3c3-1f3fd-2642",
			"1f3c3-1f3fe-2642",
			"1f3c3-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-2642",
			"fully_qualified": "1f3c3-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-200d-2642",
			"output": "1f3c3-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-200d-2642-fe0f",
				"1f3c3-200d-2642",
				"1f3c3-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-200d-2642-fe0f",
				"1f3c3-200d-2642",
				"1f3c3-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"marathon",
			"racing",
			"running"
		]
	},
	"1f3c3-1f3ff-2642": {
		"name": "man running: dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 947,
		"display": 0,
		"shortname": ":man_running_tone5:",
		"shortname_alternates": [
			":man_running_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3ff-2642",
			"fully_qualified": "1f3c3-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-1f3ff-200d-2642",
			"output": "1f3c3-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-1f3ff-200d-2642-fe0f",
				"1f3c3-1f3ff-200d-2642",
				"1f3c3-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3ff-200d-2642-fe0f",
				"1f3c3-1f3ff-200d-2642",
				"1f3c3-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"marathon",
			"racing",
			"running"
		]
	},
	"1f3c3-1f3fe-2642": {
		"name": "man running: medium-dark skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 948,
		"display": 0,
		"shortname": ":man_running_tone4:",
		"shortname_alternates": [
			":man_running_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fe-2642",
			"fully_qualified": "1f3c3-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-1f3fe-200d-2642",
			"output": "1f3c3-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-1f3fe-200d-2642-fe0f",
				"1f3c3-1f3fe-200d-2642",
				"1f3c3-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fe-200d-2642-fe0f",
				"1f3c3-1f3fe-200d-2642",
				"1f3c3-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"marathon",
			"medium-dark skin tone",
			"racing",
			"running"
		]
	},
	"1f3c3-1f3fd-2642": {
		"name": "man running: medium skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 949,
		"display": 0,
		"shortname": ":man_running_tone3:",
		"shortname_alternates": [
			":man_running_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fd-2642",
			"fully_qualified": "1f3c3-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-1f3fd-200d-2642",
			"output": "1f3c3-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-1f3fd-200d-2642-fe0f",
				"1f3c3-1f3fd-200d-2642",
				"1f3c3-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fd-200d-2642-fe0f",
				"1f3c3-1f3fd-200d-2642",
				"1f3c3-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"marathon",
			"medium skin tone",
			"racing",
			"running"
		]
	},
	"1f3c3-1f3fc-2642": {
		"name": "man running: medium-light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 950,
		"display": 0,
		"shortname": ":man_running_tone2:",
		"shortname_alternates": [
			":man_running_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fc-2642",
			"fully_qualified": "1f3c3-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-1f3fc-200d-2642",
			"output": "1f3c3-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-1f3fc-200d-2642-fe0f",
				"1f3c3-1f3fc-200d-2642",
				"1f3c3-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fc-200d-2642-fe0f",
				"1f3c3-1f3fc-200d-2642",
				"1f3c3-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"marathon",
			"medium-light skin tone",
			"racing",
			"running"
		]
	},
	"1f3c3-1f3fb-2642": {
		"name": "man running: light skin tone",
		"unicode_version": 8,
		"category": "people",
		"order": 951,
		"display": 0,
		"shortname": ":man_running_tone1:",
		"shortname_alternates": [
			":man_running_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c3-1f3fb-2642",
			"fully_qualified": "1f3c3-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f3c3-1f3fb-200d-2642",
			"output": "1f3c3-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f3c3-1f3fb-200d-2642-fe0f",
				"1f3c3-1f3fb-200d-2642",
				"1f3c3-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c3-1f3fb-200d-2642-fe0f",
				"1f3c3-1f3fb-200d-2642",
				"1f3c3-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"marathon",
			"racing",
			"running"
		]
	},
	"1f46b": {
		"name": "man and woman holding hands",
		"unicode_version": 6,
		"category": "people",
		"order": 952,
		"display": 1,
		"shortname": ":couple:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f46b",
			"fully_qualified": "1f46b",
			"non_fully_qualified": "1f46b",
			"output": "1f46b",
			"default_matches": [
				"1f46b"
			],
			"greedy_matches": [
				"1f46b"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"hand",
			"hold",
			"man",
			"woman"
		]
	},
	"1f46d": {
		"name": "two women holding hands",
		"unicode_version": 6,
		"category": "people",
		"order": 953,
		"display": 1,
		"shortname": ":two_women_holding_hands:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f46d",
			"fully_qualified": "1f46d",
			"non_fully_qualified": "1f46d",
			"output": "1f46d",
			"default_matches": [
				"1f46d"
			],
			"greedy_matches": [
				"1f46d"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"hand",
			"hold",
			"woman"
		]
	},
	"1f46c": {
		"name": "two men holding hands",
		"unicode_version": 6,
		"category": "people",
		"order": 954,
		"display": 1,
		"shortname": ":two_men_holding_hands:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f46c",
			"fully_qualified": "1f46c",
			"non_fully_qualified": "1f46c",
			"output": "1f46c",
			"default_matches": [
				"1f46c"
			],
			"greedy_matches": [
				"1f46c"
			],
			"decimal": ""
		},
		"keywords": [
			"Gemini",
			"couple",
			"hand",
			"hold",
			"man",
			"twins",
			"zodiac"
		]
	},
	"1f491": {
		"name": "couple with heart",
		"unicode_version": 6,
		"category": "people",
		"order": 955,
		"display": 1,
		"shortname": ":couple_with_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f491",
			"fully_qualified": "1f491",
			"non_fully_qualified": "1f491",
			"output": "1f491",
			"default_matches": [
				"1f491"
			],
			"greedy_matches": [
				"1f491"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"love"
		]
	},
	"1f469-2764-1f469": {
		"name": "couple with heart: woman, woman",
		"unicode_version": 6,
		"category": "people",
		"order": 956,
		"display": 1,
		"shortname": ":couple_ww:",
		"shortname_alternates": [
			":couple_with_heart_ww:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2764-1f469",
			"fully_qualified": "1f469-200d-2764-fe0f-200d-1f469",
			"non_fully_qualified": "1f469-200d-2764-200d-1f469",
			"output": "1f469-200d-2764-fe0f-200d-1f469",
			"default_matches": [
				"1f469-200d-2764-fe0f-200d-1f469",
				"1f469-200d-2764-200d-1f469",
				"1f469-2764-fe0f-1f469"
			],
			"greedy_matches": [
				"1f469-200d-2764-fe0f-200d-1f469",
				"1f469-200d-2764-200d-1f469",
				"1f469-2764-fe0f-1f469"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"love",
			"woman"
		]
	},
	"1f468-2764-1f468": {
		"name": "couple with heart: man, man",
		"unicode_version": 6,
		"category": "people",
		"order": 957,
		"display": 1,
		"shortname": ":couple_mm:",
		"shortname_alternates": [
			":couple_with_heart_mm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-2764-1f468",
			"fully_qualified": "1f468-200d-2764-fe0f-200d-1f468",
			"non_fully_qualified": "1f468-200d-2764-200d-1f468",
			"output": "1f468-200d-2764-fe0f-200d-1f468",
			"default_matches": [
				"1f468-200d-2764-fe0f-200d-1f468",
				"1f468-200d-2764-200d-1f468",
				"1f468-2764-fe0f-1f468"
			],
			"greedy_matches": [
				"1f468-200d-2764-fe0f-200d-1f468",
				"1f468-200d-2764-200d-1f468",
				"1f468-2764-fe0f-1f468"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"love",
			"man"
		]
	},
	"1f48f": {
		"name": "kiss",
		"unicode_version": 6,
		"category": "people",
		"order": 958,
		"display": 1,
		"shortname": ":couplekiss:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48f",
			"fully_qualified": "1f48f",
			"non_fully_qualified": "1f48f",
			"output": "1f48f",
			"default_matches": [
				"1f48f"
			],
			"greedy_matches": [
				"1f48f"
			],
			"decimal": ""
		},
		"keywords": [
			"couple"
		]
	},
	"1f469-2764-1f48b-1f469": {
		"name": "kiss: woman, woman",
		"unicode_version": 6,
		"category": "people",
		"order": 959,
		"display": 1,
		"shortname": ":kiss_ww:",
		"shortname_alternates": [
			":couplekiss_ww:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2764-1f48b-1f469",
			"fully_qualified": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
			"non_fully_qualified": "1f469-200d-2764-200d-1f48b-200d-1f469",
			"output": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
			"default_matches": [
				"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
				"1f469-200d-2764-200d-1f48b-200d-1f469",
				"1f469-2764-fe0f-1f48b-1f469"
			],
			"greedy_matches": [
				"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
				"1f469-200d-2764-200d-1f48b-200d-1f469",
				"1f469-2764-fe0f-1f48b-1f469"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"woman"
		]
	},
	"1f468-2764-1f48b-1f468": {
		"name": "kiss: man, man",
		"unicode_version": 6,
		"category": "people",
		"order": 960,
		"display": 1,
		"shortname": ":kiss_mm:",
		"shortname_alternates": [
			":couplekiss_mm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-2764-1f48b-1f468",
			"fully_qualified": "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
			"non_fully_qualified": "1f468-200d-2764-200d-1f48b-200d-1f468",
			"output": "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
			"default_matches": [
				"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
				"1f468-200d-2764-200d-1f48b-200d-1f468",
				"1f468-2764-fe0f-1f48b-1f468"
			],
			"greedy_matches": [
				"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
				"1f468-200d-2764-200d-1f48b-200d-1f468",
				"1f468-2764-fe0f-1f48b-1f468"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"man"
		]
	},
	"1f46a": {
		"name": "family",
		"unicode_version": 6,
		"category": "people",
		"order": 961,
		"display": 1,
		"shortname": ":family:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f46a",
			"fully_qualified": "1f46a",
			"non_fully_qualified": "1f46a",
			"output": "1f46a",
			"default_matches": [
				"1f46a"
			],
			"greedy_matches": [
				"1f46a"
			],
			"decimal": ""
		},
		"keywords": [
			"family"
		]
	},
	"1f468-1f469-1f467": {
		"name": "family: man, woman, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 962,
		"display": 1,
		"shortname": ":family_mwg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f469-1f467",
			"fully_qualified": "1f468-200d-1f469-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f469-200d-1f467",
			"output": "1f468-200d-1f469-200d-1f467",
			"default_matches": [
				"1f468-200d-1f469-200d-1f467",
				"1f468-1f469-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f469-200d-1f467",
				"1f468-1f469-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man",
			"woman"
		]
	},
	"1f468-1f469-1f467-1f466": {
		"name": "family: man, woman, girl, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 963,
		"display": 1,
		"shortname": ":family_mwgb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f469-1f467-1f466",
			"fully_qualified": "1f468-200d-1f469-200d-1f467-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f469-200d-1f467-200d-1f466",
			"output": "1f468-200d-1f469-200d-1f467-200d-1f466",
			"default_matches": [
				"1f468-200d-1f469-200d-1f467-200d-1f466",
				"1f468-1f469-1f467-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f469-200d-1f467-200d-1f466",
				"1f468-1f469-1f467-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"girl",
			"man",
			"woman"
		]
	},
	"1f468-1f469-1f466-1f466": {
		"name": "family: man, woman, boy, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 964,
		"display": 1,
		"shortname": ":family_mwbb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f469-1f466-1f466",
			"fully_qualified": "1f468-200d-1f469-200d-1f466-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f469-200d-1f466-200d-1f466",
			"output": "1f468-200d-1f469-200d-1f466-200d-1f466",
			"default_matches": [
				"1f468-200d-1f469-200d-1f466-200d-1f466",
				"1f468-1f469-1f466-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f469-200d-1f466-200d-1f466",
				"1f468-1f469-1f466-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man",
			"woman"
		]
	},
	"1f468-1f469-1f467-1f467": {
		"name": "family: man, woman, girl, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 965,
		"display": 1,
		"shortname": ":family_mwgg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f469-1f467-1f467",
			"fully_qualified": "1f468-200d-1f469-200d-1f467-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f469-200d-1f467-200d-1f467",
			"output": "1f468-200d-1f469-200d-1f467-200d-1f467",
			"default_matches": [
				"1f468-200d-1f469-200d-1f467-200d-1f467",
				"1f468-1f469-1f467-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f469-200d-1f467-200d-1f467",
				"1f468-1f469-1f467-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man",
			"woman"
		]
	},
	"1f469-1f469-1f466": {
		"name": "family: woman, woman, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 966,
		"display": 1,
		"shortname": ":family_wwb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f469-1f466",
			"fully_qualified": "1f469-200d-1f469-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f469-200d-1f466",
			"output": "1f469-200d-1f469-200d-1f466",
			"default_matches": [
				"1f469-200d-1f469-200d-1f466",
				"1f469-1f469-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f469-200d-1f466",
				"1f469-1f469-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"woman"
		]
	},
	"1f469-1f469-1f467": {
		"name": "family: woman, woman, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 967,
		"display": 1,
		"shortname": ":family_wwg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f469-1f467",
			"fully_qualified": "1f469-200d-1f469-200d-1f467",
			"non_fully_qualified": "1f469-200d-1f469-200d-1f467",
			"output": "1f469-200d-1f469-200d-1f467",
			"default_matches": [
				"1f469-200d-1f469-200d-1f467",
				"1f469-1f469-1f467"
			],
			"greedy_matches": [
				"1f469-200d-1f469-200d-1f467",
				"1f469-1f469-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"woman"
		]
	},
	"1f469-1f469-1f467-1f466": {
		"name": "family: woman, woman, girl, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 968,
		"display": 1,
		"shortname": ":family_wwgb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f469-1f467-1f466",
			"fully_qualified": "1f469-200d-1f469-200d-1f467-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f469-200d-1f467-200d-1f466",
			"output": "1f469-200d-1f469-200d-1f467-200d-1f466",
			"default_matches": [
				"1f469-200d-1f469-200d-1f467-200d-1f466",
				"1f469-1f469-1f467-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f469-200d-1f467-200d-1f466",
				"1f469-1f469-1f467-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"girl",
			"woman"
		]
	},
	"1f469-1f469-1f466-1f466": {
		"name": "family: woman, woman, boy, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 969,
		"display": 1,
		"shortname": ":family_wwbb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f469-1f466-1f466",
			"fully_qualified": "1f469-200d-1f469-200d-1f466-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f469-200d-1f466-200d-1f466",
			"output": "1f469-200d-1f469-200d-1f466-200d-1f466",
			"default_matches": [
				"1f469-200d-1f469-200d-1f466-200d-1f466",
				"1f469-1f469-1f466-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f469-200d-1f466-200d-1f466",
				"1f469-1f469-1f466-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"woman"
		]
	},
	"1f469-1f469-1f467-1f467": {
		"name": "family: woman, woman, girl, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 970,
		"display": 1,
		"shortname": ":family_wwgg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f469-1f467-1f467",
			"fully_qualified": "1f469-200d-1f469-200d-1f467-200d-1f467",
			"non_fully_qualified": "1f469-200d-1f469-200d-1f467-200d-1f467",
			"output": "1f469-200d-1f469-200d-1f467-200d-1f467",
			"default_matches": [
				"1f469-200d-1f469-200d-1f467-200d-1f467",
				"1f469-1f469-1f467-1f467"
			],
			"greedy_matches": [
				"1f469-200d-1f469-200d-1f467-200d-1f467",
				"1f469-1f469-1f467-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"woman"
		]
	},
	"1f468-1f468-1f466": {
		"name": "family: man, man, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 971,
		"display": 1,
		"shortname": ":family_mmb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f468-1f466",
			"fully_qualified": "1f468-200d-1f468-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f468-200d-1f466",
			"output": "1f468-200d-1f468-200d-1f466",
			"default_matches": [
				"1f468-200d-1f468-200d-1f466",
				"1f468-1f468-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f468-200d-1f466",
				"1f468-1f468-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man"
		]
	},
	"1f468-1f468-1f467": {
		"name": "family: man, man, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 972,
		"display": 1,
		"shortname": ":family_mmg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f468-1f467",
			"fully_qualified": "1f468-200d-1f468-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f468-200d-1f467",
			"output": "1f468-200d-1f468-200d-1f467",
			"default_matches": [
				"1f468-200d-1f468-200d-1f467",
				"1f468-1f468-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f468-200d-1f467",
				"1f468-1f468-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man"
		]
	},
	"1f468-1f468-1f467-1f466": {
		"name": "family: man, man, girl, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 973,
		"display": 1,
		"shortname": ":family_mmgb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f468-1f467-1f466",
			"fully_qualified": "1f468-200d-1f468-200d-1f467-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f468-200d-1f467-200d-1f466",
			"output": "1f468-200d-1f468-200d-1f467-200d-1f466",
			"default_matches": [
				"1f468-200d-1f468-200d-1f467-200d-1f466",
				"1f468-1f468-1f467-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f468-200d-1f467-200d-1f466",
				"1f468-1f468-1f467-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"girl",
			"man"
		]
	},
	"1f468-1f468-1f466-1f466": {
		"name": "family: man, man, boy, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 974,
		"display": 1,
		"shortname": ":family_mmbb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f468-1f466-1f466",
			"fully_qualified": "1f468-200d-1f468-200d-1f466-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f468-200d-1f466-200d-1f466",
			"output": "1f468-200d-1f468-200d-1f466-200d-1f466",
			"default_matches": [
				"1f468-200d-1f468-200d-1f466-200d-1f466",
				"1f468-1f468-1f466-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f468-200d-1f466-200d-1f466",
				"1f468-1f468-1f466-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man"
		]
	},
	"1f468-1f468-1f467-1f467": {
		"name": "family: man, man, girl, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 975,
		"display": 1,
		"shortname": ":family_mmgg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f468-1f467-1f467",
			"fully_qualified": "1f468-200d-1f468-200d-1f467-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f468-200d-1f467-200d-1f467",
			"output": "1f468-200d-1f468-200d-1f467-200d-1f467",
			"default_matches": [
				"1f468-200d-1f468-200d-1f467-200d-1f467",
				"1f468-1f468-1f467-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f468-200d-1f467-200d-1f467",
				"1f468-1f468-1f467-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man"
		]
	},
	"1f469-1f466": {
		"name": "family: woman, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 976,
		"display": 1,
		"shortname": ":family_woman_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f466",
			"fully_qualified": "1f469-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f466",
			"output": "1f469-200d-1f466",
			"default_matches": [
				"1f469-200d-1f466",
				"1f469-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f466",
				"1f469-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"woman"
		]
	},
	"1f469-1f467": {
		"name": "family: woman, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 977,
		"display": 1,
		"shortname": ":family_woman_girl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f467",
			"fully_qualified": "1f469-200d-1f467",
			"non_fully_qualified": "1f469-200d-1f467",
			"output": "1f469-200d-1f467",
			"default_matches": [
				"1f469-200d-1f467",
				"1f469-1f467"
			],
			"greedy_matches": [
				"1f469-200d-1f467",
				"1f469-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"woman"
		]
	},
	"1f469-1f467-1f466": {
		"name": "family: woman, girl, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 978,
		"display": 1,
		"shortname": ":family_woman_girl_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f467-1f466",
			"fully_qualified": "1f469-200d-1f467-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f467-200d-1f466",
			"output": "1f469-200d-1f467-200d-1f466",
			"default_matches": [
				"1f469-200d-1f467-200d-1f466",
				"1f469-1f467-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f467-200d-1f466",
				"1f469-1f467-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"girl",
			"woman"
		]
	},
	"1f469-1f466-1f466": {
		"name": "family: woman, boy, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 979,
		"display": 1,
		"shortname": ":family_woman_boy_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f466-1f466",
			"fully_qualified": "1f469-200d-1f466-200d-1f466",
			"non_fully_qualified": "1f469-200d-1f466-200d-1f466",
			"output": "1f469-200d-1f466-200d-1f466",
			"default_matches": [
				"1f469-200d-1f466-200d-1f466",
				"1f469-1f466-1f466"
			],
			"greedy_matches": [
				"1f469-200d-1f466-200d-1f466",
				"1f469-1f466-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"woman"
		]
	},
	"1f469-1f467-1f467": {
		"name": "family: woman, girl, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 980,
		"display": 1,
		"shortname": ":family_woman_girl_girl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-1f467-1f467",
			"fully_qualified": "1f469-200d-1f467-200d-1f467",
			"non_fully_qualified": "1f469-200d-1f467-200d-1f467",
			"output": "1f469-200d-1f467-200d-1f467",
			"default_matches": [
				"1f469-200d-1f467-200d-1f467",
				"1f469-1f467-1f467"
			],
			"greedy_matches": [
				"1f469-200d-1f467-200d-1f467",
				"1f469-1f467-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"woman"
		]
	},
	"1f468-1f466": {
		"name": "family: man, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 981,
		"display": 1,
		"shortname": ":family_man_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f466",
			"fully_qualified": "1f468-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f466",
			"output": "1f468-200d-1f466",
			"default_matches": [
				"1f468-200d-1f466",
				"1f468-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f466",
				"1f468-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man"
		]
	},
	"1f468-1f467": {
		"name": "family: man, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 982,
		"display": 1,
		"shortname": ":family_man_girl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f467",
			"fully_qualified": "1f468-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f467",
			"output": "1f468-200d-1f467",
			"default_matches": [
				"1f468-200d-1f467",
				"1f468-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f467",
				"1f468-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man"
		]
	},
	"1f468-1f467-1f466": {
		"name": "family: man, girl, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 983,
		"display": 1,
		"shortname": ":family_man_girl_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f467-1f466",
			"fully_qualified": "1f468-200d-1f467-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f467-200d-1f466",
			"output": "1f468-200d-1f467-200d-1f466",
			"default_matches": [
				"1f468-200d-1f467-200d-1f466",
				"1f468-1f467-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f467-200d-1f466",
				"1f468-1f467-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"girl",
			"man"
		]
	},
	"1f468-1f466-1f466": {
		"name": "family: man, boy, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 984,
		"display": 1,
		"shortname": ":family_man_boy_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f466-1f466",
			"fully_qualified": "1f468-200d-1f466-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f466-200d-1f466",
			"output": "1f468-200d-1f466-200d-1f466",
			"default_matches": [
				"1f468-200d-1f466-200d-1f466",
				"1f468-1f466-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f466-200d-1f466",
				"1f468-1f466-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man"
		]
	},
	"1f468-1f467-1f467": {
		"name": "family: man, girl, girl",
		"unicode_version": 6,
		"category": "people",
		"order": 985,
		"display": 1,
		"shortname": ":family_man_girl_girl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f467-1f467",
			"fully_qualified": "1f468-200d-1f467-200d-1f467",
			"non_fully_qualified": "1f468-200d-1f467-200d-1f467",
			"output": "1f468-200d-1f467-200d-1f467",
			"default_matches": [
				"1f468-200d-1f467-200d-1f467",
				"1f468-1f467-1f467"
			],
			"greedy_matches": [
				"1f468-200d-1f467-200d-1f467",
				"1f468-1f467-1f467"
			],
			"decimal": ""
		},
		"keywords": [
			"family",
			"girl",
			"man"
		]
	},
	"1f45a": {
		"name": "woman’s clothes",
		"unicode_version": 6,
		"category": "people",
		"order": 986,
		"display": 1,
		"shortname": ":womans_clothes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45a",
			"fully_qualified": "1f45a",
			"non_fully_qualified": "1f45a",
			"output": "1f45a",
			"default_matches": [
				"1f45a"
			],
			"greedy_matches": [
				"1f45a"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"woman"
		]
	},
	"1f455": {
		"name": "t-shirt",
		"unicode_version": 6,
		"category": "people",
		"order": 987,
		"display": 1,
		"shortname": ":shirt:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f455",
			"fully_qualified": "1f455",
			"non_fully_qualified": "1f455",
			"output": "1f455",
			"default_matches": [
				"1f455"
			],
			"greedy_matches": [
				"1f455"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"shirt",
			"tshirt"
		]
	},
	"1f456": {
		"name": "jeans",
		"unicode_version": 6,
		"category": "people",
		"order": 988,
		"display": 1,
		"shortname": ":jeans:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f456",
			"fully_qualified": "1f456",
			"non_fully_qualified": "1f456",
			"output": "1f456",
			"default_matches": [
				"1f456"
			],
			"greedy_matches": [
				"1f456"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"pants",
			"trousers"
		]
	},
	"1f454": {
		"name": "necktie",
		"unicode_version": 6,
		"category": "people",
		"order": 989,
		"display": 1,
		"shortname": ":necktie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f454",
			"fully_qualified": "1f454",
			"non_fully_qualified": "1f454",
			"output": "1f454",
			"default_matches": [
				"1f454"
			],
			"greedy_matches": [
				"1f454"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing"
		]
	},
	"1f457": {
		"name": "dress",
		"unicode_version": 6,
		"category": "people",
		"order": 990,
		"display": 1,
		"shortname": ":dress:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f457",
			"fully_qualified": "1f457",
			"non_fully_qualified": "1f457",
			"output": "1f457",
			"default_matches": [
				"1f457"
			],
			"greedy_matches": [
				"1f457"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing"
		]
	},
	"1f459": {
		"name": "bikini",
		"unicode_version": 6,
		"category": "people",
		"order": 991,
		"display": 1,
		"shortname": ":bikini:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f459",
			"fully_qualified": "1f459",
			"non_fully_qualified": "1f459",
			"output": "1f459",
			"default_matches": [
				"1f459"
			],
			"greedy_matches": [
				"1f459"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"swim"
		]
	},
	"1f458": {
		"name": "kimono",
		"unicode_version": 6,
		"category": "people",
		"order": 992,
		"display": 1,
		"shortname": ":kimono:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f458",
			"fully_qualified": "1f458",
			"non_fully_qualified": "1f458",
			"output": "1f458",
			"default_matches": [
				"1f458"
			],
			"greedy_matches": [
				"1f458"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing"
		]
	},
	"1f460": {
		"name": "high-heeled shoe",
		"unicode_version": 6,
		"category": "people",
		"order": 993,
		"display": 1,
		"shortname": ":high_heel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f460",
			"fully_qualified": "1f460",
			"non_fully_qualified": "1f460",
			"output": "1f460",
			"default_matches": [
				"1f460"
			],
			"greedy_matches": [
				"1f460"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"heel",
			"shoe",
			"woman"
		]
	},
	"1f461": {
		"name": "woman’s sandal",
		"unicode_version": 6,
		"category": "people",
		"order": 994,
		"display": 1,
		"shortname": ":sandal:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f461",
			"fully_qualified": "1f461",
			"non_fully_qualified": "1f461",
			"output": "1f461",
			"default_matches": [
				"1f461"
			],
			"greedy_matches": [
				"1f461"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"sandal",
			"shoe",
			"woman"
		]
	},
	"1f462": {
		"name": "woman’s boot",
		"unicode_version": 6,
		"category": "people",
		"order": 995,
		"display": 1,
		"shortname": ":boot:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f462",
			"fully_qualified": "1f462",
			"non_fully_qualified": "1f462",
			"output": "1f462",
			"default_matches": [
				"1f462"
			],
			"greedy_matches": [
				"1f462"
			],
			"decimal": ""
		},
		"keywords": [
			"boot",
			"clothing",
			"shoe",
			"woman"
		]
	},
	"1f45e": {
		"name": "man’s shoe",
		"unicode_version": 6,
		"category": "people",
		"order": 996,
		"display": 1,
		"shortname": ":mans_shoe:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45e",
			"fully_qualified": "1f45e",
			"non_fully_qualified": "1f45e",
			"output": "1f45e",
			"default_matches": [
				"1f45e"
			],
			"greedy_matches": [
				"1f45e"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"man",
			"shoe"
		]
	},
	"1f45f": {
		"name": "running shoe",
		"unicode_version": 6,
		"category": "people",
		"order": 997,
		"display": 1,
		"shortname": ":athletic_shoe:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45f",
			"fully_qualified": "1f45f",
			"non_fully_qualified": "1f45f",
			"output": "1f45f",
			"default_matches": [
				"1f45f"
			],
			"greedy_matches": [
				"1f45f"
			],
			"decimal": ""
		},
		"keywords": [
			"athletic",
			"clothing",
			"shoe",
			"sneaker"
		]
	},
	"1f452": {
		"name": "woman’s hat",
		"unicode_version": 6,
		"category": "people",
		"order": 998,
		"display": 1,
		"shortname": ":womans_hat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f452",
			"fully_qualified": "1f452",
			"non_fully_qualified": "1f452",
			"output": "1f452",
			"default_matches": [
				"1f452"
			],
			"greedy_matches": [
				"1f452"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"hat",
			"woman"
		]
	},
	"1f3a9": {
		"name": "top hat",
		"unicode_version": 6,
		"category": "people",
		"order": 999,
		"display": 1,
		"shortname": ":tophat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a9",
			"fully_qualified": "1f3a9",
			"non_fully_qualified": "1f3a9",
			"output": "1f3a9",
			"default_matches": [
				"1f3a9"
			],
			"greedy_matches": [
				"1f3a9"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"hat",
			"top",
			"tophat"
		]
	},
	"1f393": {
		"name": "graduation cap",
		"unicode_version": 6,
		"category": "people",
		"order": 1000,
		"display": 1,
		"shortname": ":mortar_board:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f393",
			"fully_qualified": "1f393",
			"non_fully_qualified": "1f393",
			"output": "1f393",
			"default_matches": [
				"1f393"
			],
			"greedy_matches": [
				"1f393"
			],
			"decimal": ""
		},
		"keywords": [
			"cap",
			"celebration",
			"clothing",
			"graduation",
			"hat"
		]
	},
	"1f451": {
		"name": "crown",
		"unicode_version": 6,
		"category": "people",
		"order": 1001,
		"display": 1,
		"shortname": ":crown:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f451",
			"fully_qualified": "1f451",
			"non_fully_qualified": "1f451",
			"output": "1f451",
			"default_matches": [
				"1f451"
			],
			"greedy_matches": [
				"1f451"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"king",
			"queen"
		]
	},
	"26d1": {
		"name": "rescue worker’s helmet",
		"unicode_version": 5.2,
		"category": "people",
		"order": 1002,
		"display": 1,
		"shortname": ":helmet_with_cross:",
		"shortname_alternates": [
			":helmet_with_white_cross:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26d1",
			"fully_qualified": "26d1-fe0f",
			"non_fully_qualified": "26d1",
			"output": "26d1-fe0f",
			"default_matches": [
				"26d1-fe0f",
				"26d1"
			],
			"greedy_matches": [
				"26d1-fe0f",
				"26d1"
			],
			"decimal": ""
		},
		"keywords": [
			"aid",
			"cross",
			"face",
			"hat",
			"helmet"
		]
	},
	"1f392": {
		"name": "school backpack",
		"unicode_version": 6,
		"category": "people",
		"order": 1003,
		"display": 1,
		"shortname": ":school_satchel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f392",
			"fully_qualified": "1f392",
			"non_fully_qualified": "1f392",
			"output": "1f392",
			"default_matches": [
				"1f392"
			],
			"greedy_matches": [
				"1f392"
			],
			"decimal": ""
		},
		"keywords": [
			"bag",
			"satchel",
			"school"
		]
	},
	"1f45d": {
		"name": "clutch bag",
		"unicode_version": 6,
		"category": "people",
		"order": 1004,
		"display": 1,
		"shortname": ":pouch:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45d",
			"fully_qualified": "1f45d",
			"non_fully_qualified": "1f45d",
			"output": "1f45d",
			"default_matches": [
				"1f45d"
			],
			"greedy_matches": [
				"1f45d"
			],
			"decimal": ""
		},
		"keywords": [
			"bag",
			"clothing",
			"pouch"
		]
	},
	"1f45b": {
		"name": "purse",
		"unicode_version": 6,
		"category": "people",
		"order": 1005,
		"display": 1,
		"shortname": ":purse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45b",
			"fully_qualified": "1f45b",
			"non_fully_qualified": "1f45b",
			"output": "1f45b",
			"default_matches": [
				"1f45b"
			],
			"greedy_matches": [
				"1f45b"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"coin"
		]
	},
	"1f45c": {
		"name": "handbag",
		"unicode_version": 6,
		"category": "people",
		"order": 1006,
		"display": 1,
		"shortname": ":handbag:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f45c",
			"fully_qualified": "1f45c",
			"non_fully_qualified": "1f45c",
			"output": "1f45c",
			"default_matches": [
				"1f45c"
			],
			"greedy_matches": [
				"1f45c"
			],
			"decimal": ""
		},
		"keywords": [
			"bag",
			"clothing",
			"purse"
		]
	},
	"1f4bc": {
		"name": "briefcase",
		"unicode_version": 6,
		"category": "people",
		"order": 1007,
		"display": 1,
		"shortname": ":briefcase:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4bc",
			"fully_qualified": "1f4bc",
			"non_fully_qualified": "1f4bc",
			"output": "1f4bc",
			"default_matches": [
				"1f4bc"
			],
			"greedy_matches": [
				"1f4bc"
			],
			"decimal": ""
		},
		"keywords": [
			"briefcase"
		]
	},
	"1f453": {
		"name": "glasses",
		"unicode_version": 6,
		"category": "people",
		"order": 1008,
		"display": 1,
		"shortname": ":eyeglasses:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f453",
			"fully_qualified": "1f453",
			"non_fully_qualified": "1f453",
			"output": "1f453",
			"default_matches": [
				"1f453"
			],
			"greedy_matches": [
				"1f453"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"eye",
			"eyeglasses",
			"eyewear"
		]
	},
	"1f576": {
		"name": "sunglasses",
		"unicode_version": 7,
		"category": "people",
		"order": 1009,
		"display": 1,
		"shortname": ":dark_sunglasses:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f576",
			"fully_qualified": "1f576-fe0f",
			"non_fully_qualified": "1f576",
			"output": "1f576-fe0f",
			"default_matches": [
				"1f576-fe0f",
				"1f576"
			],
			"greedy_matches": [
				"1f576-fe0f",
				"1f576"
			],
			"decimal": ""
		},
		"keywords": [
			"dark",
			"eye",
			"eyewear",
			"glasses"
		]
	},
	"1f302": {
		"name": "closed umbrella",
		"unicode_version": 6,
		"category": "people",
		"order": 1010,
		"display": 1,
		"shortname": ":closed_umbrella:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f302",
			"fully_qualified": "1f302",
			"non_fully_qualified": "1f302",
			"output": "1f302",
			"default_matches": [
				"1f302"
			],
			"greedy_matches": [
				"1f302"
			],
			"decimal": ""
		},
		"keywords": [
			"clothing",
			"rain",
			"umbrella"
		]
	},
	"1f436": {
		"name": "dog face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1012,
		"display": 1,
		"shortname": ":dog:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f436",
			"fully_qualified": "1f436",
			"non_fully_qualified": "1f436",
			"output": "1f436",
			"default_matches": [
				"1f436"
			],
			"greedy_matches": [
				"1f436"
			],
			"decimal": ""
		},
		"keywords": [
			"dog",
			"face",
			"pet"
		]
	},
	"1f431": {
		"name": "cat face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1013,
		"display": 1,
		"shortname": ":cat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f431",
			"fully_qualified": "1f431",
			"non_fully_qualified": "1f431",
			"output": "1f431",
			"default_matches": [
				"1f431"
			],
			"greedy_matches": [
				"1f431"
			],
			"decimal": ""
		},
		"keywords": [
			"cat",
			"face",
			"pet"
		]
	},
	"1f42d": {
		"name": "mouse face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1014,
		"display": 1,
		"shortname": ":mouse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42d",
			"fully_qualified": "1f42d",
			"non_fully_qualified": "1f42d",
			"output": "1f42d",
			"default_matches": [
				"1f42d"
			],
			"greedy_matches": [
				"1f42d"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"mouse"
		]
	},
	"1f439": {
		"name": "hamster face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1015,
		"display": 1,
		"shortname": ":hamster:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f439",
			"fully_qualified": "1f439",
			"non_fully_qualified": "1f439",
			"output": "1f439",
			"default_matches": [
				"1f439"
			],
			"greedy_matches": [
				"1f439"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"hamster",
			"pet"
		]
	},
	"1f430": {
		"name": "rabbit face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1016,
		"display": 1,
		"shortname": ":rabbit:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f430",
			"fully_qualified": "1f430",
			"non_fully_qualified": "1f430",
			"output": "1f430",
			"default_matches": [
				"1f430"
			],
			"greedy_matches": [
				"1f430"
			],
			"decimal": ""
		},
		"keywords": [
			"bunny",
			"face",
			"pet",
			"rabbit"
		]
	},
	"1f98a": {
		"name": "fox face",
		"unicode_version": 9,
		"category": "nature",
		"order": 1017,
		"display": 1,
		"shortname": ":fox:",
		"shortname_alternates": [
			":fox_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98a",
			"fully_qualified": "1f98a",
			"non_fully_qualified": "1f98a",
			"output": "1f98a",
			"default_matches": [
				"1f98a"
			],
			"greedy_matches": [
				"1f98a"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"fox"
		]
	},
	"1f43b": {
		"name": "bear face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1018,
		"display": 1,
		"shortname": ":bear:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43b",
			"fully_qualified": "1f43b",
			"non_fully_qualified": "1f43b",
			"output": "1f43b",
			"default_matches": [
				"1f43b"
			],
			"greedy_matches": [
				"1f43b"
			],
			"decimal": ""
		},
		"keywords": [
			"bear",
			"face"
		]
	},
	"1f43c": {
		"name": "panda face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1019,
		"display": 1,
		"shortname": ":panda_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43c",
			"fully_qualified": "1f43c",
			"non_fully_qualified": "1f43c",
			"output": "1f43c",
			"default_matches": [
				"1f43c"
			],
			"greedy_matches": [
				"1f43c"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"panda"
		]
	},
	"1f428": {
		"name": "koala",
		"unicode_version": 6,
		"category": "nature",
		"order": 1020,
		"display": 1,
		"shortname": ":koala:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f428",
			"fully_qualified": "1f428",
			"non_fully_qualified": "1f428",
			"output": "1f428",
			"default_matches": [
				"1f428"
			],
			"greedy_matches": [
				"1f428"
			],
			"decimal": ""
		},
		"keywords": [
			"bear"
		]
	},
	"1f42f": {
		"name": "tiger face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1021,
		"display": 1,
		"shortname": ":tiger:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42f",
			"fully_qualified": "1f42f",
			"non_fully_qualified": "1f42f",
			"output": "1f42f",
			"default_matches": [
				"1f42f"
			],
			"greedy_matches": [
				"1f42f"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"tiger"
		]
	},
	"1f981": {
		"name": "lion face",
		"unicode_version": 8,
		"category": "nature",
		"order": 1022,
		"display": 1,
		"shortname": ":lion_face:",
		"shortname_alternates": [
			":lion:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f981",
			"fully_qualified": "1f981",
			"non_fully_qualified": "1f981",
			"output": "1f981",
			"default_matches": [
				"1f981"
			],
			"greedy_matches": [
				"1f981"
			],
			"decimal": ""
		},
		"keywords": [
			"Leo",
			"face",
			"lion",
			"zodiac"
		]
	},
	"1f42e": {
		"name": "cow face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1023,
		"display": 1,
		"shortname": ":cow:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42e",
			"fully_qualified": "1f42e",
			"non_fully_qualified": "1f42e",
			"output": "1f42e",
			"default_matches": [
				"1f42e"
			],
			"greedy_matches": [
				"1f42e"
			],
			"decimal": ""
		},
		"keywords": [
			"cow",
			"face"
		]
	},
	"1f437": {
		"name": "pig face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1024,
		"display": 1,
		"shortname": ":pig:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f437",
			"fully_qualified": "1f437",
			"non_fully_qualified": "1f437",
			"output": "1f437",
			"default_matches": [
				"1f437"
			],
			"greedy_matches": [
				"1f437"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"pig"
		]
	},
	"1f43d": {
		"name": "pig nose",
		"unicode_version": 6,
		"category": "nature",
		"order": 1025,
		"display": 1,
		"shortname": ":pig_nose:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43d",
			"fully_qualified": "1f43d",
			"non_fully_qualified": "1f43d",
			"output": "1f43d",
			"default_matches": [
				"1f43d"
			],
			"greedy_matches": [
				"1f43d"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"nose",
			"pig"
		]
	},
	"1f438": {
		"name": "frog face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1026,
		"display": 1,
		"shortname": ":frog:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f438",
			"fully_qualified": "1f438",
			"non_fully_qualified": "1f438",
			"output": "1f438",
			"default_matches": [
				"1f438"
			],
			"greedy_matches": [
				"1f438"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"frog"
		]
	},
	"1f435": {
		"name": "monkey face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1027,
		"display": 1,
		"shortname": ":monkey_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f435",
			"fully_qualified": "1f435",
			"non_fully_qualified": "1f435",
			"output": "1f435",
			"default_matches": [
				"1f435"
			],
			"greedy_matches": [
				"1f435"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"monkey"
		]
	},
	"1f648": {
		"name": "see-no-evil monkey",
		"unicode_version": 6,
		"category": "nature",
		"order": 1028,
		"display": 1,
		"shortname": ":see_no_evil:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f648",
			"fully_qualified": "1f648",
			"non_fully_qualified": "1f648",
			"output": "1f648",
			"default_matches": [
				"1f648"
			],
			"greedy_matches": [
				"1f648"
			],
			"decimal": ""
		},
		"keywords": [
			"evil",
			"face",
			"forbidden",
			"gesture",
			"monkey",
			"no",
			"not",
			"prohibited",
			"see"
		]
	},
	"1f649": {
		"name": "hear-no-evil monkey",
		"unicode_version": 6,
		"category": "nature",
		"order": 1029,
		"display": 1,
		"shortname": ":hear_no_evil:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f649",
			"fully_qualified": "1f649",
			"non_fully_qualified": "1f649",
			"output": "1f649",
			"default_matches": [
				"1f649"
			],
			"greedy_matches": [
				"1f649"
			],
			"decimal": ""
		},
		"keywords": [
			"evil",
			"face",
			"forbidden",
			"gesture",
			"hear",
			"monkey",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f64a": {
		"name": "speak-no-evil monkey",
		"unicode_version": 6,
		"category": "nature",
		"order": 1030,
		"display": 1,
		"shortname": ":speak_no_evil:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f64a",
			"fully_qualified": "1f64a",
			"non_fully_qualified": "1f64a",
			"output": "1f64a",
			"default_matches": [
				"1f64a"
			],
			"greedy_matches": [
				"1f64a"
			],
			"decimal": ""
		},
		"keywords": [
			"evil",
			"face",
			"forbidden",
			"gesture",
			"monkey",
			"no",
			"not",
			"prohibited",
			"speak"
		]
	},
	"1f412": {
		"name": "monkey",
		"unicode_version": 6,
		"category": "nature",
		"order": 1031,
		"display": 1,
		"shortname": ":monkey:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f412",
			"fully_qualified": "1f412",
			"non_fully_qualified": "1f412",
			"output": "1f412",
			"default_matches": [
				"1f412"
			],
			"greedy_matches": [
				"1f412"
			],
			"decimal": ""
		},
		"keywords": [
			"monkey"
		]
	},
	"1f414": {
		"name": "chicken",
		"unicode_version": 6,
		"category": "nature",
		"order": 1032,
		"display": 1,
		"shortname": ":chicken:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f414",
			"fully_qualified": "1f414",
			"non_fully_qualified": "1f414",
			"output": "1f414",
			"default_matches": [
				"1f414"
			],
			"greedy_matches": [
				"1f414"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"chicken"
		]
	},
	"1f427": {
		"name": "penguin",
		"unicode_version": 6,
		"category": "nature",
		"order": 1033,
		"display": 1,
		"shortname": ":penguin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f427",
			"fully_qualified": "1f427",
			"non_fully_qualified": "1f427",
			"output": "1f427",
			"default_matches": [
				"1f427"
			],
			"greedy_matches": [
				"1f427"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"penguin"
		]
	},
	"1f426": {
		"name": "bird",
		"unicode_version": 6,
		"category": "nature",
		"order": 1034,
		"display": 1,
		"shortname": ":bird:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f426",
			"fully_qualified": "1f426",
			"non_fully_qualified": "1f426",
			"output": "1f426",
			"default_matches": [
				"1f426"
			],
			"greedy_matches": [
				"1f426"
			],
			"decimal": ""
		},
		"keywords": [
			"bird"
		]
	},
	"1f424": {
		"name": "baby chick",
		"unicode_version": 6,
		"category": "nature",
		"order": 1035,
		"display": 1,
		"shortname": ":baby_chick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f424",
			"fully_qualified": "1f424",
			"non_fully_qualified": "1f424",
			"output": "1f424",
			"default_matches": [
				"1f424"
			],
			"greedy_matches": [
				"1f424"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"bird",
			"chick"
		]
	},
	"1f423": {
		"name": "hatching chick",
		"unicode_version": 6,
		"category": "nature",
		"order": 1036,
		"display": 1,
		"shortname": ":hatching_chick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f423",
			"fully_qualified": "1f423",
			"non_fully_qualified": "1f423",
			"output": "1f423",
			"default_matches": [
				"1f423"
			],
			"greedy_matches": [
				"1f423"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"bird",
			"chick",
			"hatching"
		]
	},
	"1f425": {
		"name": "front-facing baby chick",
		"unicode_version": 6,
		"category": "nature",
		"order": 1037,
		"display": 1,
		"shortname": ":hatched_chick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f425",
			"fully_qualified": "1f425",
			"non_fully_qualified": "1f425",
			"output": "1f425",
			"default_matches": [
				"1f425"
			],
			"greedy_matches": [
				"1f425"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"bird",
			"chick"
		]
	},
	"1f986": {
		"name": "duck",
		"unicode_version": 9,
		"category": "nature",
		"order": 1038,
		"display": 1,
		"shortname": ":duck:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f986",
			"fully_qualified": "1f986",
			"non_fully_qualified": "1f986",
			"output": "1f986",
			"default_matches": [
				"1f986"
			],
			"greedy_matches": [
				"1f986"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"duck"
		]
	},
	"1f985": {
		"name": "eagle",
		"unicode_version": 9,
		"category": "nature",
		"order": 1039,
		"display": 1,
		"shortname": ":eagle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f985",
			"fully_qualified": "1f985",
			"non_fully_qualified": "1f985",
			"output": "1f985",
			"default_matches": [
				"1f985"
			],
			"greedy_matches": [
				"1f985"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"eagle"
		]
	},
	"1f989": {
		"name": "owl",
		"unicode_version": 9,
		"category": "nature",
		"order": 1040,
		"display": 1,
		"shortname": ":owl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f989",
			"fully_qualified": "1f989",
			"non_fully_qualified": "1f989",
			"output": "1f989",
			"default_matches": [
				"1f989"
			],
			"greedy_matches": [
				"1f989"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"owl",
			"wise"
		]
	},
	"1f987": {
		"name": "bat",
		"unicode_version": 9,
		"category": "nature",
		"order": 1041,
		"display": 1,
		"shortname": ":bat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f987",
			"fully_qualified": "1f987",
			"non_fully_qualified": "1f987",
			"output": "1f987",
			"default_matches": [
				"1f987"
			],
			"greedy_matches": [
				"1f987"
			],
			"decimal": ""
		},
		"keywords": [
			"bat",
			"vampire"
		]
	},
	"1f43a": {
		"name": "wolf face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1042,
		"display": 1,
		"shortname": ":wolf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43a",
			"fully_qualified": "1f43a",
			"non_fully_qualified": "1f43a",
			"output": "1f43a",
			"default_matches": [
				"1f43a"
			],
			"greedy_matches": [
				"1f43a"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"wolf"
		]
	},
	"1f417": {
		"name": "boar",
		"unicode_version": 6,
		"category": "nature",
		"order": 1043,
		"display": 1,
		"shortname": ":boar:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f417",
			"fully_qualified": "1f417",
			"non_fully_qualified": "1f417",
			"output": "1f417",
			"default_matches": [
				"1f417"
			],
			"greedy_matches": [
				"1f417"
			],
			"decimal": ""
		},
		"keywords": [
			"pig"
		]
	},
	"1f434": {
		"name": "horse face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1044,
		"display": 1,
		"shortname": ":horse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f434",
			"fully_qualified": "1f434",
			"non_fully_qualified": "1f434",
			"output": "1f434",
			"default_matches": [
				"1f434"
			],
			"greedy_matches": [
				"1f434"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"horse"
		]
	},
	"1f984": {
		"name": "unicorn face",
		"unicode_version": 8,
		"category": "nature",
		"order": 1045,
		"display": 1,
		"shortname": ":unicorn:",
		"shortname_alternates": [
			":unicorn_face:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f984",
			"fully_qualified": "1f984",
			"non_fully_qualified": "1f984",
			"output": "1f984",
			"default_matches": [
				"1f984"
			],
			"greedy_matches": [
				"1f984"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"unicorn"
		]
	},
	"1f41d": {
		"name": "honeybee",
		"unicode_version": 6,
		"category": "nature",
		"order": 1046,
		"display": 1,
		"shortname": ":bee:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41d",
			"fully_qualified": "1f41d",
			"non_fully_qualified": "1f41d",
			"output": "1f41d",
			"default_matches": [
				"1f41d"
			],
			"greedy_matches": [
				"1f41d"
			],
			"decimal": ""
		},
		"keywords": [
			"bee",
			"insect"
		]
	},
	"1f41b": {
		"name": "bug",
		"unicode_version": 6,
		"category": "nature",
		"order": 1047,
		"display": 1,
		"shortname": ":bug:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41b",
			"fully_qualified": "1f41b",
			"non_fully_qualified": "1f41b",
			"output": "1f41b",
			"default_matches": [
				"1f41b"
			],
			"greedy_matches": [
				"1f41b"
			],
			"decimal": ""
		},
		"keywords": [
			"insect"
		]
	},
	"1f98b": {
		"name": "butterfly",
		"unicode_version": 9,
		"category": "nature",
		"order": 1048,
		"display": 1,
		"shortname": ":butterfly:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98b",
			"fully_qualified": "1f98b",
			"non_fully_qualified": "1f98b",
			"output": "1f98b",
			"default_matches": [
				"1f98b"
			],
			"greedy_matches": [
				"1f98b"
			],
			"decimal": ""
		},
		"keywords": [
			"butterfly",
			"insect",
			"pretty"
		]
	},
	"1f40c": {
		"name": "snail",
		"unicode_version": 6,
		"category": "nature",
		"order": 1049,
		"display": 1,
		"shortname": ":snail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40c",
			"fully_qualified": "1f40c",
			"non_fully_qualified": "1f40c",
			"output": "1f40c",
			"default_matches": [
				"1f40c"
			],
			"greedy_matches": [
				"1f40c"
			],
			"decimal": ""
		},
		"keywords": [
			"snail"
		]
	},
	"1f41a": {
		"name": "spiral shell",
		"unicode_version": 6,
		"category": "nature",
		"order": 1050,
		"display": 1,
		"shortname": ":shell:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41a",
			"fully_qualified": "1f41a",
			"non_fully_qualified": "1f41a",
			"output": "1f41a",
			"default_matches": [
				"1f41a"
			],
			"greedy_matches": [
				"1f41a"
			],
			"decimal": ""
		},
		"keywords": [
			"shell",
			"spiral"
		]
	},
	"1f41e": {
		"name": "lady beetle",
		"unicode_version": 6,
		"category": "nature",
		"order": 1051,
		"display": 1,
		"shortname": ":beetle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41e",
			"fully_qualified": "1f41e",
			"non_fully_qualified": "1f41e",
			"output": "1f41e",
			"default_matches": [
				"1f41e"
			],
			"greedy_matches": [
				"1f41e"
			],
			"decimal": ""
		},
		"keywords": [
			"beetle",
			"insect",
			"ladybird",
			"ladybug"
		]
	},
	"1f41c": {
		"name": "ant",
		"unicode_version": 6,
		"category": "nature",
		"order": 1052,
		"display": 1,
		"shortname": ":ant:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41c",
			"fully_qualified": "1f41c",
			"non_fully_qualified": "1f41c",
			"output": "1f41c",
			"default_matches": [
				"1f41c"
			],
			"greedy_matches": [
				"1f41c"
			],
			"decimal": ""
		},
		"keywords": [
			"insect"
		]
	},
	"1f577": {
		"name": "spider",
		"unicode_version": 7,
		"category": "nature",
		"order": 1053,
		"display": 1,
		"shortname": ":spider:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f577",
			"fully_qualified": "1f577-fe0f",
			"non_fully_qualified": "1f577",
			"output": "1f577-fe0f",
			"default_matches": [
				"1f577-fe0f",
				"1f577"
			],
			"greedy_matches": [
				"1f577-fe0f",
				"1f577"
			],
			"decimal": ""
		},
		"keywords": [
			"insect"
		]
	},
	"1f578": {
		"name": "spider web",
		"unicode_version": 7,
		"category": "nature",
		"order": 1054,
		"display": 1,
		"shortname": ":spider_web:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f578",
			"fully_qualified": "1f578-fe0f",
			"non_fully_qualified": "1f578",
			"output": "1f578-fe0f",
			"default_matches": [
				"1f578-fe0f",
				"1f578"
			],
			"greedy_matches": [
				"1f578-fe0f",
				"1f578"
			],
			"decimal": ""
		},
		"keywords": [
			"spider",
			"web"
		]
	},
	"1f422": {
		"name": "turtle",
		"unicode_version": 6,
		"category": "nature",
		"order": 1055,
		"display": 1,
		"shortname": ":turtle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f422",
			"fully_qualified": "1f422",
			"non_fully_qualified": "1f422",
			"output": "1f422",
			"default_matches": [
				"1f422"
			],
			"greedy_matches": [
				"1f422"
			],
			"decimal": ""
		},
		"keywords": [
			"terrapin",
			"tortoise",
			"turtle"
		]
	},
	"1f40d": {
		"name": "snake",
		"unicode_version": 6,
		"category": "nature",
		"order": 1056,
		"display": 1,
		"shortname": ":snake:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40d",
			"fully_qualified": "1f40d",
			"non_fully_qualified": "1f40d",
			"output": "1f40d",
			"default_matches": [
				"1f40d"
			],
			"greedy_matches": [
				"1f40d"
			],
			"decimal": ""
		},
		"keywords": [
			"Ophiuchus",
			"bearer",
			"serpent",
			"zodiac"
		]
	},
	"1f98e": {
		"name": "lizard",
		"unicode_version": 9,
		"category": "nature",
		"order": 1057,
		"display": 1,
		"shortname": ":lizard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98e",
			"fully_qualified": "1f98e",
			"non_fully_qualified": "1f98e",
			"output": "1f98e",
			"default_matches": [
				"1f98e"
			],
			"greedy_matches": [
				"1f98e"
			],
			"decimal": ""
		},
		"keywords": [
			"lizard",
			"reptile"
		]
	},
	"1f982": {
		"name": "scorpion",
		"unicode_version": 8,
		"category": "nature",
		"order": 1058,
		"display": 1,
		"shortname": ":scorpion:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f982",
			"fully_qualified": "1f982",
			"non_fully_qualified": "1f982",
			"output": "1f982",
			"default_matches": [
				"1f982"
			],
			"greedy_matches": [
				"1f982"
			],
			"decimal": ""
		},
		"keywords": [
			"Scorpius",
			"scorpio",
			"zodiac"
		]
	},
	"1f980": {
		"name": "crab",
		"unicode_version": 8,
		"category": "nature",
		"order": 1059,
		"display": 1,
		"shortname": ":crab:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f980",
			"fully_qualified": "1f980",
			"non_fully_qualified": "1f980",
			"output": "1f980",
			"default_matches": [
				"1f980"
			],
			"greedy_matches": [
				"1f980"
			],
			"decimal": ""
		},
		"keywords": [
			"Cancer",
			"zodiac"
		]
	},
	"1f991": {
		"name": "squid",
		"unicode_version": 9,
		"category": "nature",
		"order": 1060,
		"display": 1,
		"shortname": ":squid:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f991",
			"fully_qualified": "1f991",
			"non_fully_qualified": "1f991",
			"output": "1f991",
			"default_matches": [
				"1f991"
			],
			"greedy_matches": [
				"1f991"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"molusc",
			"squid"
		]
	},
	"1f419": {
		"name": "octopus",
		"unicode_version": 6,
		"category": "nature",
		"order": 1061,
		"display": 1,
		"shortname": ":octopus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f419",
			"fully_qualified": "1f419",
			"non_fully_qualified": "1f419",
			"output": "1f419",
			"default_matches": [
				"1f419"
			],
			"greedy_matches": [
				"1f419"
			],
			"decimal": ""
		},
		"keywords": [
			"octopus"
		]
	},
	"1f990": {
		"name": "shrimp",
		"unicode_version": 9,
		"category": "nature",
		"order": 1062,
		"display": 1,
		"shortname": ":shrimp:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f990",
			"fully_qualified": "1f990",
			"non_fully_qualified": "1f990",
			"output": "1f990",
			"default_matches": [
				"1f990"
			],
			"greedy_matches": [
				"1f990"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"shellfish",
			"shrimp",
			"small"
		]
	},
	"1f420": {
		"name": "tropical fish",
		"unicode_version": 6,
		"category": "nature",
		"order": 1063,
		"display": 1,
		"shortname": ":tropical_fish:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f420",
			"fully_qualified": "1f420",
			"non_fully_qualified": "1f420",
			"output": "1f420",
			"default_matches": [
				"1f420"
			],
			"greedy_matches": [
				"1f420"
			],
			"decimal": ""
		},
		"keywords": [
			"fish",
			"tropical"
		]
	},
	"1f41f": {
		"name": "fish",
		"unicode_version": 6,
		"category": "nature",
		"order": 1064,
		"display": 1,
		"shortname": ":fish:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f41f",
			"fully_qualified": "1f41f",
			"non_fully_qualified": "1f41f",
			"output": "1f41f",
			"default_matches": [
				"1f41f"
			],
			"greedy_matches": [
				"1f41f"
			],
			"decimal": ""
		},
		"keywords": [
			"Pisces",
			"zodiac"
		]
	},
	"1f421": {
		"name": "blowfish",
		"unicode_version": 6,
		"category": "nature",
		"order": 1065,
		"display": 1,
		"shortname": ":blowfish:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f421",
			"fully_qualified": "1f421",
			"non_fully_qualified": "1f421",
			"output": "1f421",
			"default_matches": [
				"1f421"
			],
			"greedy_matches": [
				"1f421"
			],
			"decimal": ""
		},
		"keywords": [
			"fish"
		]
	},
	"1f42c": {
		"name": "dolphin",
		"unicode_version": 6,
		"category": "nature",
		"order": 1066,
		"display": 1,
		"shortname": ":dolphin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42c",
			"fully_qualified": "1f42c",
			"non_fully_qualified": "1f42c",
			"output": "1f42c",
			"default_matches": [
				"1f42c"
			],
			"greedy_matches": [
				"1f42c"
			],
			"decimal": ""
		},
		"keywords": [
			"flipper"
		]
	},
	"1f988": {
		"name": "shark",
		"unicode_version": 9,
		"category": "nature",
		"order": 1067,
		"display": 1,
		"shortname": ":shark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f988",
			"fully_qualified": "1f988",
			"non_fully_qualified": "1f988",
			"output": "1f988",
			"default_matches": [
				"1f988"
			],
			"greedy_matches": [
				"1f988"
			],
			"decimal": ""
		},
		"keywords": [
			"fish",
			"shark"
		]
	},
	"1f433": {
		"name": "spouting whale",
		"unicode_version": 6,
		"category": "nature",
		"order": 1068,
		"display": 1,
		"shortname": ":whale:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f433",
			"fully_qualified": "1f433",
			"non_fully_qualified": "1f433",
			"output": "1f433",
			"default_matches": [
				"1f433"
			],
			"greedy_matches": [
				"1f433"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"spouting",
			"whale"
		]
	},
	"1f40b": {
		"name": "whale",
		"unicode_version": 6,
		"category": "nature",
		"order": 1069,
		"display": 1,
		"shortname": ":whale2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40b",
			"fully_qualified": "1f40b",
			"non_fully_qualified": "1f40b",
			"output": "1f40b",
			"default_matches": [
				"1f40b"
			],
			"greedy_matches": [
				"1f40b"
			],
			"decimal": ""
		},
		"keywords": [
			"whale"
		]
	},
	"1f40a": {
		"name": "crocodile",
		"unicode_version": 6,
		"category": "nature",
		"order": 1070,
		"display": 1,
		"shortname": ":crocodile:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40a",
			"fully_qualified": "1f40a",
			"non_fully_qualified": "1f40a",
			"output": "1f40a",
			"default_matches": [
				"1f40a"
			],
			"greedy_matches": [
				"1f40a"
			],
			"decimal": ""
		},
		"keywords": [
			"crocodile"
		]
	},
	"1f406": {
		"name": "leopard",
		"unicode_version": 6,
		"category": "nature",
		"order": 1071,
		"display": 1,
		"shortname": ":leopard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f406",
			"fully_qualified": "1f406",
			"non_fully_qualified": "1f406",
			"output": "1f406",
			"default_matches": [
				"1f406"
			],
			"greedy_matches": [
				"1f406"
			],
			"decimal": ""
		},
		"keywords": [
			"leopard"
		]
	},
	"1f405": {
		"name": "tiger",
		"unicode_version": 6,
		"category": "nature",
		"order": 1072,
		"display": 1,
		"shortname": ":tiger2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f405",
			"fully_qualified": "1f405",
			"non_fully_qualified": "1f405",
			"output": "1f405",
			"default_matches": [
				"1f405"
			],
			"greedy_matches": [
				"1f405"
			],
			"decimal": ""
		},
		"keywords": [
			"tiger"
		]
	},
	"1f403": {
		"name": "water buffalo",
		"unicode_version": 6,
		"category": "nature",
		"order": 1073,
		"display": 1,
		"shortname": ":water_buffalo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f403",
			"fully_qualified": "1f403",
			"non_fully_qualified": "1f403",
			"output": "1f403",
			"default_matches": [
				"1f403"
			],
			"greedy_matches": [
				"1f403"
			],
			"decimal": ""
		},
		"keywords": [
			"buffalo",
			"water"
		]
	},
	"1f402": {
		"name": "ox",
		"unicode_version": 6,
		"category": "nature",
		"order": 1074,
		"display": 1,
		"shortname": ":ox:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f402",
			"fully_qualified": "1f402",
			"non_fully_qualified": "1f402",
			"output": "1f402",
			"default_matches": [
				"1f402"
			],
			"greedy_matches": [
				"1f402"
			],
			"decimal": ""
		},
		"keywords": [
			"Taurus",
			"bull",
			"zodiac"
		]
	},
	"1f404": {
		"name": "cow",
		"unicode_version": 6,
		"category": "nature",
		"order": 1075,
		"display": 1,
		"shortname": ":cow2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f404",
			"fully_qualified": "1f404",
			"non_fully_qualified": "1f404",
			"output": "1f404",
			"default_matches": [
				"1f404"
			],
			"greedy_matches": [
				"1f404"
			],
			"decimal": ""
		},
		"keywords": [
			"cow"
		]
	},
	"1f98c": {
		"name": "deer",
		"unicode_version": 9,
		"category": "nature",
		"order": 1076,
		"display": 1,
		"shortname": ":deer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98c",
			"fully_qualified": "1f98c",
			"non_fully_qualified": "1f98c",
			"output": "1f98c",
			"default_matches": [
				"1f98c"
			],
			"greedy_matches": [
				"1f98c"
			],
			"decimal": ""
		},
		"keywords": [
			"deer"
		]
	},
	"1f42a": {
		"name": "camel",
		"unicode_version": 6,
		"category": "nature",
		"order": 1077,
		"display": 1,
		"shortname": ":dromedary_camel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42a",
			"fully_qualified": "1f42a",
			"non_fully_qualified": "1f42a",
			"output": "1f42a",
			"default_matches": [
				"1f42a"
			],
			"greedy_matches": [
				"1f42a"
			],
			"decimal": ""
		},
		"keywords": [
			"dromedary",
			"hump"
		]
	},
	"1f42b": {
		"name": "two-hump camel",
		"unicode_version": 6,
		"category": "nature",
		"order": 1078,
		"display": 1,
		"shortname": ":camel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f42b",
			"fully_qualified": "1f42b",
			"non_fully_qualified": "1f42b",
			"output": "1f42b",
			"default_matches": [
				"1f42b"
			],
			"greedy_matches": [
				"1f42b"
			],
			"decimal": ""
		},
		"keywords": [
			"bactrian",
			"camel",
			"hump"
		]
	},
	"1f418": {
		"name": "elephant",
		"unicode_version": 6,
		"category": "nature",
		"order": 1079,
		"display": 1,
		"shortname": ":elephant:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f418",
			"fully_qualified": "1f418",
			"non_fully_qualified": "1f418",
			"output": "1f418",
			"default_matches": [
				"1f418"
			],
			"greedy_matches": [
				"1f418"
			],
			"decimal": ""
		},
		"keywords": [
			"elephant"
		]
	},
	"1f98f": {
		"name": "rhinoceros",
		"unicode_version": 9,
		"category": "nature",
		"order": 1080,
		"display": 1,
		"shortname": ":rhino:",
		"shortname_alternates": [
			":rhinoceros:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98f",
			"fully_qualified": "1f98f",
			"non_fully_qualified": "1f98f",
			"output": "1f98f",
			"default_matches": [
				"1f98f"
			],
			"greedy_matches": [
				"1f98f"
			],
			"decimal": ""
		},
		"keywords": [
			"rhinoceros"
		]
	},
	"1f98d": {
		"name": "gorilla",
		"unicode_version": 9,
		"category": "nature",
		"order": 1081,
		"display": 1,
		"shortname": ":gorilla:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f98d",
			"fully_qualified": "1f98d",
			"non_fully_qualified": "1f98d",
			"output": "1f98d",
			"default_matches": [
				"1f98d"
			],
			"greedy_matches": [
				"1f98d"
			],
			"decimal": ""
		},
		"keywords": [
			"gorilla"
		]
	},
	"1f40e": {
		"name": "horse",
		"unicode_version": 6,
		"category": "nature",
		"order": 1082,
		"display": 1,
		"shortname": ":racehorse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40e",
			"fully_qualified": "1f40e",
			"non_fully_qualified": "1f40e",
			"output": "1f40e",
			"default_matches": [
				"1f40e"
			],
			"greedy_matches": [
				"1f40e"
			],
			"decimal": ""
		},
		"keywords": [
			"equestrian",
			"racehorse",
			"racing"
		]
	},
	"1f416": {
		"name": "pig",
		"unicode_version": 6,
		"category": "nature",
		"order": 1083,
		"display": 1,
		"shortname": ":pig2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f416",
			"fully_qualified": "1f416",
			"non_fully_qualified": "1f416",
			"output": "1f416",
			"default_matches": [
				"1f416"
			],
			"greedy_matches": [
				"1f416"
			],
			"decimal": ""
		},
		"keywords": [
			"sow"
		]
	},
	"1f410": {
		"name": "goat",
		"unicode_version": 6,
		"category": "nature",
		"order": 1084,
		"display": 1,
		"shortname": ":goat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f410",
			"fully_qualified": "1f410",
			"non_fully_qualified": "1f410",
			"output": "1f410",
			"default_matches": [
				"1f410"
			],
			"greedy_matches": [
				"1f410"
			],
			"decimal": ""
		},
		"keywords": [
			"Capricorn",
			"zodiac"
		]
	},
	"1f40f": {
		"name": "ram",
		"unicode_version": 6,
		"category": "nature",
		"order": 1085,
		"display": 1,
		"shortname": ":ram:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f40f",
			"fully_qualified": "1f40f",
			"non_fully_qualified": "1f40f",
			"output": "1f40f",
			"default_matches": [
				"1f40f"
			],
			"greedy_matches": [
				"1f40f"
			],
			"decimal": ""
		},
		"keywords": [
			"Aries",
			"male",
			"sheep",
			"zodiac"
		]
	},
	"1f411": {
		"name": "ewe",
		"unicode_version": 6,
		"category": "nature",
		"order": 1086,
		"display": 1,
		"shortname": ":sheep:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f411",
			"fully_qualified": "1f411",
			"non_fully_qualified": "1f411",
			"output": "1f411",
			"default_matches": [
				"1f411"
			],
			"greedy_matches": [
				"1f411"
			],
			"decimal": ""
		},
		"keywords": [
			"female",
			"sheep"
		]
	},
	"1f415": {
		"name": "dog",
		"unicode_version": 6,
		"category": "nature",
		"order": 1087,
		"display": 1,
		"shortname": ":dog2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f415",
			"fully_qualified": "1f415",
			"non_fully_qualified": "1f415",
			"output": "1f415",
			"default_matches": [
				"1f415"
			],
			"greedy_matches": [
				"1f415"
			],
			"decimal": ""
		},
		"keywords": [
			"pet"
		]
	},
	"1f429": {
		"name": "poodle",
		"unicode_version": 6,
		"category": "nature",
		"order": 1088,
		"display": 1,
		"shortname": ":poodle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f429",
			"fully_qualified": "1f429",
			"non_fully_qualified": "1f429",
			"output": "1f429",
			"default_matches": [
				"1f429"
			],
			"greedy_matches": [
				"1f429"
			],
			"decimal": ""
		},
		"keywords": [
			"dog"
		]
	},
	"1f408": {
		"name": "cat",
		"unicode_version": 6,
		"category": "nature",
		"order": 1089,
		"display": 1,
		"shortname": ":cat2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f408",
			"fully_qualified": "1f408",
			"non_fully_qualified": "1f408",
			"output": "1f408",
			"default_matches": [
				"1f408"
			],
			"greedy_matches": [
				"1f408"
			],
			"decimal": ""
		},
		"keywords": [
			"pet"
		]
	},
	"1f413": {
		"name": "rooster",
		"unicode_version": 6,
		"category": "nature",
		"order": 1090,
		"display": 1,
		"shortname": ":rooster:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f413",
			"fully_qualified": "1f413",
			"non_fully_qualified": "1f413",
			"output": "1f413",
			"default_matches": [
				"1f413"
			],
			"greedy_matches": [
				"1f413"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"rooster"
		]
	},
	"1f983": {
		"name": "turkey",
		"unicode_version": 8,
		"category": "nature",
		"order": 1091,
		"display": 1,
		"shortname": ":turkey:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f983",
			"fully_qualified": "1f983",
			"non_fully_qualified": "1f983",
			"output": "1f983",
			"default_matches": [
				"1f983"
			],
			"greedy_matches": [
				"1f983"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"turkey"
		]
	},
	"1f54a": {
		"name": "dove",
		"unicode_version": 7,
		"category": "nature",
		"order": 1092,
		"display": 1,
		"shortname": ":dove:",
		"shortname_alternates": [
			":dove_of_peace:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f54a",
			"fully_qualified": "1f54a-fe0f",
			"non_fully_qualified": "1f54a",
			"output": "1f54a-fe0f",
			"default_matches": [
				"1f54a-fe0f",
				"1f54a"
			],
			"greedy_matches": [
				"1f54a-fe0f",
				"1f54a"
			],
			"decimal": ""
		},
		"keywords": [
			"bird",
			"fly",
			"peace"
		]
	},
	"1f407": {
		"name": "rabbit",
		"unicode_version": 6,
		"category": "nature",
		"order": 1093,
		"display": 1,
		"shortname": ":rabbit2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f407",
			"fully_qualified": "1f407",
			"non_fully_qualified": "1f407",
			"output": "1f407",
			"default_matches": [
				"1f407"
			],
			"greedy_matches": [
				"1f407"
			],
			"decimal": ""
		},
		"keywords": [
			"bunny",
			"pet"
		]
	},
	"1f401": {
		"name": "mouse",
		"unicode_version": 6,
		"category": "nature",
		"order": 1094,
		"display": 1,
		"shortname": ":mouse2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f401",
			"fully_qualified": "1f401",
			"non_fully_qualified": "1f401",
			"output": "1f401",
			"default_matches": [
				"1f401"
			],
			"greedy_matches": [
				"1f401"
			],
			"decimal": ""
		},
		"keywords": [
			"mouse"
		]
	},
	"1f400": {
		"name": "rat",
		"unicode_version": 6,
		"category": "nature",
		"order": 1095,
		"display": 1,
		"shortname": ":rat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f400",
			"fully_qualified": "1f400",
			"non_fully_qualified": "1f400",
			"output": "1f400",
			"default_matches": [
				"1f400"
			],
			"greedy_matches": [
				"1f400"
			],
			"decimal": ""
		},
		"keywords": [
			"rat"
		]
	},
	"1f43f": {
		"name": "chipmunk",
		"unicode_version": 7,
		"category": "nature",
		"order": 1096,
		"display": 1,
		"shortname": ":chipmunk:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43f",
			"fully_qualified": "1f43f-fe0f",
			"non_fully_qualified": "1f43f",
			"output": "1f43f-fe0f",
			"default_matches": [
				"1f43f-fe0f",
				"1f43f"
			],
			"greedy_matches": [
				"1f43f-fe0f",
				"1f43f"
			],
			"decimal": ""
		},
		"keywords": [
			"chipmunk"
		]
	},
	"1f43e": {
		"name": "paw prints",
		"unicode_version": 6,
		"category": "nature",
		"order": 1097,
		"display": 1,
		"shortname": ":feet:",
		"shortname_alternates": [
			":paw_prints:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f43e",
			"fully_qualified": "1f43e",
			"non_fully_qualified": "1f43e",
			"output": "1f43e",
			"default_matches": [
				"1f43e"
			],
			"greedy_matches": [
				"1f43e"
			],
			"decimal": ""
		},
		"keywords": [
			"feet",
			"paw",
			"print"
		]
	},
	"1f409": {
		"name": "dragon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1098,
		"display": 1,
		"shortname": ":dragon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f409",
			"fully_qualified": "1f409",
			"non_fully_qualified": "1f409",
			"output": "1f409",
			"default_matches": [
				"1f409"
			],
			"greedy_matches": [
				"1f409"
			],
			"decimal": ""
		},
		"keywords": [
			"fairy tale"
		]
	},
	"1f432": {
		"name": "dragon face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1099,
		"display": 1,
		"shortname": ":dragon_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f432",
			"fully_qualified": "1f432",
			"non_fully_qualified": "1f432",
			"output": "1f432",
			"default_matches": [
				"1f432"
			],
			"greedy_matches": [
				"1f432"
			],
			"decimal": ""
		},
		"keywords": [
			"dragon",
			"face",
			"fairy tale"
		]
	},
	"1f335": {
		"name": "cactus",
		"unicode_version": 6,
		"category": "nature",
		"order": 1100,
		"display": 1,
		"shortname": ":cactus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f335",
			"fully_qualified": "1f335",
			"non_fully_qualified": "1f335",
			"output": "1f335",
			"default_matches": [
				"1f335"
			],
			"greedy_matches": [
				"1f335"
			],
			"decimal": ""
		},
		"keywords": [
			"plant"
		]
	},
	"1f384": {
		"name": "Christmas tree",
		"unicode_version": 6,
		"category": "nature",
		"order": 1101,
		"display": 1,
		"shortname": ":christmas_tree:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f384",
			"fully_qualified": "1f384",
			"non_fully_qualified": "1f384",
			"output": "1f384",
			"default_matches": [
				"1f384"
			],
			"greedy_matches": [
				"1f384"
			],
			"decimal": ""
		},
		"keywords": [
			"Christmas",
			"celebration",
			"tree"
		]
	},
	"1f332": {
		"name": "evergreen tree",
		"unicode_version": 6,
		"category": "nature",
		"order": 1102,
		"display": 1,
		"shortname": ":evergreen_tree:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f332",
			"fully_qualified": "1f332",
			"non_fully_qualified": "1f332",
			"output": "1f332",
			"default_matches": [
				"1f332"
			],
			"greedy_matches": [
				"1f332"
			],
			"decimal": ""
		},
		"keywords": [
			"tree"
		]
	},
	"1f333": {
		"name": "deciduous tree",
		"unicode_version": 6,
		"category": "nature",
		"order": 1103,
		"display": 1,
		"shortname": ":deciduous_tree:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f333",
			"fully_qualified": "1f333",
			"non_fully_qualified": "1f333",
			"output": "1f333",
			"default_matches": [
				"1f333"
			],
			"greedy_matches": [
				"1f333"
			],
			"decimal": ""
		},
		"keywords": [
			"deciduous",
			"shedding",
			"tree"
		]
	},
	"1f334": {
		"name": "palm tree",
		"unicode_version": 6,
		"category": "nature",
		"order": 1104,
		"display": 1,
		"shortname": ":palm_tree:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f334",
			"fully_qualified": "1f334",
			"non_fully_qualified": "1f334",
			"output": "1f334",
			"default_matches": [
				"1f334"
			],
			"greedy_matches": [
				"1f334"
			],
			"decimal": ""
		},
		"keywords": [
			"palm",
			"tree"
		]
	},
	"1f331": {
		"name": "seedling",
		"unicode_version": 6,
		"category": "nature",
		"order": 1105,
		"display": 1,
		"shortname": ":seedling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f331",
			"fully_qualified": "1f331",
			"non_fully_qualified": "1f331",
			"output": "1f331",
			"default_matches": [
				"1f331"
			],
			"greedy_matches": [
				"1f331"
			],
			"decimal": ""
		},
		"keywords": [
			"young"
		]
	},
	"1f33f": {
		"name": "herb",
		"unicode_version": 6,
		"category": "nature",
		"order": 1106,
		"display": 1,
		"shortname": ":herb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33f",
			"fully_qualified": "1f33f",
			"non_fully_qualified": "1f33f",
			"output": "1f33f",
			"default_matches": [
				"1f33f"
			],
			"greedy_matches": [
				"1f33f"
			],
			"decimal": ""
		},
		"keywords": [
			"leaf"
		]
	},
	"1f340": {
		"name": "four leaf clover",
		"unicode_version": 6,
		"category": "nature",
		"order": 1108,
		"display": 1,
		"shortname": ":four_leaf_clover:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f340",
			"fully_qualified": "1f340",
			"non_fully_qualified": "1f340",
			"output": "1f340",
			"default_matches": [
				"1f340"
			],
			"greedy_matches": [
				"1f340"
			],
			"decimal": ""
		},
		"keywords": [
			"4",
			"clover",
			"four",
			"leaf"
		]
	},
	"1f38d": {
		"name": "pine decoration",
		"unicode_version": 6,
		"category": "nature",
		"order": 1109,
		"display": 1,
		"shortname": ":bamboo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38d",
			"fully_qualified": "1f38d",
			"non_fully_qualified": "1f38d",
			"output": "1f38d",
			"default_matches": [
				"1f38d"
			],
			"greedy_matches": [
				"1f38d"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"bamboo",
			"celebration",
			"pine"
		]
	},
	"1f38b": {
		"name": "tanabata tree",
		"unicode_version": 6,
		"category": "nature",
		"order": 1110,
		"display": 1,
		"shortname": ":tanabata_tree:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38b",
			"fully_qualified": "1f38b",
			"non_fully_qualified": "1f38b",
			"output": "1f38b",
			"default_matches": [
				"1f38b"
			],
			"greedy_matches": [
				"1f38b"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"banner",
			"celebration",
			"tree"
		]
	},
	"1f343": {
		"name": "leaf fluttering in wind",
		"unicode_version": 6,
		"category": "nature",
		"order": 1111,
		"display": 1,
		"shortname": ":leaves:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f343",
			"fully_qualified": "1f343",
			"non_fully_qualified": "1f343",
			"output": "1f343",
			"default_matches": [
				"1f343"
			],
			"greedy_matches": [
				"1f343"
			],
			"decimal": ""
		},
		"keywords": [
			"blow",
			"flutter",
			"leaf",
			"wind"
		]
	},
	"1f342": {
		"name": "fallen leaf",
		"unicode_version": 6,
		"category": "nature",
		"order": 1112,
		"display": 1,
		"shortname": ":fallen_leaf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f342",
			"fully_qualified": "1f342",
			"non_fully_qualified": "1f342",
			"output": "1f342",
			"default_matches": [
				"1f342"
			],
			"greedy_matches": [
				"1f342"
			],
			"decimal": ""
		},
		"keywords": [
			"falling",
			"leaf"
		]
	},
	"1f341": {
		"name": "maple leaf",
		"unicode_version": 6,
		"category": "nature",
		"order": 1113,
		"display": 1,
		"shortname": ":maple_leaf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f341",
			"fully_qualified": "1f341",
			"non_fully_qualified": "1f341",
			"output": "1f341",
			"default_matches": [
				"1f341"
			],
			"greedy_matches": [
				"1f341"
			],
			"decimal": ""
		},
		"keywords": [
			"falling",
			"leaf",
			"maple"
		]
	},
	"1f344": {
		"name": "mushroom",
		"unicode_version": 6,
		"category": "nature",
		"order": 1114,
		"display": 1,
		"shortname": ":mushroom:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f344",
			"fully_qualified": "1f344",
			"non_fully_qualified": "1f344",
			"output": "1f344",
			"default_matches": [
				"1f344"
			],
			"greedy_matches": [
				"1f344"
			],
			"decimal": ""
		},
		"keywords": [
			"toadstool"
		]
	},
	"1f33e": {
		"name": "sheaf of rice",
		"unicode_version": 6,
		"category": "nature",
		"order": 1115,
		"display": 1,
		"shortname": ":ear_of_rice:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33e",
			"fully_qualified": "1f33e",
			"non_fully_qualified": "1f33e",
			"output": "1f33e",
			"default_matches": [
				"1f33e"
			],
			"greedy_matches": [
				"1f33e"
			],
			"decimal": ""
		},
		"keywords": [
			"ear",
			"grain",
			"rice"
		]
	},
	"1f490": {
		"name": "bouquet",
		"unicode_version": 6,
		"category": "nature",
		"order": 1116,
		"display": 1,
		"shortname": ":bouquet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f490",
			"fully_qualified": "1f490",
			"non_fully_qualified": "1f490",
			"output": "1f490",
			"default_matches": [
				"1f490"
			],
			"greedy_matches": [
				"1f490"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f337": {
		"name": "tulip",
		"unicode_version": 6,
		"category": "nature",
		"order": 1117,
		"display": 1,
		"shortname": ":tulip:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f337",
			"fully_qualified": "1f337",
			"non_fully_qualified": "1f337",
			"output": "1f337",
			"default_matches": [
				"1f337"
			],
			"greedy_matches": [
				"1f337"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f339": {
		"name": "rose",
		"unicode_version": 6,
		"category": "nature",
		"order": 1118,
		"display": 1,
		"shortname": ":rose:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f339",
			"fully_qualified": "1f339",
			"non_fully_qualified": "1f339",
			"output": "1f339",
			"default_matches": [
				"1f339"
			],
			"greedy_matches": [
				"1f339"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f940": {
		"name": "wilted flower",
		"unicode_version": 9,
		"category": "nature",
		"order": 1119,
		"display": 1,
		"shortname": ":wilted_rose:",
		"shortname_alternates": [
			":wilted_flower:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f940",
			"fully_qualified": "1f940",
			"non_fully_qualified": "1f940",
			"output": "1f940",
			"default_matches": [
				"1f940"
			],
			"greedy_matches": [
				"1f940"
			],
			"decimal": ""
		},
		"keywords": [
			"flower",
			"wilted"
		]
	},
	"1f33b": {
		"name": "sunflower",
		"unicode_version": 6,
		"category": "nature",
		"order": 1120,
		"display": 1,
		"shortname": ":sunflower:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33b",
			"fully_qualified": "1f33b",
			"non_fully_qualified": "1f33b",
			"output": "1f33b",
			"default_matches": [
				"1f33b"
			],
			"greedy_matches": [
				"1f33b"
			],
			"decimal": ""
		},
		"keywords": [
			"flower",
			"sun"
		]
	},
	"1f33c": {
		"name": "blossom",
		"unicode_version": 6,
		"category": "nature",
		"order": 1121,
		"display": 1,
		"shortname": ":blossom:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33c",
			"fully_qualified": "1f33c",
			"non_fully_qualified": "1f33c",
			"output": "1f33c",
			"default_matches": [
				"1f33c"
			],
			"greedy_matches": [
				"1f33c"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f338": {
		"name": "cherry blossom",
		"unicode_version": 6,
		"category": "nature",
		"order": 1122,
		"display": 1,
		"shortname": ":cherry_blossom:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f338",
			"fully_qualified": "1f338",
			"non_fully_qualified": "1f338",
			"output": "1f338",
			"default_matches": [
				"1f338"
			],
			"greedy_matches": [
				"1f338"
			],
			"decimal": ""
		},
		"keywords": [
			"blossom",
			"cherry",
			"flower"
		]
	},
	"1f33a": {
		"name": "hibiscus",
		"unicode_version": 6,
		"category": "nature",
		"order": 1123,
		"display": 1,
		"shortname": ":hibiscus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33a",
			"fully_qualified": "1f33a",
			"non_fully_qualified": "1f33a",
			"output": "1f33a",
			"default_matches": [
				"1f33a"
			],
			"greedy_matches": [
				"1f33a"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f30e": {
		"name": "globe showing Americas",
		"unicode_version": 6,
		"category": "nature",
		"order": 1124,
		"display": 1,
		"shortname": ":earth_americas:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30e",
			"fully_qualified": "1f30e",
			"non_fully_qualified": "1f30e",
			"output": "1f30e",
			"default_matches": [
				"1f30e"
			],
			"greedy_matches": [
				"1f30e"
			],
			"decimal": ""
		},
		"keywords": [
			"Americas",
			"earth",
			"globe",
			"world"
		]
	},
	"1f30d": {
		"name": "globe showing Europe-Africa",
		"unicode_version": 6,
		"category": "nature",
		"order": 1125,
		"display": 1,
		"shortname": ":earth_africa:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30d",
			"fully_qualified": "1f30d",
			"non_fully_qualified": "1f30d",
			"output": "1f30d",
			"default_matches": [
				"1f30d"
			],
			"greedy_matches": [
				"1f30d"
			],
			"decimal": ""
		},
		"keywords": [
			"Africa",
			"Europe",
			"earth",
			"globe",
			"world"
		]
	},
	"1f30f": {
		"name": "globe showing Asia-Australia",
		"unicode_version": 6,
		"category": "nature",
		"order": 1126,
		"display": 1,
		"shortname": ":earth_asia:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30f",
			"fully_qualified": "1f30f",
			"non_fully_qualified": "1f30f",
			"output": "1f30f",
			"default_matches": [
				"1f30f"
			],
			"greedy_matches": [
				"1f30f"
			],
			"decimal": ""
		},
		"keywords": [
			"Asia",
			"Australia",
			"earth",
			"globe",
			"world"
		]
	},
	"1f315": {
		"name": "full moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1127,
		"display": 1,
		"shortname": ":full_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f315",
			"fully_qualified": "1f315",
			"non_fully_qualified": "1f315",
			"output": "1f315",
			"default_matches": [
				"1f315"
			],
			"greedy_matches": [
				"1f315"
			],
			"decimal": ""
		},
		"keywords": [
			"full",
			"moon"
		]
	},
	"1f316": {
		"name": "waning gibbous moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1128,
		"display": 1,
		"shortname": ":waning_gibbous_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f316",
			"fully_qualified": "1f316",
			"non_fully_qualified": "1f316",
			"output": "1f316",
			"default_matches": [
				"1f316"
			],
			"greedy_matches": [
				"1f316"
			],
			"decimal": ""
		},
		"keywords": [
			"gibbous",
			"moon",
			"waning"
		]
	},
	"1f317": {
		"name": "last quarter moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1129,
		"display": 1,
		"shortname": ":last_quarter_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f317",
			"fully_qualified": "1f317",
			"non_fully_qualified": "1f317",
			"output": "1f317",
			"default_matches": [
				"1f317"
			],
			"greedy_matches": [
				"1f317"
			],
			"decimal": ""
		},
		"keywords": [
			"moon",
			"quarter"
		]
	},
	"1f318": {
		"name": "waning crescent moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1130,
		"display": 1,
		"shortname": ":waning_crescent_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f318",
			"fully_qualified": "1f318",
			"non_fully_qualified": "1f318",
			"output": "1f318",
			"default_matches": [
				"1f318"
			],
			"greedy_matches": [
				"1f318"
			],
			"decimal": ""
		},
		"keywords": [
			"crescent",
			"moon",
			"waning"
		]
	},
	"1f311": {
		"name": "new moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1131,
		"display": 1,
		"shortname": ":new_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f311",
			"fully_qualified": "1f311",
			"non_fully_qualified": "1f311",
			"output": "1f311",
			"default_matches": [
				"1f311"
			],
			"greedy_matches": [
				"1f311"
			],
			"decimal": ""
		},
		"keywords": [
			"dark",
			"moon"
		]
	},
	"1f312": {
		"name": "waxing crescent moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1132,
		"display": 1,
		"shortname": ":waxing_crescent_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f312",
			"fully_qualified": "1f312",
			"non_fully_qualified": "1f312",
			"output": "1f312",
			"default_matches": [
				"1f312"
			],
			"greedy_matches": [
				"1f312"
			],
			"decimal": ""
		},
		"keywords": [
			"crescent",
			"moon",
			"waxing"
		]
	},
	"1f313": {
		"name": "first quarter moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1133,
		"display": 1,
		"shortname": ":first_quarter_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f313",
			"fully_qualified": "1f313",
			"non_fully_qualified": "1f313",
			"output": "1f313",
			"default_matches": [
				"1f313"
			],
			"greedy_matches": [
				"1f313"
			],
			"decimal": ""
		},
		"keywords": [
			"moon",
			"quarter"
		]
	},
	"1f314": {
		"name": "waxing gibbous moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1134,
		"display": 1,
		"shortname": ":waxing_gibbous_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f314",
			"fully_qualified": "1f314",
			"non_fully_qualified": "1f314",
			"output": "1f314",
			"default_matches": [
				"1f314"
			],
			"greedy_matches": [
				"1f314"
			],
			"decimal": ""
		},
		"keywords": [
			"gibbous",
			"moon",
			"waxing"
		]
	},
	"1f31a": {
		"name": "new moon face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1135,
		"display": 1,
		"shortname": ":new_moon_with_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31a",
			"fully_qualified": "1f31a",
			"non_fully_qualified": "1f31a",
			"output": "1f31a",
			"default_matches": [
				"1f31a"
			],
			"greedy_matches": [
				"1f31a"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"moon"
		]
	},
	"1f31d": {
		"name": "full moon with face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1136,
		"display": 1,
		"shortname": ":full_moon_with_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31d",
			"fully_qualified": "1f31d",
			"non_fully_qualified": "1f31d",
			"output": "1f31d",
			"default_matches": [
				"1f31d"
			],
			"greedy_matches": [
				"1f31d"
			],
			"decimal": ""
		},
		"keywords": [
			"bright",
			"face",
			"full",
			"moon"
		]
	},
	"1f31e": {
		"name": "sun with face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1137,
		"display": 1,
		"shortname": ":sun_with_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31e",
			"fully_qualified": "1f31e",
			"non_fully_qualified": "1f31e",
			"output": "1f31e",
			"default_matches": [
				"1f31e"
			],
			"greedy_matches": [
				"1f31e"
			],
			"decimal": ""
		},
		"keywords": [
			"bright",
			"face",
			"sun"
		]
	},
	"1f31b": {
		"name": "first quarter moon with face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1138,
		"display": 1,
		"shortname": ":first_quarter_moon_with_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31b",
			"fully_qualified": "1f31b",
			"non_fully_qualified": "1f31b",
			"output": "1f31b",
			"default_matches": [
				"1f31b"
			],
			"greedy_matches": [
				"1f31b"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"moon",
			"quarter"
		]
	},
	"1f31c": {
		"name": "last quarter moon with face",
		"unicode_version": 6,
		"category": "nature",
		"order": 1139,
		"display": 1,
		"shortname": ":last_quarter_moon_with_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31c",
			"fully_qualified": "1f31c",
			"non_fully_qualified": "1f31c",
			"output": "1f31c",
			"default_matches": [
				"1f31c"
			],
			"greedy_matches": [
				"1f31c"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"moon",
			"quarter"
		]
	},
	"1f319": {
		"name": "crescent moon",
		"unicode_version": 6,
		"category": "nature",
		"order": 1140,
		"display": 1,
		"shortname": ":crescent_moon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f319",
			"fully_qualified": "1f319",
			"non_fully_qualified": "1f319",
			"output": "1f319",
			"default_matches": [
				"1f319"
			],
			"greedy_matches": [
				"1f319"
			],
			"decimal": ""
		},
		"keywords": [
			"crescent",
			"moon"
		]
	},
	"1f4ab": {
		"name": "dizzy",
		"unicode_version": 6,
		"category": "nature",
		"order": 1141,
		"display": 1,
		"shortname": ":dizzy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ab",
			"fully_qualified": "1f4ab",
			"non_fully_qualified": "1f4ab",
			"output": "1f4ab",
			"default_matches": [
				"1f4ab"
			],
			"greedy_matches": [
				"1f4ab"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"star"
		]
	},
	"2b50": {
		"name": "white medium star",
		"unicode_version": 5.1,
		"category": "nature",
		"order": 1142,
		"display": 1,
		"shortname": ":star:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b50",
			"fully_qualified": "2b50",
			"non_fully_qualified": "2b50",
			"output": "2b50",
			"default_matches": [
				"2b50"
			],
			"greedy_matches": [
				"2b50"
			],
			"decimal": ""
		},
		"keywords": [
			"star"
		]
	},
	"1f31f": {
		"name": "glowing star",
		"unicode_version": 6,
		"category": "nature",
		"order": 1143,
		"display": 1,
		"shortname": ":star2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f31f",
			"fully_qualified": "1f31f",
			"non_fully_qualified": "1f31f",
			"output": "1f31f",
			"default_matches": [
				"1f31f"
			],
			"greedy_matches": [
				"1f31f"
			],
			"decimal": ""
		},
		"keywords": [
			"glittery",
			"glow",
			"shining",
			"sparkle",
			"star"
		]
	},
	"26a1": {
		"name": "high voltage",
		"unicode_version": 4,
		"category": "nature",
		"order": 1145,
		"display": 1,
		"shortname": ":zap:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26a1",
			"fully_qualified": "26a1",
			"non_fully_qualified": "26a1",
			"output": "26a1",
			"default_matches": [
				"26a1"
			],
			"greedy_matches": [
				"26a1"
			],
			"decimal": ""
		},
		"keywords": [
			"danger",
			"electric",
			"electricity",
			"lightning",
			"voltage",
			"zap"
		]
	},
	"1f525": {
		"name": "fire",
		"unicode_version": 6,
		"category": "nature",
		"order": 1146,
		"display": 1,
		"shortname": ":fire:",
		"shortname_alternates": [
			":flame:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f525",
			"fully_qualified": "1f525",
			"non_fully_qualified": "1f525",
			"output": "1f525",
			"default_matches": [
				"1f525"
			],
			"greedy_matches": [
				"1f525"
			],
			"decimal": ""
		},
		"keywords": [
			"flame",
			"tool"
		]
	},
	"1f4a5": {
		"name": "collision",
		"unicode_version": 6,
		"category": "nature",
		"order": 1147,
		"display": 1,
		"shortname": ":boom:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a5",
			"fully_qualified": "1f4a5",
			"non_fully_qualified": "1f4a5",
			"output": "1f4a5",
			"default_matches": [
				"1f4a5"
			],
			"greedy_matches": [
				"1f4a5"
			],
			"decimal": ""
		},
		"keywords": [
			"boom",
			"comic"
		]
	},
	"1f324": {
		"name": "sun behind small cloud",
		"unicode_version": 7,
		"category": "nature",
		"order": 1150,
		"display": 1,
		"shortname": ":white_sun_small_cloud:",
		"shortname_alternates": [
			":white_sun_with_small_cloud:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f324",
			"fully_qualified": "1f324-fe0f",
			"non_fully_qualified": "1f324",
			"output": "1f324-fe0f",
			"default_matches": [
				"1f324-fe0f",
				"1f324"
			],
			"greedy_matches": [
				"1f324-fe0f",
				"1f324"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"sun"
		]
	},
	"26c5": {
		"name": "sun behind cloud",
		"unicode_version": 5.2,
		"category": "nature",
		"order": 1151,
		"display": 1,
		"shortname": ":partly_sunny:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26c5",
			"fully_qualified": "26c5",
			"non_fully_qualified": "26c5",
			"output": "26c5",
			"default_matches": [
				"26c5"
			],
			"greedy_matches": [
				"26c5"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"sun"
		]
	},
	"1f325": {
		"name": "sun behind large cloud",
		"unicode_version": 7,
		"category": "nature",
		"order": 1152,
		"display": 1,
		"shortname": ":white_sun_cloud:",
		"shortname_alternates": [
			":white_sun_behind_cloud:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f325",
			"fully_qualified": "1f325-fe0f",
			"non_fully_qualified": "1f325",
			"output": "1f325-fe0f",
			"default_matches": [
				"1f325-fe0f",
				"1f325"
			],
			"greedy_matches": [
				"1f325-fe0f",
				"1f325"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"sun"
		]
	},
	"1f326": {
		"name": "sun behind rain cloud",
		"unicode_version": 7,
		"category": "nature",
		"order": 1153,
		"display": 1,
		"shortname": ":white_sun_rain_cloud:",
		"shortname_alternates": [
			":white_sun_behind_cloud_with_rain:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f326",
			"fully_qualified": "1f326-fe0f",
			"non_fully_qualified": "1f326",
			"output": "1f326-fe0f",
			"default_matches": [
				"1f326-fe0f",
				"1f326"
			],
			"greedy_matches": [
				"1f326-fe0f",
				"1f326"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"rain",
			"sun"
		]
	},
	"1f308": {
		"name": "rainbow",
		"unicode_version": 6,
		"category": "nature",
		"order": 1154,
		"display": 1,
		"shortname": ":rainbow:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f308",
			"fully_qualified": "1f308",
			"non_fully_qualified": "1f308",
			"output": "1f308",
			"default_matches": [
				"1f308"
			],
			"greedy_matches": [
				"1f308"
			],
			"decimal": ""
		},
		"keywords": [
			"rain"
		]
	},
	"1f327": {
		"name": "cloud with rain",
		"unicode_version": 7,
		"category": "nature",
		"order": 1156,
		"display": 1,
		"shortname": ":cloud_rain:",
		"shortname_alternates": [
			":cloud_with_rain:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f327",
			"fully_qualified": "1f327-fe0f",
			"non_fully_qualified": "1f327",
			"output": "1f327-fe0f",
			"default_matches": [
				"1f327-fe0f",
				"1f327"
			],
			"greedy_matches": [
				"1f327-fe0f",
				"1f327"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"rain"
		]
	},
	"26c8": {
		"name": "cloud with lightning and rain",
		"unicode_version": 5.2,
		"category": "nature",
		"order": 1157,
		"display": 1,
		"shortname": ":thunder_cloud_rain:",
		"shortname_alternates": [
			":thunder_cloud_and_rain:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26c8",
			"fully_qualified": "26c8-fe0f",
			"non_fully_qualified": "26c8",
			"output": "26c8-fe0f",
			"default_matches": [
				"26c8-fe0f",
				"26c8"
			],
			"greedy_matches": [
				"26c8-fe0f",
				"26c8"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"rain",
			"thunder"
		]
	},
	"1f329": {
		"name": "cloud with lightning",
		"unicode_version": 7,
		"category": "nature",
		"order": 1158,
		"display": 1,
		"shortname": ":cloud_lightning:",
		"shortname_alternates": [
			":cloud_with_lightning:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f329",
			"fully_qualified": "1f329-fe0f",
			"non_fully_qualified": "1f329",
			"output": "1f329-fe0f",
			"default_matches": [
				"1f329-fe0f",
				"1f329"
			],
			"greedy_matches": [
				"1f329-fe0f",
				"1f329"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"lightning"
		]
	},
	"1f328": {
		"name": "cloud with snow",
		"unicode_version": 7,
		"category": "nature",
		"order": 1159,
		"display": 1,
		"shortname": ":cloud_snow:",
		"shortname_alternates": [
			":cloud_with_snow:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f328",
			"fully_qualified": "1f328-fe0f",
			"non_fully_qualified": "1f328",
			"output": "1f328-fe0f",
			"default_matches": [
				"1f328-fe0f",
				"1f328"
			],
			"greedy_matches": [
				"1f328-fe0f",
				"1f328"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"cold",
			"snow"
		]
	},
	"26c4": {
		"name": "snowman without snow",
		"unicode_version": 5.2,
		"category": "nature",
		"order": 1161,
		"display": 1,
		"shortname": ":snowman:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26c4",
			"fully_qualified": "26c4",
			"non_fully_qualified": "26c4",
			"output": "26c4",
			"default_matches": [
				"26c4"
			],
			"greedy_matches": [
				"26c4"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"snow",
			"snowman"
		]
	},
	"1f32c": {
		"name": "wind face",
		"unicode_version": 7,
		"category": "nature",
		"order": 1163,
		"display": 1,
		"shortname": ":wind_blowing_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32c",
			"fully_qualified": "1f32c-fe0f",
			"non_fully_qualified": "1f32c",
			"output": "1f32c-fe0f",
			"default_matches": [
				"1f32c-fe0f",
				"1f32c"
			],
			"greedy_matches": [
				"1f32c-fe0f",
				"1f32c"
			],
			"decimal": ""
		},
		"keywords": [
			"blow",
			"cloud",
			"face",
			"wind"
		]
	},
	"1f4a8": {
		"name": "dashing away",
		"unicode_version": 6,
		"category": "nature",
		"order": 1164,
		"display": 1,
		"shortname": ":dash:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a8",
			"fully_qualified": "1f4a8",
			"non_fully_qualified": "1f4a8",
			"output": "1f4a8",
			"default_matches": [
				"1f4a8"
			],
			"greedy_matches": [
				"1f4a8"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"dash",
			"running"
		]
	},
	"1f32a": {
		"name": "tornado",
		"unicode_version": 7,
		"category": "nature",
		"order": 1165,
		"display": 1,
		"shortname": ":cloud_tornado:",
		"shortname_alternates": [
			":cloud_with_tornado:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32a",
			"fully_qualified": "1f32a-fe0f",
			"non_fully_qualified": "1f32a",
			"output": "1f32a-fe0f",
			"default_matches": [
				"1f32a-fe0f",
				"1f32a"
			],
			"greedy_matches": [
				"1f32a-fe0f",
				"1f32a"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud",
			"whirlwind"
		]
	},
	"1f32b": {
		"name": "fog",
		"unicode_version": 7,
		"category": "nature",
		"order": 1166,
		"display": 1,
		"shortname": ":fog:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32b",
			"fully_qualified": "1f32b-fe0f",
			"non_fully_qualified": "1f32b",
			"output": "1f32b-fe0f",
			"default_matches": [
				"1f32b-fe0f",
				"1f32b"
			],
			"greedy_matches": [
				"1f32b-fe0f",
				"1f32b"
			],
			"decimal": ""
		},
		"keywords": [
			"cloud"
		]
	},
	"1f30a": {
		"name": "water wave",
		"unicode_version": 6,
		"category": "nature",
		"order": 1167,
		"display": 1,
		"shortname": ":ocean:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30a",
			"fully_qualified": "1f30a",
			"non_fully_qualified": "1f30a",
			"output": "1f30a",
			"default_matches": [
				"1f30a"
			],
			"greedy_matches": [
				"1f30a"
			],
			"decimal": ""
		},
		"keywords": [
			"ocean",
			"water",
			"wave"
		]
	},
	"1f4a7": {
		"name": "droplet",
		"unicode_version": 6,
		"category": "nature",
		"order": 1168,
		"display": 1,
		"shortname": ":droplet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a7",
			"fully_qualified": "1f4a7",
			"non_fully_qualified": "1f4a7",
			"output": "1f4a7",
			"default_matches": [
				"1f4a7"
			],
			"greedy_matches": [
				"1f4a7"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"comic",
			"drop",
			"sweat"
		]
	},
	"1f4a6": {
		"name": "sweat droplets",
		"unicode_version": 6,
		"category": "nature",
		"order": 1169,
		"display": 1,
		"shortname": ":sweat_drops:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a6",
			"fully_qualified": "1f4a6",
			"non_fully_qualified": "1f4a6",
			"output": "1f4a6",
			"default_matches": [
				"1f4a6"
			],
			"greedy_matches": [
				"1f4a6"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"splashing",
			"sweat"
		]
	},
	"1f992": {
		"name": "giraffe",
		"unicode_version": 10,
		"category": "nature",
		"order": 1171,
		"display": 1,
		"shortname": ":giraffe:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f992",
			"fully_qualified": "1f992",
			"non_fully_qualified": "1f992",
			"output": "1f992",
			"default_matches": [
				"1f992"
			],
			"greedy_matches": [
				"1f992"
			],
			"decimal": ""
		},
		"keywords": [
			"spots"
		]
	},
	"1f993": {
		"name": "zebra",
		"unicode_version": 10,
		"category": "nature",
		"order": 1172,
		"display": 1,
		"shortname": ":zebra:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f993",
			"fully_qualified": "1f993",
			"non_fully_qualified": "1f993",
			"output": "1f993",
			"default_matches": [
				"1f993"
			],
			"greedy_matches": [
				"1f993"
			],
			"decimal": ""
		},
		"keywords": [
			"stripe"
		]
	},
	"1f994": {
		"name": "hedgehog",
		"unicode_version": 10,
		"category": "nature",
		"order": 1173,
		"display": 1,
		"shortname": ":hedgehog:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f994",
			"fully_qualified": "1f994",
			"non_fully_qualified": "1f994",
			"output": "1f994",
			"default_matches": [
				"1f994"
			],
			"greedy_matches": [
				"1f994"
			],
			"decimal": ""
		},
		"keywords": [
			"spiny"
		]
	},
	"1f995": {
		"name": "sauropod",
		"unicode_version": 10,
		"category": "nature",
		"order": 1174,
		"display": 1,
		"shortname": ":sauropod:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f995",
			"fully_qualified": "1f995",
			"non_fully_qualified": "1f995",
			"output": "1f995",
			"default_matches": [
				"1f995"
			],
			"greedy_matches": [
				"1f995"
			],
			"decimal": ""
		},
		"keywords": [
			"brachiosaurus",
			"brontosaurus",
			"diplodocus"
		]
	},
	"1f996": {
		"name": "T-Rex",
		"unicode_version": 10,
		"category": "nature",
		"order": 1175,
		"display": 1,
		"shortname": ":t_rex:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f996",
			"fully_qualified": "1f996",
			"non_fully_qualified": "1f996",
			"output": "1f996",
			"default_matches": [
				"1f996"
			],
			"greedy_matches": [
				"1f996"
			],
			"decimal": ""
		},
		"keywords": [
			"Tyrannosaurus Rex"
		]
	},
	"1f997": {
		"name": "cricket",
		"unicode_version": 10,
		"category": "nature",
		"order": 1176,
		"display": 1,
		"shortname": ":cricket:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f997",
			"fully_qualified": "1f997",
			"non_fully_qualified": "1f997",
			"output": "1f997",
			"default_matches": [
				"1f997"
			],
			"greedy_matches": [
				"1f997"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f34f": {
		"name": "green apple",
		"unicode_version": 6,
		"category": "food",
		"order": 1177,
		"display": 1,
		"shortname": ":green_apple:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34f",
			"fully_qualified": "1f34f",
			"non_fully_qualified": "1f34f",
			"output": "1f34f",
			"default_matches": [
				"1f34f"
			],
			"greedy_matches": [
				"1f34f"
			],
			"decimal": ""
		},
		"keywords": [
			"apple",
			"fruit",
			"green"
		]
	},
	"1f34e": {
		"name": "red apple",
		"unicode_version": 6,
		"category": "food",
		"order": 1178,
		"display": 1,
		"shortname": ":apple:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34e",
			"fully_qualified": "1f34e",
			"non_fully_qualified": "1f34e",
			"output": "1f34e",
			"default_matches": [
				"1f34e"
			],
			"greedy_matches": [
				"1f34e"
			],
			"decimal": ""
		},
		"keywords": [
			"apple",
			"fruit",
			"red"
		]
	},
	"1f350": {
		"name": "pear",
		"unicode_version": 6,
		"category": "food",
		"order": 1179,
		"display": 1,
		"shortname": ":pear:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f350",
			"fully_qualified": "1f350",
			"non_fully_qualified": "1f350",
			"output": "1f350",
			"default_matches": [
				"1f350"
			],
			"greedy_matches": [
				"1f350"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f34a": {
		"name": "tangerine",
		"unicode_version": 6,
		"category": "food",
		"order": 1180,
		"display": 1,
		"shortname": ":tangerine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34a",
			"fully_qualified": "1f34a",
			"non_fully_qualified": "1f34a",
			"output": "1f34a",
			"default_matches": [
				"1f34a"
			],
			"greedy_matches": [
				"1f34a"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit",
			"orange"
		]
	},
	"1f34b": {
		"name": "lemon",
		"unicode_version": 6,
		"category": "food",
		"order": 1181,
		"display": 1,
		"shortname": ":lemon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34b",
			"fully_qualified": "1f34b",
			"non_fully_qualified": "1f34b",
			"output": "1f34b",
			"default_matches": [
				"1f34b"
			],
			"greedy_matches": [
				"1f34b"
			],
			"decimal": ""
		},
		"keywords": [
			"citrus",
			"fruit"
		]
	},
	"1f34c": {
		"name": "banana",
		"unicode_version": 6,
		"category": "food",
		"order": 1182,
		"display": 1,
		"shortname": ":banana:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34c",
			"fully_qualified": "1f34c",
			"non_fully_qualified": "1f34c",
			"output": "1f34c",
			"default_matches": [
				"1f34c"
			],
			"greedy_matches": [
				"1f34c"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f349": {
		"name": "watermelon",
		"unicode_version": 6,
		"category": "food",
		"order": 1183,
		"display": 1,
		"shortname": ":watermelon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f349",
			"fully_qualified": "1f349",
			"non_fully_qualified": "1f349",
			"output": "1f349",
			"default_matches": [
				"1f349"
			],
			"greedy_matches": [
				"1f349"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f347": {
		"name": "grapes",
		"unicode_version": 6,
		"category": "food",
		"order": 1184,
		"display": 1,
		"shortname": ":grapes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f347",
			"fully_qualified": "1f347",
			"non_fully_qualified": "1f347",
			"output": "1f347",
			"default_matches": [
				"1f347"
			],
			"greedy_matches": [
				"1f347"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit",
			"grape"
		]
	},
	"1f353": {
		"name": "strawberry",
		"unicode_version": 6,
		"category": "food",
		"order": 1185,
		"display": 1,
		"shortname": ":strawberry:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f353",
			"fully_qualified": "1f353",
			"non_fully_qualified": "1f353",
			"output": "1f353",
			"default_matches": [
				"1f353"
			],
			"greedy_matches": [
				"1f353"
			],
			"decimal": ""
		},
		"keywords": [
			"berry",
			"fruit"
		]
	},
	"1f348": {
		"name": "melon",
		"unicode_version": 6,
		"category": "food",
		"order": 1186,
		"display": 1,
		"shortname": ":melon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f348",
			"fully_qualified": "1f348",
			"non_fully_qualified": "1f348",
			"output": "1f348",
			"default_matches": [
				"1f348"
			],
			"greedy_matches": [
				"1f348"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f352": {
		"name": "cherries",
		"unicode_version": 6,
		"category": "food",
		"order": 1187,
		"display": 1,
		"shortname": ":cherries:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f352",
			"fully_qualified": "1f352",
			"non_fully_qualified": "1f352",
			"output": "1f352",
			"default_matches": [
				"1f352"
			],
			"greedy_matches": [
				"1f352"
			],
			"decimal": ""
		},
		"keywords": [
			"cherry",
			"fruit"
		]
	},
	"1f351": {
		"name": "peach",
		"unicode_version": 6,
		"category": "food",
		"order": 1188,
		"display": 1,
		"shortname": ":peach:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f351",
			"fully_qualified": "1f351",
			"non_fully_qualified": "1f351",
			"output": "1f351",
			"default_matches": [
				"1f351"
			],
			"greedy_matches": [
				"1f351"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f34d": {
		"name": "pineapple",
		"unicode_version": 6,
		"category": "food",
		"order": 1189,
		"display": 1,
		"shortname": ":pineapple:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f34d",
			"fully_qualified": "1f34d",
			"non_fully_qualified": "1f34d",
			"output": "1f34d",
			"default_matches": [
				"1f34d"
			],
			"greedy_matches": [
				"1f34d"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit"
		]
	},
	"1f95d": {
		"name": "kiwi fruit",
		"unicode_version": 9,
		"category": "food",
		"order": 1190,
		"display": 1,
		"shortname": ":kiwi:",
		"shortname_alternates": [
			":kiwifruit:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95d",
			"fully_qualified": "1f95d",
			"non_fully_qualified": "1f95d",
			"output": "1f95d",
			"default_matches": [
				"1f95d"
			],
			"greedy_matches": [
				"1f95d"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"fruit",
			"kiwi"
		]
	},
	"1f951": {
		"name": "avocado",
		"unicode_version": 9,
		"category": "food",
		"order": 1191,
		"display": 1,
		"shortname": ":avocado:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f951",
			"fully_qualified": "1f951",
			"non_fully_qualified": "1f951",
			"output": "1f951",
			"default_matches": [
				"1f951"
			],
			"greedy_matches": [
				"1f951"
			],
			"decimal": ""
		},
		"keywords": [
			"avocado",
			"food",
			"fruit"
		]
	},
	"1f345": {
		"name": "tomato",
		"unicode_version": 6,
		"category": "food",
		"order": 1192,
		"display": 1,
		"shortname": ":tomato:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f345",
			"fully_qualified": "1f345",
			"non_fully_qualified": "1f345",
			"output": "1f345",
			"default_matches": [
				"1f345"
			],
			"greedy_matches": [
				"1f345"
			],
			"decimal": ""
		},
		"keywords": [
			"fruit",
			"vegetable"
		]
	},
	"1f346": {
		"name": "eggplant",
		"unicode_version": 6,
		"category": "food",
		"order": 1193,
		"display": 1,
		"shortname": ":eggplant:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f346",
			"fully_qualified": "1f346",
			"non_fully_qualified": "1f346",
			"output": "1f346",
			"default_matches": [
				"1f346"
			],
			"greedy_matches": [
				"1f346"
			],
			"decimal": ""
		},
		"keywords": [
			"aubergine",
			"vegetable"
		]
	},
	"1f952": {
		"name": "cucumber",
		"unicode_version": 9,
		"category": "food",
		"order": 1194,
		"display": 1,
		"shortname": ":cucumber:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f952",
			"fully_qualified": "1f952",
			"non_fully_qualified": "1f952",
			"output": "1f952",
			"default_matches": [
				"1f952"
			],
			"greedy_matches": [
				"1f952"
			],
			"decimal": ""
		},
		"keywords": [
			"cucumber",
			"food",
			"pickle",
			"vegetable"
		]
	},
	"1f955": {
		"name": "carrot",
		"unicode_version": 9,
		"category": "food",
		"order": 1195,
		"display": 1,
		"shortname": ":carrot:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f955",
			"fully_qualified": "1f955",
			"non_fully_qualified": "1f955",
			"output": "1f955",
			"default_matches": [
				"1f955"
			],
			"greedy_matches": [
				"1f955"
			],
			"decimal": ""
		},
		"keywords": [
			"carrot",
			"food",
			"vegetable"
		]
	},
	"1f33d": {
		"name": "ear of corn",
		"unicode_version": 6,
		"category": "food",
		"order": 1196,
		"display": 1,
		"shortname": ":corn:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f33d",
			"fully_qualified": "1f33d",
			"non_fully_qualified": "1f33d",
			"output": "1f33d",
			"default_matches": [
				"1f33d"
			],
			"greedy_matches": [
				"1f33d"
			],
			"decimal": ""
		},
		"keywords": [
			"corn",
			"ear",
			"maize",
			"maze"
		]
	},
	"1f336": {
		"name": "hot pepper",
		"unicode_version": 7,
		"category": "food",
		"order": 1197,
		"display": 1,
		"shortname": ":hot_pepper:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f336",
			"fully_qualified": "1f336-fe0f",
			"non_fully_qualified": "1f336",
			"output": "1f336-fe0f",
			"default_matches": [
				"1f336-fe0f",
				"1f336"
			],
			"greedy_matches": [
				"1f336-fe0f",
				"1f336"
			],
			"decimal": ""
		},
		"keywords": [
			"hot",
			"pepper"
		]
	},
	"1f954": {
		"name": "potato",
		"unicode_version": 9,
		"category": "food",
		"order": 1198,
		"display": 1,
		"shortname": ":potato:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f954",
			"fully_qualified": "1f954",
			"non_fully_qualified": "1f954",
			"output": "1f954",
			"default_matches": [
				"1f954"
			],
			"greedy_matches": [
				"1f954"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"potato",
			"vegetable"
		]
	},
	"1f360": {
		"name": "roasted sweet potato",
		"unicode_version": 6,
		"category": "food",
		"order": 1199,
		"display": 1,
		"shortname": ":sweet_potato:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f360",
			"fully_qualified": "1f360",
			"non_fully_qualified": "1f360",
			"output": "1f360",
			"default_matches": [
				"1f360"
			],
			"greedy_matches": [
				"1f360"
			],
			"decimal": ""
		},
		"keywords": [
			"potato",
			"roasted",
			"sweet"
		]
	},
	"1f330": {
		"name": "chestnut",
		"unicode_version": 6,
		"category": "food",
		"order": 1200,
		"display": 1,
		"shortname": ":chestnut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f330",
			"fully_qualified": "1f330",
			"non_fully_qualified": "1f330",
			"output": "1f330",
			"default_matches": [
				"1f330"
			],
			"greedy_matches": [
				"1f330"
			],
			"decimal": ""
		},
		"keywords": [
			"plant"
		]
	},
	"1f95c": {
		"name": "peanuts",
		"unicode_version": 9,
		"category": "food",
		"order": 1201,
		"display": 1,
		"shortname": ":peanuts:",
		"shortname_alternates": [
			":shelled_peanut:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95c",
			"fully_qualified": "1f95c",
			"non_fully_qualified": "1f95c",
			"output": "1f95c",
			"default_matches": [
				"1f95c"
			],
			"greedy_matches": [
				"1f95c"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"nut",
			"peanut",
			"vegetable"
		]
	},
	"1f36f": {
		"name": "honey pot",
		"unicode_version": 6,
		"category": "food",
		"order": 1202,
		"display": 1,
		"shortname": ":honey_pot:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36f",
			"fully_qualified": "1f36f",
			"non_fully_qualified": "1f36f",
			"output": "1f36f",
			"default_matches": [
				"1f36f"
			],
			"greedy_matches": [
				"1f36f"
			],
			"decimal": ""
		},
		"keywords": [
			"honey",
			"honeypot",
			"pot",
			"sweet"
		]
	},
	"1f950": {
		"name": "croissant",
		"unicode_version": 9,
		"category": "food",
		"order": 1203,
		"display": 1,
		"shortname": ":croissant:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f950",
			"fully_qualified": "1f950",
			"non_fully_qualified": "1f950",
			"output": "1f950",
			"default_matches": [
				"1f950"
			],
			"greedy_matches": [
				"1f950"
			],
			"decimal": ""
		},
		"keywords": [
			"bread",
			"crescent roll",
			"croissant",
			"food",
			"french"
		]
	},
	"1f35e": {
		"name": "bread",
		"unicode_version": 6,
		"category": "food",
		"order": 1204,
		"display": 1,
		"shortname": ":bread:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35e",
			"fully_qualified": "1f35e",
			"non_fully_qualified": "1f35e",
			"output": "1f35e",
			"default_matches": [
				"1f35e"
			],
			"greedy_matches": [
				"1f35e"
			],
			"decimal": ""
		},
		"keywords": [
			"loaf"
		]
	},
	"1f956": {
		"name": "baguette bread",
		"unicode_version": 9,
		"category": "food",
		"order": 1205,
		"display": 1,
		"shortname": ":french_bread:",
		"shortname_alternates": [
			":baguette_bread:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f956",
			"fully_qualified": "1f956",
			"non_fully_qualified": "1f956",
			"output": "1f956",
			"default_matches": [
				"1f956"
			],
			"greedy_matches": [
				"1f956"
			],
			"decimal": ""
		},
		"keywords": [
			"baguette",
			"bread",
			"food",
			"french"
		]
	},
	"1f9c0": {
		"name": "cheese wedge",
		"unicode_version": 8,
		"category": "food",
		"order": 1206,
		"display": 1,
		"shortname": ":cheese:",
		"shortname_alternates": [
			":cheese_wedge:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9c0",
			"fully_qualified": "1f9c0",
			"non_fully_qualified": "1f9c0",
			"output": "1f9c0",
			"default_matches": [
				"1f9c0"
			],
			"greedy_matches": [
				"1f9c0"
			],
			"decimal": ""
		},
		"keywords": [
			"cheese"
		]
	},
	"1f95a": {
		"name": "egg",
		"unicode_version": 9,
		"category": "food",
		"order": 1207,
		"display": 1,
		"shortname": ":egg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95a",
			"fully_qualified": "1f95a",
			"non_fully_qualified": "1f95a",
			"output": "1f95a",
			"default_matches": [
				"1f95a"
			],
			"greedy_matches": [
				"1f95a"
			],
			"decimal": ""
		},
		"keywords": [
			"egg",
			"food"
		]
	},
	"1f373": {
		"name": "cooking",
		"unicode_version": 6,
		"category": "food",
		"order": 1208,
		"display": 1,
		"shortname": ":cooking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f373",
			"fully_qualified": "1f373",
			"non_fully_qualified": "1f373",
			"output": "1f373",
			"default_matches": [
				"1f373"
			],
			"greedy_matches": [
				"1f373"
			],
			"decimal": ""
		},
		"keywords": [
			"egg",
			"frying",
			"pan"
		]
	},
	"1f953": {
		"name": "bacon",
		"unicode_version": 9,
		"category": "food",
		"order": 1209,
		"display": 1,
		"shortname": ":bacon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f953",
			"fully_qualified": "1f953",
			"non_fully_qualified": "1f953",
			"output": "1f953",
			"default_matches": [
				"1f953"
			],
			"greedy_matches": [
				"1f953"
			],
			"decimal": ""
		},
		"keywords": [
			"bacon",
			"food",
			"meat"
		]
	},
	"1f95e": {
		"name": "pancakes",
		"unicode_version": 9,
		"category": "food",
		"order": 1210,
		"display": 1,
		"shortname": ":pancakes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95e",
			"fully_qualified": "1f95e",
			"non_fully_qualified": "1f95e",
			"output": "1f95e",
			"default_matches": [
				"1f95e"
			],
			"greedy_matches": [
				"1f95e"
			],
			"decimal": ""
		},
		"keywords": [
			"crêpe",
			"food",
			"hotcake",
			"pancake"
		]
	},
	"1f364": {
		"name": "fried shrimp",
		"unicode_version": 6,
		"category": "food",
		"order": 1211,
		"display": 1,
		"shortname": ":fried_shrimp:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f364",
			"fully_qualified": "1f364",
			"non_fully_qualified": "1f364",
			"output": "1f364",
			"default_matches": [
				"1f364"
			],
			"greedy_matches": [
				"1f364"
			],
			"decimal": ""
		},
		"keywords": [
			"fried",
			"prawn",
			"shrimp",
			"tempura"
		]
	},
	"1f357": {
		"name": "poultry leg",
		"unicode_version": 6,
		"category": "food",
		"order": 1212,
		"display": 1,
		"shortname": ":poultry_leg:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f357",
			"fully_qualified": "1f357",
			"non_fully_qualified": "1f357",
			"output": "1f357",
			"default_matches": [
				"1f357"
			],
			"greedy_matches": [
				"1f357"
			],
			"decimal": ""
		},
		"keywords": [
			"bone",
			"chicken",
			"leg",
			"poultry"
		]
	},
	"1f356": {
		"name": "meat on bone",
		"unicode_version": 6,
		"category": "food",
		"order": 1213,
		"display": 1,
		"shortname": ":meat_on_bone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f356",
			"fully_qualified": "1f356",
			"non_fully_qualified": "1f356",
			"output": "1f356",
			"default_matches": [
				"1f356"
			],
			"greedy_matches": [
				"1f356"
			],
			"decimal": ""
		},
		"keywords": [
			"bone",
			"meat"
		]
	},
	"1f355": {
		"name": "pizza",
		"unicode_version": 6,
		"category": "food",
		"order": 1214,
		"display": 1,
		"shortname": ":pizza:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f355",
			"fully_qualified": "1f355",
			"non_fully_qualified": "1f355",
			"output": "1f355",
			"default_matches": [
				"1f355"
			],
			"greedy_matches": [
				"1f355"
			],
			"decimal": ""
		},
		"keywords": [
			"cheese",
			"slice"
		]
	},
	"1f32d": {
		"name": "hot dog",
		"unicode_version": 8,
		"category": "food",
		"order": 1215,
		"display": 1,
		"shortname": ":hotdog:",
		"shortname_alternates": [
			":hot_dog:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32d",
			"fully_qualified": "1f32d",
			"non_fully_qualified": "1f32d",
			"output": "1f32d",
			"default_matches": [
				"1f32d"
			],
			"greedy_matches": [
				"1f32d"
			],
			"decimal": ""
		},
		"keywords": [
			"frankfurter",
			"hotdog",
			"sausage"
		]
	},
	"1f354": {
		"name": "hamburger",
		"unicode_version": 6,
		"category": "food",
		"order": 1216,
		"display": 1,
		"shortname": ":hamburger:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f354",
			"fully_qualified": "1f354",
			"non_fully_qualified": "1f354",
			"output": "1f354",
			"default_matches": [
				"1f354"
			],
			"greedy_matches": [
				"1f354"
			],
			"decimal": ""
		},
		"keywords": [
			"burger"
		]
	},
	"1f35f": {
		"name": "french fries",
		"unicode_version": 6,
		"category": "food",
		"order": 1217,
		"display": 1,
		"shortname": ":fries:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35f",
			"fully_qualified": "1f35f",
			"non_fully_qualified": "1f35f",
			"output": "1f35f",
			"default_matches": [
				"1f35f"
			],
			"greedy_matches": [
				"1f35f"
			],
			"decimal": ""
		},
		"keywords": [
			"french",
			"fries"
		]
	},
	"1f959": {
		"name": "stuffed flatbread",
		"unicode_version": 9,
		"category": "food",
		"order": 1218,
		"display": 1,
		"shortname": ":stuffed_flatbread:",
		"shortname_alternates": [
			":stuffed_pita:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f959",
			"fully_qualified": "1f959",
			"non_fully_qualified": "1f959",
			"output": "1f959",
			"default_matches": [
				"1f959"
			],
			"greedy_matches": [
				"1f959"
			],
			"decimal": ""
		},
		"keywords": [
			"falafel",
			"flatbread",
			"food",
			"gyro",
			"kebab",
			"stuffed"
		]
	},
	"1f32e": {
		"name": "taco",
		"unicode_version": 8,
		"category": "food",
		"order": 1219,
		"display": 1,
		"shortname": ":taco:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32e",
			"fully_qualified": "1f32e",
			"non_fully_qualified": "1f32e",
			"output": "1f32e",
			"default_matches": [
				"1f32e"
			],
			"greedy_matches": [
				"1f32e"
			],
			"decimal": ""
		},
		"keywords": [
			"mexican"
		]
	},
	"1f32f": {
		"name": "burrito",
		"unicode_version": 8,
		"category": "food",
		"order": 1220,
		"display": 1,
		"shortname": ":burrito:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f32f",
			"fully_qualified": "1f32f",
			"non_fully_qualified": "1f32f",
			"output": "1f32f",
			"default_matches": [
				"1f32f"
			],
			"greedy_matches": [
				"1f32f"
			],
			"decimal": ""
		},
		"keywords": [
			"mexican",
			"wrap"
		]
	},
	"1f957": {
		"name": "green salad",
		"unicode_version": 9,
		"category": "food",
		"order": 1221,
		"display": 1,
		"shortname": ":salad:",
		"shortname_alternates": [
			":green_salad:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f957",
			"fully_qualified": "1f957",
			"non_fully_qualified": "1f957",
			"output": "1f957",
			"default_matches": [
				"1f957"
			],
			"greedy_matches": [
				"1f957"
			],
			"decimal": ""
		},
		"keywords": [
			"food",
			"green",
			"salad"
		]
	},
	"1f958": {
		"name": "shallow pan of food",
		"unicode_version": 9,
		"category": "food",
		"order": 1222,
		"display": 1,
		"shortname": ":shallow_pan_of_food:",
		"shortname_alternates": [
			":paella:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f958",
			"fully_qualified": "1f958",
			"non_fully_qualified": "1f958",
			"output": "1f958",
			"default_matches": [
				"1f958"
			],
			"greedy_matches": [
				"1f958"
			],
			"decimal": ""
		},
		"keywords": [
			"casserole",
			"food",
			"paella",
			"pan",
			"shallow"
		]
	},
	"1f35d": {
		"name": "spaghetti",
		"unicode_version": 6,
		"category": "food",
		"order": 1223,
		"display": 1,
		"shortname": ":spaghetti:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35d",
			"fully_qualified": "1f35d",
			"non_fully_qualified": "1f35d",
			"output": "1f35d",
			"default_matches": [
				"1f35d"
			],
			"greedy_matches": [
				"1f35d"
			],
			"decimal": ""
		},
		"keywords": [
			"pasta"
		]
	},
	"1f35c": {
		"name": "steaming bowl",
		"unicode_version": 6,
		"category": "food",
		"order": 1224,
		"display": 1,
		"shortname": ":ramen:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35c",
			"fully_qualified": "1f35c",
			"non_fully_qualified": "1f35c",
			"output": "1f35c",
			"default_matches": [
				"1f35c"
			],
			"greedy_matches": [
				"1f35c"
			],
			"decimal": ""
		},
		"keywords": [
			"bowl",
			"noodle",
			"ramen",
			"steaming"
		]
	},
	"1f372": {
		"name": "pot of food",
		"unicode_version": 6,
		"category": "food",
		"order": 1225,
		"display": 1,
		"shortname": ":stew:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f372",
			"fully_qualified": "1f372",
			"non_fully_qualified": "1f372",
			"output": "1f372",
			"default_matches": [
				"1f372"
			],
			"greedy_matches": [
				"1f372"
			],
			"decimal": ""
		},
		"keywords": [
			"pot",
			"stew"
		]
	},
	"1f365": {
		"name": "fish cake with swirl",
		"unicode_version": 6,
		"category": "food",
		"order": 1226,
		"display": 1,
		"shortname": ":fish_cake:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f365",
			"fully_qualified": "1f365",
			"non_fully_qualified": "1f365",
			"output": "1f365",
			"default_matches": [
				"1f365"
			],
			"greedy_matches": [
				"1f365"
			],
			"decimal": ""
		},
		"keywords": [
			"cake",
			"fish",
			"pastry",
			"swirl"
		]
	},
	"1f363": {
		"name": "sushi",
		"unicode_version": 6,
		"category": "food",
		"order": 1227,
		"display": 1,
		"shortname": ":sushi:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f363",
			"fully_qualified": "1f363",
			"non_fully_qualified": "1f363",
			"output": "1f363",
			"default_matches": [
				"1f363"
			],
			"greedy_matches": [
				"1f363"
			],
			"decimal": ""
		},
		"keywords": [
			"sushi"
		]
	},
	"1f371": {
		"name": "bento box",
		"unicode_version": 6,
		"category": "food",
		"order": 1228,
		"display": 1,
		"shortname": ":bento:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f371",
			"fully_qualified": "1f371",
			"non_fully_qualified": "1f371",
			"output": "1f371",
			"default_matches": [
				"1f371"
			],
			"greedy_matches": [
				"1f371"
			],
			"decimal": ""
		},
		"keywords": [
			"bento",
			"box"
		]
	},
	"1f35b": {
		"name": "curry rice",
		"unicode_version": 6,
		"category": "food",
		"order": 1229,
		"display": 1,
		"shortname": ":curry:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35b",
			"fully_qualified": "1f35b",
			"non_fully_qualified": "1f35b",
			"output": "1f35b",
			"default_matches": [
				"1f35b"
			],
			"greedy_matches": [
				"1f35b"
			],
			"decimal": ""
		},
		"keywords": [
			"curry",
			"rice"
		]
	},
	"1f359": {
		"name": "rice ball",
		"unicode_version": 6,
		"category": "food",
		"order": 1230,
		"display": 1,
		"shortname": ":rice_ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f359",
			"fully_qualified": "1f359",
			"non_fully_qualified": "1f359",
			"output": "1f359",
			"default_matches": [
				"1f359"
			],
			"greedy_matches": [
				"1f359"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ball",
			"rice"
		]
	},
	"1f35a": {
		"name": "cooked rice",
		"unicode_version": 6,
		"category": "food",
		"order": 1231,
		"display": 1,
		"shortname": ":rice:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f35a",
			"fully_qualified": "1f35a",
			"non_fully_qualified": "1f35a",
			"output": "1f35a",
			"default_matches": [
				"1f35a"
			],
			"greedy_matches": [
				"1f35a"
			],
			"decimal": ""
		},
		"keywords": [
			"cooked",
			"rice"
		]
	},
	"1f358": {
		"name": "rice cracker",
		"unicode_version": 6,
		"category": "food",
		"order": 1232,
		"display": 1,
		"shortname": ":rice_cracker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f358",
			"fully_qualified": "1f358",
			"non_fully_qualified": "1f358",
			"output": "1f358",
			"default_matches": [
				"1f358"
			],
			"greedy_matches": [
				"1f358"
			],
			"decimal": ""
		},
		"keywords": [
			"cracker",
			"rice"
		]
	},
	"1f362": {
		"name": "oden",
		"unicode_version": 6,
		"category": "food",
		"order": 1233,
		"display": 1,
		"shortname": ":oden:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f362",
			"fully_qualified": "1f362",
			"non_fully_qualified": "1f362",
			"output": "1f362",
			"default_matches": [
				"1f362"
			],
			"greedy_matches": [
				"1f362"
			],
			"decimal": ""
		},
		"keywords": [
			"kebab",
			"seafood",
			"skewer",
			"stick"
		]
	},
	"1f361": {
		"name": "dango",
		"unicode_version": 6,
		"category": "food",
		"order": 1234,
		"display": 1,
		"shortname": ":dango:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f361",
			"fully_qualified": "1f361",
			"non_fully_qualified": "1f361",
			"output": "1f361",
			"default_matches": [
				"1f361"
			],
			"greedy_matches": [
				"1f361"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"dessert",
			"skewer",
			"stick",
			"sweet"
		]
	},
	"1f367": {
		"name": "shaved ice",
		"unicode_version": 6,
		"category": "food",
		"order": 1235,
		"display": 1,
		"shortname": ":shaved_ice:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f367",
			"fully_qualified": "1f367",
			"non_fully_qualified": "1f367",
			"output": "1f367",
			"default_matches": [
				"1f367"
			],
			"greedy_matches": [
				"1f367"
			],
			"decimal": ""
		},
		"keywords": [
			"dessert",
			"ice",
			"shaved",
			"sweet"
		]
	},
	"1f368": {
		"name": "ice cream",
		"unicode_version": 6,
		"category": "food",
		"order": 1236,
		"display": 1,
		"shortname": ":ice_cream:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f368",
			"fully_qualified": "1f368",
			"non_fully_qualified": "1f368",
			"output": "1f368",
			"default_matches": [
				"1f368"
			],
			"greedy_matches": [
				"1f368"
			],
			"decimal": ""
		},
		"keywords": [
			"cream",
			"dessert",
			"ice",
			"sweet"
		]
	},
	"1f366": {
		"name": "soft ice cream",
		"unicode_version": 6,
		"category": "food",
		"order": 1237,
		"display": 1,
		"shortname": ":icecream:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f366",
			"fully_qualified": "1f366",
			"non_fully_qualified": "1f366",
			"output": "1f366",
			"default_matches": [
				"1f366"
			],
			"greedy_matches": [
				"1f366"
			],
			"decimal": ""
		},
		"keywords": [
			"cream",
			"dessert",
			"ice",
			"icecream",
			"soft",
			"sweet"
		]
	},
	"1f370": {
		"name": "shortcake",
		"unicode_version": 6,
		"category": "food",
		"order": 1238,
		"display": 1,
		"shortname": ":cake:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f370",
			"fully_qualified": "1f370",
			"non_fully_qualified": "1f370",
			"output": "1f370",
			"default_matches": [
				"1f370"
			],
			"greedy_matches": [
				"1f370"
			],
			"decimal": ""
		},
		"keywords": [
			"cake",
			"dessert",
			"pastry",
			"slice",
			"sweet"
		]
	},
	"1f382": {
		"name": "birthday cake",
		"unicode_version": 6,
		"category": "food",
		"order": 1239,
		"display": 1,
		"shortname": ":birthday:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f382",
			"fully_qualified": "1f382",
			"non_fully_qualified": "1f382",
			"output": "1f382",
			"default_matches": [
				"1f382"
			],
			"greedy_matches": [
				"1f382"
			],
			"decimal": ""
		},
		"keywords": [
			"birthday",
			"cake",
			"celebration",
			"dessert",
			"pastry",
			"sweet"
		]
	},
	"1f36e": {
		"name": "custard",
		"unicode_version": 6,
		"category": "food",
		"order": 1240,
		"display": 1,
		"shortname": ":custard:",
		"shortname_alternates": [
			":pudding:",
			":flan:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36e",
			"fully_qualified": "1f36e",
			"non_fully_qualified": "1f36e",
			"output": "1f36e",
			"default_matches": [
				"1f36e"
			],
			"greedy_matches": [
				"1f36e"
			],
			"decimal": ""
		},
		"keywords": [
			"dessert",
			"pudding",
			"sweet"
		]
	},
	"1f36d": {
		"name": "lollipop",
		"unicode_version": 6,
		"category": "food",
		"order": 1241,
		"display": 1,
		"shortname": ":lollipop:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36d",
			"fully_qualified": "1f36d",
			"non_fully_qualified": "1f36d",
			"output": "1f36d",
			"default_matches": [
				"1f36d"
			],
			"greedy_matches": [
				"1f36d"
			],
			"decimal": ""
		},
		"keywords": [
			"candy",
			"dessert",
			"sweet"
		]
	},
	"1f36c": {
		"name": "candy",
		"unicode_version": 6,
		"category": "food",
		"order": 1242,
		"display": 1,
		"shortname": ":candy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36c",
			"fully_qualified": "1f36c",
			"non_fully_qualified": "1f36c",
			"output": "1f36c",
			"default_matches": [
				"1f36c"
			],
			"greedy_matches": [
				"1f36c"
			],
			"decimal": ""
		},
		"keywords": [
			"dessert",
			"sweet"
		]
	},
	"1f36b": {
		"name": "chocolate bar",
		"unicode_version": 6,
		"category": "food",
		"order": 1243,
		"display": 1,
		"shortname": ":chocolate_bar:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36b",
			"fully_qualified": "1f36b",
			"non_fully_qualified": "1f36b",
			"output": "1f36b",
			"default_matches": [
				"1f36b"
			],
			"greedy_matches": [
				"1f36b"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"chocolate",
			"dessert",
			"sweet"
		]
	},
	"1f37f": {
		"name": "popcorn",
		"unicode_version": 8,
		"category": "food",
		"order": 1244,
		"display": 1,
		"shortname": ":popcorn:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37f",
			"fully_qualified": "1f37f",
			"non_fully_qualified": "1f37f",
			"output": "1f37f",
			"default_matches": [
				"1f37f"
			],
			"greedy_matches": [
				"1f37f"
			],
			"decimal": ""
		},
		"keywords": [
			"popcorn"
		]
	},
	"1f369": {
		"name": "doughnut",
		"unicode_version": 6,
		"category": "food",
		"order": 1245,
		"display": 1,
		"shortname": ":doughnut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f369",
			"fully_qualified": "1f369",
			"non_fully_qualified": "1f369",
			"output": "1f369",
			"default_matches": [
				"1f369"
			],
			"greedy_matches": [
				"1f369"
			],
			"decimal": ""
		},
		"keywords": [
			"dessert",
			"donut",
			"sweet"
		]
	},
	"1f36a": {
		"name": "cookie",
		"unicode_version": 6,
		"category": "food",
		"order": 1246,
		"display": 1,
		"shortname": ":cookie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f36a",
			"fully_qualified": "1f36a",
			"non_fully_qualified": "1f36a",
			"output": "1f36a",
			"default_matches": [
				"1f36a"
			],
			"greedy_matches": [
				"1f36a"
			],
			"decimal": ""
		},
		"keywords": [
			"dessert",
			"sweet"
		]
	},
	"1f95b": {
		"name": "glass of milk",
		"unicode_version": 9,
		"category": "food",
		"order": 1247,
		"display": 1,
		"shortname": ":milk:",
		"shortname_alternates": [
			":glass_of_milk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95b",
			"fully_qualified": "1f95b",
			"non_fully_qualified": "1f95b",
			"output": "1f95b",
			"default_matches": [
				"1f95b"
			],
			"greedy_matches": [
				"1f95b"
			],
			"decimal": ""
		},
		"keywords": [
			"drink",
			"glass",
			"milk"
		]
	},
	"1f37c": {
		"name": "baby bottle",
		"unicode_version": 6,
		"category": "food",
		"order": 1248,
		"display": 1,
		"shortname": ":baby_bottle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37c",
			"fully_qualified": "1f37c",
			"non_fully_qualified": "1f37c",
			"output": "1f37c",
			"default_matches": [
				"1f37c"
			],
			"greedy_matches": [
				"1f37c"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"bottle",
			"drink",
			"milk"
		]
	},
	"1f375": {
		"name": "teacup without handle",
		"unicode_version": 6,
		"category": "food",
		"order": 1250,
		"display": 1,
		"shortname": ":tea:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f375",
			"fully_qualified": "1f375",
			"non_fully_qualified": "1f375",
			"output": "1f375",
			"default_matches": [
				"1f375"
			],
			"greedy_matches": [
				"1f375"
			],
			"decimal": ""
		},
		"keywords": [
			"beverage",
			"cup",
			"drink",
			"tea",
			"teacup"
		]
	},
	"1f376": {
		"name": "sake",
		"unicode_version": 6,
		"category": "food",
		"order": 1251,
		"display": 1,
		"shortname": ":sake:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f376",
			"fully_qualified": "1f376",
			"non_fully_qualified": "1f376",
			"output": "1f376",
			"default_matches": [
				"1f376"
			],
			"greedy_matches": [
				"1f376"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"beverage",
			"bottle",
			"cup",
			"drink"
		]
	},
	"1f37a": {
		"name": "beer mug",
		"unicode_version": 6,
		"category": "food",
		"order": 1252,
		"display": 1,
		"shortname": ":beer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37a",
			"fully_qualified": "1f37a",
			"non_fully_qualified": "1f37a",
			"output": "1f37a",
			"default_matches": [
				"1f37a"
			],
			"greedy_matches": [
				"1f37a"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"beer",
			"drink",
			"mug"
		]
	},
	"1f37b": {
		"name": "clinking beer mugs",
		"unicode_version": 6,
		"category": "food",
		"order": 1253,
		"display": 1,
		"shortname": ":beers:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37b",
			"fully_qualified": "1f37b",
			"non_fully_qualified": "1f37b",
			"output": "1f37b",
			"default_matches": [
				"1f37b"
			],
			"greedy_matches": [
				"1f37b"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"beer",
			"clink",
			"drink",
			"mug"
		]
	},
	"1f942": {
		"name": "clinking glasses",
		"unicode_version": 9,
		"category": "food",
		"order": 1254,
		"display": 1,
		"shortname": ":champagne_glass:",
		"shortname_alternates": [
			":clinking_glass:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f942",
			"fully_qualified": "1f942",
			"non_fully_qualified": "1f942",
			"output": "1f942",
			"default_matches": [
				"1f942"
			],
			"greedy_matches": [
				"1f942"
			],
			"decimal": ""
		},
		"keywords": [
			"celebrate",
			"clink",
			"drink",
			"glass"
		]
	},
	"1f377": {
		"name": "wine glass",
		"unicode_version": 6,
		"category": "food",
		"order": 1255,
		"display": 1,
		"shortname": ":wine_glass:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f377",
			"fully_qualified": "1f377",
			"non_fully_qualified": "1f377",
			"output": "1f377",
			"default_matches": [
				"1f377"
			],
			"greedy_matches": [
				"1f377"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"beverage",
			"drink",
			"glass",
			"wine"
		]
	},
	"1f943": {
		"name": "tumbler glass",
		"unicode_version": 9,
		"category": "food",
		"order": 1256,
		"display": 1,
		"shortname": ":tumbler_glass:",
		"shortname_alternates": [
			":whisky:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f943",
			"fully_qualified": "1f943",
			"non_fully_qualified": "1f943",
			"output": "1f943",
			"default_matches": [
				"1f943"
			],
			"greedy_matches": [
				"1f943"
			],
			"decimal": ""
		},
		"keywords": [
			"glass",
			"liquor",
			"shot",
			"tumbler",
			"whisky"
		]
	},
	"1f378": {
		"name": "cocktail glass",
		"unicode_version": 6,
		"category": "food",
		"order": 1257,
		"display": 1,
		"shortname": ":cocktail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f378",
			"fully_qualified": "1f378",
			"non_fully_qualified": "1f378",
			"output": "1f378",
			"default_matches": [
				"1f378"
			],
			"greedy_matches": [
				"1f378"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"cocktail",
			"drink",
			"glass"
		]
	},
	"1f379": {
		"name": "tropical drink",
		"unicode_version": 6,
		"category": "food",
		"order": 1258,
		"display": 1,
		"shortname": ":tropical_drink:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f379",
			"fully_qualified": "1f379",
			"non_fully_qualified": "1f379",
			"output": "1f379",
			"default_matches": [
				"1f379"
			],
			"greedy_matches": [
				"1f379"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"drink",
			"tropical"
		]
	},
	"1f37e": {
		"name": "bottle with popping cork",
		"unicode_version": 8,
		"category": "food",
		"order": 1259,
		"display": 1,
		"shortname": ":champagne:",
		"shortname_alternates": [
			":bottle_with_popping_cork:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37e",
			"fully_qualified": "1f37e",
			"non_fully_qualified": "1f37e",
			"output": "1f37e",
			"default_matches": [
				"1f37e"
			],
			"greedy_matches": [
				"1f37e"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"bottle",
			"cork",
			"drink",
			"popping"
		]
	},
	"1f944": {
		"name": "spoon",
		"unicode_version": 9,
		"category": "food",
		"order": 1260,
		"display": 1,
		"shortname": ":spoon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f944",
			"fully_qualified": "1f944",
			"non_fully_qualified": "1f944",
			"output": "1f944",
			"default_matches": [
				"1f944"
			],
			"greedy_matches": [
				"1f944"
			],
			"decimal": ""
		},
		"keywords": [
			"spoon",
			"tableware"
		]
	},
	"1f374": {
		"name": "fork and knife",
		"unicode_version": 6,
		"category": "food",
		"order": 1261,
		"display": 1,
		"shortname": ":fork_and_knife:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f374",
			"fully_qualified": "1f374",
			"non_fully_qualified": "1f374",
			"output": "1f374",
			"default_matches": [
				"1f374"
			],
			"greedy_matches": [
				"1f374"
			],
			"decimal": ""
		},
		"keywords": [
			"cooking",
			"fork",
			"knife"
		]
	},
	"1f37d": {
		"name": "fork and knife with plate",
		"unicode_version": 7,
		"category": "food",
		"order": 1262,
		"display": 1,
		"shortname": ":fork_knife_plate:",
		"shortname_alternates": [
			":fork_and_knife_with_plate:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f37d",
			"fully_qualified": "1f37d-fe0f",
			"non_fully_qualified": "1f37d",
			"output": "1f37d-fe0f",
			"default_matches": [
				"1f37d-fe0f",
				"1f37d"
			],
			"greedy_matches": [
				"1f37d-fe0f",
				"1f37d"
			],
			"decimal": ""
		},
		"keywords": [
			"cooking",
			"fork",
			"knife",
			"plate"
		]
	},
	"1f95f": {
		"name": "dumpling",
		"unicode_version": 10,
		"category": "food",
		"order": 1263,
		"display": 1,
		"shortname": ":dumpling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f95f",
			"fully_qualified": "1f95f",
			"non_fully_qualified": "1f95f",
			"output": "1f95f",
			"default_matches": [
				"1f95f"
			],
			"greedy_matches": [
				"1f95f"
			],
			"decimal": ""
		},
		"keywords": [
			"empanada",
			"gyōza",
			"jiaozi",
			"pierogi",
			"potsticker"
		]
	},
	"1f960": {
		"name": "fortune cookie",
		"unicode_version": 10,
		"category": "food",
		"order": 1264,
		"display": 1,
		"shortname": ":fortune_cookie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f960",
			"fully_qualified": "1f960",
			"non_fully_qualified": "1f960",
			"output": "1f960",
			"default_matches": [
				"1f960"
			],
			"greedy_matches": [
				"1f960"
			],
			"decimal": ""
		},
		"keywords": [
			"prophecy"
		]
	},
	"1f961": {
		"name": "takeout box",
		"unicode_version": 10,
		"category": "food",
		"order": 1265,
		"display": 1,
		"shortname": ":takeout_box:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f961",
			"fully_qualified": "1f961",
			"non_fully_qualified": "1f961",
			"output": "1f961",
			"default_matches": [
				"1f961"
			],
			"greedy_matches": [
				"1f961"
			],
			"decimal": ""
		},
		"keywords": [
			"oyster pail"
		]
	},
	"1f962": {
		"name": "chopsticks",
		"unicode_version": 10,
		"category": "food",
		"order": 1266,
		"display": 1,
		"shortname": ":chopsticks:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f962",
			"fully_qualified": "1f962",
			"non_fully_qualified": "1f962",
			"output": "1f962",
			"default_matches": [
				"1f962"
			],
			"greedy_matches": [
				"1f962"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f963": {
		"name": "bowl with spoon",
		"unicode_version": 10,
		"category": "food",
		"order": 1267,
		"display": 1,
		"shortname": ":bowl_with_spoon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f963",
			"fully_qualified": "1f963",
			"non_fully_qualified": "1f963",
			"output": "1f963",
			"default_matches": [
				"1f963"
			],
			"greedy_matches": [
				"1f963"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f964": {
		"name": "cup with straw",
		"unicode_version": 10,
		"category": "food",
		"order": 1268,
		"display": 1,
		"shortname": ":cup_with_straw:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f964",
			"fully_qualified": "1f964",
			"non_fully_qualified": "1f964",
			"output": "1f964",
			"default_matches": [
				"1f964"
			],
			"greedy_matches": [
				"1f964"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f965": {
		"name": "coconut",
		"unicode_version": 10,
		"category": "food",
		"order": 1269,
		"display": 1,
		"shortname": ":coconut:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f965",
			"fully_qualified": "1f965",
			"non_fully_qualified": "1f965",
			"output": "1f965",
			"default_matches": [
				"1f965"
			],
			"greedy_matches": [
				"1f965"
			],
			"decimal": ""
		},
		"keywords": [
			"palm",
			"piña colada"
		]
	},
	"1f966": {
		"name": "broccoli",
		"unicode_version": 10,
		"category": "food",
		"order": 1270,
		"display": 1,
		"shortname": ":broccoli:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f966",
			"fully_qualified": "1f966",
			"non_fully_qualified": "1f966",
			"output": "1f966",
			"default_matches": [
				"1f966"
			],
			"greedy_matches": [
				"1f966"
			],
			"decimal": ""
		},
		"keywords": [
			"wild cabbage"
		]
	},
	"1f967": {
		"name": "pie",
		"unicode_version": 10,
		"category": "food",
		"order": 1271,
		"display": 1,
		"shortname": ":pie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f967",
			"fully_qualified": "1f967",
			"non_fully_qualified": "1f967",
			"output": "1f967",
			"default_matches": [
				"1f967"
			],
			"greedy_matches": [
				"1f967"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f968": {
		"name": "pretzel",
		"unicode_version": 10,
		"category": "food",
		"order": 1272,
		"display": 1,
		"shortname": ":pretzel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f968",
			"fully_qualified": "1f968",
			"non_fully_qualified": "1f968",
			"output": "1f968",
			"default_matches": [
				"1f968"
			],
			"greedy_matches": [
				"1f968"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f969": {
		"name": "cut of meat",
		"unicode_version": 10,
		"category": "food",
		"order": 1273,
		"display": 1,
		"shortname": ":cut_of_meat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f969",
			"fully_qualified": "1f969",
			"non_fully_qualified": "1f969",
			"output": "1f969",
			"default_matches": [
				"1f969"
			],
			"greedy_matches": [
				"1f969"
			],
			"decimal": ""
		},
		"keywords": [
			"chop",
			"lambchop",
			"porkchop",
			"steak"
		]
	},
	"1f96a": {
		"name": "sandwich",
		"unicode_version": 10,
		"category": "food",
		"order": 1274,
		"display": 1,
		"shortname": ":sandwich:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f96a",
			"fully_qualified": "1f96a",
			"non_fully_qualified": "1f96a",
			"output": "1f96a",
			"default_matches": [
				"1f96a"
			],
			"greedy_matches": [
				"1f96a"
			],
			"decimal": ""
		},
		"keywords": [
			"bread"
		]
	},
	"1f96b": {
		"name": "canned food",
		"unicode_version": 10,
		"category": "food",
		"order": 1275,
		"display": 1,
		"shortname": ":canned_food:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f96b",
			"fully_qualified": "1f96b",
			"non_fully_qualified": "1f96b",
			"output": "1f96b",
			"default_matches": [
				"1f96b"
			],
			"greedy_matches": [
				"1f96b"
			],
			"decimal": ""
		},
		"keywords": [
			"can"
		]
	},
	"26bd": {
		"name": "soccer ball",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1276,
		"display": 1,
		"shortname": ":soccer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26bd",
			"fully_qualified": "26bd",
			"non_fully_qualified": "26bd",
			"output": "26bd",
			"default_matches": [
				"26bd"
			],
			"greedy_matches": [
				"26bd"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"football",
			"soccer"
		]
	},
	"1f3c0": {
		"name": "basketball",
		"unicode_version": 6,
		"category": "activity",
		"order": 1277,
		"display": 1,
		"shortname": ":basketball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c0",
			"fully_qualified": "1f3c0",
			"non_fully_qualified": "1f3c0",
			"output": "1f3c0",
			"default_matches": [
				"1f3c0"
			],
			"greedy_matches": [
				"1f3c0"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"hoop"
		]
	},
	"1f3c8": {
		"name": "american football",
		"unicode_version": 6,
		"category": "activity",
		"order": 1278,
		"display": 1,
		"shortname": ":football:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c8",
			"fully_qualified": "1f3c8",
			"non_fully_qualified": "1f3c8",
			"output": "1f3c8",
			"default_matches": [
				"1f3c8"
			],
			"greedy_matches": [
				"1f3c8"
			],
			"decimal": ""
		},
		"keywords": [
			"american",
			"ball",
			"football"
		]
	},
	"26be": {
		"name": "baseball",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1279,
		"display": 1,
		"shortname": ":baseball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26be",
			"fully_qualified": "26be",
			"non_fully_qualified": "26be",
			"output": "26be",
			"default_matches": [
				"26be"
			],
			"greedy_matches": [
				"26be"
			],
			"decimal": ""
		},
		"keywords": [
			"ball"
		]
	},
	"1f3be": {
		"name": "tennis",
		"unicode_version": 6,
		"category": "activity",
		"order": 1280,
		"display": 1,
		"shortname": ":tennis:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3be",
			"fully_qualified": "1f3be",
			"non_fully_qualified": "1f3be",
			"output": "1f3be",
			"default_matches": [
				"1f3be"
			],
			"greedy_matches": [
				"1f3be"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"racquet"
		]
	},
	"1f3d0": {
		"name": "volleyball",
		"unicode_version": 8,
		"category": "activity",
		"order": 1281,
		"display": 1,
		"shortname": ":volleyball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d0",
			"fully_qualified": "1f3d0",
			"non_fully_qualified": "1f3d0",
			"output": "1f3d0",
			"default_matches": [
				"1f3d0"
			],
			"greedy_matches": [
				"1f3d0"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"game"
		]
	},
	"1f3c9": {
		"name": "rugby football",
		"unicode_version": 6,
		"category": "activity",
		"order": 1282,
		"display": 1,
		"shortname": ":rugby_football:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c9",
			"fully_qualified": "1f3c9",
			"non_fully_qualified": "1f3c9",
			"output": "1f3c9",
			"default_matches": [
				"1f3c9"
			],
			"greedy_matches": [
				"1f3c9"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"football",
			"rugby"
		]
	},
	"1f3b1": {
		"name": "pool 8 ball",
		"unicode_version": 6,
		"category": "activity",
		"order": 1283,
		"display": 1,
		"shortname": ":8ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b1",
			"fully_qualified": "1f3b1",
			"non_fully_qualified": "1f3b1",
			"output": "1f3b1",
			"default_matches": [
				"1f3b1"
			],
			"greedy_matches": [
				"1f3b1"
			],
			"decimal": ""
		},
		"keywords": [
			"8",
			"8 ball",
			"ball",
			"billiard",
			"eight",
			"game"
		]
	},
	"1f3d3": {
		"name": "ping pong",
		"unicode_version": 8,
		"category": "activity",
		"order": 1284,
		"display": 1,
		"shortname": ":ping_pong:",
		"shortname_alternates": [
			":table_tennis:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d3",
			"fully_qualified": "1f3d3",
			"non_fully_qualified": "1f3d3",
			"output": "1f3d3",
			"default_matches": [
				"1f3d3"
			],
			"greedy_matches": [
				"1f3d3"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"bat",
			"game",
			"paddle",
			"ping pong",
			"table tennis"
		]
	},
	"1f3f8": {
		"name": "badminton",
		"unicode_version": 8,
		"category": "activity",
		"order": 1285,
		"display": 1,
		"shortname": ":badminton:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f8",
			"fully_qualified": "1f3f8",
			"non_fully_qualified": "1f3f8",
			"output": "1f3f8",
			"default_matches": [
				"1f3f8"
			],
			"greedy_matches": [
				"1f3f8"
			],
			"decimal": ""
		},
		"keywords": [
			"birdie",
			"game",
			"racquet",
			"shuttlecock"
		]
	},
	"1f945": {
		"name": "goal net",
		"unicode_version": 9,
		"category": "activity",
		"order": 1286,
		"display": 1,
		"shortname": ":goal:",
		"shortname_alternates": [
			":goal_net:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f945",
			"fully_qualified": "1f945",
			"non_fully_qualified": "1f945",
			"output": "1f945",
			"default_matches": [
				"1f945"
			],
			"greedy_matches": [
				"1f945"
			],
			"decimal": ""
		},
		"keywords": [
			"goal",
			"net"
		]
	},
	"1f3d2": {
		"name": "ice hockey",
		"unicode_version": 8,
		"category": "activity",
		"order": 1287,
		"display": 1,
		"shortname": ":hockey:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d2",
			"fully_qualified": "1f3d2",
			"non_fully_qualified": "1f3d2",
			"output": "1f3d2",
			"default_matches": [
				"1f3d2"
			],
			"greedy_matches": [
				"1f3d2"
			],
			"decimal": ""
		},
		"keywords": [
			"game",
			"hockey",
			"ice",
			"puck",
			"stick"
		]
	},
	"1f3d1": {
		"name": "field hockey",
		"unicode_version": 8,
		"category": "activity",
		"order": 1288,
		"display": 1,
		"shortname": ":field_hockey:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d1",
			"fully_qualified": "1f3d1",
			"non_fully_qualified": "1f3d1",
			"output": "1f3d1",
			"default_matches": [
				"1f3d1"
			],
			"greedy_matches": [
				"1f3d1"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"field",
			"game",
			"hockey",
			"stick"
		]
	},
	"1f3cf": {
		"name": "cricket game",
		"unicode_version": 8,
		"category": "activity",
		"order": 1289,
		"display": 1,
		"shortname": ":cricket_game:",
		"shortname_alternates": [
			":cricket_bat_ball:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3cf",
			"fully_qualified": "1f3cf",
			"non_fully_qualified": "1f3cf",
			"output": "1f3cf",
			"default_matches": [
				"1f3cf"
			],
			"greedy_matches": [
				"1f3cf"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"bat",
			"game"
		]
	},
	"26f3": {
		"name": "flag in hole",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1290,
		"display": 1,
		"shortname": ":golf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f3",
			"fully_qualified": "26f3",
			"non_fully_qualified": "26f3",
			"output": "26f3",
			"default_matches": [
				"26f3"
			],
			"greedy_matches": [
				"26f3"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"hole"
		]
	},
	"1f3f9": {
		"name": "bow and arrow",
		"unicode_version": 8,
		"category": "activity",
		"order": 1291,
		"display": 1,
		"shortname": ":bow_and_arrow:",
		"shortname_alternates": [
			":archery:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f9",
			"fully_qualified": "1f3f9",
			"non_fully_qualified": "1f3f9",
			"output": "1f3f9",
			"default_matches": [
				"1f3f9"
			],
			"greedy_matches": [
				"1f3f9"
			],
			"decimal": ""
		},
		"keywords": [
			"Sagittarius",
			"archer",
			"archery",
			"arrow",
			"bow",
			"tool",
			"weapon",
			"zodiac"
		]
	},
	"1f3a3": {
		"name": "fishing pole",
		"unicode_version": 6,
		"category": "activity",
		"order": 1292,
		"display": 1,
		"shortname": ":fishing_pole_and_fish:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a3",
			"fully_qualified": "1f3a3",
			"non_fully_qualified": "1f3a3",
			"output": "1f3a3",
			"default_matches": [
				"1f3a3"
			],
			"greedy_matches": [
				"1f3a3"
			],
			"decimal": ""
		},
		"keywords": [
			"fish",
			"pole"
		]
	},
	"1f94a": {
		"name": "boxing glove",
		"unicode_version": 9,
		"category": "activity",
		"order": 1293,
		"display": 1,
		"shortname": ":boxing_glove:",
		"shortname_alternates": [
			":boxing_gloves:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f94a",
			"fully_qualified": "1f94a",
			"non_fully_qualified": "1f94a",
			"output": "1f94a",
			"default_matches": [
				"1f94a"
			],
			"greedy_matches": [
				"1f94a"
			],
			"decimal": ""
		},
		"keywords": [
			"boxing",
			"glove"
		]
	},
	"1f94b": {
		"name": "martial arts uniform",
		"unicode_version": 9,
		"category": "activity",
		"order": 1294,
		"display": 1,
		"shortname": ":martial_arts_uniform:",
		"shortname_alternates": [
			":karate_uniform:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f94b",
			"fully_qualified": "1f94b",
			"non_fully_qualified": "1f94b",
			"output": "1f94b",
			"default_matches": [
				"1f94b"
			],
			"greedy_matches": [
				"1f94b"
			],
			"decimal": ""
		},
		"keywords": [
			"judo",
			"karate",
			"martial arts",
			"taekwondo",
			"uniform"
		]
	},
	"26f8": {
		"name": "ice skate",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1295,
		"display": 1,
		"shortname": ":ice_skate:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f8",
			"fully_qualified": "26f8-fe0f",
			"non_fully_qualified": "26f8",
			"output": "26f8-fe0f",
			"default_matches": [
				"26f8-fe0f",
				"26f8"
			],
			"greedy_matches": [
				"26f8-fe0f",
				"26f8"
			],
			"decimal": ""
		},
		"keywords": [
			"ice",
			"skate"
		]
	},
	"1f3bf": {
		"name": "skis",
		"unicode_version": 6,
		"category": "activity",
		"order": 1296,
		"display": 1,
		"shortname": ":ski:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3bf",
			"fully_qualified": "1f3bf",
			"non_fully_qualified": "1f3bf",
			"output": "1f3bf",
			"default_matches": [
				"1f3bf"
			],
			"greedy_matches": [
				"1f3bf"
			],
			"decimal": ""
		},
		"keywords": [
			"ski",
			"snow"
		]
	},
	"26f7": {
		"name": "skier",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1297,
		"display": 1,
		"shortname": ":skier:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f7",
			"fully_qualified": "26f7-fe0f",
			"non_fully_qualified": "26f7",
			"output": "26f7-fe0f",
			"default_matches": [
				"26f7-fe0f",
				"26f7"
			],
			"greedy_matches": [
				"26f7-fe0f",
				"26f7"
			],
			"decimal": ""
		},
		"keywords": [
			"ski",
			"snow"
		]
	},
	"1f3c2": {
		"name": "snowboarder",
		"unicode_version": 6,
		"category": "activity",
		"order": 1298,
		"display": 1,
		"shortname": ":snowboarder:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c2-1f3fb",
			"1f3c2-1f3fc",
			"1f3c2-1f3fd",
			"1f3c2-1f3fe",
			"1f3c2-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2",
			"fully_qualified": "1f3c2",
			"non_fully_qualified": "1f3c2",
			"output": "1f3c2",
			"default_matches": [
				"1f3c2"
			],
			"greedy_matches": [
				"1f3c2"
			],
			"decimal": ""
		},
		"keywords": [
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3c2-1f3fb": {
		"name": "snowboarder: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1299,
		"display": 1,
		"shortname": ":snowboarder_tone1:",
		"shortname_alternates": [
			":snowboarder_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2-1f3fb",
			"fully_qualified": "1f3c2-1f3fb",
			"non_fully_qualified": "1f3c2-1f3fb",
			"output": "1f3c2-1f3fb",
			"default_matches": [
				"1f3c2-1f3fb"
			],
			"greedy_matches": [
				"1f3c2-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3c2-1f3fc": {
		"name": "snowboarder: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1300,
		"display": 1,
		"shortname": ":snowboarder_tone2:",
		"shortname_alternates": [
			":snowboarder_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2-1f3fc",
			"fully_qualified": "1f3c2-1f3fc",
			"non_fully_qualified": "1f3c2-1f3fc",
			"output": "1f3c2-1f3fc",
			"default_matches": [
				"1f3c2-1f3fc"
			],
			"greedy_matches": [
				"1f3c2-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3c2-1f3fd": {
		"name": "snowboarder: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1301,
		"display": 1,
		"shortname": ":snowboarder_tone3:",
		"shortname_alternates": [
			":snowboarder_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2-1f3fd",
			"fully_qualified": "1f3c2-1f3fd",
			"non_fully_qualified": "1f3c2-1f3fd",
			"output": "1f3c2-1f3fd",
			"default_matches": [
				"1f3c2-1f3fd"
			],
			"greedy_matches": [
				"1f3c2-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3c2-1f3fe": {
		"name": "snowboarder: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1302,
		"display": 1,
		"shortname": ":snowboarder_tone4:",
		"shortname_alternates": [
			":snowboarder_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2-1f3fe",
			"fully_qualified": "1f3c2-1f3fe",
			"non_fully_qualified": "1f3c2-1f3fe",
			"output": "1f3c2-1f3fe",
			"default_matches": [
				"1f3c2-1f3fe"
			],
			"greedy_matches": [
				"1f3c2-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3c2-1f3ff": {
		"name": "snowboarder: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1303,
		"display": 1,
		"shortname": ":snowboarder_tone5:",
		"shortname_alternates": [
			":snowboarder_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c2-1f3ff",
			"fully_qualified": "1f3c2-1f3ff",
			"non_fully_qualified": "1f3c2-1f3ff",
			"output": "1f3c2-1f3ff",
			"default_matches": [
				"1f3c2-1f3ff"
			],
			"greedy_matches": [
				"1f3c2-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"ski",
			"snow",
			"snowboard"
		]
	},
	"1f3cb-2640": {
		"name": "woman lifting weights",
		"unicode_version": 7,
		"category": "activity",
		"order": 1304,
		"display": 1,
		"shortname": ":woman_lifting_weights:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cb-1f3fb-2640",
			"1f3cb-1f3fc-2640",
			"1f3cb-1f3fd-2640",
			"1f3cb-1f3fe-2640",
			"1f3cb-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-2640",
			"fully_qualified": "1f3cb-fe0f-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-200d-2640",
			"output": "1f3cb-fe0f-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-fe0f-200d-2640-fe0f",
				"1f3cb-200d-2640",
				"1f3cb-fe0f-2640-fe0f",
				"1f3cb-200d-2640-fe0f",
				"1f3cb-fe0f-200d-2640"
			],
			"greedy_matches": [
				"1f3cb-fe0f-200d-2640-fe0f",
				"1f3cb-200d-2640",
				"1f3cb-fe0f-2640-fe0f",
				"1f3cb-200d-2640-fe0f",
				"1f3cb-fe0f-200d-2640"
			],
			"decimal": ""
		},
		"keywords": [
			"weight lifter",
			"woman"
		]
	},
	"1f3cb-1f3fb-2640": {
		"name": "woman lifting weights: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1305,
		"display": 1,
		"shortname": ":woman_lifting_weights_tone1:",
		"shortname_alternates": [
			":woman_lifting_weights_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fb-2640",
			"fully_qualified": "1f3cb-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-1f3fb-200d-2640",
			"output": "1f3cb-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-1f3fb-200d-2640-fe0f",
				"1f3cb-1f3fb-200d-2640",
				"1f3cb-fe0f-1f3fb-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fb-200d-2640-fe0f",
				"1f3cb-1f3fb-200d-2640",
				"1f3cb-fe0f-1f3fb-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"weight lifter",
			"woman"
		]
	},
	"1f3cb-1f3fc-2640": {
		"name": "woman lifting weights: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1306,
		"display": 1,
		"shortname": ":woman_lifting_weights_tone2:",
		"shortname_alternates": [
			":woman_lifting_weights_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fc-2640",
			"fully_qualified": "1f3cb-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-1f3fc-200d-2640",
			"output": "1f3cb-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-1f3fc-200d-2640-fe0f",
				"1f3cb-1f3fc-200d-2640",
				"1f3cb-fe0f-1f3fc-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fc-200d-2640-fe0f",
				"1f3cb-1f3fc-200d-2640",
				"1f3cb-fe0f-1f3fc-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"weight lifter",
			"woman"
		]
	},
	"1f3cb-1f3fd-2640": {
		"name": "woman lifting weights: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1307,
		"display": 1,
		"shortname": ":woman_lifting_weights_tone3:",
		"shortname_alternates": [
			":woman_lifting_weights_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fd-2640",
			"fully_qualified": "1f3cb-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-1f3fd-200d-2640",
			"output": "1f3cb-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-1f3fd-200d-2640-fe0f",
				"1f3cb-1f3fd-200d-2640",
				"1f3cb-fe0f-1f3fd-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fd-200d-2640-fe0f",
				"1f3cb-1f3fd-200d-2640",
				"1f3cb-fe0f-1f3fd-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"weight lifter",
			"woman"
		]
	},
	"1f3cb-1f3fe-2640": {
		"name": "woman lifting weights: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1308,
		"display": 1,
		"shortname": ":woman_lifting_weights_tone4:",
		"shortname_alternates": [
			":woman_lifting_weights_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fe-2640",
			"fully_qualified": "1f3cb-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-1f3fe-200d-2640",
			"output": "1f3cb-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-1f3fe-200d-2640-fe0f",
				"1f3cb-1f3fe-200d-2640",
				"1f3cb-fe0f-1f3fe-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fe-200d-2640-fe0f",
				"1f3cb-1f3fe-200d-2640",
				"1f3cb-fe0f-1f3fe-200d-2640-fe0f",
				"1f3cb-fe0f-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"weight lifter",
			"woman"
		]
	},
	"1f3cb-1f3ff-2640": {
		"name": "woman lifting weights: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1309,
		"display": 1,
		"shortname": ":woman_lifting_weights_tone5:",
		"shortname_alternates": [
			":woman_lifting_weights_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3ff-2640",
			"fully_qualified": "1f3cb-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f3cb-1f3ff-200d-2640",
			"output": "1f3cb-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f3cb-1f3ff-200d-2640-fe0f",
				"1f3cb-1f3ff-200d-2640",
				"1f3cb-fe0f-1f3ff-200d-2640-fe0f",
				"1f3cb-fe0f-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3ff-200d-2640-fe0f",
				"1f3cb-1f3ff-200d-2640",
				"1f3cb-fe0f-1f3ff-200d-2640-fe0f",
				"1f3cb-fe0f-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"weight lifter",
			"woman"
		]
	},
	"1f3cb": {
		"name": "person lifting weights",
		"unicode_version": 7,
		"category": "activity",
		"order": 1310,
		"display": 1,
		"shortname": ":person_lifting_weights:",
		"shortname_alternates": [
			":lifter:",
			":weight_lifter:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cb-1f3fb",
			"1f3cb-1f3fc",
			"1f3cb-1f3fd",
			"1f3cb-1f3fe",
			"1f3cb-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f3cb-2642",
			"1f3cb-2640"
		],
		"code_points": {
			"base": "1f3cb",
			"fully_qualified": "1f3cb-fe0f",
			"non_fully_qualified": "1f3cb",
			"output": "1f3cb-fe0f",
			"default_matches": [
				"1f3cb-fe0f",
				"1f3cb"
			],
			"greedy_matches": [
				"1f3cb-fe0f",
				"1f3cb"
			],
			"decimal": ""
		},
		"keywords": [
			"lifter",
			"weight"
		]
	},
	"1f3cb-1f3fb": {
		"name": "person lifting weights: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1311,
		"display": 1,
		"shortname": ":person_lifting_weights_tone1:",
		"shortname_alternates": [
			":lifter_tone1:",
			":weight_lifter_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cb-1f3fb-2642",
			"1f3cb-1f3fb-2640"
		],
		"code_points": {
			"base": "1f3cb-1f3fb",
			"fully_qualified": "1f3cb-1f3fb",
			"non_fully_qualified": "1f3cb-1f3fb",
			"output": "1f3cb-1f3fb",
			"default_matches": [
				"1f3cb-1f3fb",
				"1f3cb-fe0f-1f3fb"
			],
			"greedy_matches": [
				"1f3cb-1f3fb",
				"1f3cb-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"lifter",
			"light skin tone",
			"weight"
		]
	},
	"1f3cb-1f3fc": {
		"name": "person lifting weights: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1312,
		"display": 1,
		"shortname": ":person_lifting_weights_tone2:",
		"shortname_alternates": [
			":lifter_tone2:",
			":weight_lifter_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cb-1f3fc-2642",
			"1f3cb-1f3fc-2640"
		],
		"code_points": {
			"base": "1f3cb-1f3fc",
			"fully_qualified": "1f3cb-1f3fc",
			"non_fully_qualified": "1f3cb-1f3fc",
			"output": "1f3cb-1f3fc",
			"default_matches": [
				"1f3cb-1f3fc",
				"1f3cb-fe0f-1f3fc"
			],
			"greedy_matches": [
				"1f3cb-1f3fc",
				"1f3cb-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"lifter",
			"medium-light skin tone",
			"weight"
		]
	},
	"1f3cb-1f3fd": {
		"name": "person lifting weights: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1313,
		"display": 1,
		"shortname": ":person_lifting_weights_tone3:",
		"shortname_alternates": [
			":lifter_tone3:",
			":weight_lifter_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cb-1f3fd-2642",
			"1f3cb-1f3fd-2640"
		],
		"code_points": {
			"base": "1f3cb-1f3fd",
			"fully_qualified": "1f3cb-1f3fd",
			"non_fully_qualified": "1f3cb-1f3fd",
			"output": "1f3cb-1f3fd",
			"default_matches": [
				"1f3cb-1f3fd",
				"1f3cb-fe0f-1f3fd"
			],
			"greedy_matches": [
				"1f3cb-1f3fd",
				"1f3cb-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"lifter",
			"medium skin tone",
			"weight"
		]
	},
	"1f3cb-1f3fe": {
		"name": "person lifting weights: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1314,
		"display": 1,
		"shortname": ":person_lifting_weights_tone4:",
		"shortname_alternates": [
			":lifter_tone4:",
			":weight_lifter_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cb-1f3fe-2642",
			"1f3cb-1f3fe-2640"
		],
		"code_points": {
			"base": "1f3cb-1f3fe",
			"fully_qualified": "1f3cb-1f3fe",
			"non_fully_qualified": "1f3cb-1f3fe",
			"output": "1f3cb-1f3fe",
			"default_matches": [
				"1f3cb-1f3fe",
				"1f3cb-fe0f-1f3fe"
			],
			"greedy_matches": [
				"1f3cb-1f3fe",
				"1f3cb-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"lifter",
			"medium-dark skin tone",
			"weight"
		]
	},
	"1f3cb-1f3ff": {
		"name": "person lifting weights: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1315,
		"display": 1,
		"shortname": ":person_lifting_weights_tone5:",
		"shortname_alternates": [
			":lifter_tone5:",
			":weight_lifter_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cb-1f3ff-2642",
			"1f3cb-1f3ff-2640"
		],
		"code_points": {
			"base": "1f3cb-1f3ff",
			"fully_qualified": "1f3cb-1f3ff",
			"non_fully_qualified": "1f3cb-1f3ff",
			"output": "1f3cb-1f3ff",
			"default_matches": [
				"1f3cb-1f3ff",
				"1f3cb-fe0f-1f3ff"
			],
			"greedy_matches": [
				"1f3cb-1f3ff",
				"1f3cb-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"lifter",
			"weight"
		]
	},
	"1f3cb-2642": {
		"name": "man lifting weights",
		"unicode_version": 7,
		"category": "activity",
		"order": 1316,
		"display": 0,
		"shortname": ":man_lifting_weights:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cb-1f3fb-2642",
			"1f3cb-1f3fc-2642",
			"1f3cb-1f3fd-2642",
			"1f3cb-1f3fe-2642",
			"1f3cb-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-2642",
			"fully_qualified": "1f3cb-fe0f-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-200d-2642",
			"output": "1f3cb-fe0f-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-fe0f-200d-2642-fe0f",
				"1f3cb-200d-2642",
				"1f3cb-fe0f-2642-fe0f",
				"1f3cb-200d-2642-fe0f",
				"1f3cb-fe0f-200d-2642"
			],
			"greedy_matches": [
				"1f3cb-fe0f-200d-2642-fe0f",
				"1f3cb-200d-2642",
				"1f3cb-fe0f-2642-fe0f",
				"1f3cb-200d-2642-fe0f",
				"1f3cb-fe0f-200d-2642"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"weight lifter"
		]
	},
	"1f3cb-1f3ff-2642": {
		"name": "man lifting weights: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1317,
		"display": 0,
		"shortname": ":man_lifting_weights_tone5:",
		"shortname_alternates": [
			":man_lifting_weights_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3ff-2642",
			"fully_qualified": "1f3cb-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-1f3ff-200d-2642",
			"output": "1f3cb-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-1f3ff-200d-2642-fe0f",
				"1f3cb-1f3ff-200d-2642",
				"1f3cb-fe0f-1f3ff-200d-2642-fe0f",
				"1f3cb-fe0f-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3ff-200d-2642-fe0f",
				"1f3cb-1f3ff-200d-2642",
				"1f3cb-fe0f-1f3ff-200d-2642-fe0f",
				"1f3cb-fe0f-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"weight lifter"
		]
	},
	"1f3cb-1f3fe-2642": {
		"name": "man lifting weights: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1318,
		"display": 0,
		"shortname": ":man_lifting_weights_tone4:",
		"shortname_alternates": [
			":man_lifting_weights_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fe-2642",
			"fully_qualified": "1f3cb-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-1f3fe-200d-2642",
			"output": "1f3cb-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-1f3fe-200d-2642-fe0f",
				"1f3cb-1f3fe-200d-2642",
				"1f3cb-fe0f-1f3fe-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fe-200d-2642-fe0f",
				"1f3cb-1f3fe-200d-2642",
				"1f3cb-fe0f-1f3fe-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"weight lifter"
		]
	},
	"1f3cb-1f3fd-2642": {
		"name": "man lifting weights: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1319,
		"display": 0,
		"shortname": ":man_lifting_weights_tone3:",
		"shortname_alternates": [
			":man_lifting_weights_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fd-2642",
			"fully_qualified": "1f3cb-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-1f3fd-200d-2642",
			"output": "1f3cb-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-1f3fd-200d-2642-fe0f",
				"1f3cb-1f3fd-200d-2642",
				"1f3cb-fe0f-1f3fd-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fd-200d-2642-fe0f",
				"1f3cb-1f3fd-200d-2642",
				"1f3cb-fe0f-1f3fd-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"weight lifter"
		]
	},
	"1f3cb-1f3fc-2642": {
		"name": "man lifting weights: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1320,
		"display": 0,
		"shortname": ":man_lifting_weights_tone2:",
		"shortname_alternates": [
			":man_lifting_weights_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fc-2642",
			"fully_qualified": "1f3cb-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-1f3fc-200d-2642",
			"output": "1f3cb-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-1f3fc-200d-2642-fe0f",
				"1f3cb-1f3fc-200d-2642",
				"1f3cb-fe0f-1f3fc-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fc-200d-2642-fe0f",
				"1f3cb-1f3fc-200d-2642",
				"1f3cb-fe0f-1f3fc-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"weight lifter"
		]
	},
	"1f3cb-1f3fb-2642": {
		"name": "man lifting weights: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1321,
		"display": 0,
		"shortname": ":man_lifting_weights_tone1:",
		"shortname_alternates": [
			":man_lifting_weights_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cb-1f3fb-2642",
			"fully_qualified": "1f3cb-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f3cb-1f3fb-200d-2642",
			"output": "1f3cb-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f3cb-1f3fb-200d-2642-fe0f",
				"1f3cb-1f3fb-200d-2642",
				"1f3cb-fe0f-1f3fb-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cb-1f3fb-200d-2642-fe0f",
				"1f3cb-1f3fb-200d-2642",
				"1f3cb-fe0f-1f3fb-200d-2642-fe0f",
				"1f3cb-fe0f-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"weight lifter"
		]
	},
	"1f93a": {
		"name": "person fencing",
		"unicode_version": 9,
		"category": "activity",
		"order": 1322,
		"display": 1,
		"shortname": ":person_fencing:",
		"shortname_alternates": [
			":fencer:",
			":fencing:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f93a",
			"fully_qualified": "1f93a",
			"non_fully_qualified": "1f93a",
			"output": "1f93a",
			"default_matches": [
				"1f93a"
			],
			"greedy_matches": [
				"1f93a"
			],
			"decimal": ""
		},
		"keywords": [
			"fencer",
			"fencing",
			"sword"
		]
	},
	"1f93c-2640": {
		"name": "women wrestling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1323,
		"display": 1,
		"shortname": ":women_wrestling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93c-2640",
			"fully_qualified": "1f93c-200d-2640-fe0f",
			"non_fully_qualified": "1f93c-200d-2640",
			"output": "1f93c-200d-2640-fe0f",
			"default_matches": [
				"1f93c-200d-2640-fe0f",
				"1f93c-200d-2640",
				"1f93c-2640-fe0f"
			],
			"greedy_matches": [
				"1f93c-200d-2640-fe0f",
				"1f93c-200d-2640",
				"1f93c-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"women",
			"wrestle"
		]
	},
	"1f93c-2642": {
		"name": "men wrestling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1324,
		"display": 1,
		"shortname": ":men_wrestling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93c-2642",
			"fully_qualified": "1f93c-200d-2642-fe0f",
			"non_fully_qualified": "1f93c-200d-2642",
			"output": "1f93c-200d-2642-fe0f",
			"default_matches": [
				"1f93c-200d-2642-fe0f",
				"1f93c-200d-2642",
				"1f93c-2642-fe0f"
			],
			"greedy_matches": [
				"1f93c-200d-2642-fe0f",
				"1f93c-200d-2642",
				"1f93c-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"men",
			"wrestle"
		]
	},
	"1f93c": {
		"name": "people wrestling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1325,
		"display": 0,
		"shortname": ":people_wrestling:",
		"shortname_alternates": [
			":wrestlers:",
			":wrestling:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93c-2642",
			"1f93c-2640"
		],
		"code_points": {
			"base": "1f93c",
			"fully_qualified": "1f93c",
			"non_fully_qualified": "1f93c",
			"output": "1f93c",
			"default_matches": [
				"1f93c"
			],
			"greedy_matches": [
				"1f93c"
			],
			"decimal": ""
		},
		"keywords": [
			"wrestle",
			"wrestler"
		]
	},
	"1f938-2640": {
		"name": "woman cartwheeling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1326,
		"display": 1,
		"shortname": ":woman_cartwheeling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f938-1f3fb-2640",
			"1f938-1f3fc-2640",
			"1f938-1f3fd-2640",
			"1f938-1f3fe-2640",
			"1f938-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-2640",
			"fully_qualified": "1f938-200d-2640-fe0f",
			"non_fully_qualified": "1f938-200d-2640",
			"output": "1f938-200d-2640-fe0f",
			"default_matches": [
				"1f938-200d-2640-fe0f",
				"1f938-200d-2640",
				"1f938-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-200d-2640-fe0f",
				"1f938-200d-2640",
				"1f938-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"woman"
		]
	},
	"1f938-1f3fb-2640": {
		"name": "woman cartwheeling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1327,
		"display": 1,
		"shortname": ":woman_cartwheeling_tone1:",
		"shortname_alternates": [
			":woman_cartwheeling_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fb-2640",
			"fully_qualified": "1f938-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f938-1f3fb-200d-2640",
			"output": "1f938-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f938-1f3fb-200d-2640-fe0f",
				"1f938-1f3fb-200d-2640",
				"1f938-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fb-200d-2640-fe0f",
				"1f938-1f3fb-200d-2640",
				"1f938-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"light skin tone",
			"woman"
		]
	},
	"1f938-1f3fc-2640": {
		"name": "woman cartwheeling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1328,
		"display": 1,
		"shortname": ":woman_cartwheeling_tone2:",
		"shortname_alternates": [
			":woman_cartwheeling_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fc-2640",
			"fully_qualified": "1f938-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f938-1f3fc-200d-2640",
			"output": "1f938-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f938-1f3fc-200d-2640-fe0f",
				"1f938-1f3fc-200d-2640",
				"1f938-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fc-200d-2640-fe0f",
				"1f938-1f3fc-200d-2640",
				"1f938-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f938-1f3fd-2640": {
		"name": "woman cartwheeling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1329,
		"display": 1,
		"shortname": ":woman_cartwheeling_tone3:",
		"shortname_alternates": [
			":woman_cartwheeling_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fd-2640",
			"fully_qualified": "1f938-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f938-1f3fd-200d-2640",
			"output": "1f938-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f938-1f3fd-200d-2640-fe0f",
				"1f938-1f3fd-200d-2640",
				"1f938-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fd-200d-2640-fe0f",
				"1f938-1f3fd-200d-2640",
				"1f938-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium skin tone",
			"woman"
		]
	},
	"1f938-1f3fe-2640": {
		"name": "woman cartwheeling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1330,
		"display": 1,
		"shortname": ":woman_cartwheeling_tone4:",
		"shortname_alternates": [
			":woman_cartwheeling_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fe-2640",
			"fully_qualified": "1f938-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f938-1f3fe-200d-2640",
			"output": "1f938-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f938-1f3fe-200d-2640-fe0f",
				"1f938-1f3fe-200d-2640",
				"1f938-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fe-200d-2640-fe0f",
				"1f938-1f3fe-200d-2640",
				"1f938-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f938-1f3ff-2640": {
		"name": "woman cartwheeling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1331,
		"display": 1,
		"shortname": ":woman_cartwheeling_tone5:",
		"shortname_alternates": [
			":woman_cartwheeling_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3ff-2640",
			"fully_qualified": "1f938-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f938-1f3ff-200d-2640",
			"output": "1f938-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f938-1f3ff-200d-2640-fe0f",
				"1f938-1f3ff-200d-2640",
				"1f938-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3ff-200d-2640-fe0f",
				"1f938-1f3ff-200d-2640",
				"1f938-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"dark skin tone",
			"gymnastics",
			"woman"
		]
	},
	"1f938-2642": {
		"name": "man cartwheeling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1332,
		"display": 1,
		"shortname": ":man_cartwheeling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f938-1f3fb-2642",
			"1f938-1f3fc-2642",
			"1f938-1f3fd-2642",
			"1f938-1f3fe-2642",
			"1f938-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-2642",
			"fully_qualified": "1f938-200d-2642-fe0f",
			"non_fully_qualified": "1f938-200d-2642",
			"output": "1f938-200d-2642-fe0f",
			"default_matches": [
				"1f938-200d-2642-fe0f",
				"1f938-200d-2642",
				"1f938-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-200d-2642-fe0f",
				"1f938-200d-2642",
				"1f938-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"man"
		]
	},
	"1f938-1f3fb-2642": {
		"name": "man cartwheeling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1333,
		"display": 1,
		"shortname": ":man_cartwheeling_tone1:",
		"shortname_alternates": [
			":man_cartwheeling_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fb-2642",
			"fully_qualified": "1f938-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f938-1f3fb-200d-2642",
			"output": "1f938-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f938-1f3fb-200d-2642-fe0f",
				"1f938-1f3fb-200d-2642",
				"1f938-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fb-200d-2642-fe0f",
				"1f938-1f3fb-200d-2642",
				"1f938-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"light skin tone",
			"man"
		]
	},
	"1f938-1f3fc-2642": {
		"name": "man cartwheeling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1334,
		"display": 1,
		"shortname": ":man_cartwheeling_tone2:",
		"shortname_alternates": [
			":man_cartwheeling_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fc-2642",
			"fully_qualified": "1f938-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f938-1f3fc-200d-2642",
			"output": "1f938-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f938-1f3fc-200d-2642-fe0f",
				"1f938-1f3fc-200d-2642",
				"1f938-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fc-200d-2642-fe0f",
				"1f938-1f3fc-200d-2642",
				"1f938-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"man",
			"medium-light skin tone"
		]
	},
	"1f938-1f3fd-2642": {
		"name": "man cartwheeling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1335,
		"display": 1,
		"shortname": ":man_cartwheeling_tone3:",
		"shortname_alternates": [
			":man_cartwheeling_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fd-2642",
			"fully_qualified": "1f938-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f938-1f3fd-200d-2642",
			"output": "1f938-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f938-1f3fd-200d-2642-fe0f",
				"1f938-1f3fd-200d-2642",
				"1f938-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fd-200d-2642-fe0f",
				"1f938-1f3fd-200d-2642",
				"1f938-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"man",
			"medium skin tone"
		]
	},
	"1f938-1f3fe-2642": {
		"name": "man cartwheeling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1336,
		"display": 1,
		"shortname": ":man_cartwheeling_tone4:",
		"shortname_alternates": [
			":man_cartwheeling_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3fe-2642",
			"fully_qualified": "1f938-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f938-1f3fe-200d-2642",
			"output": "1f938-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f938-1f3fe-200d-2642-fe0f",
				"1f938-1f3fe-200d-2642",
				"1f938-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3fe-200d-2642-fe0f",
				"1f938-1f3fe-200d-2642",
				"1f938-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f938-1f3ff-2642": {
		"name": "man cartwheeling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1337,
		"display": 1,
		"shortname": ":man_cartwheeling_tone5:",
		"shortname_alternates": [
			":man_cartwheeling_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f938-1f3ff-2642",
			"fully_qualified": "1f938-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f938-1f3ff-200d-2642",
			"output": "1f938-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f938-1f3ff-200d-2642-fe0f",
				"1f938-1f3ff-200d-2642",
				"1f938-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f938-1f3ff-200d-2642-fe0f",
				"1f938-1f3ff-200d-2642",
				"1f938-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"dark skin tone",
			"gymnastics",
			"man"
		]
	},
	"1f938": {
		"name": "person cartwheeling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1338,
		"display": 0,
		"shortname": ":person_doing_cartwheel:",
		"shortname_alternates": [
			":cartwheel:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f938-1f3fb",
			"1f938-1f3fc",
			"1f938-1f3fd",
			"1f938-1f3fe",
			"1f938-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f938-2642",
			"1f938-2640"
		],
		"code_points": {
			"base": "1f938",
			"fully_qualified": "1f938",
			"non_fully_qualified": "1f938",
			"output": "1f938",
			"default_matches": [
				"1f938"
			],
			"greedy_matches": [
				"1f938"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics"
		]
	},
	"1f938-1f3fb": {
		"name": "person cartwheeling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1339,
		"display": 0,
		"shortname": ":person_doing_cartwheel_tone1:",
		"shortname_alternates": [
			":cartwheel_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f938-1f3fb-2642",
			"1f938-1f3fb-2640"
		],
		"code_points": {
			"base": "1f938-1f3fb",
			"fully_qualified": "1f938-1f3fb",
			"non_fully_qualified": "1f938-1f3fb",
			"output": "1f938-1f3fb",
			"default_matches": [
				"1f938-1f3fb"
			],
			"greedy_matches": [
				"1f938-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"light skin tone"
		]
	},
	"1f938-1f3fc": {
		"name": "person cartwheeling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1340,
		"display": 0,
		"shortname": ":person_doing_cartwheel_tone2:",
		"shortname_alternates": [
			":cartwheel_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f938-1f3fc-2642",
			"1f938-1f3fc-2640"
		],
		"code_points": {
			"base": "1f938-1f3fc",
			"fully_qualified": "1f938-1f3fc",
			"non_fully_qualified": "1f938-1f3fc",
			"output": "1f938-1f3fc",
			"default_matches": [
				"1f938-1f3fc"
			],
			"greedy_matches": [
				"1f938-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium-light skin tone"
		]
	},
	"1f938-1f3fd": {
		"name": "person cartwheeling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1341,
		"display": 0,
		"shortname": ":person_doing_cartwheel_tone3:",
		"shortname_alternates": [
			":cartwheel_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f938-1f3fd-2642",
			"1f938-1f3fd-2640"
		],
		"code_points": {
			"base": "1f938-1f3fd",
			"fully_qualified": "1f938-1f3fd",
			"non_fully_qualified": "1f938-1f3fd",
			"output": "1f938-1f3fd",
			"default_matches": [
				"1f938-1f3fd"
			],
			"greedy_matches": [
				"1f938-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium skin tone"
		]
	},
	"1f938-1f3fe": {
		"name": "person cartwheeling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1342,
		"display": 0,
		"shortname": ":person_doing_cartwheel_tone4:",
		"shortname_alternates": [
			":cartwheel_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f938-1f3fe-2642",
			"1f938-1f3fe-2640"
		],
		"code_points": {
			"base": "1f938-1f3fe",
			"fully_qualified": "1f938-1f3fe",
			"non_fully_qualified": "1f938-1f3fe",
			"output": "1f938-1f3fe",
			"default_matches": [
				"1f938-1f3fe"
			],
			"greedy_matches": [
				"1f938-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"gymnastics",
			"medium-dark skin tone"
		]
	},
	"1f938-1f3ff": {
		"name": "person cartwheeling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1343,
		"display": 0,
		"shortname": ":person_doing_cartwheel_tone5:",
		"shortname_alternates": [
			":cartwheel_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f938-1f3ff-2642",
			"1f938-1f3ff-2640"
		],
		"code_points": {
			"base": "1f938-1f3ff",
			"fully_qualified": "1f938-1f3ff",
			"non_fully_qualified": "1f938-1f3ff",
			"output": "1f938-1f3ff",
			"default_matches": [
				"1f938-1f3ff"
			],
			"greedy_matches": [
				"1f938-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"cartwheel",
			"dark skin tone",
			"gymnastics"
		]
	},
	"26f9-2640": {
		"name": "woman bouncing ball",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1344,
		"display": 1,
		"shortname": ":woman_bouncing_ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"26f9-1f3fb-2640",
			"26f9-1f3fc-2640",
			"26f9-1f3fd-2640",
			"26f9-1f3fe-2640",
			"26f9-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-2640",
			"fully_qualified": "26f9-fe0f-200d-2640-fe0f",
			"non_fully_qualified": "26f9-200d-2640",
			"output": "26f9-fe0f-200d-2640-fe0f",
			"default_matches": [
				"26f9-fe0f-200d-2640-fe0f",
				"26f9-200d-2640",
				"26f9-fe0f-2640-fe0f",
				"26f9-200d-2640-fe0f",
				"26f9-fe0f-200d-2640"
			],
			"greedy_matches": [
				"26f9-fe0f-200d-2640-fe0f",
				"26f9-200d-2640",
				"26f9-fe0f-2640-fe0f",
				"26f9-200d-2640-fe0f",
				"26f9-fe0f-200d-2640"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"woman"
		]
	},
	"26f9-1f3fb-2640": {
		"name": "woman bouncing ball: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1345,
		"display": 1,
		"shortname": ":woman_bouncing_ball_tone1:",
		"shortname_alternates": [
			":woman_bouncing_ball_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fb-2640",
			"fully_qualified": "26f9-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "26f9-1f3fb-200d-2640",
			"output": "26f9-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"26f9-1f3fb-200d-2640-fe0f",
				"26f9-1f3fb-200d-2640",
				"26f9-fe0f-1f3fb-200d-2640-fe0f",
				"26f9-fe0f-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fb-200d-2640-fe0f",
				"26f9-1f3fb-200d-2640",
				"26f9-fe0f-1f3fb-200d-2640-fe0f",
				"26f9-fe0f-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"light skin tone",
			"woman"
		]
	},
	"26f9-1f3fc-2640": {
		"name": "woman bouncing ball: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1346,
		"display": 1,
		"shortname": ":woman_bouncing_ball_tone2:",
		"shortname_alternates": [
			":woman_bouncing_ball_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fc-2640",
			"fully_qualified": "26f9-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "26f9-1f3fc-200d-2640",
			"output": "26f9-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"26f9-1f3fc-200d-2640-fe0f",
				"26f9-1f3fc-200d-2640",
				"26f9-fe0f-1f3fc-200d-2640-fe0f",
				"26f9-fe0f-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fc-200d-2640-fe0f",
				"26f9-1f3fc-200d-2640",
				"26f9-fe0f-1f3fc-200d-2640-fe0f",
				"26f9-fe0f-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium-light skin tone",
			"woman"
		]
	},
	"26f9-1f3fd-2640": {
		"name": "woman bouncing ball: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1347,
		"display": 1,
		"shortname": ":woman_bouncing_ball_tone3:",
		"shortname_alternates": [
			":woman_bouncing_ball_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fd-2640",
			"fully_qualified": "26f9-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "26f9-1f3fd-200d-2640",
			"output": "26f9-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"26f9-1f3fd-200d-2640-fe0f",
				"26f9-1f3fd-200d-2640",
				"26f9-fe0f-1f3fd-200d-2640-fe0f",
				"26f9-fe0f-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fd-200d-2640-fe0f",
				"26f9-1f3fd-200d-2640",
				"26f9-fe0f-1f3fd-200d-2640-fe0f",
				"26f9-fe0f-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium skin tone",
			"woman"
		]
	},
	"26f9-1f3fe-2640": {
		"name": "woman bouncing ball: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1348,
		"display": 1,
		"shortname": ":woman_bouncing_ball_tone4:",
		"shortname_alternates": [
			":woman_bouncing_ball_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fe-2640",
			"fully_qualified": "26f9-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "26f9-1f3fe-200d-2640",
			"output": "26f9-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"26f9-1f3fe-200d-2640-fe0f",
				"26f9-1f3fe-200d-2640",
				"26f9-fe0f-1f3fe-200d-2640-fe0f",
				"26f9-fe0f-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fe-200d-2640-fe0f",
				"26f9-1f3fe-200d-2640",
				"26f9-fe0f-1f3fe-200d-2640-fe0f",
				"26f9-fe0f-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium-dark skin tone",
			"woman"
		]
	},
	"26f9-1f3ff-2640": {
		"name": "woman bouncing ball: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1349,
		"display": 1,
		"shortname": ":woman_bouncing_ball_tone5:",
		"shortname_alternates": [
			":woman_bouncing_ball_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3ff-2640",
			"fully_qualified": "26f9-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "26f9-1f3ff-200d-2640",
			"output": "26f9-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"26f9-1f3ff-200d-2640-fe0f",
				"26f9-1f3ff-200d-2640",
				"26f9-fe0f-1f3ff-200d-2640-fe0f",
				"26f9-fe0f-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3ff-200d-2640-fe0f",
				"26f9-1f3ff-200d-2640",
				"26f9-fe0f-1f3ff-200d-2640-fe0f",
				"26f9-fe0f-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"dark skin tone",
			"woman"
		]
	},
	"26f9": {
		"name": "person bouncing ball",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1350,
		"display": 1,
		"shortname": ":person_bouncing_ball:",
		"shortname_alternates": [
			":basketball_player:",
			":person_with_ball:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"26f9-1f3fb",
			"26f9-1f3fc",
			"26f9-1f3fd",
			"26f9-1f3fe",
			"26f9-1f3ff"
		],
		"gender": null,
		"genders": [
			"26f9-2642",
			"26f9-2640"
		],
		"code_points": {
			"base": "26f9",
			"fully_qualified": "26f9-fe0f",
			"non_fully_qualified": "26f9",
			"output": "26f9-fe0f",
			"default_matches": [
				"26f9-fe0f",
				"26f9"
			],
			"greedy_matches": [
				"26f9-fe0f",
				"26f9"
			],
			"decimal": ""
		},
		"keywords": [
			"ball"
		]
	},
	"26f9-1f3fb": {
		"name": "person bouncing ball: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1351,
		"display": 1,
		"shortname": ":person_bouncing_ball_tone1:",
		"shortname_alternates": [
			":basketball_player_tone1:",
			":person_with_ball_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"26f9-1f3fb-2642",
			"26f9-1f3fb-2640"
		],
		"code_points": {
			"base": "26f9-1f3fb",
			"fully_qualified": "26f9-1f3fb",
			"non_fully_qualified": "26f9-1f3fb",
			"output": "26f9-1f3fb",
			"default_matches": [
				"26f9-1f3fb",
				"26f9-fe0f-1f3fb"
			],
			"greedy_matches": [
				"26f9-1f3fb",
				"26f9-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"light skin tone"
		]
	},
	"26f9-1f3fc": {
		"name": "person bouncing ball: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1352,
		"display": 1,
		"shortname": ":person_bouncing_ball_tone2:",
		"shortname_alternates": [
			":basketball_player_tone2:",
			":person_with_ball_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"26f9-1f3fc-2642",
			"26f9-1f3fc-2640"
		],
		"code_points": {
			"base": "26f9-1f3fc",
			"fully_qualified": "26f9-1f3fc",
			"non_fully_qualified": "26f9-1f3fc",
			"output": "26f9-1f3fc",
			"default_matches": [
				"26f9-1f3fc",
				"26f9-fe0f-1f3fc"
			],
			"greedy_matches": [
				"26f9-1f3fc",
				"26f9-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium-light skin tone"
		]
	},
	"26f9-1f3fd": {
		"name": "person bouncing ball: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1353,
		"display": 1,
		"shortname": ":person_bouncing_ball_tone3:",
		"shortname_alternates": [
			":basketball_player_tone3:",
			":person_with_ball_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"26f9-1f3fd-2642",
			"26f9-1f3fd-2640"
		],
		"code_points": {
			"base": "26f9-1f3fd",
			"fully_qualified": "26f9-1f3fd",
			"non_fully_qualified": "26f9-1f3fd",
			"output": "26f9-1f3fd",
			"default_matches": [
				"26f9-1f3fd",
				"26f9-fe0f-1f3fd"
			],
			"greedy_matches": [
				"26f9-1f3fd",
				"26f9-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium skin tone"
		]
	},
	"26f9-1f3fe": {
		"name": "person bouncing ball: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1354,
		"display": 1,
		"shortname": ":person_bouncing_ball_tone4:",
		"shortname_alternates": [
			":basketball_player_tone4:",
			":person_with_ball_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"26f9-1f3fe-2642",
			"26f9-1f3fe-2640"
		],
		"code_points": {
			"base": "26f9-1f3fe",
			"fully_qualified": "26f9-1f3fe",
			"non_fully_qualified": "26f9-1f3fe",
			"output": "26f9-1f3fe",
			"default_matches": [
				"26f9-1f3fe",
				"26f9-fe0f-1f3fe"
			],
			"greedy_matches": [
				"26f9-1f3fe",
				"26f9-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"medium-dark skin tone"
		]
	},
	"26f9-1f3ff": {
		"name": "person bouncing ball: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1355,
		"display": 1,
		"shortname": ":person_bouncing_ball_tone5:",
		"shortname_alternates": [
			":basketball_player_tone5:",
			":person_with_ball_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"26f9-1f3ff-2642",
			"26f9-1f3ff-2640"
		],
		"code_points": {
			"base": "26f9-1f3ff",
			"fully_qualified": "26f9-1f3ff",
			"non_fully_qualified": "26f9-1f3ff",
			"output": "26f9-1f3ff",
			"default_matches": [
				"26f9-1f3ff",
				"26f9-fe0f-1f3ff"
			],
			"greedy_matches": [
				"26f9-1f3ff",
				"26f9-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"dark skin tone"
		]
	},
	"26f9-2642": {
		"name": "man bouncing ball",
		"unicode_version": 5.2,
		"category": "activity",
		"order": 1356,
		"display": 0,
		"shortname": ":man_bouncing_ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"26f9-1f3fb-2642",
			"26f9-1f3fc-2642",
			"26f9-1f3fd-2642",
			"26f9-1f3fe-2642",
			"26f9-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-2642",
			"fully_qualified": "26f9-fe0f-200d-2642-fe0f",
			"non_fully_qualified": "26f9-200d-2642",
			"output": "26f9-fe0f-200d-2642-fe0f",
			"default_matches": [
				"26f9-fe0f-200d-2642-fe0f",
				"26f9-200d-2642",
				"26f9-fe0f-2642-fe0f",
				"26f9-200d-2642-fe0f",
				"26f9-fe0f-200d-2642"
			],
			"greedy_matches": [
				"26f9-fe0f-200d-2642-fe0f",
				"26f9-200d-2642",
				"26f9-fe0f-2642-fe0f",
				"26f9-200d-2642-fe0f",
				"26f9-fe0f-200d-2642"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"man"
		]
	},
	"26f9-1f3ff-2642": {
		"name": "man bouncing ball: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1357,
		"display": 0,
		"shortname": ":man_bouncing_ball_tone5:",
		"shortname_alternates": [
			":man_bouncing_ball_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3ff-2642",
			"fully_qualified": "26f9-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "26f9-1f3ff-200d-2642",
			"output": "26f9-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"26f9-1f3ff-200d-2642-fe0f",
				"26f9-1f3ff-200d-2642",
				"26f9-fe0f-1f3ff-200d-2642-fe0f",
				"26f9-fe0f-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3ff-200d-2642-fe0f",
				"26f9-1f3ff-200d-2642",
				"26f9-fe0f-1f3ff-200d-2642-fe0f",
				"26f9-fe0f-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"dark skin tone",
			"man"
		]
	},
	"26f9-1f3fe-2642": {
		"name": "man bouncing ball: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1358,
		"display": 0,
		"shortname": ":man_bouncing_ball_tone4:",
		"shortname_alternates": [
			":man_bouncing_ball_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fe-2642",
			"fully_qualified": "26f9-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "26f9-1f3fe-200d-2642",
			"output": "26f9-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"26f9-1f3fe-200d-2642-fe0f",
				"26f9-1f3fe-200d-2642",
				"26f9-fe0f-1f3fe-200d-2642-fe0f",
				"26f9-fe0f-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fe-200d-2642-fe0f",
				"26f9-1f3fe-200d-2642",
				"26f9-fe0f-1f3fe-200d-2642-fe0f",
				"26f9-fe0f-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"man",
			"medium-dark skin tone"
		]
	},
	"26f9-1f3fd-2642": {
		"name": "man bouncing ball: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1359,
		"display": 0,
		"shortname": ":man_bouncing_ball_tone3:",
		"shortname_alternates": [
			":man_bouncing_ball_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fd-2642",
			"fully_qualified": "26f9-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "26f9-1f3fd-200d-2642",
			"output": "26f9-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"26f9-1f3fd-200d-2642-fe0f",
				"26f9-1f3fd-200d-2642",
				"26f9-fe0f-1f3fd-200d-2642-fe0f",
				"26f9-fe0f-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fd-200d-2642-fe0f",
				"26f9-1f3fd-200d-2642",
				"26f9-fe0f-1f3fd-200d-2642-fe0f",
				"26f9-fe0f-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"man",
			"medium skin tone"
		]
	},
	"26f9-1f3fc-2642": {
		"name": "man bouncing ball: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1360,
		"display": 0,
		"shortname": ":man_bouncing_ball_tone2:",
		"shortname_alternates": [
			":man_bouncing_ball_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fc-2642",
			"fully_qualified": "26f9-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "26f9-1f3fc-200d-2642",
			"output": "26f9-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"26f9-1f3fc-200d-2642-fe0f",
				"26f9-1f3fc-200d-2642",
				"26f9-fe0f-1f3fc-200d-2642-fe0f",
				"26f9-fe0f-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fc-200d-2642-fe0f",
				"26f9-1f3fc-200d-2642",
				"26f9-fe0f-1f3fc-200d-2642-fe0f",
				"26f9-fe0f-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"man",
			"medium-light skin tone"
		]
	},
	"26f9-1f3fb-2642": {
		"name": "man bouncing ball: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1361,
		"display": 0,
		"shortname": ":man_bouncing_ball_tone1:",
		"shortname_alternates": [
			":man_bouncing_ball_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "26f9-1f3fb-2642",
			"fully_qualified": "26f9-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "26f9-1f3fb-200d-2642",
			"output": "26f9-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"26f9-1f3fb-200d-2642-fe0f",
				"26f9-1f3fb-200d-2642",
				"26f9-fe0f-1f3fb-200d-2642-fe0f",
				"26f9-fe0f-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"26f9-1f3fb-200d-2642-fe0f",
				"26f9-1f3fb-200d-2642",
				"26f9-fe0f-1f3fb-200d-2642-fe0f",
				"26f9-fe0f-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"light skin tone",
			"man"
		]
	},
	"1f93e-2640": {
		"name": "woman playing handball",
		"unicode_version": 9,
		"category": "activity",
		"order": 1362,
		"display": 1,
		"shortname": ":woman_playing_handball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93e-1f3fb-2640",
			"1f93e-1f3fc-2640",
			"1f93e-1f3fd-2640",
			"1f93e-1f3fe-2640",
			"1f93e-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-2640",
			"fully_qualified": "1f93e-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-200d-2640",
			"output": "1f93e-200d-2640-fe0f",
			"default_matches": [
				"1f93e-200d-2640-fe0f",
				"1f93e-200d-2640",
				"1f93e-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-200d-2640-fe0f",
				"1f93e-200d-2640",
				"1f93e-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"woman"
		]
	},
	"1f93e-1f3fb-2640": {
		"name": "woman playing handball: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1363,
		"display": 1,
		"shortname": ":woman_playing_handball_tone1:",
		"shortname_alternates": [
			":woman_playing_handball_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fb-2640",
			"fully_qualified": "1f93e-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-1f3fb-200d-2640",
			"output": "1f93e-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f93e-1f3fb-200d-2640-fe0f",
				"1f93e-1f3fb-200d-2640",
				"1f93e-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fb-200d-2640-fe0f",
				"1f93e-1f3fb-200d-2640",
				"1f93e-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"light skin tone",
			"woman"
		]
	},
	"1f93e-1f3fc-2640": {
		"name": "woman playing handball: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1364,
		"display": 1,
		"shortname": ":woman_playing_handball_tone2:",
		"shortname_alternates": [
			":woman_playing_handball_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fc-2640",
			"fully_qualified": "1f93e-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-1f3fc-200d-2640",
			"output": "1f93e-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f93e-1f3fc-200d-2640-fe0f",
				"1f93e-1f3fc-200d-2640",
				"1f93e-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fc-200d-2640-fe0f",
				"1f93e-1f3fc-200d-2640",
				"1f93e-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f93e-1f3fd-2640": {
		"name": "woman playing handball: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1365,
		"display": 1,
		"shortname": ":woman_playing_handball_tone3:",
		"shortname_alternates": [
			":woman_playing_handball_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fd-2640",
			"fully_qualified": "1f93e-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-1f3fd-200d-2640",
			"output": "1f93e-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f93e-1f3fd-200d-2640-fe0f",
				"1f93e-1f3fd-200d-2640",
				"1f93e-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fd-200d-2640-fe0f",
				"1f93e-1f3fd-200d-2640",
				"1f93e-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"medium skin tone",
			"woman"
		]
	},
	"1f93e-1f3fe-2640": {
		"name": "woman playing handball: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1366,
		"display": 1,
		"shortname": ":woman_playing_handball_tone4:",
		"shortname_alternates": [
			":woman_playing_handball_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fe-2640",
			"fully_qualified": "1f93e-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-1f3fe-200d-2640",
			"output": "1f93e-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f93e-1f3fe-200d-2640-fe0f",
				"1f93e-1f3fe-200d-2640",
				"1f93e-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fe-200d-2640-fe0f",
				"1f93e-1f3fe-200d-2640",
				"1f93e-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f93e-1f3ff-2640": {
		"name": "woman playing handball: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1367,
		"display": 1,
		"shortname": ":woman_playing_handball_tone5:",
		"shortname_alternates": [
			":woman_playing_handball_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3ff-2640",
			"fully_qualified": "1f93e-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f93e-1f3ff-200d-2640",
			"output": "1f93e-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f93e-1f3ff-200d-2640-fe0f",
				"1f93e-1f3ff-200d-2640",
				"1f93e-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3ff-200d-2640-fe0f",
				"1f93e-1f3ff-200d-2640",
				"1f93e-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"handball",
			"woman"
		]
	},
	"1f93e-2642": {
		"name": "man playing handball",
		"unicode_version": 9,
		"category": "activity",
		"order": 1368,
		"display": 1,
		"shortname": ":man_playing_handball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93e-1f3fb-2642",
			"1f93e-1f3fc-2642",
			"1f93e-1f3fd-2642",
			"1f93e-1f3fe-2642",
			"1f93e-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-2642",
			"fully_qualified": "1f93e-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-200d-2642",
			"output": "1f93e-200d-2642-fe0f",
			"default_matches": [
				"1f93e-200d-2642-fe0f",
				"1f93e-200d-2642",
				"1f93e-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-200d-2642-fe0f",
				"1f93e-200d-2642",
				"1f93e-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"man"
		]
	},
	"1f93e-1f3fb-2642": {
		"name": "man playing handball: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1369,
		"display": 1,
		"shortname": ":man_playing_handball_tone1:",
		"shortname_alternates": [
			":man_playing_handball_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fb-2642",
			"fully_qualified": "1f93e-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-1f3fb-200d-2642",
			"output": "1f93e-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f93e-1f3fb-200d-2642-fe0f",
				"1f93e-1f3fb-200d-2642",
				"1f93e-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fb-200d-2642-fe0f",
				"1f93e-1f3fb-200d-2642",
				"1f93e-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"light skin tone",
			"man"
		]
	},
	"1f93e-1f3fc-2642": {
		"name": "man playing handball: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1370,
		"display": 1,
		"shortname": ":man_playing_handball_tone2:",
		"shortname_alternates": [
			":man_playing_handball_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fc-2642",
			"fully_qualified": "1f93e-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-1f3fc-200d-2642",
			"output": "1f93e-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f93e-1f3fc-200d-2642-fe0f",
				"1f93e-1f3fc-200d-2642",
				"1f93e-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fc-200d-2642-fe0f",
				"1f93e-1f3fc-200d-2642",
				"1f93e-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"man",
			"medium-light skin tone"
		]
	},
	"1f93e-1f3fd-2642": {
		"name": "man playing handball: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1371,
		"display": 1,
		"shortname": ":man_playing_handball_tone3:",
		"shortname_alternates": [
			":man_playing_handball_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fd-2642",
			"fully_qualified": "1f93e-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-1f3fd-200d-2642",
			"output": "1f93e-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f93e-1f3fd-200d-2642-fe0f",
				"1f93e-1f3fd-200d-2642",
				"1f93e-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fd-200d-2642-fe0f",
				"1f93e-1f3fd-200d-2642",
				"1f93e-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"man",
			"medium skin tone"
		]
	},
	"1f93e-1f3fe-2642": {
		"name": "man playing handball: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1372,
		"display": 1,
		"shortname": ":man_playing_handball_tone4:",
		"shortname_alternates": [
			":man_playing_handball_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3fe-2642",
			"fully_qualified": "1f93e-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-1f3fe-200d-2642",
			"output": "1f93e-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f93e-1f3fe-200d-2642-fe0f",
				"1f93e-1f3fe-200d-2642",
				"1f93e-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3fe-200d-2642-fe0f",
				"1f93e-1f3fe-200d-2642",
				"1f93e-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"handball",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f93e-1f3ff-2642": {
		"name": "man playing handball: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1373,
		"display": 1,
		"shortname": ":man_playing_handball_tone5:",
		"shortname_alternates": [
			":man_playing_handball_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93e-1f3ff-2642",
			"fully_qualified": "1f93e-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f93e-1f3ff-200d-2642",
			"output": "1f93e-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f93e-1f3ff-200d-2642-fe0f",
				"1f93e-1f3ff-200d-2642",
				"1f93e-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f93e-1f3ff-200d-2642-fe0f",
				"1f93e-1f3ff-200d-2642",
				"1f93e-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"handball",
			"man"
		]
	},
	"1f93e": {
		"name": "person playing handball",
		"unicode_version": 9,
		"category": "activity",
		"order": 1374,
		"display": 0,
		"shortname": ":person_playing_handball:",
		"shortname_alternates": [
			":handball:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93e-1f3fb",
			"1f93e-1f3fc",
			"1f93e-1f3fd",
			"1f93e-1f3fe",
			"1f93e-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f93e-2642",
			"1f93e-2640"
		],
		"code_points": {
			"base": "1f93e",
			"fully_qualified": "1f93e",
			"non_fully_qualified": "1f93e",
			"output": "1f93e",
			"default_matches": [
				"1f93e"
			],
			"greedy_matches": [
				"1f93e"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"handball"
		]
	},
	"1f93e-1f3fb": {
		"name": "person playing handball: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1375,
		"display": 0,
		"shortname": ":person_playing_handball_tone1:",
		"shortname_alternates": [
			":handball_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93e-1f3fb-2642",
			"1f93e-1f3fb-2640"
		],
		"code_points": {
			"base": "1f93e-1f3fb",
			"fully_qualified": "1f93e-1f3fb",
			"non_fully_qualified": "1f93e-1f3fb",
			"output": "1f93e-1f3fb",
			"default_matches": [
				"1f93e-1f3fb"
			],
			"greedy_matches": [
				"1f93e-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"handball",
			"light skin tone"
		]
	},
	"1f93e-1f3fc": {
		"name": "person playing handball: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1376,
		"display": 0,
		"shortname": ":person_playing_handball_tone2:",
		"shortname_alternates": [
			":handball_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93e-1f3fc-2642",
			"1f93e-1f3fc-2640"
		],
		"code_points": {
			"base": "1f93e-1f3fc",
			"fully_qualified": "1f93e-1f3fc",
			"non_fully_qualified": "1f93e-1f3fc",
			"output": "1f93e-1f3fc",
			"default_matches": [
				"1f93e-1f3fc"
			],
			"greedy_matches": [
				"1f93e-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"handball",
			"medium-light skin tone"
		]
	},
	"1f93e-1f3fd": {
		"name": "person playing handball: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1377,
		"display": 0,
		"shortname": ":person_playing_handball_tone3:",
		"shortname_alternates": [
			":handball_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93e-1f3fd-2642",
			"1f93e-1f3fd-2640"
		],
		"code_points": {
			"base": "1f93e-1f3fd",
			"fully_qualified": "1f93e-1f3fd",
			"non_fully_qualified": "1f93e-1f3fd",
			"output": "1f93e-1f3fd",
			"default_matches": [
				"1f93e-1f3fd"
			],
			"greedy_matches": [
				"1f93e-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"handball",
			"medium skin tone"
		]
	},
	"1f93e-1f3fe": {
		"name": "person playing handball: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1378,
		"display": 0,
		"shortname": ":person_playing_handball_tone4:",
		"shortname_alternates": [
			":handball_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93e-1f3fe-2642",
			"1f93e-1f3fe-2640"
		],
		"code_points": {
			"base": "1f93e-1f3fe",
			"fully_qualified": "1f93e-1f3fe",
			"non_fully_qualified": "1f93e-1f3fe",
			"output": "1f93e-1f3fe",
			"default_matches": [
				"1f93e-1f3fe"
			],
			"greedy_matches": [
				"1f93e-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"handball",
			"medium-dark skin tone"
		]
	},
	"1f93e-1f3ff": {
		"name": "person playing handball: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1379,
		"display": 0,
		"shortname": ":person_playing_handball_tone5:",
		"shortname_alternates": [
			":handball_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93e-1f3ff-2642",
			"1f93e-1f3ff-2640"
		],
		"code_points": {
			"base": "1f93e-1f3ff",
			"fully_qualified": "1f93e-1f3ff",
			"non_fully_qualified": "1f93e-1f3ff",
			"output": "1f93e-1f3ff",
			"default_matches": [
				"1f93e-1f3ff"
			],
			"greedy_matches": [
				"1f93e-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"dark skin tone",
			"handball"
		]
	},
	"1f3cc-2640": {
		"name": "woman golfing",
		"unicode_version": 7,
		"category": "activity",
		"order": 1380,
		"display": 1,
		"shortname": ":woman_golfing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cc-1f3fb-2640",
			"1f3cc-1f3fc-2640",
			"1f3cc-1f3fd-2640",
			"1f3cc-1f3fe-2640",
			"1f3cc-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-2640",
			"fully_qualified": "1f3cc-fe0f-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-200d-2640",
			"output": "1f3cc-fe0f-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-fe0f-200d-2640-fe0f",
				"1f3cc-200d-2640",
				"1f3cc-fe0f-2640-fe0f",
				"1f3cc-200d-2640-fe0f",
				"1f3cc-fe0f-200d-2640"
			],
			"greedy_matches": [
				"1f3cc-fe0f-200d-2640-fe0f",
				"1f3cc-200d-2640",
				"1f3cc-fe0f-2640-fe0f",
				"1f3cc-200d-2640-fe0f",
				"1f3cc-fe0f-200d-2640"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"woman"
		]
	},
	"1f3cc-1f3fb-2640": {
		"name": "woman golfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1381,
		"display": 1,
		"shortname": ":woman_golfing_tone1:",
		"shortname_alternates": [
			":woman_golfing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fb-2640",
			"fully_qualified": "1f3cc-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-1f3fb-200d-2640",
			"output": "1f3cc-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-1f3fb-200d-2640-fe0f",
				"1f3cc-1f3fb-200d-2640",
				"1f3cc-fe0f-1f3fb-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fb-200d-2640-fe0f",
				"1f3cc-1f3fb-200d-2640",
				"1f3cc-fe0f-1f3fb-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"light skin tone",
			"woman"
		]
	},
	"1f3cc-1f3fc-2640": {
		"name": "woman golfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1382,
		"display": 1,
		"shortname": ":woman_golfing_tone2:",
		"shortname_alternates": [
			":woman_golfing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fc-2640",
			"fully_qualified": "1f3cc-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-1f3fc-200d-2640",
			"output": "1f3cc-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-1f3fc-200d-2640-fe0f",
				"1f3cc-1f3fc-200d-2640",
				"1f3cc-fe0f-1f3fc-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fc-200d-2640-fe0f",
				"1f3cc-1f3fc-200d-2640",
				"1f3cc-fe0f-1f3fc-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f3cc-1f3fd-2640": {
		"name": "woman golfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1383,
		"display": 1,
		"shortname": ":woman_golfing_tone3:",
		"shortname_alternates": [
			":woman_golfing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fd-2640",
			"fully_qualified": "1f3cc-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-1f3fd-200d-2640",
			"output": "1f3cc-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-1f3fd-200d-2640-fe0f",
				"1f3cc-1f3fd-200d-2640",
				"1f3cc-fe0f-1f3fd-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fd-200d-2640-fe0f",
				"1f3cc-1f3fd-200d-2640",
				"1f3cc-fe0f-1f3fd-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"medium skin tone",
			"woman"
		]
	},
	"1f3cc-1f3fe-2640": {
		"name": "woman golfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1384,
		"display": 1,
		"shortname": ":woman_golfing_tone4:",
		"shortname_alternates": [
			":woman_golfing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fe-2640",
			"fully_qualified": "1f3cc-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-1f3fe-200d-2640",
			"output": "1f3cc-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-1f3fe-200d-2640-fe0f",
				"1f3cc-1f3fe-200d-2640",
				"1f3cc-fe0f-1f3fe-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fe-200d-2640-fe0f",
				"1f3cc-1f3fe-200d-2640",
				"1f3cc-fe0f-1f3fe-200d-2640-fe0f",
				"1f3cc-fe0f-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f3cc-1f3ff-2640": {
		"name": "woman golfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1385,
		"display": 1,
		"shortname": ":woman_golfing_tone5:",
		"shortname_alternates": [
			":woman_golfing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3ff-2640",
			"fully_qualified": "1f3cc-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f3cc-1f3ff-200d-2640",
			"output": "1f3cc-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f3cc-1f3ff-200d-2640-fe0f",
				"1f3cc-1f3ff-200d-2640",
				"1f3cc-fe0f-1f3ff-200d-2640-fe0f",
				"1f3cc-fe0f-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3ff-200d-2640-fe0f",
				"1f3cc-1f3ff-200d-2640",
				"1f3cc-fe0f-1f3ff-200d-2640-fe0f",
				"1f3cc-fe0f-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"golf",
			"woman"
		]
	},
	"1f3cc": {
		"name": "person golfing",
		"unicode_version": 7,
		"category": "activity",
		"order": 1386,
		"display": 1,
		"shortname": ":person_golfing:",
		"shortname_alternates": [
			":golfer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cc-1f3fb",
			"1f3cc-1f3fc",
			"1f3cc-1f3fd",
			"1f3cc-1f3fe",
			"1f3cc-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f3cc-2642",
			"1f3cc-2640"
		],
		"code_points": {
			"base": "1f3cc",
			"fully_qualified": "1f3cc-fe0f",
			"non_fully_qualified": "1f3cc",
			"output": "1f3cc-fe0f",
			"default_matches": [
				"1f3cc-fe0f",
				"1f3cc"
			],
			"greedy_matches": [
				"1f3cc-fe0f",
				"1f3cc"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"golf"
		]
	},
	"1f3cc-1f3fb": {
		"name": "person golfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1387,
		"display": 1,
		"shortname": ":person_golfing_tone1:",
		"shortname_alternates": [
			":person_golfing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cc-1f3fb-2642",
			"1f3cc-1f3fb-2640"
		],
		"code_points": {
			"base": "1f3cc-1f3fb",
			"fully_qualified": "1f3cc-1f3fb",
			"non_fully_qualified": "1f3cc-1f3fb",
			"output": "1f3cc-1f3fb",
			"default_matches": [
				"1f3cc-1f3fb",
				"1f3cc-fe0f-1f3fb"
			],
			"greedy_matches": [
				"1f3cc-1f3fb",
				"1f3cc-fe0f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"golf",
			"light skin tone"
		]
	},
	"1f3cc-1f3fc": {
		"name": "person golfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1388,
		"display": 1,
		"shortname": ":person_golfing_tone2:",
		"shortname_alternates": [
			":person_golfing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cc-1f3fc-2642",
			"1f3cc-1f3fc-2640"
		],
		"code_points": {
			"base": "1f3cc-1f3fc",
			"fully_qualified": "1f3cc-1f3fc",
			"non_fully_qualified": "1f3cc-1f3fc",
			"output": "1f3cc-1f3fc",
			"default_matches": [
				"1f3cc-1f3fc",
				"1f3cc-fe0f-1f3fc"
			],
			"greedy_matches": [
				"1f3cc-1f3fc",
				"1f3cc-fe0f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"golf",
			"medium-light skin tone"
		]
	},
	"1f3cc-1f3fd": {
		"name": "person golfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1389,
		"display": 1,
		"shortname": ":person_golfing_tone3:",
		"shortname_alternates": [
			":person_golfing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cc-1f3fd-2642",
			"1f3cc-1f3fd-2640"
		],
		"code_points": {
			"base": "1f3cc-1f3fd",
			"fully_qualified": "1f3cc-1f3fd",
			"non_fully_qualified": "1f3cc-1f3fd",
			"output": "1f3cc-1f3fd",
			"default_matches": [
				"1f3cc-1f3fd",
				"1f3cc-fe0f-1f3fd"
			],
			"greedy_matches": [
				"1f3cc-1f3fd",
				"1f3cc-fe0f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"golf",
			"medium skin tone"
		]
	},
	"1f3cc-1f3fe": {
		"name": "person golfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1390,
		"display": 1,
		"shortname": ":person_golfing_tone4:",
		"shortname_alternates": [
			":person_golfing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cc-1f3fe-2642",
			"1f3cc-1f3fe-2640"
		],
		"code_points": {
			"base": "1f3cc-1f3fe",
			"fully_qualified": "1f3cc-1f3fe",
			"non_fully_qualified": "1f3cc-1f3fe",
			"output": "1f3cc-1f3fe",
			"default_matches": [
				"1f3cc-1f3fe",
				"1f3cc-fe0f-1f3fe"
			],
			"greedy_matches": [
				"1f3cc-1f3fe",
				"1f3cc-fe0f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"golf",
			"medium-dark skin tone"
		]
	},
	"1f3cc-1f3ff": {
		"name": "person golfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1391,
		"display": 1,
		"shortname": ":person_golfing_tone5:",
		"shortname_alternates": [
			":person_golfing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3cc-1f3ff-2642",
			"1f3cc-1f3ff-2640"
		],
		"code_points": {
			"base": "1f3cc-1f3ff",
			"fully_qualified": "1f3cc-1f3ff",
			"non_fully_qualified": "1f3cc-1f3ff",
			"output": "1f3cc-1f3ff",
			"default_matches": [
				"1f3cc-1f3ff",
				"1f3cc-fe0f-1f3ff"
			],
			"greedy_matches": [
				"1f3cc-1f3ff",
				"1f3cc-fe0f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"dark skin tone",
			"golf"
		]
	},
	"1f3cc-2642": {
		"name": "man golfing",
		"unicode_version": 7,
		"category": "activity",
		"order": 1392,
		"display": 0,
		"shortname": ":man_golfing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3cc-1f3fb-2642",
			"1f3cc-1f3fc-2642",
			"1f3cc-1f3fd-2642",
			"1f3cc-1f3fe-2642",
			"1f3cc-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-2642",
			"fully_qualified": "1f3cc-fe0f-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-200d-2642",
			"output": "1f3cc-fe0f-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-fe0f-200d-2642-fe0f",
				"1f3cc-200d-2642",
				"1f3cc-fe0f-2642-fe0f",
				"1f3cc-200d-2642-fe0f",
				"1f3cc-fe0f-200d-2642"
			],
			"greedy_matches": [
				"1f3cc-fe0f-200d-2642-fe0f",
				"1f3cc-200d-2642",
				"1f3cc-fe0f-2642-fe0f",
				"1f3cc-200d-2642-fe0f",
				"1f3cc-fe0f-200d-2642"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"man"
		]
	},
	"1f3cc-1f3fb-2642": {
		"name": "man golfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1393,
		"display": 0,
		"shortname": ":man_golfing_tone1:",
		"shortname_alternates": [
			":man_golfing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fb-2642",
			"fully_qualified": "1f3cc-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-1f3fb-200d-2642",
			"output": "1f3cc-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-1f3fb-200d-2642-fe0f",
				"1f3cc-1f3fb-200d-2642",
				"1f3cc-fe0f-1f3fb-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fb-200d-2642-fe0f",
				"1f3cc-1f3fb-200d-2642",
				"1f3cc-fe0f-1f3fb-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"light skin tone",
			"man"
		]
	},
	"1f3cc-1f3fc-2642": {
		"name": "man golfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1394,
		"display": 0,
		"shortname": ":man_golfing_tone2:",
		"shortname_alternates": [
			":man_golfing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fc-2642",
			"fully_qualified": "1f3cc-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-1f3fc-200d-2642",
			"output": "1f3cc-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-1f3fc-200d-2642-fe0f",
				"1f3cc-1f3fc-200d-2642",
				"1f3cc-fe0f-1f3fc-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fc-200d-2642-fe0f",
				"1f3cc-1f3fc-200d-2642",
				"1f3cc-fe0f-1f3fc-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"man",
			"medium-light skin tone"
		]
	},
	"1f3cc-1f3fd-2642": {
		"name": "man golfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1395,
		"display": 0,
		"shortname": ":man_golfing_tone3:",
		"shortname_alternates": [
			":man_golfing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fd-2642",
			"fully_qualified": "1f3cc-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-1f3fd-200d-2642",
			"output": "1f3cc-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-1f3fd-200d-2642-fe0f",
				"1f3cc-1f3fd-200d-2642",
				"1f3cc-fe0f-1f3fd-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fd-200d-2642-fe0f",
				"1f3cc-1f3fd-200d-2642",
				"1f3cc-fe0f-1f3fd-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"man",
			"medium skin tone"
		]
	},
	"1f3cc-1f3fe-2642": {
		"name": "man golfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1396,
		"display": 0,
		"shortname": ":man_golfing_tone4:",
		"shortname_alternates": [
			":man_golfing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3fe-2642",
			"fully_qualified": "1f3cc-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-1f3fe-200d-2642",
			"output": "1f3cc-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-1f3fe-200d-2642-fe0f",
				"1f3cc-1f3fe-200d-2642",
				"1f3cc-fe0f-1f3fe-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3fe-200d-2642-fe0f",
				"1f3cc-1f3fe-200d-2642",
				"1f3cc-fe0f-1f3fe-200d-2642-fe0f",
				"1f3cc-fe0f-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"golf",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f3cc-1f3ff-2642": {
		"name": "man golfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1397,
		"display": 0,
		"shortname": ":man_golfing_tone5:",
		"shortname_alternates": [
			":man_golfing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3cc-1f3ff-2642",
			"fully_qualified": "1f3cc-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f3cc-1f3ff-200d-2642",
			"output": "1f3cc-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f3cc-1f3ff-200d-2642-fe0f",
				"1f3cc-1f3ff-200d-2642",
				"1f3cc-fe0f-1f3ff-200d-2642-fe0f",
				"1f3cc-fe0f-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f3cc-1f3ff-200d-2642-fe0f",
				"1f3cc-1f3ff-200d-2642",
				"1f3cc-fe0f-1f3ff-200d-2642-fe0f",
				"1f3cc-fe0f-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"golf",
			"man"
		]
	},
	"1f3c4-2640": {
		"name": "woman surfing",
		"unicode_version": 6,
		"category": "activity",
		"order": 1398,
		"display": 1,
		"shortname": ":woman_surfing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c4-1f3fb-2640",
			"1f3c4-1f3fc-2640",
			"1f3c4-1f3fd-2640",
			"1f3c4-1f3fe-2640",
			"1f3c4-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-2640",
			"fully_qualified": "1f3c4-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-200d-2640",
			"output": "1f3c4-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-200d-2640-fe0f",
				"1f3c4-200d-2640",
				"1f3c4-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-200d-2640-fe0f",
				"1f3c4-200d-2640",
				"1f3c4-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"surfing",
			"woman"
		]
	},
	"1f3c4-1f3fb-2640": {
		"name": "woman surfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1399,
		"display": 1,
		"shortname": ":woman_surfing_tone1:",
		"shortname_alternates": [
			":woman_surfing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fb-2640",
			"fully_qualified": "1f3c4-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-1f3fb-200d-2640",
			"output": "1f3c4-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-1f3fb-200d-2640-fe0f",
				"1f3c4-1f3fb-200d-2640",
				"1f3c4-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fb-200d-2640-fe0f",
				"1f3c4-1f3fb-200d-2640",
				"1f3c4-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"surfing",
			"woman"
		]
	},
	"1f3c4-1f3fc-2640": {
		"name": "woman surfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1400,
		"display": 1,
		"shortname": ":woman_surfing_tone2:",
		"shortname_alternates": [
			":woman_surfing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fc-2640",
			"fully_qualified": "1f3c4-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-1f3fc-200d-2640",
			"output": "1f3c4-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-1f3fc-200d-2640-fe0f",
				"1f3c4-1f3fc-200d-2640",
				"1f3c4-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fc-200d-2640-fe0f",
				"1f3c4-1f3fc-200d-2640",
				"1f3c4-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"surfing",
			"woman"
		]
	},
	"1f3c4-1f3fd-2640": {
		"name": "woman surfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1401,
		"display": 1,
		"shortname": ":woman_surfing_tone3:",
		"shortname_alternates": [
			":woman_surfing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fd-2640",
			"fully_qualified": "1f3c4-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-1f3fd-200d-2640",
			"output": "1f3c4-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-1f3fd-200d-2640-fe0f",
				"1f3c4-1f3fd-200d-2640",
				"1f3c4-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fd-200d-2640-fe0f",
				"1f3c4-1f3fd-200d-2640",
				"1f3c4-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"surfing",
			"woman"
		]
	},
	"1f3c4-1f3fe-2640": {
		"name": "woman surfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1402,
		"display": 1,
		"shortname": ":woman_surfing_tone4:",
		"shortname_alternates": [
			":woman_surfing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fe-2640",
			"fully_qualified": "1f3c4-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-1f3fe-200d-2640",
			"output": "1f3c4-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-1f3fe-200d-2640-fe0f",
				"1f3c4-1f3fe-200d-2640",
				"1f3c4-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fe-200d-2640-fe0f",
				"1f3c4-1f3fe-200d-2640",
				"1f3c4-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"surfing",
			"woman"
		]
	},
	"1f3c4-1f3ff-2640": {
		"name": "woman surfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1403,
		"display": 1,
		"shortname": ":woman_surfing_tone5:",
		"shortname_alternates": [
			":woman_surfing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3ff-2640",
			"fully_qualified": "1f3c4-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f3c4-1f3ff-200d-2640",
			"output": "1f3c4-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f3c4-1f3ff-200d-2640-fe0f",
				"1f3c4-1f3ff-200d-2640",
				"1f3c4-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3ff-200d-2640-fe0f",
				"1f3c4-1f3ff-200d-2640",
				"1f3c4-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"surfing",
			"woman"
		]
	},
	"1f3c4": {
		"name": "person surfing",
		"unicode_version": 6,
		"category": "activity",
		"order": 1404,
		"display": 1,
		"shortname": ":person_surfing:",
		"shortname_alternates": [
			":surfer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c4-1f3fb",
			"1f3c4-1f3fc",
			"1f3c4-1f3fd",
			"1f3c4-1f3fe",
			"1f3c4-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f3c4-2642",
			"1f3c4-2640"
		],
		"code_points": {
			"base": "1f3c4",
			"fully_qualified": "1f3c4",
			"non_fully_qualified": "1f3c4",
			"output": "1f3c4",
			"default_matches": [
				"1f3c4"
			],
			"greedy_matches": [
				"1f3c4"
			],
			"decimal": ""
		},
		"keywords": [
			"surfing"
		]
	},
	"1f3c4-1f3fb": {
		"name": "person surfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1405,
		"display": 1,
		"shortname": ":person_surfing_tone1:",
		"shortname_alternates": [
			":surfer_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c4-1f3fb-2642",
			"1f3c4-1f3fb-2640"
		],
		"code_points": {
			"base": "1f3c4-1f3fb",
			"fully_qualified": "1f3c4-1f3fb",
			"non_fully_qualified": "1f3c4-1f3fb",
			"output": "1f3c4-1f3fb",
			"default_matches": [
				"1f3c4-1f3fb"
			],
			"greedy_matches": [
				"1f3c4-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fc": {
		"name": "person surfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1406,
		"display": 1,
		"shortname": ":person_surfing_tone2:",
		"shortname_alternates": [
			":surfer_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c4-1f3fc-2642",
			"1f3c4-1f3fc-2640"
		],
		"code_points": {
			"base": "1f3c4-1f3fc",
			"fully_qualified": "1f3c4-1f3fc",
			"non_fully_qualified": "1f3c4-1f3fc",
			"output": "1f3c4-1f3fc",
			"default_matches": [
				"1f3c4-1f3fc"
			],
			"greedy_matches": [
				"1f3c4-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fd": {
		"name": "person surfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1407,
		"display": 1,
		"shortname": ":person_surfing_tone3:",
		"shortname_alternates": [
			":surfer_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c4-1f3fd-2642",
			"1f3c4-1f3fd-2640"
		],
		"code_points": {
			"base": "1f3c4-1f3fd",
			"fully_qualified": "1f3c4-1f3fd",
			"non_fully_qualified": "1f3c4-1f3fd",
			"output": "1f3c4-1f3fd",
			"default_matches": [
				"1f3c4-1f3fd"
			],
			"greedy_matches": [
				"1f3c4-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fe": {
		"name": "person surfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1408,
		"display": 1,
		"shortname": ":person_surfing_tone4:",
		"shortname_alternates": [
			":surfer_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c4-1f3fe-2642",
			"1f3c4-1f3fe-2640"
		],
		"code_points": {
			"base": "1f3c4-1f3fe",
			"fully_qualified": "1f3c4-1f3fe",
			"non_fully_qualified": "1f3c4-1f3fe",
			"output": "1f3c4-1f3fe",
			"default_matches": [
				"1f3c4-1f3fe"
			],
			"greedy_matches": [
				"1f3c4-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3ff": {
		"name": "person surfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1409,
		"display": 1,
		"shortname": ":person_surfing_tone5:",
		"shortname_alternates": [
			":surfer_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3c4-1f3ff-2642",
			"1f3c4-1f3ff-2640"
		],
		"code_points": {
			"base": "1f3c4-1f3ff",
			"fully_qualified": "1f3c4-1f3ff",
			"non_fully_qualified": "1f3c4-1f3ff",
			"output": "1f3c4-1f3ff",
			"default_matches": [
				"1f3c4-1f3ff"
			],
			"greedy_matches": [
				"1f3c4-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"surfing"
		]
	},
	"1f3c4-2642": {
		"name": "man surfing",
		"unicode_version": 6,
		"category": "activity",
		"order": 1410,
		"display": 0,
		"shortname": ":man_surfing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c4-1f3fb-2642",
			"1f3c4-1f3fc-2642",
			"1f3c4-1f3fd-2642",
			"1f3c4-1f3fe-2642",
			"1f3c4-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-2642",
			"fully_qualified": "1f3c4-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-200d-2642",
			"output": "1f3c4-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-200d-2642-fe0f",
				"1f3c4-200d-2642",
				"1f3c4-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-200d-2642-fe0f",
				"1f3c4-200d-2642",
				"1f3c4-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"surfing"
		]
	},
	"1f3c4-1f3ff-2642": {
		"name": "man surfing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1411,
		"display": 0,
		"shortname": ":man_surfing_tone5:",
		"shortname_alternates": [
			":man_surfing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3ff-2642",
			"fully_qualified": "1f3c4-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-1f3ff-200d-2642",
			"output": "1f3c4-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-1f3ff-200d-2642-fe0f",
				"1f3c4-1f3ff-200d-2642",
				"1f3c4-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3ff-200d-2642-fe0f",
				"1f3c4-1f3ff-200d-2642",
				"1f3c4-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"surfing"
		]
	},
	"1f3c4-1f3fe-2642": {
		"name": "man surfing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1412,
		"display": 0,
		"shortname": ":man_surfing_tone4:",
		"shortname_alternates": [
			":man_surfing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fe-2642",
			"fully_qualified": "1f3c4-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-1f3fe-200d-2642",
			"output": "1f3c4-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-1f3fe-200d-2642-fe0f",
				"1f3c4-1f3fe-200d-2642",
				"1f3c4-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fe-200d-2642-fe0f",
				"1f3c4-1f3fe-200d-2642",
				"1f3c4-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fd-2642": {
		"name": "man surfing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1413,
		"display": 0,
		"shortname": ":man_surfing_tone3:",
		"shortname_alternates": [
			":man_surfing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fd-2642",
			"fully_qualified": "1f3c4-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-1f3fd-200d-2642",
			"output": "1f3c4-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-1f3fd-200d-2642-fe0f",
				"1f3c4-1f3fd-200d-2642",
				"1f3c4-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fd-200d-2642-fe0f",
				"1f3c4-1f3fd-200d-2642",
				"1f3c4-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fc-2642": {
		"name": "man surfing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1414,
		"display": 0,
		"shortname": ":man_surfing_tone2:",
		"shortname_alternates": [
			":man_surfing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fc-2642",
			"fully_qualified": "1f3c4-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-1f3fc-200d-2642",
			"output": "1f3c4-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-1f3fc-200d-2642-fe0f",
				"1f3c4-1f3fc-200d-2642",
				"1f3c4-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fc-200d-2642-fe0f",
				"1f3c4-1f3fc-200d-2642",
				"1f3c4-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"surfing"
		]
	},
	"1f3c4-1f3fb-2642": {
		"name": "man surfing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1415,
		"display": 0,
		"shortname": ":man_surfing_tone1:",
		"shortname_alternates": [
			":man_surfing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3c4-1f3fb-2642",
			"fully_qualified": "1f3c4-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f3c4-1f3fb-200d-2642",
			"output": "1f3c4-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f3c4-1f3fb-200d-2642-fe0f",
				"1f3c4-1f3fb-200d-2642",
				"1f3c4-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f3c4-1f3fb-200d-2642-fe0f",
				"1f3c4-1f3fb-200d-2642",
				"1f3c4-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"surfing"
		]
	},
	"1f3ca-2640": {
		"name": "woman swimming",
		"unicode_version": 6,
		"category": "activity",
		"order": 1416,
		"display": 1,
		"shortname": ":woman_swimming:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3ca-1f3fb-2640",
			"1f3ca-1f3fc-2640",
			"1f3ca-1f3fd-2640",
			"1f3ca-1f3fe-2640",
			"1f3ca-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-2640",
			"fully_qualified": "1f3ca-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-200d-2640",
			"output": "1f3ca-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-200d-2640-fe0f",
				"1f3ca-200d-2640",
				"1f3ca-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-200d-2640-fe0f",
				"1f3ca-200d-2640",
				"1f3ca-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"swim",
			"woman"
		]
	},
	"1f3ca-1f3fb-2640": {
		"name": "woman swimming: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1417,
		"display": 1,
		"shortname": ":woman_swimming_tone1:",
		"shortname_alternates": [
			":woman_swimming_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fb-2640",
			"fully_qualified": "1f3ca-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-1f3fb-200d-2640",
			"output": "1f3ca-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-1f3fb-200d-2640-fe0f",
				"1f3ca-1f3fb-200d-2640",
				"1f3ca-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fb-200d-2640-fe0f",
				"1f3ca-1f3fb-200d-2640",
				"1f3ca-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"swim",
			"woman"
		]
	},
	"1f3ca-1f3fc-2640": {
		"name": "woman swimming: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1418,
		"display": 1,
		"shortname": ":woman_swimming_tone2:",
		"shortname_alternates": [
			":woman_swimming_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fc-2640",
			"fully_qualified": "1f3ca-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-1f3fc-200d-2640",
			"output": "1f3ca-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-1f3fc-200d-2640-fe0f",
				"1f3ca-1f3fc-200d-2640",
				"1f3ca-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fc-200d-2640-fe0f",
				"1f3ca-1f3fc-200d-2640",
				"1f3ca-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"swim",
			"woman"
		]
	},
	"1f3ca-1f3fd-2640": {
		"name": "woman swimming: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1419,
		"display": 1,
		"shortname": ":woman_swimming_tone3:",
		"shortname_alternates": [
			":woman_swimming_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fd-2640",
			"fully_qualified": "1f3ca-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-1f3fd-200d-2640",
			"output": "1f3ca-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-1f3fd-200d-2640-fe0f",
				"1f3ca-1f3fd-200d-2640",
				"1f3ca-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fd-200d-2640-fe0f",
				"1f3ca-1f3fd-200d-2640",
				"1f3ca-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"swim",
			"woman"
		]
	},
	"1f3ca-1f3fe-2640": {
		"name": "woman swimming: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1420,
		"display": 1,
		"shortname": ":woman_swimming_tone4:",
		"shortname_alternates": [
			":woman_swimming_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fe-2640",
			"fully_qualified": "1f3ca-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-1f3fe-200d-2640",
			"output": "1f3ca-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-1f3fe-200d-2640-fe0f",
				"1f3ca-1f3fe-200d-2640",
				"1f3ca-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fe-200d-2640-fe0f",
				"1f3ca-1f3fe-200d-2640",
				"1f3ca-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"swim",
			"woman"
		]
	},
	"1f3ca-1f3ff-2640": {
		"name": "woman swimming: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1421,
		"display": 1,
		"shortname": ":woman_swimming_tone5:",
		"shortname_alternates": [
			":woman_swimming_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3ff-2640",
			"fully_qualified": "1f3ca-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f3ca-1f3ff-200d-2640",
			"output": "1f3ca-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f3ca-1f3ff-200d-2640-fe0f",
				"1f3ca-1f3ff-200d-2640",
				"1f3ca-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3ff-200d-2640-fe0f",
				"1f3ca-1f3ff-200d-2640",
				"1f3ca-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"swim",
			"woman"
		]
	},
	"1f3ca": {
		"name": "person swimming",
		"unicode_version": 6,
		"category": "activity",
		"order": 1422,
		"display": 1,
		"shortname": ":person_swimming:",
		"shortname_alternates": [
			":swimmer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3ca-1f3fb",
			"1f3ca-1f3fc",
			"1f3ca-1f3fd",
			"1f3ca-1f3fe",
			"1f3ca-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f3ca-2642",
			"1f3ca-2640"
		],
		"code_points": {
			"base": "1f3ca",
			"fully_qualified": "1f3ca",
			"non_fully_qualified": "1f3ca",
			"output": "1f3ca",
			"default_matches": [
				"1f3ca"
			],
			"greedy_matches": [
				"1f3ca"
			],
			"decimal": ""
		},
		"keywords": [
			"swim"
		]
	},
	"1f3ca-1f3fb": {
		"name": "person swimming: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1423,
		"display": 1,
		"shortname": ":person_swimming_tone1:",
		"shortname_alternates": [
			":swimmer_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3ca-1f3fb-2642",
			"1f3ca-1f3fb-2640"
		],
		"code_points": {
			"base": "1f3ca-1f3fb",
			"fully_qualified": "1f3ca-1f3fb",
			"non_fully_qualified": "1f3ca-1f3fb",
			"output": "1f3ca-1f3fb",
			"default_matches": [
				"1f3ca-1f3fb"
			],
			"greedy_matches": [
				"1f3ca-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fc": {
		"name": "person swimming: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1424,
		"display": 1,
		"shortname": ":person_swimming_tone2:",
		"shortname_alternates": [
			":swimmer_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3ca-1f3fc-2642",
			"1f3ca-1f3fc-2640"
		],
		"code_points": {
			"base": "1f3ca-1f3fc",
			"fully_qualified": "1f3ca-1f3fc",
			"non_fully_qualified": "1f3ca-1f3fc",
			"output": "1f3ca-1f3fc",
			"default_matches": [
				"1f3ca-1f3fc"
			],
			"greedy_matches": [
				"1f3ca-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fd": {
		"name": "person swimming: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1425,
		"display": 1,
		"shortname": ":person_swimming_tone3:",
		"shortname_alternates": [
			":swimmer_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3ca-1f3fd-2642",
			"1f3ca-1f3fd-2640"
		],
		"code_points": {
			"base": "1f3ca-1f3fd",
			"fully_qualified": "1f3ca-1f3fd",
			"non_fully_qualified": "1f3ca-1f3fd",
			"output": "1f3ca-1f3fd",
			"default_matches": [
				"1f3ca-1f3fd"
			],
			"greedy_matches": [
				"1f3ca-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fe": {
		"name": "person swimming: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1426,
		"display": 1,
		"shortname": ":person_swimming_tone4:",
		"shortname_alternates": [
			":swimmer_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3ca-1f3fe-2642",
			"1f3ca-1f3fe-2640"
		],
		"code_points": {
			"base": "1f3ca-1f3fe",
			"fully_qualified": "1f3ca-1f3fe",
			"non_fully_qualified": "1f3ca-1f3fe",
			"output": "1f3ca-1f3fe",
			"default_matches": [
				"1f3ca-1f3fe"
			],
			"greedy_matches": [
				"1f3ca-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"swim"
		]
	},
	"1f3ca-1f3ff": {
		"name": "person swimming: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1427,
		"display": 1,
		"shortname": ":person_swimming_tone5:",
		"shortname_alternates": [
			":swimmer_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f3ca-1f3ff-2642",
			"1f3ca-1f3ff-2640"
		],
		"code_points": {
			"base": "1f3ca-1f3ff",
			"fully_qualified": "1f3ca-1f3ff",
			"non_fully_qualified": "1f3ca-1f3ff",
			"output": "1f3ca-1f3ff",
			"default_matches": [
				"1f3ca-1f3ff"
			],
			"greedy_matches": [
				"1f3ca-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"swim"
		]
	},
	"1f3ca-2642": {
		"name": "man swimming",
		"unicode_version": 6,
		"category": "activity",
		"order": 1428,
		"display": 0,
		"shortname": ":man_swimming:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3ca-1f3fb-2642",
			"1f3ca-1f3fc-2642",
			"1f3ca-1f3fd-2642",
			"1f3ca-1f3fe-2642",
			"1f3ca-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-2642",
			"fully_qualified": "1f3ca-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-200d-2642",
			"output": "1f3ca-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-200d-2642-fe0f",
				"1f3ca-200d-2642",
				"1f3ca-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-200d-2642-fe0f",
				"1f3ca-200d-2642",
				"1f3ca-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"swim"
		]
	},
	"1f3ca-1f3ff-2642": {
		"name": "man swimming: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1429,
		"display": 0,
		"shortname": ":man_swimming_tone5:",
		"shortname_alternates": [
			":man_swimming_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3ff-2642",
			"fully_qualified": "1f3ca-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-1f3ff-200d-2642",
			"output": "1f3ca-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-1f3ff-200d-2642-fe0f",
				"1f3ca-1f3ff-200d-2642",
				"1f3ca-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3ff-200d-2642-fe0f",
				"1f3ca-1f3ff-200d-2642",
				"1f3ca-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"swim"
		]
	},
	"1f3ca-1f3fe-2642": {
		"name": "man swimming: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1430,
		"display": 0,
		"shortname": ":man_swimming_tone4:",
		"shortname_alternates": [
			":man_swimming_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fe-2642",
			"fully_qualified": "1f3ca-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-1f3fe-200d-2642",
			"output": "1f3ca-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-1f3fe-200d-2642-fe0f",
				"1f3ca-1f3fe-200d-2642",
				"1f3ca-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fe-200d-2642-fe0f",
				"1f3ca-1f3fe-200d-2642",
				"1f3ca-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fd-2642": {
		"name": "man swimming: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1431,
		"display": 0,
		"shortname": ":man_swimming_tone3:",
		"shortname_alternates": [
			":man_swimming_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fd-2642",
			"fully_qualified": "1f3ca-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-1f3fd-200d-2642",
			"output": "1f3ca-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-1f3fd-200d-2642-fe0f",
				"1f3ca-1f3fd-200d-2642",
				"1f3ca-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fd-200d-2642-fe0f",
				"1f3ca-1f3fd-200d-2642",
				"1f3ca-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fc-2642": {
		"name": "man swimming: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1432,
		"display": 0,
		"shortname": ":man_swimming_tone2:",
		"shortname_alternates": [
			":man_swimming_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fc-2642",
			"fully_qualified": "1f3ca-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-1f3fc-200d-2642",
			"output": "1f3ca-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-1f3fc-200d-2642-fe0f",
				"1f3ca-1f3fc-200d-2642",
				"1f3ca-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fc-200d-2642-fe0f",
				"1f3ca-1f3fc-200d-2642",
				"1f3ca-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"swim"
		]
	},
	"1f3ca-1f3fb-2642": {
		"name": "man swimming: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1433,
		"display": 0,
		"shortname": ":man_swimming_tone1:",
		"shortname_alternates": [
			":man_swimming_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f3ca-1f3fb-2642",
			"fully_qualified": "1f3ca-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f3ca-1f3fb-200d-2642",
			"output": "1f3ca-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f3ca-1f3fb-200d-2642-fe0f",
				"1f3ca-1f3fb-200d-2642",
				"1f3ca-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f3ca-1f3fb-200d-2642-fe0f",
				"1f3ca-1f3fb-200d-2642",
				"1f3ca-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"swim"
		]
	},
	"1f93d-2640": {
		"name": "woman playing water polo",
		"unicode_version": 9,
		"category": "activity",
		"order": 1434,
		"display": 1,
		"shortname": ":woman_playing_water_polo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93d-1f3fb-2640",
			"1f93d-1f3fc-2640",
			"1f93d-1f3fd-2640",
			"1f93d-1f3fe-2640",
			"1f93d-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-2640",
			"fully_qualified": "1f93d-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-200d-2640",
			"output": "1f93d-200d-2640-fe0f",
			"default_matches": [
				"1f93d-200d-2640-fe0f",
				"1f93d-200d-2640",
				"1f93d-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-200d-2640-fe0f",
				"1f93d-200d-2640",
				"1f93d-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"water polo",
			"woman"
		]
	},
	"1f93d-1f3fb-2640": {
		"name": "woman playing water polo: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1435,
		"display": 1,
		"shortname": ":woman_playing_water_polo_tone1:",
		"shortname_alternates": [
			":woman_playing_water_polo_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fb-2640",
			"fully_qualified": "1f93d-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-1f3fb-200d-2640",
			"output": "1f93d-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f93d-1f3fb-200d-2640-fe0f",
				"1f93d-1f3fb-200d-2640",
				"1f93d-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fb-200d-2640-fe0f",
				"1f93d-1f3fb-200d-2640",
				"1f93d-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"water polo",
			"woman"
		]
	},
	"1f93d-1f3fc-2640": {
		"name": "woman playing water polo: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1436,
		"display": 1,
		"shortname": ":woman_playing_water_polo_tone2:",
		"shortname_alternates": [
			":woman_playing_water_polo_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fc-2640",
			"fully_qualified": "1f93d-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-1f3fc-200d-2640",
			"output": "1f93d-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f93d-1f3fc-200d-2640-fe0f",
				"1f93d-1f3fc-200d-2640",
				"1f93d-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fc-200d-2640-fe0f",
				"1f93d-1f3fc-200d-2640",
				"1f93d-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"water polo",
			"woman"
		]
	},
	"1f93d-1f3fd-2640": {
		"name": "woman playing water polo: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1437,
		"display": 1,
		"shortname": ":woman_playing_water_polo_tone3:",
		"shortname_alternates": [
			":woman_playing_water_polo_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fd-2640",
			"fully_qualified": "1f93d-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-1f3fd-200d-2640",
			"output": "1f93d-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f93d-1f3fd-200d-2640-fe0f",
				"1f93d-1f3fd-200d-2640",
				"1f93d-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fd-200d-2640-fe0f",
				"1f93d-1f3fd-200d-2640",
				"1f93d-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"water polo",
			"woman"
		]
	},
	"1f93d-1f3fe-2640": {
		"name": "woman playing water polo: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1438,
		"display": 1,
		"shortname": ":woman_playing_water_polo_tone4:",
		"shortname_alternates": [
			":woman_playing_water_polo_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fe-2640",
			"fully_qualified": "1f93d-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-1f3fe-200d-2640",
			"output": "1f93d-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f93d-1f3fe-200d-2640-fe0f",
				"1f93d-1f3fe-200d-2640",
				"1f93d-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fe-200d-2640-fe0f",
				"1f93d-1f3fe-200d-2640",
				"1f93d-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"water polo",
			"woman"
		]
	},
	"1f93d-1f3ff-2640": {
		"name": "woman playing water polo: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1439,
		"display": 1,
		"shortname": ":woman_playing_water_polo_tone5:",
		"shortname_alternates": [
			":woman_playing_water_polo_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3ff-2640",
			"fully_qualified": "1f93d-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f93d-1f3ff-200d-2640",
			"output": "1f93d-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f93d-1f3ff-200d-2640-fe0f",
				"1f93d-1f3ff-200d-2640",
				"1f93d-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3ff-200d-2640-fe0f",
				"1f93d-1f3ff-200d-2640",
				"1f93d-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"water polo",
			"woman"
		]
	},
	"1f93d-2642": {
		"name": "man playing water polo",
		"unicode_version": 9,
		"category": "activity",
		"order": 1440,
		"display": 1,
		"shortname": ":man_playing_water_polo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93d-1f3fb-2642",
			"1f93d-1f3fc-2642",
			"1f93d-1f3fd-2642",
			"1f93d-1f3fe-2642",
			"1f93d-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-2642",
			"fully_qualified": "1f93d-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-200d-2642",
			"output": "1f93d-200d-2642-fe0f",
			"default_matches": [
				"1f93d-200d-2642-fe0f",
				"1f93d-200d-2642",
				"1f93d-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-200d-2642-fe0f",
				"1f93d-200d-2642",
				"1f93d-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"water polo"
		]
	},
	"1f93d-1f3fb-2642": {
		"name": "man playing water polo: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1441,
		"display": 1,
		"shortname": ":man_playing_water_polo_tone1:",
		"shortname_alternates": [
			":man_playing_water_polo_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fb-2642",
			"fully_qualified": "1f93d-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-1f3fb-200d-2642",
			"output": "1f93d-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f93d-1f3fb-200d-2642-fe0f",
				"1f93d-1f3fb-200d-2642",
				"1f93d-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fb-200d-2642-fe0f",
				"1f93d-1f3fb-200d-2642",
				"1f93d-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"man",
			"water polo"
		]
	},
	"1f93d-1f3fc-2642": {
		"name": "man playing water polo: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1442,
		"display": 1,
		"shortname": ":man_playing_water_polo_tone2:",
		"shortname_alternates": [
			":man_playing_water_polo_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fc-2642",
			"fully_qualified": "1f93d-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-1f3fc-200d-2642",
			"output": "1f93d-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f93d-1f3fc-200d-2642-fe0f",
				"1f93d-1f3fc-200d-2642",
				"1f93d-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fc-200d-2642-fe0f",
				"1f93d-1f3fc-200d-2642",
				"1f93d-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-light skin tone",
			"water polo"
		]
	},
	"1f93d-1f3fd-2642": {
		"name": "man playing water polo: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1443,
		"display": 1,
		"shortname": ":man_playing_water_polo_tone3:",
		"shortname_alternates": [
			":man_playing_water_polo_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fd-2642",
			"fully_qualified": "1f93d-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-1f3fd-200d-2642",
			"output": "1f93d-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f93d-1f3fd-200d-2642-fe0f",
				"1f93d-1f3fd-200d-2642",
				"1f93d-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fd-200d-2642-fe0f",
				"1f93d-1f3fd-200d-2642",
				"1f93d-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium skin tone",
			"water polo"
		]
	},
	"1f93d-1f3fe-2642": {
		"name": "man playing water polo: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1444,
		"display": 1,
		"shortname": ":man_playing_water_polo_tone4:",
		"shortname_alternates": [
			":man_playing_water_polo_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3fe-2642",
			"fully_qualified": "1f93d-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-1f3fe-200d-2642",
			"output": "1f93d-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f93d-1f3fe-200d-2642-fe0f",
				"1f93d-1f3fe-200d-2642",
				"1f93d-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3fe-200d-2642-fe0f",
				"1f93d-1f3fe-200d-2642",
				"1f93d-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"man",
			"medium-dark skin tone",
			"water polo"
		]
	},
	"1f93d-1f3ff-2642": {
		"name": "man playing water polo: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1445,
		"display": 1,
		"shortname": ":man_playing_water_polo_tone5:",
		"shortname_alternates": [
			":man_playing_water_polo_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f93d-1f3ff-2642",
			"fully_qualified": "1f93d-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f93d-1f3ff-200d-2642",
			"output": "1f93d-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f93d-1f3ff-200d-2642-fe0f",
				"1f93d-1f3ff-200d-2642",
				"1f93d-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f93d-1f3ff-200d-2642-fe0f",
				"1f93d-1f3ff-200d-2642",
				"1f93d-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"man",
			"water polo"
		]
	},
	"1f93d": {
		"name": "person playing water polo",
		"unicode_version": 9,
		"category": "activity",
		"order": 1446,
		"display": 0,
		"shortname": ":person_playing_water_polo:",
		"shortname_alternates": [
			":water_polo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f93d-1f3fb",
			"1f93d-1f3fc",
			"1f93d-1f3fd",
			"1f93d-1f3fe",
			"1f93d-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f93d-2642",
			"1f93d-2640"
		],
		"code_points": {
			"base": "1f93d",
			"fully_qualified": "1f93d",
			"non_fully_qualified": "1f93d",
			"output": "1f93d",
			"default_matches": [
				"1f93d"
			],
			"greedy_matches": [
				"1f93d"
			],
			"decimal": ""
		},
		"keywords": [
			"polo",
			"water"
		]
	},
	"1f93d-1f3fb": {
		"name": "person playing water polo: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1447,
		"display": 0,
		"shortname": ":person_playing_water_polo_tone1:",
		"shortname_alternates": [
			":water_polo_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93d-1f3fb-2642",
			"1f93d-1f3fb-2640"
		],
		"code_points": {
			"base": "1f93d-1f3fb",
			"fully_qualified": "1f93d-1f3fb",
			"non_fully_qualified": "1f93d-1f3fb",
			"output": "1f93d-1f3fb",
			"default_matches": [
				"1f93d-1f3fb"
			],
			"greedy_matches": [
				"1f93d-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"polo",
			"water"
		]
	},
	"1f93d-1f3fc": {
		"name": "person playing water polo: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1448,
		"display": 0,
		"shortname": ":person_playing_water_polo_tone2:",
		"shortname_alternates": [
			":water_polo_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93d-1f3fc-2642",
			"1f93d-1f3fc-2640"
		],
		"code_points": {
			"base": "1f93d-1f3fc",
			"fully_qualified": "1f93d-1f3fc",
			"non_fully_qualified": "1f93d-1f3fc",
			"output": "1f93d-1f3fc",
			"default_matches": [
				"1f93d-1f3fc"
			],
			"greedy_matches": [
				"1f93d-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"polo",
			"water"
		]
	},
	"1f93d-1f3fd": {
		"name": "person playing water polo: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1449,
		"display": 0,
		"shortname": ":person_playing_water_polo_tone3:",
		"shortname_alternates": [
			":water_polo_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93d-1f3fd-2642",
			"1f93d-1f3fd-2640"
		],
		"code_points": {
			"base": "1f93d-1f3fd",
			"fully_qualified": "1f93d-1f3fd",
			"non_fully_qualified": "1f93d-1f3fd",
			"output": "1f93d-1f3fd",
			"default_matches": [
				"1f93d-1f3fd"
			],
			"greedy_matches": [
				"1f93d-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"polo",
			"water"
		]
	},
	"1f93d-1f3fe": {
		"name": "person playing water polo: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1450,
		"display": 0,
		"shortname": ":person_playing_water_polo_tone4:",
		"shortname_alternates": [
			":water_polo_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93d-1f3fe-2642",
			"1f93d-1f3fe-2640"
		],
		"code_points": {
			"base": "1f93d-1f3fe",
			"fully_qualified": "1f93d-1f3fe",
			"non_fully_qualified": "1f93d-1f3fe",
			"output": "1f93d-1f3fe",
			"default_matches": [
				"1f93d-1f3fe"
			],
			"greedy_matches": [
				"1f93d-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"polo",
			"water"
		]
	},
	"1f93d-1f3ff": {
		"name": "person playing water polo: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1451,
		"display": 0,
		"shortname": ":person_playing_water_polo_tone5:",
		"shortname_alternates": [
			":water_polo_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f93d-1f3ff-2642",
			"1f93d-1f3ff-2640"
		],
		"code_points": {
			"base": "1f93d-1f3ff",
			"fully_qualified": "1f93d-1f3ff",
			"non_fully_qualified": "1f93d-1f3ff",
			"output": "1f93d-1f3ff",
			"default_matches": [
				"1f93d-1f3ff"
			],
			"greedy_matches": [
				"1f93d-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"polo",
			"water"
		]
	},
	"1f6a3-2640": {
		"name": "woman rowing boat",
		"unicode_version": 6,
		"category": "activity",
		"order": 1452,
		"display": 1,
		"shortname": ":woman_rowing_boat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6a3-1f3fb-2640",
			"1f6a3-1f3fc-2640",
			"1f6a3-1f3fd-2640",
			"1f6a3-1f3fe-2640",
			"1f6a3-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-2640",
			"fully_qualified": "1f6a3-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-200d-2640",
			"output": "1f6a3-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-200d-2640-fe0f",
				"1f6a3-200d-2640",
				"1f6a3-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-200d-2640-fe0f",
				"1f6a3-200d-2640",
				"1f6a3-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"rowboat",
			"woman"
		]
	},
	"1f6a3-1f3fb-2640": {
		"name": "woman rowing boat: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1453,
		"display": 1,
		"shortname": ":woman_rowing_boat_tone1:",
		"shortname_alternates": [
			":woman_rowing_boat_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fb-2640",
			"fully_qualified": "1f6a3-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-1f3fb-200d-2640",
			"output": "1f6a3-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-1f3fb-200d-2640-fe0f",
				"1f6a3-1f3fb-200d-2640",
				"1f6a3-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fb-200d-2640-fe0f",
				"1f6a3-1f3fb-200d-2640",
				"1f6a3-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"light skin tone",
			"rowboat",
			"woman"
		]
	},
	"1f6a3-1f3fc-2640": {
		"name": "woman rowing boat: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1454,
		"display": 1,
		"shortname": ":woman_rowing_boat_tone2:",
		"shortname_alternates": [
			":woman_rowing_boat_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fc-2640",
			"fully_qualified": "1f6a3-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-1f3fc-200d-2640",
			"output": "1f6a3-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-1f3fc-200d-2640-fe0f",
				"1f6a3-1f3fc-200d-2640",
				"1f6a3-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fc-200d-2640-fe0f",
				"1f6a3-1f3fc-200d-2640",
				"1f6a3-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium-light skin tone",
			"rowboat",
			"woman"
		]
	},
	"1f6a3-1f3fd-2640": {
		"name": "woman rowing boat: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1455,
		"display": 1,
		"shortname": ":woman_rowing_boat_tone3:",
		"shortname_alternates": [
			":woman_rowing_boat_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fd-2640",
			"fully_qualified": "1f6a3-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-1f3fd-200d-2640",
			"output": "1f6a3-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-1f3fd-200d-2640-fe0f",
				"1f6a3-1f3fd-200d-2640",
				"1f6a3-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fd-200d-2640-fe0f",
				"1f6a3-1f3fd-200d-2640",
				"1f6a3-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium skin tone",
			"rowboat",
			"woman"
		]
	},
	"1f6a3-1f3fe-2640": {
		"name": "woman rowing boat: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1456,
		"display": 1,
		"shortname": ":woman_rowing_boat_tone4:",
		"shortname_alternates": [
			":woman_rowing_boat_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fe-2640",
			"fully_qualified": "1f6a3-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-1f3fe-200d-2640",
			"output": "1f6a3-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-1f3fe-200d-2640-fe0f",
				"1f6a3-1f3fe-200d-2640",
				"1f6a3-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fe-200d-2640-fe0f",
				"1f6a3-1f3fe-200d-2640",
				"1f6a3-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium-dark skin tone",
			"rowboat",
			"woman"
		]
	},
	"1f6a3-1f3ff-2640": {
		"name": "woman rowing boat: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1457,
		"display": 1,
		"shortname": ":woman_rowing_boat_tone5:",
		"shortname_alternates": [
			":woman_rowing_boat_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3ff-2640",
			"fully_qualified": "1f6a3-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f6a3-1f3ff-200d-2640",
			"output": "1f6a3-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f6a3-1f3ff-200d-2640-fe0f",
				"1f6a3-1f3ff-200d-2640",
				"1f6a3-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3ff-200d-2640-fe0f",
				"1f6a3-1f3ff-200d-2640",
				"1f6a3-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"dark skin tone",
			"rowboat",
			"woman"
		]
	},
	"1f6a3": {
		"name": "person rowing boat",
		"unicode_version": 6,
		"category": "activity",
		"order": 1458,
		"display": 1,
		"shortname": ":person_rowing_boat:",
		"shortname_alternates": [
			":rowboat:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6a3-1f3fb",
			"1f6a3-1f3fc",
			"1f6a3-1f3fd",
			"1f6a3-1f3fe",
			"1f6a3-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f6a3-2642",
			"1f6a3-2640"
		],
		"code_points": {
			"base": "1f6a3",
			"fully_qualified": "1f6a3",
			"non_fully_qualified": "1f6a3",
			"output": "1f6a3",
			"default_matches": [
				"1f6a3"
			],
			"greedy_matches": [
				"1f6a3"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"rowboat"
		]
	},
	"1f6a3-1f3fb": {
		"name": "person rowing boat: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1459,
		"display": 1,
		"shortname": ":person_rowing_boat_tone1:",
		"shortname_alternates": [
			":rowboat_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6a3-1f3fb-2642",
			"1f6a3-1f3fb-2640"
		],
		"code_points": {
			"base": "1f6a3-1f3fb",
			"fully_qualified": "1f6a3-1f3fb",
			"non_fully_qualified": "1f6a3-1f3fb",
			"output": "1f6a3-1f3fb",
			"default_matches": [
				"1f6a3-1f3fb"
			],
			"greedy_matches": [
				"1f6a3-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"light skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fc": {
		"name": "person rowing boat: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1460,
		"display": 1,
		"shortname": ":person_rowing_boat_tone2:",
		"shortname_alternates": [
			":rowboat_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6a3-1f3fc-2642",
			"1f6a3-1f3fc-2640"
		],
		"code_points": {
			"base": "1f6a3-1f3fc",
			"fully_qualified": "1f6a3-1f3fc",
			"non_fully_qualified": "1f6a3-1f3fc",
			"output": "1f6a3-1f3fc",
			"default_matches": [
				"1f6a3-1f3fc"
			],
			"greedy_matches": [
				"1f6a3-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium-light skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fd": {
		"name": "person rowing boat: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1461,
		"display": 1,
		"shortname": ":person_rowing_boat_tone3:",
		"shortname_alternates": [
			":rowboat_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6a3-1f3fd-2642",
			"1f6a3-1f3fd-2640"
		],
		"code_points": {
			"base": "1f6a3-1f3fd",
			"fully_qualified": "1f6a3-1f3fd",
			"non_fully_qualified": "1f6a3-1f3fd",
			"output": "1f6a3-1f3fd",
			"default_matches": [
				"1f6a3-1f3fd"
			],
			"greedy_matches": [
				"1f6a3-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fe": {
		"name": "person rowing boat: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1462,
		"display": 1,
		"shortname": ":person_rowing_boat_tone4:",
		"shortname_alternates": [
			":rowboat_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6a3-1f3fe-2642",
			"1f6a3-1f3fe-2640"
		],
		"code_points": {
			"base": "1f6a3-1f3fe",
			"fully_qualified": "1f6a3-1f3fe",
			"non_fully_qualified": "1f6a3-1f3fe",
			"output": "1f6a3-1f3fe",
			"default_matches": [
				"1f6a3-1f3fe"
			],
			"greedy_matches": [
				"1f6a3-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"medium-dark skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3ff": {
		"name": "person rowing boat: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1463,
		"display": 1,
		"shortname": ":person_rowing_boat_tone5:",
		"shortname_alternates": [
			":rowboat_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6a3-1f3ff-2642",
			"1f6a3-1f3ff-2640"
		],
		"code_points": {
			"base": "1f6a3-1f3ff",
			"fully_qualified": "1f6a3-1f3ff",
			"non_fully_qualified": "1f6a3-1f3ff",
			"output": "1f6a3-1f3ff",
			"default_matches": [
				"1f6a3-1f3ff"
			],
			"greedy_matches": [
				"1f6a3-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"dark skin tone",
			"rowboat"
		]
	},
	"1f6a3-2642": {
		"name": "man rowing boat",
		"unicode_version": 6,
		"category": "activity",
		"order": 1464,
		"display": 0,
		"shortname": ":man_rowing_boat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6a3-1f3fb-2642",
			"1f6a3-1f3fc-2642",
			"1f6a3-1f3fd-2642",
			"1f6a3-1f3fe-2642",
			"1f6a3-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-2642",
			"fully_qualified": "1f6a3-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-200d-2642",
			"output": "1f6a3-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-200d-2642-fe0f",
				"1f6a3-200d-2642",
				"1f6a3-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-200d-2642-fe0f",
				"1f6a3-200d-2642",
				"1f6a3-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"man",
			"rowboat"
		]
	},
	"1f6a3-1f3ff-2642": {
		"name": "man rowing boat: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1465,
		"display": 0,
		"shortname": ":man_rowing_boat_tone5:",
		"shortname_alternates": [
			":man_rowing_boat_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3ff-2642",
			"fully_qualified": "1f6a3-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-1f3ff-200d-2642",
			"output": "1f6a3-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-1f3ff-200d-2642-fe0f",
				"1f6a3-1f3ff-200d-2642",
				"1f6a3-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3ff-200d-2642-fe0f",
				"1f6a3-1f3ff-200d-2642",
				"1f6a3-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"dark skin tone",
			"man",
			"rowboat"
		]
	},
	"1f6a3-1f3fe-2642": {
		"name": "man rowing boat: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1466,
		"display": 0,
		"shortname": ":man_rowing_boat_tone4:",
		"shortname_alternates": [
			":man_rowing_boat_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fe-2642",
			"fully_qualified": "1f6a3-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-1f3fe-200d-2642",
			"output": "1f6a3-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-1f3fe-200d-2642-fe0f",
				"1f6a3-1f3fe-200d-2642",
				"1f6a3-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fe-200d-2642-fe0f",
				"1f6a3-1f3fe-200d-2642",
				"1f6a3-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"man",
			"medium-dark skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fd-2642": {
		"name": "man rowing boat: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1467,
		"display": 0,
		"shortname": ":man_rowing_boat_tone3:",
		"shortname_alternates": [
			":man_rowing_boat_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fd-2642",
			"fully_qualified": "1f6a3-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-1f3fd-200d-2642",
			"output": "1f6a3-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-1f3fd-200d-2642-fe0f",
				"1f6a3-1f3fd-200d-2642",
				"1f6a3-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fd-200d-2642-fe0f",
				"1f6a3-1f3fd-200d-2642",
				"1f6a3-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"man",
			"medium skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fc-2642": {
		"name": "man rowing boat: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1468,
		"display": 0,
		"shortname": ":man_rowing_boat_tone2:",
		"shortname_alternates": [
			":man_rowing_boat_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fc-2642",
			"fully_qualified": "1f6a3-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-1f3fc-200d-2642",
			"output": "1f6a3-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-1f3fc-200d-2642-fe0f",
				"1f6a3-1f3fc-200d-2642",
				"1f6a3-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fc-200d-2642-fe0f",
				"1f6a3-1f3fc-200d-2642",
				"1f6a3-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"man",
			"medium-light skin tone",
			"rowboat"
		]
	},
	"1f6a3-1f3fb-2642": {
		"name": "man rowing boat: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1469,
		"display": 0,
		"shortname": ":man_rowing_boat_tone1:",
		"shortname_alternates": [
			":man_rowing_boat_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6a3-1f3fb-2642",
			"fully_qualified": "1f6a3-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f6a3-1f3fb-200d-2642",
			"output": "1f6a3-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f6a3-1f3fb-200d-2642-fe0f",
				"1f6a3-1f3fb-200d-2642",
				"1f6a3-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f6a3-1f3fb-200d-2642-fe0f",
				"1f6a3-1f3fb-200d-2642",
				"1f6a3-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"light skin tone",
			"man",
			"rowboat"
		]
	},
	"1f3c7": {
		"name": "horse racing",
		"unicode_version": 6,
		"category": "activity",
		"order": 1470,
		"display": 1,
		"shortname": ":horse_racing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f3c7-1f3fb",
			"1f3c7-1f3fc",
			"1f3c7-1f3fd",
			"1f3c7-1f3fe",
			"1f3c7-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7",
			"fully_qualified": "1f3c7",
			"non_fully_qualified": "1f3c7",
			"output": "1f3c7",
			"default_matches": [
				"1f3c7"
			],
			"greedy_matches": [
				"1f3c7"
			],
			"decimal": ""
		},
		"keywords": [
			"horse",
			"jockey",
			"racehorse",
			"racing"
		]
	},
	"1f3c7-1f3fb": {
		"name": "horse racing: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1471,
		"display": 1,
		"shortname": ":horse_racing_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7-1f3fb",
			"fully_qualified": "1f3c7-1f3fb",
			"non_fully_qualified": "1f3c7-1f3fb",
			"output": "1f3c7-1f3fb",
			"default_matches": [
				"1f3c7-1f3fb"
			],
			"greedy_matches": [
				"1f3c7-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"horse",
			"jockey",
			"light skin tone",
			"racehorse",
			"racing"
		]
	},
	"1f3c7-1f3fc": {
		"name": "horse racing: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1472,
		"display": 1,
		"shortname": ":horse_racing_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7-1f3fc",
			"fully_qualified": "1f3c7-1f3fc",
			"non_fully_qualified": "1f3c7-1f3fc",
			"output": "1f3c7-1f3fc",
			"default_matches": [
				"1f3c7-1f3fc"
			],
			"greedy_matches": [
				"1f3c7-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"horse",
			"jockey",
			"medium-light skin tone",
			"racehorse",
			"racing"
		]
	},
	"1f3c7-1f3fd": {
		"name": "horse racing: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1473,
		"display": 1,
		"shortname": ":horse_racing_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7-1f3fd",
			"fully_qualified": "1f3c7-1f3fd",
			"non_fully_qualified": "1f3c7-1f3fd",
			"output": "1f3c7-1f3fd",
			"default_matches": [
				"1f3c7-1f3fd"
			],
			"greedy_matches": [
				"1f3c7-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"horse",
			"jockey",
			"medium skin tone",
			"racehorse",
			"racing"
		]
	},
	"1f3c7-1f3fe": {
		"name": "horse racing: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1474,
		"display": 1,
		"shortname": ":horse_racing_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7-1f3fe",
			"fully_qualified": "1f3c7-1f3fe",
			"non_fully_qualified": "1f3c7-1f3fe",
			"output": "1f3c7-1f3fe",
			"default_matches": [
				"1f3c7-1f3fe"
			],
			"greedy_matches": [
				"1f3c7-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"horse",
			"jockey",
			"medium-dark skin tone",
			"racehorse",
			"racing"
		]
	},
	"1f3c7-1f3ff": {
		"name": "horse racing: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1475,
		"display": 1,
		"shortname": ":horse_racing_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c7-1f3ff",
			"fully_qualified": "1f3c7-1f3ff",
			"non_fully_qualified": "1f3c7-1f3ff",
			"output": "1f3c7-1f3ff",
			"default_matches": [
				"1f3c7-1f3ff"
			],
			"greedy_matches": [
				"1f3c7-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"horse",
			"jockey",
			"racehorse",
			"racing"
		]
	},
	"1f6b4-2640": {
		"name": "woman biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1476,
		"display": 1,
		"shortname": ":woman_biking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b4-1f3fb-2640",
			"1f6b4-1f3fc-2640",
			"1f6b4-1f3fd-2640",
			"1f6b4-1f3fe-2640",
			"1f6b4-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-2640",
			"fully_qualified": "1f6b4-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-200d-2640",
			"output": "1f6b4-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-200d-2640-fe0f",
				"1f6b4-200d-2640",
				"1f6b4-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-200d-2640-fe0f",
				"1f6b4-200d-2640",
				"1f6b4-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"woman"
		]
	},
	"1f6b4-1f3fb-2640": {
		"name": "woman biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1477,
		"display": 1,
		"shortname": ":woman_biking_tone1:",
		"shortname_alternates": [
			":woman_biking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fb-2640",
			"fully_qualified": "1f6b4-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-1f3fb-200d-2640",
			"output": "1f6b4-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-1f3fb-200d-2640-fe0f",
				"1f6b4-1f3fb-200d-2640",
				"1f6b4-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fb-200d-2640-fe0f",
				"1f6b4-1f3fb-200d-2640",
				"1f6b4-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"light skin tone",
			"woman"
		]
	},
	"1f6b4-1f3fc-2640": {
		"name": "woman biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1478,
		"display": 1,
		"shortname": ":woman_biking_tone2:",
		"shortname_alternates": [
			":woman_biking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fc-2640",
			"fully_qualified": "1f6b4-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-1f3fc-200d-2640",
			"output": "1f6b4-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-1f3fc-200d-2640-fe0f",
				"1f6b4-1f3fc-200d-2640",
				"1f6b4-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fc-200d-2640-fe0f",
				"1f6b4-1f3fc-200d-2640",
				"1f6b4-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium-light skin tone",
			"woman"
		]
	},
	"1f6b4-1f3fd-2640": {
		"name": "woman biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1479,
		"display": 1,
		"shortname": ":woman_biking_tone3:",
		"shortname_alternates": [
			":woman_biking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fd-2640",
			"fully_qualified": "1f6b4-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-1f3fd-200d-2640",
			"output": "1f6b4-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-1f3fd-200d-2640-fe0f",
				"1f6b4-1f3fd-200d-2640",
				"1f6b4-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fd-200d-2640-fe0f",
				"1f6b4-1f3fd-200d-2640",
				"1f6b4-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium skin tone",
			"woman"
		]
	},
	"1f6b4-1f3fe-2640": {
		"name": "woman biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1480,
		"display": 1,
		"shortname": ":woman_biking_tone4:",
		"shortname_alternates": [
			":woman_biking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fe-2640",
			"fully_qualified": "1f6b4-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-1f3fe-200d-2640",
			"output": "1f6b4-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-1f3fe-200d-2640-fe0f",
				"1f6b4-1f3fe-200d-2640",
				"1f6b4-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fe-200d-2640-fe0f",
				"1f6b4-1f3fe-200d-2640",
				"1f6b4-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium-dark skin tone",
			"woman"
		]
	},
	"1f6b4-1f3ff-2640": {
		"name": "woman biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1481,
		"display": 1,
		"shortname": ":woman_biking_tone5:",
		"shortname_alternates": [
			":woman_biking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3ff-2640",
			"fully_qualified": "1f6b4-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f6b4-1f3ff-200d-2640",
			"output": "1f6b4-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f6b4-1f3ff-200d-2640-fe0f",
				"1f6b4-1f3ff-200d-2640",
				"1f6b4-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3ff-200d-2640-fe0f",
				"1f6b4-1f3ff-200d-2640",
				"1f6b4-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"dark skin tone",
			"woman"
		]
	},
	"1f6b4": {
		"name": "person biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1482,
		"display": 1,
		"shortname": ":person_biking:",
		"shortname_alternates": [
			":bicyclist:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b4-1f3fb",
			"1f6b4-1f3fc",
			"1f6b4-1f3fd",
			"1f6b4-1f3fe",
			"1f6b4-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f6b4-2642",
			"1f6b4-2640"
		],
		"code_points": {
			"base": "1f6b4",
			"fully_qualified": "1f6b4",
			"non_fully_qualified": "1f6b4",
			"output": "1f6b4",
			"default_matches": [
				"1f6b4"
			],
			"greedy_matches": [
				"1f6b4"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist"
		]
	},
	"1f6b4-1f3fb": {
		"name": "person biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1483,
		"display": 1,
		"shortname": ":person_biking_tone1:",
		"shortname_alternates": [
			":bicyclist_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b4-1f3fb-2642",
			"1f6b4-1f3fb-2640"
		],
		"code_points": {
			"base": "1f6b4-1f3fb",
			"fully_qualified": "1f6b4-1f3fb",
			"non_fully_qualified": "1f6b4-1f3fb",
			"output": "1f6b4-1f3fb",
			"default_matches": [
				"1f6b4-1f3fb"
			],
			"greedy_matches": [
				"1f6b4-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"light skin tone"
		]
	},
	"1f6b4-1f3fc": {
		"name": "person biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1484,
		"display": 1,
		"shortname": ":person_biking_tone2:",
		"shortname_alternates": [
			":bicyclist_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b4-1f3fc-2642",
			"1f6b4-1f3fc-2640"
		],
		"code_points": {
			"base": "1f6b4-1f3fc",
			"fully_qualified": "1f6b4-1f3fc",
			"non_fully_qualified": "1f6b4-1f3fc",
			"output": "1f6b4-1f3fc",
			"default_matches": [
				"1f6b4-1f3fc"
			],
			"greedy_matches": [
				"1f6b4-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium-light skin tone"
		]
	},
	"1f6b4-1f3fd": {
		"name": "person biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1485,
		"display": 1,
		"shortname": ":person_biking_tone3:",
		"shortname_alternates": [
			":bicyclist_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b4-1f3fd-2642",
			"1f6b4-1f3fd-2640"
		],
		"code_points": {
			"base": "1f6b4-1f3fd",
			"fully_qualified": "1f6b4-1f3fd",
			"non_fully_qualified": "1f6b4-1f3fd",
			"output": "1f6b4-1f3fd",
			"default_matches": [
				"1f6b4-1f3fd"
			],
			"greedy_matches": [
				"1f6b4-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium skin tone"
		]
	},
	"1f6b4-1f3fe": {
		"name": "person biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1486,
		"display": 1,
		"shortname": ":person_biking_tone4:",
		"shortname_alternates": [
			":bicyclist_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b4-1f3fe-2642",
			"1f6b4-1f3fe-2640"
		],
		"code_points": {
			"base": "1f6b4-1f3fe",
			"fully_qualified": "1f6b4-1f3fe",
			"non_fully_qualified": "1f6b4-1f3fe",
			"output": "1f6b4-1f3fe",
			"default_matches": [
				"1f6b4-1f3fe"
			],
			"greedy_matches": [
				"1f6b4-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"medium-dark skin tone"
		]
	},
	"1f6b4-1f3ff": {
		"name": "person biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1487,
		"display": 1,
		"shortname": ":person_biking_tone5:",
		"shortname_alternates": [
			":bicyclist_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b4-1f3ff-2642",
			"1f6b4-1f3ff-2640"
		],
		"code_points": {
			"base": "1f6b4-1f3ff",
			"fully_qualified": "1f6b4-1f3ff",
			"non_fully_qualified": "1f6b4-1f3ff",
			"output": "1f6b4-1f3ff",
			"default_matches": [
				"1f6b4-1f3ff"
			],
			"greedy_matches": [
				"1f6b4-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"dark skin tone"
		]
	},
	"1f6b4-2642": {
		"name": "man biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1488,
		"display": 0,
		"shortname": ":man_biking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b4-1f3fb-2642",
			"1f6b4-1f3fc-2642",
			"1f6b4-1f3fd-2642",
			"1f6b4-1f3fe-2642",
			"1f6b4-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-2642",
			"fully_qualified": "1f6b4-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-200d-2642",
			"output": "1f6b4-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-200d-2642-fe0f",
				"1f6b4-200d-2642",
				"1f6b4-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-200d-2642-fe0f",
				"1f6b4-200d-2642",
				"1f6b4-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"man"
		]
	},
	"1f6b4-1f3ff-2642": {
		"name": "man biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1489,
		"display": 0,
		"shortname": ":man_biking_tone5:",
		"shortname_alternates": [
			":man_biking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3ff-2642",
			"fully_qualified": "1f6b4-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-1f3ff-200d-2642",
			"output": "1f6b4-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-1f3ff-200d-2642-fe0f",
				"1f6b4-1f3ff-200d-2642",
				"1f6b4-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3ff-200d-2642-fe0f",
				"1f6b4-1f3ff-200d-2642",
				"1f6b4-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"dark skin tone",
			"man"
		]
	},
	"1f6b4-1f3fe-2642": {
		"name": "man biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1490,
		"display": 0,
		"shortname": ":man_biking_tone4:",
		"shortname_alternates": [
			":man_biking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fe-2642",
			"fully_qualified": "1f6b4-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-1f3fe-200d-2642",
			"output": "1f6b4-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-1f3fe-200d-2642-fe0f",
				"1f6b4-1f3fe-200d-2642",
				"1f6b4-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fe-200d-2642-fe0f",
				"1f6b4-1f3fe-200d-2642",
				"1f6b4-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"man",
			"medium-dark skin tone"
		]
	},
	"1f6b4-1f3fd-2642": {
		"name": "man biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1491,
		"display": 0,
		"shortname": ":man_biking_tone3:",
		"shortname_alternates": [
			":man_biking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fd-2642",
			"fully_qualified": "1f6b4-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-1f3fd-200d-2642",
			"output": "1f6b4-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-1f3fd-200d-2642-fe0f",
				"1f6b4-1f3fd-200d-2642",
				"1f6b4-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fd-200d-2642-fe0f",
				"1f6b4-1f3fd-200d-2642",
				"1f6b4-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"man",
			"medium skin tone"
		]
	},
	"1f6b4-1f3fc-2642": {
		"name": "man biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1492,
		"display": 0,
		"shortname": ":man_biking_tone2:",
		"shortname_alternates": [
			":man_biking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fc-2642",
			"fully_qualified": "1f6b4-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-1f3fc-200d-2642",
			"output": "1f6b4-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-1f3fc-200d-2642-fe0f",
				"1f6b4-1f3fc-200d-2642",
				"1f6b4-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fc-200d-2642-fe0f",
				"1f6b4-1f3fc-200d-2642",
				"1f6b4-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"man",
			"medium-light skin tone"
		]
	},
	"1f6b4-1f3fb-2642": {
		"name": "man biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1493,
		"display": 0,
		"shortname": ":man_biking_tone1:",
		"shortname_alternates": [
			":man_biking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b4-1f3fb-2642",
			"fully_qualified": "1f6b4-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f6b4-1f3fb-200d-2642",
			"output": "1f6b4-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f6b4-1f3fb-200d-2642-fe0f",
				"1f6b4-1f3fb-200d-2642",
				"1f6b4-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b4-1f3fb-200d-2642-fe0f",
				"1f6b4-1f3fb-200d-2642",
				"1f6b4-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"biking",
			"cyclist",
			"light skin tone",
			"man"
		]
	},
	"1f6b5-2640": {
		"name": "woman mountain biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1494,
		"display": 1,
		"shortname": ":woman_mountain_biking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b5-1f3fb-2640",
			"1f6b5-1f3fc-2640",
			"1f6b5-1f3fd-2640",
			"1f6b5-1f3fe-2640",
			"1f6b5-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-2640",
			"fully_qualified": "1f6b5-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-200d-2640",
			"output": "1f6b5-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-200d-2640-fe0f",
				"1f6b5-200d-2640",
				"1f6b5-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-200d-2640-fe0f",
				"1f6b5-200d-2640",
				"1f6b5-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"mountain",
			"woman"
		]
	},
	"1f6b5-1f3fb-2640": {
		"name": "woman mountain biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1495,
		"display": 1,
		"shortname": ":woman_mountain_biking_tone1:",
		"shortname_alternates": [
			":woman_mountain_biking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fb-2640",
			"fully_qualified": "1f6b5-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-1f3fb-200d-2640",
			"output": "1f6b5-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-1f3fb-200d-2640-fe0f",
				"1f6b5-1f3fb-200d-2640",
				"1f6b5-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fb-200d-2640-fe0f",
				"1f6b5-1f3fb-200d-2640",
				"1f6b5-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"light skin tone",
			"mountain",
			"woman"
		]
	},
	"1f6b5-1f3fc-2640": {
		"name": "woman mountain biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1496,
		"display": 1,
		"shortname": ":woman_mountain_biking_tone2:",
		"shortname_alternates": [
			":woman_mountain_biking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fc-2640",
			"fully_qualified": "1f6b5-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-1f3fc-200d-2640",
			"output": "1f6b5-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-1f3fc-200d-2640-fe0f",
				"1f6b5-1f3fc-200d-2640",
				"1f6b5-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fc-200d-2640-fe0f",
				"1f6b5-1f3fc-200d-2640",
				"1f6b5-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"medium-light skin tone",
			"mountain",
			"woman"
		]
	},
	"1f6b5-1f3fd-2640": {
		"name": "woman mountain biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1497,
		"display": 1,
		"shortname": ":woman_mountain_biking_tone3:",
		"shortname_alternates": [
			":woman_mountain_biking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fd-2640",
			"fully_qualified": "1f6b5-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-1f3fd-200d-2640",
			"output": "1f6b5-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-1f3fd-200d-2640-fe0f",
				"1f6b5-1f3fd-200d-2640",
				"1f6b5-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fd-200d-2640-fe0f",
				"1f6b5-1f3fd-200d-2640",
				"1f6b5-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"medium skin tone",
			"mountain",
			"woman"
		]
	},
	"1f6b5-1f3fe-2640": {
		"name": "woman mountain biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1498,
		"display": 1,
		"shortname": ":woman_mountain_biking_tone4:",
		"shortname_alternates": [
			":woman_mountain_biking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fe-2640",
			"fully_qualified": "1f6b5-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-1f3fe-200d-2640",
			"output": "1f6b5-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-1f3fe-200d-2640-fe0f",
				"1f6b5-1f3fe-200d-2640",
				"1f6b5-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fe-200d-2640-fe0f",
				"1f6b5-1f3fe-200d-2640",
				"1f6b5-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"medium-dark skin tone",
			"mountain",
			"woman"
		]
	},
	"1f6b5-1f3ff-2640": {
		"name": "woman mountain biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1499,
		"display": 1,
		"shortname": ":woman_mountain_biking_tone5:",
		"shortname_alternates": [
			":woman_mountain_biking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3ff-2640",
			"fully_qualified": "1f6b5-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f6b5-1f3ff-200d-2640",
			"output": "1f6b5-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f6b5-1f3ff-200d-2640-fe0f",
				"1f6b5-1f3ff-200d-2640",
				"1f6b5-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3ff-200d-2640-fe0f",
				"1f6b5-1f3ff-200d-2640",
				"1f6b5-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"biking",
			"cyclist",
			"dark skin tone",
			"mountain",
			"woman"
		]
	},
	"1f6b5": {
		"name": "person mountain biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1500,
		"display": 1,
		"shortname": ":person_mountain_biking:",
		"shortname_alternates": [
			":mountain_bicyclist:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b5-1f3fb",
			"1f6b5-1f3fc",
			"1f6b5-1f3fd",
			"1f6b5-1f3fe",
			"1f6b5-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f6b5-2642",
			"1f6b5-2640"
		],
		"code_points": {
			"base": "1f6b5",
			"fully_qualified": "1f6b5",
			"non_fully_qualified": "1f6b5",
			"output": "1f6b5",
			"default_matches": [
				"1f6b5"
			],
			"greedy_matches": [
				"1f6b5"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"mountain"
		]
	},
	"1f6b5-1f3fb": {
		"name": "person mountain biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1501,
		"display": 1,
		"shortname": ":person_mountain_biking_tone1:",
		"shortname_alternates": [
			":mountain_bicyclist_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b5-1f3fb-2642",
			"1f6b5-1f3fb-2640"
		],
		"code_points": {
			"base": "1f6b5-1f3fb",
			"fully_qualified": "1f6b5-1f3fb",
			"non_fully_qualified": "1f6b5-1f3fb",
			"output": "1f6b5-1f3fb",
			"default_matches": [
				"1f6b5-1f3fb"
			],
			"greedy_matches": [
				"1f6b5-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"light skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fc": {
		"name": "person mountain biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1502,
		"display": 1,
		"shortname": ":person_mountain_biking_tone2:",
		"shortname_alternates": [
			":mountain_bicyclist_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b5-1f3fc-2642",
			"1f6b5-1f3fc-2640"
		],
		"code_points": {
			"base": "1f6b5-1f3fc",
			"fully_qualified": "1f6b5-1f3fc",
			"non_fully_qualified": "1f6b5-1f3fc",
			"output": "1f6b5-1f3fc",
			"default_matches": [
				"1f6b5-1f3fc"
			],
			"greedy_matches": [
				"1f6b5-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"medium-light skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fd": {
		"name": "person mountain biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1503,
		"display": 1,
		"shortname": ":person_mountain_biking_tone3:",
		"shortname_alternates": [
			":mountain_bicyclist_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b5-1f3fd-2642",
			"1f6b5-1f3fd-2640"
		],
		"code_points": {
			"base": "1f6b5-1f3fd",
			"fully_qualified": "1f6b5-1f3fd",
			"non_fully_qualified": "1f6b5-1f3fd",
			"output": "1f6b5-1f3fd",
			"default_matches": [
				"1f6b5-1f3fd"
			],
			"greedy_matches": [
				"1f6b5-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"medium skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fe": {
		"name": "person mountain biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1504,
		"display": 1,
		"shortname": ":person_mountain_biking_tone4:",
		"shortname_alternates": [
			":mountain_bicyclist_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b5-1f3fe-2642",
			"1f6b5-1f3fe-2640"
		],
		"code_points": {
			"base": "1f6b5-1f3fe",
			"fully_qualified": "1f6b5-1f3fe",
			"non_fully_qualified": "1f6b5-1f3fe",
			"output": "1f6b5-1f3fe",
			"default_matches": [
				"1f6b5-1f3fe"
			],
			"greedy_matches": [
				"1f6b5-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"medium-dark skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3ff": {
		"name": "person mountain biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1505,
		"display": 1,
		"shortname": ":person_mountain_biking_tone5:",
		"shortname_alternates": [
			":mountain_bicyclist_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f6b5-1f3ff-2642",
			"1f6b5-1f3ff-2640"
		],
		"code_points": {
			"base": "1f6b5-1f3ff",
			"fully_qualified": "1f6b5-1f3ff",
			"non_fully_qualified": "1f6b5-1f3ff",
			"output": "1f6b5-1f3ff",
			"default_matches": [
				"1f6b5-1f3ff"
			],
			"greedy_matches": [
				"1f6b5-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bicyclist",
			"bike",
			"cyclist",
			"dark skin tone",
			"mountain"
		]
	},
	"1f6b5-2642": {
		"name": "man mountain biking",
		"unicode_version": 6,
		"category": "activity",
		"order": 1506,
		"display": 0,
		"shortname": ":man_mountain_biking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6b5-1f3fb-2642",
			"1f6b5-1f3fc-2642",
			"1f6b5-1f3fd-2642",
			"1f6b5-1f3fe-2642",
			"1f6b5-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-2642",
			"fully_qualified": "1f6b5-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-200d-2642",
			"output": "1f6b5-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-200d-2642-fe0f",
				"1f6b5-200d-2642",
				"1f6b5-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-200d-2642-fe0f",
				"1f6b5-200d-2642",
				"1f6b5-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"man",
			"mountain"
		]
	},
	"1f6b5-1f3ff-2642": {
		"name": "man mountain biking: dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1507,
		"display": 0,
		"shortname": ":man_mountain_biking_tone5:",
		"shortname_alternates": [
			":man_mountain_biking_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3ff-2642",
			"fully_qualified": "1f6b5-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-1f3ff-200d-2642",
			"output": "1f6b5-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-1f3ff-200d-2642-fe0f",
				"1f6b5-1f3ff-200d-2642",
				"1f6b5-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3ff-200d-2642-fe0f",
				"1f6b5-1f3ff-200d-2642",
				"1f6b5-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"dark skin tone",
			"man",
			"mountain"
		]
	},
	"1f6b5-1f3fe-2642": {
		"name": "man mountain biking: medium-dark skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1508,
		"display": 0,
		"shortname": ":man_mountain_biking_tone4:",
		"shortname_alternates": [
			":man_mountain_biking_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fe-2642",
			"fully_qualified": "1f6b5-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-1f3fe-200d-2642",
			"output": "1f6b5-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-1f3fe-200d-2642-fe0f",
				"1f6b5-1f3fe-200d-2642",
				"1f6b5-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fe-200d-2642-fe0f",
				"1f6b5-1f3fe-200d-2642",
				"1f6b5-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"man",
			"medium-dark skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fd-2642": {
		"name": "man mountain biking: medium skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1509,
		"display": 0,
		"shortname": ":man_mountain_biking_tone3:",
		"shortname_alternates": [
			":man_mountain_biking_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fd-2642",
			"fully_qualified": "1f6b5-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-1f3fd-200d-2642",
			"output": "1f6b5-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-1f3fd-200d-2642-fe0f",
				"1f6b5-1f3fd-200d-2642",
				"1f6b5-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fd-200d-2642-fe0f",
				"1f6b5-1f3fd-200d-2642",
				"1f6b5-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"man",
			"medium skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fc-2642": {
		"name": "man mountain biking: medium-light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1510,
		"display": 0,
		"shortname": ":man_mountain_biking_tone2:",
		"shortname_alternates": [
			":man_mountain_biking_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fc-2642",
			"fully_qualified": "1f6b5-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-1f3fc-200d-2642",
			"output": "1f6b5-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-1f3fc-200d-2642-fe0f",
				"1f6b5-1f3fc-200d-2642",
				"1f6b5-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fc-200d-2642-fe0f",
				"1f6b5-1f3fc-200d-2642",
				"1f6b5-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"man",
			"medium-light skin tone",
			"mountain"
		]
	},
	"1f6b5-1f3fb-2642": {
		"name": "man mountain biking: light skin tone",
		"unicode_version": 8,
		"category": "activity",
		"order": 1511,
		"display": 0,
		"shortname": ":man_mountain_biking_tone1:",
		"shortname_alternates": [
			":man_mountain_biking_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f6b5-1f3fb-2642",
			"fully_qualified": "1f6b5-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f6b5-1f3fb-200d-2642",
			"output": "1f6b5-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f6b5-1f3fb-200d-2642-fe0f",
				"1f6b5-1f3fb-200d-2642",
				"1f6b5-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f6b5-1f3fb-200d-2642-fe0f",
				"1f6b5-1f3fb-200d-2642",
				"1f6b5-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"cyclist",
			"light skin tone",
			"man",
			"mountain"
		]
	},
	"1f3bd": {
		"name": "running shirt",
		"unicode_version": 6,
		"category": "activity",
		"order": 1512,
		"display": 1,
		"shortname": ":running_shirt_with_sash:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3bd",
			"fully_qualified": "1f3bd",
			"non_fully_qualified": "1f3bd",
			"output": "1f3bd",
			"default_matches": [
				"1f3bd"
			],
			"greedy_matches": [
				"1f3bd"
			],
			"decimal": ""
		},
		"keywords": [
			"athletics",
			"running",
			"sash",
			"shirt"
		]
	},
	"1f3c5": {
		"name": "sports medal",
		"unicode_version": 7,
		"category": "activity",
		"order": 1513,
		"display": 1,
		"shortname": ":medal:",
		"shortname_alternates": [
			":sports_medal:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c5",
			"fully_qualified": "1f3c5",
			"non_fully_qualified": "1f3c5",
			"output": "1f3c5",
			"default_matches": [
				"1f3c5"
			],
			"greedy_matches": [
				"1f3c5"
			],
			"decimal": ""
		},
		"keywords": [
			"medal"
		]
	},
	"1f396": {
		"name": "military medal",
		"unicode_version": 7,
		"category": "activity",
		"order": 1514,
		"display": 1,
		"shortname": ":military_medal:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f396",
			"fully_qualified": "1f396-fe0f",
			"non_fully_qualified": "1f396",
			"output": "1f396-fe0f",
			"default_matches": [
				"1f396-fe0f",
				"1f396"
			],
			"greedy_matches": [
				"1f396-fe0f",
				"1f396"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"medal",
			"military"
		]
	},
	"1f947": {
		"name": "1st place medal",
		"unicode_version": 9,
		"category": "activity",
		"order": 1515,
		"display": 1,
		"shortname": ":first_place:",
		"shortname_alternates": [
			":first_place_medal:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f947",
			"fully_qualified": "1f947",
			"non_fully_qualified": "1f947",
			"output": "1f947",
			"default_matches": [
				"1f947"
			],
			"greedy_matches": [
				"1f947"
			],
			"decimal": ""
		},
		"keywords": [
			"first",
			"gold",
			"medal"
		]
	},
	"1f948": {
		"name": "2nd place medal",
		"unicode_version": 9,
		"category": "activity",
		"order": 1516,
		"display": 1,
		"shortname": ":second_place:",
		"shortname_alternates": [
			":second_place_medal:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f948",
			"fully_qualified": "1f948",
			"non_fully_qualified": "1f948",
			"output": "1f948",
			"default_matches": [
				"1f948"
			],
			"greedy_matches": [
				"1f948"
			],
			"decimal": ""
		},
		"keywords": [
			"medal",
			"second",
			"silver"
		]
	},
	"1f949": {
		"name": "3rd place medal",
		"unicode_version": 9,
		"category": "activity",
		"order": 1517,
		"display": 1,
		"shortname": ":third_place:",
		"shortname_alternates": [
			":third_place_medal:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f949",
			"fully_qualified": "1f949",
			"non_fully_qualified": "1f949",
			"output": "1f949",
			"default_matches": [
				"1f949"
			],
			"greedy_matches": [
				"1f949"
			],
			"decimal": ""
		},
		"keywords": [
			"bronze",
			"medal",
			"third"
		]
	},
	"1f3c6": {
		"name": "trophy",
		"unicode_version": 6,
		"category": "activity",
		"order": 1518,
		"display": 1,
		"shortname": ":trophy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c6",
			"fully_qualified": "1f3c6",
			"non_fully_qualified": "1f3c6",
			"output": "1f3c6",
			"default_matches": [
				"1f3c6"
			],
			"greedy_matches": [
				"1f3c6"
			],
			"decimal": ""
		},
		"keywords": [
			"prize"
		]
	},
	"1f3f5": {
		"name": "rosette",
		"unicode_version": 7,
		"category": "activity",
		"order": 1519,
		"display": 1,
		"shortname": ":rosette:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f5",
			"fully_qualified": "1f3f5-fe0f",
			"non_fully_qualified": "1f3f5",
			"output": "1f3f5-fe0f",
			"default_matches": [
				"1f3f5-fe0f",
				"1f3f5"
			],
			"greedy_matches": [
				"1f3f5-fe0f",
				"1f3f5"
			],
			"decimal": ""
		},
		"keywords": [
			"plant"
		]
	},
	"1f397": {
		"name": "reminder ribbon",
		"unicode_version": 7,
		"category": "activity",
		"order": 1520,
		"display": 1,
		"shortname": ":reminder_ribbon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f397",
			"fully_qualified": "1f397-fe0f",
			"non_fully_qualified": "1f397",
			"output": "1f397-fe0f",
			"default_matches": [
				"1f397-fe0f",
				"1f397"
			],
			"greedy_matches": [
				"1f397-fe0f",
				"1f397"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"reminder",
			"ribbon"
		]
	},
	"1f3ab": {
		"name": "ticket",
		"unicode_version": 6,
		"category": "activity",
		"order": 1521,
		"display": 1,
		"shortname": ":ticket:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ab",
			"fully_qualified": "1f3ab",
			"non_fully_qualified": "1f3ab",
			"output": "1f3ab",
			"default_matches": [
				"1f3ab"
			],
			"greedy_matches": [
				"1f3ab"
			],
			"decimal": ""
		},
		"keywords": [
			"admission"
		]
	},
	"1f39f": {
		"name": "admission tickets",
		"unicode_version": 7,
		"category": "activity",
		"order": 1522,
		"display": 1,
		"shortname": ":tickets:",
		"shortname_alternates": [
			":admission_tickets:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f39f",
			"fully_qualified": "1f39f-fe0f",
			"non_fully_qualified": "1f39f",
			"output": "1f39f-fe0f",
			"default_matches": [
				"1f39f-fe0f",
				"1f39f"
			],
			"greedy_matches": [
				"1f39f-fe0f",
				"1f39f"
			],
			"decimal": ""
		},
		"keywords": [
			"admission",
			"ticket"
		]
	},
	"1f3aa": {
		"name": "circus tent",
		"unicode_version": 6,
		"category": "activity",
		"order": 1523,
		"display": 1,
		"shortname": ":circus_tent:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3aa",
			"fully_qualified": "1f3aa",
			"non_fully_qualified": "1f3aa",
			"output": "1f3aa",
			"default_matches": [
				"1f3aa"
			],
			"greedy_matches": [
				"1f3aa"
			],
			"decimal": ""
		},
		"keywords": [
			"circus",
			"tent"
		]
	},
	"1f939-2640": {
		"name": "woman juggling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1524,
		"display": 1,
		"shortname": ":woman_juggling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f939-1f3fb-2640",
			"1f939-1f3fc-2640",
			"1f939-1f3fd-2640",
			"1f939-1f3fe-2640",
			"1f939-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-2640",
			"fully_qualified": "1f939-200d-2640-fe0f",
			"non_fully_qualified": "1f939-200d-2640",
			"output": "1f939-200d-2640-fe0f",
			"default_matches": [
				"1f939-200d-2640-fe0f",
				"1f939-200d-2640",
				"1f939-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-200d-2640-fe0f",
				"1f939-200d-2640",
				"1f939-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"multitask",
			"woman"
		]
	},
	"1f939-1f3fb-2640": {
		"name": "woman juggling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1525,
		"display": 1,
		"shortname": ":woman_juggling_tone1:",
		"shortname_alternates": [
			":woman_juggling_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fb-2640",
			"fully_qualified": "1f939-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f939-1f3fb-200d-2640",
			"output": "1f939-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f939-1f3fb-200d-2640-fe0f",
				"1f939-1f3fb-200d-2640",
				"1f939-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fb-200d-2640-fe0f",
				"1f939-1f3fb-200d-2640",
				"1f939-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"light skin tone",
			"multitask",
			"woman"
		]
	},
	"1f939-1f3fc-2640": {
		"name": "woman juggling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1526,
		"display": 1,
		"shortname": ":woman_juggling_tone2:",
		"shortname_alternates": [
			":woman_juggling_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fc-2640",
			"fully_qualified": "1f939-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f939-1f3fc-200d-2640",
			"output": "1f939-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f939-1f3fc-200d-2640-fe0f",
				"1f939-1f3fc-200d-2640",
				"1f939-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fc-200d-2640-fe0f",
				"1f939-1f3fc-200d-2640",
				"1f939-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"medium-light skin tone",
			"multitask",
			"woman"
		]
	},
	"1f939-1f3fd-2640": {
		"name": "woman juggling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1527,
		"display": 1,
		"shortname": ":woman_juggling_tone3:",
		"shortname_alternates": [
			":woman_juggling_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fd-2640",
			"fully_qualified": "1f939-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f939-1f3fd-200d-2640",
			"output": "1f939-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f939-1f3fd-200d-2640-fe0f",
				"1f939-1f3fd-200d-2640",
				"1f939-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fd-200d-2640-fe0f",
				"1f939-1f3fd-200d-2640",
				"1f939-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"medium skin tone",
			"multitask",
			"woman"
		]
	},
	"1f939-1f3fe-2640": {
		"name": "woman juggling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1528,
		"display": 1,
		"shortname": ":woman_juggling_tone4:",
		"shortname_alternates": [
			":woman_juggling_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fe-2640",
			"fully_qualified": "1f939-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f939-1f3fe-200d-2640",
			"output": "1f939-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f939-1f3fe-200d-2640-fe0f",
				"1f939-1f3fe-200d-2640",
				"1f939-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fe-200d-2640-fe0f",
				"1f939-1f3fe-200d-2640",
				"1f939-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"medium-dark skin tone",
			"multitask",
			"woman"
		]
	},
	"1f939-1f3ff-2640": {
		"name": "woman juggling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1529,
		"display": 1,
		"shortname": ":woman_juggling_tone5:",
		"shortname_alternates": [
			":woman_juggling_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3ff-2640",
			"fully_qualified": "1f939-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f939-1f3ff-200d-2640",
			"output": "1f939-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f939-1f3ff-200d-2640-fe0f",
				"1f939-1f3ff-200d-2640",
				"1f939-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3ff-200d-2640-fe0f",
				"1f939-1f3ff-200d-2640",
				"1f939-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"juggling",
			"multitask",
			"woman"
		]
	},
	"1f939-2642": {
		"name": "man juggling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1530,
		"display": 1,
		"shortname": ":man_juggling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f939-1f3fb-2642",
			"1f939-1f3fc-2642",
			"1f939-1f3fd-2642",
			"1f939-1f3fe-2642",
			"1f939-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-2642",
			"fully_qualified": "1f939-200d-2642-fe0f",
			"non_fully_qualified": "1f939-200d-2642",
			"output": "1f939-200d-2642-fe0f",
			"default_matches": [
				"1f939-200d-2642-fe0f",
				"1f939-200d-2642",
				"1f939-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-200d-2642-fe0f",
				"1f939-200d-2642",
				"1f939-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"man",
			"multitask"
		]
	},
	"1f939-1f3fb-2642": {
		"name": "man juggling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1531,
		"display": 1,
		"shortname": ":man_juggling_tone1:",
		"shortname_alternates": [
			":man_juggling_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fb-2642",
			"fully_qualified": "1f939-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f939-1f3fb-200d-2642",
			"output": "1f939-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f939-1f3fb-200d-2642-fe0f",
				"1f939-1f3fb-200d-2642",
				"1f939-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fb-200d-2642-fe0f",
				"1f939-1f3fb-200d-2642",
				"1f939-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"light skin tone",
			"man",
			"multitask"
		]
	},
	"1f939-1f3fc-2642": {
		"name": "man juggling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1532,
		"display": 1,
		"shortname": ":man_juggling_tone2:",
		"shortname_alternates": [
			":man_juggling_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fc-2642",
			"fully_qualified": "1f939-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f939-1f3fc-200d-2642",
			"output": "1f939-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f939-1f3fc-200d-2642-fe0f",
				"1f939-1f3fc-200d-2642",
				"1f939-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fc-200d-2642-fe0f",
				"1f939-1f3fc-200d-2642",
				"1f939-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"man",
			"medium-light skin tone",
			"multitask"
		]
	},
	"1f939-1f3fd-2642": {
		"name": "man juggling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1533,
		"display": 1,
		"shortname": ":man_juggling_tone3:",
		"shortname_alternates": [
			":man_juggling_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fd-2642",
			"fully_qualified": "1f939-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f939-1f3fd-200d-2642",
			"output": "1f939-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f939-1f3fd-200d-2642-fe0f",
				"1f939-1f3fd-200d-2642",
				"1f939-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fd-200d-2642-fe0f",
				"1f939-1f3fd-200d-2642",
				"1f939-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"man",
			"medium skin tone",
			"multitask"
		]
	},
	"1f939-1f3fe-2642": {
		"name": "man juggling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1534,
		"display": 1,
		"shortname": ":man_juggling_tone4:",
		"shortname_alternates": [
			":man_juggling_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3fe-2642",
			"fully_qualified": "1f939-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f939-1f3fe-200d-2642",
			"output": "1f939-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f939-1f3fe-200d-2642-fe0f",
				"1f939-1f3fe-200d-2642",
				"1f939-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3fe-200d-2642-fe0f",
				"1f939-1f3fe-200d-2642",
				"1f939-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"juggling",
			"man",
			"medium-dark skin tone",
			"multitask"
		]
	},
	"1f939-1f3ff-2642": {
		"name": "man juggling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1535,
		"display": 1,
		"shortname": ":man_juggling_tone5:",
		"shortname_alternates": [
			":man_juggling_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f939-1f3ff-2642",
			"fully_qualified": "1f939-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f939-1f3ff-200d-2642",
			"output": "1f939-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f939-1f3ff-200d-2642-fe0f",
				"1f939-1f3ff-200d-2642",
				"1f939-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f939-1f3ff-200d-2642-fe0f",
				"1f939-1f3ff-200d-2642",
				"1f939-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"juggling",
			"man",
			"multitask"
		]
	},
	"1f939": {
		"name": "person juggling",
		"unicode_version": 9,
		"category": "activity",
		"order": 1536,
		"display": 0,
		"shortname": ":person_juggling:",
		"shortname_alternates": [
			":juggling:",
			":juggler:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f939-1f3fb",
			"1f939-1f3fc",
			"1f939-1f3fd",
			"1f939-1f3fe",
			"1f939-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f939-2642",
			"1f939-2640"
		],
		"code_points": {
			"base": "1f939",
			"fully_qualified": "1f939",
			"non_fully_qualified": "1f939",
			"output": "1f939",
			"default_matches": [
				"1f939"
			],
			"greedy_matches": [
				"1f939"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"juggle",
			"multitask",
			"skill"
		]
	},
	"1f939-1f3fb": {
		"name": "person juggling: light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1537,
		"display": 0,
		"shortname": ":person_juggling_tone1:",
		"shortname_alternates": [
			":juggling_tone1:",
			":juggler_tone1:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f939-1f3fb-2642",
			"1f939-1f3fb-2640"
		],
		"code_points": {
			"base": "1f939-1f3fb",
			"fully_qualified": "1f939-1f3fb",
			"non_fully_qualified": "1f939-1f3fb",
			"output": "1f939-1f3fb",
			"default_matches": [
				"1f939-1f3fb"
			],
			"greedy_matches": [
				"1f939-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"juggle",
			"light skin tone",
			"multitask",
			"skill"
		]
	},
	"1f939-1f3fc": {
		"name": "person juggling: medium-light skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1538,
		"display": 0,
		"shortname": ":person_juggling_tone2:",
		"shortname_alternates": [
			":juggling_tone2:",
			":juggler_tone2:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f939-1f3fc-2642",
			"1f939-1f3fc-2640"
		],
		"code_points": {
			"base": "1f939-1f3fc",
			"fully_qualified": "1f939-1f3fc",
			"non_fully_qualified": "1f939-1f3fc",
			"output": "1f939-1f3fc",
			"default_matches": [
				"1f939-1f3fc"
			],
			"greedy_matches": [
				"1f939-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"juggle",
			"medium-light skin tone",
			"multitask",
			"skill"
		]
	},
	"1f939-1f3fd": {
		"name": "person juggling: medium skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1539,
		"display": 0,
		"shortname": ":person_juggling_tone3:",
		"shortname_alternates": [
			":juggling_tone3:",
			":juggler_tone3:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f939-1f3fd-2642",
			"1f939-1f3fd-2640"
		],
		"code_points": {
			"base": "1f939-1f3fd",
			"fully_qualified": "1f939-1f3fd",
			"non_fully_qualified": "1f939-1f3fd",
			"output": "1f939-1f3fd",
			"default_matches": [
				"1f939-1f3fd"
			],
			"greedy_matches": [
				"1f939-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"juggle",
			"medium skin tone",
			"multitask",
			"skill"
		]
	},
	"1f939-1f3fe": {
		"name": "person juggling: medium-dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1540,
		"display": 0,
		"shortname": ":person_juggling_tone4:",
		"shortname_alternates": [
			":juggling_tone4:",
			":juggler_tone4:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f939-1f3fe-2642",
			"1f939-1f3fe-2640"
		],
		"code_points": {
			"base": "1f939-1f3fe",
			"fully_qualified": "1f939-1f3fe",
			"non_fully_qualified": "1f939-1f3fe",
			"output": "1f939-1f3fe",
			"default_matches": [
				"1f939-1f3fe"
			],
			"greedy_matches": [
				"1f939-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"juggle",
			"medium-dark skin tone",
			"multitask",
			"skill"
		]
	},
	"1f939-1f3ff": {
		"name": "person juggling: dark skin tone",
		"unicode_version": 9,
		"category": "activity",
		"order": 1541,
		"display": 0,
		"shortname": ":person_juggling_tone5:",
		"shortname_alternates": [
			":juggling_tone5:",
			":juggler_tone5:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f939-1f3ff-2642",
			"1f939-1f3ff-2640"
		],
		"code_points": {
			"base": "1f939-1f3ff",
			"fully_qualified": "1f939-1f3ff",
			"non_fully_qualified": "1f939-1f3ff",
			"output": "1f939-1f3ff",
			"default_matches": [
				"1f939-1f3ff"
			],
			"greedy_matches": [
				"1f939-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"dark skin tone",
			"juggle",
			"multitask",
			"skill"
		]
	},
	"1f3ad": {
		"name": "performing arts",
		"unicode_version": 6,
		"category": "activity",
		"order": 1542,
		"display": 1,
		"shortname": ":performing_arts:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ad",
			"fully_qualified": "1f3ad",
			"non_fully_qualified": "1f3ad",
			"output": "1f3ad",
			"default_matches": [
				"1f3ad"
			],
			"greedy_matches": [
				"1f3ad"
			],
			"decimal": ""
		},
		"keywords": [
			"art",
			"mask",
			"performing",
			"theater",
			"theatre"
		]
	},
	"1f3a8": {
		"name": "artist palette",
		"unicode_version": 6,
		"category": "activity",
		"order": 1543,
		"display": 1,
		"shortname": ":art:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a8",
			"fully_qualified": "1f3a8",
			"non_fully_qualified": "1f3a8",
			"output": "1f3a8",
			"default_matches": [
				"1f3a8"
			],
			"greedy_matches": [
				"1f3a8"
			],
			"decimal": ""
		},
		"keywords": [
			"art",
			"museum",
			"painting",
			"palette"
		]
	},
	"1f3ac": {
		"name": "clapper board",
		"unicode_version": 6,
		"category": "activity",
		"order": 1544,
		"display": 1,
		"shortname": ":clapper:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ac",
			"fully_qualified": "1f3ac",
			"non_fully_qualified": "1f3ac",
			"output": "1f3ac",
			"default_matches": [
				"1f3ac"
			],
			"greedy_matches": [
				"1f3ac"
			],
			"decimal": ""
		},
		"keywords": [
			"clapper",
			"movie"
		]
	},
	"1f3a4": {
		"name": "microphone",
		"unicode_version": 6,
		"category": "activity",
		"order": 1545,
		"display": 1,
		"shortname": ":microphone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a4",
			"fully_qualified": "1f3a4",
			"non_fully_qualified": "1f3a4",
			"output": "1f3a4",
			"default_matches": [
				"1f3a4"
			],
			"greedy_matches": [
				"1f3a4"
			],
			"decimal": ""
		},
		"keywords": [
			"karaoke",
			"mic"
		]
	},
	"1f3a7": {
		"name": "headphone",
		"unicode_version": 6,
		"category": "activity",
		"order": 1546,
		"display": 1,
		"shortname": ":headphones:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a7",
			"fully_qualified": "1f3a7",
			"non_fully_qualified": "1f3a7",
			"output": "1f3a7",
			"default_matches": [
				"1f3a7"
			],
			"greedy_matches": [
				"1f3a7"
			],
			"decimal": ""
		},
		"keywords": [
			"earbud"
		]
	},
	"1f3bc": {
		"name": "musical score",
		"unicode_version": 6,
		"category": "activity",
		"order": 1547,
		"display": 1,
		"shortname": ":musical_score:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3bc",
			"fully_qualified": "1f3bc",
			"non_fully_qualified": "1f3bc",
			"output": "1f3bc",
			"default_matches": [
				"1f3bc"
			],
			"greedy_matches": [
				"1f3bc"
			],
			"decimal": ""
		},
		"keywords": [
			"music",
			"score"
		]
	},
	"1f3b9": {
		"name": "musical keyboard",
		"unicode_version": 6,
		"category": "activity",
		"order": 1548,
		"display": 1,
		"shortname": ":musical_keyboard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b9",
			"fully_qualified": "1f3b9",
			"non_fully_qualified": "1f3b9",
			"output": "1f3b9",
			"default_matches": [
				"1f3b9"
			],
			"greedy_matches": [
				"1f3b9"
			],
			"decimal": ""
		},
		"keywords": [
			"instrument",
			"keyboard",
			"music",
			"piano"
		]
	},
	"1f941": {
		"name": "drum",
		"unicode_version": 9,
		"category": "activity",
		"order": 1549,
		"display": 1,
		"shortname": ":drum:",
		"shortname_alternates": [
			":drum_with_drumsticks:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f941",
			"fully_qualified": "1f941",
			"non_fully_qualified": "1f941",
			"output": "1f941",
			"default_matches": [
				"1f941"
			],
			"greedy_matches": [
				"1f941"
			],
			"decimal": ""
		},
		"keywords": [
			"drum",
			"drumsticks",
			"music"
		]
	},
	"1f3b7": {
		"name": "saxophone",
		"unicode_version": 6,
		"category": "activity",
		"order": 1550,
		"display": 1,
		"shortname": ":saxophone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b7",
			"fully_qualified": "1f3b7",
			"non_fully_qualified": "1f3b7",
			"output": "1f3b7",
			"default_matches": [
				"1f3b7"
			],
			"greedy_matches": [
				"1f3b7"
			],
			"decimal": ""
		},
		"keywords": [
			"instrument",
			"music",
			"sax"
		]
	},
	"1f3ba": {
		"name": "trumpet",
		"unicode_version": 6,
		"category": "activity",
		"order": 1551,
		"display": 1,
		"shortname": ":trumpet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ba",
			"fully_qualified": "1f3ba",
			"non_fully_qualified": "1f3ba",
			"output": "1f3ba",
			"default_matches": [
				"1f3ba"
			],
			"greedy_matches": [
				"1f3ba"
			],
			"decimal": ""
		},
		"keywords": [
			"instrument",
			"music"
		]
	},
	"1f3b8": {
		"name": "guitar",
		"unicode_version": 6,
		"category": "activity",
		"order": 1552,
		"display": 1,
		"shortname": ":guitar:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b8",
			"fully_qualified": "1f3b8",
			"non_fully_qualified": "1f3b8",
			"output": "1f3b8",
			"default_matches": [
				"1f3b8"
			],
			"greedy_matches": [
				"1f3b8"
			],
			"decimal": ""
		},
		"keywords": [
			"instrument",
			"music"
		]
	},
	"1f3bb": {
		"name": "violin",
		"unicode_version": 6,
		"category": "activity",
		"order": 1553,
		"display": 1,
		"shortname": ":violin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3bb",
			"fully_qualified": "1f3bb",
			"non_fully_qualified": "1f3bb",
			"output": "1f3bb",
			"default_matches": [
				"1f3bb"
			],
			"greedy_matches": [
				"1f3bb"
			],
			"decimal": ""
		},
		"keywords": [
			"instrument",
			"music"
		]
	},
	"1f3b2": {
		"name": "game die",
		"unicode_version": 6,
		"category": "activity",
		"order": 1554,
		"display": 1,
		"shortname": ":game_die:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b2",
			"fully_qualified": "1f3b2",
			"non_fully_qualified": "1f3b2",
			"output": "1f3b2",
			"default_matches": [
				"1f3b2"
			],
			"greedy_matches": [
				"1f3b2"
			],
			"decimal": ""
		},
		"keywords": [
			"dice",
			"die",
			"game"
		]
	},
	"1f3af": {
		"name": "direct hit",
		"unicode_version": 6,
		"category": "activity",
		"order": 1555,
		"display": 1,
		"shortname": ":dart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3af",
			"fully_qualified": "1f3af",
			"non_fully_qualified": "1f3af",
			"output": "1f3af",
			"default_matches": [
				"1f3af"
			],
			"greedy_matches": [
				"1f3af"
			],
			"decimal": ""
		},
		"keywords": [
			"bull",
			"bullseye",
			"dart",
			"eye",
			"game",
			"hit",
			"target"
		]
	},
	"1f3b3": {
		"name": "bowling",
		"unicode_version": 6,
		"category": "activity",
		"order": 1556,
		"display": 1,
		"shortname": ":bowling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b3",
			"fully_qualified": "1f3b3",
			"non_fully_qualified": "1f3b3",
			"output": "1f3b3",
			"default_matches": [
				"1f3b3"
			],
			"greedy_matches": [
				"1f3b3"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"game"
		]
	},
	"1f3ae": {
		"name": "video game",
		"unicode_version": 6,
		"category": "activity",
		"order": 1557,
		"display": 1,
		"shortname": ":video_game:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ae",
			"fully_qualified": "1f3ae",
			"non_fully_qualified": "1f3ae",
			"output": "1f3ae",
			"default_matches": [
				"1f3ae"
			],
			"greedy_matches": [
				"1f3ae"
			],
			"decimal": ""
		},
		"keywords": [
			"controller",
			"game"
		]
	},
	"1f3b0": {
		"name": "slot machine",
		"unicode_version": 6,
		"category": "activity",
		"order": 1558,
		"display": 1,
		"shortname": ":slot_machine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b0",
			"fully_qualified": "1f3b0",
			"non_fully_qualified": "1f3b0",
			"output": "1f3b0",
			"default_matches": [
				"1f3b0"
			],
			"greedy_matches": [
				"1f3b0"
			],
			"decimal": ""
		},
		"keywords": [
			"game",
			"slot"
		]
	},
	"1f6f7": {
		"name": "sled",
		"unicode_version": 10,
		"category": "activity",
		"order": 1559,
		"display": 1,
		"shortname": ":sled:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f7",
			"fully_qualified": "1f6f7",
			"non_fully_qualified": "1f6f7",
			"output": "1f6f7",
			"default_matches": [
				"1f6f7"
			],
			"greedy_matches": [
				"1f6f7"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f931": {
		"name": "breast-feeding",
		"unicode_version": 10,
		"category": "activity",
		"order": 1560,
		"display": 1,
		"shortname": ":breast_feeding:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f931-1f3fb",
			"1f931-1f3fc",
			"1f931-1f3fd",
			"1f931-1f3fe",
			"1f931-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931",
			"fully_qualified": "1f931",
			"non_fully_qualified": "1f931",
			"output": "1f931",
			"default_matches": [
				"1f931"
			],
			"greedy_matches": [
				"1f931"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"nursing"
		]
	},
	"1f94c": {
		"name": "curling stone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1561,
		"display": 1,
		"shortname": ":curling_stone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f94c",
			"fully_qualified": "1f94c",
			"non_fully_qualified": "1f94c",
			"output": "1f94c",
			"default_matches": [
				"1f94c"
			],
			"greedy_matches": [
				"1f94c"
			],
			"decimal": ""
		},
		"keywords": [
			"game",
			"rock"
		]
	},
	"1f9d6": {
		"name": "person in steamy room",
		"unicode_version": 10,
		"category": "activity",
		"order": 1562,
		"display": 0,
		"shortname": ":person_in_steamy_room:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d6-1f3fb",
			"1f9d6-1f3fc",
			"1f9d6-1f3fd",
			"1f9d6-1f3fe",
			"1f9d6-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9d6-2640",
			"1f9d6-2642"
		],
		"code_points": {
			"base": "1f9d6",
			"fully_qualified": "1f9d6",
			"non_fully_qualified": "1f9d6",
			"output": "1f9d6",
			"default_matches": [
				"1f9d6"
			],
			"greedy_matches": [
				"1f9d6"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d7": {
		"name": "person climbing",
		"unicode_version": 10,
		"category": "activity",
		"order": 1563,
		"display": 0,
		"shortname": ":person_climbing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d7-1f3fb",
			"1f9d7-1f3fc",
			"1f9d7-1f3fd",
			"1f9d7-1f3fe",
			"1f9d7-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9d7-2640",
			"1f9d7-2642"
		],
		"code_points": {
			"base": "1f9d7",
			"fully_qualified": "1f9d7",
			"non_fully_qualified": "1f9d7",
			"output": "1f9d7",
			"default_matches": [
				"1f9d7"
			],
			"greedy_matches": [
				"1f9d7"
			],
			"decimal": ""
		},
		"keywords": [
			"climber"
		]
	},
	"1f9d8": {
		"name": "person in lotus position",
		"unicode_version": 10,
		"category": "activity",
		"order": 1564,
		"display": 0,
		"shortname": ":person_in_lotus_position:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d8-1f3fb",
			"1f9d8-1f3fc",
			"1f9d8-1f3fd",
			"1f9d8-1f3fe",
			"1f9d8-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9d8-2640",
			"1f9d8-2642"
		],
		"code_points": {
			"base": "1f9d8",
			"fully_qualified": "1f9d8",
			"non_fully_qualified": "1f9d8",
			"output": "1f9d8",
			"default_matches": [
				"1f9d8"
			],
			"greedy_matches": [
				"1f9d8"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f931-1f3fb": {
		"name": "breast-feeding: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1565,
		"display": 1,
		"shortname": ":breast_feeding_tone1:",
		"shortname_alternates": [
			":breast_feeding_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931-1f3fb",
			"fully_qualified": "1f931-1f3fb",
			"non_fully_qualified": "1f931-1f3fb",
			"output": "1f931-1f3fb",
			"default_matches": [
				"1f931-1f3fb"
			],
			"greedy_matches": [
				"1f931-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"light skin tone",
			"nursing"
		]
	},
	"1f931-1f3fc": {
		"name": "breast-feeding: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1566,
		"display": 1,
		"shortname": ":breast_feeding_tone2:",
		"shortname_alternates": [
			":breast_feeding_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931-1f3fc",
			"fully_qualified": "1f931-1f3fc",
			"non_fully_qualified": "1f931-1f3fc",
			"output": "1f931-1f3fc",
			"default_matches": [
				"1f931-1f3fc"
			],
			"greedy_matches": [
				"1f931-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"medium-light skin tone",
			"nursing"
		]
	},
	"1f931-1f3fd": {
		"name": "breast-feeding: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1567,
		"display": 1,
		"shortname": ":breast_feeding_tone3:",
		"shortname_alternates": [
			":breast_feeding_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931-1f3fd",
			"fully_qualified": "1f931-1f3fd",
			"non_fully_qualified": "1f931-1f3fd",
			"output": "1f931-1f3fd",
			"default_matches": [
				"1f931-1f3fd"
			],
			"greedy_matches": [
				"1f931-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"medium skin tone",
			"nursing"
		]
	},
	"1f931-1f3fe": {
		"name": "breast-feeding: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1568,
		"display": 1,
		"shortname": ":breast_feeding_tone4:",
		"shortname_alternates": [
			":breast_feeding_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931-1f3fe",
			"fully_qualified": "1f931-1f3fe",
			"non_fully_qualified": "1f931-1f3fe",
			"output": "1f931-1f3fe",
			"default_matches": [
				"1f931-1f3fe"
			],
			"greedy_matches": [
				"1f931-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"medium-dark skin tone",
			"nursing"
		]
	},
	"1f931-1f3ff": {
		"name": "breast-feeding: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1569,
		"display": 1,
		"shortname": ":breast_feeding_tone5:",
		"shortname_alternates": [
			":breast_feeding_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f931-1f3ff",
			"fully_qualified": "1f931-1f3ff",
			"non_fully_qualified": "1f931-1f3ff",
			"output": "1f931-1f3ff",
			"default_matches": [
				"1f931-1f3ff"
			],
			"greedy_matches": [
				"1f931-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"breast",
			"dark skin tone",
			"nursing"
		]
	},
	"1f9d6-1f3fb": {
		"name": "person in steamy room: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1570,
		"display": 0,
		"shortname": ":person_in_steamy_room_tone1:",
		"shortname_alternates": [
			":person_in_steamy_room_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d6-1f3fb-2640",
			"1f9d6-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9d6-1f3fb",
			"fully_qualified": "1f9d6-1f3fb",
			"non_fully_qualified": "1f9d6-1f3fb",
			"output": "1f9d6-1f3fb",
			"default_matches": [
				"1f9d6-1f3fb"
			],
			"greedy_matches": [
				"1f9d6-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fc": {
		"name": "person in steamy room: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1571,
		"display": 0,
		"shortname": ":person_in_steamy_room_tone2:",
		"shortname_alternates": [
			":person_in_steamy_room_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d6-1f3fc-2640",
			"1f9d6-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9d6-1f3fc",
			"fully_qualified": "1f9d6-1f3fc",
			"non_fully_qualified": "1f9d6-1f3fc",
			"output": "1f9d6-1f3fc",
			"default_matches": [
				"1f9d6-1f3fc"
			],
			"greedy_matches": [
				"1f9d6-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fd": {
		"name": "person in steamy room: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1572,
		"display": 0,
		"shortname": ":person_in_steamy_room_tone3:",
		"shortname_alternates": [
			":person_in_steamy_room_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d6-1f3fd-2640",
			"1f9d6-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9d6-1f3fd",
			"fully_qualified": "1f9d6-1f3fd",
			"non_fully_qualified": "1f9d6-1f3fd",
			"output": "1f9d6-1f3fd",
			"default_matches": [
				"1f9d6-1f3fd"
			],
			"greedy_matches": [
				"1f9d6-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fe": {
		"name": "person in steamy room: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1573,
		"display": 0,
		"shortname": ":person_in_steamy_room_tone4:",
		"shortname_alternates": [
			":person_in_steamy_room_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d6-1f3fe-2640",
			"1f9d6-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9d6-1f3fe",
			"fully_qualified": "1f9d6-1f3fe",
			"non_fully_qualified": "1f9d6-1f3fe",
			"output": "1f9d6-1f3fe",
			"default_matches": [
				"1f9d6-1f3fe"
			],
			"greedy_matches": [
				"1f9d6-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3ff": {
		"name": "person in steamy room: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1574,
		"display": 0,
		"shortname": ":person_in_steamy_room_tone5:",
		"shortname_alternates": [
			":person_in_steamy_room_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d6-1f3ff-2640",
			"1f9d6-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9d6-1f3ff",
			"fully_qualified": "1f9d6-1f3ff",
			"non_fully_qualified": "1f9d6-1f3ff",
			"output": "1f9d6-1f3ff",
			"default_matches": [
				"1f9d6-1f3ff"
			],
			"greedy_matches": [
				"1f9d6-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d7-1f3fb": {
		"name": "person climbing: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1575,
		"display": 0,
		"shortname": ":person_climbing_tone1:",
		"shortname_alternates": [
			":person_climbing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d7-1f3fb-2640",
			"1f9d7-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9d7-1f3fb",
			"fully_qualified": "1f9d7-1f3fb",
			"non_fully_qualified": "1f9d7-1f3fb",
			"output": "1f9d7-1f3fb",
			"default_matches": [
				"1f9d7-1f3fb"
			],
			"greedy_matches": [
				"1f9d7-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"light skin tone"
		]
	},
	"1f9d7-1f3fc": {
		"name": "person climbing: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1576,
		"display": 0,
		"shortname": ":person_climbing_tone2:",
		"shortname_alternates": [
			":person_climbing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d7-1f3fc-2640",
			"1f9d7-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9d7-1f3fc",
			"fully_qualified": "1f9d7-1f3fc",
			"non_fully_qualified": "1f9d7-1f3fc",
			"output": "1f9d7-1f3fc",
			"default_matches": [
				"1f9d7-1f3fc"
			],
			"greedy_matches": [
				"1f9d7-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-light skin tone"
		]
	},
	"1f9d7-1f3fd": {
		"name": "person climbing: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1577,
		"display": 0,
		"shortname": ":person_climbing_tone3:",
		"shortname_alternates": [
			":person_climbing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d7-1f3fd-2640",
			"1f9d7-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9d7-1f3fd",
			"fully_qualified": "1f9d7-1f3fd",
			"non_fully_qualified": "1f9d7-1f3fd",
			"output": "1f9d7-1f3fd",
			"default_matches": [
				"1f9d7-1f3fd"
			],
			"greedy_matches": [
				"1f9d7-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium skin tone"
		]
	},
	"1f9d7-1f3fe": {
		"name": "person climbing: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1578,
		"display": 0,
		"shortname": ":person_climbing_tone4:",
		"shortname_alternates": [
			":person_climbing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d7-1f3fe-2640",
			"1f9d7-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9d7-1f3fe",
			"fully_qualified": "1f9d7-1f3fe",
			"non_fully_qualified": "1f9d7-1f3fe",
			"output": "1f9d7-1f3fe",
			"default_matches": [
				"1f9d7-1f3fe"
			],
			"greedy_matches": [
				"1f9d7-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-dark skin tone"
		]
	},
	"1f9d7-1f3ff": {
		"name": "person climbing: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1579,
		"display": 0,
		"shortname": ":person_climbing_tone5:",
		"shortname_alternates": [
			":person_climbing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d7-1f3ff-2640",
			"1f9d7-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9d7-1f3ff",
			"fully_qualified": "1f9d7-1f3ff",
			"non_fully_qualified": "1f9d7-1f3ff",
			"output": "1f9d7-1f3ff",
			"default_matches": [
				"1f9d7-1f3ff"
			],
			"greedy_matches": [
				"1f9d7-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"dark skin tone"
		]
	},
	"1f9d8-1f3fb": {
		"name": "person in lotus position: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1580,
		"display": 0,
		"shortname": ":person_in_lotus_position_tone1:",
		"shortname_alternates": [
			":person_in_lotus_position_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d8-1f3fb-2640",
			"1f9d8-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9d8-1f3fb",
			"fully_qualified": "1f9d8-1f3fb",
			"non_fully_qualified": "1f9d8-1f3fb",
			"output": "1f9d8-1f3fb",
			"default_matches": [
				"1f9d8-1f3fb"
			],
			"greedy_matches": [
				"1f9d8-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f9d8-1f3fc": {
		"name": "person in lotus position: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1581,
		"display": 0,
		"shortname": ":person_in_lotus_position_tone2:",
		"shortname_alternates": [
			":person_in_lotus_position_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d8-1f3fc-2640",
			"1f9d8-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9d8-1f3fc",
			"fully_qualified": "1f9d8-1f3fc",
			"non_fully_qualified": "1f9d8-1f3fc",
			"output": "1f9d8-1f3fc",
			"default_matches": [
				"1f9d8-1f3fc"
			],
			"greedy_matches": [
				"1f9d8-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-light skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fd": {
		"name": "person in lotus position: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1582,
		"display": 0,
		"shortname": ":person_in_lotus_position_tone3:",
		"shortname_alternates": [
			":person_in_lotus_position_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d8-1f3fd-2640",
			"1f9d8-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9d8-1f3fd",
			"fully_qualified": "1f9d8-1f3fd",
			"non_fully_qualified": "1f9d8-1f3fd",
			"output": "1f9d8-1f3fd",
			"default_matches": [
				"1f9d8-1f3fd"
			],
			"greedy_matches": [
				"1f9d8-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fe": {
		"name": "person in lotus position: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1583,
		"display": 0,
		"shortname": ":person_in_lotus_position_tone4:",
		"shortname_alternates": [
			":person_in_lotus_position_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d8-1f3fe-2640",
			"1f9d8-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9d8-1f3fe",
			"fully_qualified": "1f9d8-1f3fe",
			"non_fully_qualified": "1f9d8-1f3fe",
			"output": "1f9d8-1f3fe",
			"default_matches": [
				"1f9d8-1f3fe"
			],
			"greedy_matches": [
				"1f9d8-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-dark skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3ff": {
		"name": "person in lotus position: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1584,
		"display": 0,
		"shortname": ":person_in_lotus_position_tone5:",
		"shortname_alternates": [
			":person_in_lotus_position_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d8-1f3ff-2640",
			"1f9d8-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9d8-1f3ff",
			"fully_qualified": "1f9d8-1f3ff",
			"non_fully_qualified": "1f9d8-1f3ff",
			"output": "1f9d8-1f3ff",
			"default_matches": [
				"1f9d8-1f3ff"
			],
			"greedy_matches": [
				"1f9d8-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f9d6-2640": {
		"name": "woman in steamy room",
		"unicode_version": 10,
		"category": "activity",
		"order": 1585,
		"display": 1,
		"shortname": ":woman_in_steamy_room:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d6-1f3fb-2640",
			"1f9d6-1f3fc-2640",
			"1f9d6-1f3fd-2640",
			"1f9d6-1f3fe-2640",
			"1f9d6-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-2640",
			"fully_qualified": "1f9d6-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-200d-2640",
			"output": "1f9d6-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-200d-2640-fe0f",
				"1f9d6-200d-2640",
				"1f9d6-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-200d-2640-fe0f",
				"1f9d6-200d-2640",
				"1f9d6-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"sauna",
			"steam room"
		]
	},
	"1f9d6-2642": {
		"name": "man in steamy room",
		"unicode_version": 10,
		"category": "activity",
		"order": 1586,
		"display": 1,
		"shortname": ":man_in_steamy_room:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d6-1f3fb-2642",
			"1f9d6-1f3fc-2642",
			"1f9d6-1f3fd-2642",
			"1f9d6-1f3fe-2642",
			"1f9d6-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-2642",
			"fully_qualified": "1f9d6-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-200d-2642",
			"output": "1f9d6-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-200d-2642-fe0f",
				"1f9d6-200d-2642",
				"1f9d6-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-200d-2642-fe0f",
				"1f9d6-200d-2642",
				"1f9d6-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fb-2640": {
		"name": "woman in steamy room: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1587,
		"display": 1,
		"shortname": ":woman_in_steamy_room_tone1:",
		"shortname_alternates": [
			":woman_in_steamy_room_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fb-2640",
			"fully_qualified": "1f9d6-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-1f3fb-200d-2640",
			"output": "1f9d6-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-1f3fb-200d-2640-fe0f",
				"1f9d6-1f3fb-200d-2640",
				"1f9d6-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fb-200d-2640-fe0f",
				"1f9d6-1f3fb-200d-2640",
				"1f9d6-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fb-2642": {
		"name": "man in steamy room: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1588,
		"display": 1,
		"shortname": ":man_in_steamy_room_tone1:",
		"shortname_alternates": [
			":man_in_steamy_room_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fb-2642",
			"fully_qualified": "1f9d6-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-1f3fb-200d-2642",
			"output": "1f9d6-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-1f3fb-200d-2642-fe0f",
				"1f9d6-1f3fb-200d-2642",
				"1f9d6-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fb-200d-2642-fe0f",
				"1f9d6-1f3fb-200d-2642",
				"1f9d6-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fc-2640": {
		"name": "woman in steamy room: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1589,
		"display": 1,
		"shortname": ":woman_in_steamy_room_tone2:",
		"shortname_alternates": [
			":woman_in_steamy_room_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fc-2640",
			"fully_qualified": "1f9d6-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-1f3fc-200d-2640",
			"output": "1f9d6-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-1f3fc-200d-2640-fe0f",
				"1f9d6-1f3fc-200d-2640",
				"1f9d6-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fc-200d-2640-fe0f",
				"1f9d6-1f3fc-200d-2640",
				"1f9d6-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fc-2642": {
		"name": "man in steamy room: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1590,
		"display": 1,
		"shortname": ":man_in_steamy_room_tone2:",
		"shortname_alternates": [
			":man_in_steamy_room_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fc-2642",
			"fully_qualified": "1f9d6-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-1f3fc-200d-2642",
			"output": "1f9d6-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-1f3fc-200d-2642-fe0f",
				"1f9d6-1f3fc-200d-2642",
				"1f9d6-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fc-200d-2642-fe0f",
				"1f9d6-1f3fc-200d-2642",
				"1f9d6-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fd-2640": {
		"name": "woman in steamy room: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1591,
		"display": 1,
		"shortname": ":woman_in_steamy_room_tone3:",
		"shortname_alternates": [
			":woman_in_steamy_room_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fd-2640",
			"fully_qualified": "1f9d6-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-1f3fd-200d-2640",
			"output": "1f9d6-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-1f3fd-200d-2640-fe0f",
				"1f9d6-1f3fd-200d-2640",
				"1f9d6-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fd-200d-2640-fe0f",
				"1f9d6-1f3fd-200d-2640",
				"1f9d6-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fd-2642": {
		"name": "man in steamy room: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1592,
		"display": 1,
		"shortname": ":man_in_steamy_room_tone3:",
		"shortname_alternates": [
			":man_in_steamy_room_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fd-2642",
			"fully_qualified": "1f9d6-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-1f3fd-200d-2642",
			"output": "1f9d6-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-1f3fd-200d-2642-fe0f",
				"1f9d6-1f3fd-200d-2642",
				"1f9d6-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fd-200d-2642-fe0f",
				"1f9d6-1f3fd-200d-2642",
				"1f9d6-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fe-2640": {
		"name": "woman in steamy room: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1593,
		"display": 1,
		"shortname": ":woman_in_steamy_room_tone4:",
		"shortname_alternates": [
			":woman_in_steamy_room_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fe-2640",
			"fully_qualified": "1f9d6-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-1f3fe-200d-2640",
			"output": "1f9d6-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-1f3fe-200d-2640-fe0f",
				"1f9d6-1f3fe-200d-2640",
				"1f9d6-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fe-200d-2640-fe0f",
				"1f9d6-1f3fe-200d-2640",
				"1f9d6-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3fe-2642": {
		"name": "man in steamy room: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1594,
		"display": 1,
		"shortname": ":man_in_steamy_room_tone4:",
		"shortname_alternates": [
			":man_in_steamy_room_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3fe-2642",
			"fully_qualified": "1f9d6-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-1f3fe-200d-2642",
			"output": "1f9d6-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-1f3fe-200d-2642-fe0f",
				"1f9d6-1f3fe-200d-2642",
				"1f9d6-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3fe-200d-2642-fe0f",
				"1f9d6-1f3fe-200d-2642",
				"1f9d6-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3ff-2640": {
		"name": "woman in steamy room: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1595,
		"display": 1,
		"shortname": ":woman_in_steamy_room_tone5:",
		"shortname_alternates": [
			":woman_in_steamy_room_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3ff-2640",
			"fully_qualified": "1f9d6-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9d6-1f3ff-200d-2640",
			"output": "1f9d6-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9d6-1f3ff-200d-2640-fe0f",
				"1f9d6-1f3ff-200d-2640",
				"1f9d6-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3ff-200d-2640-fe0f",
				"1f9d6-1f3ff-200d-2640",
				"1f9d6-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d6-1f3ff-2642": {
		"name": "man in steamy room: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1596,
		"display": 1,
		"shortname": ":man_in_steamy_room_tone5:",
		"shortname_alternates": [
			":man_in_steamy_room_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d6-1f3ff-2642",
			"fully_qualified": "1f9d6-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9d6-1f3ff-200d-2642",
			"output": "1f9d6-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9d6-1f3ff-200d-2642-fe0f",
				"1f9d6-1f3ff-200d-2642",
				"1f9d6-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d6-1f3ff-200d-2642-fe0f",
				"1f9d6-1f3ff-200d-2642",
				"1f9d6-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sauna",
			"steam room"
		]
	},
	"1f9d7-2640": {
		"name": "woman climbing",
		"unicode_version": 10,
		"category": "activity",
		"order": 1597,
		"display": 1,
		"shortname": ":woman_climbing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d7-1f3fb-2640",
			"1f9d7-1f3fc-2640",
			"1f9d7-1f3fd-2640",
			"1f9d7-1f3fe-2640",
			"1f9d7-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-2640",
			"fully_qualified": "1f9d7-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-200d-2640",
			"output": "1f9d7-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-200d-2640-fe0f",
				"1f9d7-200d-2640",
				"1f9d7-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-200d-2640-fe0f",
				"1f9d7-200d-2640",
				"1f9d7-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber"
		]
	},
	"1f9d7-2642": {
		"name": "man climbing",
		"unicode_version": 10,
		"category": "activity",
		"order": 1598,
		"display": 1,
		"shortname": ":man_climbing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d7-1f3fb-2642",
			"1f9d7-1f3fc-2642",
			"1f9d7-1f3fd-2642",
			"1f9d7-1f3fe-2642",
			"1f9d7-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-2642",
			"fully_qualified": "1f9d7-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-200d-2642",
			"output": "1f9d7-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-200d-2642-fe0f",
				"1f9d7-200d-2642",
				"1f9d7-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-200d-2642-fe0f",
				"1f9d7-200d-2642",
				"1f9d7-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber"
		]
	},
	"1f9d7-1f3fb-2640": {
		"name": "woman climbing: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1599,
		"display": 1,
		"shortname": ":woman_climbing_tone1:",
		"shortname_alternates": [
			":woman_climbing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fb-2640",
			"fully_qualified": "1f9d7-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-1f3fb-200d-2640",
			"output": "1f9d7-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-1f3fb-200d-2640-fe0f",
				"1f9d7-1f3fb-200d-2640",
				"1f9d7-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fb-200d-2640-fe0f",
				"1f9d7-1f3fb-200d-2640",
				"1f9d7-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"light skin tone"
		]
	},
	"1f9d7-1f3fb-2642": {
		"name": "man climbing: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1600,
		"display": 1,
		"shortname": ":man_climbing_tone1:",
		"shortname_alternates": [
			":man_climbing_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fb-2642",
			"fully_qualified": "1f9d7-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-1f3fb-200d-2642",
			"output": "1f9d7-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-1f3fb-200d-2642-fe0f",
				"1f9d7-1f3fb-200d-2642",
				"1f9d7-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fb-200d-2642-fe0f",
				"1f9d7-1f3fb-200d-2642",
				"1f9d7-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"light skin tone"
		]
	},
	"1f9d7-1f3fc-2640": {
		"name": "woman climbing: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1601,
		"display": 1,
		"shortname": ":woman_climbing_tone2:",
		"shortname_alternates": [
			":woman_climbing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fc-2640",
			"fully_qualified": "1f9d7-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-1f3fc-200d-2640",
			"output": "1f9d7-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-1f3fc-200d-2640-fe0f",
				"1f9d7-1f3fc-200d-2640",
				"1f9d7-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fc-200d-2640-fe0f",
				"1f9d7-1f3fc-200d-2640",
				"1f9d7-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-light skin tone"
		]
	},
	"1f9d7-1f3fc-2642": {
		"name": "man climbing: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1602,
		"display": 1,
		"shortname": ":man_climbing_tone2:",
		"shortname_alternates": [
			":man_climbing_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fc-2642",
			"fully_qualified": "1f9d7-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-1f3fc-200d-2642",
			"output": "1f9d7-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-1f3fc-200d-2642-fe0f",
				"1f9d7-1f3fc-200d-2642",
				"1f9d7-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fc-200d-2642-fe0f",
				"1f9d7-1f3fc-200d-2642",
				"1f9d7-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-light skin tone"
		]
	},
	"1f9d7-1f3fd-2640": {
		"name": "woman climbing: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1603,
		"display": 1,
		"shortname": ":woman_climbing_tone3:",
		"shortname_alternates": [
			":woman_climbing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fd-2640",
			"fully_qualified": "1f9d7-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-1f3fd-200d-2640",
			"output": "1f9d7-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-1f3fd-200d-2640-fe0f",
				"1f9d7-1f3fd-200d-2640",
				"1f9d7-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fd-200d-2640-fe0f",
				"1f9d7-1f3fd-200d-2640",
				"1f9d7-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium skin tone"
		]
	},
	"1f9d7-1f3fd-2642": {
		"name": "man climbing: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1604,
		"display": 1,
		"shortname": ":man_climbing_tone3:",
		"shortname_alternates": [
			":man_climbing_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fd-2642",
			"fully_qualified": "1f9d7-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-1f3fd-200d-2642",
			"output": "1f9d7-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-1f3fd-200d-2642-fe0f",
				"1f9d7-1f3fd-200d-2642",
				"1f9d7-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fd-200d-2642-fe0f",
				"1f9d7-1f3fd-200d-2642",
				"1f9d7-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium skin tone"
		]
	},
	"1f9d7-1f3fe-2640": {
		"name": "woman climbing: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1605,
		"display": 1,
		"shortname": ":woman_climbing_tone4:",
		"shortname_alternates": [
			":woman_climbing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fe-2640",
			"fully_qualified": "1f9d7-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-1f3fe-200d-2640",
			"output": "1f9d7-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-1f3fe-200d-2640-fe0f",
				"1f9d7-1f3fe-200d-2640",
				"1f9d7-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fe-200d-2640-fe0f",
				"1f9d7-1f3fe-200d-2640",
				"1f9d7-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-dark skin tone"
		]
	},
	"1f9d7-1f3fe-2642": {
		"name": "man climbing: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1606,
		"display": 1,
		"shortname": ":man_climbing_tone4:",
		"shortname_alternates": [
			":man_climbing_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3fe-2642",
			"fully_qualified": "1f9d7-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-1f3fe-200d-2642",
			"output": "1f9d7-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-1f3fe-200d-2642-fe0f",
				"1f9d7-1f3fe-200d-2642",
				"1f9d7-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3fe-200d-2642-fe0f",
				"1f9d7-1f3fe-200d-2642",
				"1f9d7-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"medium-dark skin tone"
		]
	},
	"1f9d7-1f3ff-2640": {
		"name": "woman climbing: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1607,
		"display": 1,
		"shortname": ":woman_climbing_tone5:",
		"shortname_alternates": [
			":woman_climbing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3ff-2640",
			"fully_qualified": "1f9d7-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9d7-1f3ff-200d-2640",
			"output": "1f9d7-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9d7-1f3ff-200d-2640-fe0f",
				"1f9d7-1f3ff-200d-2640",
				"1f9d7-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3ff-200d-2640-fe0f",
				"1f9d7-1f3ff-200d-2640",
				"1f9d7-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"dark skin tone"
		]
	},
	"1f9d7-1f3ff-2642": {
		"name": "man climbing: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1608,
		"display": 1,
		"shortname": ":man_climbing_tone5:",
		"shortname_alternates": [
			":man_climbing_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d7-1f3ff-2642",
			"fully_qualified": "1f9d7-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9d7-1f3ff-200d-2642",
			"output": "1f9d7-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9d7-1f3ff-200d-2642-fe0f",
				"1f9d7-1f3ff-200d-2642",
				"1f9d7-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d7-1f3ff-200d-2642-fe0f",
				"1f9d7-1f3ff-200d-2642",
				"1f9d7-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"climber",
			"dark skin tone"
		]
	},
	"1f9d8-2640": {
		"name": "woman in lotus position",
		"unicode_version": 10,
		"category": "activity",
		"order": 1609,
		"display": 1,
		"shortname": ":woman_in_lotus_position:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d8-1f3fb-2640",
			"1f9d8-1f3fc-2640",
			"1f9d8-1f3fd-2640",
			"1f9d8-1f3fe-2640",
			"1f9d8-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-2640",
			"fully_qualified": "1f9d8-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-200d-2640",
			"output": "1f9d8-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-200d-2640-fe0f",
				"1f9d8-200d-2640",
				"1f9d8-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-200d-2640-fe0f",
				"1f9d8-200d-2640",
				"1f9d8-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"yoga"
		]
	},
	"1f9d8-2642": {
		"name": "man in lotus position",
		"unicode_version": 10,
		"category": "activity",
		"order": 1610,
		"display": 1,
		"shortname": ":man_in_lotus_position:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d8-1f3fb-2642",
			"1f9d8-1f3fc-2642",
			"1f9d8-1f3fd-2642",
			"1f9d8-1f3fe-2642",
			"1f9d8-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-2642",
			"fully_qualified": "1f9d8-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-200d-2642",
			"output": "1f9d8-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-200d-2642-fe0f",
				"1f9d8-200d-2642",
				"1f9d8-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-200d-2642-fe0f",
				"1f9d8-200d-2642",
				"1f9d8-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"yoga"
		]
	},
	"1f9d8-1f3fb-2640": {
		"name": "woman in lotus position: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1611,
		"display": 1,
		"shortname": ":woman_in_lotus_position_tone1:",
		"shortname_alternates": [
			":woman_in_lotus_position_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fb-2640",
			"fully_qualified": "1f9d8-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-1f3fb-200d-2640",
			"output": "1f9d8-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-1f3fb-200d-2640-fe0f",
				"1f9d8-1f3fb-200d-2640",
				"1f9d8-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fb-200d-2640-fe0f",
				"1f9d8-1f3fb-200d-2640",
				"1f9d8-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f9d8-1f3fb-2642": {
		"name": "man in lotus position: light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1612,
		"display": 1,
		"shortname": ":man_in_lotus_position_tone1:",
		"shortname_alternates": [
			":man_in_lotus_position_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fb-2642",
			"fully_qualified": "1f9d8-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-1f3fb-200d-2642",
			"output": "1f9d8-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-1f3fb-200d-2642-fe0f",
				"1f9d8-1f3fb-200d-2642",
				"1f9d8-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fb-200d-2642-fe0f",
				"1f9d8-1f3fb-200d-2642",
				"1f9d8-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f9d8-1f3fc-2640": {
		"name": "woman in lotus position: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1613,
		"display": 1,
		"shortname": ":woman_in_lotus_position_tone2:",
		"shortname_alternates": [
			":woman_in_lotus_position_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fc-2640",
			"fully_qualified": "1f9d8-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-1f3fc-200d-2640",
			"output": "1f9d8-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-1f3fc-200d-2640-fe0f",
				"1f9d8-1f3fc-200d-2640",
				"1f9d8-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fc-200d-2640-fe0f",
				"1f9d8-1f3fc-200d-2640",
				"1f9d8-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-light skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fc-2642": {
		"name": "man in lotus position: medium-light skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1614,
		"display": 1,
		"shortname": ":man_in_lotus_position_tone2:",
		"shortname_alternates": [
			":man_in_lotus_position_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fc-2642",
			"fully_qualified": "1f9d8-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-1f3fc-200d-2642",
			"output": "1f9d8-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-1f3fc-200d-2642-fe0f",
				"1f9d8-1f3fc-200d-2642",
				"1f9d8-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fc-200d-2642-fe0f",
				"1f9d8-1f3fc-200d-2642",
				"1f9d8-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-light skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fd-2640": {
		"name": "woman in lotus position: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1615,
		"display": 1,
		"shortname": ":woman_in_lotus_position_tone3:",
		"shortname_alternates": [
			":woman_in_lotus_position_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fd-2640",
			"fully_qualified": "1f9d8-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-1f3fd-200d-2640",
			"output": "1f9d8-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-1f3fd-200d-2640-fe0f",
				"1f9d8-1f3fd-200d-2640",
				"1f9d8-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fd-200d-2640-fe0f",
				"1f9d8-1f3fd-200d-2640",
				"1f9d8-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fd-2642": {
		"name": "man in lotus position: medium skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1616,
		"display": 1,
		"shortname": ":man_in_lotus_position_tone3:",
		"shortname_alternates": [
			":man_in_lotus_position_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fd-2642",
			"fully_qualified": "1f9d8-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-1f3fd-200d-2642",
			"output": "1f9d8-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-1f3fd-200d-2642-fe0f",
				"1f9d8-1f3fd-200d-2642",
				"1f9d8-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fd-200d-2642-fe0f",
				"1f9d8-1f3fd-200d-2642",
				"1f9d8-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fe-2640": {
		"name": "woman in lotus position: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1617,
		"display": 1,
		"shortname": ":woman_in_lotus_position_tone4:",
		"shortname_alternates": [
			":woman_in_lotus_position_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fe-2640",
			"fully_qualified": "1f9d8-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-1f3fe-200d-2640",
			"output": "1f9d8-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-1f3fe-200d-2640-fe0f",
				"1f9d8-1f3fe-200d-2640",
				"1f9d8-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fe-200d-2640-fe0f",
				"1f9d8-1f3fe-200d-2640",
				"1f9d8-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-dark skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3fe-2642": {
		"name": "man in lotus position: medium-dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1618,
		"display": 1,
		"shortname": ":man_in_lotus_position_tone4:",
		"shortname_alternates": [
			":man_in_lotus_position_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3fe-2642",
			"fully_qualified": "1f9d8-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-1f3fe-200d-2642",
			"output": "1f9d8-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-1f3fe-200d-2642-fe0f",
				"1f9d8-1f3fe-200d-2642",
				"1f9d8-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3fe-200d-2642-fe0f",
				"1f9d8-1f3fe-200d-2642",
				"1f9d8-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"meditation",
			"medium-dark skin tone",
			"yoga"
		]
	},
	"1f9d8-1f3ff-2640": {
		"name": "woman in lotus position: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1619,
		"display": 1,
		"shortname": ":woman_in_lotus_position_tone5:",
		"shortname_alternates": [
			":woman_in_lotus_position_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3ff-2640",
			"fully_qualified": "1f9d8-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9d8-1f3ff-200d-2640",
			"output": "1f9d8-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9d8-1f3ff-200d-2640-fe0f",
				"1f9d8-1f3ff-200d-2640",
				"1f9d8-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3ff-200d-2640-fe0f",
				"1f9d8-1f3ff-200d-2640",
				"1f9d8-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f9d8-1f3ff-2642": {
		"name": "man in lotus position: dark skin tone",
		"unicode_version": 10,
		"category": "activity",
		"order": 1620,
		"display": 1,
		"shortname": ":man_in_lotus_position_tone5:",
		"shortname_alternates": [
			":man_in_lotus_position_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d8-1f3ff-2642",
			"fully_qualified": "1f9d8-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9d8-1f3ff-200d-2642",
			"output": "1f9d8-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9d8-1f3ff-200d-2642-fe0f",
				"1f9d8-1f3ff-200d-2642",
				"1f9d8-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d8-1f3ff-200d-2642-fe0f",
				"1f9d8-1f3ff-200d-2642",
				"1f9d8-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"meditation",
			"yoga"
		]
	},
	"1f697": {
		"name": "automobile",
		"unicode_version": 6,
		"category": "travel",
		"order": 1621,
		"display": 1,
		"shortname": ":red_car:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f697",
			"fully_qualified": "1f697",
			"non_fully_qualified": "1f697",
			"output": "1f697",
			"default_matches": [
				"1f697"
			],
			"greedy_matches": [
				"1f697"
			],
			"decimal": ""
		},
		"keywords": [
			"car"
		]
	},
	"1f695": {
		"name": "taxi",
		"unicode_version": 6,
		"category": "travel",
		"order": 1622,
		"display": 1,
		"shortname": ":taxi:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f695",
			"fully_qualified": "1f695",
			"non_fully_qualified": "1f695",
			"output": "1f695",
			"default_matches": [
				"1f695"
			],
			"greedy_matches": [
				"1f695"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f699": {
		"name": "sport utility vehicle",
		"unicode_version": 6,
		"category": "travel",
		"order": 1623,
		"display": 1,
		"shortname": ":blue_car:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f699",
			"fully_qualified": "1f699",
			"non_fully_qualified": "1f699",
			"output": "1f699",
			"default_matches": [
				"1f699"
			],
			"greedy_matches": [
				"1f699"
			],
			"decimal": ""
		},
		"keywords": [
			"recreational",
			"sport utility"
		]
	},
	"1f68c": {
		"name": "bus",
		"unicode_version": 6,
		"category": "travel",
		"order": 1624,
		"display": 1,
		"shortname": ":bus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68c",
			"fully_qualified": "1f68c",
			"non_fully_qualified": "1f68c",
			"output": "1f68c",
			"default_matches": [
				"1f68c"
			],
			"greedy_matches": [
				"1f68c"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f68e": {
		"name": "trolleybus",
		"unicode_version": 6,
		"category": "travel",
		"order": 1625,
		"display": 1,
		"shortname": ":trolleybus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68e",
			"fully_qualified": "1f68e",
			"non_fully_qualified": "1f68e",
			"output": "1f68e",
			"default_matches": [
				"1f68e"
			],
			"greedy_matches": [
				"1f68e"
			],
			"decimal": ""
		},
		"keywords": [
			"bus",
			"tram",
			"trolley"
		]
	},
	"1f3ce": {
		"name": "racing car",
		"unicode_version": 7,
		"category": "travel",
		"order": 1626,
		"display": 1,
		"shortname": ":race_car:",
		"shortname_alternates": [
			":racing_car:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ce",
			"fully_qualified": "1f3ce-fe0f",
			"non_fully_qualified": "1f3ce",
			"output": "1f3ce-fe0f",
			"default_matches": [
				"1f3ce-fe0f",
				"1f3ce"
			],
			"greedy_matches": [
				"1f3ce-fe0f",
				"1f3ce"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"racing"
		]
	},
	"1f693": {
		"name": "police car",
		"unicode_version": 6,
		"category": "travel",
		"order": 1627,
		"display": 1,
		"shortname": ":police_car:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f693",
			"fully_qualified": "1f693",
			"non_fully_qualified": "1f693",
			"output": "1f693",
			"default_matches": [
				"1f693"
			],
			"greedy_matches": [
				"1f693"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"patrol",
			"police"
		]
	},
	"1f691": {
		"name": "ambulance",
		"unicode_version": 6,
		"category": "travel",
		"order": 1628,
		"display": 1,
		"shortname": ":ambulance:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f691",
			"fully_qualified": "1f691",
			"non_fully_qualified": "1f691",
			"output": "1f691",
			"default_matches": [
				"1f691"
			],
			"greedy_matches": [
				"1f691"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f692": {
		"name": "fire engine",
		"unicode_version": 6,
		"category": "travel",
		"order": 1629,
		"display": 1,
		"shortname": ":fire_engine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f692",
			"fully_qualified": "1f692",
			"non_fully_qualified": "1f692",
			"output": "1f692",
			"default_matches": [
				"1f692"
			],
			"greedy_matches": [
				"1f692"
			],
			"decimal": ""
		},
		"keywords": [
			"engine",
			"fire",
			"truck"
		]
	},
	"1f690": {
		"name": "minibus",
		"unicode_version": 6,
		"category": "travel",
		"order": 1630,
		"display": 1,
		"shortname": ":minibus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f690",
			"fully_qualified": "1f690",
			"non_fully_qualified": "1f690",
			"output": "1f690",
			"default_matches": [
				"1f690"
			],
			"greedy_matches": [
				"1f690"
			],
			"decimal": ""
		},
		"keywords": [
			"bus"
		]
	},
	"1f69a": {
		"name": "delivery truck",
		"unicode_version": 6,
		"category": "travel",
		"order": 1631,
		"display": 1,
		"shortname": ":truck:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69a",
			"fully_qualified": "1f69a",
			"non_fully_qualified": "1f69a",
			"output": "1f69a",
			"default_matches": [
				"1f69a"
			],
			"greedy_matches": [
				"1f69a"
			],
			"decimal": ""
		},
		"keywords": [
			"delivery",
			"truck"
		]
	},
	"1f69b": {
		"name": "articulated lorry",
		"unicode_version": 6,
		"category": "travel",
		"order": 1632,
		"display": 1,
		"shortname": ":articulated_lorry:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69b",
			"fully_qualified": "1f69b",
			"non_fully_qualified": "1f69b",
			"output": "1f69b",
			"default_matches": [
				"1f69b"
			],
			"greedy_matches": [
				"1f69b"
			],
			"decimal": ""
		},
		"keywords": [
			"lorry",
			"semi",
			"truck"
		]
	},
	"1f69c": {
		"name": "tractor",
		"unicode_version": 6,
		"category": "travel",
		"order": 1633,
		"display": 1,
		"shortname": ":tractor:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69c",
			"fully_qualified": "1f69c",
			"non_fully_qualified": "1f69c",
			"output": "1f69c",
			"default_matches": [
				"1f69c"
			],
			"greedy_matches": [
				"1f69c"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f6f4": {
		"name": "kick scooter",
		"unicode_version": 9,
		"category": "travel",
		"order": 1634,
		"display": 1,
		"shortname": ":scooter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f4",
			"fully_qualified": "1f6f4",
			"non_fully_qualified": "1f6f4",
			"output": "1f6f4",
			"default_matches": [
				"1f6f4"
			],
			"greedy_matches": [
				"1f6f4"
			],
			"decimal": ""
		},
		"keywords": [
			"kick",
			"scooter"
		]
	},
	"1f6b2": {
		"name": "bicycle",
		"unicode_version": 6,
		"category": "travel",
		"order": 1635,
		"display": 1,
		"shortname": ":bike:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b2",
			"fully_qualified": "1f6b2",
			"non_fully_qualified": "1f6b2",
			"output": "1f6b2",
			"default_matches": [
				"1f6b2"
			],
			"greedy_matches": [
				"1f6b2"
			],
			"decimal": ""
		},
		"keywords": [
			"bike"
		]
	},
	"1f6f5": {
		"name": "motor scooter",
		"unicode_version": 9,
		"category": "travel",
		"order": 1636,
		"display": 1,
		"shortname": ":motor_scooter:",
		"shortname_alternates": [
			":motorbike:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f5",
			"fully_qualified": "1f6f5",
			"non_fully_qualified": "1f6f5",
			"output": "1f6f5",
			"default_matches": [
				"1f6f5"
			],
			"greedy_matches": [
				"1f6f5"
			],
			"decimal": ""
		},
		"keywords": [
			"motor",
			"scooter"
		]
	},
	"1f3cd": {
		"name": "motorcycle",
		"unicode_version": 7,
		"category": "travel",
		"order": 1637,
		"display": 1,
		"shortname": ":motorcycle:",
		"shortname_alternates": [
			":racing_motorcycle:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3cd",
			"fully_qualified": "1f3cd-fe0f",
			"non_fully_qualified": "1f3cd",
			"output": "1f3cd-fe0f",
			"default_matches": [
				"1f3cd-fe0f",
				"1f3cd"
			],
			"greedy_matches": [
				"1f3cd-fe0f",
				"1f3cd"
			],
			"decimal": ""
		},
		"keywords": [
			"racing"
		]
	},
	"1f6a8": {
		"name": "police car light",
		"unicode_version": 6,
		"category": "travel",
		"order": 1638,
		"display": 1,
		"shortname": ":rotating_light:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a8",
			"fully_qualified": "1f6a8",
			"non_fully_qualified": "1f6a8",
			"output": "1f6a8",
			"default_matches": [
				"1f6a8"
			],
			"greedy_matches": [
				"1f6a8"
			],
			"decimal": ""
		},
		"keywords": [
			"beacon",
			"car",
			"light",
			"police",
			"revolving"
		]
	},
	"1f694": {
		"name": "oncoming police car",
		"unicode_version": 6,
		"category": "travel",
		"order": 1639,
		"display": 1,
		"shortname": ":oncoming_police_car:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f694",
			"fully_qualified": "1f694",
			"non_fully_qualified": "1f694",
			"output": "1f694",
			"default_matches": [
				"1f694"
			],
			"greedy_matches": [
				"1f694"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"oncoming",
			"police"
		]
	},
	"1f68d": {
		"name": "oncoming bus",
		"unicode_version": 6,
		"category": "travel",
		"order": 1640,
		"display": 1,
		"shortname": ":oncoming_bus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68d",
			"fully_qualified": "1f68d",
			"non_fully_qualified": "1f68d",
			"output": "1f68d",
			"default_matches": [
				"1f68d"
			],
			"greedy_matches": [
				"1f68d"
			],
			"decimal": ""
		},
		"keywords": [
			"bus",
			"oncoming"
		]
	},
	"1f698": {
		"name": "oncoming automobile",
		"unicode_version": 6,
		"category": "travel",
		"order": 1641,
		"display": 1,
		"shortname": ":oncoming_automobile:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f698",
			"fully_qualified": "1f698",
			"non_fully_qualified": "1f698",
			"output": "1f698",
			"default_matches": [
				"1f698"
			],
			"greedy_matches": [
				"1f698"
			],
			"decimal": ""
		},
		"keywords": [
			"automobile",
			"car",
			"oncoming"
		]
	},
	"1f696": {
		"name": "oncoming taxi",
		"unicode_version": 6,
		"category": "travel",
		"order": 1642,
		"display": 1,
		"shortname": ":oncoming_taxi:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f696",
			"fully_qualified": "1f696",
			"non_fully_qualified": "1f696",
			"output": "1f696",
			"default_matches": [
				"1f696"
			],
			"greedy_matches": [
				"1f696"
			],
			"decimal": ""
		},
		"keywords": [
			"oncoming",
			"taxi"
		]
	},
	"1f6a1": {
		"name": "aerial tramway",
		"unicode_version": 6,
		"category": "travel",
		"order": 1643,
		"display": 1,
		"shortname": ":aerial_tramway:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a1",
			"fully_qualified": "1f6a1",
			"non_fully_qualified": "1f6a1",
			"output": "1f6a1",
			"default_matches": [
				"1f6a1"
			],
			"greedy_matches": [
				"1f6a1"
			],
			"decimal": ""
		},
		"keywords": [
			"aerial",
			"cable",
			"car",
			"gondola",
			"tramway"
		]
	},
	"1f6a0": {
		"name": "mountain cableway",
		"unicode_version": 6,
		"category": "travel",
		"order": 1644,
		"display": 1,
		"shortname": ":mountain_cableway:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a0",
			"fully_qualified": "1f6a0",
			"non_fully_qualified": "1f6a0",
			"output": "1f6a0",
			"default_matches": [
				"1f6a0"
			],
			"greedy_matches": [
				"1f6a0"
			],
			"decimal": ""
		},
		"keywords": [
			"cable",
			"gondola",
			"mountain"
		]
	},
	"1f69f": {
		"name": "suspension railway",
		"unicode_version": 6,
		"category": "travel",
		"order": 1645,
		"display": 1,
		"shortname": ":suspension_railway:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69f",
			"fully_qualified": "1f69f",
			"non_fully_qualified": "1f69f",
			"output": "1f69f",
			"default_matches": [
				"1f69f"
			],
			"greedy_matches": [
				"1f69f"
			],
			"decimal": ""
		},
		"keywords": [
			"railway",
			"suspension"
		]
	},
	"1f683": {
		"name": "railway car",
		"unicode_version": 6,
		"category": "travel",
		"order": 1646,
		"display": 1,
		"shortname": ":railway_car:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f683",
			"fully_qualified": "1f683",
			"non_fully_qualified": "1f683",
			"output": "1f683",
			"default_matches": [
				"1f683"
			],
			"greedy_matches": [
				"1f683"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"electric",
			"railway",
			"train",
			"tram",
			"trolleybus"
		]
	},
	"1f68b": {
		"name": "tram car",
		"unicode_version": 6,
		"category": "travel",
		"order": 1647,
		"display": 1,
		"shortname": ":train:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68b",
			"fully_qualified": "1f68b",
			"non_fully_qualified": "1f68b",
			"output": "1f68b",
			"default_matches": [
				"1f68b"
			],
			"greedy_matches": [
				"1f68b"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"tram",
			"trolleybus"
		]
	},
	"1f69e": {
		"name": "mountain railway",
		"unicode_version": 6,
		"category": "travel",
		"order": 1648,
		"display": 1,
		"shortname": ":mountain_railway:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69e",
			"fully_qualified": "1f69e",
			"non_fully_qualified": "1f69e",
			"output": "1f69e",
			"default_matches": [
				"1f69e"
			],
			"greedy_matches": [
				"1f69e"
			],
			"decimal": ""
		},
		"keywords": [
			"car",
			"mountain",
			"railway"
		]
	},
	"1f69d": {
		"name": "monorail",
		"unicode_version": 6,
		"category": "travel",
		"order": 1649,
		"display": 1,
		"shortname": ":monorail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f69d",
			"fully_qualified": "1f69d",
			"non_fully_qualified": "1f69d",
			"output": "1f69d",
			"default_matches": [
				"1f69d"
			],
			"greedy_matches": [
				"1f69d"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f684": {
		"name": "high-speed train",
		"unicode_version": 6,
		"category": "travel",
		"order": 1650,
		"display": 1,
		"shortname": ":bullettrain_side:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f684",
			"fully_qualified": "1f684",
			"non_fully_qualified": "1f684",
			"output": "1f684",
			"default_matches": [
				"1f684"
			],
			"greedy_matches": [
				"1f684"
			],
			"decimal": ""
		},
		"keywords": [
			"railway",
			"shinkansen",
			"speed",
			"train"
		]
	},
	"1f685": {
		"name": "high-speed train with bullet nose",
		"unicode_version": 6,
		"category": "travel",
		"order": 1651,
		"display": 1,
		"shortname": ":bullettrain_front:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f685",
			"fully_qualified": "1f685",
			"non_fully_qualified": "1f685",
			"output": "1f685",
			"default_matches": [
				"1f685"
			],
			"greedy_matches": [
				"1f685"
			],
			"decimal": ""
		},
		"keywords": [
			"bullet",
			"railway",
			"shinkansen",
			"speed",
			"train"
		]
	},
	"1f688": {
		"name": "light rail",
		"unicode_version": 6,
		"category": "travel",
		"order": 1652,
		"display": 1,
		"shortname": ":light_rail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f688",
			"fully_qualified": "1f688",
			"non_fully_qualified": "1f688",
			"output": "1f688",
			"default_matches": [
				"1f688"
			],
			"greedy_matches": [
				"1f688"
			],
			"decimal": ""
		},
		"keywords": [
			"railway"
		]
	},
	"1f682": {
		"name": "locomotive",
		"unicode_version": 6,
		"category": "travel",
		"order": 1653,
		"display": 1,
		"shortname": ":steam_locomotive:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f682",
			"fully_qualified": "1f682",
			"non_fully_qualified": "1f682",
			"output": "1f682",
			"default_matches": [
				"1f682"
			],
			"greedy_matches": [
				"1f682"
			],
			"decimal": ""
		},
		"keywords": [
			"engine",
			"railway",
			"steam",
			"train"
		]
	},
	"1f686": {
		"name": "train",
		"unicode_version": 6,
		"category": "travel",
		"order": 1654,
		"display": 1,
		"shortname": ":train2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f686",
			"fully_qualified": "1f686",
			"non_fully_qualified": "1f686",
			"output": "1f686",
			"default_matches": [
				"1f686"
			],
			"greedy_matches": [
				"1f686"
			],
			"decimal": ""
		},
		"keywords": [
			"railway"
		]
	},
	"1f687": {
		"name": "metro",
		"unicode_version": 6,
		"category": "travel",
		"order": 1655,
		"display": 1,
		"shortname": ":metro:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f687",
			"fully_qualified": "1f687",
			"non_fully_qualified": "1f687",
			"output": "1f687",
			"default_matches": [
				"1f687"
			],
			"greedy_matches": [
				"1f687"
			],
			"decimal": ""
		},
		"keywords": [
			"subway"
		]
	},
	"1f68a": {
		"name": "tram",
		"unicode_version": 6,
		"category": "travel",
		"order": 1656,
		"display": 1,
		"shortname": ":tram:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68a",
			"fully_qualified": "1f68a",
			"non_fully_qualified": "1f68a",
			"output": "1f68a",
			"default_matches": [
				"1f68a"
			],
			"greedy_matches": [
				"1f68a"
			],
			"decimal": ""
		},
		"keywords": [
			"trolleybus"
		]
	},
	"1f689": {
		"name": "station",
		"unicode_version": 6,
		"category": "travel",
		"order": 1657,
		"display": 1,
		"shortname": ":station:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f689",
			"fully_qualified": "1f689",
			"non_fully_qualified": "1f689",
			"output": "1f689",
			"default_matches": [
				"1f689"
			],
			"greedy_matches": [
				"1f689"
			],
			"decimal": ""
		},
		"keywords": [
			"railway",
			"train"
		]
	},
	"1f681": {
		"name": "helicopter",
		"unicode_version": 6,
		"category": "travel",
		"order": 1658,
		"display": 1,
		"shortname": ":helicopter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f681",
			"fully_qualified": "1f681",
			"non_fully_qualified": "1f681",
			"output": "1f681",
			"default_matches": [
				"1f681"
			],
			"greedy_matches": [
				"1f681"
			],
			"decimal": ""
		},
		"keywords": [
			"vehicle"
		]
	},
	"1f6e9": {
		"name": "small airplane",
		"unicode_version": 7,
		"category": "travel",
		"order": 1659,
		"display": 1,
		"shortname": ":airplane_small:",
		"shortname_alternates": [
			":small_airplane:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e9",
			"fully_qualified": "1f6e9-fe0f",
			"non_fully_qualified": "1f6e9",
			"output": "1f6e9-fe0f",
			"default_matches": [
				"1f6e9-fe0f",
				"1f6e9"
			],
			"greedy_matches": [
				"1f6e9-fe0f",
				"1f6e9"
			],
			"decimal": ""
		},
		"keywords": [
			"aeroplane",
			"airplane"
		]
	},
	"1f6eb": {
		"name": "airplane departure",
		"unicode_version": 7,
		"category": "travel",
		"order": 1661,
		"display": 1,
		"shortname": ":airplane_departure:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6eb",
			"fully_qualified": "1f6eb",
			"non_fully_qualified": "1f6eb",
			"output": "1f6eb",
			"default_matches": [
				"1f6eb"
			],
			"greedy_matches": [
				"1f6eb"
			],
			"decimal": ""
		},
		"keywords": [
			"aeroplane",
			"airplane",
			"check-in",
			"departure",
			"departures"
		]
	},
	"1f6ec": {
		"name": "airplane arrival",
		"unicode_version": 7,
		"category": "travel",
		"order": 1662,
		"display": 1,
		"shortname": ":airplane_arriving:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ec",
			"fully_qualified": "1f6ec",
			"non_fully_qualified": "1f6ec",
			"output": "1f6ec",
			"default_matches": [
				"1f6ec"
			],
			"greedy_matches": [
				"1f6ec"
			],
			"decimal": ""
		},
		"keywords": [
			"aeroplane",
			"airplane",
			"arrivals",
			"arriving",
			"landing"
		]
	},
	"1f680": {
		"name": "rocket",
		"unicode_version": 6,
		"category": "travel",
		"order": 1663,
		"display": 1,
		"shortname": ":rocket:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f680",
			"fully_qualified": "1f680",
			"non_fully_qualified": "1f680",
			"output": "1f680",
			"default_matches": [
				"1f680"
			],
			"greedy_matches": [
				"1f680"
			],
			"decimal": ""
		},
		"keywords": [
			"space"
		]
	},
	"1f6f0": {
		"name": "satellite",
		"unicode_version": 7,
		"category": "travel",
		"order": 1664,
		"display": 1,
		"shortname": ":satellite_orbital:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f0",
			"fully_qualified": "1f6f0-fe0f",
			"non_fully_qualified": "1f6f0",
			"output": "1f6f0-fe0f",
			"default_matches": [
				"1f6f0-fe0f",
				"1f6f0"
			],
			"greedy_matches": [
				"1f6f0-fe0f",
				"1f6f0"
			],
			"decimal": ""
		},
		"keywords": [
			"space"
		]
	},
	"1f4ba": {
		"name": "seat",
		"unicode_version": 6,
		"category": "travel",
		"order": 1665,
		"display": 1,
		"shortname": ":seat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ba",
			"fully_qualified": "1f4ba",
			"non_fully_qualified": "1f4ba",
			"output": "1f4ba",
			"default_matches": [
				"1f4ba"
			],
			"greedy_matches": [
				"1f4ba"
			],
			"decimal": ""
		},
		"keywords": [
			"chair"
		]
	},
	"1f6f6": {
		"name": "canoe",
		"unicode_version": 9,
		"category": "travel",
		"order": 1666,
		"display": 1,
		"shortname": ":canoe:",
		"shortname_alternates": [
			":kayak:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f6",
			"fully_qualified": "1f6f6",
			"non_fully_qualified": "1f6f6",
			"output": "1f6f6",
			"default_matches": [
				"1f6f6"
			],
			"greedy_matches": [
				"1f6f6"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"canoe"
		]
	},
	"26f5": {
		"name": "sailboat",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1667,
		"display": 1,
		"shortname": ":sailboat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f5",
			"fully_qualified": "26f5",
			"non_fully_qualified": "26f5",
			"output": "26f5",
			"default_matches": [
				"26f5"
			],
			"greedy_matches": [
				"26f5"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"resort",
			"sea",
			"yacht"
		]
	},
	"1f6e5": {
		"name": "motor boat",
		"unicode_version": 7,
		"category": "travel",
		"order": 1668,
		"display": 1,
		"shortname": ":motorboat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e5",
			"fully_qualified": "1f6e5-fe0f",
			"non_fully_qualified": "1f6e5",
			"output": "1f6e5-fe0f",
			"default_matches": [
				"1f6e5-fe0f",
				"1f6e5"
			],
			"greedy_matches": [
				"1f6e5-fe0f",
				"1f6e5"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"motorboat"
		]
	},
	"1f6a4": {
		"name": "speedboat",
		"unicode_version": 6,
		"category": "travel",
		"order": 1669,
		"display": 1,
		"shortname": ":speedboat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a4",
			"fully_qualified": "1f6a4",
			"non_fully_qualified": "1f6a4",
			"output": "1f6a4",
			"default_matches": [
				"1f6a4"
			],
			"greedy_matches": [
				"1f6a4"
			],
			"decimal": ""
		},
		"keywords": [
			"boat"
		]
	},
	"1f6f3": {
		"name": "passenger ship",
		"unicode_version": 7,
		"category": "travel",
		"order": 1670,
		"display": 1,
		"shortname": ":cruise_ship:",
		"shortname_alternates": [
			":passenger_ship:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f3",
			"fully_qualified": "1f6f3-fe0f",
			"non_fully_qualified": "1f6f3",
			"output": "1f6f3-fe0f",
			"default_matches": [
				"1f6f3-fe0f",
				"1f6f3"
			],
			"greedy_matches": [
				"1f6f3-fe0f",
				"1f6f3"
			],
			"decimal": ""
		},
		"keywords": [
			"passenger",
			"ship"
		]
	},
	"26f4": {
		"name": "ferry",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1671,
		"display": 1,
		"shortname": ":ferry:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f4",
			"fully_qualified": "26f4-fe0f",
			"non_fully_qualified": "26f4",
			"output": "26f4-fe0f",
			"default_matches": [
				"26f4-fe0f",
				"26f4"
			],
			"greedy_matches": [
				"26f4-fe0f",
				"26f4"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"passenger"
		]
	},
	"1f6a2": {
		"name": "ship",
		"unicode_version": 6,
		"category": "travel",
		"order": 1672,
		"display": 1,
		"shortname": ":ship:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a2",
			"fully_qualified": "1f6a2",
			"non_fully_qualified": "1f6a2",
			"output": "1f6a2",
			"default_matches": [
				"1f6a2"
			],
			"greedy_matches": [
				"1f6a2"
			],
			"decimal": ""
		},
		"keywords": [
			"boat",
			"passenger"
		]
	},
	"1f6a7": {
		"name": "construction",
		"unicode_version": 6,
		"category": "travel",
		"order": 1674,
		"display": 1,
		"shortname": ":construction:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a7",
			"fully_qualified": "1f6a7",
			"non_fully_qualified": "1f6a7",
			"output": "1f6a7",
			"default_matches": [
				"1f6a7"
			],
			"greedy_matches": [
				"1f6a7"
			],
			"decimal": ""
		},
		"keywords": [
			"barrier"
		]
	},
	"26fd": {
		"name": "fuel pump",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1675,
		"display": 1,
		"shortname": ":fuelpump:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26fd",
			"fully_qualified": "26fd",
			"non_fully_qualified": "26fd",
			"output": "26fd",
			"default_matches": [
				"26fd"
			],
			"greedy_matches": [
				"26fd"
			],
			"decimal": ""
		},
		"keywords": [
			"fuel",
			"fuelpump",
			"gas",
			"pump",
			"station"
		]
	},
	"1f68f": {
		"name": "bus stop",
		"unicode_version": 6,
		"category": "travel",
		"order": 1676,
		"display": 1,
		"shortname": ":busstop:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f68f",
			"fully_qualified": "1f68f",
			"non_fully_qualified": "1f68f",
			"output": "1f68f",
			"default_matches": [
				"1f68f"
			],
			"greedy_matches": [
				"1f68f"
			],
			"decimal": ""
		},
		"keywords": [
			"bus",
			"busstop",
			"stop"
		]
	},
	"1f6a6": {
		"name": "vertical traffic light",
		"unicode_version": 6,
		"category": "travel",
		"order": 1677,
		"display": 1,
		"shortname": ":vertical_traffic_light:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a6",
			"fully_qualified": "1f6a6",
			"non_fully_qualified": "1f6a6",
			"output": "1f6a6",
			"default_matches": [
				"1f6a6"
			],
			"greedy_matches": [
				"1f6a6"
			],
			"decimal": ""
		},
		"keywords": [
			"light",
			"signal",
			"traffic"
		]
	},
	"1f6a5": {
		"name": "horizontal traffic light",
		"unicode_version": 6,
		"category": "travel",
		"order": 1678,
		"display": 1,
		"shortname": ":traffic_light:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a5",
			"fully_qualified": "1f6a5",
			"non_fully_qualified": "1f6a5",
			"output": "1f6a5",
			"default_matches": [
				"1f6a5"
			],
			"greedy_matches": [
				"1f6a5"
			],
			"decimal": ""
		},
		"keywords": [
			"light",
			"signal",
			"traffic"
		]
	},
	"1f5fa": {
		"name": "world map",
		"unicode_version": 7,
		"category": "travel",
		"order": 1679,
		"display": 1,
		"shortname": ":map:",
		"shortname_alternates": [
			":world_map:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5fa",
			"fully_qualified": "1f5fa-fe0f",
			"non_fully_qualified": "1f5fa",
			"output": "1f5fa-fe0f",
			"default_matches": [
				"1f5fa-fe0f",
				"1f5fa"
			],
			"greedy_matches": [
				"1f5fa-fe0f",
				"1f5fa"
			],
			"decimal": ""
		},
		"keywords": [
			"map",
			"world"
		]
	},
	"1f5ff": {
		"name": "moai",
		"unicode_version": 6,
		"category": "travel",
		"order": 1680,
		"display": 1,
		"shortname": ":moyai:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5ff",
			"fully_qualified": "1f5ff",
			"non_fully_qualified": "1f5ff",
			"output": "1f5ff",
			"default_matches": [
				"1f5ff"
			],
			"greedy_matches": [
				"1f5ff"
			],
			"decimal": ""
		},
		"keywords": [
			"face",
			"moyai",
			"statue"
		]
	},
	"1f5fd": {
		"name": "Statue of Liberty",
		"unicode_version": 6,
		"category": "travel",
		"order": 1681,
		"display": 1,
		"shortname": ":statue_of_liberty:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5fd",
			"fully_qualified": "1f5fd",
			"non_fully_qualified": "1f5fd",
			"output": "1f5fd",
			"default_matches": [
				"1f5fd"
			],
			"greedy_matches": [
				"1f5fd"
			],
			"decimal": ""
		},
		"keywords": [
			"liberty",
			"statue"
		]
	},
	"26f2": {
		"name": "fountain",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1682,
		"display": 1,
		"shortname": ":fountain:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f2",
			"fully_qualified": "26f2",
			"non_fully_qualified": "26f2",
			"output": "26f2",
			"default_matches": [
				"26f2"
			],
			"greedy_matches": [
				"26f2"
			],
			"decimal": ""
		},
		"keywords": [
			"fountain"
		]
	},
	"1f5fc": {
		"name": "Tokyo tower",
		"unicode_version": 6,
		"category": "travel",
		"order": 1683,
		"display": 1,
		"shortname": ":tokyo_tower:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5fc",
			"fully_qualified": "1f5fc",
			"non_fully_qualified": "1f5fc",
			"output": "1f5fc",
			"default_matches": [
				"1f5fc"
			],
			"greedy_matches": [
				"1f5fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Tokyo",
			"tower"
		]
	},
	"1f3f0": {
		"name": "castle",
		"unicode_version": 6,
		"category": "travel",
		"order": 1684,
		"display": 1,
		"shortname": ":european_castle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f0",
			"fully_qualified": "1f3f0",
			"non_fully_qualified": "1f3f0",
			"output": "1f3f0",
			"default_matches": [
				"1f3f0"
			],
			"greedy_matches": [
				"1f3f0"
			],
			"decimal": ""
		},
		"keywords": [
			"European"
		]
	},
	"1f3ef": {
		"name": "Japanese castle",
		"unicode_version": 6,
		"category": "travel",
		"order": 1685,
		"display": 1,
		"shortname": ":japanese_castle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ef",
			"fully_qualified": "1f3ef",
			"non_fully_qualified": "1f3ef",
			"output": "1f3ef",
			"default_matches": [
				"1f3ef"
			],
			"greedy_matches": [
				"1f3ef"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"castle"
		]
	},
	"1f3df": {
		"name": "stadium",
		"unicode_version": 7,
		"category": "travel",
		"order": 1686,
		"display": 1,
		"shortname": ":stadium:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3df",
			"fully_qualified": "1f3df-fe0f",
			"non_fully_qualified": "1f3df",
			"output": "1f3df-fe0f",
			"default_matches": [
				"1f3df-fe0f",
				"1f3df"
			],
			"greedy_matches": [
				"1f3df-fe0f",
				"1f3df"
			],
			"decimal": ""
		},
		"keywords": [
			"stadium"
		]
	},
	"1f3a1": {
		"name": "ferris wheel",
		"unicode_version": 6,
		"category": "travel",
		"order": 1687,
		"display": 1,
		"shortname": ":ferris_wheel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a1",
			"fully_qualified": "1f3a1",
			"non_fully_qualified": "1f3a1",
			"output": "1f3a1",
			"default_matches": [
				"1f3a1"
			],
			"greedy_matches": [
				"1f3a1"
			],
			"decimal": ""
		},
		"keywords": [
			"amusement park",
			"ferris",
			"wheel"
		]
	},
	"1f3a2": {
		"name": "roller coaster",
		"unicode_version": 6,
		"category": "travel",
		"order": 1688,
		"display": 1,
		"shortname": ":roller_coaster:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a2",
			"fully_qualified": "1f3a2",
			"non_fully_qualified": "1f3a2",
			"output": "1f3a2",
			"default_matches": [
				"1f3a2"
			],
			"greedy_matches": [
				"1f3a2"
			],
			"decimal": ""
		},
		"keywords": [
			"amusement park",
			"coaster",
			"roller"
		]
	},
	"1f3a0": {
		"name": "carousel horse",
		"unicode_version": 6,
		"category": "travel",
		"order": 1689,
		"display": 1,
		"shortname": ":carousel_horse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a0",
			"fully_qualified": "1f3a0",
			"non_fully_qualified": "1f3a0",
			"output": "1f3a0",
			"default_matches": [
				"1f3a0"
			],
			"greedy_matches": [
				"1f3a0"
			],
			"decimal": ""
		},
		"keywords": [
			"carousel",
			"horse"
		]
	},
	"26f1": {
		"name": "umbrella on ground",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1690,
		"display": 1,
		"shortname": ":beach_umbrella:",
		"shortname_alternates": [
			":umbrella_on_ground:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f1",
			"fully_qualified": "26f1-fe0f",
			"non_fully_qualified": "26f1",
			"output": "26f1-fe0f",
			"default_matches": [
				"26f1-fe0f",
				"26f1"
			],
			"greedy_matches": [
				"26f1-fe0f",
				"26f1"
			],
			"decimal": ""
		},
		"keywords": [
			"rain",
			"sun",
			"umbrella"
		]
	},
	"1f3d6": {
		"name": "beach with umbrella",
		"unicode_version": 7,
		"category": "travel",
		"order": 1691,
		"display": 1,
		"shortname": ":beach:",
		"shortname_alternates": [
			":beach_with_umbrella:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d6",
			"fully_qualified": "1f3d6-fe0f",
			"non_fully_qualified": "1f3d6",
			"output": "1f3d6-fe0f",
			"default_matches": [
				"1f3d6-fe0f",
				"1f3d6"
			],
			"greedy_matches": [
				"1f3d6-fe0f",
				"1f3d6"
			],
			"decimal": ""
		},
		"keywords": [
			"beach",
			"umbrella"
		]
	},
	"1f3dd": {
		"name": "desert island",
		"unicode_version": 7,
		"category": "travel",
		"order": 1692,
		"display": 1,
		"shortname": ":island:",
		"shortname_alternates": [
			":desert_island:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3dd",
			"fully_qualified": "1f3dd-fe0f",
			"non_fully_qualified": "1f3dd",
			"output": "1f3dd-fe0f",
			"default_matches": [
				"1f3dd-fe0f",
				"1f3dd"
			],
			"greedy_matches": [
				"1f3dd-fe0f",
				"1f3dd"
			],
			"decimal": ""
		},
		"keywords": [
			"desert",
			"island"
		]
	},
	"26f0": {
		"name": "mountain",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1693,
		"display": 1,
		"shortname": ":mountain:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26f0",
			"fully_qualified": "26f0-fe0f",
			"non_fully_qualified": "26f0",
			"output": "26f0-fe0f",
			"default_matches": [
				"26f0-fe0f",
				"26f0"
			],
			"greedy_matches": [
				"26f0-fe0f",
				"26f0"
			],
			"decimal": ""
		},
		"keywords": [
			"mountain"
		]
	},
	"1f3d4": {
		"name": "snow-capped mountain",
		"unicode_version": 7,
		"category": "travel",
		"order": 1694,
		"display": 1,
		"shortname": ":mountain_snow:",
		"shortname_alternates": [
			":snow_capped_mountain:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d4",
			"fully_qualified": "1f3d4-fe0f",
			"non_fully_qualified": "1f3d4",
			"output": "1f3d4-fe0f",
			"default_matches": [
				"1f3d4-fe0f",
				"1f3d4"
			],
			"greedy_matches": [
				"1f3d4-fe0f",
				"1f3d4"
			],
			"decimal": ""
		},
		"keywords": [
			"cold",
			"mountain",
			"snow"
		]
	},
	"1f5fb": {
		"name": "mount fuji",
		"unicode_version": 6,
		"category": "travel",
		"order": 1695,
		"display": 1,
		"shortname": ":mount_fuji:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5fb",
			"fully_qualified": "1f5fb",
			"non_fully_qualified": "1f5fb",
			"output": "1f5fb",
			"default_matches": [
				"1f5fb"
			],
			"greedy_matches": [
				"1f5fb"
			],
			"decimal": ""
		},
		"keywords": [
			"fuji",
			"mountain"
		]
	},
	"1f30b": {
		"name": "volcano",
		"unicode_version": 6,
		"category": "travel",
		"order": 1696,
		"display": 1,
		"shortname": ":volcano:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30b",
			"fully_qualified": "1f30b",
			"non_fully_qualified": "1f30b",
			"output": "1f30b",
			"default_matches": [
				"1f30b"
			],
			"greedy_matches": [
				"1f30b"
			],
			"decimal": ""
		},
		"keywords": [
			"eruption",
			"mountain"
		]
	},
	"1f3dc": {
		"name": "desert",
		"unicode_version": 7,
		"category": "travel",
		"order": 1697,
		"display": 1,
		"shortname": ":desert:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3dc",
			"fully_qualified": "1f3dc-fe0f",
			"non_fully_qualified": "1f3dc",
			"output": "1f3dc-fe0f",
			"default_matches": [
				"1f3dc-fe0f",
				"1f3dc"
			],
			"greedy_matches": [
				"1f3dc-fe0f",
				"1f3dc"
			],
			"decimal": ""
		},
		"keywords": [
			"desert"
		]
	},
	"1f3d5": {
		"name": "camping",
		"unicode_version": 7,
		"category": "travel",
		"order": 1698,
		"display": 1,
		"shortname": ":camping:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d5",
			"fully_qualified": "1f3d5-fe0f",
			"non_fully_qualified": "1f3d5",
			"output": "1f3d5-fe0f",
			"default_matches": [
				"1f3d5-fe0f",
				"1f3d5"
			],
			"greedy_matches": [
				"1f3d5-fe0f",
				"1f3d5"
			],
			"decimal": ""
		},
		"keywords": [
			"camping"
		]
	},
	"26fa": {
		"name": "tent",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1699,
		"display": 1,
		"shortname": ":tent:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26fa",
			"fully_qualified": "26fa",
			"non_fully_qualified": "26fa",
			"output": "26fa",
			"default_matches": [
				"26fa"
			],
			"greedy_matches": [
				"26fa"
			],
			"decimal": ""
		},
		"keywords": [
			"camping"
		]
	},
	"1f6e4": {
		"name": "railway track",
		"unicode_version": 7,
		"category": "travel",
		"order": 1700,
		"display": 1,
		"shortname": ":railway_track:",
		"shortname_alternates": [
			":railroad_track:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e4",
			"fully_qualified": "1f6e4-fe0f",
			"non_fully_qualified": "1f6e4",
			"output": "1f6e4-fe0f",
			"default_matches": [
				"1f6e4-fe0f",
				"1f6e4"
			],
			"greedy_matches": [
				"1f6e4-fe0f",
				"1f6e4"
			],
			"decimal": ""
		},
		"keywords": [
			"railway",
			"train"
		]
	},
	"1f6e3": {
		"name": "motorway",
		"unicode_version": 7,
		"category": "travel",
		"order": 1701,
		"display": 1,
		"shortname": ":motorway:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e3",
			"fully_qualified": "1f6e3-fe0f",
			"non_fully_qualified": "1f6e3",
			"output": "1f6e3-fe0f",
			"default_matches": [
				"1f6e3-fe0f",
				"1f6e3"
			],
			"greedy_matches": [
				"1f6e3-fe0f",
				"1f6e3"
			],
			"decimal": ""
		},
		"keywords": [
			"highway",
			"road"
		]
	},
	"1f3d7": {
		"name": "building construction",
		"unicode_version": 7,
		"category": "travel",
		"order": 1702,
		"display": 1,
		"shortname": ":construction_site:",
		"shortname_alternates": [
			":building_construction:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d7",
			"fully_qualified": "1f3d7-fe0f",
			"non_fully_qualified": "1f3d7",
			"output": "1f3d7-fe0f",
			"default_matches": [
				"1f3d7-fe0f",
				"1f3d7"
			],
			"greedy_matches": [
				"1f3d7-fe0f",
				"1f3d7"
			],
			"decimal": ""
		},
		"keywords": [
			"construction"
		]
	},
	"1f3ed": {
		"name": "factory",
		"unicode_version": 6,
		"category": "travel",
		"order": 1703,
		"display": 1,
		"shortname": ":factory:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ed",
			"fully_qualified": "1f3ed",
			"non_fully_qualified": "1f3ed",
			"output": "1f3ed",
			"default_matches": [
				"1f3ed"
			],
			"greedy_matches": [
				"1f3ed"
			],
			"decimal": ""
		},
		"keywords": [
			"building"
		]
	},
	"1f3e0": {
		"name": "house",
		"unicode_version": 6,
		"category": "travel",
		"order": 1704,
		"display": 1,
		"shortname": ":house:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e0",
			"fully_qualified": "1f3e0",
			"non_fully_qualified": "1f3e0",
			"output": "1f3e0",
			"default_matches": [
				"1f3e0"
			],
			"greedy_matches": [
				"1f3e0"
			],
			"decimal": ""
		},
		"keywords": [
			"home",
			"house"
		]
	},
	"1f3e1": {
		"name": "house with garden",
		"unicode_version": 6,
		"category": "travel",
		"order": 1705,
		"display": 1,
		"shortname": ":house_with_garden:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e1",
			"fully_qualified": "1f3e1",
			"non_fully_qualified": "1f3e1",
			"output": "1f3e1",
			"default_matches": [
				"1f3e1"
			],
			"greedy_matches": [
				"1f3e1"
			],
			"decimal": ""
		},
		"keywords": [
			"garden",
			"home",
			"house"
		]
	},
	"1f3d8": {
		"name": "houses",
		"unicode_version": 7,
		"category": "travel",
		"order": 1706,
		"display": 1,
		"shortname": ":homes:",
		"shortname_alternates": [
			":house_buildings:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d8",
			"fully_qualified": "1f3d8-fe0f",
			"non_fully_qualified": "1f3d8",
			"output": "1f3d8-fe0f",
			"default_matches": [
				"1f3d8-fe0f",
				"1f3d8"
			],
			"greedy_matches": [
				"1f3d8-fe0f",
				"1f3d8"
			],
			"decimal": ""
		},
		"keywords": [
			"houses"
		]
	},
	"1f3da": {
		"name": "derelict house",
		"unicode_version": 7,
		"category": "travel",
		"order": 1707,
		"display": 1,
		"shortname": ":house_abandoned:",
		"shortname_alternates": [
			":derelict_house_building:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3da",
			"fully_qualified": "1f3da-fe0f",
			"non_fully_qualified": "1f3da",
			"output": "1f3da-fe0f",
			"default_matches": [
				"1f3da-fe0f",
				"1f3da"
			],
			"greedy_matches": [
				"1f3da-fe0f",
				"1f3da"
			],
			"decimal": ""
		},
		"keywords": [
			"derelict",
			"house"
		]
	},
	"1f3e2": {
		"name": "office building",
		"unicode_version": 6,
		"category": "travel",
		"order": 1708,
		"display": 1,
		"shortname": ":office:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e2",
			"fully_qualified": "1f3e2",
			"non_fully_qualified": "1f3e2",
			"output": "1f3e2",
			"default_matches": [
				"1f3e2"
			],
			"greedy_matches": [
				"1f3e2"
			],
			"decimal": ""
		},
		"keywords": [
			"building"
		]
	},
	"1f3ec": {
		"name": "department store",
		"unicode_version": 6,
		"category": "travel",
		"order": 1709,
		"display": 1,
		"shortname": ":department_store:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ec",
			"fully_qualified": "1f3ec",
			"non_fully_qualified": "1f3ec",
			"output": "1f3ec",
			"default_matches": [
				"1f3ec"
			],
			"greedy_matches": [
				"1f3ec"
			],
			"decimal": ""
		},
		"keywords": [
			"department",
			"store"
		]
	},
	"1f3e3": {
		"name": "Japanese post office",
		"unicode_version": 6,
		"category": "travel",
		"order": 1710,
		"display": 1,
		"shortname": ":post_office:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e3",
			"fully_qualified": "1f3e3",
			"non_fully_qualified": "1f3e3",
			"output": "1f3e3",
			"default_matches": [
				"1f3e3"
			],
			"greedy_matches": [
				"1f3e3"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"post"
		]
	},
	"1f3e4": {
		"name": "post office",
		"unicode_version": 6,
		"category": "travel",
		"order": 1711,
		"display": 1,
		"shortname": ":european_post_office:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e4",
			"fully_qualified": "1f3e4",
			"non_fully_qualified": "1f3e4",
			"output": "1f3e4",
			"default_matches": [
				"1f3e4"
			],
			"greedy_matches": [
				"1f3e4"
			],
			"decimal": ""
		},
		"keywords": [
			"European",
			"post"
		]
	},
	"1f3e5": {
		"name": "hospital",
		"unicode_version": 6,
		"category": "travel",
		"order": 1712,
		"display": 1,
		"shortname": ":hospital:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e5",
			"fully_qualified": "1f3e5",
			"non_fully_qualified": "1f3e5",
			"output": "1f3e5",
			"default_matches": [
				"1f3e5"
			],
			"greedy_matches": [
				"1f3e5"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"medicine"
		]
	},
	"1f3e6": {
		"name": "bank",
		"unicode_version": 6,
		"category": "travel",
		"order": 1713,
		"display": 1,
		"shortname": ":bank:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e6",
			"fully_qualified": "1f3e6",
			"non_fully_qualified": "1f3e6",
			"output": "1f3e6",
			"default_matches": [
				"1f3e6"
			],
			"greedy_matches": [
				"1f3e6"
			],
			"decimal": ""
		},
		"keywords": [
			"building"
		]
	},
	"1f3e8": {
		"name": "hotel",
		"unicode_version": 6,
		"category": "travel",
		"order": 1714,
		"display": 1,
		"shortname": ":hotel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e8",
			"fully_qualified": "1f3e8",
			"non_fully_qualified": "1f3e8",
			"output": "1f3e8",
			"default_matches": [
				"1f3e8"
			],
			"greedy_matches": [
				"1f3e8"
			],
			"decimal": ""
		},
		"keywords": [
			"building"
		]
	},
	"1f3ea": {
		"name": "convenience store",
		"unicode_version": 6,
		"category": "travel",
		"order": 1715,
		"display": 1,
		"shortname": ":convenience_store:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ea",
			"fully_qualified": "1f3ea",
			"non_fully_qualified": "1f3ea",
			"output": "1f3ea",
			"default_matches": [
				"1f3ea"
			],
			"greedy_matches": [
				"1f3ea"
			],
			"decimal": ""
		},
		"keywords": [
			"convenience",
			"store"
		]
	},
	"1f3eb": {
		"name": "school",
		"unicode_version": 6,
		"category": "travel",
		"order": 1716,
		"display": 1,
		"shortname": ":school:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3eb",
			"fully_qualified": "1f3eb",
			"non_fully_qualified": "1f3eb",
			"output": "1f3eb",
			"default_matches": [
				"1f3eb"
			],
			"greedy_matches": [
				"1f3eb"
			],
			"decimal": ""
		},
		"keywords": [
			"building"
		]
	},
	"1f3e9": {
		"name": "love hotel",
		"unicode_version": 6,
		"category": "travel",
		"order": 1717,
		"display": 1,
		"shortname": ":love_hotel:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e9",
			"fully_qualified": "1f3e9",
			"non_fully_qualified": "1f3e9",
			"output": "1f3e9",
			"default_matches": [
				"1f3e9"
			],
			"greedy_matches": [
				"1f3e9"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"love"
		]
	},
	"1f492": {
		"name": "wedding",
		"unicode_version": 6,
		"category": "travel",
		"order": 1718,
		"display": 1,
		"shortname": ":wedding:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f492",
			"fully_qualified": "1f492",
			"non_fully_qualified": "1f492",
			"output": "1f492",
			"default_matches": [
				"1f492"
			],
			"greedy_matches": [
				"1f492"
			],
			"decimal": ""
		},
		"keywords": [
			"chapel",
			"romance"
		]
	},
	"1f3db": {
		"name": "classical building",
		"unicode_version": 7,
		"category": "travel",
		"order": 1719,
		"display": 1,
		"shortname": ":classical_building:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3db",
			"fully_qualified": "1f3db-fe0f",
			"non_fully_qualified": "1f3db",
			"output": "1f3db-fe0f",
			"default_matches": [
				"1f3db-fe0f",
				"1f3db"
			],
			"greedy_matches": [
				"1f3db-fe0f",
				"1f3db"
			],
			"decimal": ""
		},
		"keywords": [
			"classical"
		]
	},
	"26ea": {
		"name": "church",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1720,
		"display": 1,
		"shortname": ":church:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26ea",
			"fully_qualified": "26ea",
			"non_fully_qualified": "26ea",
			"output": "26ea",
			"default_matches": [
				"26ea"
			],
			"greedy_matches": [
				"26ea"
			],
			"decimal": ""
		},
		"keywords": [
			"Christian",
			"cross",
			"religion"
		]
	},
	"1f54c": {
		"name": "mosque",
		"unicode_version": 8,
		"category": "travel",
		"order": 1721,
		"display": 1,
		"shortname": ":mosque:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f54c",
			"fully_qualified": "1f54c",
			"non_fully_qualified": "1f54c",
			"output": "1f54c",
			"default_matches": [
				"1f54c"
			],
			"greedy_matches": [
				"1f54c"
			],
			"decimal": ""
		},
		"keywords": [
			"Muslim",
			"islam",
			"religion"
		]
	},
	"1f54d": {
		"name": "synagogue",
		"unicode_version": 8,
		"category": "travel",
		"order": 1722,
		"display": 1,
		"shortname": ":synagogue:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f54d",
			"fully_qualified": "1f54d",
			"non_fully_qualified": "1f54d",
			"output": "1f54d",
			"default_matches": [
				"1f54d"
			],
			"greedy_matches": [
				"1f54d"
			],
			"decimal": ""
		},
		"keywords": [
			"Jew",
			"Jewish",
			"religion",
			"temple"
		]
	},
	"1f54b": {
		"name": "kaaba",
		"unicode_version": 8,
		"category": "travel",
		"order": 1723,
		"display": 1,
		"shortname": ":kaaba:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f54b",
			"fully_qualified": "1f54b",
			"non_fully_qualified": "1f54b",
			"output": "1f54b",
			"default_matches": [
				"1f54b"
			],
			"greedy_matches": [
				"1f54b"
			],
			"decimal": ""
		},
		"keywords": [
			"Muslim",
			"islam",
			"religion"
		]
	},
	"26e9": {
		"name": "shinto shrine",
		"unicode_version": 5.2,
		"category": "travel",
		"order": 1724,
		"display": 1,
		"shortname": ":shinto_shrine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26e9",
			"fully_qualified": "26e9-fe0f",
			"non_fully_qualified": "26e9",
			"output": "26e9-fe0f",
			"default_matches": [
				"26e9-fe0f",
				"26e9"
			],
			"greedy_matches": [
				"26e9-fe0f",
				"26e9"
			],
			"decimal": ""
		},
		"keywords": [
			"religion",
			"shinto",
			"shrine"
		]
	},
	"1f5fe": {
		"name": "map of Japan",
		"unicode_version": 6,
		"category": "travel",
		"order": 1725,
		"display": 1,
		"shortname": ":japan:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5fe",
			"fully_qualified": "1f5fe",
			"non_fully_qualified": "1f5fe",
			"output": "1f5fe",
			"default_matches": [
				"1f5fe"
			],
			"greedy_matches": [
				"1f5fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Japan",
			"map"
		]
	},
	"1f391": {
		"name": "moon viewing ceremony",
		"unicode_version": 6,
		"category": "travel",
		"order": 1726,
		"display": 1,
		"shortname": ":rice_scene:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f391",
			"fully_qualified": "1f391",
			"non_fully_qualified": "1f391",
			"output": "1f391",
			"default_matches": [
				"1f391"
			],
			"greedy_matches": [
				"1f391"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"ceremony",
			"moon"
		]
	},
	"1f3de": {
		"name": "national park",
		"unicode_version": 7,
		"category": "travel",
		"order": 1727,
		"display": 1,
		"shortname": ":park:",
		"shortname_alternates": [
			":national_park:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3de",
			"fully_qualified": "1f3de-fe0f",
			"non_fully_qualified": "1f3de",
			"output": "1f3de-fe0f",
			"default_matches": [
				"1f3de-fe0f",
				"1f3de"
			],
			"greedy_matches": [
				"1f3de-fe0f",
				"1f3de"
			],
			"decimal": ""
		},
		"keywords": [
			"park"
		]
	},
	"1f305": {
		"name": "sunrise",
		"unicode_version": 6,
		"category": "travel",
		"order": 1728,
		"display": 1,
		"shortname": ":sunrise:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f305",
			"fully_qualified": "1f305",
			"non_fully_qualified": "1f305",
			"output": "1f305",
			"default_matches": [
				"1f305"
			],
			"greedy_matches": [
				"1f305"
			],
			"decimal": ""
		},
		"keywords": [
			"morning",
			"sun"
		]
	},
	"1f304": {
		"name": "sunrise over mountains",
		"unicode_version": 6,
		"category": "travel",
		"order": 1729,
		"display": 1,
		"shortname": ":sunrise_over_mountains:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f304",
			"fully_qualified": "1f304",
			"non_fully_qualified": "1f304",
			"output": "1f304",
			"default_matches": [
				"1f304"
			],
			"greedy_matches": [
				"1f304"
			],
			"decimal": ""
		},
		"keywords": [
			"morning",
			"mountain",
			"sun",
			"sunrise"
		]
	},
	"1f320": {
		"name": "shooting star",
		"unicode_version": 6,
		"category": "travel",
		"order": 1730,
		"display": 1,
		"shortname": ":stars:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f320",
			"fully_qualified": "1f320",
			"non_fully_qualified": "1f320",
			"output": "1f320",
			"default_matches": [
				"1f320"
			],
			"greedy_matches": [
				"1f320"
			],
			"decimal": ""
		},
		"keywords": [
			"falling",
			"shooting",
			"star"
		]
	},
	"1f387": {
		"name": "sparkler",
		"unicode_version": 6,
		"category": "travel",
		"order": 1731,
		"display": 1,
		"shortname": ":sparkler:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f387",
			"fully_qualified": "1f387",
			"non_fully_qualified": "1f387",
			"output": "1f387",
			"default_matches": [
				"1f387"
			],
			"greedy_matches": [
				"1f387"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"fireworks",
			"sparkle"
		]
	},
	"1f386": {
		"name": "fireworks",
		"unicode_version": 6,
		"category": "travel",
		"order": 1732,
		"display": 1,
		"shortname": ":fireworks:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f386",
			"fully_qualified": "1f386",
			"non_fully_qualified": "1f386",
			"output": "1f386",
			"default_matches": [
				"1f386"
			],
			"greedy_matches": [
				"1f386"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration"
		]
	},
	"1f307": {
		"name": "sunset",
		"unicode_version": 6,
		"category": "travel",
		"order": 1733,
		"display": 1,
		"shortname": ":city_sunset:",
		"shortname_alternates": [
			":city_sunrise:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f307",
			"fully_qualified": "1f307",
			"non_fully_qualified": "1f307",
			"output": "1f307",
			"default_matches": [
				"1f307"
			],
			"greedy_matches": [
				"1f307"
			],
			"decimal": ""
		},
		"keywords": [
			"dusk",
			"sun"
		]
	},
	"1f306": {
		"name": "cityscape at dusk",
		"unicode_version": 6,
		"category": "travel",
		"order": 1734,
		"display": 1,
		"shortname": ":city_dusk:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f306",
			"fully_qualified": "1f306",
			"non_fully_qualified": "1f306",
			"output": "1f306",
			"default_matches": [
				"1f306"
			],
			"greedy_matches": [
				"1f306"
			],
			"decimal": ""
		},
		"keywords": [
			"city",
			"dusk",
			"evening",
			"landscape",
			"sun",
			"sunset"
		]
	},
	"1f3d9": {
		"name": "cityscape",
		"unicode_version": 7,
		"category": "travel",
		"order": 1735,
		"display": 1,
		"shortname": ":cityscape:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3d9",
			"fully_qualified": "1f3d9-fe0f",
			"non_fully_qualified": "1f3d9",
			"output": "1f3d9-fe0f",
			"default_matches": [
				"1f3d9-fe0f",
				"1f3d9"
			],
			"greedy_matches": [
				"1f3d9-fe0f",
				"1f3d9"
			],
			"decimal": ""
		},
		"keywords": [
			"city"
		]
	},
	"1f303": {
		"name": "night with stars",
		"unicode_version": 6,
		"category": "travel",
		"order": 1736,
		"display": 1,
		"shortname": ":night_with_stars:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f303",
			"fully_qualified": "1f303",
			"non_fully_qualified": "1f303",
			"output": "1f303",
			"default_matches": [
				"1f303"
			],
			"greedy_matches": [
				"1f303"
			],
			"decimal": ""
		},
		"keywords": [
			"night",
			"star"
		]
	},
	"1f30c": {
		"name": "milky way",
		"unicode_version": 6,
		"category": "travel",
		"order": 1737,
		"display": 1,
		"shortname": ":milky_way:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f30c",
			"fully_qualified": "1f30c",
			"non_fully_qualified": "1f30c",
			"output": "1f30c",
			"default_matches": [
				"1f30c"
			],
			"greedy_matches": [
				"1f30c"
			],
			"decimal": ""
		},
		"keywords": [
			"space"
		]
	},
	"1f309": {
		"name": "bridge at night",
		"unicode_version": 6,
		"category": "travel",
		"order": 1738,
		"display": 1,
		"shortname": ":bridge_at_night:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f309",
			"fully_qualified": "1f309",
			"non_fully_qualified": "1f309",
			"output": "1f309",
			"default_matches": [
				"1f309"
			],
			"greedy_matches": [
				"1f309"
			],
			"decimal": ""
		},
		"keywords": [
			"bridge",
			"night"
		]
	},
	"1f301": {
		"name": "foggy",
		"unicode_version": 6,
		"category": "travel",
		"order": 1739,
		"display": 1,
		"shortname": ":foggy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f301",
			"fully_qualified": "1f301",
			"non_fully_qualified": "1f301",
			"output": "1f301",
			"default_matches": [
				"1f301"
			],
			"greedy_matches": [
				"1f301"
			],
			"decimal": ""
		},
		"keywords": [
			"fog"
		]
	},
	"1f6f8": {
		"name": "flying saucer",
		"unicode_version": 10,
		"category": "travel",
		"order": 1740,
		"display": 1,
		"shortname": ":flying_saucer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6f8",
			"fully_qualified": "1f6f8",
			"non_fully_qualified": "1f6f8",
			"output": "1f6f8",
			"default_matches": [
				"1f6f8"
			],
			"greedy_matches": [
				"1f6f8"
			],
			"decimal": ""
		},
		"keywords": [
			"UFO"
		]
	},
	"231a": {
		"name": "watch",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1741,
		"display": 1,
		"shortname": ":watch:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "231a",
			"fully_qualified": "231a",
			"non_fully_qualified": "231a",
			"output": "231a",
			"default_matches": [
				"231a"
			],
			"greedy_matches": [
				"231a"
			],
			"decimal": ""
		},
		"keywords": [
			"clock"
		]
	},
	"1f4f1": {
		"name": "mobile phone",
		"unicode_version": 6,
		"category": "objects",
		"order": 1742,
		"display": 1,
		"shortname": ":iphone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f1",
			"fully_qualified": "1f4f1",
			"non_fully_qualified": "1f4f1",
			"output": "1f4f1",
			"default_matches": [
				"1f4f1"
			],
			"greedy_matches": [
				"1f4f1"
			],
			"decimal": ""
		},
		"keywords": [
			"cell",
			"mobile",
			"phone",
			"telephone"
		]
	},
	"1f4f2": {
		"name": "mobile phone with arrow",
		"unicode_version": 6,
		"category": "objects",
		"order": 1743,
		"display": 1,
		"shortname": ":calling:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f2",
			"fully_qualified": "1f4f2",
			"non_fully_qualified": "1f4f2",
			"output": "1f4f2",
			"default_matches": [
				"1f4f2"
			],
			"greedy_matches": [
				"1f4f2"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"call",
			"cell",
			"mobile",
			"phone",
			"receive",
			"telephone"
		]
	},
	"1f4bb": {
		"name": "laptop computer",
		"unicode_version": 6,
		"category": "objects",
		"order": 1744,
		"display": 1,
		"shortname": ":computer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4bb",
			"fully_qualified": "1f4bb",
			"non_fully_qualified": "1f4bb",
			"output": "1f4bb",
			"default_matches": [
				"1f4bb"
			],
			"greedy_matches": [
				"1f4bb"
			],
			"decimal": ""
		},
		"keywords": [
			"computer",
			"pc",
			"personal"
		]
	},
	"1f5a5": {
		"name": "desktop computer",
		"unicode_version": 7,
		"category": "objects",
		"order": 1746,
		"display": 1,
		"shortname": ":desktop:",
		"shortname_alternates": [
			":desktop_computer:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5a5",
			"fully_qualified": "1f5a5-fe0f",
			"non_fully_qualified": "1f5a5",
			"output": "1f5a5-fe0f",
			"default_matches": [
				"1f5a5-fe0f",
				"1f5a5"
			],
			"greedy_matches": [
				"1f5a5-fe0f",
				"1f5a5"
			],
			"decimal": ""
		},
		"keywords": [
			"computer",
			"desktop"
		]
	},
	"1f5a8": {
		"name": "printer",
		"unicode_version": 7,
		"category": "objects",
		"order": 1747,
		"display": 1,
		"shortname": ":printer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5a8",
			"fully_qualified": "1f5a8-fe0f",
			"non_fully_qualified": "1f5a8",
			"output": "1f5a8-fe0f",
			"default_matches": [
				"1f5a8-fe0f",
				"1f5a8"
			],
			"greedy_matches": [
				"1f5a8-fe0f",
				"1f5a8"
			],
			"decimal": ""
		},
		"keywords": [
			"computer"
		]
	},
	"1f5b1": {
		"name": "computer mouse",
		"unicode_version": 7,
		"category": "objects",
		"order": 1748,
		"display": 1,
		"shortname": ":mouse_three_button:",
		"shortname_alternates": [
			":three_button_mouse:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5b1",
			"fully_qualified": "1f5b1-fe0f",
			"non_fully_qualified": "1f5b1",
			"output": "1f5b1-fe0f",
			"default_matches": [
				"1f5b1-fe0f",
				"1f5b1"
			],
			"greedy_matches": [
				"1f5b1-fe0f",
				"1f5b1"
			],
			"decimal": ""
		},
		"keywords": [
			"computer"
		]
	},
	"1f5b2": {
		"name": "trackball",
		"unicode_version": 7,
		"category": "objects",
		"order": 1749,
		"display": 1,
		"shortname": ":trackball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5b2",
			"fully_qualified": "1f5b2-fe0f",
			"non_fully_qualified": "1f5b2",
			"output": "1f5b2-fe0f",
			"default_matches": [
				"1f5b2-fe0f",
				"1f5b2"
			],
			"greedy_matches": [
				"1f5b2-fe0f",
				"1f5b2"
			],
			"decimal": ""
		},
		"keywords": [
			"computer"
		]
	},
	"1f579": {
		"name": "joystick",
		"unicode_version": 7,
		"category": "objects",
		"order": 1750,
		"display": 1,
		"shortname": ":joystick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f579",
			"fully_qualified": "1f579-fe0f",
			"non_fully_qualified": "1f579",
			"output": "1f579-fe0f",
			"default_matches": [
				"1f579-fe0f",
				"1f579"
			],
			"greedy_matches": [
				"1f579-fe0f",
				"1f579"
			],
			"decimal": ""
		},
		"keywords": [
			"game",
			"video game"
		]
	},
	"1f5dc": {
		"name": "clamp",
		"unicode_version": 7,
		"category": "objects",
		"order": 1751,
		"display": 1,
		"shortname": ":compression:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5dc",
			"fully_qualified": "1f5dc-fe0f",
			"non_fully_qualified": "1f5dc",
			"output": "1f5dc-fe0f",
			"default_matches": [
				"1f5dc-fe0f",
				"1f5dc"
			],
			"greedy_matches": [
				"1f5dc-fe0f",
				"1f5dc"
			],
			"decimal": ""
		},
		"keywords": [
			"compress",
			"tool",
			"vice"
		]
	},
	"1f4bd": {
		"name": "computer disk",
		"unicode_version": 6,
		"category": "objects",
		"order": 1752,
		"display": 1,
		"shortname": ":minidisc:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4bd",
			"fully_qualified": "1f4bd",
			"non_fully_qualified": "1f4bd",
			"output": "1f4bd",
			"default_matches": [
				"1f4bd"
			],
			"greedy_matches": [
				"1f4bd"
			],
			"decimal": ""
		},
		"keywords": [
			"computer",
			"disk",
			"minidisk",
			"optical"
		]
	},
	"1f4be": {
		"name": "floppy disk",
		"unicode_version": 6,
		"category": "objects",
		"order": 1753,
		"display": 1,
		"shortname": ":floppy_disk:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4be",
			"fully_qualified": "1f4be",
			"non_fully_qualified": "1f4be",
			"output": "1f4be",
			"default_matches": [
				"1f4be"
			],
			"greedy_matches": [
				"1f4be"
			],
			"decimal": ""
		},
		"keywords": [
			"computer",
			"disk",
			"floppy"
		]
	},
	"1f4bf": {
		"name": "optical disk",
		"unicode_version": 6,
		"category": "objects",
		"order": 1754,
		"display": 1,
		"shortname": ":cd:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4bf",
			"fully_qualified": "1f4bf",
			"non_fully_qualified": "1f4bf",
			"output": "1f4bf",
			"default_matches": [
				"1f4bf"
			],
			"greedy_matches": [
				"1f4bf"
			],
			"decimal": ""
		},
		"keywords": [
			"cd",
			"computer",
			"disk",
			"optical"
		]
	},
	"1f4c0": {
		"name": "dvd",
		"unicode_version": 6,
		"category": "objects",
		"order": 1755,
		"display": 1,
		"shortname": ":dvd:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c0",
			"fully_qualified": "1f4c0",
			"non_fully_qualified": "1f4c0",
			"output": "1f4c0",
			"default_matches": [
				"1f4c0"
			],
			"greedy_matches": [
				"1f4c0"
			],
			"decimal": ""
		},
		"keywords": [
			"blu-ray",
			"computer",
			"disk",
			"dvd",
			"optical"
		]
	},
	"1f4fc": {
		"name": "videocassette",
		"unicode_version": 6,
		"category": "objects",
		"order": 1756,
		"display": 1,
		"shortname": ":vhs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4fc",
			"fully_qualified": "1f4fc",
			"non_fully_qualified": "1f4fc",
			"output": "1f4fc",
			"default_matches": [
				"1f4fc"
			],
			"greedy_matches": [
				"1f4fc"
			],
			"decimal": ""
		},
		"keywords": [
			"tape",
			"vhs",
			"video"
		]
	},
	"1f4f7": {
		"name": "camera",
		"unicode_version": 6,
		"category": "objects",
		"order": 1757,
		"display": 1,
		"shortname": ":camera:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f7",
			"fully_qualified": "1f4f7",
			"non_fully_qualified": "1f4f7",
			"output": "1f4f7",
			"default_matches": [
				"1f4f7"
			],
			"greedy_matches": [
				"1f4f7"
			],
			"decimal": ""
		},
		"keywords": [
			"video"
		]
	},
	"1f4f8": {
		"name": "camera with flash",
		"unicode_version": 7,
		"category": "objects",
		"order": 1758,
		"display": 1,
		"shortname": ":camera_with_flash:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f8",
			"fully_qualified": "1f4f8",
			"non_fully_qualified": "1f4f8",
			"output": "1f4f8",
			"default_matches": [
				"1f4f8"
			],
			"greedy_matches": [
				"1f4f8"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"flash",
			"video"
		]
	},
	"1f4f9": {
		"name": "video camera",
		"unicode_version": 6,
		"category": "objects",
		"order": 1759,
		"display": 1,
		"shortname": ":video_camera:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f9",
			"fully_qualified": "1f4f9",
			"non_fully_qualified": "1f4f9",
			"output": "1f4f9",
			"default_matches": [
				"1f4f9"
			],
			"greedy_matches": [
				"1f4f9"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"video"
		]
	},
	"1f3a5": {
		"name": "movie camera",
		"unicode_version": 6,
		"category": "objects",
		"order": 1760,
		"display": 1,
		"shortname": ":movie_camera:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a5",
			"fully_qualified": "1f3a5",
			"non_fully_qualified": "1f3a5",
			"output": "1f3a5",
			"default_matches": [
				"1f3a5"
			],
			"greedy_matches": [
				"1f3a5"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"cinema",
			"movie"
		]
	},
	"1f4fd": {
		"name": "film projector",
		"unicode_version": 7,
		"category": "objects",
		"order": 1761,
		"display": 1,
		"shortname": ":projector:",
		"shortname_alternates": [
			":film_projector:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4fd",
			"fully_qualified": "1f4fd-fe0f",
			"non_fully_qualified": "1f4fd",
			"output": "1f4fd-fe0f",
			"default_matches": [
				"1f4fd-fe0f",
				"1f4fd"
			],
			"greedy_matches": [
				"1f4fd-fe0f",
				"1f4fd"
			],
			"decimal": ""
		},
		"keywords": [
			"cinema",
			"film",
			"movie",
			"projector",
			"video"
		]
	},
	"1f39e": {
		"name": "film frames",
		"unicode_version": 7,
		"category": "objects",
		"order": 1762,
		"display": 1,
		"shortname": ":film_frames:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f39e",
			"fully_qualified": "1f39e-fe0f",
			"non_fully_qualified": "1f39e",
			"output": "1f39e-fe0f",
			"default_matches": [
				"1f39e-fe0f",
				"1f39e"
			],
			"greedy_matches": [
				"1f39e-fe0f",
				"1f39e"
			],
			"decimal": ""
		},
		"keywords": [
			"cinema",
			"film",
			"frames",
			"movie"
		]
	},
	"1f4de": {
		"name": "telephone receiver",
		"unicode_version": 6,
		"category": "objects",
		"order": 1763,
		"display": 1,
		"shortname": ":telephone_receiver:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4de",
			"fully_qualified": "1f4de",
			"non_fully_qualified": "1f4de",
			"output": "1f4de",
			"default_matches": [
				"1f4de"
			],
			"greedy_matches": [
				"1f4de"
			],
			"decimal": ""
		},
		"keywords": [
			"phone",
			"receiver",
			"telephone"
		]
	},
	"260e": {
		"name": "telephone",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1764,
		"display": 1,
		"shortname": ":telephone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "260e",
			"fully_qualified": "260e-fe0f",
			"non_fully_qualified": "260e",
			"output": "260e-fe0f",
			"default_matches": [
				"260e-fe0f",
				"260e"
			],
			"greedy_matches": [
				"260e-fe0f",
				"260e"
			],
			"decimal": ""
		},
		"keywords": [
			"phone"
		]
	},
	"1f4df": {
		"name": "pager",
		"unicode_version": 6,
		"category": "objects",
		"order": 1765,
		"display": 1,
		"shortname": ":pager:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4df",
			"fully_qualified": "1f4df",
			"non_fully_qualified": "1f4df",
			"output": "1f4df",
			"default_matches": [
				"1f4df"
			],
			"greedy_matches": [
				"1f4df"
			],
			"decimal": ""
		},
		"keywords": [
			"pager"
		]
	},
	"1f4e0": {
		"name": "fax machine",
		"unicode_version": 6,
		"category": "objects",
		"order": 1766,
		"display": 1,
		"shortname": ":fax:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e0",
			"fully_qualified": "1f4e0",
			"non_fully_qualified": "1f4e0",
			"output": "1f4e0",
			"default_matches": [
				"1f4e0"
			],
			"greedy_matches": [
				"1f4e0"
			],
			"decimal": ""
		},
		"keywords": [
			"fax"
		]
	},
	"1f4fa": {
		"name": "television",
		"unicode_version": 6,
		"category": "objects",
		"order": 1767,
		"display": 1,
		"shortname": ":tv:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4fa",
			"fully_qualified": "1f4fa",
			"non_fully_qualified": "1f4fa",
			"output": "1f4fa",
			"default_matches": [
				"1f4fa"
			],
			"greedy_matches": [
				"1f4fa"
			],
			"decimal": ""
		},
		"keywords": [
			"tv",
			"video"
		]
	},
	"1f4fb": {
		"name": "radio",
		"unicode_version": 6,
		"category": "objects",
		"order": 1768,
		"display": 1,
		"shortname": ":radio:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4fb",
			"fully_qualified": "1f4fb",
			"non_fully_qualified": "1f4fb",
			"output": "1f4fb",
			"default_matches": [
				"1f4fb"
			],
			"greedy_matches": [
				"1f4fb"
			],
			"decimal": ""
		},
		"keywords": [
			"video"
		]
	},
	"1f399": {
		"name": "studio microphone",
		"unicode_version": 7,
		"category": "objects",
		"order": 1769,
		"display": 1,
		"shortname": ":microphone2:",
		"shortname_alternates": [
			":studio_microphone:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f399",
			"fully_qualified": "1f399-fe0f",
			"non_fully_qualified": "1f399",
			"output": "1f399-fe0f",
			"default_matches": [
				"1f399-fe0f",
				"1f399"
			],
			"greedy_matches": [
				"1f399-fe0f",
				"1f399"
			],
			"decimal": ""
		},
		"keywords": [
			"mic",
			"microphone",
			"music",
			"studio"
		]
	},
	"1f39a": {
		"name": "level slider",
		"unicode_version": 7,
		"category": "objects",
		"order": 1770,
		"display": 1,
		"shortname": ":level_slider:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f39a",
			"fully_qualified": "1f39a-fe0f",
			"non_fully_qualified": "1f39a",
			"output": "1f39a-fe0f",
			"default_matches": [
				"1f39a-fe0f",
				"1f39a"
			],
			"greedy_matches": [
				"1f39a-fe0f",
				"1f39a"
			],
			"decimal": ""
		},
		"keywords": [
			"level",
			"music",
			"slider"
		]
	},
	"1f39b": {
		"name": "control knobs",
		"unicode_version": 7,
		"category": "objects",
		"order": 1771,
		"display": 1,
		"shortname": ":control_knobs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f39b",
			"fully_qualified": "1f39b-fe0f",
			"non_fully_qualified": "1f39b",
			"output": "1f39b-fe0f",
			"default_matches": [
				"1f39b-fe0f",
				"1f39b"
			],
			"greedy_matches": [
				"1f39b-fe0f",
				"1f39b"
			],
			"decimal": ""
		},
		"keywords": [
			"control",
			"knobs",
			"music"
		]
	},
	"23f1": {
		"name": "stopwatch",
		"unicode_version": 6,
		"category": "objects",
		"order": 1772,
		"display": 1,
		"shortname": ":stopwatch:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f1",
			"fully_qualified": "23f1-fe0f",
			"non_fully_qualified": "23f1",
			"output": "23f1-fe0f",
			"default_matches": [
				"23f1-fe0f",
				"23f1"
			],
			"greedy_matches": [
				"23f1-fe0f",
				"23f1"
			],
			"decimal": ""
		},
		"keywords": [
			"clock"
		]
	},
	"23f2": {
		"name": "timer clock",
		"unicode_version": 6,
		"category": "objects",
		"order": 1773,
		"display": 1,
		"shortname": ":timer:",
		"shortname_alternates": [
			":timer_clock:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f2",
			"fully_qualified": "23f2-fe0f",
			"non_fully_qualified": "23f2",
			"output": "23f2-fe0f",
			"default_matches": [
				"23f2-fe0f",
				"23f2"
			],
			"greedy_matches": [
				"23f2-fe0f",
				"23f2"
			],
			"decimal": ""
		},
		"keywords": [
			"clock",
			"timer"
		]
	},
	"23f0": {
		"name": "alarm clock",
		"unicode_version": 6,
		"category": "objects",
		"order": 1774,
		"display": 1,
		"shortname": ":alarm_clock:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f0",
			"fully_qualified": "23f0",
			"non_fully_qualified": "23f0",
			"output": "23f0",
			"default_matches": [
				"23f0"
			],
			"greedy_matches": [
				"23f0"
			],
			"decimal": ""
		},
		"keywords": [
			"alarm",
			"clock"
		]
	},
	"1f570": {
		"name": "mantelpiece clock",
		"unicode_version": 7,
		"category": "objects",
		"order": 1775,
		"display": 1,
		"shortname": ":clock:",
		"shortname_alternates": [
			":mantlepiece_clock:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f570",
			"fully_qualified": "1f570-fe0f",
			"non_fully_qualified": "1f570",
			"output": "1f570-fe0f",
			"default_matches": [
				"1f570-fe0f",
				"1f570"
			],
			"greedy_matches": [
				"1f570-fe0f",
				"1f570"
			],
			"decimal": ""
		},
		"keywords": [
			"clock"
		]
	},
	"231b": {
		"name": "hourglass",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1776,
		"display": 1,
		"shortname": ":hourglass:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "231b",
			"fully_qualified": "231b",
			"non_fully_qualified": "231b",
			"output": "231b",
			"default_matches": [
				"231b"
			],
			"greedy_matches": [
				"231b"
			],
			"decimal": ""
		},
		"keywords": [
			"sand",
			"timer"
		]
	},
	"23f3": {
		"name": "hourglass with flowing sand",
		"unicode_version": 6,
		"category": "objects",
		"order": 1777,
		"display": 1,
		"shortname": ":hourglass_flowing_sand:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f3",
			"fully_qualified": "23f3",
			"non_fully_qualified": "23f3",
			"output": "23f3",
			"default_matches": [
				"23f3"
			],
			"greedy_matches": [
				"23f3"
			],
			"decimal": ""
		},
		"keywords": [
			"hourglass",
			"sand",
			"timer"
		]
	},
	"1f4e1": {
		"name": "satellite antenna",
		"unicode_version": 6,
		"category": "objects",
		"order": 1778,
		"display": 1,
		"shortname": ":satellite:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e1",
			"fully_qualified": "1f4e1",
			"non_fully_qualified": "1f4e1",
			"output": "1f4e1",
			"default_matches": [
				"1f4e1"
			],
			"greedy_matches": [
				"1f4e1"
			],
			"decimal": ""
		},
		"keywords": [
			"antenna",
			"dish",
			"satellite"
		]
	},
	"1f50b": {
		"name": "battery",
		"unicode_version": 6,
		"category": "objects",
		"order": 1779,
		"display": 1,
		"shortname": ":battery:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50b",
			"fully_qualified": "1f50b",
			"non_fully_qualified": "1f50b",
			"output": "1f50b",
			"default_matches": [
				"1f50b"
			],
			"greedy_matches": [
				"1f50b"
			],
			"decimal": ""
		},
		"keywords": [
			"battery"
		]
	},
	"1f50c": {
		"name": "electric plug",
		"unicode_version": 6,
		"category": "objects",
		"order": 1780,
		"display": 1,
		"shortname": ":electric_plug:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50c",
			"fully_qualified": "1f50c",
			"non_fully_qualified": "1f50c",
			"output": "1f50c",
			"default_matches": [
				"1f50c"
			],
			"greedy_matches": [
				"1f50c"
			],
			"decimal": ""
		},
		"keywords": [
			"electric",
			"electricity",
			"plug"
		]
	},
	"1f4a1": {
		"name": "light bulb",
		"unicode_version": 6,
		"category": "objects",
		"order": 1781,
		"display": 1,
		"shortname": ":bulb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a1",
			"fully_qualified": "1f4a1",
			"non_fully_qualified": "1f4a1",
			"output": "1f4a1",
			"default_matches": [
				"1f4a1"
			],
			"greedy_matches": [
				"1f4a1"
			],
			"decimal": ""
		},
		"keywords": [
			"bulb",
			"comic",
			"electric",
			"idea",
			"light"
		]
	},
	"1f526": {
		"name": "flashlight",
		"unicode_version": 6,
		"category": "objects",
		"order": 1782,
		"display": 1,
		"shortname": ":flashlight:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f526",
			"fully_qualified": "1f526",
			"non_fully_qualified": "1f526",
			"output": "1f526",
			"default_matches": [
				"1f526"
			],
			"greedy_matches": [
				"1f526"
			],
			"decimal": ""
		},
		"keywords": [
			"electric",
			"light",
			"tool",
			"torch"
		]
	},
	"1f56f": {
		"name": "candle",
		"unicode_version": 7,
		"category": "objects",
		"order": 1783,
		"display": 1,
		"shortname": ":candle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f56f",
			"fully_qualified": "1f56f-fe0f",
			"non_fully_qualified": "1f56f",
			"output": "1f56f-fe0f",
			"default_matches": [
				"1f56f-fe0f",
				"1f56f"
			],
			"greedy_matches": [
				"1f56f-fe0f",
				"1f56f"
			],
			"decimal": ""
		},
		"keywords": [
			"light"
		]
	},
	"1f5d1": {
		"name": "wastebasket",
		"unicode_version": 7,
		"category": "objects",
		"order": 1784,
		"display": 1,
		"shortname": ":wastebasket:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5d1",
			"fully_qualified": "1f5d1-fe0f",
			"non_fully_qualified": "1f5d1",
			"output": "1f5d1-fe0f",
			"default_matches": [
				"1f5d1-fe0f",
				"1f5d1"
			],
			"greedy_matches": [
				"1f5d1-fe0f",
				"1f5d1"
			],
			"decimal": ""
		},
		"keywords": [
			"wastebasket"
		]
	},
	"1f6e2": {
		"name": "oil drum",
		"unicode_version": 7,
		"category": "objects",
		"order": 1785,
		"display": 1,
		"shortname": ":oil:",
		"shortname_alternates": [
			":oil_drum:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e2",
			"fully_qualified": "1f6e2-fe0f",
			"non_fully_qualified": "1f6e2",
			"output": "1f6e2-fe0f",
			"default_matches": [
				"1f6e2-fe0f",
				"1f6e2"
			],
			"greedy_matches": [
				"1f6e2-fe0f",
				"1f6e2"
			],
			"decimal": ""
		},
		"keywords": [
			"drum",
			"oil"
		]
	},
	"1f4b8": {
		"name": "money with wings",
		"unicode_version": 6,
		"category": "objects",
		"order": 1786,
		"display": 1,
		"shortname": ":money_with_wings:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b8",
			"fully_qualified": "1f4b8",
			"non_fully_qualified": "1f4b8",
			"output": "1f4b8",
			"default_matches": [
				"1f4b8"
			],
			"greedy_matches": [
				"1f4b8"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"banknote",
			"bill",
			"dollar",
			"fly",
			"money",
			"note",
			"wings"
		]
	},
	"1f4b5": {
		"name": "dollar banknote",
		"unicode_version": 6,
		"category": "objects",
		"order": 1787,
		"display": 1,
		"shortname": ":dollar:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b5",
			"fully_qualified": "1f4b5",
			"non_fully_qualified": "1f4b5",
			"output": "1f4b5",
			"default_matches": [
				"1f4b5"
			],
			"greedy_matches": [
				"1f4b5"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"banknote",
			"bill",
			"currency",
			"dollar",
			"money",
			"note"
		]
	},
	"1f4b4": {
		"name": "yen banknote",
		"unicode_version": 6,
		"category": "objects",
		"order": 1788,
		"display": 1,
		"shortname": ":yen:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b4",
			"fully_qualified": "1f4b4",
			"non_fully_qualified": "1f4b4",
			"output": "1f4b4",
			"default_matches": [
				"1f4b4"
			],
			"greedy_matches": [
				"1f4b4"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"banknote",
			"bill",
			"currency",
			"money",
			"note",
			"yen"
		]
	},
	"1f4b6": {
		"name": "euro banknote",
		"unicode_version": 6,
		"category": "objects",
		"order": 1789,
		"display": 1,
		"shortname": ":euro:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b6",
			"fully_qualified": "1f4b6",
			"non_fully_qualified": "1f4b6",
			"output": "1f4b6",
			"default_matches": [
				"1f4b6"
			],
			"greedy_matches": [
				"1f4b6"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"banknote",
			"bill",
			"currency",
			"euro",
			"money",
			"note"
		]
	},
	"1f4b7": {
		"name": "pound banknote",
		"unicode_version": 6,
		"category": "objects",
		"order": 1790,
		"display": 1,
		"shortname": ":pound:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b7",
			"fully_qualified": "1f4b7",
			"non_fully_qualified": "1f4b7",
			"output": "1f4b7",
			"default_matches": [
				"1f4b7"
			],
			"greedy_matches": [
				"1f4b7"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"banknote",
			"bill",
			"currency",
			"money",
			"note",
			"pound"
		]
	},
	"1f4b0": {
		"name": "money bag",
		"unicode_version": 6,
		"category": "objects",
		"order": 1791,
		"display": 1,
		"shortname": ":moneybag:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b0",
			"fully_qualified": "1f4b0",
			"non_fully_qualified": "1f4b0",
			"output": "1f4b0",
			"default_matches": [
				"1f4b0"
			],
			"greedy_matches": [
				"1f4b0"
			],
			"decimal": ""
		},
		"keywords": [
			"bag",
			"dollar",
			"money",
			"moneybag"
		]
	},
	"1f4b3": {
		"name": "credit card",
		"unicode_version": 6,
		"category": "objects",
		"order": 1792,
		"display": 1,
		"shortname": ":credit_card:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b3",
			"fully_qualified": "1f4b3",
			"non_fully_qualified": "1f4b3",
			"output": "1f4b3",
			"default_matches": [
				"1f4b3"
			],
			"greedy_matches": [
				"1f4b3"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"card",
			"credit",
			"money"
		]
	},
	"1f48e": {
		"name": "gem stone",
		"unicode_version": 6,
		"category": "objects",
		"order": 1793,
		"display": 1,
		"shortname": ":gem:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48e",
			"fully_qualified": "1f48e",
			"non_fully_qualified": "1f48e",
			"output": "1f48e",
			"default_matches": [
				"1f48e"
			],
			"greedy_matches": [
				"1f48e"
			],
			"decimal": ""
		},
		"keywords": [
			"diamond",
			"gem",
			"jewel"
		]
	},
	"1f527": {
		"name": "wrench",
		"unicode_version": 6,
		"category": "objects",
		"order": 1795,
		"display": 1,
		"shortname": ":wrench:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f527",
			"fully_qualified": "1f527",
			"non_fully_qualified": "1f527",
			"output": "1f527",
			"default_matches": [
				"1f527"
			],
			"greedy_matches": [
				"1f527"
			],
			"decimal": ""
		},
		"keywords": [
			"spanner",
			"tool",
			"wrench"
		]
	},
	"1f528": {
		"name": "hammer",
		"unicode_version": 6,
		"category": "objects",
		"order": 1796,
		"display": 1,
		"shortname": ":hammer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f528",
			"fully_qualified": "1f528",
			"non_fully_qualified": "1f528",
			"output": "1f528",
			"default_matches": [
				"1f528"
			],
			"greedy_matches": [
				"1f528"
			],
			"decimal": ""
		},
		"keywords": [
			"tool"
		]
	},
	"1f6e0": {
		"name": "hammer and wrench",
		"unicode_version": 7,
		"category": "objects",
		"order": 1798,
		"display": 1,
		"shortname": ":tools:",
		"shortname_alternates": [
			":hammer_and_wrench:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e0",
			"fully_qualified": "1f6e0-fe0f",
			"non_fully_qualified": "1f6e0",
			"output": "1f6e0-fe0f",
			"default_matches": [
				"1f6e0-fe0f",
				"1f6e0"
			],
			"greedy_matches": [
				"1f6e0-fe0f",
				"1f6e0"
			],
			"decimal": ""
		},
		"keywords": [
			"hammer",
			"spanner",
			"tool",
			"wrench"
		]
	},
	"26cf": {
		"name": "pick",
		"unicode_version": 5.2,
		"category": "objects",
		"order": 1799,
		"display": 1,
		"shortname": ":pick:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26cf",
			"fully_qualified": "26cf-fe0f",
			"non_fully_qualified": "26cf",
			"output": "26cf-fe0f",
			"default_matches": [
				"26cf-fe0f",
				"26cf"
			],
			"greedy_matches": [
				"26cf-fe0f",
				"26cf"
			],
			"decimal": ""
		},
		"keywords": [
			"mining",
			"tool"
		]
	},
	"1f529": {
		"name": "nut and bolt",
		"unicode_version": 6,
		"category": "objects",
		"order": 1800,
		"display": 1,
		"shortname": ":nut_and_bolt:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f529",
			"fully_qualified": "1f529",
			"non_fully_qualified": "1f529",
			"output": "1f529",
			"default_matches": [
				"1f529"
			],
			"greedy_matches": [
				"1f529"
			],
			"decimal": ""
		},
		"keywords": [
			"bolt",
			"nut",
			"tool"
		]
	},
	"26d3": {
		"name": "chains",
		"unicode_version": 5.2,
		"category": "objects",
		"order": 1802,
		"display": 1,
		"shortname": ":chains:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26d3",
			"fully_qualified": "26d3-fe0f",
			"non_fully_qualified": "26d3",
			"output": "26d3-fe0f",
			"default_matches": [
				"26d3-fe0f",
				"26d3"
			],
			"greedy_matches": [
				"26d3-fe0f",
				"26d3"
			],
			"decimal": ""
		},
		"keywords": [
			"chain"
		]
	},
	"1f52b": {
		"name": "pistol",
		"unicode_version": 6,
		"category": "objects",
		"order": 1803,
		"display": 1,
		"shortname": ":gun:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52b",
			"fully_qualified": "1f52b",
			"non_fully_qualified": "1f52b",
			"output": "1f52b",
			"default_matches": [
				"1f52b"
			],
			"greedy_matches": [
				"1f52b"
			],
			"decimal": ""
		},
		"keywords": [
			"gun",
			"handgun",
			"revolver",
			"tool",
			"weapon"
		]
	},
	"1f4a3": {
		"name": "bomb",
		"unicode_version": 6,
		"category": "objects",
		"order": 1804,
		"display": 1,
		"shortname": ":bomb:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a3",
			"fully_qualified": "1f4a3",
			"non_fully_qualified": "1f4a3",
			"output": "1f4a3",
			"default_matches": [
				"1f4a3"
			],
			"greedy_matches": [
				"1f4a3"
			],
			"decimal": ""
		},
		"keywords": [
			"comic"
		]
	},
	"1f52a": {
		"name": "kitchen knife",
		"unicode_version": 6,
		"category": "objects",
		"order": 1805,
		"display": 1,
		"shortname": ":knife:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52a",
			"fully_qualified": "1f52a",
			"non_fully_qualified": "1f52a",
			"output": "1f52a",
			"default_matches": [
				"1f52a"
			],
			"greedy_matches": [
				"1f52a"
			],
			"decimal": ""
		},
		"keywords": [
			"cooking",
			"hocho",
			"knife",
			"tool",
			"weapon"
		]
	},
	"1f5e1": {
		"name": "dagger",
		"unicode_version": 7,
		"category": "objects",
		"order": 1806,
		"display": 1,
		"shortname": ":dagger:",
		"shortname_alternates": [
			":dagger_knife:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5e1",
			"fully_qualified": "1f5e1-fe0f",
			"non_fully_qualified": "1f5e1",
			"output": "1f5e1-fe0f",
			"default_matches": [
				"1f5e1-fe0f",
				"1f5e1"
			],
			"greedy_matches": [
				"1f5e1-fe0f",
				"1f5e1"
			],
			"decimal": ""
		},
		"keywords": [
			"knife",
			"weapon"
		]
	},
	"1f6e1": {
		"name": "shield",
		"unicode_version": 7,
		"category": "objects",
		"order": 1808,
		"display": 1,
		"shortname": ":shield:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6e1",
			"fully_qualified": "1f6e1-fe0f",
			"non_fully_qualified": "1f6e1",
			"output": "1f6e1-fe0f",
			"default_matches": [
				"1f6e1-fe0f",
				"1f6e1"
			],
			"greedy_matches": [
				"1f6e1-fe0f",
				"1f6e1"
			],
			"decimal": ""
		},
		"keywords": [
			"weapon"
		]
	},
	"1f6ac": {
		"name": "cigarette",
		"unicode_version": 6,
		"category": "objects",
		"order": 1809,
		"display": 1,
		"shortname": ":smoking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ac",
			"fully_qualified": "1f6ac",
			"non_fully_qualified": "1f6ac",
			"output": "1f6ac",
			"default_matches": [
				"1f6ac"
			],
			"greedy_matches": [
				"1f6ac"
			],
			"decimal": ""
		},
		"keywords": [
			"smoking"
		]
	},
	"26b0": {
		"name": "coffin",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1810,
		"display": 1,
		"shortname": ":coffin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26b0",
			"fully_qualified": "26b0-fe0f",
			"non_fully_qualified": "26b0",
			"output": "26b0-fe0f",
			"default_matches": [
				"26b0-fe0f",
				"26b0"
			],
			"greedy_matches": [
				"26b0-fe0f",
				"26b0"
			],
			"decimal": ""
		},
		"keywords": [
			"death"
		]
	},
	"26b1": {
		"name": "funeral urn",
		"unicode_version": 4.1,
		"category": "objects",
		"order": 1811,
		"display": 1,
		"shortname": ":urn:",
		"shortname_alternates": [
			":funeral_urn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26b1",
			"fully_qualified": "26b1-fe0f",
			"non_fully_qualified": "26b1",
			"output": "26b1-fe0f",
			"default_matches": [
				"26b1-fe0f",
				"26b1"
			],
			"greedy_matches": [
				"26b1-fe0f",
				"26b1"
			],
			"decimal": ""
		},
		"keywords": [
			"ashes",
			"death",
			"funeral",
			"urn"
		]
	},
	"1f3fa": {
		"name": "amphora",
		"unicode_version": 8,
		"category": "objects",
		"order": 1812,
		"display": 1,
		"shortname": ":amphora:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3fa",
			"fully_qualified": "1f3fa",
			"non_fully_qualified": "1f3fa",
			"output": "1f3fa",
			"default_matches": [
				"1f3fa"
			],
			"greedy_matches": [
				"1f3fa"
			],
			"decimal": ""
		},
		"keywords": [
			"Aquarius",
			"cooking",
			"drink",
			"jug",
			"tool",
			"weapon",
			"zodiac"
		]
	},
	"1f52e": {
		"name": "crystal ball",
		"unicode_version": 6,
		"category": "objects",
		"order": 1813,
		"display": 1,
		"shortname": ":crystal_ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52e",
			"fully_qualified": "1f52e",
			"non_fully_qualified": "1f52e",
			"output": "1f52e",
			"default_matches": [
				"1f52e"
			],
			"greedy_matches": [
				"1f52e"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"crystal",
			"fairy tale",
			"fantasy",
			"fortune",
			"tool"
		]
	},
	"1f4ff": {
		"name": "prayer beads",
		"unicode_version": 8,
		"category": "objects",
		"order": 1814,
		"display": 1,
		"shortname": ":prayer_beads:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ff",
			"fully_qualified": "1f4ff",
			"non_fully_qualified": "1f4ff",
			"output": "1f4ff",
			"default_matches": [
				"1f4ff"
			],
			"greedy_matches": [
				"1f4ff"
			],
			"decimal": ""
		},
		"keywords": [
			"beads",
			"clothing",
			"necklace",
			"prayer",
			"religion"
		]
	},
	"1f488": {
		"name": "barber pole",
		"unicode_version": 6,
		"category": "objects",
		"order": 1815,
		"display": 1,
		"shortname": ":barber:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f488",
			"fully_qualified": "1f488",
			"non_fully_qualified": "1f488",
			"output": "1f488",
			"default_matches": [
				"1f488"
			],
			"greedy_matches": [
				"1f488"
			],
			"decimal": ""
		},
		"keywords": [
			"barber",
			"haircut",
			"pole"
		]
	},
	"1f52d": {
		"name": "telescope",
		"unicode_version": 6,
		"category": "objects",
		"order": 1817,
		"display": 1,
		"shortname": ":telescope:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52d",
			"fully_qualified": "1f52d",
			"non_fully_qualified": "1f52d",
			"output": "1f52d",
			"default_matches": [
				"1f52d"
			],
			"greedy_matches": [
				"1f52d"
			],
			"decimal": ""
		},
		"keywords": [
			"science",
			"tool"
		]
	},
	"1f52c": {
		"name": "microscope",
		"unicode_version": 6,
		"category": "objects",
		"order": 1818,
		"display": 1,
		"shortname": ":microscope:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52c",
			"fully_qualified": "1f52c",
			"non_fully_qualified": "1f52c",
			"output": "1f52c",
			"default_matches": [
				"1f52c"
			],
			"greedy_matches": [
				"1f52c"
			],
			"decimal": ""
		},
		"keywords": [
			"science",
			"tool"
		]
	},
	"1f573": {
		"name": "hole",
		"unicode_version": 7,
		"category": "objects",
		"order": 1819,
		"display": 1,
		"shortname": ":hole:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f573",
			"fully_qualified": "1f573-fe0f",
			"non_fully_qualified": "1f573",
			"output": "1f573-fe0f",
			"default_matches": [
				"1f573-fe0f",
				"1f573"
			],
			"greedy_matches": [
				"1f573-fe0f",
				"1f573"
			],
			"decimal": ""
		},
		"keywords": [
			"hole"
		]
	},
	"1f48a": {
		"name": "pill",
		"unicode_version": 6,
		"category": "objects",
		"order": 1820,
		"display": 1,
		"shortname": ":pill:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48a",
			"fully_qualified": "1f48a",
			"non_fully_qualified": "1f48a",
			"output": "1f48a",
			"default_matches": [
				"1f48a"
			],
			"greedy_matches": [
				"1f48a"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"medicine",
			"sick"
		]
	},
	"1f489": {
		"name": "syringe",
		"unicode_version": 6,
		"category": "objects",
		"order": 1821,
		"display": 1,
		"shortname": ":syringe:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f489",
			"fully_qualified": "1f489",
			"non_fully_qualified": "1f489",
			"output": "1f489",
			"default_matches": [
				"1f489"
			],
			"greedy_matches": [
				"1f489"
			],
			"decimal": ""
		},
		"keywords": [
			"doctor",
			"medicine",
			"needle",
			"shot",
			"sick",
			"tool"
		]
	},
	"1f321": {
		"name": "thermometer",
		"unicode_version": 7,
		"category": "objects",
		"order": 1822,
		"display": 1,
		"shortname": ":thermometer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f321",
			"fully_qualified": "1f321-fe0f",
			"non_fully_qualified": "1f321",
			"output": "1f321-fe0f",
			"default_matches": [
				"1f321-fe0f",
				"1f321"
			],
			"greedy_matches": [
				"1f321-fe0f",
				"1f321"
			],
			"decimal": ""
		},
		"keywords": [
			"weather"
		]
	},
	"1f6bd": {
		"name": "toilet",
		"unicode_version": 6,
		"category": "objects",
		"order": 1823,
		"display": 1,
		"shortname": ":toilet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6bd",
			"fully_qualified": "1f6bd",
			"non_fully_qualified": "1f6bd",
			"output": "1f6bd",
			"default_matches": [
				"1f6bd"
			],
			"greedy_matches": [
				"1f6bd"
			],
			"decimal": ""
		},
		"keywords": [
			"toilet"
		]
	},
	"1f6b0": {
		"name": "potable water",
		"unicode_version": 6,
		"category": "objects",
		"order": 1824,
		"display": 1,
		"shortname": ":potable_water:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b0",
			"fully_qualified": "1f6b0",
			"non_fully_qualified": "1f6b0",
			"output": "1f6b0",
			"default_matches": [
				"1f6b0"
			],
			"greedy_matches": [
				"1f6b0"
			],
			"decimal": ""
		},
		"keywords": [
			"drinking",
			"potable",
			"water"
		]
	},
	"1f6bf": {
		"name": "shower",
		"unicode_version": 6,
		"category": "objects",
		"order": 1825,
		"display": 1,
		"shortname": ":shower:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6bf",
			"fully_qualified": "1f6bf",
			"non_fully_qualified": "1f6bf",
			"output": "1f6bf",
			"default_matches": [
				"1f6bf"
			],
			"greedy_matches": [
				"1f6bf"
			],
			"decimal": ""
		},
		"keywords": [
			"water"
		]
	},
	"1f6c1": {
		"name": "bathtub",
		"unicode_version": 6,
		"category": "objects",
		"order": 1826,
		"display": 1,
		"shortname": ":bathtub:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c1",
			"fully_qualified": "1f6c1",
			"non_fully_qualified": "1f6c1",
			"output": "1f6c1",
			"default_matches": [
				"1f6c1"
			],
			"greedy_matches": [
				"1f6c1"
			],
			"decimal": ""
		},
		"keywords": [
			"bath"
		]
	},
	"1f6c0": {
		"name": "person taking bath",
		"unicode_version": 6,
		"category": "objects",
		"order": 1827,
		"display": 1,
		"shortname": ":bath:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6c0-1f3fb",
			"1f6c0-1f3fc",
			"1f6c0-1f3fd",
			"1f6c0-1f3fe",
			"1f6c0-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0",
			"fully_qualified": "1f6c0",
			"non_fully_qualified": "1f6c0",
			"output": "1f6c0",
			"default_matches": [
				"1f6c0"
			],
			"greedy_matches": [
				"1f6c0"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub"
		]
	},
	"1f6c0-1f3fb": {
		"name": "person taking bath: light skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1828,
		"display": 1,
		"shortname": ":bath_tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0-1f3fb",
			"fully_qualified": "1f6c0-1f3fb",
			"non_fully_qualified": "1f6c0-1f3fb",
			"output": "1f6c0-1f3fb",
			"default_matches": [
				"1f6c0-1f3fb"
			],
			"greedy_matches": [
				"1f6c0-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub",
			"light skin tone"
		]
	},
	"1f6c0-1f3fc": {
		"name": "person taking bath: medium-light skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1829,
		"display": 1,
		"shortname": ":bath_tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0-1f3fc",
			"fully_qualified": "1f6c0-1f3fc",
			"non_fully_qualified": "1f6c0-1f3fc",
			"output": "1f6c0-1f3fc",
			"default_matches": [
				"1f6c0-1f3fc"
			],
			"greedy_matches": [
				"1f6c0-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub",
			"medium-light skin tone"
		]
	},
	"1f6c0-1f3fd": {
		"name": "person taking bath: medium skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1830,
		"display": 1,
		"shortname": ":bath_tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0-1f3fd",
			"fully_qualified": "1f6c0-1f3fd",
			"non_fully_qualified": "1f6c0-1f3fd",
			"output": "1f6c0-1f3fd",
			"default_matches": [
				"1f6c0-1f3fd"
			],
			"greedy_matches": [
				"1f6c0-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub",
			"medium skin tone"
		]
	},
	"1f6c0-1f3fe": {
		"name": "person taking bath: medium-dark skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1831,
		"display": 1,
		"shortname": ":bath_tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0-1f3fe",
			"fully_qualified": "1f6c0-1f3fe",
			"non_fully_qualified": "1f6c0-1f3fe",
			"output": "1f6c0-1f3fe",
			"default_matches": [
				"1f6c0-1f3fe"
			],
			"greedy_matches": [
				"1f6c0-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub",
			"medium-dark skin tone"
		]
	},
	"1f6c0-1f3ff": {
		"name": "person taking bath: dark skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1832,
		"display": 1,
		"shortname": ":bath_tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c0-1f3ff",
			"fully_qualified": "1f6c0-1f3ff",
			"non_fully_qualified": "1f6c0-1f3ff",
			"output": "1f6c0-1f3ff",
			"default_matches": [
				"1f6c0-1f3ff"
			],
			"greedy_matches": [
				"1f6c0-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"bath",
			"bathtub",
			"dark skin tone"
		]
	},
	"1f6ce": {
		"name": "bellhop bell",
		"unicode_version": 7,
		"category": "objects",
		"order": 1833,
		"display": 1,
		"shortname": ":bellhop:",
		"shortname_alternates": [
			":bellhop_bell:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ce",
			"fully_qualified": "1f6ce-fe0f",
			"non_fully_qualified": "1f6ce",
			"output": "1f6ce-fe0f",
			"default_matches": [
				"1f6ce-fe0f",
				"1f6ce"
			],
			"greedy_matches": [
				"1f6ce-fe0f",
				"1f6ce"
			],
			"decimal": ""
		},
		"keywords": [
			"bell",
			"bellhop",
			"hotel"
		]
	},
	"1f511": {
		"name": "key",
		"unicode_version": 6,
		"category": "objects",
		"order": 1834,
		"display": 1,
		"shortname": ":key:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f511",
			"fully_qualified": "1f511",
			"non_fully_qualified": "1f511",
			"output": "1f511",
			"default_matches": [
				"1f511"
			],
			"greedy_matches": [
				"1f511"
			],
			"decimal": ""
		},
		"keywords": [
			"lock",
			"password"
		]
	},
	"1f5dd": {
		"name": "old key",
		"unicode_version": 7,
		"category": "objects",
		"order": 1835,
		"display": 1,
		"shortname": ":key2:",
		"shortname_alternates": [
			":old_key:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5dd",
			"fully_qualified": "1f5dd-fe0f",
			"non_fully_qualified": "1f5dd",
			"output": "1f5dd-fe0f",
			"default_matches": [
				"1f5dd-fe0f"
			],
			"greedy_matches": [
				"1f5dd-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"clue",
			"key",
			"lock",
			"old"
		]
	},
	"1f6aa": {
		"name": "door",
		"unicode_version": 6,
		"category": "objects",
		"order": 1836,
		"display": 1,
		"shortname": ":door:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6aa",
			"fully_qualified": "1f6aa",
			"non_fully_qualified": "1f6aa",
			"output": "1f6aa",
			"default_matches": [
				"1f6aa"
			],
			"greedy_matches": [
				"1f6aa"
			],
			"decimal": ""
		},
		"keywords": [
			"door"
		]
	},
	"1f6cb": {
		"name": "couch and lamp",
		"unicode_version": 7,
		"category": "objects",
		"order": 1837,
		"display": 1,
		"shortname": ":couch:",
		"shortname_alternates": [
			":couch_and_lamp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cb",
			"fully_qualified": "1f6cb-fe0f",
			"non_fully_qualified": "1f6cb",
			"output": "1f6cb-fe0f",
			"default_matches": [
				"1f6cb-fe0f",
				"1f6cb"
			],
			"greedy_matches": [
				"1f6cb-fe0f",
				"1f6cb"
			],
			"decimal": ""
		},
		"keywords": [
			"couch",
			"hotel",
			"lamp"
		]
	},
	"1f6cf": {
		"name": "bed",
		"unicode_version": 7,
		"category": "objects",
		"order": 1838,
		"display": 1,
		"shortname": ":bed:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cf",
			"fully_qualified": "1f6cf-fe0f",
			"non_fully_qualified": "1f6cf",
			"output": "1f6cf-fe0f",
			"default_matches": [
				"1f6cf-fe0f",
				"1f6cf"
			],
			"greedy_matches": [
				"1f6cf-fe0f",
				"1f6cf"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"sleep"
		]
	},
	"1f6cc": {
		"name": "person in bed",
		"unicode_version": 7,
		"category": "objects",
		"order": 1839,
		"display": 1,
		"shortname": ":sleeping_accommodation:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f6cc-1f3fb",
			"1f6cc-1f3fc",
			"1f6cc-1f3fd",
			"1f6cc-1f3fe",
			"1f6cc-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc",
			"fully_qualified": "1f6cc",
			"non_fully_qualified": "1f6cc",
			"output": "1f6cc",
			"default_matches": [
				"1f6cc"
			],
			"greedy_matches": [
				"1f6cc"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"sleep"
		]
	},
	"1f6cc-1f3fb": {
		"name": "person in bed: light skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1840,
		"display": 1,
		"shortname": ":person_in_bed_tone1:",
		"shortname_alternates": [
			":person_in_bed_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc-1f3fb",
			"fully_qualified": "1f6cc-1f3fb",
			"non_fully_qualified": "1f6cc-1f3fb",
			"output": "1f6cc-1f3fb",
			"default_matches": [
				"1f6cc-1f3fb"
			],
			"greedy_matches": [
				"1f6cc-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"light skin tone",
			"sleep"
		]
	},
	"1f6cc-1f3fc": {
		"name": "person in bed: medium-light skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1841,
		"display": 1,
		"shortname": ":person_in_bed_tone2:",
		"shortname_alternates": [
			":person_in_bed_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc-1f3fc",
			"fully_qualified": "1f6cc-1f3fc",
			"non_fully_qualified": "1f6cc-1f3fc",
			"output": "1f6cc-1f3fc",
			"default_matches": [
				"1f6cc-1f3fc"
			],
			"greedy_matches": [
				"1f6cc-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"medium-light skin tone",
			"sleep"
		]
	},
	"1f6cc-1f3fd": {
		"name": "person in bed: medium skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1842,
		"display": 1,
		"shortname": ":person_in_bed_tone3:",
		"shortname_alternates": [
			":person_in_bed_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc-1f3fd",
			"fully_qualified": "1f6cc-1f3fd",
			"non_fully_qualified": "1f6cc-1f3fd",
			"output": "1f6cc-1f3fd",
			"default_matches": [
				"1f6cc-1f3fd"
			],
			"greedy_matches": [
				"1f6cc-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"medium skin tone",
			"sleep"
		]
	},
	"1f6cc-1f3fe": {
		"name": "person in bed: medium-dark skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1843,
		"display": 1,
		"shortname": ":person_in_bed_tone4:",
		"shortname_alternates": [
			":person_in_bed_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc-1f3fe",
			"fully_qualified": "1f6cc-1f3fe",
			"non_fully_qualified": "1f6cc-1f3fe",
			"output": "1f6cc-1f3fe",
			"default_matches": [
				"1f6cc-1f3fe"
			],
			"greedy_matches": [
				"1f6cc-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"hotel",
			"medium-dark skin tone",
			"sleep"
		]
	},
	"1f6cc-1f3ff": {
		"name": "person in bed: dark skin tone",
		"unicode_version": 8,
		"category": "objects",
		"order": 1844,
		"display": 1,
		"shortname": ":person_in_bed_tone5:",
		"shortname_alternates": [
			":person_in_bed_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cc-1f3ff",
			"fully_qualified": "1f6cc-1f3ff",
			"non_fully_qualified": "1f6cc-1f3ff",
			"output": "1f6cc-1f3ff",
			"default_matches": [
				"1f6cc-1f3ff"
			],
			"greedy_matches": [
				"1f6cc-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"hotel",
			"sleep"
		]
	},
	"1f5bc": {
		"name": "framed picture",
		"unicode_version": 7,
		"category": "objects",
		"order": 1845,
		"display": 1,
		"shortname": ":frame_photo:",
		"shortname_alternates": [
			":frame_with_picture:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5bc",
			"fully_qualified": "1f5bc-fe0f",
			"non_fully_qualified": "1f5bc",
			"output": "1f5bc-fe0f",
			"default_matches": [
				"1f5bc-fe0f",
				"1f5bc"
			],
			"greedy_matches": [
				"1f5bc-fe0f",
				"1f5bc"
			],
			"decimal": ""
		},
		"keywords": [
			"art",
			"frame",
			"museum",
			"painting",
			"picture"
		]
	},
	"1f6cd": {
		"name": "shopping bags",
		"unicode_version": 7,
		"category": "objects",
		"order": 1846,
		"display": 1,
		"shortname": ":shopping_bags:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6cd",
			"fully_qualified": "1f6cd-fe0f",
			"non_fully_qualified": "1f6cd",
			"output": "1f6cd-fe0f",
			"default_matches": [
				"1f6cd-fe0f",
				"1f6cd"
			],
			"greedy_matches": [
				"1f6cd-fe0f",
				"1f6cd"
			],
			"decimal": ""
		},
		"keywords": [
			"bag",
			"hotel",
			"shopping"
		]
	},
	"1f6d2": {
		"name": "shopping cart",
		"unicode_version": 9,
		"category": "objects",
		"order": 1847,
		"display": 1,
		"shortname": ":shopping_cart:",
		"shortname_alternates": [
			":shopping_trolley:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6d2",
			"fully_qualified": "1f6d2",
			"non_fully_qualified": "1f6d2",
			"output": "1f6d2",
			"default_matches": [
				"1f6d2"
			],
			"greedy_matches": [
				"1f6d2"
			],
			"decimal": ""
		},
		"keywords": [
			"cart",
			"shopping",
			"trolley"
		]
	},
	"1f381": {
		"name": "wrapped gift",
		"unicode_version": 6,
		"category": "objects",
		"order": 1848,
		"display": 1,
		"shortname": ":gift:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f381",
			"fully_qualified": "1f381",
			"non_fully_qualified": "1f381",
			"output": "1f381",
			"default_matches": [
				"1f381"
			],
			"greedy_matches": [
				"1f381"
			],
			"decimal": ""
		},
		"keywords": [
			"box",
			"celebration",
			"gift",
			"present",
			"wrapped"
		]
	},
	"1f388": {
		"name": "balloon",
		"unicode_version": 6,
		"category": "objects",
		"order": 1849,
		"display": 1,
		"shortname": ":balloon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f388",
			"fully_qualified": "1f388",
			"non_fully_qualified": "1f388",
			"output": "1f388",
			"default_matches": [
				"1f388"
			],
			"greedy_matches": [
				"1f388"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration"
		]
	},
	"1f38f": {
		"name": "carp streamer",
		"unicode_version": 6,
		"category": "objects",
		"order": 1850,
		"display": 1,
		"shortname": ":flags:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38f",
			"fully_qualified": "1f38f",
			"non_fully_qualified": "1f38f",
			"output": "1f38f",
			"default_matches": [
				"1f38f"
			],
			"greedy_matches": [
				"1f38f"
			],
			"decimal": ""
		},
		"keywords": [
			"carp",
			"celebration",
			"streamer"
		]
	},
	"1f380": {
		"name": "ribbon",
		"unicode_version": 6,
		"category": "objects",
		"order": 1851,
		"display": 1,
		"shortname": ":ribbon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f380",
			"fully_qualified": "1f380",
			"non_fully_qualified": "1f380",
			"output": "1f380",
			"default_matches": [
				"1f380"
			],
			"greedy_matches": [
				"1f380"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration"
		]
	},
	"1f38a": {
		"name": "confetti ball",
		"unicode_version": 6,
		"category": "objects",
		"order": 1852,
		"display": 1,
		"shortname": ":confetti_ball:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38a",
			"fully_qualified": "1f38a",
			"non_fully_qualified": "1f38a",
			"output": "1f38a",
			"default_matches": [
				"1f38a"
			],
			"greedy_matches": [
				"1f38a"
			],
			"decimal": ""
		},
		"keywords": [
			"ball",
			"celebration",
			"confetti"
		]
	},
	"1f389": {
		"name": "party popper",
		"unicode_version": 6,
		"category": "objects",
		"order": 1853,
		"display": 1,
		"shortname": ":tada:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f389",
			"fully_qualified": "1f389",
			"non_fully_qualified": "1f389",
			"output": "1f389",
			"default_matches": [
				"1f389"
			],
			"greedy_matches": [
				"1f389"
			],
			"decimal": ""
		},
		"keywords": [
			"celebration",
			"party",
			"popper",
			"tada"
		]
	},
	"1f38e": {
		"name": "Japanese dolls",
		"unicode_version": 6,
		"category": "objects",
		"order": 1854,
		"display": 1,
		"shortname": ":dolls:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38e",
			"fully_qualified": "1f38e",
			"non_fully_qualified": "1f38e",
			"output": "1f38e",
			"default_matches": [
				"1f38e"
			],
			"greedy_matches": [
				"1f38e"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"celebration",
			"doll",
			"festival"
		]
	},
	"1f3ee": {
		"name": "red paper lantern",
		"unicode_version": 6,
		"category": "objects",
		"order": 1855,
		"display": 1,
		"shortname": ":izakaya_lantern:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ee",
			"fully_qualified": "1f3ee",
			"non_fully_qualified": "1f3ee",
			"output": "1f3ee",
			"default_matches": [
				"1f3ee"
			],
			"greedy_matches": [
				"1f3ee"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"lantern",
			"light",
			"red"
		]
	},
	"1f390": {
		"name": "wind chime",
		"unicode_version": 6,
		"category": "objects",
		"order": 1856,
		"display": 1,
		"shortname": ":wind_chime:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f390",
			"fully_qualified": "1f390",
			"non_fully_qualified": "1f390",
			"output": "1f390",
			"default_matches": [
				"1f390"
			],
			"greedy_matches": [
				"1f390"
			],
			"decimal": ""
		},
		"keywords": [
			"bell",
			"celebration",
			"chime",
			"wind"
		]
	},
	"1f4e9": {
		"name": "envelope with arrow",
		"unicode_version": 6,
		"category": "objects",
		"order": 1858,
		"display": 1,
		"shortname": ":envelope_with_arrow:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e9",
			"fully_qualified": "1f4e9",
			"non_fully_qualified": "1f4e9",
			"output": "1f4e9",
			"default_matches": [
				"1f4e9"
			],
			"greedy_matches": [
				"1f4e9"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"down",
			"e-mail",
			"email",
			"envelope",
			"letter",
			"mail",
			"outgoing",
			"sent"
		]
	},
	"1f4e8": {
		"name": "incoming envelope",
		"unicode_version": 6,
		"category": "objects",
		"order": 1859,
		"display": 1,
		"shortname": ":incoming_envelope:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e8",
			"fully_qualified": "1f4e8",
			"non_fully_qualified": "1f4e8",
			"output": "1f4e8",
			"default_matches": [
				"1f4e8"
			],
			"greedy_matches": [
				"1f4e8"
			],
			"decimal": ""
		},
		"keywords": [
			"e-mail",
			"email",
			"envelope",
			"incoming",
			"letter",
			"mail",
			"receive"
		]
	},
	"1f4e7": {
		"name": "e-mail",
		"unicode_version": 6,
		"category": "objects",
		"order": 1860,
		"display": 1,
		"shortname": ":e-mail:",
		"shortname_alternates": [
			":email:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e7",
			"fully_qualified": "1f4e7",
			"non_fully_qualified": "1f4e7",
			"output": "1f4e7",
			"default_matches": [
				"1f4e7"
			],
			"greedy_matches": [
				"1f4e7"
			],
			"decimal": ""
		},
		"keywords": [
			"email",
			"letter",
			"mail"
		]
	},
	"1f48c": {
		"name": "love letter",
		"unicode_version": 6,
		"category": "objects",
		"order": 1861,
		"display": 1,
		"shortname": ":love_letter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f48c",
			"fully_qualified": "1f48c",
			"non_fully_qualified": "1f48c",
			"output": "1f48c",
			"default_matches": [
				"1f48c"
			],
			"greedy_matches": [
				"1f48c"
			],
			"decimal": ""
		},
		"keywords": [
			"heart",
			"letter",
			"love",
			"mail"
		]
	},
	"1f4e5": {
		"name": "inbox tray",
		"unicode_version": 6,
		"category": "objects",
		"order": 1862,
		"display": 1,
		"shortname": ":inbox_tray:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e5",
			"fully_qualified": "1f4e5",
			"non_fully_qualified": "1f4e5",
			"output": "1f4e5",
			"default_matches": [
				"1f4e5"
			],
			"greedy_matches": [
				"1f4e5"
			],
			"decimal": ""
		},
		"keywords": [
			"box",
			"inbox",
			"letter",
			"mail",
			"receive",
			"tray"
		]
	},
	"1f4e4": {
		"name": "outbox tray",
		"unicode_version": 6,
		"category": "objects",
		"order": 1863,
		"display": 1,
		"shortname": ":outbox_tray:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e4",
			"fully_qualified": "1f4e4",
			"non_fully_qualified": "1f4e4",
			"output": "1f4e4",
			"default_matches": [
				"1f4e4"
			],
			"greedy_matches": [
				"1f4e4"
			],
			"decimal": ""
		},
		"keywords": [
			"box",
			"letter",
			"mail",
			"outbox",
			"sent",
			"tray"
		]
	},
	"1f4e6": {
		"name": "package",
		"unicode_version": 6,
		"category": "objects",
		"order": 1864,
		"display": 1,
		"shortname": ":package:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e6",
			"fully_qualified": "1f4e6",
			"non_fully_qualified": "1f4e6",
			"output": "1f4e6",
			"default_matches": [
				"1f4e6"
			],
			"greedy_matches": [
				"1f4e6"
			],
			"decimal": ""
		},
		"keywords": [
			"box",
			"parcel"
		]
	},
	"1f3f7": {
		"name": "label",
		"unicode_version": 7,
		"category": "objects",
		"order": 1865,
		"display": 1,
		"shortname": ":label:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f7",
			"fully_qualified": "1f3f7-fe0f",
			"non_fully_qualified": "1f3f7",
			"output": "1f3f7-fe0f",
			"default_matches": [
				"1f3f7-fe0f",
				"1f3f7"
			],
			"greedy_matches": [
				"1f3f7-fe0f",
				"1f3f7"
			],
			"decimal": ""
		},
		"keywords": [
			"label"
		]
	},
	"1f4ea": {
		"name": "closed mailbox with lowered flag",
		"unicode_version": 6,
		"category": "objects",
		"order": 1866,
		"display": 1,
		"shortname": ":mailbox_closed:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ea",
			"fully_qualified": "1f4ea",
			"non_fully_qualified": "1f4ea",
			"output": "1f4ea",
			"default_matches": [
				"1f4ea"
			],
			"greedy_matches": [
				"1f4ea"
			],
			"decimal": ""
		},
		"keywords": [
			"closed",
			"lowered",
			"mail",
			"mailbox",
			"postbox"
		]
	},
	"1f4eb": {
		"name": "closed mailbox with raised flag",
		"unicode_version": 6,
		"category": "objects",
		"order": 1867,
		"display": 1,
		"shortname": ":mailbox:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4eb",
			"fully_qualified": "1f4eb",
			"non_fully_qualified": "1f4eb",
			"output": "1f4eb",
			"default_matches": [
				"1f4eb"
			],
			"greedy_matches": [
				"1f4eb"
			],
			"decimal": ""
		},
		"keywords": [
			"closed",
			"mail",
			"mailbox",
			"postbox"
		]
	},
	"1f4ec": {
		"name": "open mailbox with raised flag",
		"unicode_version": 6,
		"category": "objects",
		"order": 1868,
		"display": 1,
		"shortname": ":mailbox_with_mail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ec",
			"fully_qualified": "1f4ec",
			"non_fully_qualified": "1f4ec",
			"output": "1f4ec",
			"default_matches": [
				"1f4ec"
			],
			"greedy_matches": [
				"1f4ec"
			],
			"decimal": ""
		},
		"keywords": [
			"mail",
			"mailbox",
			"open",
			"postbox"
		]
	},
	"1f4ed": {
		"name": "open mailbox with lowered flag",
		"unicode_version": 6,
		"category": "objects",
		"order": 1869,
		"display": 1,
		"shortname": ":mailbox_with_no_mail:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ed",
			"fully_qualified": "1f4ed",
			"non_fully_qualified": "1f4ed",
			"output": "1f4ed",
			"default_matches": [
				"1f4ed"
			],
			"greedy_matches": [
				"1f4ed"
			],
			"decimal": ""
		},
		"keywords": [
			"lowered",
			"mail",
			"mailbox",
			"open",
			"postbox"
		]
	},
	"1f4ee": {
		"name": "postbox",
		"unicode_version": 6,
		"category": "objects",
		"order": 1870,
		"display": 1,
		"shortname": ":postbox:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ee",
			"fully_qualified": "1f4ee",
			"non_fully_qualified": "1f4ee",
			"output": "1f4ee",
			"default_matches": [
				"1f4ee"
			],
			"greedy_matches": [
				"1f4ee"
			],
			"decimal": ""
		},
		"keywords": [
			"mail",
			"mailbox"
		]
	},
	"1f4ef": {
		"name": "postal horn",
		"unicode_version": 6,
		"category": "objects",
		"order": 1871,
		"display": 1,
		"shortname": ":postal_horn:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ef",
			"fully_qualified": "1f4ef",
			"non_fully_qualified": "1f4ef",
			"output": "1f4ef",
			"default_matches": [
				"1f4ef"
			],
			"greedy_matches": [
				"1f4ef"
			],
			"decimal": ""
		},
		"keywords": [
			"horn",
			"post",
			"postal"
		]
	},
	"1f4dc": {
		"name": "scroll",
		"unicode_version": 6,
		"category": "objects",
		"order": 1872,
		"display": 1,
		"shortname": ":scroll:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4dc",
			"fully_qualified": "1f4dc",
			"non_fully_qualified": "1f4dc",
			"output": "1f4dc",
			"default_matches": [
				"1f4dc"
			],
			"greedy_matches": [
				"1f4dc"
			],
			"decimal": ""
		},
		"keywords": [
			"paper"
		]
	},
	"1f4c3": {
		"name": "page with curl",
		"unicode_version": 6,
		"category": "objects",
		"order": 1873,
		"display": 1,
		"shortname": ":page_with_curl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c3",
			"fully_qualified": "1f4c3",
			"non_fully_qualified": "1f4c3",
			"output": "1f4c3",
			"default_matches": [
				"1f4c3"
			],
			"greedy_matches": [
				"1f4c3"
			],
			"decimal": ""
		},
		"keywords": [
			"curl",
			"document",
			"page"
		]
	},
	"1f4c4": {
		"name": "page facing up",
		"unicode_version": 6,
		"category": "objects",
		"order": 1874,
		"display": 1,
		"shortname": ":page_facing_up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c4",
			"fully_qualified": "1f4c4",
			"non_fully_qualified": "1f4c4",
			"output": "1f4c4",
			"default_matches": [
				"1f4c4"
			],
			"greedy_matches": [
				"1f4c4"
			],
			"decimal": ""
		},
		"keywords": [
			"document",
			"page"
		]
	},
	"1f4d1": {
		"name": "bookmark tabs",
		"unicode_version": 6,
		"category": "objects",
		"order": 1875,
		"display": 1,
		"shortname": ":bookmark_tabs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d1",
			"fully_qualified": "1f4d1",
			"non_fully_qualified": "1f4d1",
			"output": "1f4d1",
			"default_matches": [
				"1f4d1"
			],
			"greedy_matches": [
				"1f4d1"
			],
			"decimal": ""
		},
		"keywords": [
			"bookmark",
			"mark",
			"marker",
			"tabs"
		]
	},
	"1f4ca": {
		"name": "bar chart",
		"unicode_version": 6,
		"category": "objects",
		"order": 1876,
		"display": 1,
		"shortname": ":bar_chart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ca",
			"fully_qualified": "1f4ca",
			"non_fully_qualified": "1f4ca",
			"output": "1f4ca",
			"default_matches": [
				"1f4ca"
			],
			"greedy_matches": [
				"1f4ca"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"chart",
			"graph"
		]
	},
	"1f4c8": {
		"name": "chart increasing",
		"unicode_version": 6,
		"category": "objects",
		"order": 1877,
		"display": 1,
		"shortname": ":chart_with_upwards_trend:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c8",
			"fully_qualified": "1f4c8",
			"non_fully_qualified": "1f4c8",
			"output": "1f4c8",
			"default_matches": [
				"1f4c8"
			],
			"greedy_matches": [
				"1f4c8"
			],
			"decimal": ""
		},
		"keywords": [
			"chart",
			"graph",
			"growth",
			"trend",
			"upward"
		]
	},
	"1f4c9": {
		"name": "chart decreasing",
		"unicode_version": 6,
		"category": "objects",
		"order": 1878,
		"display": 1,
		"shortname": ":chart_with_downwards_trend:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c9",
			"fully_qualified": "1f4c9",
			"non_fully_qualified": "1f4c9",
			"output": "1f4c9",
			"default_matches": [
				"1f4c9"
			],
			"greedy_matches": [
				"1f4c9"
			],
			"decimal": ""
		},
		"keywords": [
			"chart",
			"down",
			"graph",
			"trend"
		]
	},
	"1f5d2": {
		"name": "spiral notepad",
		"unicode_version": 7,
		"category": "objects",
		"order": 1879,
		"display": 1,
		"shortname": ":notepad_spiral:",
		"shortname_alternates": [
			":spiral_note_pad:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5d2",
			"fully_qualified": "1f5d2-fe0f",
			"non_fully_qualified": "1f5d2",
			"output": "1f5d2-fe0f",
			"default_matches": [
				"1f5d2-fe0f",
				"1f5d2"
			],
			"greedy_matches": [
				"1f5d2-fe0f",
				"1f5d2"
			],
			"decimal": ""
		},
		"keywords": [
			"note",
			"pad",
			"spiral"
		]
	},
	"1f5d3": {
		"name": "spiral calendar",
		"unicode_version": 7,
		"category": "objects",
		"order": 1880,
		"display": 1,
		"shortname": ":calendar_spiral:",
		"shortname_alternates": [
			":spiral_calendar_pad:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5d3",
			"fully_qualified": "1f5d3-fe0f",
			"non_fully_qualified": "1f5d3",
			"output": "1f5d3-fe0f",
			"default_matches": [
				"1f5d3-fe0f",
				"1f5d3"
			],
			"greedy_matches": [
				"1f5d3-fe0f",
				"1f5d3"
			],
			"decimal": ""
		},
		"keywords": [
			"calendar",
			"pad",
			"spiral"
		]
	},
	"1f4c6": {
		"name": "tear-off calendar",
		"unicode_version": 6,
		"category": "objects",
		"order": 1881,
		"display": 1,
		"shortname": ":calendar:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c6",
			"fully_qualified": "1f4c6",
			"non_fully_qualified": "1f4c6",
			"output": "1f4c6",
			"default_matches": [
				"1f4c6"
			],
			"greedy_matches": [
				"1f4c6"
			],
			"decimal": ""
		},
		"keywords": [
			"calendar"
		]
	},
	"1f4c5": {
		"name": "calendar",
		"unicode_version": 6,
		"category": "objects",
		"order": 1882,
		"display": 1,
		"shortname": ":date:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c5",
			"fully_qualified": "1f4c5",
			"non_fully_qualified": "1f4c5",
			"output": "1f4c5",
			"default_matches": [
				"1f4c5"
			],
			"greedy_matches": [
				"1f4c5"
			],
			"decimal": ""
		},
		"keywords": [
			"date"
		]
	},
	"1f4c7": {
		"name": "card index",
		"unicode_version": 6,
		"category": "objects",
		"order": 1883,
		"display": 1,
		"shortname": ":card_index:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c7",
			"fully_qualified": "1f4c7",
			"non_fully_qualified": "1f4c7",
			"output": "1f4c7",
			"default_matches": [
				"1f4c7"
			],
			"greedy_matches": [
				"1f4c7"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"index",
			"rolodex"
		]
	},
	"1f5c3": {
		"name": "card file box",
		"unicode_version": 7,
		"category": "objects",
		"order": 1884,
		"display": 1,
		"shortname": ":card_box:",
		"shortname_alternates": [
			":card_file_box:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5c3",
			"fully_qualified": "1f5c3-fe0f",
			"non_fully_qualified": "1f5c3",
			"output": "1f5c3-fe0f",
			"default_matches": [
				"1f5c3-fe0f",
				"1f5c3"
			],
			"greedy_matches": [
				"1f5c3-fe0f",
				"1f5c3"
			],
			"decimal": ""
		},
		"keywords": [
			"box",
			"card",
			"file"
		]
	},
	"1f5f3": {
		"name": "ballot box with ballot",
		"unicode_version": 7,
		"category": "objects",
		"order": 1885,
		"display": 1,
		"shortname": ":ballot_box:",
		"shortname_alternates": [
			":ballot_box_with_ballot:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5f3",
			"fully_qualified": "1f5f3-fe0f",
			"non_fully_qualified": "1f5f3",
			"output": "1f5f3-fe0f",
			"default_matches": [
				"1f5f3-fe0f",
				"1f5f3"
			],
			"greedy_matches": [
				"1f5f3-fe0f",
				"1f5f3"
			],
			"decimal": ""
		},
		"keywords": [
			"ballot",
			"box"
		]
	},
	"1f5c4": {
		"name": "file cabinet",
		"unicode_version": 7,
		"category": "objects",
		"order": 1886,
		"display": 1,
		"shortname": ":file_cabinet:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5c4",
			"fully_qualified": "1f5c4-fe0f",
			"non_fully_qualified": "1f5c4",
			"output": "1f5c4-fe0f",
			"default_matches": [
				"1f5c4-fe0f",
				"1f5c4"
			],
			"greedy_matches": [
				"1f5c4-fe0f",
				"1f5c4"
			],
			"decimal": ""
		},
		"keywords": [
			"cabinet",
			"file",
			"filing"
		]
	},
	"1f4cb": {
		"name": "clipboard",
		"unicode_version": 6,
		"category": "objects",
		"order": 1887,
		"display": 1,
		"shortname": ":clipboard:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4cb",
			"fully_qualified": "1f4cb",
			"non_fully_qualified": "1f4cb",
			"output": "1f4cb",
			"default_matches": [
				"1f4cb"
			],
			"greedy_matches": [
				"1f4cb"
			],
			"decimal": ""
		},
		"keywords": [
			"clipboard"
		]
	},
	"1f4c1": {
		"name": "file folder",
		"unicode_version": 6,
		"category": "objects",
		"order": 1888,
		"display": 1,
		"shortname": ":file_folder:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c1",
			"fully_qualified": "1f4c1",
			"non_fully_qualified": "1f4c1",
			"output": "1f4c1",
			"default_matches": [
				"1f4c1"
			],
			"greedy_matches": [
				"1f4c1"
			],
			"decimal": ""
		},
		"keywords": [
			"file",
			"folder"
		]
	},
	"1f4c2": {
		"name": "open file folder",
		"unicode_version": 6,
		"category": "objects",
		"order": 1889,
		"display": 1,
		"shortname": ":open_file_folder:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4c2",
			"fully_qualified": "1f4c2",
			"non_fully_qualified": "1f4c2",
			"output": "1f4c2",
			"default_matches": [
				"1f4c2"
			],
			"greedy_matches": [
				"1f4c2"
			],
			"decimal": ""
		},
		"keywords": [
			"file",
			"folder",
			"open"
		]
	},
	"1f5c2": {
		"name": "card index dividers",
		"unicode_version": 7,
		"category": "objects",
		"order": 1890,
		"display": 1,
		"shortname": ":dividers:",
		"shortname_alternates": [
			":card_index_dividers:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5c2",
			"fully_qualified": "1f5c2-fe0f",
			"non_fully_qualified": "1f5c2",
			"output": "1f5c2-fe0f",
			"default_matches": [
				"1f5c2-fe0f",
				"1f5c2"
			],
			"greedy_matches": [
				"1f5c2-fe0f",
				"1f5c2"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"dividers",
			"index"
		]
	},
	"1f5de": {
		"name": "rolled-up newspaper",
		"unicode_version": 7,
		"category": "objects",
		"order": 1891,
		"display": 1,
		"shortname": ":newspaper2:",
		"shortname_alternates": [
			":rolled_up_newspaper:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5de",
			"fully_qualified": "1f5de-fe0f",
			"non_fully_qualified": "1f5de",
			"output": "1f5de-fe0f",
			"default_matches": [
				"1f5de-fe0f",
				"1f5de"
			],
			"greedy_matches": [
				"1f5de-fe0f",
				"1f5de"
			],
			"decimal": ""
		},
		"keywords": [
			"news",
			"newspaper",
			"paper",
			"rolled"
		]
	},
	"1f4f0": {
		"name": "newspaper",
		"unicode_version": 6,
		"category": "objects",
		"order": 1892,
		"display": 1,
		"shortname": ":newspaper:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f0",
			"fully_qualified": "1f4f0",
			"non_fully_qualified": "1f4f0",
			"output": "1f4f0",
			"default_matches": [
				"1f4f0"
			],
			"greedy_matches": [
				"1f4f0"
			],
			"decimal": ""
		},
		"keywords": [
			"news",
			"paper"
		]
	},
	"1f4d3": {
		"name": "notebook",
		"unicode_version": 6,
		"category": "objects",
		"order": 1893,
		"display": 1,
		"shortname": ":notebook:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d3",
			"fully_qualified": "1f4d3",
			"non_fully_qualified": "1f4d3",
			"output": "1f4d3",
			"default_matches": [
				"1f4d3"
			],
			"greedy_matches": [
				"1f4d3"
			],
			"decimal": ""
		},
		"keywords": [
			"notebook"
		]
	},
	"1f4d4": {
		"name": "notebook with decorative cover",
		"unicode_version": 6,
		"category": "objects",
		"order": 1894,
		"display": 1,
		"shortname": ":notebook_with_decorative_cover:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d4",
			"fully_qualified": "1f4d4",
			"non_fully_qualified": "1f4d4",
			"output": "1f4d4",
			"default_matches": [
				"1f4d4"
			],
			"greedy_matches": [
				"1f4d4"
			],
			"decimal": ""
		},
		"keywords": [
			"book",
			"cover",
			"decorated",
			"notebook"
		]
	},
	"1f4d2": {
		"name": "ledger",
		"unicode_version": 6,
		"category": "objects",
		"order": 1895,
		"display": 1,
		"shortname": ":ledger:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d2",
			"fully_qualified": "1f4d2",
			"non_fully_qualified": "1f4d2",
			"output": "1f4d2",
			"default_matches": [
				"1f4d2"
			],
			"greedy_matches": [
				"1f4d2"
			],
			"decimal": ""
		},
		"keywords": [
			"notebook"
		]
	},
	"1f4d5": {
		"name": "closed book",
		"unicode_version": 6,
		"category": "objects",
		"order": 1896,
		"display": 1,
		"shortname": ":closed_book:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d5",
			"fully_qualified": "1f4d5",
			"non_fully_qualified": "1f4d5",
			"output": "1f4d5",
			"default_matches": [
				"1f4d5"
			],
			"greedy_matches": [
				"1f4d5"
			],
			"decimal": ""
		},
		"keywords": [
			"book",
			"closed"
		]
	},
	"1f4d7": {
		"name": "green book",
		"unicode_version": 6,
		"category": "objects",
		"order": 1897,
		"display": 1,
		"shortname": ":green_book:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d7",
			"fully_qualified": "1f4d7",
			"non_fully_qualified": "1f4d7",
			"output": "1f4d7",
			"default_matches": [
				"1f4d7"
			],
			"greedy_matches": [
				"1f4d7"
			],
			"decimal": ""
		},
		"keywords": [
			"book",
			"green"
		]
	},
	"1f4d8": {
		"name": "blue book",
		"unicode_version": 6,
		"category": "objects",
		"order": 1898,
		"display": 1,
		"shortname": ":blue_book:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d8",
			"fully_qualified": "1f4d8",
			"non_fully_qualified": "1f4d8",
			"output": "1f4d8",
			"default_matches": [
				"1f4d8"
			],
			"greedy_matches": [
				"1f4d8"
			],
			"decimal": ""
		},
		"keywords": [
			"blue",
			"book"
		]
	},
	"1f4d9": {
		"name": "orange book",
		"unicode_version": 6,
		"category": "objects",
		"order": 1899,
		"display": 1,
		"shortname": ":orange_book:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d9",
			"fully_qualified": "1f4d9",
			"non_fully_qualified": "1f4d9",
			"output": "1f4d9",
			"default_matches": [
				"1f4d9"
			],
			"greedy_matches": [
				"1f4d9"
			],
			"decimal": ""
		},
		"keywords": [
			"book",
			"orange"
		]
	},
	"1f4da": {
		"name": "books",
		"unicode_version": 6,
		"category": "objects",
		"order": 1900,
		"display": 1,
		"shortname": ":books:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4da",
			"fully_qualified": "1f4da",
			"non_fully_qualified": "1f4da",
			"output": "1f4da",
			"default_matches": [
				"1f4da"
			],
			"greedy_matches": [
				"1f4da"
			],
			"decimal": ""
		},
		"keywords": [
			"book"
		]
	},
	"1f4d6": {
		"name": "open book",
		"unicode_version": 6,
		"category": "objects",
		"order": 1901,
		"display": 1,
		"shortname": ":book:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d6",
			"fully_qualified": "1f4d6",
			"non_fully_qualified": "1f4d6",
			"output": "1f4d6",
			"default_matches": [
				"1f4d6"
			],
			"greedy_matches": [
				"1f4d6"
			],
			"decimal": ""
		},
		"keywords": [
			"book",
			"open"
		]
	},
	"1f516": {
		"name": "bookmark",
		"unicode_version": 6,
		"category": "objects",
		"order": 1902,
		"display": 1,
		"shortname": ":bookmark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f516",
			"fully_qualified": "1f516",
			"non_fully_qualified": "1f516",
			"output": "1f516",
			"default_matches": [
				"1f516"
			],
			"greedy_matches": [
				"1f516"
			],
			"decimal": ""
		},
		"keywords": [
			"mark"
		]
	},
	"1f517": {
		"name": "link",
		"unicode_version": 6,
		"category": "objects",
		"order": 1903,
		"display": 1,
		"shortname": ":link:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f517",
			"fully_qualified": "1f517",
			"non_fully_qualified": "1f517",
			"output": "1f517",
			"default_matches": [
				"1f517"
			],
			"greedy_matches": [
				"1f517"
			],
			"decimal": ""
		},
		"keywords": [
			"link"
		]
	},
	"1f4ce": {
		"name": "paperclip",
		"unicode_version": 6,
		"category": "objects",
		"order": 1904,
		"display": 1,
		"shortname": ":paperclip:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ce",
			"fully_qualified": "1f4ce",
			"non_fully_qualified": "1f4ce",
			"output": "1f4ce",
			"default_matches": [
				"1f4ce"
			],
			"greedy_matches": [
				"1f4ce"
			],
			"decimal": ""
		},
		"keywords": [
			"paperclip"
		]
	},
	"1f587": {
		"name": "linked paperclips",
		"unicode_version": 7,
		"category": "objects",
		"order": 1905,
		"display": 1,
		"shortname": ":paperclips:",
		"shortname_alternates": [
			":linked_paperclips:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f587",
			"fully_qualified": "1f587-fe0f",
			"non_fully_qualified": "1f587",
			"output": "1f587-fe0f",
			"default_matches": [
				"1f587-fe0f",
				"1f587"
			],
			"greedy_matches": [
				"1f587-fe0f",
				"1f587"
			],
			"decimal": ""
		},
		"keywords": [
			"link",
			"paperclip"
		]
	},
	"1f4d0": {
		"name": "triangular ruler",
		"unicode_version": 6,
		"category": "objects",
		"order": 1906,
		"display": 1,
		"shortname": ":triangular_ruler:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4d0",
			"fully_qualified": "1f4d0",
			"non_fully_qualified": "1f4d0",
			"output": "1f4d0",
			"default_matches": [
				"1f4d0"
			],
			"greedy_matches": [
				"1f4d0"
			],
			"decimal": ""
		},
		"keywords": [
			"ruler",
			"set",
			"triangle"
		]
	},
	"1f4cf": {
		"name": "straight ruler",
		"unicode_version": 6,
		"category": "objects",
		"order": 1907,
		"display": 1,
		"shortname": ":straight_ruler:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4cf",
			"fully_qualified": "1f4cf",
			"non_fully_qualified": "1f4cf",
			"output": "1f4cf",
			"default_matches": [
				"1f4cf"
			],
			"greedy_matches": [
				"1f4cf"
			],
			"decimal": ""
		},
		"keywords": [
			"ruler",
			"straight edge"
		]
	},
	"1f4cc": {
		"name": "pushpin",
		"unicode_version": 6,
		"category": "objects",
		"order": 1908,
		"display": 1,
		"shortname": ":pushpin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4cc",
			"fully_qualified": "1f4cc",
			"non_fully_qualified": "1f4cc",
			"output": "1f4cc",
			"default_matches": [
				"1f4cc"
			],
			"greedy_matches": [
				"1f4cc"
			],
			"decimal": ""
		},
		"keywords": [
			"pin"
		]
	},
	"1f4cd": {
		"name": "round pushpin",
		"unicode_version": 6,
		"category": "objects",
		"order": 1909,
		"display": 1,
		"shortname": ":round_pushpin:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4cd",
			"fully_qualified": "1f4cd",
			"non_fully_qualified": "1f4cd",
			"output": "1f4cd",
			"default_matches": [
				"1f4cd"
			],
			"greedy_matches": [
				"1f4cd"
			],
			"decimal": ""
		},
		"keywords": [
			"pin",
			"pushpin"
		]
	},
	"1f58a": {
		"name": "pen",
		"unicode_version": 7,
		"category": "objects",
		"order": 1911,
		"display": 1,
		"shortname": ":pen_ballpoint:",
		"shortname_alternates": [
			":lower_left_ballpoint_pen:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f58a",
			"fully_qualified": "1f58a-fe0f",
			"non_fully_qualified": "1f58a",
			"output": "1f58a-fe0f",
			"default_matches": [
				"1f58a-fe0f",
				"1f58a"
			],
			"greedy_matches": [
				"1f58a-fe0f",
				"1f58a"
			],
			"decimal": ""
		},
		"keywords": [
			"ballpoint"
		]
	},
	"1f58b": {
		"name": "fountain pen",
		"unicode_version": 7,
		"category": "objects",
		"order": 1912,
		"display": 1,
		"shortname": ":pen_fountain:",
		"shortname_alternates": [
			":lower_left_fountain_pen:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f58b",
			"fully_qualified": "1f58b-fe0f",
			"non_fully_qualified": "1f58b",
			"output": "1f58b-fe0f",
			"default_matches": [
				"1f58b-fe0f",
				"1f58b"
			],
			"greedy_matches": [
				"1f58b-fe0f",
				"1f58b"
			],
			"decimal": ""
		},
		"keywords": [
			"fountain",
			"pen"
		]
	},
	"1f58c": {
		"name": "paintbrush",
		"unicode_version": 7,
		"category": "objects",
		"order": 1914,
		"display": 1,
		"shortname": ":paintbrush:",
		"shortname_alternates": [
			":lower_left_paintbrush:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f58c",
			"fully_qualified": "1f58c-fe0f",
			"non_fully_qualified": "1f58c",
			"output": "1f58c-fe0f",
			"default_matches": [
				"1f58c-fe0f",
				"1f58c"
			],
			"greedy_matches": [
				"1f58c-fe0f",
				"1f58c"
			],
			"decimal": ""
		},
		"keywords": [
			"painting"
		]
	},
	"1f58d": {
		"name": "crayon",
		"unicode_version": 7,
		"category": "objects",
		"order": 1915,
		"display": 1,
		"shortname": ":crayon:",
		"shortname_alternates": [
			":lower_left_crayon:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f58d",
			"fully_qualified": "1f58d-fe0f",
			"non_fully_qualified": "1f58d",
			"output": "1f58d-fe0f",
			"default_matches": [
				"1f58d-fe0f",
				"1f58d"
			],
			"greedy_matches": [
				"1f58d-fe0f",
				"1f58d"
			],
			"decimal": ""
		},
		"keywords": [
			"crayon"
		]
	},
	"1f4dd": {
		"name": "memo",
		"unicode_version": 6,
		"category": "objects",
		"order": 1916,
		"display": 1,
		"shortname": ":pencil:",
		"shortname_alternates": [
			":memo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4dd",
			"fully_qualified": "1f4dd",
			"non_fully_qualified": "1f4dd",
			"output": "1f4dd",
			"default_matches": [
				"1f4dd"
			],
			"greedy_matches": [
				"1f4dd"
			],
			"decimal": ""
		},
		"keywords": [
			"pencil"
		]
	},
	"270f": {
		"name": "pencil",
		"unicode_version": 1.1,
		"category": "objects",
		"order": 1917,
		"display": 1,
		"shortname": ":pencil2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "270f",
			"fully_qualified": "270f-fe0f",
			"non_fully_qualified": "270f",
			"output": "270f-fe0f",
			"default_matches": [
				"270f-fe0f",
				"270f"
			],
			"greedy_matches": [
				"270f-fe0f",
				"270f"
			],
			"decimal": ""
		},
		"keywords": [
			"pencil"
		]
	},
	"1f50d": {
		"name": "left-pointing magnifying glass",
		"unicode_version": 6,
		"category": "objects",
		"order": 1918,
		"display": 1,
		"shortname": ":mag:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50d",
			"fully_qualified": "1f50d",
			"non_fully_qualified": "1f50d",
			"output": "1f50d",
			"default_matches": [
				"1f50d"
			],
			"greedy_matches": [
				"1f50d"
			],
			"decimal": ""
		},
		"keywords": [
			"glass",
			"magnifying",
			"search",
			"tool"
		]
	},
	"1f50e": {
		"name": "right-pointing magnifying glass",
		"unicode_version": 6,
		"category": "objects",
		"order": 1919,
		"display": 1,
		"shortname": ":mag_right:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50e",
			"fully_qualified": "1f50e",
			"non_fully_qualified": "1f50e",
			"output": "1f50e",
			"default_matches": [
				"1f50e"
			],
			"greedy_matches": [
				"1f50e"
			],
			"decimal": ""
		},
		"keywords": [
			"glass",
			"magnifying",
			"search",
			"tool"
		]
	},
	"1f50f": {
		"name": "locked with pen",
		"unicode_version": 6,
		"category": "objects",
		"order": 1920,
		"display": 1,
		"shortname": ":lock_with_ink_pen:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50f",
			"fully_qualified": "1f50f",
			"non_fully_qualified": "1f50f",
			"output": "1f50f",
			"default_matches": [
				"1f50f"
			],
			"greedy_matches": [
				"1f50f"
			],
			"decimal": ""
		},
		"keywords": [
			"ink",
			"lock",
			"nib",
			"pen",
			"privacy"
		]
	},
	"1f510": {
		"name": "locked with key",
		"unicode_version": 6,
		"category": "objects",
		"order": 1921,
		"display": 1,
		"shortname": ":closed_lock_with_key:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f510",
			"fully_qualified": "1f510",
			"non_fully_qualified": "1f510",
			"output": "1f510",
			"default_matches": [
				"1f510"
			],
			"greedy_matches": [
				"1f510"
			],
			"decimal": ""
		},
		"keywords": [
			"closed",
			"key",
			"lock",
			"secure"
		]
	},
	"1f512": {
		"name": "locked",
		"unicode_version": 6,
		"category": "objects",
		"order": 1922,
		"display": 1,
		"shortname": ":lock:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f512",
			"fully_qualified": "1f512",
			"non_fully_qualified": "1f512",
			"output": "1f512",
			"default_matches": [
				"1f512"
			],
			"greedy_matches": [
				"1f512"
			],
			"decimal": ""
		},
		"keywords": [
			"closed"
		]
	},
	"1f513": {
		"name": "unlocked",
		"unicode_version": 6,
		"category": "objects",
		"order": 1923,
		"display": 1,
		"shortname": ":unlock:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f513",
			"fully_qualified": "1f513",
			"non_fully_qualified": "1f513",
			"output": "1f513",
			"default_matches": [
				"1f513"
			],
			"greedy_matches": [
				"1f513"
			],
			"decimal": ""
		},
		"keywords": [
			"lock",
			"open",
			"unlock"
		]
	},
	"1f9e1": {
		"name": "orange heart",
		"unicode_version": 10,
		"category": "objects",
		"order": 1924,
		"display": 1,
		"shortname": ":orange_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e1",
			"fully_qualified": "1f9e1",
			"non_fully_qualified": "1f9e1",
			"output": "1f9e1",
			"default_matches": [
				"1f9e1"
			],
			"greedy_matches": [
				"1f9e1"
			],
			"decimal": ""
		},
		"keywords": [
			"orange"
		]
	},
	"1f49b": {
		"name": "yellow heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1926,
		"display": 1,
		"shortname": ":yellow_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49b",
			"fully_qualified": "1f49b",
			"non_fully_qualified": "1f49b",
			"output": "1f49b",
			"default_matches": [
				"1f49b"
			],
			"greedy_matches": [
				"1f49b"
			],
			"decimal": ""
		},
		"keywords": [
			"yellow"
		]
	},
	"1f49a": {
		"name": "green heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1927,
		"display": 1,
		"shortname": ":green_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49a",
			"fully_qualified": "1f49a",
			"non_fully_qualified": "1f49a",
			"output": "1f49a",
			"default_matches": [
				"1f49a"
			],
			"greedy_matches": [
				"1f49a"
			],
			"decimal": ""
		},
		"keywords": [
			"green"
		]
	},
	"1f499": {
		"name": "blue heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1928,
		"display": 1,
		"shortname": ":blue_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f499",
			"fully_qualified": "1f499",
			"non_fully_qualified": "1f499",
			"output": "1f499",
			"default_matches": [
				"1f499"
			],
			"greedy_matches": [
				"1f499"
			],
			"decimal": ""
		},
		"keywords": [
			"blue"
		]
	},
	"1f49c": {
		"name": "purple heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1929,
		"display": 1,
		"shortname": ":purple_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49c",
			"fully_qualified": "1f49c",
			"non_fully_qualified": "1f49c",
			"output": "1f49c",
			"default_matches": [
				"1f49c"
			],
			"greedy_matches": [
				"1f49c"
			],
			"decimal": ""
		},
		"keywords": [
			"purple"
		]
	},
	"1f5a4": {
		"name": "black heart",
		"unicode_version": 9,
		"category": "symbols",
		"order": 1930,
		"display": 1,
		"shortname": ":black_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5a4",
			"fully_qualified": "1f5a4",
			"non_fully_qualified": "1f5a4",
			"output": "1f5a4",
			"default_matches": [
				"1f5a4"
			],
			"greedy_matches": [
				"1f5a4"
			],
			"decimal": ""
		},
		"keywords": [
			"black",
			"evil",
			"wicked"
		]
	},
	"1f494": {
		"name": "broken heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1931,
		"display": 1,
		"shortname": ":broken_heart:",
		"shortname_alternates": [],
		"ascii": [
			"</3"
		],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f494",
			"fully_qualified": "1f494",
			"non_fully_qualified": "1f494",
			"output": "1f494",
			"default_matches": [
				"1f494"
			],
			"greedy_matches": [
				"1f494"
			],
			"decimal": ""
		},
		"keywords": [
			"break",
			"broken"
		]
	},
	"1f495": {
		"name": "two hearts",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1933,
		"display": 1,
		"shortname": ":two_hearts:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f495",
			"fully_qualified": "1f495",
			"non_fully_qualified": "1f495",
			"output": "1f495",
			"default_matches": [
				"1f495"
			],
			"greedy_matches": [
				"1f495"
			],
			"decimal": ""
		},
		"keywords": [
			"love"
		]
	},
	"1f49e": {
		"name": "revolving hearts",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1934,
		"display": 1,
		"shortname": ":revolving_hearts:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49e",
			"fully_qualified": "1f49e",
			"non_fully_qualified": "1f49e",
			"output": "1f49e",
			"default_matches": [
				"1f49e"
			],
			"greedy_matches": [
				"1f49e"
			],
			"decimal": ""
		},
		"keywords": [
			"revolving"
		]
	},
	"1f493": {
		"name": "beating heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1935,
		"display": 1,
		"shortname": ":heartbeat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f493",
			"fully_qualified": "1f493",
			"non_fully_qualified": "1f493",
			"output": "1f493",
			"default_matches": [
				"1f493"
			],
			"greedy_matches": [
				"1f493"
			],
			"decimal": ""
		},
		"keywords": [
			"beating",
			"heartbeat",
			"pulsating"
		]
	},
	"1f497": {
		"name": "growing heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1936,
		"display": 1,
		"shortname": ":heartpulse:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f497",
			"fully_qualified": "1f497",
			"non_fully_qualified": "1f497",
			"output": "1f497",
			"default_matches": [
				"1f497"
			],
			"greedy_matches": [
				"1f497"
			],
			"decimal": ""
		},
		"keywords": [
			"excited",
			"growing",
			"nervous",
			"pulse"
		]
	},
	"1f496": {
		"name": "sparkling heart",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1937,
		"display": 1,
		"shortname": ":sparkling_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f496",
			"fully_qualified": "1f496",
			"non_fully_qualified": "1f496",
			"output": "1f496",
			"default_matches": [
				"1f496"
			],
			"greedy_matches": [
				"1f496"
			],
			"decimal": ""
		},
		"keywords": [
			"excited",
			"sparkle"
		]
	},
	"1f498": {
		"name": "heart with arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1938,
		"display": 1,
		"shortname": ":cupid:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f498",
			"fully_qualified": "1f498",
			"non_fully_qualified": "1f498",
			"output": "1f498",
			"default_matches": [
				"1f498"
			],
			"greedy_matches": [
				"1f498"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"cupid"
		]
	},
	"1f49d": {
		"name": "heart with ribbon",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1939,
		"display": 1,
		"shortname": ":gift_heart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49d",
			"fully_qualified": "1f49d",
			"non_fully_qualified": "1f49d",
			"output": "1f49d",
			"default_matches": [
				"1f49d"
			],
			"greedy_matches": [
				"1f49d"
			],
			"decimal": ""
		},
		"keywords": [
			"ribbon",
			"valentine"
		]
	},
	"1f49f": {
		"name": "heart decoration",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1940,
		"display": 1,
		"shortname": ":heart_decoration:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f49f",
			"fully_qualified": "1f49f",
			"non_fully_qualified": "1f49f",
			"output": "1f49f",
			"default_matches": [
				"1f49f"
			],
			"greedy_matches": [
				"1f49f"
			],
			"decimal": ""
		},
		"keywords": [
			"heart"
		]
	},
	"262e": {
		"name": "peace symbol",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1941,
		"display": 1,
		"shortname": ":peace:",
		"shortname_alternates": [
			":peace_symbol:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "262e",
			"fully_qualified": "262e-fe0f",
			"non_fully_qualified": "262e",
			"output": "262e-fe0f",
			"default_matches": [
				"262e-fe0f"
			],
			"greedy_matches": [
				"262e-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"peace"
		]
	},
	"271d": {
		"name": "latin cross",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1942,
		"display": 1,
		"shortname": ":cross:",
		"shortname_alternates": [
			":latin_cross:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "271d",
			"fully_qualified": "271d-fe0f",
			"non_fully_qualified": "271d",
			"output": "271d-fe0f",
			"default_matches": [
				"271d-fe0f"
			],
			"greedy_matches": [
				"271d-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Christian",
			"cross",
			"religion"
		]
	},
	"262a": {
		"name": "star and crescent",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1943,
		"display": 1,
		"shortname": ":star_and_crescent:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "262a",
			"fully_qualified": "262a-fe0f",
			"non_fully_qualified": "262a",
			"output": "262a-fe0f",
			"default_matches": [
				"262a-fe0f"
			],
			"greedy_matches": [
				"262a-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Muslim",
			"islam",
			"religion"
		]
	},
	"1f549": {
		"name": "om",
		"unicode_version": 7,
		"category": "symbols",
		"order": 1944,
		"display": 1,
		"shortname": ":om_symbol:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f549",
			"fully_qualified": "1f549-fe0f",
			"non_fully_qualified": "1f549",
			"output": "1f549-fe0f",
			"default_matches": [
				"1f549-fe0f"
			],
			"greedy_matches": [
				"1f549-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Hindu",
			"religion"
		]
	},
	"1f52f": {
		"name": "dotted six-pointed star",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1947,
		"display": 1,
		"shortname": ":six_pointed_star:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f52f",
			"fully_qualified": "1f52f",
			"non_fully_qualified": "1f52f",
			"output": "1f52f",
			"default_matches": [
				"1f52f"
			],
			"greedy_matches": [
				"1f52f"
			],
			"decimal": ""
		},
		"keywords": [
			"fortune",
			"star"
		]
	},
	"1f54e": {
		"name": "menorah",
		"unicode_version": 8,
		"category": "symbols",
		"order": 1948,
		"display": 1,
		"shortname": ":menorah:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f54e",
			"fully_qualified": "1f54e",
			"non_fully_qualified": "1f54e",
			"output": "1f54e",
			"default_matches": [
				"1f54e"
			],
			"greedy_matches": [
				"1f54e"
			],
			"decimal": ""
		},
		"keywords": [
			"candelabrum",
			"candlestick",
			"religion"
		]
	},
	"262f": {
		"name": "yin yang",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1949,
		"display": 1,
		"shortname": ":yin_yang:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "262f",
			"fully_qualified": "262f-fe0f",
			"non_fully_qualified": "262f",
			"output": "262f-fe0f",
			"default_matches": [
				"262f-fe0f"
			],
			"greedy_matches": [
				"262f-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"religion",
			"tao",
			"taoist",
			"yang",
			"yin"
		]
	},
	"1f6d0": {
		"name": "place of worship",
		"unicode_version": 8,
		"category": "symbols",
		"order": 1951,
		"display": 1,
		"shortname": ":place_of_worship:",
		"shortname_alternates": [
			":worship_symbol:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6d0",
			"fully_qualified": "1f6d0",
			"non_fully_qualified": "1f6d0",
			"output": "1f6d0",
			"default_matches": [
				"1f6d0"
			],
			"greedy_matches": [
				"1f6d0"
			],
			"decimal": ""
		},
		"keywords": [
			"religion",
			"worship"
		]
	},
	"26ce": {
		"name": "Ophiuchus",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1952,
		"display": 1,
		"shortname": ":ophiuchus:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26ce",
			"fully_qualified": "26ce",
			"non_fully_qualified": "26ce",
			"output": "26ce",
			"default_matches": [
				"26ce"
			],
			"greedy_matches": [
				"26ce"
			],
			"decimal": ""
		},
		"keywords": [
			"bearer",
			"serpent",
			"snake",
			"zodiac"
		]
	},
	"264a": {
		"name": "Gemini",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1955,
		"display": 1,
		"shortname": ":gemini:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264a",
			"fully_qualified": "264a",
			"non_fully_qualified": "264a",
			"output": "264a",
			"default_matches": [
				"264a"
			],
			"greedy_matches": [
				"264a"
			],
			"decimal": ""
		},
		"keywords": [
			"twins",
			"zodiac"
		]
	},
	"264b": {
		"name": "Cancer",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1956,
		"display": 1,
		"shortname": ":cancer:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264b",
			"fully_qualified": "264b",
			"non_fully_qualified": "264b",
			"output": "264b",
			"default_matches": [
				"264b"
			],
			"greedy_matches": [
				"264b"
			],
			"decimal": ""
		},
		"keywords": [
			"crab",
			"zodiac"
		]
	},
	"264c": {
		"name": "Leo",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1957,
		"display": 1,
		"shortname": ":leo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264c",
			"fully_qualified": "264c",
			"non_fully_qualified": "264c",
			"output": "264c",
			"default_matches": [
				"264c"
			],
			"greedy_matches": [
				"264c"
			],
			"decimal": ""
		},
		"keywords": [
			"lion",
			"zodiac"
		]
	},
	"264d": {
		"name": "Virgo",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1958,
		"display": 1,
		"shortname": ":virgo:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264d",
			"fully_qualified": "264d",
			"non_fully_qualified": "264d",
			"output": "264d",
			"default_matches": [
				"264d"
			],
			"greedy_matches": [
				"264d"
			],
			"decimal": ""
		},
		"keywords": [
			"zodiac"
		]
	},
	"264e": {
		"name": "Libra",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1959,
		"display": 1,
		"shortname": ":libra:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264e",
			"fully_qualified": "264e",
			"non_fully_qualified": "264e",
			"output": "264e",
			"default_matches": [
				"264e"
			],
			"greedy_matches": [
				"264e"
			],
			"decimal": ""
		},
		"keywords": [
			"balance",
			"justice",
			"scales",
			"zodiac"
		]
	},
	"264f": {
		"name": "Scorpius",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 1960,
		"display": 1,
		"shortname": ":scorpius:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "264f",
			"fully_qualified": "264f",
			"non_fully_qualified": "264f",
			"output": "264f",
			"default_matches": [
				"264f"
			],
			"greedy_matches": [
				"264f"
			],
			"decimal": ""
		},
		"keywords": [
			"scorpio",
			"scorpion",
			"zodiac"
		]
	},
	"1f194": {
		"name": "ID button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1965,
		"display": 1,
		"shortname": ":id:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f194",
			"fully_qualified": "1f194",
			"non_fully_qualified": "1f194",
			"output": "1f194",
			"default_matches": [
				"1f194"
			],
			"greedy_matches": [
				"1f194"
			],
			"decimal": ""
		},
		"keywords": [
			"id",
			"identity"
		]
	},
	"269b": {
		"name": "atom symbol",
		"unicode_version": 4.1,
		"category": "symbols",
		"order": 1966,
		"display": 1,
		"shortname": ":atom:",
		"shortname_alternates": [
			":atom_symbol:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "269b",
			"fully_qualified": "269b-fe0f",
			"non_fully_qualified": "269b",
			"output": "269b-fe0f",
			"default_matches": [
				"269b-fe0f"
			],
			"greedy_matches": [
				"269b-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"atheist",
			"atom"
		]
	},
	"1f251": {
		"name": "Japanese “acceptable” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1967,
		"display": 1,
		"shortname": ":accept:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f251",
			"fully_qualified": "1f251",
			"non_fully_qualified": "1f251",
			"output": "1f251",
			"default_matches": [
				"1f251"
			],
			"greedy_matches": [
				"1f251"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“acceptable”",
			"可"
		]
	},
	"1f4f4": {
		"name": "mobile phone off",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1970,
		"display": 1,
		"shortname": ":mobile_phone_off:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f4",
			"fully_qualified": "1f4f4",
			"non_fully_qualified": "1f4f4",
			"output": "1f4f4",
			"default_matches": [
				"1f4f4"
			],
			"greedy_matches": [
				"1f4f4"
			],
			"decimal": ""
		},
		"keywords": [
			"cell",
			"mobile",
			"off",
			"phone",
			"telephone"
		]
	},
	"1f4f3": {
		"name": "vibration mode",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1971,
		"display": 1,
		"shortname": ":vibration_mode:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f3",
			"fully_qualified": "1f4f3",
			"non_fully_qualified": "1f4f3",
			"output": "1f4f3",
			"default_matches": [
				"1f4f3"
			],
			"greedy_matches": [
				"1f4f3"
			],
			"decimal": ""
		},
		"keywords": [
			"cell",
			"mobile",
			"mode",
			"phone",
			"telephone",
			"vibration"
		]
	},
	"1f236": {
		"name": "Japanese “not free of charge” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1972,
		"display": 1,
		"shortname": ":u6709:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f236",
			"fully_qualified": "1f236",
			"non_fully_qualified": "1f236",
			"output": "1f236",
			"default_matches": [
				"1f236"
			],
			"greedy_matches": [
				"1f236"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“not free of charge”",
			"有"
		]
	},
	"1f21a": {
		"name": "Japanese “free of charge” button",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 1973,
		"display": 1,
		"shortname": ":u7121:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f21a",
			"fully_qualified": "1f21a",
			"non_fully_qualified": "1f21a",
			"output": "1f21a",
			"default_matches": [
				"1f21a"
			],
			"greedy_matches": [
				"1f21a"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“free of charge”",
			"無"
		]
	},
	"1f238": {
		"name": "Japanese “application” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1974,
		"display": 1,
		"shortname": ":u7533:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f238",
			"fully_qualified": "1f238",
			"non_fully_qualified": "1f238",
			"output": "1f238",
			"default_matches": [
				"1f238"
			],
			"greedy_matches": [
				"1f238"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“application”",
			"申"
		]
	},
	"1f23a": {
		"name": "Japanese “open for business” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1975,
		"display": 1,
		"shortname": ":u55b6:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f23a",
			"fully_qualified": "1f23a",
			"non_fully_qualified": "1f23a",
			"output": "1f23a",
			"default_matches": [
				"1f23a"
			],
			"greedy_matches": [
				"1f23a"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“open for business”",
			"営"
		]
	},
	"1f237": {
		"name": "Japanese “monthly amount” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1976,
		"display": 1,
		"shortname": ":u6708:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f237",
			"fully_qualified": "1f237-fe0f",
			"non_fully_qualified": "1f237",
			"output": "1f237-fe0f",
			"default_matches": [
				"1f237-fe0f",
				"1f237"
			],
			"greedy_matches": [
				"1f237-fe0f",
				"1f237"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“monthly amount”",
			"月"
		]
	},
	"1f19a": {
		"name": "VS button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1978,
		"display": 1,
		"shortname": ":vs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f19a",
			"fully_qualified": "1f19a",
			"non_fully_qualified": "1f19a",
			"output": "1f19a",
			"default_matches": [
				"1f19a"
			],
			"greedy_matches": [
				"1f19a"
			],
			"decimal": ""
		},
		"keywords": [
			"versus",
			"vs"
		]
	},
	"1f4ae": {
		"name": "white flower",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1979,
		"display": 1,
		"shortname": ":white_flower:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ae",
			"fully_qualified": "1f4ae",
			"non_fully_qualified": "1f4ae",
			"output": "1f4ae",
			"default_matches": [
				"1f4ae"
			],
			"greedy_matches": [
				"1f4ae"
			],
			"decimal": ""
		},
		"keywords": [
			"flower"
		]
	},
	"1f250": {
		"name": "Japanese “bargain” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1980,
		"display": 1,
		"shortname": ":ideograph_advantage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f250",
			"fully_qualified": "1f250",
			"non_fully_qualified": "1f250",
			"output": "1f250",
			"default_matches": [
				"1f250"
			],
			"greedy_matches": [
				"1f250"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“bargain”",
			"得"
		]
	},
	"1f234": {
		"name": "Japanese “passing grade” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1983,
		"display": 1,
		"shortname": ":u5408:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f234",
			"fully_qualified": "1f234",
			"non_fully_qualified": "1f234",
			"output": "1f234",
			"default_matches": [
				"1f234"
			],
			"greedy_matches": [
				"1f234"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“passing grade”",
			"合"
		]
	},
	"1f235": {
		"name": "Japanese “no vacancy” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1984,
		"display": 1,
		"shortname": ":u6e80:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f235",
			"fully_qualified": "1f235",
			"non_fully_qualified": "1f235",
			"output": "1f235",
			"default_matches": [
				"1f235"
			],
			"greedy_matches": [
				"1f235"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“no vacancy”",
			"満"
		]
	},
	"1f239": {
		"name": "Japanese “discount” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1985,
		"display": 1,
		"shortname": ":u5272:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f239",
			"fully_qualified": "1f239",
			"non_fully_qualified": "1f239",
			"output": "1f239",
			"default_matches": [
				"1f239"
			],
			"greedy_matches": [
				"1f239"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“discount”",
			"割"
		]
	},
	"1f232": {
		"name": "Japanese “prohibited” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1986,
		"display": 1,
		"shortname": ":u7981:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f232",
			"fully_qualified": "1f232",
			"non_fully_qualified": "1f232",
			"output": "1f232",
			"default_matches": [
				"1f232"
			],
			"greedy_matches": [
				"1f232"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“prohibited”",
			"禁"
		]
	},
	"1f170": {
		"name": "A button (blood type)",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1987,
		"display": 1,
		"shortname": ":a:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f170",
			"fully_qualified": "1f170-fe0f",
			"non_fully_qualified": "1f170",
			"output": "1f170-fe0f",
			"default_matches": [
				"1f170-fe0f",
				"1f170"
			],
			"greedy_matches": [
				"1f170-fe0f",
				"1f170"
			],
			"decimal": ""
		},
		"keywords": [
			"a",
			"blood type"
		]
	},
	"1f171": {
		"name": "B button (blood type)",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1988,
		"display": 1,
		"shortname": ":b:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f171",
			"fully_qualified": "1f171-fe0f",
			"non_fully_qualified": "1f171",
			"output": "1f171-fe0f",
			"default_matches": [
				"1f171-fe0f",
				"1f171"
			],
			"greedy_matches": [
				"1f171-fe0f",
				"1f171"
			],
			"decimal": ""
		},
		"keywords": [
			"b",
			"blood type"
		]
	},
	"1f18e": {
		"name": "AB button (blood type)",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1989,
		"display": 1,
		"shortname": ":ab:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f18e",
			"fully_qualified": "1f18e",
			"non_fully_qualified": "1f18e",
			"output": "1f18e",
			"default_matches": [
				"1f18e"
			],
			"greedy_matches": [
				"1f18e"
			],
			"decimal": ""
		},
		"keywords": [
			"ab",
			"blood type"
		]
	},
	"1f191": {
		"name": "CL button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1990,
		"display": 1,
		"shortname": ":cl:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f191",
			"fully_qualified": "1f191",
			"non_fully_qualified": "1f191",
			"output": "1f191",
			"default_matches": [
				"1f191"
			],
			"greedy_matches": [
				"1f191"
			],
			"decimal": ""
		},
		"keywords": [
			"cl"
		]
	},
	"1f17e": {
		"name": "O button (blood type)",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1991,
		"display": 1,
		"shortname": ":o2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f17e",
			"fully_qualified": "1f17e-fe0f",
			"non_fully_qualified": "1f17e",
			"output": "1f17e-fe0f",
			"default_matches": [
				"1f17e-fe0f",
				"1f17e"
			],
			"greedy_matches": [
				"1f17e-fe0f",
				"1f17e"
			],
			"decimal": ""
		},
		"keywords": [
			"blood type",
			"o"
		]
	},
	"1f198": {
		"name": "SOS button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1992,
		"display": 1,
		"shortname": ":sos:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f198",
			"fully_qualified": "1f198",
			"non_fully_qualified": "1f198",
			"output": "1f198",
			"default_matches": [
				"1f198"
			],
			"greedy_matches": [
				"1f198"
			],
			"decimal": ""
		},
		"keywords": [
			"help",
			"sos"
		]
	},
	"274c": {
		"name": "cross mark",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1993,
		"display": 1,
		"shortname": ":x:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "274c",
			"fully_qualified": "274c",
			"non_fully_qualified": "274c",
			"output": "274c",
			"default_matches": [
				"274c"
			],
			"greedy_matches": [
				"274c"
			],
			"decimal": ""
		},
		"keywords": [
			"cancel",
			"mark",
			"multiplication",
			"multiply",
			"x"
		]
	},
	"2b55": {
		"name": "heavy large circle",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 1994,
		"display": 1,
		"shortname": ":o:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b55",
			"fully_qualified": "2b55",
			"non_fully_qualified": "2b55",
			"output": "2b55",
			"default_matches": [
				"2b55"
			],
			"greedy_matches": [
				"2b55"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"o"
		]
	},
	"1f6d1": {
		"name": "stop sign",
		"unicode_version": 9,
		"category": "symbols",
		"order": 1995,
		"display": 1,
		"shortname": ":octagonal_sign:",
		"shortname_alternates": [
			":stop_sign:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6d1",
			"fully_qualified": "1f6d1",
			"non_fully_qualified": "1f6d1",
			"output": "1f6d1",
			"default_matches": [
				"1f6d1"
			],
			"greedy_matches": [
				"1f6d1"
			],
			"decimal": ""
		},
		"keywords": [
			"octagonal",
			"sign",
			"stop"
		]
	},
	"26d4": {
		"name": "no entry",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 1996,
		"display": 1,
		"shortname": ":no_entry:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26d4",
			"fully_qualified": "26d4",
			"non_fully_qualified": "26d4",
			"output": "26d4",
			"default_matches": [
				"26d4"
			],
			"greedy_matches": [
				"26d4"
			],
			"decimal": ""
		},
		"keywords": [
			"entry",
			"forbidden",
			"no",
			"not",
			"prohibited",
			"traffic"
		]
	},
	"1f4db": {
		"name": "name badge",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1997,
		"display": 1,
		"shortname": ":name_badge:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4db",
			"fully_qualified": "1f4db",
			"non_fully_qualified": "1f4db",
			"output": "1f4db",
			"default_matches": [
				"1f4db"
			],
			"greedy_matches": [
				"1f4db"
			],
			"decimal": ""
		},
		"keywords": [
			"badge",
			"name"
		]
	},
	"1f6ab": {
		"name": "prohibited",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1998,
		"display": 1,
		"shortname": ":no_entry_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ab",
			"fully_qualified": "1f6ab",
			"non_fully_qualified": "1f6ab",
			"output": "1f6ab",
			"default_matches": [
				"1f6ab"
			],
			"greedy_matches": [
				"1f6ab"
			],
			"decimal": ""
		},
		"keywords": [
			"entry",
			"forbidden",
			"no",
			"not"
		]
	},
	"1f4af": {
		"name": "hundred points",
		"unicode_version": 6,
		"category": "symbols",
		"order": 1999,
		"display": 1,
		"shortname": ":100:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4af",
			"fully_qualified": "1f4af",
			"non_fully_qualified": "1f4af",
			"output": "1f4af",
			"default_matches": [
				"1f4af"
			],
			"greedy_matches": [
				"1f4af"
			],
			"decimal": ""
		},
		"keywords": [
			"100",
			"full",
			"hundred",
			"score"
		]
	},
	"1f4a2": {
		"name": "anger symbol",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2000,
		"display": 1,
		"shortname": ":anger:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a2",
			"fully_qualified": "1f4a2",
			"non_fully_qualified": "1f4a2",
			"output": "1f4a2",
			"default_matches": [
				"1f4a2"
			],
			"greedy_matches": [
				"1f4a2"
			],
			"decimal": ""
		},
		"keywords": [
			"angry",
			"comic",
			"mad"
		]
	},
	"1f6b7": {
		"name": "no pedestrians",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2002,
		"display": 1,
		"shortname": ":no_pedestrians:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b7",
			"fully_qualified": "1f6b7",
			"non_fully_qualified": "1f6b7",
			"output": "1f6b7",
			"default_matches": [
				"1f6b7"
			],
			"greedy_matches": [
				"1f6b7"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"no",
			"not",
			"pedestrian",
			"prohibited"
		]
	},
	"1f6af": {
		"name": "no littering",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2003,
		"display": 1,
		"shortname": ":do_not_litter:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6af",
			"fully_qualified": "1f6af",
			"non_fully_qualified": "1f6af",
			"output": "1f6af",
			"default_matches": [
				"1f6af"
			],
			"greedy_matches": [
				"1f6af"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"litter",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f6b3": {
		"name": "no bicycles",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2004,
		"display": 1,
		"shortname": ":no_bicycles:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b3",
			"fully_qualified": "1f6b3",
			"non_fully_qualified": "1f6b3",
			"output": "1f6b3",
			"default_matches": [
				"1f6b3"
			],
			"greedy_matches": [
				"1f6b3"
			],
			"decimal": ""
		},
		"keywords": [
			"bicycle",
			"bike",
			"forbidden",
			"no",
			"not",
			"prohibited"
		]
	},
	"1f6b1": {
		"name": "non-potable water",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2005,
		"display": 1,
		"shortname": ":non-potable_water:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b1",
			"fully_qualified": "1f6b1",
			"non_fully_qualified": "1f6b1",
			"output": "1f6b1",
			"default_matches": [
				"1f6b1"
			],
			"greedy_matches": [
				"1f6b1"
			],
			"decimal": ""
		},
		"keywords": [
			"non-drinking",
			"non-potable",
			"water"
		]
	},
	"1f51e": {
		"name": "no one under eighteen",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2006,
		"display": 1,
		"shortname": ":underage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51e",
			"fully_qualified": "1f51e",
			"non_fully_qualified": "1f51e",
			"output": "1f51e",
			"default_matches": [
				"1f51e"
			],
			"greedy_matches": [
				"1f51e"
			],
			"decimal": ""
		},
		"keywords": [
			"18",
			"age restriction",
			"eighteen",
			"forbidden",
			"no",
			"not",
			"prohibited",
			"underage"
		]
	},
	"1f4f5": {
		"name": "no mobile phones",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2007,
		"display": 1,
		"shortname": ":no_mobile_phones:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f5",
			"fully_qualified": "1f4f5",
			"non_fully_qualified": "1f4f5",
			"output": "1f4f5",
			"default_matches": [
				"1f4f5"
			],
			"greedy_matches": [
				"1f4f5"
			],
			"decimal": ""
		},
		"keywords": [
			"cell",
			"forbidden",
			"mobile",
			"no",
			"not",
			"phone",
			"prohibited",
			"telephone"
		]
	},
	"1f6ad": {
		"name": "no smoking",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2008,
		"display": 1,
		"shortname": ":no_smoking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ad",
			"fully_qualified": "1f6ad",
			"non_fully_qualified": "1f6ad",
			"output": "1f6ad",
			"default_matches": [
				"1f6ad"
			],
			"greedy_matches": [
				"1f6ad"
			],
			"decimal": ""
		},
		"keywords": [
			"forbidden",
			"no",
			"not",
			"prohibited",
			"smoking"
		]
	},
	"203c": {
		"name": "double exclamation mark",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2013,
		"display": 1,
		"shortname": ":bangbang:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "203c",
			"fully_qualified": "203c-fe0f",
			"non_fully_qualified": "203c",
			"output": "203c-fe0f",
			"default_matches": [
				"203c-fe0f"
			],
			"greedy_matches": [
				"203c-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bangbang",
			"exclamation",
			"mark",
			"punctuation"
		]
	},
	"1f505": {
		"name": "dim button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2015,
		"display": 1,
		"shortname": ":low_brightness:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f505",
			"fully_qualified": "1f505",
			"non_fully_qualified": "1f505",
			"output": "1f505",
			"default_matches": [
				"1f505"
			],
			"greedy_matches": [
				"1f505"
			],
			"decimal": ""
		},
		"keywords": [
			"brightness",
			"dim",
			"low"
		]
	},
	"1f506": {
		"name": "bright button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2016,
		"display": 1,
		"shortname": ":high_brightness:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f506",
			"fully_qualified": "1f506",
			"non_fully_qualified": "1f506",
			"output": "1f506",
			"default_matches": [
				"1f506"
			],
			"greedy_matches": [
				"1f506"
			],
			"decimal": ""
		},
		"keywords": [
			"bright",
			"brightness"
		]
	},
	"303d": {
		"name": "part alternation mark",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2017,
		"display": 1,
		"shortname": ":part_alternation_mark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "303d",
			"fully_qualified": "303d-fe0f",
			"non_fully_qualified": "303d",
			"output": "303d-fe0f",
			"default_matches": [
				"303d-fe0f",
				"303d"
			],
			"greedy_matches": [
				"303d-fe0f",
				"303d"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"part"
		]
	},
	"26a0": {
		"name": "warning",
		"unicode_version": 4,
		"category": "symbols",
		"order": 2018,
		"display": 1,
		"shortname": ":warning:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26a0",
			"fully_qualified": "26a0-fe0f",
			"non_fully_qualified": "26a0",
			"output": "26a0-fe0f",
			"default_matches": [
				"26a0-fe0f"
			],
			"greedy_matches": [
				"26a0-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"warning"
		]
	},
	"1f6b8": {
		"name": "children crossing",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2019,
		"display": 1,
		"shortname": ":children_crossing:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b8",
			"fully_qualified": "1f6b8",
			"non_fully_qualified": "1f6b8",
			"output": "1f6b8",
			"default_matches": [
				"1f6b8"
			],
			"greedy_matches": [
				"1f6b8"
			],
			"decimal": ""
		},
		"keywords": [
			"child",
			"crossing",
			"pedestrian",
			"traffic"
		]
	},
	"1f531": {
		"name": "trident emblem",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2020,
		"display": 1,
		"shortname": ":trident:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f531",
			"fully_qualified": "1f531",
			"non_fully_qualified": "1f531",
			"output": "1f531",
			"default_matches": [
				"1f531"
			],
			"greedy_matches": [
				"1f531"
			],
			"decimal": ""
		},
		"keywords": [
			"anchor",
			"emblem",
			"ship",
			"tool",
			"trident"
		]
	},
	"269c": {
		"name": "fleur-de-lis",
		"unicode_version": 4.1,
		"category": "symbols",
		"order": 2021,
		"display": 1,
		"shortname": ":fleur-de-lis:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "269c",
			"fully_qualified": "269c-fe0f",
			"non_fully_qualified": "269c",
			"output": "269c-fe0f",
			"default_matches": [
				"269c-fe0f",
				"269c"
			],
			"greedy_matches": [
				"269c-fe0f",
				"269c"
			],
			"decimal": ""
		},
		"keywords": [
			"fleur-de-lis"
		]
	},
	"1f530": {
		"name": "Japanese symbol for beginner",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2022,
		"display": 1,
		"shortname": ":beginner:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f530",
			"fully_qualified": "1f530",
			"non_fully_qualified": "1f530",
			"output": "1f530",
			"default_matches": [
				"1f530"
			],
			"greedy_matches": [
				"1f530"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"beginner",
			"chevron",
			"green",
			"leaf",
			"tool",
			"yellow"
		]
	},
	"267b": {
		"name": "recycling symbol",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2023,
		"display": 1,
		"shortname": ":recycle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "267b",
			"fully_qualified": "267b-fe0f",
			"non_fully_qualified": "267b",
			"output": "267b-fe0f",
			"default_matches": [
				"267b-fe0f",
				"267b"
			],
			"greedy_matches": [
				"267b-fe0f",
				"267b"
			],
			"decimal": ""
		},
		"keywords": [
			"recycle"
		]
	},
	"1f22f": {
		"name": "Japanese “reserved” button",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 2025,
		"display": 1,
		"shortname": ":u6307:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f22f",
			"fully_qualified": "1f22f",
			"non_fully_qualified": "1f22f",
			"output": "1f22f",
			"default_matches": [
				"1f22f"
			],
			"greedy_matches": [
				"1f22f"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“reserved”",
			"指"
		]
	},
	"1f4b9": {
		"name": "chart increasing with yen",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2026,
		"display": 1,
		"shortname": ":chart:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b9",
			"fully_qualified": "1f4b9",
			"non_fully_qualified": "1f4b9",
			"output": "1f4b9",
			"default_matches": [
				"1f4b9"
			],
			"greedy_matches": [
				"1f4b9"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"chart",
			"currency",
			"graph",
			"growth",
			"market",
			"money",
			"rise",
			"trend",
			"upward",
			"yen"
		]
	},
	"274e": {
		"name": "cross mark button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2029,
		"display": 1,
		"shortname": ":negative_squared_cross_mark:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "274e",
			"fully_qualified": "274e",
			"non_fully_qualified": "274e",
			"output": "274e",
			"default_matches": [
				"274e"
			],
			"greedy_matches": [
				"274e"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"square"
		]
	},
	"1f310": {
		"name": "globe with meridians",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2030,
		"display": 1,
		"shortname": ":globe_with_meridians:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f310",
			"fully_qualified": "1f310",
			"non_fully_qualified": "1f310",
			"output": "1f310",
			"default_matches": [
				"1f310"
			],
			"greedy_matches": [
				"1f310"
			],
			"decimal": ""
		},
		"keywords": [
			"earth",
			"globe",
			"meridians",
			"world"
		]
	},
	"1f4a0": {
		"name": "diamond with a dot",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2031,
		"display": 1,
		"shortname": ":diamond_shape_with_a_dot_inside:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a0",
			"fully_qualified": "1f4a0",
			"non_fully_qualified": "1f4a0",
			"output": "1f4a0",
			"default_matches": [
				"1f4a0"
			],
			"greedy_matches": [
				"1f4a0"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"diamond",
			"geometric",
			"inside"
		]
	},
	"24c2": {
		"name": "circled M",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2032,
		"display": 1,
		"shortname": ":m:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "24c2",
			"fully_qualified": "24c2-fe0f",
			"non_fully_qualified": "24c2",
			"output": "24c2-fe0f",
			"default_matches": [
				"24c2-fe0f",
				"24c2"
			],
			"greedy_matches": [
				"24c2-fe0f",
				"24c2"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"m"
		]
	},
	"1f300": {
		"name": "cyclone",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2033,
		"display": 1,
		"shortname": ":cyclone:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f300",
			"fully_qualified": "1f300",
			"non_fully_qualified": "1f300",
			"output": "1f300",
			"default_matches": [
				"1f300"
			],
			"greedy_matches": [
				"1f300"
			],
			"decimal": ""
		},
		"keywords": [
			"dizzy",
			"twister",
			"typhoon"
		]
	},
	"1f4a4": {
		"name": "zzz",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2034,
		"display": 1,
		"shortname": ":zzz:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4a4",
			"fully_qualified": "1f4a4",
			"non_fully_qualified": "1f4a4",
			"output": "1f4a4",
			"default_matches": [
				"1f4a4"
			],
			"greedy_matches": [
				"1f4a4"
			],
			"decimal": ""
		},
		"keywords": [
			"comic",
			"sleep"
		]
	},
	"1f3e7": {
		"name": "ATM sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2035,
		"display": 1,
		"shortname": ":atm:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3e7",
			"fully_qualified": "1f3e7",
			"non_fully_qualified": "1f3e7",
			"output": "1f3e7",
			"default_matches": [
				"1f3e7"
			],
			"greedy_matches": [
				"1f3e7"
			],
			"decimal": ""
		},
		"keywords": [
			"atm",
			"automated",
			"bank",
			"teller"
		]
	},
	"1f6be": {
		"name": "water closet",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2036,
		"display": 1,
		"shortname": ":wc:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6be",
			"fully_qualified": "1f6be",
			"non_fully_qualified": "1f6be",
			"output": "1f6be",
			"default_matches": [
				"1f6be"
			],
			"greedy_matches": [
				"1f6be"
			],
			"decimal": ""
		},
		"keywords": [
			"closet",
			"lavatory",
			"restroom",
			"water",
			"wc"
		]
	},
	"267f": {
		"name": "wheelchair symbol",
		"unicode_version": 4.1,
		"category": "symbols",
		"order": 2037,
		"display": 1,
		"shortname": ":wheelchair:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "267f",
			"fully_qualified": "267f",
			"non_fully_qualified": "267f",
			"output": "267f",
			"default_matches": [
				"267f"
			],
			"greedy_matches": [
				"267f"
			],
			"decimal": ""
		},
		"keywords": [
			"access"
		]
	},
	"1f17f": {
		"name": "P button",
		"unicode_version": 5.2,
		"category": "symbols",
		"order": 2038,
		"display": 1,
		"shortname": ":parking:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f17f",
			"fully_qualified": "1f17f-fe0f",
			"non_fully_qualified": "1f17f",
			"output": "1f17f-fe0f",
			"default_matches": [
				"1f17f-fe0f",
				"1f17f"
			],
			"greedy_matches": [
				"1f17f-fe0f",
				"1f17f"
			],
			"decimal": ""
		},
		"keywords": [
			"parking"
		]
	},
	"1f233": {
		"name": "Japanese “vacancy” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2039,
		"display": 1,
		"shortname": ":u7a7a:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f233",
			"fully_qualified": "1f233",
			"non_fully_qualified": "1f233",
			"output": "1f233",
			"default_matches": [
				"1f233"
			],
			"greedy_matches": [
				"1f233"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"ideograph",
			"“vacancy”",
			"空"
		]
	},
	"1f202": {
		"name": "Japanese “service charge” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2040,
		"display": 1,
		"shortname": ":sa:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f202",
			"fully_qualified": "1f202-fe0f",
			"non_fully_qualified": "1f202",
			"output": "1f202-fe0f",
			"default_matches": [
				"1f202-fe0f",
				"1f202"
			],
			"greedy_matches": [
				"1f202-fe0f",
				"1f202"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"katakana",
			"“service charge”",
			"サ"
		]
	},
	"1f6c2": {
		"name": "passport control",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2041,
		"display": 1,
		"shortname": ":passport_control:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c2",
			"fully_qualified": "1f6c2",
			"non_fully_qualified": "1f6c2",
			"output": "1f6c2",
			"default_matches": [
				"1f6c2"
			],
			"greedy_matches": [
				"1f6c2"
			],
			"decimal": ""
		},
		"keywords": [
			"control",
			"passport"
		]
	},
	"1f6c3": {
		"name": "customs",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2042,
		"display": 1,
		"shortname": ":customs:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c3",
			"fully_qualified": "1f6c3",
			"non_fully_qualified": "1f6c3",
			"output": "1f6c3",
			"default_matches": [
				"1f6c3"
			],
			"greedy_matches": [
				"1f6c3"
			],
			"decimal": ""
		},
		"keywords": [
			"customs"
		]
	},
	"1f6c4": {
		"name": "baggage claim",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2043,
		"display": 1,
		"shortname": ":baggage_claim:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c4",
			"fully_qualified": "1f6c4",
			"non_fully_qualified": "1f6c4",
			"output": "1f6c4",
			"default_matches": [
				"1f6c4"
			],
			"greedy_matches": [
				"1f6c4"
			],
			"decimal": ""
		},
		"keywords": [
			"baggage",
			"claim"
		]
	},
	"1f6c5": {
		"name": "left luggage",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2044,
		"display": 1,
		"shortname": ":left_luggage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6c5",
			"fully_qualified": "1f6c5",
			"non_fully_qualified": "1f6c5",
			"output": "1f6c5",
			"default_matches": [
				"1f6c5"
			],
			"greedy_matches": [
				"1f6c5"
			],
			"decimal": ""
		},
		"keywords": [
			"baggage",
			"locker",
			"luggage"
		]
	},
	"1f6b9": {
		"name": "men’s room",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2045,
		"display": 1,
		"shortname": ":mens:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6b9",
			"fully_qualified": "1f6b9",
			"non_fully_qualified": "1f6b9",
			"output": "1f6b9",
			"default_matches": [
				"1f6b9"
			],
			"greedy_matches": [
				"1f6b9"
			],
			"decimal": ""
		},
		"keywords": [
			"lavatory",
			"man",
			"restroom",
			"wc"
		]
	},
	"1f6ba": {
		"name": "women’s room",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2046,
		"display": 1,
		"shortname": ":womens:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ba",
			"fully_qualified": "1f6ba",
			"non_fully_qualified": "1f6ba",
			"output": "1f6ba",
			"default_matches": [
				"1f6ba"
			],
			"greedy_matches": [
				"1f6ba"
			],
			"decimal": ""
		},
		"keywords": [
			"lavatory",
			"restroom",
			"wc",
			"woman"
		]
	},
	"1f6bc": {
		"name": "baby symbol",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2047,
		"display": 1,
		"shortname": ":baby_symbol:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6bc",
			"fully_qualified": "1f6bc",
			"non_fully_qualified": "1f6bc",
			"output": "1f6bc",
			"default_matches": [
				"1f6bc"
			],
			"greedy_matches": [
				"1f6bc"
			],
			"decimal": ""
		},
		"keywords": [
			"baby",
			"changing"
		]
	},
	"1f6bb": {
		"name": "restroom",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2048,
		"display": 1,
		"shortname": ":restroom:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6bb",
			"fully_qualified": "1f6bb",
			"non_fully_qualified": "1f6bb",
			"output": "1f6bb",
			"default_matches": [
				"1f6bb"
			],
			"greedy_matches": [
				"1f6bb"
			],
			"decimal": ""
		},
		"keywords": [
			"WC",
			"lavatory",
			"restroom"
		]
	},
	"1f6ae": {
		"name": "litter in bin sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2049,
		"display": 1,
		"shortname": ":put_litter_in_its_place:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6ae",
			"fully_qualified": "1f6ae",
			"non_fully_qualified": "1f6ae",
			"output": "1f6ae",
			"default_matches": [
				"1f6ae"
			],
			"greedy_matches": [
				"1f6ae"
			],
			"decimal": ""
		},
		"keywords": [
			"litter",
			"litter bin"
		]
	},
	"1f3a6": {
		"name": "cinema",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2050,
		"display": 1,
		"shortname": ":cinema:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3a6",
			"fully_qualified": "1f3a6",
			"non_fully_qualified": "1f3a6",
			"output": "1f3a6",
			"default_matches": [
				"1f3a6"
			],
			"greedy_matches": [
				"1f3a6"
			],
			"decimal": ""
		},
		"keywords": [
			"camera",
			"film",
			"movie"
		]
	},
	"1f4f6": {
		"name": "antenna bars",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2051,
		"display": 1,
		"shortname": ":signal_strength:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4f6",
			"fully_qualified": "1f4f6",
			"non_fully_qualified": "1f4f6",
			"output": "1f4f6",
			"default_matches": [
				"1f4f6"
			],
			"greedy_matches": [
				"1f4f6"
			],
			"decimal": ""
		},
		"keywords": [
			"antenna",
			"bar",
			"cell",
			"mobile",
			"phone",
			"signal",
			"telephone"
		]
	},
	"1f201": {
		"name": "Japanese “here” button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2052,
		"display": 1,
		"shortname": ":koko:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f201",
			"fully_qualified": "1f201",
			"non_fully_qualified": "1f201",
			"output": "1f201",
			"default_matches": [
				"1f201"
			],
			"greedy_matches": [
				"1f201"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"katakana",
			"“here”",
			"ココ"
		]
	},
	"1f523": {
		"name": "input symbols",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2053,
		"display": 1,
		"shortname": ":symbols:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f523",
			"fully_qualified": "1f523",
			"non_fully_qualified": "1f523",
			"output": "1f523",
			"default_matches": [
				"1f523"
			],
			"greedy_matches": [
				"1f523"
			],
			"decimal": ""
		},
		"keywords": [
			"input",
			"〒♪&amp;%"
		]
	},
	"1f524": {
		"name": "input latin letters",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2055,
		"display": 1,
		"shortname": ":abc:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f524",
			"fully_qualified": "1f524",
			"non_fully_qualified": "1f524",
			"output": "1f524",
			"default_matches": [
				"1f524"
			],
			"greedy_matches": [
				"1f524"
			],
			"decimal": ""
		},
		"keywords": [
			"abc",
			"alphabet",
			"input",
			"latin",
			"letters"
		]
	},
	"1f521": {
		"name": "input latin lowercase",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2056,
		"display": 1,
		"shortname": ":abcd:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f521",
			"fully_qualified": "1f521",
			"non_fully_qualified": "1f521",
			"output": "1f521",
			"default_matches": [
				"1f521"
			],
			"greedy_matches": [
				"1f521"
			],
			"decimal": ""
		},
		"keywords": [
			"abcd",
			"input",
			"latin",
			"letters",
			"lowercase"
		]
	},
	"1f520": {
		"name": "input latin uppercase",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2057,
		"display": 1,
		"shortname": ":capital_abcd:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f520",
			"fully_qualified": "1f520",
			"non_fully_qualified": "1f520",
			"output": "1f520",
			"default_matches": [
				"1f520"
			],
			"greedy_matches": [
				"1f520"
			],
			"decimal": ""
		},
		"keywords": [
			"ABCD",
			"input",
			"latin",
			"letters",
			"uppercase"
		]
	},
	"1f196": {
		"name": "NG button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2058,
		"display": 1,
		"shortname": ":ng:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f196",
			"fully_qualified": "1f196",
			"non_fully_qualified": "1f196",
			"output": "1f196",
			"default_matches": [
				"1f196"
			],
			"greedy_matches": [
				"1f196"
			],
			"decimal": ""
		},
		"keywords": [
			"ng"
		]
	},
	"1f197": {
		"name": "OK button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2059,
		"display": 1,
		"shortname": ":ok:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f197",
			"fully_qualified": "1f197",
			"non_fully_qualified": "1f197",
			"output": "1f197",
			"default_matches": [
				"1f197"
			],
			"greedy_matches": [
				"1f197"
			],
			"decimal": ""
		},
		"keywords": [
			"OK"
		]
	},
	"1f199": {
		"name": "UP! button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2060,
		"display": 1,
		"shortname": ":up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f199",
			"fully_qualified": "1f199",
			"non_fully_qualified": "1f199",
			"output": "1f199",
			"default_matches": [
				"1f199"
			],
			"greedy_matches": [
				"1f199"
			],
			"decimal": ""
		},
		"keywords": [
			"mark",
			"up"
		]
	},
	"1f192": {
		"name": "COOL button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2061,
		"display": 1,
		"shortname": ":cool:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f192",
			"fully_qualified": "1f192",
			"non_fully_qualified": "1f192",
			"output": "1f192",
			"default_matches": [
				"1f192"
			],
			"greedy_matches": [
				"1f192"
			],
			"decimal": ""
		},
		"keywords": [
			"cool"
		]
	},
	"1f195": {
		"name": "NEW button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2062,
		"display": 1,
		"shortname": ":new:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f195",
			"fully_qualified": "1f195",
			"non_fully_qualified": "1f195",
			"output": "1f195",
			"default_matches": [
				"1f195"
			],
			"greedy_matches": [
				"1f195"
			],
			"decimal": ""
		},
		"keywords": [
			"new"
		]
	},
	"1f193": {
		"name": "FREE button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2063,
		"display": 1,
		"shortname": ":free:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f193",
			"fully_qualified": "1f193",
			"non_fully_qualified": "1f193",
			"output": "1f193",
			"default_matches": [
				"1f193"
			],
			"greedy_matches": [
				"1f193"
			],
			"decimal": ""
		},
		"keywords": [
			"free"
		]
	},
	"0030-20e3": {
		"name": "keycap: 0",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2064,
		"display": 1,
		"shortname": ":zero:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0030-20e3",
			"fully_qualified": "0030-fe0f-20e3",
			"non_fully_qualified": "0030-20e3",
			"output": "0030-fe0f-20e3",
			"default_matches": [
				"0030-fe0f-20e3",
				"0030-20e3"
			],
			"greedy_matches": [
				"0030-fe0f-20e3",
				"0030-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0031-20e3": {
		"name": "keycap: 1",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2065,
		"display": 1,
		"shortname": ":one:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0031-20e3",
			"fully_qualified": "0031-fe0f-20e3",
			"non_fully_qualified": "0031-20e3",
			"output": "0031-fe0f-20e3",
			"default_matches": [
				"0031-fe0f-20e3",
				"0031-20e3"
			],
			"greedy_matches": [
				"0031-fe0f-20e3",
				"0031-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0032-20e3": {
		"name": "keycap: 2",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2066,
		"display": 1,
		"shortname": ":two:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0032-20e3",
			"fully_qualified": "0032-fe0f-20e3",
			"non_fully_qualified": "0032-20e3",
			"output": "0032-fe0f-20e3",
			"default_matches": [
				"0032-fe0f-20e3",
				"0032-20e3"
			],
			"greedy_matches": [
				"0032-fe0f-20e3",
				"0032-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0033-20e3": {
		"name": "keycap: 3",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2067,
		"display": 1,
		"shortname": ":three:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0033-20e3",
			"fully_qualified": "0033-fe0f-20e3",
			"non_fully_qualified": "0033-20e3",
			"output": "0033-fe0f-20e3",
			"default_matches": [
				"0033-fe0f-20e3",
				"0033-20e3"
			],
			"greedy_matches": [
				"0033-fe0f-20e3",
				"0033-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0034-20e3": {
		"name": "keycap: 4",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2068,
		"display": 1,
		"shortname": ":four:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0034-20e3",
			"fully_qualified": "0034-fe0f-20e3",
			"non_fully_qualified": "0034-20e3",
			"output": "0034-fe0f-20e3",
			"default_matches": [
				"0034-fe0f-20e3",
				"0034-20e3"
			],
			"greedy_matches": [
				"0034-fe0f-20e3",
				"0034-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0035-20e3": {
		"name": "keycap: 5",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2069,
		"display": 1,
		"shortname": ":five:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0035-20e3",
			"fully_qualified": "0035-fe0f-20e3",
			"non_fully_qualified": "0035-20e3",
			"output": "0035-fe0f-20e3",
			"default_matches": [
				"0035-fe0f-20e3",
				"0035-20e3"
			],
			"greedy_matches": [
				"0035-fe0f-20e3",
				"0035-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0036-20e3": {
		"name": "keycap: 6",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2070,
		"display": 1,
		"shortname": ":six:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0036-20e3",
			"fully_qualified": "0036-fe0f-20e3",
			"non_fully_qualified": "0036-20e3",
			"output": "0036-fe0f-20e3",
			"default_matches": [
				"0036-fe0f-20e3",
				"0036-20e3"
			],
			"greedy_matches": [
				"0036-fe0f-20e3",
				"0036-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0037-20e3": {
		"name": "keycap: 7",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2071,
		"display": 1,
		"shortname": ":seven:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0037-20e3",
			"fully_qualified": "0037-fe0f-20e3",
			"non_fully_qualified": "0037-20e3",
			"output": "0037-fe0f-20e3",
			"default_matches": [
				"0037-fe0f-20e3",
				"0037-20e3"
			],
			"greedy_matches": [
				"0037-fe0f-20e3",
				"0037-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0038-20e3": {
		"name": "keycap: 8",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2072,
		"display": 1,
		"shortname": ":eight:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0038-20e3",
			"fully_qualified": "0038-fe0f-20e3",
			"non_fully_qualified": "0038-20e3",
			"output": "0038-fe0f-20e3",
			"default_matches": [
				"0038-fe0f-20e3",
				"0038-20e3"
			],
			"greedy_matches": [
				"0038-fe0f-20e3",
				"0038-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"0039-20e3": {
		"name": "keycap: 9",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2073,
		"display": 1,
		"shortname": ":nine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0039-20e3",
			"fully_qualified": "0039-fe0f-20e3",
			"non_fully_qualified": "0039-20e3",
			"output": "0039-fe0f-20e3",
			"default_matches": [
				"0039-fe0f-20e3",
				"0039-20e3"
			],
			"greedy_matches": [
				"0039-fe0f-20e3",
				"0039-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"1f51f": {
		"name": "keycap 10",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2074,
		"display": 1,
		"shortname": ":keycap_ten:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51f",
			"fully_qualified": "1f51f",
			"non_fully_qualified": "1f51f",
			"output": "1f51f",
			"default_matches": [
				"1f51f"
			],
			"greedy_matches": [
				"1f51f"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap 10"
		]
	},
	"1f522": {
		"name": "input numbers",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2075,
		"display": 1,
		"shortname": ":1234:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f522",
			"fully_qualified": "1f522",
			"non_fully_qualified": "1f522",
			"output": "1f522",
			"default_matches": [
				"1f522"
			],
			"greedy_matches": [
				"1f522"
			],
			"decimal": ""
		},
		"keywords": [
			"1234",
			"input",
			"numbers"
		]
	},
	"0023-20e3": {
		"name": "keycap: #",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2076,
		"display": 1,
		"shortname": ":hash:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0023-20e3",
			"fully_qualified": "0023-fe0f-20e3",
			"non_fully_qualified": "0023-20e3",
			"output": "0023-fe0f-20e3",
			"default_matches": [
				"0023-fe0f-20e3",
				"0023-20e3"
			],
			"greedy_matches": [
				"0023-fe0f-20e3",
				"0023-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"002a-20e3": {
		"name": "keycap: *",
		"unicode_version": 3,
		"category": "symbols",
		"order": 2077,
		"display": 1,
		"shortname": ":asterisk:",
		"shortname_alternates": [
			":keycap_asterisk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "002a-20e3",
			"fully_qualified": "002a-fe0f-20e3",
			"non_fully_qualified": "002a-20e3",
			"output": "002a-fe0f-20e3",
			"default_matches": [
				"002a-fe0f-20e3",
				"002a-20e3"
			],
			"greedy_matches": [
				"002a-fe0f-20e3",
				"002a-20e3"
			],
			"decimal": ""
		},
		"keywords": [
			"keycap"
		]
	},
	"25b6": {
		"name": "play button",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2078,
		"display": 1,
		"shortname": ":arrow_forward:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25b6",
			"fully_qualified": "25b6-fe0f",
			"non_fully_qualified": "25b6",
			"output": "25b6-fe0f",
			"default_matches": [
				"25b6-fe0f"
			],
			"greedy_matches": [
				"25b6-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"play",
			"right",
			"triangle"
		]
	},
	"23f8": {
		"name": "pause button",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2079,
		"display": 1,
		"shortname": ":pause_button:",
		"shortname_alternates": [
			":double_vertical_bar:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f8",
			"fully_qualified": "23f8-fe0f",
			"non_fully_qualified": "23f8",
			"output": "23f8-fe0f",
			"default_matches": [
				"23f8-fe0f"
			],
			"greedy_matches": [
				"23f8-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"bar",
			"double",
			"pause",
			"vertical"
		]
	},
	"23ef": {
		"name": "play or pause button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2080,
		"display": 1,
		"shortname": ":play_pause:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23ef",
			"fully_qualified": "23ef-fe0f",
			"non_fully_qualified": "23ef",
			"output": "23ef-fe0f",
			"default_matches": [
				"23ef-fe0f"
			],
			"greedy_matches": [
				"23ef-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"pause",
			"play",
			"right",
			"triangle"
		]
	},
	"23f9": {
		"name": "stop button",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2081,
		"display": 1,
		"shortname": ":stop_button:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23f9",
			"fully_qualified": "23f9-fe0f",
			"non_fully_qualified": "23f9",
			"output": "23f9-fe0f",
			"default_matches": [
				"23f9-fe0f"
			],
			"greedy_matches": [
				"23f9-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"square",
			"stop"
		]
	},
	"23fa": {
		"name": "record button",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2082,
		"display": 1,
		"shortname": ":record_button:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23fa",
			"fully_qualified": "23fa-fe0f",
			"non_fully_qualified": "23fa",
			"output": "23fa-fe0f",
			"default_matches": [
				"23fa-fe0f"
			],
			"greedy_matches": [
				"23fa-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"record"
		]
	},
	"23cf": {
		"name": "eject button",
		"unicode_version": 4,
		"category": "symbols",
		"order": 2083,
		"display": 1,
		"shortname": ":eject:",
		"shortname_alternates": [
			":eject_symbol:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23cf",
			"fully_qualified": "23cf-fe0f",
			"non_fully_qualified": "23cf",
			"output": "23cf-fe0f",
			"default_matches": [
				"23cf-fe0f"
			],
			"greedy_matches": [
				"23cf-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"eject"
		]
	},
	"23ed": {
		"name": "next track button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2084,
		"display": 1,
		"shortname": ":track_next:",
		"shortname_alternates": [
			":next_track:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23ed",
			"fully_qualified": "23ed-fe0f",
			"non_fully_qualified": "23ed",
			"output": "23ed-fe0f",
			"default_matches": [
				"23ed-fe0f"
			],
			"greedy_matches": [
				"23ed-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"next scene",
			"next track",
			"triangle"
		]
	},
	"23ee": {
		"name": "last track button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2085,
		"display": 1,
		"shortname": ":track_previous:",
		"shortname_alternates": [
			":previous_track:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23ee",
			"fully_qualified": "23ee-fe0f",
			"non_fully_qualified": "23ee",
			"output": "23ee-fe0f",
			"default_matches": [
				"23ee-fe0f"
			],
			"greedy_matches": [
				"23ee-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"previous scene",
			"previous track",
			"triangle"
		]
	},
	"23e9": {
		"name": "fast-forward button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2086,
		"display": 1,
		"shortname": ":fast_forward:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23e9",
			"fully_qualified": "23e9",
			"non_fully_qualified": "23e9",
			"output": "23e9",
			"default_matches": [
				"23e9"
			],
			"greedy_matches": [
				"23e9"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"double",
			"fast",
			"forward"
		]
	},
	"23ea": {
		"name": "fast reverse button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2087,
		"display": 1,
		"shortname": ":rewind:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23ea",
			"fully_qualified": "23ea",
			"non_fully_qualified": "23ea",
			"output": "23ea",
			"default_matches": [
				"23ea"
			],
			"greedy_matches": [
				"23ea"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"double",
			"rewind"
		]
	},
	"23eb": {
		"name": "fast up button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2088,
		"display": 1,
		"shortname": ":arrow_double_up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23eb",
			"fully_qualified": "23eb",
			"non_fully_qualified": "23eb",
			"output": "23eb",
			"default_matches": [
				"23eb"
			],
			"greedy_matches": [
				"23eb"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"double"
		]
	},
	"23ec": {
		"name": "fast down button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2089,
		"display": 1,
		"shortname": ":arrow_double_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "23ec",
			"fully_qualified": "23ec",
			"non_fully_qualified": "23ec",
			"output": "23ec",
			"default_matches": [
				"23ec"
			],
			"greedy_matches": [
				"23ec"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"double",
			"down"
		]
	},
	"25c0": {
		"name": "reverse button",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2090,
		"display": 1,
		"shortname": ":arrow_backward:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25c0",
			"fully_qualified": "25c0-fe0f",
			"non_fully_qualified": "25c0",
			"output": "25c0-fe0f",
			"default_matches": [
				"25c0-fe0f"
			],
			"greedy_matches": [
				"25c0-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"left",
			"reverse",
			"triangle"
		]
	},
	"1f53c": {
		"name": "up button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2091,
		"display": 1,
		"shortname": ":arrow_up_small:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f53c",
			"fully_qualified": "1f53c",
			"non_fully_qualified": "1f53c",
			"output": "1f53c",
			"default_matches": [
				"1f53c"
			],
			"greedy_matches": [
				"1f53c"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"button",
			"red"
		]
	},
	"1f53d": {
		"name": "down button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2092,
		"display": 1,
		"shortname": ":arrow_down_small:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f53d",
			"fully_qualified": "1f53d",
			"non_fully_qualified": "1f53d",
			"output": "1f53d",
			"default_matches": [
				"1f53d"
			],
			"greedy_matches": [
				"1f53d"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"button",
			"down",
			"red"
		]
	},
	"27a1": {
		"name": "right arrow",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2093,
		"display": 1,
		"shortname": ":arrow_right:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "27a1",
			"fully_qualified": "27a1-fe0f",
			"non_fully_qualified": "27a1",
			"output": "27a1-fe0f",
			"default_matches": [
				"27a1-fe0f"
			],
			"greedy_matches": [
				"27a1-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"cardinal",
			"direction",
			"east"
		]
	},
	"2b05": {
		"name": "left arrow",
		"unicode_version": 4,
		"category": "symbols",
		"order": 2094,
		"display": 1,
		"shortname": ":arrow_left:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b05",
			"fully_qualified": "2b05-fe0f",
			"non_fully_qualified": "2b05",
			"output": "2b05-fe0f",
			"default_matches": [
				"2b05-fe0f"
			],
			"greedy_matches": [
				"2b05-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"cardinal",
			"direction",
			"west"
		]
	},
	"2b06": {
		"name": "up arrow",
		"unicode_version": 4,
		"category": "symbols",
		"order": 2095,
		"display": 1,
		"shortname": ":arrow_up:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b06",
			"fully_qualified": "2b06-fe0f",
			"non_fully_qualified": "2b06",
			"output": "2b06-fe0f",
			"default_matches": [
				"2b06-fe0f"
			],
			"greedy_matches": [
				"2b06-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"cardinal",
			"direction",
			"north"
		]
	},
	"2b07": {
		"name": "down arrow",
		"unicode_version": 4,
		"category": "symbols",
		"order": 2096,
		"display": 1,
		"shortname": ":arrow_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b07",
			"fully_qualified": "2b07-fe0f",
			"non_fully_qualified": "2b07",
			"output": "2b07-fe0f",
			"default_matches": [
				"2b07-fe0f"
			],
			"greedy_matches": [
				"2b07-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"cardinal",
			"direction",
			"down",
			"south"
		]
	},
	"21aa": {
		"name": "left arrow curving right",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2103,
		"display": 1,
		"shortname": ":arrow_right_hook:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "21aa",
			"fully_qualified": "21aa-fe0f",
			"non_fully_qualified": "21aa",
			"output": "21aa-fe0f",
			"default_matches": [
				"21aa-fe0f"
			],
			"greedy_matches": [
				"21aa-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow"
		]
	},
	"21a9": {
		"name": "right arrow curving left",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2104,
		"display": 1,
		"shortname": ":leftwards_arrow_with_hook:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "21a9",
			"fully_qualified": "21a9-fe0f",
			"non_fully_qualified": "21a9",
			"output": "21a9-fe0f",
			"default_matches": [
				"21a9-fe0f"
			],
			"greedy_matches": [
				"21a9-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow"
		]
	},
	"1f500": {
		"name": "shuffle tracks button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2107,
		"display": 1,
		"shortname": ":twisted_rightwards_arrows:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f500",
			"fully_qualified": "1f500",
			"non_fully_qualified": "1f500",
			"output": "1f500",
			"default_matches": [
				"1f500"
			],
			"greedy_matches": [
				"1f500"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"crossed"
		]
	},
	"1f501": {
		"name": "repeat button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2108,
		"display": 1,
		"shortname": ":repeat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f501",
			"fully_qualified": "1f501",
			"non_fully_qualified": "1f501",
			"output": "1f501",
			"default_matches": [
				"1f501"
			],
			"greedy_matches": [
				"1f501"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"clockwise",
			"repeat"
		]
	},
	"1f502": {
		"name": "repeat single button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2109,
		"display": 1,
		"shortname": ":repeat_one:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f502",
			"fully_qualified": "1f502",
			"non_fully_qualified": "1f502",
			"output": "1f502",
			"default_matches": [
				"1f502"
			],
			"greedy_matches": [
				"1f502"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"clockwise",
			"once"
		]
	},
	"1f504": {
		"name": "anticlockwise arrows button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2110,
		"display": 1,
		"shortname": ":arrows_counterclockwise:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f504",
			"fully_qualified": "1f504",
			"non_fully_qualified": "1f504",
			"output": "1f504",
			"default_matches": [
				"1f504"
			],
			"greedy_matches": [
				"1f504"
			],
			"decimal": ""
		},
		"keywords": [
			"anticlockwise",
			"arrow",
			"counterclockwise",
			"withershins"
		]
	},
	"1f503": {
		"name": "clockwise vertical arrows",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2111,
		"display": 1,
		"shortname": ":arrows_clockwise:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f503",
			"fully_qualified": "1f503",
			"non_fully_qualified": "1f503",
			"output": "1f503",
			"default_matches": [
				"1f503"
			],
			"greedy_matches": [
				"1f503"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"clockwise",
			"reload"
		]
	},
	"1f3b5": {
		"name": "musical note",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2112,
		"display": 1,
		"shortname": ":musical_note:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b5",
			"fully_qualified": "1f3b5",
			"non_fully_qualified": "1f3b5",
			"output": "1f3b5",
			"default_matches": [
				"1f3b5"
			],
			"greedy_matches": [
				"1f3b5"
			],
			"decimal": ""
		},
		"keywords": [
			"music",
			"note"
		]
	},
	"1f3b6": {
		"name": "musical notes",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2113,
		"display": 1,
		"shortname": ":notes:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b6",
			"fully_qualified": "1f3b6",
			"non_fully_qualified": "1f3b6",
			"output": "1f3b6",
			"default_matches": [
				"1f3b6"
			],
			"greedy_matches": [
				"1f3b6"
			],
			"decimal": ""
		},
		"keywords": [
			"music",
			"note",
			"notes"
		]
	},
	"1f4b2": {
		"name": "heavy dollar sign",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2118,
		"display": 1,
		"shortname": ":heavy_dollar_sign:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b2",
			"fully_qualified": "1f4b2",
			"non_fully_qualified": "1f4b2",
			"output": "1f4b2",
			"default_matches": [
				"1f4b2"
			],
			"greedy_matches": [
				"1f4b2"
			],
			"decimal": ""
		},
		"keywords": [
			"currency",
			"dollar",
			"money"
		]
	},
	"1f4b1": {
		"name": "currency exchange",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2119,
		"display": 1,
		"shortname": ":currency_exchange:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4b1",
			"fully_qualified": "1f4b1",
			"non_fully_qualified": "1f4b1",
			"output": "1f4b1",
			"default_matches": [
				"1f4b1"
			],
			"greedy_matches": [
				"1f4b1"
			],
			"decimal": ""
		},
		"keywords": [
			"bank",
			"currency",
			"exchange",
			"money"
		]
	},
	"00a9": {
		"name": "copyright",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2121,
		"display": 1,
		"shortname": ":copyright:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "00a9",
			"fully_qualified": "00a9-fe0f",
			"non_fully_qualified": "00a9",
			"output": "00a9-fe0f",
			"default_matches": [
				"00a9-fe0f"
			],
			"greedy_matches": [
				"00a9-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"copyright"
		]
	},
	"00ae": {
		"name": "registered",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2122,
		"display": 1,
		"shortname": ":registered:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "00ae",
			"fully_qualified": "00ae-fe0f",
			"non_fully_qualified": "00ae",
			"output": "00ae-fe0f",
			"default_matches": [
				"00ae-fe0f"
			],
			"greedy_matches": [
				"00ae-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"registered"
		]
	},
	"27b0": {
		"name": "curly loop",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2124,
		"display": 1,
		"shortname": ":curly_loop:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "27b0",
			"fully_qualified": "27b0",
			"non_fully_qualified": "27b0",
			"output": "27b0",
			"default_matches": [
				"27b0"
			],
			"greedy_matches": [
				"27b0"
			],
			"decimal": ""
		},
		"keywords": [
			"curl",
			"loop"
		]
	},
	"27bf": {
		"name": "double curly loop",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2125,
		"display": 1,
		"shortname": ":loop:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "27bf",
			"fully_qualified": "27bf",
			"non_fully_qualified": "27bf",
			"output": "27bf",
			"default_matches": [
				"27bf"
			],
			"greedy_matches": [
				"27bf"
			],
			"decimal": ""
		},
		"keywords": [
			"curl",
			"double",
			"loop"
		]
	},
	"1f51a": {
		"name": "END arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2126,
		"display": 1,
		"shortname": ":end:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51a",
			"fully_qualified": "1f51a",
			"non_fully_qualified": "1f51a",
			"output": "1f51a",
			"default_matches": [
				"1f51a"
			],
			"greedy_matches": [
				"1f51a"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"end"
		]
	},
	"1f519": {
		"name": "BACK arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2127,
		"display": 1,
		"shortname": ":back:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f519",
			"fully_qualified": "1f519",
			"non_fully_qualified": "1f519",
			"output": "1f519",
			"default_matches": [
				"1f519"
			],
			"greedy_matches": [
				"1f519"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"back"
		]
	},
	"1f51b": {
		"name": "ON! arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2128,
		"display": 1,
		"shortname": ":on:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51b",
			"fully_qualified": "1f51b",
			"non_fully_qualified": "1f51b",
			"output": "1f51b",
			"default_matches": [
				"1f51b"
			],
			"greedy_matches": [
				"1f51b"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"mark",
			"on"
		]
	},
	"1f51d": {
		"name": "TOP arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2129,
		"display": 1,
		"shortname": ":top:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51d",
			"fully_qualified": "1f51d",
			"non_fully_qualified": "1f51d",
			"output": "1f51d",
			"default_matches": [
				"1f51d"
			],
			"greedy_matches": [
				"1f51d"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"top",
			"up"
		]
	},
	"1f51c": {
		"name": "SOON arrow",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2130,
		"display": 1,
		"shortname": ":soon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f51c",
			"fully_qualified": "1f51c",
			"non_fully_qualified": "1f51c",
			"output": "1f51c",
			"default_matches": [
				"1f51c"
			],
			"greedy_matches": [
				"1f51c"
			],
			"decimal": ""
		},
		"keywords": [
			"arrow",
			"soon"
		]
	},
	"1f518": {
		"name": "radio button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2133,
		"display": 1,
		"shortname": ":radio_button:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f518",
			"fully_qualified": "1f518",
			"non_fully_qualified": "1f518",
			"output": "1f518",
			"default_matches": [
				"1f518"
			],
			"greedy_matches": [
				"1f518"
			],
			"decimal": ""
		},
		"keywords": [
			"button",
			"geometric",
			"radio"
		]
	},
	"26aa": {
		"name": "white circle",
		"unicode_version": 4.1,
		"category": "symbols",
		"order": 2134,
		"display": 1,
		"shortname": ":white_circle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26aa",
			"fully_qualified": "26aa",
			"non_fully_qualified": "26aa",
			"output": "26aa",
			"default_matches": [
				"26aa"
			],
			"greedy_matches": [
				"26aa"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"geometric"
		]
	},
	"26ab": {
		"name": "black circle",
		"unicode_version": 4.1,
		"category": "symbols",
		"order": 2135,
		"display": 1,
		"shortname": ":black_circle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "26ab",
			"fully_qualified": "26ab",
			"non_fully_qualified": "26ab",
			"output": "26ab",
			"default_matches": [
				"26ab"
			],
			"greedy_matches": [
				"26ab"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"geometric"
		]
	},
	"1f534": {
		"name": "red circle",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2136,
		"display": 1,
		"shortname": ":red_circle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f534",
			"fully_qualified": "1f534",
			"non_fully_qualified": "1f534",
			"output": "1f534",
			"default_matches": [
				"1f534"
			],
			"greedy_matches": [
				"1f534"
			],
			"decimal": ""
		},
		"keywords": [
			"circle",
			"geometric",
			"red"
		]
	},
	"1f535": {
		"name": "blue circle",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2137,
		"display": 1,
		"shortname": ":blue_circle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f535",
			"fully_qualified": "1f535",
			"non_fully_qualified": "1f535",
			"output": "1f535",
			"default_matches": [
				"1f535"
			],
			"greedy_matches": [
				"1f535"
			],
			"decimal": ""
		},
		"keywords": [
			"blue",
			"circle",
			"geometric"
		]
	},
	"1f53a": {
		"name": "red triangle pointed up",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2138,
		"display": 1,
		"shortname": ":small_red_triangle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f53a",
			"fully_qualified": "1f53a",
			"non_fully_qualified": "1f53a",
			"output": "1f53a",
			"default_matches": [
				"1f53a"
			],
			"greedy_matches": [
				"1f53a"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"red"
		]
	},
	"1f53b": {
		"name": "red triangle pointed down",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2139,
		"display": 1,
		"shortname": ":small_red_triangle_down:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f53b",
			"fully_qualified": "1f53b",
			"non_fully_qualified": "1f53b",
			"output": "1f53b",
			"default_matches": [
				"1f53b"
			],
			"greedy_matches": [
				"1f53b"
			],
			"decimal": ""
		},
		"keywords": [
			"down",
			"geometric",
			"red"
		]
	},
	"1f538": {
		"name": "small orange diamond",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2140,
		"display": 1,
		"shortname": ":small_orange_diamond:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f538",
			"fully_qualified": "1f538",
			"non_fully_qualified": "1f538",
			"output": "1f538",
			"default_matches": [
				"1f538"
			],
			"greedy_matches": [
				"1f538"
			],
			"decimal": ""
		},
		"keywords": [
			"diamond",
			"geometric",
			"orange"
		]
	},
	"1f539": {
		"name": "small blue diamond",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2141,
		"display": 1,
		"shortname": ":small_blue_diamond:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f539",
			"fully_qualified": "1f539",
			"non_fully_qualified": "1f539",
			"output": "1f539",
			"default_matches": [
				"1f539"
			],
			"greedy_matches": [
				"1f539"
			],
			"decimal": ""
		},
		"keywords": [
			"blue",
			"diamond",
			"geometric"
		]
	},
	"1f536": {
		"name": "large orange diamond",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2142,
		"display": 1,
		"shortname": ":large_orange_diamond:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f536",
			"fully_qualified": "1f536",
			"non_fully_qualified": "1f536",
			"output": "1f536",
			"default_matches": [
				"1f536"
			],
			"greedy_matches": [
				"1f536"
			],
			"decimal": ""
		},
		"keywords": [
			"diamond",
			"geometric",
			"orange"
		]
	},
	"1f537": {
		"name": "large blue diamond",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2143,
		"display": 1,
		"shortname": ":large_blue_diamond:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f537",
			"fully_qualified": "1f537",
			"non_fully_qualified": "1f537",
			"output": "1f537",
			"default_matches": [
				"1f537"
			],
			"greedy_matches": [
				"1f537"
			],
			"decimal": ""
		},
		"keywords": [
			"blue",
			"diamond",
			"geometric"
		]
	},
	"1f533": {
		"name": "white square button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2144,
		"display": 1,
		"shortname": ":white_square_button:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f533",
			"fully_qualified": "1f533",
			"non_fully_qualified": "1f533",
			"output": "1f533",
			"default_matches": [
				"1f533"
			],
			"greedy_matches": [
				"1f533"
			],
			"decimal": ""
		},
		"keywords": [
			"button",
			"geometric",
			"outlined",
			"square"
		]
	},
	"1f532": {
		"name": "black square button",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2145,
		"display": 1,
		"shortname": ":black_square_button:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f532",
			"fully_qualified": "1f532",
			"non_fully_qualified": "1f532",
			"output": "1f532",
			"default_matches": [
				"1f532"
			],
			"greedy_matches": [
				"1f532"
			],
			"decimal": ""
		},
		"keywords": [
			"button",
			"geometric",
			"square"
		]
	},
	"25aa": {
		"name": "black small square",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2146,
		"display": 1,
		"shortname": ":black_small_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25aa",
			"fully_qualified": "25aa-fe0f",
			"non_fully_qualified": "25aa",
			"output": "25aa-fe0f",
			"default_matches": [
				"25aa-fe0f"
			],
			"greedy_matches": [
				"25aa-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"25ab": {
		"name": "white small square",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2147,
		"display": 1,
		"shortname": ":white_small_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25ab",
			"fully_qualified": "25ab-fe0f",
			"non_fully_qualified": "25ab",
			"output": "25ab-fe0f",
			"default_matches": [
				"25ab-fe0f"
			],
			"greedy_matches": [
				"25ab-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"25fe": {
		"name": "black medium-small square",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2148,
		"display": 1,
		"shortname": ":black_medium_small_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25fe",
			"fully_qualified": "25fe",
			"non_fully_qualified": "25fe",
			"output": "25fe",
			"default_matches": [
				"25fe"
			],
			"greedy_matches": [
				"25fe"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"25fd": {
		"name": "white medium-small square",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2149,
		"display": 1,
		"shortname": ":white_medium_small_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25fd",
			"fully_qualified": "25fd",
			"non_fully_qualified": "25fd",
			"output": "25fd",
			"default_matches": [
				"25fd"
			],
			"greedy_matches": [
				"25fd"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"25fc": {
		"name": "black medium square",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2150,
		"display": 1,
		"shortname": ":black_medium_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25fc",
			"fully_qualified": "25fc-fe0f",
			"non_fully_qualified": "25fc",
			"output": "25fc-fe0f",
			"default_matches": [
				"25fc-fe0f"
			],
			"greedy_matches": [
				"25fc-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"25fb": {
		"name": "white medium square",
		"unicode_version": 3.2,
		"category": "symbols",
		"order": 2151,
		"display": 1,
		"shortname": ":white_medium_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "25fb",
			"fully_qualified": "25fb-fe0f",
			"non_fully_qualified": "25fb",
			"output": "25fb-fe0f",
			"default_matches": [
				"25fb-fe0f"
			],
			"greedy_matches": [
				"25fb-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"2b1b": {
		"name": "black large square",
		"unicode_version": 5.1,
		"category": "symbols",
		"order": 2152,
		"display": 1,
		"shortname": ":black_large_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b1b",
			"fully_qualified": "2b1b",
			"non_fully_qualified": "2b1b",
			"output": "2b1b",
			"default_matches": [
				"2b1b"
			],
			"greedy_matches": [
				"2b1b"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"2b1c": {
		"name": "white large square",
		"unicode_version": 5.1,
		"category": "symbols",
		"order": 2153,
		"display": 1,
		"shortname": ":white_large_square:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "2b1c",
			"fully_qualified": "2b1c",
			"non_fully_qualified": "2b1c",
			"output": "2b1c",
			"default_matches": [
				"2b1c"
			],
			"greedy_matches": [
				"2b1c"
			],
			"decimal": ""
		},
		"keywords": [
			"geometric",
			"square"
		]
	},
	"1f508": {
		"name": "speaker low volume",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2154,
		"display": 1,
		"shortname": ":speaker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f508",
			"fully_qualified": "1f508",
			"non_fully_qualified": "1f508",
			"output": "1f508",
			"default_matches": [
				"1f508"
			],
			"greedy_matches": [
				"1f508"
			],
			"decimal": ""
		},
		"keywords": [
			"soft"
		]
	},
	"1f507": {
		"name": "muted speaker",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2155,
		"display": 1,
		"shortname": ":mute:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f507",
			"fully_qualified": "1f507",
			"non_fully_qualified": "1f507",
			"output": "1f507",
			"default_matches": [
				"1f507"
			],
			"greedy_matches": [
				"1f507"
			],
			"decimal": ""
		},
		"keywords": [
			"mute",
			"quiet",
			"silent",
			"speaker"
		]
	},
	"1f509": {
		"name": "speaker medium volume",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2156,
		"display": 1,
		"shortname": ":sound:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f509",
			"fully_qualified": "1f509",
			"non_fully_qualified": "1f509",
			"output": "1f509",
			"default_matches": [
				"1f509"
			],
			"greedy_matches": [
				"1f509"
			],
			"decimal": ""
		},
		"keywords": [
			"medium"
		]
	},
	"1f50a": {
		"name": "speaker high volume",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2157,
		"display": 1,
		"shortname": ":loud_sound:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f50a",
			"fully_qualified": "1f50a",
			"non_fully_qualified": "1f50a",
			"output": "1f50a",
			"default_matches": [
				"1f50a"
			],
			"greedy_matches": [
				"1f50a"
			],
			"decimal": ""
		},
		"keywords": [
			"loud"
		]
	},
	"1f514": {
		"name": "bell",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2158,
		"display": 1,
		"shortname": ":bell:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f514",
			"fully_qualified": "1f514",
			"non_fully_qualified": "1f514",
			"output": "1f514",
			"default_matches": [
				"1f514"
			],
			"greedy_matches": [
				"1f514"
			],
			"decimal": ""
		},
		"keywords": [
			"bell"
		]
	},
	"1f515": {
		"name": "bell with slash",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2159,
		"display": 1,
		"shortname": ":no_bell:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f515",
			"fully_qualified": "1f515",
			"non_fully_qualified": "1f515",
			"output": "1f515",
			"default_matches": [
				"1f515"
			],
			"greedy_matches": [
				"1f515"
			],
			"decimal": ""
		},
		"keywords": [
			"bell",
			"forbidden",
			"mute",
			"no",
			"not",
			"prohibited",
			"quiet",
			"silent"
		]
	},
	"1f4e3": {
		"name": "megaphone",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2160,
		"display": 1,
		"shortname": ":mega:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e3",
			"fully_qualified": "1f4e3",
			"non_fully_qualified": "1f4e3",
			"output": "1f4e3",
			"default_matches": [
				"1f4e3"
			],
			"greedy_matches": [
				"1f4e3"
			],
			"decimal": ""
		},
		"keywords": [
			"cheering"
		]
	},
	"1f4e2": {
		"name": "loudspeaker",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2161,
		"display": 1,
		"shortname": ":loudspeaker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4e2",
			"fully_qualified": "1f4e2",
			"non_fully_qualified": "1f4e2",
			"output": "1f4e2",
			"default_matches": [
				"1f4e2"
			],
			"greedy_matches": [
				"1f4e2"
			],
			"decimal": ""
		},
		"keywords": [
			"loud",
			"public address"
		]
	},
	"1f5e8": {
		"name": "left speech bubble",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2162,
		"display": 1,
		"shortname": ":speech_left:",
		"shortname_alternates": [
			":left_speech_bubble:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5e8",
			"fully_qualified": "1f5e8-fe0f",
			"non_fully_qualified": "1f5e8",
			"output": "1f5e8-fe0f",
			"default_matches": [
				"1f5e8-fe0f",
				"1f5e8"
			],
			"greedy_matches": [
				"1f5e8-fe0f",
				"1f5e8"
			],
			"decimal": ""
		},
		"keywords": [
			"dialog",
			"speech"
		]
	},
	"1f441-1f5e8": {
		"name": "eye in speech bubble",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2163,
		"display": 1,
		"shortname": ":eye_in_speech_bubble:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f441-1f5e8",
			"fully_qualified": "1f441-fe0f-200d-1f5e8-fe0f",
			"non_fully_qualified": "1f441-200d-1f5e8",
			"output": "1f441-fe0f-200d-1f5e8-fe0f",
			"default_matches": [
				"1f441-fe0f-200d-1f5e8-fe0f",
				"1f441-200d-1f5e8",
				"1f441-fe0f-1f5e8-fe0f",
				"1f441-200d-1f5e8-fe0f",
				"1f441-fe0f-200d-1f5e8"
			],
			"greedy_matches": [
				"1f441-fe0f-200d-1f5e8-fe0f",
				"1f441-200d-1f5e8",
				"1f441-fe0f-1f5e8-fe0f",
				"1f441-200d-1f5e8-fe0f",
				"1f441-fe0f-200d-1f5e8"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"speech bubble",
			"witness"
		]
	},
	"1f4ac": {
		"name": "speech balloon",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2164,
		"display": 1,
		"shortname": ":speech_balloon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ac",
			"fully_qualified": "1f4ac",
			"non_fully_qualified": "1f4ac",
			"output": "1f4ac",
			"default_matches": [
				"1f4ac"
			],
			"greedy_matches": [
				"1f4ac"
			],
			"decimal": ""
		},
		"keywords": [
			"balloon",
			"bubble",
			"comic",
			"dialog",
			"speech"
		]
	},
	"1f4ad": {
		"name": "thought balloon",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2165,
		"display": 1,
		"shortname": ":thought_balloon:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f4ad",
			"fully_qualified": "1f4ad",
			"non_fully_qualified": "1f4ad",
			"output": "1f4ad",
			"default_matches": [
				"1f4ad"
			],
			"greedy_matches": [
				"1f4ad"
			],
			"decimal": ""
		},
		"keywords": [
			"balloon",
			"bubble",
			"comic",
			"thought"
		]
	},
	"1f5ef": {
		"name": "right anger bubble",
		"unicode_version": 7,
		"category": "symbols",
		"order": 2166,
		"display": 1,
		"shortname": ":anger_right:",
		"shortname_alternates": [
			":right_anger_bubble:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f5ef",
			"fully_qualified": "1f5ef-fe0f",
			"non_fully_qualified": "1f5ef",
			"output": "1f5ef-fe0f",
			"default_matches": [
				"1f5ef-fe0f",
				"1f5ef"
			],
			"greedy_matches": [
				"1f5ef-fe0f",
				"1f5ef"
			],
			"decimal": ""
		},
		"keywords": [
			"angry",
			"balloon",
			"bubble",
			"mad"
		]
	},
	"1f0cf": {
		"name": "joker",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2171,
		"display": 1,
		"shortname": ":black_joker:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f0cf",
			"fully_qualified": "1f0cf",
			"non_fully_qualified": "1f0cf",
			"output": "1f0cf",
			"default_matches": [
				"1f0cf"
			],
			"greedy_matches": [
				"1f0cf"
			],
			"decimal": ""
		},
		"keywords": [
			"card",
			"game",
			"wildcard"
		]
	},
	"1f3b4": {
		"name": "flower playing cards",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2172,
		"display": 1,
		"shortname": ":flower_playing_cards:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3b4",
			"fully_qualified": "1f3b4",
			"non_fully_qualified": "1f3b4",
			"output": "1f3b4",
			"default_matches": [
				"1f3b4"
			],
			"greedy_matches": [
				"1f3b4"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"card",
			"flower",
			"game",
			"playing"
		]
	},
	"1f004": {
		"name": "mahjong red dragon",
		"unicode_version": 5.1,
		"category": "symbols",
		"order": 2173,
		"display": 1,
		"shortname": ":mahjong:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f004",
			"fully_qualified": "1f004",
			"non_fully_qualified": "1f004",
			"output": "1f004",
			"default_matches": [
				"1f004"
			],
			"greedy_matches": [
				"1f004"
			],
			"decimal": ""
		},
		"keywords": [
			"game",
			"mahjong",
			"red"
		]
	},
	"1f550": {
		"name": "one o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2174,
		"display": 1,
		"shortname": ":clock1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f550",
			"fully_qualified": "1f550",
			"non_fully_qualified": "1f550",
			"output": "1f550",
			"default_matches": [
				"1f550"
			],
			"greedy_matches": [
				"1f550"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"1",
			"1:00",
			"clock",
			"one",
			"o’clock"
		]
	},
	"1f551": {
		"name": "two o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2175,
		"display": 1,
		"shortname": ":clock2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f551",
			"fully_qualified": "1f551",
			"non_fully_qualified": "1f551",
			"output": "1f551",
			"default_matches": [
				"1f551"
			],
			"greedy_matches": [
				"1f551"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"2",
			"2:00",
			"clock",
			"o’clock",
			"two"
		]
	},
	"1f552": {
		"name": "three o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2176,
		"display": 1,
		"shortname": ":clock3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f552",
			"fully_qualified": "1f552",
			"non_fully_qualified": "1f552",
			"output": "1f552",
			"default_matches": [
				"1f552"
			],
			"greedy_matches": [
				"1f552"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"3",
			"3:00",
			"clock",
			"o’clock",
			"three"
		]
	},
	"1f553": {
		"name": "four o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2177,
		"display": 1,
		"shortname": ":clock4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f553",
			"fully_qualified": "1f553",
			"non_fully_qualified": "1f553",
			"output": "1f553",
			"default_matches": [
				"1f553"
			],
			"greedy_matches": [
				"1f553"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"4",
			"4:00",
			"clock",
			"four",
			"o’clock"
		]
	},
	"1f554": {
		"name": "five o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2178,
		"display": 1,
		"shortname": ":clock5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f554",
			"fully_qualified": "1f554",
			"non_fully_qualified": "1f554",
			"output": "1f554",
			"default_matches": [
				"1f554"
			],
			"greedy_matches": [
				"1f554"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"5",
			"5:00",
			"clock",
			"five",
			"o’clock"
		]
	},
	"1f555": {
		"name": "six o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2179,
		"display": 1,
		"shortname": ":clock6:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f555",
			"fully_qualified": "1f555",
			"non_fully_qualified": "1f555",
			"output": "1f555",
			"default_matches": [
				"1f555"
			],
			"greedy_matches": [
				"1f555"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"6",
			"6:00",
			"clock",
			"o’clock",
			"six"
		]
	},
	"1f556": {
		"name": "seven o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2180,
		"display": 1,
		"shortname": ":clock7:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f556",
			"fully_qualified": "1f556",
			"non_fully_qualified": "1f556",
			"output": "1f556",
			"default_matches": [
				"1f556"
			],
			"greedy_matches": [
				"1f556"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"7",
			"7:00",
			"clock",
			"o’clock",
			"seven"
		]
	},
	"1f557": {
		"name": "eight o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2181,
		"display": 1,
		"shortname": ":clock8:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f557",
			"fully_qualified": "1f557",
			"non_fully_qualified": "1f557",
			"output": "1f557",
			"default_matches": [
				"1f557"
			],
			"greedy_matches": [
				"1f557"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"8",
			"8:00",
			"clock",
			"eight",
			"o’clock"
		]
	},
	"1f558": {
		"name": "nine o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2182,
		"display": 1,
		"shortname": ":clock9:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f558",
			"fully_qualified": "1f558",
			"non_fully_qualified": "1f558",
			"output": "1f558",
			"default_matches": [
				"1f558"
			],
			"greedy_matches": [
				"1f558"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"9",
			"9:00",
			"clock",
			"nine",
			"o’clock"
		]
	},
	"1f559": {
		"name": "ten o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2183,
		"display": 1,
		"shortname": ":clock10:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f559",
			"fully_qualified": "1f559",
			"non_fully_qualified": "1f559",
			"output": "1f559",
			"default_matches": [
				"1f559"
			],
			"greedy_matches": [
				"1f559"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"10",
			"10:00",
			"clock",
			"o’clock",
			"ten"
		]
	},
	"1f55a": {
		"name": "eleven o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2184,
		"display": 1,
		"shortname": ":clock11:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55a",
			"fully_qualified": "1f55a",
			"non_fully_qualified": "1f55a",
			"output": "1f55a",
			"default_matches": [
				"1f55a"
			],
			"greedy_matches": [
				"1f55a"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"11",
			"11:00",
			"clock",
			"eleven",
			"o’clock"
		]
	},
	"1f55b": {
		"name": "twelve o’clock",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2185,
		"display": 1,
		"shortname": ":clock12:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55b",
			"fully_qualified": "1f55b",
			"non_fully_qualified": "1f55b",
			"output": "1f55b",
			"default_matches": [
				"1f55b"
			],
			"greedy_matches": [
				"1f55b"
			],
			"decimal": ""
		},
		"keywords": [
			"00",
			"12",
			"12:00",
			"clock",
			"o’clock",
			"twelve"
		]
	},
	"1f55c": {
		"name": "one-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2186,
		"display": 1,
		"shortname": ":clock130:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55c",
			"fully_qualified": "1f55c",
			"non_fully_qualified": "1f55c",
			"output": "1f55c",
			"default_matches": [
				"1f55c"
			],
			"greedy_matches": [
				"1f55c"
			],
			"decimal": ""
		},
		"keywords": [
			"1",
			"1:30",
			"30",
			"clock",
			"one",
			"thirty"
		]
	},
	"1f55d": {
		"name": "two-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2187,
		"display": 1,
		"shortname": ":clock230:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55d",
			"fully_qualified": "1f55d",
			"non_fully_qualified": "1f55d",
			"output": "1f55d",
			"default_matches": [
				"1f55d"
			],
			"greedy_matches": [
				"1f55d"
			],
			"decimal": ""
		},
		"keywords": [
			"2",
			"2:30",
			"30",
			"clock",
			"thirty",
			"two"
		]
	},
	"1f55e": {
		"name": "three-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2188,
		"display": 1,
		"shortname": ":clock330:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55e",
			"fully_qualified": "1f55e",
			"non_fully_qualified": "1f55e",
			"output": "1f55e",
			"default_matches": [
				"1f55e"
			],
			"greedy_matches": [
				"1f55e"
			],
			"decimal": ""
		},
		"keywords": [
			"3",
			"30",
			"3:30",
			"clock",
			"thirty",
			"three"
		]
	},
	"1f55f": {
		"name": "four-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2189,
		"display": 1,
		"shortname": ":clock430:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f55f",
			"fully_qualified": "1f55f",
			"non_fully_qualified": "1f55f",
			"output": "1f55f",
			"default_matches": [
				"1f55f"
			],
			"greedy_matches": [
				"1f55f"
			],
			"decimal": ""
		},
		"keywords": [
			"4",
			"30",
			"4:30",
			"clock",
			"four",
			"thirty"
		]
	},
	"1f560": {
		"name": "five-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2190,
		"display": 1,
		"shortname": ":clock530:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f560",
			"fully_qualified": "1f560",
			"non_fully_qualified": "1f560",
			"output": "1f560",
			"default_matches": [
				"1f560"
			],
			"greedy_matches": [
				"1f560"
			],
			"decimal": ""
		},
		"keywords": [
			"5",
			"30",
			"5:30",
			"clock",
			"five",
			"thirty"
		]
	},
	"1f561": {
		"name": "six-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2191,
		"display": 1,
		"shortname": ":clock630:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f561",
			"fully_qualified": "1f561",
			"non_fully_qualified": "1f561",
			"output": "1f561",
			"default_matches": [
				"1f561"
			],
			"greedy_matches": [
				"1f561"
			],
			"decimal": ""
		},
		"keywords": [
			"6",
			"30",
			"6:30",
			"clock",
			"six",
			"thirty"
		]
	},
	"1f562": {
		"name": "seven-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2192,
		"display": 1,
		"shortname": ":clock730:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f562",
			"fully_qualified": "1f562",
			"non_fully_qualified": "1f562",
			"output": "1f562",
			"default_matches": [
				"1f562"
			],
			"greedy_matches": [
				"1f562"
			],
			"decimal": ""
		},
		"keywords": [
			"7",
			"30",
			"7:30",
			"clock",
			"seven",
			"thirty"
		]
	},
	"1f563": {
		"name": "eight-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2193,
		"display": 1,
		"shortname": ":clock830:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f563",
			"fully_qualified": "1f563",
			"non_fully_qualified": "1f563",
			"output": "1f563",
			"default_matches": [
				"1f563"
			],
			"greedy_matches": [
				"1f563"
			],
			"decimal": ""
		},
		"keywords": [
			"8",
			"30",
			"8:30",
			"clock",
			"eight",
			"thirty"
		]
	},
	"1f564": {
		"name": "nine-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2194,
		"display": 1,
		"shortname": ":clock930:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f564",
			"fully_qualified": "1f564",
			"non_fully_qualified": "1f564",
			"output": "1f564",
			"default_matches": [
				"1f564"
			],
			"greedy_matches": [
				"1f564"
			],
			"decimal": ""
		},
		"keywords": [
			"9",
			"30",
			"9:30",
			"clock",
			"nine",
			"thirty"
		]
	},
	"1f565": {
		"name": "ten-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2195,
		"display": 1,
		"shortname": ":clock1030:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f565",
			"fully_qualified": "1f565",
			"non_fully_qualified": "1f565",
			"output": "1f565",
			"default_matches": [
				"1f565"
			],
			"greedy_matches": [
				"1f565"
			],
			"decimal": ""
		},
		"keywords": [
			"10",
			"10:30",
			"30",
			"clock",
			"ten",
			"thirty"
		]
	},
	"1f566": {
		"name": "eleven-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2196,
		"display": 1,
		"shortname": ":clock1130:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f566",
			"fully_qualified": "1f566",
			"non_fully_qualified": "1f566",
			"output": "1f566",
			"default_matches": [
				"1f566"
			],
			"greedy_matches": [
				"1f566"
			],
			"decimal": ""
		},
		"keywords": [
			"11",
			"11:30",
			"30",
			"clock",
			"eleven",
			"thirty"
		]
	},
	"1f567": {
		"name": "twelve-thirty",
		"unicode_version": 6,
		"category": "symbols",
		"order": 2197,
		"display": 1,
		"shortname": ":clock1230:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f567",
			"fully_qualified": "1f567",
			"non_fully_qualified": "1f567",
			"output": "1f567",
			"default_matches": [
				"1f567"
			],
			"greedy_matches": [
				"1f567"
			],
			"decimal": ""
		},
		"keywords": [
			"12",
			"12:30",
			"30",
			"clock",
			"thirty",
			"twelve"
		]
	},
	"1f3f3": {
		"name": "white flag",
		"unicode_version": 7,
		"category": "flags",
		"order": 2198,
		"display": 1,
		"shortname": ":flag_white:",
		"shortname_alternates": [
			":waving_white_flag:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f3",
			"fully_qualified": "1f3f3-fe0f",
			"non_fully_qualified": "1f3f3",
			"output": "1f3f3-fe0f",
			"default_matches": [
				"1f3f3-fe0f",
				"1f3f3"
			],
			"greedy_matches": [
				"1f3f3-fe0f",
				"1f3f3"
			],
			"decimal": ""
		},
		"keywords": [
			"waving"
		]
	},
	"1f3f4": {
		"name": "black flag",
		"unicode_version": 7,
		"category": "flags",
		"order": 2199,
		"display": 1,
		"shortname": ":flag_black:",
		"shortname_alternates": [
			":waving_black_flag:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f4",
			"fully_qualified": "1f3f4",
			"non_fully_qualified": "1f3f4",
			"output": "1f3f4",
			"default_matches": [
				"1f3f4"
			],
			"greedy_matches": [
				"1f3f4"
			],
			"decimal": ""
		},
		"keywords": [
			"waving"
		]
	},
	"1f3c1": {
		"name": "chequered flag",
		"unicode_version": 6,
		"category": "flags",
		"order": 2200,
		"display": 1,
		"shortname": ":checkered_flag:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3c1",
			"fully_qualified": "1f3c1",
			"non_fully_qualified": "1f3c1",
			"output": "1f3c1",
			"default_matches": [
				"1f3c1"
			],
			"greedy_matches": [
				"1f3c1"
			],
			"decimal": ""
		},
		"keywords": [
			"checkered",
			"chequered",
			"racing"
		]
	},
	"1f6a9": {
		"name": "triangular flag",
		"unicode_version": 6,
		"category": "flags",
		"order": 2201,
		"display": 1,
		"shortname": ":triangular_flag_on_post:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f6a9",
			"fully_qualified": "1f6a9",
			"non_fully_qualified": "1f6a9",
			"output": "1f6a9",
			"default_matches": [
				"1f6a9"
			],
			"greedy_matches": [
				"1f6a9"
			],
			"decimal": ""
		},
		"keywords": [
			"post"
		]
	},
	"1f3f3-1f308": {
		"name": "rainbow flag",
		"unicode_version": 7,
		"category": "flags",
		"order": 2202,
		"display": 1,
		"shortname": ":rainbow_flag:",
		"shortname_alternates": [
			":gay_pride_flag:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f3-1f308",
			"fully_qualified": "1f3f3-fe0f-200d-1f308",
			"non_fully_qualified": "1f3f3-200d-1f308",
			"output": "1f3f3-fe0f-200d-1f308",
			"default_matches": [
				"1f3f3-fe0f-200d-1f308",
				"1f3f3-200d-1f308",
				"1f3f3-fe0f-1f308"
			],
			"greedy_matches": [
				"1f3f3-fe0f-200d-1f308",
				"1f3f3-200d-1f308",
				"1f3f3-fe0f-1f308"
			],
			"decimal": ""
		},
		"keywords": [
			"rainbow"
		]
	},
	"1f1e6-1f1eb": {
		"name": "Afghanistan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2203,
		"display": 1,
		"shortname": ":flag_af:",
		"shortname_alternates": [
			":af:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1eb",
			"fully_qualified": "1f1e6-1f1eb",
			"non_fully_qualified": "1f1e6-1f1eb",
			"output": "1f1e6-1f1eb",
			"default_matches": [
				"1f1e6-1f1eb"
			],
			"greedy_matches": [
				"1f1e6-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1fd": {
		"name": "Åland Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2204,
		"display": 1,
		"shortname": ":flag_ax:",
		"shortname_alternates": [
			":ax:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1fd",
			"fully_qualified": "1f1e6-1f1fd",
			"non_fully_qualified": "1f1e6-1f1fd",
			"output": "1f1e6-1f1fd",
			"default_matches": [
				"1f1e6-1f1fd"
			],
			"greedy_matches": [
				"1f1e6-1f1fd"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f1": {
		"name": "Albania",
		"unicode_version": 6,
		"category": "flags",
		"order": 2205,
		"display": 1,
		"shortname": ":flag_al:",
		"shortname_alternates": [
			":al:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f1",
			"fully_qualified": "1f1e6-1f1f1",
			"non_fully_qualified": "1f1e6-1f1f1",
			"output": "1f1e6-1f1f1",
			"default_matches": [
				"1f1e6-1f1f1"
			],
			"greedy_matches": [
				"1f1e6-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1ff": {
		"name": "Algeria",
		"unicode_version": 6,
		"category": "flags",
		"order": 2206,
		"display": 1,
		"shortname": ":flag_dz:",
		"shortname_alternates": [
			":dz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1ff",
			"fully_qualified": "1f1e9-1f1ff",
			"non_fully_qualified": "1f1e9-1f1ff",
			"output": "1f1e9-1f1ff",
			"default_matches": [
				"1f1e9-1f1ff"
			],
			"greedy_matches": [
				"1f1e9-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f8": {
		"name": "American Samoa",
		"unicode_version": 6,
		"category": "flags",
		"order": 2207,
		"display": 1,
		"shortname": ":flag_as:",
		"shortname_alternates": [
			":as:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f8",
			"fully_qualified": "1f1e6-1f1f8",
			"non_fully_qualified": "1f1e6-1f1f8",
			"output": "1f1e6-1f1f8",
			"default_matches": [
				"1f1e6-1f1f8"
			],
			"greedy_matches": [
				"1f1e6-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1e9": {
		"name": "Andorra",
		"unicode_version": 6,
		"category": "flags",
		"order": 2208,
		"display": 1,
		"shortname": ":flag_ad:",
		"shortname_alternates": [
			":ad:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1e9",
			"fully_qualified": "1f1e6-1f1e9",
			"non_fully_qualified": "1f1e6-1f1e9",
			"output": "1f1e6-1f1e9",
			"default_matches": [
				"1f1e6-1f1e9"
			],
			"greedy_matches": [
				"1f1e6-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f4": {
		"name": "Angola",
		"unicode_version": 6,
		"category": "flags",
		"order": 2209,
		"display": 1,
		"shortname": ":flag_ao:",
		"shortname_alternates": [
			":ao:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f4",
			"fully_qualified": "1f1e6-1f1f4",
			"non_fully_qualified": "1f1e6-1f1f4",
			"output": "1f1e6-1f1f4",
			"default_matches": [
				"1f1e6-1f1f4"
			],
			"greedy_matches": [
				"1f1e6-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1ee": {
		"name": "Anguilla",
		"unicode_version": 6,
		"category": "flags",
		"order": 2210,
		"display": 1,
		"shortname": ":flag_ai:",
		"shortname_alternates": [
			":ai:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1ee",
			"fully_qualified": "1f1e6-1f1ee",
			"non_fully_qualified": "1f1e6-1f1ee",
			"output": "1f1e6-1f1ee",
			"default_matches": [
				"1f1e6-1f1ee"
			],
			"greedy_matches": [
				"1f1e6-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f6": {
		"name": "Antarctica",
		"unicode_version": 6,
		"category": "flags",
		"order": 2211,
		"display": 1,
		"shortname": ":flag_aq:",
		"shortname_alternates": [
			":aq:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f6",
			"fully_qualified": "1f1e6-1f1f6",
			"non_fully_qualified": "1f1e6-1f1f6",
			"output": "1f1e6-1f1f6",
			"default_matches": [
				"1f1e6-1f1f6"
			],
			"greedy_matches": [
				"1f1e6-1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1ec": {
		"name": "Antigua & Barbuda",
		"unicode_version": 6,
		"category": "flags",
		"order": 2212,
		"display": 1,
		"shortname": ":flag_ag:",
		"shortname_alternates": [
			":ag:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1ec",
			"fully_qualified": "1f1e6-1f1ec",
			"non_fully_qualified": "1f1e6-1f1ec",
			"output": "1f1e6-1f1ec",
			"default_matches": [
				"1f1e6-1f1ec"
			],
			"greedy_matches": [
				"1f1e6-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f7": {
		"name": "Argentina",
		"unicode_version": 6,
		"category": "flags",
		"order": 2213,
		"display": 1,
		"shortname": ":flag_ar:",
		"shortname_alternates": [
			":ar:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f7",
			"fully_qualified": "1f1e6-1f1f7",
			"non_fully_qualified": "1f1e6-1f1f7",
			"output": "1f1e6-1f1f7",
			"default_matches": [
				"1f1e6-1f1f7"
			],
			"greedy_matches": [
				"1f1e6-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f2": {
		"name": "Armenia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2214,
		"display": 1,
		"shortname": ":flag_am:",
		"shortname_alternates": [
			":am:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f2",
			"fully_qualified": "1f1e6-1f1f2",
			"non_fully_qualified": "1f1e6-1f1f2",
			"output": "1f1e6-1f1f2",
			"default_matches": [
				"1f1e6-1f1f2"
			],
			"greedy_matches": [
				"1f1e6-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1fc": {
		"name": "Aruba",
		"unicode_version": 6,
		"category": "flags",
		"order": 2215,
		"display": 1,
		"shortname": ":flag_aw:",
		"shortname_alternates": [
			":aw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1fc",
			"fully_qualified": "1f1e6-1f1fc",
			"non_fully_qualified": "1f1e6-1f1fc",
			"output": "1f1e6-1f1fc",
			"default_matches": [
				"1f1e6-1f1fc"
			],
			"greedy_matches": [
				"1f1e6-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1fa": {
		"name": "Australia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2216,
		"display": 1,
		"shortname": ":flag_au:",
		"shortname_alternates": [
			":au:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1fa",
			"fully_qualified": "1f1e6-1f1fa",
			"non_fully_qualified": "1f1e6-1f1fa",
			"output": "1f1e6-1f1fa",
			"default_matches": [
				"1f1e6-1f1fa"
			],
			"greedy_matches": [
				"1f1e6-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1f9": {
		"name": "Austria",
		"unicode_version": 6,
		"category": "flags",
		"order": 2217,
		"display": 1,
		"shortname": ":flag_at:",
		"shortname_alternates": [
			":at:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1f9",
			"fully_qualified": "1f1e6-1f1f9",
			"non_fully_qualified": "1f1e6-1f1f9",
			"output": "1f1e6-1f1f9",
			"default_matches": [
				"1f1e6-1f1f9"
			],
			"greedy_matches": [
				"1f1e6-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1ff": {
		"name": "Azerbaijan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2218,
		"display": 1,
		"shortname": ":flag_az:",
		"shortname_alternates": [
			":az:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1ff",
			"fully_qualified": "1f1e6-1f1ff",
			"non_fully_qualified": "1f1e6-1f1ff",
			"output": "1f1e6-1f1ff",
			"default_matches": [
				"1f1e6-1f1ff"
			],
			"greedy_matches": [
				"1f1e6-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f8": {
		"name": "Bahamas",
		"unicode_version": 6,
		"category": "flags",
		"order": 2219,
		"display": 1,
		"shortname": ":flag_bs:",
		"shortname_alternates": [
			":bs:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f8",
			"fully_qualified": "1f1e7-1f1f8",
			"non_fully_qualified": "1f1e7-1f1f8",
			"output": "1f1e7-1f1f8",
			"default_matches": [
				"1f1e7-1f1f8"
			],
			"greedy_matches": [
				"1f1e7-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ed": {
		"name": "Bahrain",
		"unicode_version": 6,
		"category": "flags",
		"order": 2220,
		"display": 1,
		"shortname": ":flag_bh:",
		"shortname_alternates": [
			":bh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ed",
			"fully_qualified": "1f1e7-1f1ed",
			"non_fully_qualified": "1f1e7-1f1ed",
			"output": "1f1e7-1f1ed",
			"default_matches": [
				"1f1e7-1f1ed"
			],
			"greedy_matches": [
				"1f1e7-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1e9": {
		"name": "Bangladesh",
		"unicode_version": 6,
		"category": "flags",
		"order": 2221,
		"display": 1,
		"shortname": ":flag_bd:",
		"shortname_alternates": [
			":bd:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1e9",
			"fully_qualified": "1f1e7-1f1e9",
			"non_fully_qualified": "1f1e7-1f1e9",
			"output": "1f1e7-1f1e9",
			"default_matches": [
				"1f1e7-1f1e9"
			],
			"greedy_matches": [
				"1f1e7-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1e7": {
		"name": "Barbados",
		"unicode_version": 6,
		"category": "flags",
		"order": 2222,
		"display": 1,
		"shortname": ":flag_bb:",
		"shortname_alternates": [
			":bb:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1e7",
			"fully_qualified": "1f1e7-1f1e7",
			"non_fully_qualified": "1f1e7-1f1e7",
			"output": "1f1e7-1f1e7",
			"default_matches": [
				"1f1e7-1f1e7"
			],
			"greedy_matches": [
				"1f1e7-1f1e7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1fe": {
		"name": "Belarus",
		"unicode_version": 6,
		"category": "flags",
		"order": 2223,
		"display": 1,
		"shortname": ":flag_by:",
		"shortname_alternates": [
			":by:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1fe",
			"fully_qualified": "1f1e7-1f1fe",
			"non_fully_qualified": "1f1e7-1f1fe",
			"output": "1f1e7-1f1fe",
			"default_matches": [
				"1f1e7-1f1fe"
			],
			"greedy_matches": [
				"1f1e7-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ea": {
		"name": "Belgium",
		"unicode_version": 6,
		"category": "flags",
		"order": 2224,
		"display": 1,
		"shortname": ":flag_be:",
		"shortname_alternates": [
			":be:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ea",
			"fully_qualified": "1f1e7-1f1ea",
			"non_fully_qualified": "1f1e7-1f1ea",
			"output": "1f1e7-1f1ea",
			"default_matches": [
				"1f1e7-1f1ea"
			],
			"greedy_matches": [
				"1f1e7-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ff": {
		"name": "Belize",
		"unicode_version": 6,
		"category": "flags",
		"order": 2225,
		"display": 1,
		"shortname": ":flag_bz:",
		"shortname_alternates": [
			":bz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ff",
			"fully_qualified": "1f1e7-1f1ff",
			"non_fully_qualified": "1f1e7-1f1ff",
			"output": "1f1e7-1f1ff",
			"default_matches": [
				"1f1e7-1f1ff"
			],
			"greedy_matches": [
				"1f1e7-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ef": {
		"name": "Benin",
		"unicode_version": 6,
		"category": "flags",
		"order": 2226,
		"display": 1,
		"shortname": ":flag_bj:",
		"shortname_alternates": [
			":bj:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ef",
			"fully_qualified": "1f1e7-1f1ef",
			"non_fully_qualified": "1f1e7-1f1ef",
			"output": "1f1e7-1f1ef",
			"default_matches": [
				"1f1e7-1f1ef"
			],
			"greedy_matches": [
				"1f1e7-1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f2": {
		"name": "Bermuda",
		"unicode_version": 6,
		"category": "flags",
		"order": 2227,
		"display": 1,
		"shortname": ":flag_bm:",
		"shortname_alternates": [
			":bm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f2",
			"fully_qualified": "1f1e7-1f1f2",
			"non_fully_qualified": "1f1e7-1f1f2",
			"output": "1f1e7-1f1f2",
			"default_matches": [
				"1f1e7-1f1f2"
			],
			"greedy_matches": [
				"1f1e7-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f9": {
		"name": "Bhutan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2228,
		"display": 1,
		"shortname": ":flag_bt:",
		"shortname_alternates": [
			":bt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f9",
			"fully_qualified": "1f1e7-1f1f9",
			"non_fully_qualified": "1f1e7-1f1f9",
			"output": "1f1e7-1f1f9",
			"default_matches": [
				"1f1e7-1f1f9"
			],
			"greedy_matches": [
				"1f1e7-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f4": {
		"name": "Bolivia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2229,
		"display": 1,
		"shortname": ":flag_bo:",
		"shortname_alternates": [
			":bo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f4",
			"fully_qualified": "1f1e7-1f1f4",
			"non_fully_qualified": "1f1e7-1f1f4",
			"output": "1f1e7-1f1f4",
			"default_matches": [
				"1f1e7-1f1f4"
			],
			"greedy_matches": [
				"1f1e7-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1e6": {
		"name": "Bosnia & Herzegovina",
		"unicode_version": 6,
		"category": "flags",
		"order": 2230,
		"display": 1,
		"shortname": ":flag_ba:",
		"shortname_alternates": [
			":ba:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1e6",
			"fully_qualified": "1f1e7-1f1e6",
			"non_fully_qualified": "1f1e7-1f1e6",
			"output": "1f1e7-1f1e6",
			"default_matches": [
				"1f1e7-1f1e6"
			],
			"greedy_matches": [
				"1f1e7-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1fc": {
		"name": "Botswana",
		"unicode_version": 6,
		"category": "flags",
		"order": 2231,
		"display": 1,
		"shortname": ":flag_bw:",
		"shortname_alternates": [
			":bw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1fc",
			"fully_qualified": "1f1e7-1f1fc",
			"non_fully_qualified": "1f1e7-1f1fc",
			"output": "1f1e7-1f1fc",
			"default_matches": [
				"1f1e7-1f1fc"
			],
			"greedy_matches": [
				"1f1e7-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f7": {
		"name": "Brazil",
		"unicode_version": 6,
		"category": "flags",
		"order": 2232,
		"display": 1,
		"shortname": ":flag_br:",
		"shortname_alternates": [
			":br:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f7",
			"fully_qualified": "1f1e7-1f1f7",
			"non_fully_qualified": "1f1e7-1f1f7",
			"output": "1f1e7-1f1f7",
			"default_matches": [
				"1f1e7-1f1f7"
			],
			"greedy_matches": [
				"1f1e7-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f4": {
		"name": "British Indian Ocean Territory",
		"unicode_version": 6,
		"category": "flags",
		"order": 2233,
		"display": 1,
		"shortname": ":flag_io:",
		"shortname_alternates": [
			":io:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f4",
			"fully_qualified": "1f1ee-1f1f4",
			"non_fully_qualified": "1f1ee-1f1f4",
			"output": "1f1ee-1f1f4",
			"default_matches": [
				"1f1ee-1f1f4"
			],
			"greedy_matches": [
				"1f1ee-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1ec": {
		"name": "British Virgin Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2234,
		"display": 1,
		"shortname": ":flag_vg:",
		"shortname_alternates": [
			":vg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1ec",
			"fully_qualified": "1f1fb-1f1ec",
			"non_fully_qualified": "1f1fb-1f1ec",
			"output": "1f1fb-1f1ec",
			"default_matches": [
				"1f1fb-1f1ec"
			],
			"greedy_matches": [
				"1f1fb-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f3": {
		"name": "Brunei",
		"unicode_version": 6,
		"category": "flags",
		"order": 2235,
		"display": 1,
		"shortname": ":flag_bn:",
		"shortname_alternates": [
			":bn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f3",
			"fully_qualified": "1f1e7-1f1f3",
			"non_fully_qualified": "1f1e7-1f1f3",
			"output": "1f1e7-1f1f3",
			"default_matches": [
				"1f1e7-1f1f3"
			],
			"greedy_matches": [
				"1f1e7-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ec": {
		"name": "Bulgaria",
		"unicode_version": 6,
		"category": "flags",
		"order": 2236,
		"display": 1,
		"shortname": ":flag_bg:",
		"shortname_alternates": [
			":bg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ec",
			"fully_qualified": "1f1e7-1f1ec",
			"non_fully_qualified": "1f1e7-1f1ec",
			"output": "1f1e7-1f1ec",
			"default_matches": [
				"1f1e7-1f1ec"
			],
			"greedy_matches": [
				"1f1e7-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1eb": {
		"name": "Burkina Faso",
		"unicode_version": 6,
		"category": "flags",
		"order": 2237,
		"display": 1,
		"shortname": ":flag_bf:",
		"shortname_alternates": [
			":bf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1eb",
			"fully_qualified": "1f1e7-1f1eb",
			"non_fully_qualified": "1f1e7-1f1eb",
			"output": "1f1e7-1f1eb",
			"default_matches": [
				"1f1e7-1f1eb"
			],
			"greedy_matches": [
				"1f1e7-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1ee": {
		"name": "Burundi",
		"unicode_version": 6,
		"category": "flags",
		"order": 2238,
		"display": 1,
		"shortname": ":flag_bi:",
		"shortname_alternates": [
			":bi:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1ee",
			"fully_qualified": "1f1e7-1f1ee",
			"non_fully_qualified": "1f1e7-1f1ee",
			"output": "1f1e7-1f1ee",
			"default_matches": [
				"1f1e7-1f1ee"
			],
			"greedy_matches": [
				"1f1e7-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1ed": {
		"name": "Cambodia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2239,
		"display": 1,
		"shortname": ":flag_kh:",
		"shortname_alternates": [
			":kh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1ed",
			"fully_qualified": "1f1f0-1f1ed",
			"non_fully_qualified": "1f1f0-1f1ed",
			"output": "1f1f0-1f1ed",
			"default_matches": [
				"1f1f0-1f1ed"
			],
			"greedy_matches": [
				"1f1f0-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f2": {
		"name": "Cameroon",
		"unicode_version": 6,
		"category": "flags",
		"order": 2240,
		"display": 1,
		"shortname": ":flag_cm:",
		"shortname_alternates": [
			":cm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f2",
			"fully_qualified": "1f1e8-1f1f2",
			"non_fully_qualified": "1f1e8-1f1f2",
			"output": "1f1e8-1f1f2",
			"default_matches": [
				"1f1e8-1f1f2"
			],
			"greedy_matches": [
				"1f1e8-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1e6": {
		"name": "Canada",
		"unicode_version": 6,
		"category": "flags",
		"order": 2241,
		"display": 1,
		"shortname": ":flag_ca:",
		"shortname_alternates": [
			":ca:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1e6",
			"fully_qualified": "1f1e8-1f1e6",
			"non_fully_qualified": "1f1e8-1f1e6",
			"output": "1f1e8-1f1e6",
			"default_matches": [
				"1f1e8-1f1e6"
			],
			"greedy_matches": [
				"1f1e8-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1e8": {
		"name": "Canary Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2242,
		"display": 1,
		"shortname": ":flag_ic:",
		"shortname_alternates": [
			":ic:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1e8",
			"fully_qualified": "1f1ee-1f1e8",
			"non_fully_qualified": "1f1ee-1f1e8",
			"output": "1f1ee-1f1e8",
			"default_matches": [
				"1f1ee-1f1e8"
			],
			"greedy_matches": [
				"1f1ee-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1fb": {
		"name": "Cape Verde",
		"unicode_version": 6,
		"category": "flags",
		"order": 2243,
		"display": 1,
		"shortname": ":flag_cv:",
		"shortname_alternates": [
			":cv:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1fb",
			"fully_qualified": "1f1e8-1f1fb",
			"non_fully_qualified": "1f1e8-1f1fb",
			"output": "1f1e8-1f1fb",
			"default_matches": [
				"1f1e8-1f1fb"
			],
			"greedy_matches": [
				"1f1e8-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f6": {
		"name": "Caribbean Netherlands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2244,
		"display": 1,
		"shortname": ":flag_bq:",
		"shortname_alternates": [
			":bq:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f6",
			"fully_qualified": "1f1e7-1f1f6",
			"non_fully_qualified": "1f1e7-1f1f6",
			"output": "1f1e7-1f1f6",
			"default_matches": [
				"1f1e7-1f1f6"
			],
			"greedy_matches": [
				"1f1e7-1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1fe": {
		"name": "Cayman Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2245,
		"display": 1,
		"shortname": ":flag_ky:",
		"shortname_alternates": [
			":ky:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1fe",
			"fully_qualified": "1f1f0-1f1fe",
			"non_fully_qualified": "1f1f0-1f1fe",
			"output": "1f1f0-1f1fe",
			"default_matches": [
				"1f1f0-1f1fe"
			],
			"greedy_matches": [
				"1f1f0-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1eb": {
		"name": "Central African Republic",
		"unicode_version": 6,
		"category": "flags",
		"order": 2246,
		"display": 1,
		"shortname": ":flag_cf:",
		"shortname_alternates": [
			":cf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1eb",
			"fully_qualified": "1f1e8-1f1eb",
			"non_fully_qualified": "1f1e8-1f1eb",
			"output": "1f1e8-1f1eb",
			"default_matches": [
				"1f1e8-1f1eb"
			],
			"greedy_matches": [
				"1f1e8-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1e9": {
		"name": "Chad",
		"unicode_version": 6,
		"category": "flags",
		"order": 2247,
		"display": 1,
		"shortname": ":flag_td:",
		"shortname_alternates": [
			":td:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1e9",
			"fully_qualified": "1f1f9-1f1e9",
			"non_fully_qualified": "1f1f9-1f1e9",
			"output": "1f1f9-1f1e9",
			"default_matches": [
				"1f1f9-1f1e9"
			],
			"greedy_matches": [
				"1f1f9-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f1": {
		"name": "Chile",
		"unicode_version": 6,
		"category": "flags",
		"order": 2248,
		"display": 1,
		"shortname": ":flag_cl:",
		"shortname_alternates": [
			":chile:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f1",
			"fully_qualified": "1f1e8-1f1f1",
			"non_fully_qualified": "1f1e8-1f1f1",
			"output": "1f1e8-1f1f1",
			"default_matches": [
				"1f1e8-1f1f1"
			],
			"greedy_matches": [
				"1f1e8-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f3": {
		"name": "China",
		"unicode_version": 6,
		"category": "flags",
		"order": 2249,
		"display": 1,
		"shortname": ":flag_cn:",
		"shortname_alternates": [
			":cn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f3",
			"fully_qualified": "1f1e8-1f1f3",
			"non_fully_qualified": "1f1e8-1f1f3",
			"output": "1f1e8-1f1f3",
			"default_matches": [
				"1f1e8-1f1f3"
			],
			"greedy_matches": [
				"1f1e8-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1fd": {
		"name": "Christmas Island",
		"unicode_version": 6,
		"category": "flags",
		"order": 2250,
		"display": 1,
		"shortname": ":flag_cx:",
		"shortname_alternates": [
			":cx:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1fd",
			"fully_qualified": "1f1e8-1f1fd",
			"non_fully_qualified": "1f1e8-1f1fd",
			"output": "1f1e8-1f1fd",
			"default_matches": [
				"1f1e8-1f1fd"
			],
			"greedy_matches": [
				"1f1e8-1f1fd"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1e8": {
		"name": "Cocos (Keeling) Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2251,
		"display": 1,
		"shortname": ":flag_cc:",
		"shortname_alternates": [
			":cc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1e8",
			"fully_qualified": "1f1e8-1f1e8",
			"non_fully_qualified": "1f1e8-1f1e8",
			"output": "1f1e8-1f1e8",
			"default_matches": [
				"1f1e8-1f1e8"
			],
			"greedy_matches": [
				"1f1e8-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f4": {
		"name": "Colombia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2252,
		"display": 1,
		"shortname": ":flag_co:",
		"shortname_alternates": [
			":co:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f4",
			"fully_qualified": "1f1e8-1f1f4",
			"non_fully_qualified": "1f1e8-1f1f4",
			"output": "1f1e8-1f1f4",
			"default_matches": [
				"1f1e8-1f1f4"
			],
			"greedy_matches": [
				"1f1e8-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1f2": {
		"name": "Comoros",
		"unicode_version": 6,
		"category": "flags",
		"order": 2253,
		"display": 1,
		"shortname": ":flag_km:",
		"shortname_alternates": [
			":km:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1f2",
			"fully_qualified": "1f1f0-1f1f2",
			"non_fully_qualified": "1f1f0-1f1f2",
			"output": "1f1f0-1f1f2",
			"default_matches": [
				"1f1f0-1f1f2"
			],
			"greedy_matches": [
				"1f1f0-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1ec": {
		"name": "Congo - Brazzaville",
		"unicode_version": 6,
		"category": "flags",
		"order": 2254,
		"display": 1,
		"shortname": ":flag_cg:",
		"shortname_alternates": [
			":cg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1ec",
			"fully_qualified": "1f1e8-1f1ec",
			"non_fully_qualified": "1f1e8-1f1ec",
			"output": "1f1e8-1f1ec",
			"default_matches": [
				"1f1e8-1f1ec"
			],
			"greedy_matches": [
				"1f1e8-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1e9": {
		"name": "Congo - Kinshasa",
		"unicode_version": 6,
		"category": "flags",
		"order": 2255,
		"display": 1,
		"shortname": ":flag_cd:",
		"shortname_alternates": [
			":congo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1e9",
			"fully_qualified": "1f1e8-1f1e9",
			"non_fully_qualified": "1f1e8-1f1e9",
			"output": "1f1e8-1f1e9",
			"default_matches": [
				"1f1e8-1f1e9"
			],
			"greedy_matches": [
				"1f1e8-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f0": {
		"name": "Cook Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2256,
		"display": 1,
		"shortname": ":flag_ck:",
		"shortname_alternates": [
			":ck:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f0",
			"fully_qualified": "1f1e8-1f1f0",
			"non_fully_qualified": "1f1e8-1f1f0",
			"output": "1f1e8-1f1f0",
			"default_matches": [
				"1f1e8-1f1f0"
			],
			"greedy_matches": [
				"1f1e8-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f7": {
		"name": "Costa Rica",
		"unicode_version": 6,
		"category": "flags",
		"order": 2257,
		"display": 1,
		"shortname": ":flag_cr:",
		"shortname_alternates": [
			":cr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f7",
			"fully_qualified": "1f1e8-1f1f7",
			"non_fully_qualified": "1f1e8-1f1f7",
			"output": "1f1e8-1f1f7",
			"default_matches": [
				"1f1e8-1f1f7"
			],
			"greedy_matches": [
				"1f1e8-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1ee": {
		"name": "Côte d’Ivoire",
		"unicode_version": 6,
		"category": "flags",
		"order": 2258,
		"display": 1,
		"shortname": ":flag_ci:",
		"shortname_alternates": [
			":ci:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1ee",
			"fully_qualified": "1f1e8-1f1ee",
			"non_fully_qualified": "1f1e8-1f1ee",
			"output": "1f1e8-1f1ee",
			"default_matches": [
				"1f1e8-1f1ee"
			],
			"greedy_matches": [
				"1f1e8-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1f7": {
		"name": "Croatia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2259,
		"display": 1,
		"shortname": ":flag_hr:",
		"shortname_alternates": [
			":hr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1f7",
			"fully_qualified": "1f1ed-1f1f7",
			"non_fully_qualified": "1f1ed-1f1f7",
			"output": "1f1ed-1f1f7",
			"default_matches": [
				"1f1ed-1f1f7"
			],
			"greedy_matches": [
				"1f1ed-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1fa": {
		"name": "Cuba",
		"unicode_version": 6,
		"category": "flags",
		"order": 2260,
		"display": 1,
		"shortname": ":flag_cu:",
		"shortname_alternates": [
			":cu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1fa",
			"fully_qualified": "1f1e8-1f1fa",
			"non_fully_qualified": "1f1e8-1f1fa",
			"output": "1f1e8-1f1fa",
			"default_matches": [
				"1f1e8-1f1fa"
			],
			"greedy_matches": [
				"1f1e8-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1fc": {
		"name": "Curaçao",
		"unicode_version": 6,
		"category": "flags",
		"order": 2261,
		"display": 1,
		"shortname": ":flag_cw:",
		"shortname_alternates": [
			":cw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1fc",
			"fully_qualified": "1f1e8-1f1fc",
			"non_fully_qualified": "1f1e8-1f1fc",
			"output": "1f1e8-1f1fc",
			"default_matches": [
				"1f1e8-1f1fc"
			],
			"greedy_matches": [
				"1f1e8-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1fe": {
		"name": "Cyprus",
		"unicode_version": 6,
		"category": "flags",
		"order": 2262,
		"display": 1,
		"shortname": ":flag_cy:",
		"shortname_alternates": [
			":cy:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1fe",
			"fully_qualified": "1f1e8-1f1fe",
			"non_fully_qualified": "1f1e8-1f1fe",
			"output": "1f1e8-1f1fe",
			"default_matches": [
				"1f1e8-1f1fe"
			],
			"greedy_matches": [
				"1f1e8-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1ff": {
		"name": "Czechia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2263,
		"display": 1,
		"shortname": ":flag_cz:",
		"shortname_alternates": [
			":cz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1ff",
			"fully_qualified": "1f1e8-1f1ff",
			"non_fully_qualified": "1f1e8-1f1ff",
			"output": "1f1e8-1f1ff",
			"default_matches": [
				"1f1e8-1f1ff"
			],
			"greedy_matches": [
				"1f1e8-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1f0": {
		"name": "Denmark",
		"unicode_version": 6,
		"category": "flags",
		"order": 2264,
		"display": 1,
		"shortname": ":flag_dk:",
		"shortname_alternates": [
			":dk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1f0",
			"fully_qualified": "1f1e9-1f1f0",
			"non_fully_qualified": "1f1e9-1f1f0",
			"output": "1f1e9-1f1f0",
			"default_matches": [
				"1f1e9-1f1f0"
			],
			"greedy_matches": [
				"1f1e9-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1ef": {
		"name": "Djibouti",
		"unicode_version": 6,
		"category": "flags",
		"order": 2265,
		"display": 1,
		"shortname": ":flag_dj:",
		"shortname_alternates": [
			":dj:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1ef",
			"fully_qualified": "1f1e9-1f1ef",
			"non_fully_qualified": "1f1e9-1f1ef",
			"output": "1f1e9-1f1ef",
			"default_matches": [
				"1f1e9-1f1ef"
			],
			"greedy_matches": [
				"1f1e9-1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1f2": {
		"name": "Dominica",
		"unicode_version": 6,
		"category": "flags",
		"order": 2266,
		"display": 1,
		"shortname": ":flag_dm:",
		"shortname_alternates": [
			":dm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1f2",
			"fully_qualified": "1f1e9-1f1f2",
			"non_fully_qualified": "1f1e9-1f1f2",
			"output": "1f1e9-1f1f2",
			"default_matches": [
				"1f1e9-1f1f2"
			],
			"greedy_matches": [
				"1f1e9-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1f4": {
		"name": "Dominican Republic",
		"unicode_version": 6,
		"category": "flags",
		"order": 2267,
		"display": 1,
		"shortname": ":flag_do:",
		"shortname_alternates": [
			":do:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1f4",
			"fully_qualified": "1f1e9-1f1f4",
			"non_fully_qualified": "1f1e9-1f1f4",
			"output": "1f1e9-1f1f4",
			"default_matches": [
				"1f1e9-1f1f4"
			],
			"greedy_matches": [
				"1f1e9-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1e8": {
		"name": "Ecuador",
		"unicode_version": 6,
		"category": "flags",
		"order": 2268,
		"display": 1,
		"shortname": ":flag_ec:",
		"shortname_alternates": [
			":ec:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1e8",
			"fully_qualified": "1f1ea-1f1e8",
			"non_fully_qualified": "1f1ea-1f1e8",
			"output": "1f1ea-1f1e8",
			"default_matches": [
				"1f1ea-1f1e8"
			],
			"greedy_matches": [
				"1f1ea-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1ec": {
		"name": "Egypt",
		"unicode_version": 6,
		"category": "flags",
		"order": 2269,
		"display": 1,
		"shortname": ":flag_eg:",
		"shortname_alternates": [
			":eg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1ec",
			"fully_qualified": "1f1ea-1f1ec",
			"non_fully_qualified": "1f1ea-1f1ec",
			"output": "1f1ea-1f1ec",
			"default_matches": [
				"1f1ea-1f1ec"
			],
			"greedy_matches": [
				"1f1ea-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1fb": {
		"name": "El Salvador",
		"unicode_version": 6,
		"category": "flags",
		"order": 2270,
		"display": 1,
		"shortname": ":flag_sv:",
		"shortname_alternates": [
			":sv:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1fb",
			"fully_qualified": "1f1f8-1f1fb",
			"non_fully_qualified": "1f1f8-1f1fb",
			"output": "1f1f8-1f1fb",
			"default_matches": [
				"1f1f8-1f1fb"
			],
			"greedy_matches": [
				"1f1f8-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f6": {
		"name": "Equatorial Guinea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2271,
		"display": 1,
		"shortname": ":flag_gq:",
		"shortname_alternates": [
			":gq:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f6",
			"fully_qualified": "1f1ec-1f1f6",
			"non_fully_qualified": "1f1ec-1f1f6",
			"output": "1f1ec-1f1f6",
			"default_matches": [
				"1f1ec-1f1f6"
			],
			"greedy_matches": [
				"1f1ec-1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1f7": {
		"name": "Eritrea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2272,
		"display": 1,
		"shortname": ":flag_er:",
		"shortname_alternates": [
			":er:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1f7",
			"fully_qualified": "1f1ea-1f1f7",
			"non_fully_qualified": "1f1ea-1f1f7",
			"output": "1f1ea-1f1f7",
			"default_matches": [
				"1f1ea-1f1f7"
			],
			"greedy_matches": [
				"1f1ea-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1ea": {
		"name": "Estonia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2273,
		"display": 1,
		"shortname": ":flag_ee:",
		"shortname_alternates": [
			":ee:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1ea",
			"fully_qualified": "1f1ea-1f1ea",
			"non_fully_qualified": "1f1ea-1f1ea",
			"output": "1f1ea-1f1ea",
			"default_matches": [
				"1f1ea-1f1ea"
			],
			"greedy_matches": [
				"1f1ea-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1f9": {
		"name": "Ethiopia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2274,
		"display": 1,
		"shortname": ":flag_et:",
		"shortname_alternates": [
			":et:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1f9",
			"fully_qualified": "1f1ea-1f1f9",
			"non_fully_qualified": "1f1ea-1f1f9",
			"output": "1f1ea-1f1f9",
			"default_matches": [
				"1f1ea-1f1f9"
			],
			"greedy_matches": [
				"1f1ea-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1fa": {
		"name": "European Union",
		"unicode_version": 6,
		"category": "flags",
		"order": 2275,
		"display": 1,
		"shortname": ":flag_eu:",
		"shortname_alternates": [
			":eu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1fa",
			"fully_qualified": "1f1ea-1f1fa",
			"non_fully_qualified": "1f1ea-1f1fa",
			"output": "1f1ea-1f1fa",
			"default_matches": [
				"1f1ea-1f1fa"
			],
			"greedy_matches": [
				"1f1ea-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1f0": {
		"name": "Falkland Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2276,
		"display": 1,
		"shortname": ":flag_fk:",
		"shortname_alternates": [
			":fk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1f0",
			"fully_qualified": "1f1eb-1f1f0",
			"non_fully_qualified": "1f1eb-1f1f0",
			"output": "1f1eb-1f1f0",
			"default_matches": [
				"1f1eb-1f1f0"
			],
			"greedy_matches": [
				"1f1eb-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1f4": {
		"name": "Faroe Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2277,
		"display": 1,
		"shortname": ":flag_fo:",
		"shortname_alternates": [
			":fo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1f4",
			"fully_qualified": "1f1eb-1f1f4",
			"non_fully_qualified": "1f1eb-1f1f4",
			"output": "1f1eb-1f1f4",
			"default_matches": [
				"1f1eb-1f1f4"
			],
			"greedy_matches": [
				"1f1eb-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1ef": {
		"name": "Fiji",
		"unicode_version": 6,
		"category": "flags",
		"order": 2278,
		"display": 1,
		"shortname": ":flag_fj:",
		"shortname_alternates": [
			":fj:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1ef",
			"fully_qualified": "1f1eb-1f1ef",
			"non_fully_qualified": "1f1eb-1f1ef",
			"output": "1f1eb-1f1ef",
			"default_matches": [
				"1f1eb-1f1ef"
			],
			"greedy_matches": [
				"1f1eb-1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1ee": {
		"name": "Finland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2279,
		"display": 1,
		"shortname": ":flag_fi:",
		"shortname_alternates": [
			":fi:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1ee",
			"fully_qualified": "1f1eb-1f1ee",
			"non_fully_qualified": "1f1eb-1f1ee",
			"output": "1f1eb-1f1ee",
			"default_matches": [
				"1f1eb-1f1ee"
			],
			"greedy_matches": [
				"1f1eb-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1f7": {
		"name": "France",
		"unicode_version": 6,
		"category": "flags",
		"order": 2280,
		"display": 1,
		"shortname": ":flag_fr:",
		"shortname_alternates": [
			":fr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1f7",
			"fully_qualified": "1f1eb-1f1f7",
			"non_fully_qualified": "1f1eb-1f1f7",
			"output": "1f1eb-1f1f7",
			"default_matches": [
				"1f1eb-1f1f7"
			],
			"greedy_matches": [
				"1f1eb-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1eb": {
		"name": "French Guiana",
		"unicode_version": 6,
		"category": "flags",
		"order": 2281,
		"display": 1,
		"shortname": ":flag_gf:",
		"shortname_alternates": [
			":gf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1eb",
			"fully_qualified": "1f1ec-1f1eb",
			"non_fully_qualified": "1f1ec-1f1eb",
			"output": "1f1ec-1f1eb",
			"default_matches": [
				"1f1ec-1f1eb"
			],
			"greedy_matches": [
				"1f1ec-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1eb": {
		"name": "French Polynesia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2282,
		"display": 1,
		"shortname": ":flag_pf:",
		"shortname_alternates": [
			":pf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1eb",
			"fully_qualified": "1f1f5-1f1eb",
			"non_fully_qualified": "1f1f5-1f1eb",
			"output": "1f1f5-1f1eb",
			"default_matches": [
				"1f1f5-1f1eb"
			],
			"greedy_matches": [
				"1f1f5-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1eb": {
		"name": "French Southern Territories",
		"unicode_version": 6,
		"category": "flags",
		"order": 2283,
		"display": 1,
		"shortname": ":flag_tf:",
		"shortname_alternates": [
			":tf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1eb",
			"fully_qualified": "1f1f9-1f1eb",
			"non_fully_qualified": "1f1f9-1f1eb",
			"output": "1f1f9-1f1eb",
			"default_matches": [
				"1f1f9-1f1eb"
			],
			"greedy_matches": [
				"1f1f9-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1e6": {
		"name": "Gabon",
		"unicode_version": 6,
		"category": "flags",
		"order": 2284,
		"display": 1,
		"shortname": ":flag_ga:",
		"shortname_alternates": [
			":ga:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1e6",
			"fully_qualified": "1f1ec-1f1e6",
			"non_fully_qualified": "1f1ec-1f1e6",
			"output": "1f1ec-1f1e6",
			"default_matches": [
				"1f1ec-1f1e6"
			],
			"greedy_matches": [
				"1f1ec-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f2": {
		"name": "Gambia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2285,
		"display": 1,
		"shortname": ":flag_gm:",
		"shortname_alternates": [
			":gm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f2",
			"fully_qualified": "1f1ec-1f1f2",
			"non_fully_qualified": "1f1ec-1f1f2",
			"output": "1f1ec-1f1f2",
			"default_matches": [
				"1f1ec-1f1f2"
			],
			"greedy_matches": [
				"1f1ec-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1ea": {
		"name": "Georgia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2286,
		"display": 1,
		"shortname": ":flag_ge:",
		"shortname_alternates": [
			":ge:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1ea",
			"fully_qualified": "1f1ec-1f1ea",
			"non_fully_qualified": "1f1ec-1f1ea",
			"output": "1f1ec-1f1ea",
			"default_matches": [
				"1f1ec-1f1ea"
			],
			"greedy_matches": [
				"1f1ec-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1ea": {
		"name": "Germany",
		"unicode_version": 6,
		"category": "flags",
		"order": 2287,
		"display": 1,
		"shortname": ":flag_de:",
		"shortname_alternates": [
			":de:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1ea",
			"fully_qualified": "1f1e9-1f1ea",
			"non_fully_qualified": "1f1e9-1f1ea",
			"output": "1f1e9-1f1ea",
			"default_matches": [
				"1f1e9-1f1ea"
			],
			"greedy_matches": [
				"1f1e9-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1ed": {
		"name": "Ghana",
		"unicode_version": 6,
		"category": "flags",
		"order": 2288,
		"display": 1,
		"shortname": ":flag_gh:",
		"shortname_alternates": [
			":gh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1ed",
			"fully_qualified": "1f1ec-1f1ed",
			"non_fully_qualified": "1f1ec-1f1ed",
			"output": "1f1ec-1f1ed",
			"default_matches": [
				"1f1ec-1f1ed"
			],
			"greedy_matches": [
				"1f1ec-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1ee": {
		"name": "Gibraltar",
		"unicode_version": 6,
		"category": "flags",
		"order": 2289,
		"display": 1,
		"shortname": ":flag_gi:",
		"shortname_alternates": [
			":gi:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1ee",
			"fully_qualified": "1f1ec-1f1ee",
			"non_fully_qualified": "1f1ec-1f1ee",
			"output": "1f1ec-1f1ee",
			"default_matches": [
				"1f1ec-1f1ee"
			],
			"greedy_matches": [
				"1f1ec-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f7": {
		"name": "Greece",
		"unicode_version": 6,
		"category": "flags",
		"order": 2290,
		"display": 1,
		"shortname": ":flag_gr:",
		"shortname_alternates": [
			":gr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f7",
			"fully_qualified": "1f1ec-1f1f7",
			"non_fully_qualified": "1f1ec-1f1f7",
			"output": "1f1ec-1f1f7",
			"default_matches": [
				"1f1ec-1f1f7"
			],
			"greedy_matches": [
				"1f1ec-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f1": {
		"name": "Greenland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2291,
		"display": 1,
		"shortname": ":flag_gl:",
		"shortname_alternates": [
			":gl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f1",
			"fully_qualified": "1f1ec-1f1f1",
			"non_fully_qualified": "1f1ec-1f1f1",
			"output": "1f1ec-1f1f1",
			"default_matches": [
				"1f1ec-1f1f1"
			],
			"greedy_matches": [
				"1f1ec-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1e9": {
		"name": "Grenada",
		"unicode_version": 6,
		"category": "flags",
		"order": 2292,
		"display": 1,
		"shortname": ":flag_gd:",
		"shortname_alternates": [
			":gd:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1e9",
			"fully_qualified": "1f1ec-1f1e9",
			"non_fully_qualified": "1f1ec-1f1e9",
			"output": "1f1ec-1f1e9",
			"default_matches": [
				"1f1ec-1f1e9"
			],
			"greedy_matches": [
				"1f1ec-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f5": {
		"name": "Guadeloupe",
		"unicode_version": 6,
		"category": "flags",
		"order": 2293,
		"display": 1,
		"shortname": ":flag_gp:",
		"shortname_alternates": [
			":gp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f5",
			"fully_qualified": "1f1ec-1f1f5",
			"non_fully_qualified": "1f1ec-1f1f5",
			"output": "1f1ec-1f1f5",
			"default_matches": [
				"1f1ec-1f1f5"
			],
			"greedy_matches": [
				"1f1ec-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1fa": {
		"name": "Guam",
		"unicode_version": 6,
		"category": "flags",
		"order": 2294,
		"display": 1,
		"shortname": ":flag_gu:",
		"shortname_alternates": [
			":gu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1fa",
			"fully_qualified": "1f1ec-1f1fa",
			"non_fully_qualified": "1f1ec-1f1fa",
			"output": "1f1ec-1f1fa",
			"default_matches": [
				"1f1ec-1f1fa"
			],
			"greedy_matches": [
				"1f1ec-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f9": {
		"name": "Guatemala",
		"unicode_version": 6,
		"category": "flags",
		"order": 2295,
		"display": 1,
		"shortname": ":flag_gt:",
		"shortname_alternates": [
			":gt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f9",
			"fully_qualified": "1f1ec-1f1f9",
			"non_fully_qualified": "1f1ec-1f1f9",
			"output": "1f1ec-1f1f9",
			"default_matches": [
				"1f1ec-1f1f9"
			],
			"greedy_matches": [
				"1f1ec-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1ec": {
		"name": "Guernsey",
		"unicode_version": 6,
		"category": "flags",
		"order": 2296,
		"display": 1,
		"shortname": ":flag_gg:",
		"shortname_alternates": [
			":gg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1ec",
			"fully_qualified": "1f1ec-1f1ec",
			"non_fully_qualified": "1f1ec-1f1ec",
			"output": "1f1ec-1f1ec",
			"default_matches": [
				"1f1ec-1f1ec"
			],
			"greedy_matches": [
				"1f1ec-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f3": {
		"name": "Guinea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2297,
		"display": 1,
		"shortname": ":flag_gn:",
		"shortname_alternates": [
			":gn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f3",
			"fully_qualified": "1f1ec-1f1f3",
			"non_fully_qualified": "1f1ec-1f1f3",
			"output": "1f1ec-1f1f3",
			"default_matches": [
				"1f1ec-1f1f3"
			],
			"greedy_matches": [
				"1f1ec-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1fc": {
		"name": "Guinea-Bissau",
		"unicode_version": 6,
		"category": "flags",
		"order": 2298,
		"display": 1,
		"shortname": ":flag_gw:",
		"shortname_alternates": [
			":gw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1fc",
			"fully_qualified": "1f1ec-1f1fc",
			"non_fully_qualified": "1f1ec-1f1fc",
			"output": "1f1ec-1f1fc",
			"default_matches": [
				"1f1ec-1f1fc"
			],
			"greedy_matches": [
				"1f1ec-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1fe": {
		"name": "Guyana",
		"unicode_version": 6,
		"category": "flags",
		"order": 2299,
		"display": 1,
		"shortname": ":flag_gy:",
		"shortname_alternates": [
			":gy:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1fe",
			"fully_qualified": "1f1ec-1f1fe",
			"non_fully_qualified": "1f1ec-1f1fe",
			"output": "1f1ec-1f1fe",
			"default_matches": [
				"1f1ec-1f1fe"
			],
			"greedy_matches": [
				"1f1ec-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1f9": {
		"name": "Haiti",
		"unicode_version": 6,
		"category": "flags",
		"order": 2300,
		"display": 1,
		"shortname": ":flag_ht:",
		"shortname_alternates": [
			":ht:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1f9",
			"fully_qualified": "1f1ed-1f1f9",
			"non_fully_qualified": "1f1ed-1f1f9",
			"output": "1f1ed-1f1f9",
			"default_matches": [
				"1f1ed-1f1f9"
			],
			"greedy_matches": [
				"1f1ed-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1f3": {
		"name": "Honduras",
		"unicode_version": 6,
		"category": "flags",
		"order": 2301,
		"display": 1,
		"shortname": ":flag_hn:",
		"shortname_alternates": [
			":hn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1f3",
			"fully_qualified": "1f1ed-1f1f3",
			"non_fully_qualified": "1f1ed-1f1f3",
			"output": "1f1ed-1f1f3",
			"default_matches": [
				"1f1ed-1f1f3"
			],
			"greedy_matches": [
				"1f1ed-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1f0": {
		"name": "Hong Kong SAR China",
		"unicode_version": 6,
		"category": "flags",
		"order": 2302,
		"display": 1,
		"shortname": ":flag_hk:",
		"shortname_alternates": [
			":hk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1f0",
			"fully_qualified": "1f1ed-1f1f0",
			"non_fully_qualified": "1f1ed-1f1f0",
			"output": "1f1ed-1f1f0",
			"default_matches": [
				"1f1ed-1f1f0"
			],
			"greedy_matches": [
				"1f1ed-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1fa": {
		"name": "Hungary",
		"unicode_version": 6,
		"category": "flags",
		"order": 2303,
		"display": 1,
		"shortname": ":flag_hu:",
		"shortname_alternates": [
			":hu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1fa",
			"fully_qualified": "1f1ed-1f1fa",
			"non_fully_qualified": "1f1ed-1f1fa",
			"output": "1f1ed-1f1fa",
			"default_matches": [
				"1f1ed-1f1fa"
			],
			"greedy_matches": [
				"1f1ed-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f8": {
		"name": "Iceland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2304,
		"display": 1,
		"shortname": ":flag_is:",
		"shortname_alternates": [
			":is:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f8",
			"fully_qualified": "1f1ee-1f1f8",
			"non_fully_qualified": "1f1ee-1f1f8",
			"output": "1f1ee-1f1f8",
			"default_matches": [
				"1f1ee-1f1f8"
			],
			"greedy_matches": [
				"1f1ee-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f3": {
		"name": "India",
		"unicode_version": 6,
		"category": "flags",
		"order": 2305,
		"display": 1,
		"shortname": ":flag_in:",
		"shortname_alternates": [
			":in:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f3",
			"fully_qualified": "1f1ee-1f1f3",
			"non_fully_qualified": "1f1ee-1f1f3",
			"output": "1f1ee-1f1f3",
			"default_matches": [
				"1f1ee-1f1f3"
			],
			"greedy_matches": [
				"1f1ee-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1e9": {
		"name": "Indonesia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2306,
		"display": 1,
		"shortname": ":flag_id:",
		"shortname_alternates": [
			":indonesia:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1e9",
			"fully_qualified": "1f1ee-1f1e9",
			"non_fully_qualified": "1f1ee-1f1e9",
			"output": "1f1ee-1f1e9",
			"default_matches": [
				"1f1ee-1f1e9"
			],
			"greedy_matches": [
				"1f1ee-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f7": {
		"name": "Iran",
		"unicode_version": 6,
		"category": "flags",
		"order": 2307,
		"display": 1,
		"shortname": ":flag_ir:",
		"shortname_alternates": [
			":ir:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f7",
			"fully_qualified": "1f1ee-1f1f7",
			"non_fully_qualified": "1f1ee-1f1f7",
			"output": "1f1ee-1f1f7",
			"default_matches": [
				"1f1ee-1f1f7"
			],
			"greedy_matches": [
				"1f1ee-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f6": {
		"name": "Iraq",
		"unicode_version": 6,
		"category": "flags",
		"order": 2308,
		"display": 1,
		"shortname": ":flag_iq:",
		"shortname_alternates": [
			":iq:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f6",
			"fully_qualified": "1f1ee-1f1f6",
			"non_fully_qualified": "1f1ee-1f1f6",
			"output": "1f1ee-1f1f6",
			"default_matches": [
				"1f1ee-1f1f6"
			],
			"greedy_matches": [
				"1f1ee-1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1ea": {
		"name": "Ireland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2309,
		"display": 1,
		"shortname": ":flag_ie:",
		"shortname_alternates": [
			":ie:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1ea",
			"fully_qualified": "1f1ee-1f1ea",
			"non_fully_qualified": "1f1ee-1f1ea",
			"output": "1f1ee-1f1ea",
			"default_matches": [
				"1f1ee-1f1ea"
			],
			"greedy_matches": [
				"1f1ee-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f2": {
		"name": "Isle of Man",
		"unicode_version": 6,
		"category": "flags",
		"order": 2310,
		"display": 1,
		"shortname": ":flag_im:",
		"shortname_alternates": [
			":im:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f2",
			"fully_qualified": "1f1ee-1f1f2",
			"non_fully_qualified": "1f1ee-1f1f2",
			"output": "1f1ee-1f1f2",
			"default_matches": [
				"1f1ee-1f1f2"
			],
			"greedy_matches": [
				"1f1ee-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f1": {
		"name": "Israel",
		"unicode_version": 6,
		"category": "flags",
		"order": 2311,
		"display": 1,
		"shortname": ":flag_il:",
		"shortname_alternates": [
			":il:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f1",
			"fully_qualified": "1f1ee-1f1f1",
			"non_fully_qualified": "1f1ee-1f1f1",
			"output": "1f1ee-1f1f1",
			"default_matches": [
				"1f1ee-1f1f1"
			],
			"greedy_matches": [
				"1f1ee-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ee-1f1f9": {
		"name": "Italy",
		"unicode_version": 6,
		"category": "flags",
		"order": 2312,
		"display": 1,
		"shortname": ":flag_it:",
		"shortname_alternates": [
			":it:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee-1f1f9",
			"fully_qualified": "1f1ee-1f1f9",
			"non_fully_qualified": "1f1ee-1f1f9",
			"output": "1f1ee-1f1f9",
			"default_matches": [
				"1f1ee-1f1f9"
			],
			"greedy_matches": [
				"1f1ee-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ef-1f1f2": {
		"name": "Jamaica",
		"unicode_version": 6,
		"category": "flags",
		"order": 2313,
		"display": 1,
		"shortname": ":flag_jm:",
		"shortname_alternates": [
			":jm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ef-1f1f2",
			"fully_qualified": "1f1ef-1f1f2",
			"non_fully_qualified": "1f1ef-1f1f2",
			"output": "1f1ef-1f1f2",
			"default_matches": [
				"1f1ef-1f1f2"
			],
			"greedy_matches": [
				"1f1ef-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ef-1f1f5": {
		"name": "Japan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2314,
		"display": 1,
		"shortname": ":flag_jp:",
		"shortname_alternates": [
			":jp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ef-1f1f5",
			"fully_qualified": "1f1ef-1f1f5",
			"non_fully_qualified": "1f1ef-1f1f5",
			"output": "1f1ef-1f1f5",
			"default_matches": [
				"1f1ef-1f1f5"
			],
			"greedy_matches": [
				"1f1ef-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f38c": {
		"name": "crossed flags",
		"unicode_version": 6,
		"category": "flags",
		"order": 2315,
		"display": 1,
		"shortname": ":crossed_flags:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f38c",
			"fully_qualified": "1f38c",
			"non_fully_qualified": "1f38c",
			"output": "1f38c",
			"default_matches": [
				"1f38c"
			],
			"greedy_matches": [
				"1f38c"
			],
			"decimal": ""
		},
		"keywords": [
			"Japanese",
			"celebration",
			"cross",
			"crossed"
		]
	},
	"1f1ef-1f1ea": {
		"name": "Jersey",
		"unicode_version": 6,
		"category": "flags",
		"order": 2316,
		"display": 1,
		"shortname": ":flag_je:",
		"shortname_alternates": [
			":je:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ef-1f1ea",
			"fully_qualified": "1f1ef-1f1ea",
			"non_fully_qualified": "1f1ef-1f1ea",
			"output": "1f1ef-1f1ea",
			"default_matches": [
				"1f1ef-1f1ea"
			],
			"greedy_matches": [
				"1f1ef-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ef-1f1f4": {
		"name": "Jordan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2317,
		"display": 1,
		"shortname": ":flag_jo:",
		"shortname_alternates": [
			":jo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ef-1f1f4",
			"fully_qualified": "1f1ef-1f1f4",
			"non_fully_qualified": "1f1ef-1f1f4",
			"output": "1f1ef-1f1f4",
			"default_matches": [
				"1f1ef-1f1f4"
			],
			"greedy_matches": [
				"1f1ef-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1ff": {
		"name": "Kazakhstan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2318,
		"display": 1,
		"shortname": ":flag_kz:",
		"shortname_alternates": [
			":kz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1ff",
			"fully_qualified": "1f1f0-1f1ff",
			"non_fully_qualified": "1f1f0-1f1ff",
			"output": "1f1f0-1f1ff",
			"default_matches": [
				"1f1f0-1f1ff"
			],
			"greedy_matches": [
				"1f1f0-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1ea": {
		"name": "Kenya",
		"unicode_version": 6,
		"category": "flags",
		"order": 2319,
		"display": 1,
		"shortname": ":flag_ke:",
		"shortname_alternates": [
			":ke:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1ea",
			"fully_qualified": "1f1f0-1f1ea",
			"non_fully_qualified": "1f1f0-1f1ea",
			"output": "1f1f0-1f1ea",
			"default_matches": [
				"1f1f0-1f1ea"
			],
			"greedy_matches": [
				"1f1f0-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1ee": {
		"name": "Kiribati",
		"unicode_version": 6,
		"category": "flags",
		"order": 2320,
		"display": 1,
		"shortname": ":flag_ki:",
		"shortname_alternates": [
			":ki:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1ee",
			"fully_qualified": "1f1f0-1f1ee",
			"non_fully_qualified": "1f1f0-1f1ee",
			"output": "1f1f0-1f1ee",
			"default_matches": [
				"1f1f0-1f1ee"
			],
			"greedy_matches": [
				"1f1f0-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fd-1f1f0": {
		"name": "Kosovo",
		"unicode_version": 6,
		"category": "flags",
		"order": 2321,
		"display": 1,
		"shortname": ":flag_xk:",
		"shortname_alternates": [
			":xk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fd-1f1f0",
			"fully_qualified": "1f1fd-1f1f0",
			"non_fully_qualified": "1f1fd-1f1f0",
			"output": "1f1fd-1f1f0",
			"default_matches": [
				"1f1fd-1f1f0"
			],
			"greedy_matches": [
				"1f1fd-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1fc": {
		"name": "Kuwait",
		"unicode_version": 6,
		"category": "flags",
		"order": 2322,
		"display": 1,
		"shortname": ":flag_kw:",
		"shortname_alternates": [
			":kw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1fc",
			"fully_qualified": "1f1f0-1f1fc",
			"non_fully_qualified": "1f1f0-1f1fc",
			"output": "1f1f0-1f1fc",
			"default_matches": [
				"1f1f0-1f1fc"
			],
			"greedy_matches": [
				"1f1f0-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1ec": {
		"name": "Kyrgyzstan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2323,
		"display": 1,
		"shortname": ":flag_kg:",
		"shortname_alternates": [
			":kg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1ec",
			"fully_qualified": "1f1f0-1f1ec",
			"non_fully_qualified": "1f1f0-1f1ec",
			"output": "1f1f0-1f1ec",
			"default_matches": [
				"1f1f0-1f1ec"
			],
			"greedy_matches": [
				"1f1f0-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1e6": {
		"name": "Laos",
		"unicode_version": 6,
		"category": "flags",
		"order": 2324,
		"display": 1,
		"shortname": ":flag_la:",
		"shortname_alternates": [
			":la:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1e6",
			"fully_qualified": "1f1f1-1f1e6",
			"non_fully_qualified": "1f1f1-1f1e6",
			"output": "1f1f1-1f1e6",
			"default_matches": [
				"1f1f1-1f1e6"
			],
			"greedy_matches": [
				"1f1f1-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1fb": {
		"name": "Latvia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2325,
		"display": 1,
		"shortname": ":flag_lv:",
		"shortname_alternates": [
			":lv:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1fb",
			"fully_qualified": "1f1f1-1f1fb",
			"non_fully_qualified": "1f1f1-1f1fb",
			"output": "1f1f1-1f1fb",
			"default_matches": [
				"1f1f1-1f1fb"
			],
			"greedy_matches": [
				"1f1f1-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1e7": {
		"name": "Lebanon",
		"unicode_version": 6,
		"category": "flags",
		"order": 2326,
		"display": 1,
		"shortname": ":flag_lb:",
		"shortname_alternates": [
			":lb:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1e7",
			"fully_qualified": "1f1f1-1f1e7",
			"non_fully_qualified": "1f1f1-1f1e7",
			"output": "1f1f1-1f1e7",
			"default_matches": [
				"1f1f1-1f1e7"
			],
			"greedy_matches": [
				"1f1f1-1f1e7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1f8": {
		"name": "Lesotho",
		"unicode_version": 6,
		"category": "flags",
		"order": 2327,
		"display": 1,
		"shortname": ":flag_ls:",
		"shortname_alternates": [
			":ls:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1f8",
			"fully_qualified": "1f1f1-1f1f8",
			"non_fully_qualified": "1f1f1-1f1f8",
			"output": "1f1f1-1f1f8",
			"default_matches": [
				"1f1f1-1f1f8"
			],
			"greedy_matches": [
				"1f1f1-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1f7": {
		"name": "Liberia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2328,
		"display": 1,
		"shortname": ":flag_lr:",
		"shortname_alternates": [
			":lr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1f7",
			"fully_qualified": "1f1f1-1f1f7",
			"non_fully_qualified": "1f1f1-1f1f7",
			"output": "1f1f1-1f1f7",
			"default_matches": [
				"1f1f1-1f1f7"
			],
			"greedy_matches": [
				"1f1f1-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1fe": {
		"name": "Libya",
		"unicode_version": 6,
		"category": "flags",
		"order": 2329,
		"display": 1,
		"shortname": ":flag_ly:",
		"shortname_alternates": [
			":ly:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1fe",
			"fully_qualified": "1f1f1-1f1fe",
			"non_fully_qualified": "1f1f1-1f1fe",
			"output": "1f1f1-1f1fe",
			"default_matches": [
				"1f1f1-1f1fe"
			],
			"greedy_matches": [
				"1f1f1-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1ee": {
		"name": "Liechtenstein",
		"unicode_version": 6,
		"category": "flags",
		"order": 2330,
		"display": 1,
		"shortname": ":flag_li:",
		"shortname_alternates": [
			":li:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1ee",
			"fully_qualified": "1f1f1-1f1ee",
			"non_fully_qualified": "1f1f1-1f1ee",
			"output": "1f1f1-1f1ee",
			"default_matches": [
				"1f1f1-1f1ee"
			],
			"greedy_matches": [
				"1f1f1-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1f9": {
		"name": "Lithuania",
		"unicode_version": 6,
		"category": "flags",
		"order": 2331,
		"display": 1,
		"shortname": ":flag_lt:",
		"shortname_alternates": [
			":lt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1f9",
			"fully_qualified": "1f1f1-1f1f9",
			"non_fully_qualified": "1f1f1-1f1f9",
			"output": "1f1f1-1f1f9",
			"default_matches": [
				"1f1f1-1f1f9"
			],
			"greedy_matches": [
				"1f1f1-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1fa": {
		"name": "Luxembourg",
		"unicode_version": 6,
		"category": "flags",
		"order": 2332,
		"display": 1,
		"shortname": ":flag_lu:",
		"shortname_alternates": [
			":lu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1fa",
			"fully_qualified": "1f1f1-1f1fa",
			"non_fully_qualified": "1f1f1-1f1fa",
			"output": "1f1f1-1f1fa",
			"default_matches": [
				"1f1f1-1f1fa"
			],
			"greedy_matches": [
				"1f1f1-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f4": {
		"name": "Macau SAR China",
		"unicode_version": 6,
		"category": "flags",
		"order": 2333,
		"display": 1,
		"shortname": ":flag_mo:",
		"shortname_alternates": [
			":mo:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f4",
			"fully_qualified": "1f1f2-1f1f4",
			"non_fully_qualified": "1f1f2-1f1f4",
			"output": "1f1f2-1f1f4",
			"default_matches": [
				"1f1f2-1f1f4"
			],
			"greedy_matches": [
				"1f1f2-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f0": {
		"name": "Macedonia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2334,
		"display": 1,
		"shortname": ":flag_mk:",
		"shortname_alternates": [
			":mk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f0",
			"fully_qualified": "1f1f2-1f1f0",
			"non_fully_qualified": "1f1f2-1f1f0",
			"output": "1f1f2-1f1f0",
			"default_matches": [
				"1f1f2-1f1f0"
			],
			"greedy_matches": [
				"1f1f2-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1ec": {
		"name": "Madagascar",
		"unicode_version": 6,
		"category": "flags",
		"order": 2335,
		"display": 1,
		"shortname": ":flag_mg:",
		"shortname_alternates": [
			":mg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1ec",
			"fully_qualified": "1f1f2-1f1ec",
			"non_fully_qualified": "1f1f2-1f1ec",
			"output": "1f1f2-1f1ec",
			"default_matches": [
				"1f1f2-1f1ec"
			],
			"greedy_matches": [
				"1f1f2-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1fc": {
		"name": "Malawi",
		"unicode_version": 6,
		"category": "flags",
		"order": 2336,
		"display": 1,
		"shortname": ":flag_mw:",
		"shortname_alternates": [
			":mw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1fc",
			"fully_qualified": "1f1f2-1f1fc",
			"non_fully_qualified": "1f1f2-1f1fc",
			"output": "1f1f2-1f1fc",
			"default_matches": [
				"1f1f2-1f1fc"
			],
			"greedy_matches": [
				"1f1f2-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1fe": {
		"name": "Malaysia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2337,
		"display": 1,
		"shortname": ":flag_my:",
		"shortname_alternates": [
			":my:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1fe",
			"fully_qualified": "1f1f2-1f1fe",
			"non_fully_qualified": "1f1f2-1f1fe",
			"output": "1f1f2-1f1fe",
			"default_matches": [
				"1f1f2-1f1fe"
			],
			"greedy_matches": [
				"1f1f2-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1fb": {
		"name": "Maldives",
		"unicode_version": 6,
		"category": "flags",
		"order": 2338,
		"display": 1,
		"shortname": ":flag_mv:",
		"shortname_alternates": [
			":mv:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1fb",
			"fully_qualified": "1f1f2-1f1fb",
			"non_fully_qualified": "1f1f2-1f1fb",
			"output": "1f1f2-1f1fb",
			"default_matches": [
				"1f1f2-1f1fb"
			],
			"greedy_matches": [
				"1f1f2-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f1": {
		"name": "Mali",
		"unicode_version": 6,
		"category": "flags",
		"order": 2339,
		"display": 1,
		"shortname": ":flag_ml:",
		"shortname_alternates": [
			":ml:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f1",
			"fully_qualified": "1f1f2-1f1f1",
			"non_fully_qualified": "1f1f2-1f1f1",
			"output": "1f1f2-1f1f1",
			"default_matches": [
				"1f1f2-1f1f1"
			],
			"greedy_matches": [
				"1f1f2-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f9": {
		"name": "Malta",
		"unicode_version": 6,
		"category": "flags",
		"order": 2340,
		"display": 1,
		"shortname": ":flag_mt:",
		"shortname_alternates": [
			":mt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f9",
			"fully_qualified": "1f1f2-1f1f9",
			"non_fully_qualified": "1f1f2-1f1f9",
			"output": "1f1f2-1f1f9",
			"default_matches": [
				"1f1f2-1f1f9"
			],
			"greedy_matches": [
				"1f1f2-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1ed": {
		"name": "Marshall Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2341,
		"display": 1,
		"shortname": ":flag_mh:",
		"shortname_alternates": [
			":mh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1ed",
			"fully_qualified": "1f1f2-1f1ed",
			"non_fully_qualified": "1f1f2-1f1ed",
			"output": "1f1f2-1f1ed",
			"default_matches": [
				"1f1f2-1f1ed"
			],
			"greedy_matches": [
				"1f1f2-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f6": {
		"name": "Martinique",
		"unicode_version": 6,
		"category": "flags",
		"order": 2342,
		"display": 1,
		"shortname": ":flag_mq:",
		"shortname_alternates": [
			":mq:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f6",
			"fully_qualified": "1f1f2-1f1f6",
			"non_fully_qualified": "1f1f2-1f1f6",
			"output": "1f1f2-1f1f6",
			"default_matches": [
				"1f1f2-1f1f6"
			],
			"greedy_matches": [
				"1f1f2-1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f7": {
		"name": "Mauritania",
		"unicode_version": 6,
		"category": "flags",
		"order": 2343,
		"display": 1,
		"shortname": ":flag_mr:",
		"shortname_alternates": [
			":mr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f7",
			"fully_qualified": "1f1f2-1f1f7",
			"non_fully_qualified": "1f1f2-1f1f7",
			"output": "1f1f2-1f1f7",
			"default_matches": [
				"1f1f2-1f1f7"
			],
			"greedy_matches": [
				"1f1f2-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1fa": {
		"name": "Mauritius",
		"unicode_version": 6,
		"category": "flags",
		"order": 2344,
		"display": 1,
		"shortname": ":flag_mu:",
		"shortname_alternates": [
			":mu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1fa",
			"fully_qualified": "1f1f2-1f1fa",
			"non_fully_qualified": "1f1f2-1f1fa",
			"output": "1f1f2-1f1fa",
			"default_matches": [
				"1f1f2-1f1fa"
			],
			"greedy_matches": [
				"1f1f2-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fe-1f1f9": {
		"name": "Mayotte",
		"unicode_version": 6,
		"category": "flags",
		"order": 2345,
		"display": 1,
		"shortname": ":flag_yt:",
		"shortname_alternates": [
			":yt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fe-1f1f9",
			"fully_qualified": "1f1fe-1f1f9",
			"non_fully_qualified": "1f1fe-1f1f9",
			"output": "1f1fe-1f1f9",
			"default_matches": [
				"1f1fe-1f1f9"
			],
			"greedy_matches": [
				"1f1fe-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1fd": {
		"name": "Mexico",
		"unicode_version": 6,
		"category": "flags",
		"order": 2346,
		"display": 1,
		"shortname": ":flag_mx:",
		"shortname_alternates": [
			":mx:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1fd",
			"fully_qualified": "1f1f2-1f1fd",
			"non_fully_qualified": "1f1f2-1f1fd",
			"output": "1f1f2-1f1fd",
			"default_matches": [
				"1f1f2-1f1fd"
			],
			"greedy_matches": [
				"1f1f2-1f1fd"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1eb-1f1f2": {
		"name": "Micronesia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2347,
		"display": 1,
		"shortname": ":flag_fm:",
		"shortname_alternates": [
			":fm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb-1f1f2",
			"fully_qualified": "1f1eb-1f1f2",
			"non_fully_qualified": "1f1eb-1f1f2",
			"output": "1f1eb-1f1f2",
			"default_matches": [
				"1f1eb-1f1f2"
			],
			"greedy_matches": [
				"1f1eb-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1e9": {
		"name": "Moldova",
		"unicode_version": 6,
		"category": "flags",
		"order": 2348,
		"display": 1,
		"shortname": ":flag_md:",
		"shortname_alternates": [
			":md:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1e9",
			"fully_qualified": "1f1f2-1f1e9",
			"non_fully_qualified": "1f1f2-1f1e9",
			"output": "1f1f2-1f1e9",
			"default_matches": [
				"1f1f2-1f1e9"
			],
			"greedy_matches": [
				"1f1f2-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1e8": {
		"name": "Monaco",
		"unicode_version": 6,
		"category": "flags",
		"order": 2349,
		"display": 1,
		"shortname": ":flag_mc:",
		"shortname_alternates": [
			":mc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1e8",
			"fully_qualified": "1f1f2-1f1e8",
			"non_fully_qualified": "1f1f2-1f1e8",
			"output": "1f1f2-1f1e8",
			"default_matches": [
				"1f1f2-1f1e8"
			],
			"greedy_matches": [
				"1f1f2-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f3": {
		"name": "Mongolia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2350,
		"display": 1,
		"shortname": ":flag_mn:",
		"shortname_alternates": [
			":mn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f3",
			"fully_qualified": "1f1f2-1f1f3",
			"non_fully_qualified": "1f1f2-1f1f3",
			"output": "1f1f2-1f1f3",
			"default_matches": [
				"1f1f2-1f1f3"
			],
			"greedy_matches": [
				"1f1f2-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1ea": {
		"name": "Montenegro",
		"unicode_version": 6,
		"category": "flags",
		"order": 2351,
		"display": 1,
		"shortname": ":flag_me:",
		"shortname_alternates": [
			":me:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1ea",
			"fully_qualified": "1f1f2-1f1ea",
			"non_fully_qualified": "1f1f2-1f1ea",
			"output": "1f1f2-1f1ea",
			"default_matches": [
				"1f1f2-1f1ea"
			],
			"greedy_matches": [
				"1f1f2-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f8": {
		"name": "Montserrat",
		"unicode_version": 6,
		"category": "flags",
		"order": 2352,
		"display": 1,
		"shortname": ":flag_ms:",
		"shortname_alternates": [
			":ms:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f8",
			"fully_qualified": "1f1f2-1f1f8",
			"non_fully_qualified": "1f1f2-1f1f8",
			"output": "1f1f2-1f1f8",
			"default_matches": [
				"1f1f2-1f1f8"
			],
			"greedy_matches": [
				"1f1f2-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1e6": {
		"name": "Morocco",
		"unicode_version": 6,
		"category": "flags",
		"order": 2353,
		"display": 1,
		"shortname": ":flag_ma:",
		"shortname_alternates": [
			":ma:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1e6",
			"fully_qualified": "1f1f2-1f1e6",
			"non_fully_qualified": "1f1f2-1f1e6",
			"output": "1f1f2-1f1e6",
			"default_matches": [
				"1f1f2-1f1e6"
			],
			"greedy_matches": [
				"1f1f2-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1ff": {
		"name": "Mozambique",
		"unicode_version": 6,
		"category": "flags",
		"order": 2354,
		"display": 1,
		"shortname": ":flag_mz:",
		"shortname_alternates": [
			":mz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1ff",
			"fully_qualified": "1f1f2-1f1ff",
			"non_fully_qualified": "1f1f2-1f1ff",
			"output": "1f1f2-1f1ff",
			"default_matches": [
				"1f1f2-1f1ff"
			],
			"greedy_matches": [
				"1f1f2-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f2": {
		"name": "Myanmar (Burma)",
		"unicode_version": 6,
		"category": "flags",
		"order": 2355,
		"display": 1,
		"shortname": ":flag_mm:",
		"shortname_alternates": [
			":mm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f2",
			"fully_qualified": "1f1f2-1f1f2",
			"non_fully_qualified": "1f1f2-1f1f2",
			"output": "1f1f2-1f1f2",
			"default_matches": [
				"1f1f2-1f1f2"
			],
			"greedy_matches": [
				"1f1f2-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1e6": {
		"name": "Namibia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2356,
		"display": 1,
		"shortname": ":flag_na:",
		"shortname_alternates": [
			":na:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1e6",
			"fully_qualified": "1f1f3-1f1e6",
			"non_fully_qualified": "1f1f3-1f1e6",
			"output": "1f1f3-1f1e6",
			"default_matches": [
				"1f1f3-1f1e6"
			],
			"greedy_matches": [
				"1f1f3-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1f7": {
		"name": "Nauru",
		"unicode_version": 6,
		"category": "flags",
		"order": 2357,
		"display": 1,
		"shortname": ":flag_nr:",
		"shortname_alternates": [
			":nr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1f7",
			"fully_qualified": "1f1f3-1f1f7",
			"non_fully_qualified": "1f1f3-1f1f7",
			"output": "1f1f3-1f1f7",
			"default_matches": [
				"1f1f3-1f1f7"
			],
			"greedy_matches": [
				"1f1f3-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1f5": {
		"name": "Nepal",
		"unicode_version": 6,
		"category": "flags",
		"order": 2358,
		"display": 1,
		"shortname": ":flag_np:",
		"shortname_alternates": [
			":np:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1f5",
			"fully_qualified": "1f1f3-1f1f5",
			"non_fully_qualified": "1f1f3-1f1f5",
			"output": "1f1f3-1f1f5",
			"default_matches": [
				"1f1f3-1f1f5"
			],
			"greedy_matches": [
				"1f1f3-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1f1": {
		"name": "Netherlands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2359,
		"display": 1,
		"shortname": ":flag_nl:",
		"shortname_alternates": [
			":nl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1f1",
			"fully_qualified": "1f1f3-1f1f1",
			"non_fully_qualified": "1f1f3-1f1f1",
			"output": "1f1f3-1f1f1",
			"default_matches": [
				"1f1f3-1f1f1"
			],
			"greedy_matches": [
				"1f1f3-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1e8": {
		"name": "New Caledonia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2360,
		"display": 1,
		"shortname": ":flag_nc:",
		"shortname_alternates": [
			":nc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1e8",
			"fully_qualified": "1f1f3-1f1e8",
			"non_fully_qualified": "1f1f3-1f1e8",
			"output": "1f1f3-1f1e8",
			"default_matches": [
				"1f1f3-1f1e8"
			],
			"greedy_matches": [
				"1f1f3-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1ff": {
		"name": "New Zealand",
		"unicode_version": 6,
		"category": "flags",
		"order": 2361,
		"display": 1,
		"shortname": ":flag_nz:",
		"shortname_alternates": [
			":nz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1ff",
			"fully_qualified": "1f1f3-1f1ff",
			"non_fully_qualified": "1f1f3-1f1ff",
			"output": "1f1f3-1f1ff",
			"default_matches": [
				"1f1f3-1f1ff"
			],
			"greedy_matches": [
				"1f1f3-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1ee": {
		"name": "Nicaragua",
		"unicode_version": 6,
		"category": "flags",
		"order": 2362,
		"display": 1,
		"shortname": ":flag_ni:",
		"shortname_alternates": [
			":ni:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1ee",
			"fully_qualified": "1f1f3-1f1ee",
			"non_fully_qualified": "1f1f3-1f1ee",
			"output": "1f1f3-1f1ee",
			"default_matches": [
				"1f1f3-1f1ee"
			],
			"greedy_matches": [
				"1f1f3-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1ea": {
		"name": "Niger",
		"unicode_version": 6,
		"category": "flags",
		"order": 2363,
		"display": 1,
		"shortname": ":flag_ne:",
		"shortname_alternates": [
			":ne:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1ea",
			"fully_qualified": "1f1f3-1f1ea",
			"non_fully_qualified": "1f1f3-1f1ea",
			"output": "1f1f3-1f1ea",
			"default_matches": [
				"1f1f3-1f1ea"
			],
			"greedy_matches": [
				"1f1f3-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1ec": {
		"name": "Nigeria",
		"unicode_version": 6,
		"category": "flags",
		"order": 2364,
		"display": 1,
		"shortname": ":flag_ng:",
		"shortname_alternates": [
			":nigeria:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1ec",
			"fully_qualified": "1f1f3-1f1ec",
			"non_fully_qualified": "1f1f3-1f1ec",
			"output": "1f1f3-1f1ec",
			"default_matches": [
				"1f1f3-1f1ec"
			],
			"greedy_matches": [
				"1f1f3-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1fa": {
		"name": "Niue",
		"unicode_version": 6,
		"category": "flags",
		"order": 2365,
		"display": 1,
		"shortname": ":flag_nu:",
		"shortname_alternates": [
			":nu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1fa",
			"fully_qualified": "1f1f3-1f1fa",
			"non_fully_qualified": "1f1f3-1f1fa",
			"output": "1f1f3-1f1fa",
			"default_matches": [
				"1f1f3-1f1fa"
			],
			"greedy_matches": [
				"1f1f3-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1eb": {
		"name": "Norfolk Island",
		"unicode_version": 6,
		"category": "flags",
		"order": 2366,
		"display": 1,
		"shortname": ":flag_nf:",
		"shortname_alternates": [
			":nf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1eb",
			"fully_qualified": "1f1f3-1f1eb",
			"non_fully_qualified": "1f1f3-1f1eb",
			"output": "1f1f3-1f1eb",
			"default_matches": [
				"1f1f3-1f1eb"
			],
			"greedy_matches": [
				"1f1f3-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1f5": {
		"name": "North Korea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2367,
		"display": 1,
		"shortname": ":flag_kp:",
		"shortname_alternates": [
			":kp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1f5",
			"fully_qualified": "1f1f0-1f1f5",
			"non_fully_qualified": "1f1f0-1f1f5",
			"output": "1f1f0-1f1f5",
			"default_matches": [
				"1f1f0-1f1f5"
			],
			"greedy_matches": [
				"1f1f0-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1f5": {
		"name": "Northern Mariana Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2368,
		"display": 1,
		"shortname": ":flag_mp:",
		"shortname_alternates": [
			":mp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1f5",
			"fully_qualified": "1f1f2-1f1f5",
			"non_fully_qualified": "1f1f2-1f1f5",
			"output": "1f1f2-1f1f5",
			"default_matches": [
				"1f1f2-1f1f5"
			],
			"greedy_matches": [
				"1f1f2-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f3-1f1f4": {
		"name": "Norway",
		"unicode_version": 6,
		"category": "flags",
		"order": 2369,
		"display": 1,
		"shortname": ":flag_no:",
		"shortname_alternates": [
			":no:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3-1f1f4",
			"fully_qualified": "1f1f3-1f1f4",
			"non_fully_qualified": "1f1f3-1f1f4",
			"output": "1f1f3-1f1f4",
			"default_matches": [
				"1f1f3-1f1f4"
			],
			"greedy_matches": [
				"1f1f3-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f4-1f1f2": {
		"name": "Oman",
		"unicode_version": 6,
		"category": "flags",
		"order": 2370,
		"display": 1,
		"shortname": ":flag_om:",
		"shortname_alternates": [
			":om:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f4-1f1f2",
			"fully_qualified": "1f1f4-1f1f2",
			"non_fully_qualified": "1f1f4-1f1f2",
			"output": "1f1f4-1f1f2",
			"default_matches": [
				"1f1f4-1f1f2"
			],
			"greedy_matches": [
				"1f1f4-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f0": {
		"name": "Pakistan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2371,
		"display": 1,
		"shortname": ":flag_pk:",
		"shortname_alternates": [
			":pk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f0",
			"fully_qualified": "1f1f5-1f1f0",
			"non_fully_qualified": "1f1f5-1f1f0",
			"output": "1f1f5-1f1f0",
			"default_matches": [
				"1f1f5-1f1f0"
			],
			"greedy_matches": [
				"1f1f5-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1fc": {
		"name": "Palau",
		"unicode_version": 6,
		"category": "flags",
		"order": 2372,
		"display": 1,
		"shortname": ":flag_pw:",
		"shortname_alternates": [
			":pw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1fc",
			"fully_qualified": "1f1f5-1f1fc",
			"non_fully_qualified": "1f1f5-1f1fc",
			"output": "1f1f5-1f1fc",
			"default_matches": [
				"1f1f5-1f1fc"
			],
			"greedy_matches": [
				"1f1f5-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f8": {
		"name": "Palestinian Territories",
		"unicode_version": 6,
		"category": "flags",
		"order": 2373,
		"display": 1,
		"shortname": ":flag_ps:",
		"shortname_alternates": [
			":ps:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f8",
			"fully_qualified": "1f1f5-1f1f8",
			"non_fully_qualified": "1f1f5-1f1f8",
			"output": "1f1f5-1f1f8",
			"default_matches": [
				"1f1f5-1f1f8"
			],
			"greedy_matches": [
				"1f1f5-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1e6": {
		"name": "Panama",
		"unicode_version": 6,
		"category": "flags",
		"order": 2374,
		"display": 1,
		"shortname": ":flag_pa:",
		"shortname_alternates": [
			":pa:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1e6",
			"fully_qualified": "1f1f5-1f1e6",
			"non_fully_qualified": "1f1f5-1f1e6",
			"output": "1f1f5-1f1e6",
			"default_matches": [
				"1f1f5-1f1e6"
			],
			"greedy_matches": [
				"1f1f5-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1ec": {
		"name": "Papua New Guinea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2375,
		"display": 1,
		"shortname": ":flag_pg:",
		"shortname_alternates": [
			":pg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1ec",
			"fully_qualified": "1f1f5-1f1ec",
			"non_fully_qualified": "1f1f5-1f1ec",
			"output": "1f1f5-1f1ec",
			"default_matches": [
				"1f1f5-1f1ec"
			],
			"greedy_matches": [
				"1f1f5-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1fe": {
		"name": "Paraguay",
		"unicode_version": 6,
		"category": "flags",
		"order": 2376,
		"display": 1,
		"shortname": ":flag_py:",
		"shortname_alternates": [
			":py:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1fe",
			"fully_qualified": "1f1f5-1f1fe",
			"non_fully_qualified": "1f1f5-1f1fe",
			"output": "1f1f5-1f1fe",
			"default_matches": [
				"1f1f5-1f1fe"
			],
			"greedy_matches": [
				"1f1f5-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1ea": {
		"name": "Peru",
		"unicode_version": 6,
		"category": "flags",
		"order": 2377,
		"display": 1,
		"shortname": ":flag_pe:",
		"shortname_alternates": [
			":pe:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1ea",
			"fully_qualified": "1f1f5-1f1ea",
			"non_fully_qualified": "1f1f5-1f1ea",
			"output": "1f1f5-1f1ea",
			"default_matches": [
				"1f1f5-1f1ea"
			],
			"greedy_matches": [
				"1f1f5-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1ed": {
		"name": "Philippines",
		"unicode_version": 6,
		"category": "flags",
		"order": 2378,
		"display": 1,
		"shortname": ":flag_ph:",
		"shortname_alternates": [
			":ph:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1ed",
			"fully_qualified": "1f1f5-1f1ed",
			"non_fully_qualified": "1f1f5-1f1ed",
			"output": "1f1f5-1f1ed",
			"default_matches": [
				"1f1f5-1f1ed"
			],
			"greedy_matches": [
				"1f1f5-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f3": {
		"name": "Pitcairn Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2379,
		"display": 1,
		"shortname": ":flag_pn:",
		"shortname_alternates": [
			":pn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f3",
			"fully_qualified": "1f1f5-1f1f3",
			"non_fully_qualified": "1f1f5-1f1f3",
			"output": "1f1f5-1f1f3",
			"default_matches": [
				"1f1f5-1f1f3"
			],
			"greedy_matches": [
				"1f1f5-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f1": {
		"name": "Poland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2380,
		"display": 1,
		"shortname": ":flag_pl:",
		"shortname_alternates": [
			":pl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f1",
			"fully_qualified": "1f1f5-1f1f1",
			"non_fully_qualified": "1f1f5-1f1f1",
			"output": "1f1f5-1f1f1",
			"default_matches": [
				"1f1f5-1f1f1"
			],
			"greedy_matches": [
				"1f1f5-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f9": {
		"name": "Portugal",
		"unicode_version": 6,
		"category": "flags",
		"order": 2381,
		"display": 1,
		"shortname": ":flag_pt:",
		"shortname_alternates": [
			":pt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f9",
			"fully_qualified": "1f1f5-1f1f9",
			"non_fully_qualified": "1f1f5-1f1f9",
			"output": "1f1f5-1f1f9",
			"default_matches": [
				"1f1f5-1f1f9"
			],
			"greedy_matches": [
				"1f1f5-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f7": {
		"name": "Puerto Rico",
		"unicode_version": 6,
		"category": "flags",
		"order": 2382,
		"display": 1,
		"shortname": ":flag_pr:",
		"shortname_alternates": [
			":pr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f7",
			"fully_qualified": "1f1f5-1f1f7",
			"non_fully_qualified": "1f1f5-1f1f7",
			"output": "1f1f5-1f1f7",
			"default_matches": [
				"1f1f5-1f1f7"
			],
			"greedy_matches": [
				"1f1f5-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f6-1f1e6": {
		"name": "Qatar",
		"unicode_version": 6,
		"category": "flags",
		"order": 2383,
		"display": 1,
		"shortname": ":flag_qa:",
		"shortname_alternates": [
			":qa:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f6-1f1e6",
			"fully_qualified": "1f1f6-1f1e6",
			"non_fully_qualified": "1f1f6-1f1e6",
			"output": "1f1f6-1f1e6",
			"default_matches": [
				"1f1f6-1f1e6"
			],
			"greedy_matches": [
				"1f1f6-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f7-1f1ea": {
		"name": "Réunion",
		"unicode_version": 6,
		"category": "flags",
		"order": 2384,
		"display": 1,
		"shortname": ":flag_re:",
		"shortname_alternates": [
			":re:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7-1f1ea",
			"fully_qualified": "1f1f7-1f1ea",
			"non_fully_qualified": "1f1f7-1f1ea",
			"output": "1f1f7-1f1ea",
			"default_matches": [
				"1f1f7-1f1ea"
			],
			"greedy_matches": [
				"1f1f7-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f7-1f1f4": {
		"name": "Romania",
		"unicode_version": 6,
		"category": "flags",
		"order": 2385,
		"display": 1,
		"shortname": ":flag_ro:",
		"shortname_alternates": [
			":ro:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7-1f1f4",
			"fully_qualified": "1f1f7-1f1f4",
			"non_fully_qualified": "1f1f7-1f1f4",
			"output": "1f1f7-1f1f4",
			"default_matches": [
				"1f1f7-1f1f4"
			],
			"greedy_matches": [
				"1f1f7-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f7-1f1fa": {
		"name": "Russia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2386,
		"display": 1,
		"shortname": ":flag_ru:",
		"shortname_alternates": [
			":ru:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7-1f1fa",
			"fully_qualified": "1f1f7-1f1fa",
			"non_fully_qualified": "1f1f7-1f1fa",
			"output": "1f1f7-1f1fa",
			"default_matches": [
				"1f1f7-1f1fa"
			],
			"greedy_matches": [
				"1f1f7-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f7-1f1fc": {
		"name": "Rwanda",
		"unicode_version": 6,
		"category": "flags",
		"order": 2387,
		"display": 1,
		"shortname": ":flag_rw:",
		"shortname_alternates": [
			":rw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7-1f1fc",
			"fully_qualified": "1f1f7-1f1fc",
			"non_fully_qualified": "1f1f7-1f1fc",
			"output": "1f1f7-1f1fc",
			"default_matches": [
				"1f1f7-1f1fc"
			],
			"greedy_matches": [
				"1f1f7-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fc-1f1f8": {
		"name": "Samoa",
		"unicode_version": 6,
		"category": "flags",
		"order": 2388,
		"display": 1,
		"shortname": ":flag_ws:",
		"shortname_alternates": [
			":ws:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fc-1f1f8",
			"fully_qualified": "1f1fc-1f1f8",
			"non_fully_qualified": "1f1fc-1f1f8",
			"output": "1f1fc-1f1f8",
			"default_matches": [
				"1f1fc-1f1f8"
			],
			"greedy_matches": [
				"1f1fc-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f2": {
		"name": "San Marino",
		"unicode_version": 6,
		"category": "flags",
		"order": 2389,
		"display": 1,
		"shortname": ":flag_sm:",
		"shortname_alternates": [
			":sm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f2",
			"fully_qualified": "1f1f8-1f1f2",
			"non_fully_qualified": "1f1f8-1f1f2",
			"output": "1f1f8-1f1f2",
			"default_matches": [
				"1f1f8-1f1f2"
			],
			"greedy_matches": [
				"1f1f8-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f9": {
		"name": "São Tomé & Príncipe",
		"unicode_version": 6,
		"category": "flags",
		"order": 2390,
		"display": 1,
		"shortname": ":flag_st:",
		"shortname_alternates": [
			":st:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f9",
			"fully_qualified": "1f1f8-1f1f9",
			"non_fully_qualified": "1f1f8-1f1f9",
			"output": "1f1f8-1f1f9",
			"default_matches": [
				"1f1f8-1f1f9"
			],
			"greedy_matches": [
				"1f1f8-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1e6": {
		"name": "Saudi Arabia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2391,
		"display": 1,
		"shortname": ":flag_sa:",
		"shortname_alternates": [
			":saudiarabia:",
			":saudi:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1e6",
			"fully_qualified": "1f1f8-1f1e6",
			"non_fully_qualified": "1f1f8-1f1e6",
			"output": "1f1f8-1f1e6",
			"default_matches": [
				"1f1f8-1f1e6"
			],
			"greedy_matches": [
				"1f1f8-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f3": {
		"name": "Senegal",
		"unicode_version": 6,
		"category": "flags",
		"order": 2392,
		"display": 1,
		"shortname": ":flag_sn:",
		"shortname_alternates": [
			":sn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f3",
			"fully_qualified": "1f1f8-1f1f3",
			"non_fully_qualified": "1f1f8-1f1f3",
			"output": "1f1f8-1f1f3",
			"default_matches": [
				"1f1f8-1f1f3"
			],
			"greedy_matches": [
				"1f1f8-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f7-1f1f8": {
		"name": "Serbia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2393,
		"display": 1,
		"shortname": ":flag_rs:",
		"shortname_alternates": [
			":rs:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7-1f1f8",
			"fully_qualified": "1f1f7-1f1f8",
			"non_fully_qualified": "1f1f7-1f1f8",
			"output": "1f1f7-1f1f8",
			"default_matches": [
				"1f1f7-1f1f8"
			],
			"greedy_matches": [
				"1f1f7-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1e8": {
		"name": "Seychelles",
		"unicode_version": 6,
		"category": "flags",
		"order": 2394,
		"display": 1,
		"shortname": ":flag_sc:",
		"shortname_alternates": [
			":sc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1e8",
			"fully_qualified": "1f1f8-1f1e8",
			"non_fully_qualified": "1f1f8-1f1e8",
			"output": "1f1f8-1f1e8",
			"default_matches": [
				"1f1f8-1f1e8"
			],
			"greedy_matches": [
				"1f1f8-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f1": {
		"name": "Sierra Leone",
		"unicode_version": 6,
		"category": "flags",
		"order": 2395,
		"display": 1,
		"shortname": ":flag_sl:",
		"shortname_alternates": [
			":sl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f1",
			"fully_qualified": "1f1f8-1f1f1",
			"non_fully_qualified": "1f1f8-1f1f1",
			"output": "1f1f8-1f1f1",
			"default_matches": [
				"1f1f8-1f1f1"
			],
			"greedy_matches": [
				"1f1f8-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ec": {
		"name": "Singapore",
		"unicode_version": 6,
		"category": "flags",
		"order": 2396,
		"display": 1,
		"shortname": ":flag_sg:",
		"shortname_alternates": [
			":sg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ec",
			"fully_qualified": "1f1f8-1f1ec",
			"non_fully_qualified": "1f1f8-1f1ec",
			"output": "1f1f8-1f1ec",
			"default_matches": [
				"1f1f8-1f1ec"
			],
			"greedy_matches": [
				"1f1f8-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1fd": {
		"name": "Sint Maarten",
		"unicode_version": 6,
		"category": "flags",
		"order": 2397,
		"display": 1,
		"shortname": ":flag_sx:",
		"shortname_alternates": [
			":sx:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1fd",
			"fully_qualified": "1f1f8-1f1fd",
			"non_fully_qualified": "1f1f8-1f1fd",
			"output": "1f1f8-1f1fd",
			"default_matches": [
				"1f1f8-1f1fd"
			],
			"greedy_matches": [
				"1f1f8-1f1fd"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f0": {
		"name": "Slovakia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2398,
		"display": 1,
		"shortname": ":flag_sk:",
		"shortname_alternates": [
			":sk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f0",
			"fully_qualified": "1f1f8-1f1f0",
			"non_fully_qualified": "1f1f8-1f1f0",
			"output": "1f1f8-1f1f0",
			"default_matches": [
				"1f1f8-1f1f0"
			],
			"greedy_matches": [
				"1f1f8-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ee": {
		"name": "Slovenia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2399,
		"display": 1,
		"shortname": ":flag_si:",
		"shortname_alternates": [
			":si:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ee",
			"fully_qualified": "1f1f8-1f1ee",
			"non_fully_qualified": "1f1f8-1f1ee",
			"output": "1f1f8-1f1ee",
			"default_matches": [
				"1f1f8-1f1ee"
			],
			"greedy_matches": [
				"1f1f8-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1f8": {
		"name": "South Georgia & South Sandwich Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2400,
		"display": 1,
		"shortname": ":flag_gs:",
		"shortname_alternates": [
			":gs:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1f8",
			"fully_qualified": "1f1ec-1f1f8",
			"non_fully_qualified": "1f1ec-1f1f8",
			"output": "1f1ec-1f1f8",
			"default_matches": [
				"1f1ec-1f1f8"
			],
			"greedy_matches": [
				"1f1ec-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1e7": {
		"name": "Solomon Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2401,
		"display": 1,
		"shortname": ":flag_sb:",
		"shortname_alternates": [
			":sb:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1e7",
			"fully_qualified": "1f1f8-1f1e7",
			"non_fully_qualified": "1f1f8-1f1e7",
			"output": "1f1f8-1f1e7",
			"default_matches": [
				"1f1f8-1f1e7"
			],
			"greedy_matches": [
				"1f1f8-1f1e7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f4": {
		"name": "Somalia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2402,
		"display": 1,
		"shortname": ":flag_so:",
		"shortname_alternates": [
			":so:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f4",
			"fully_qualified": "1f1f8-1f1f4",
			"non_fully_qualified": "1f1f8-1f1f4",
			"output": "1f1f8-1f1f4",
			"default_matches": [
				"1f1f8-1f1f4"
			],
			"greedy_matches": [
				"1f1f8-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ff-1f1e6": {
		"name": "South Africa",
		"unicode_version": 6,
		"category": "flags",
		"order": 2403,
		"display": 1,
		"shortname": ":flag_za:",
		"shortname_alternates": [
			":za:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ff-1f1e6",
			"fully_qualified": "1f1ff-1f1e6",
			"non_fully_qualified": "1f1ff-1f1e6",
			"output": "1f1ff-1f1e6",
			"default_matches": [
				"1f1ff-1f1e6"
			],
			"greedy_matches": [
				"1f1ff-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1f7": {
		"name": "South Korea",
		"unicode_version": 6,
		"category": "flags",
		"order": 2404,
		"display": 1,
		"shortname": ":flag_kr:",
		"shortname_alternates": [
			":kr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1f7",
			"fully_qualified": "1f1f0-1f1f7",
			"non_fully_qualified": "1f1f0-1f1f7",
			"output": "1f1f0-1f1f7",
			"default_matches": [
				"1f1f0-1f1f7"
			],
			"greedy_matches": [
				"1f1f0-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f8": {
		"name": "South Sudan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2405,
		"display": 1,
		"shortname": ":flag_ss:",
		"shortname_alternates": [
			":ss:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f8",
			"fully_qualified": "1f1f8-1f1f8",
			"non_fully_qualified": "1f1f8-1f1f8",
			"output": "1f1f8-1f1f8",
			"default_matches": [
				"1f1f8-1f1f8"
			],
			"greedy_matches": [
				"1f1f8-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1f8": {
		"name": "Spain",
		"unicode_version": 6,
		"category": "flags",
		"order": 2406,
		"display": 1,
		"shortname": ":flag_es:",
		"shortname_alternates": [
			":es:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1f8",
			"fully_qualified": "1f1ea-1f1f8",
			"non_fully_qualified": "1f1ea-1f1f8",
			"output": "1f1ea-1f1f8",
			"default_matches": [
				"1f1ea-1f1f8"
			],
			"greedy_matches": [
				"1f1ea-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1f0": {
		"name": "Sri Lanka",
		"unicode_version": 6,
		"category": "flags",
		"order": 2407,
		"display": 1,
		"shortname": ":flag_lk:",
		"shortname_alternates": [
			":lk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1f0",
			"fully_qualified": "1f1f1-1f1f0",
			"non_fully_qualified": "1f1f1-1f1f0",
			"output": "1f1f1-1f1f0",
			"default_matches": [
				"1f1f1-1f1f0"
			],
			"greedy_matches": [
				"1f1f1-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1f1": {
		"name": "St. Barthélemy",
		"unicode_version": 6,
		"category": "flags",
		"order": 2408,
		"display": 1,
		"shortname": ":flag_bl:",
		"shortname_alternates": [
			":bl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1f1",
			"fully_qualified": "1f1e7-1f1f1",
			"non_fully_qualified": "1f1e7-1f1f1",
			"output": "1f1e7-1f1f1",
			"default_matches": [
				"1f1e7-1f1f1"
			],
			"greedy_matches": [
				"1f1e7-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ed": {
		"name": "St. Helena",
		"unicode_version": 6,
		"category": "flags",
		"order": 2409,
		"display": 1,
		"shortname": ":flag_sh:",
		"shortname_alternates": [
			":sh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ed",
			"fully_qualified": "1f1f8-1f1ed",
			"non_fully_qualified": "1f1f8-1f1ed",
			"output": "1f1f8-1f1ed",
			"default_matches": [
				"1f1f8-1f1ed"
			],
			"greedy_matches": [
				"1f1f8-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f0-1f1f3": {
		"name": "St. Kitts & Nevis",
		"unicode_version": 6,
		"category": "flags",
		"order": 2410,
		"display": 1,
		"shortname": ":flag_kn:",
		"shortname_alternates": [
			":kn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0-1f1f3",
			"fully_qualified": "1f1f0-1f1f3",
			"non_fully_qualified": "1f1f0-1f1f3",
			"output": "1f1f0-1f1f3",
			"default_matches": [
				"1f1f0-1f1f3"
			],
			"greedy_matches": [
				"1f1f0-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f1-1f1e8": {
		"name": "St. Lucia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2411,
		"display": 1,
		"shortname": ":flag_lc:",
		"shortname_alternates": [
			":lc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1-1f1e8",
			"fully_qualified": "1f1f1-1f1e8",
			"non_fully_qualified": "1f1f1-1f1e8",
			"output": "1f1f1-1f1e8",
			"default_matches": [
				"1f1f1-1f1e8"
			],
			"greedy_matches": [
				"1f1f1-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f5-1f1f2": {
		"name": "St. Pierre & Miquelon",
		"unicode_version": 6,
		"category": "flags",
		"order": 2412,
		"display": 1,
		"shortname": ":flag_pm:",
		"shortname_alternates": [
			":pm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5-1f1f2",
			"fully_qualified": "1f1f5-1f1f2",
			"non_fully_qualified": "1f1f5-1f1f2",
			"output": "1f1f5-1f1f2",
			"default_matches": [
				"1f1f5-1f1f2"
			],
			"greedy_matches": [
				"1f1f5-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1e8": {
		"name": "St. Vincent & Grenadines",
		"unicode_version": 6,
		"category": "flags",
		"order": 2413,
		"display": 1,
		"shortname": ":flag_vc:",
		"shortname_alternates": [
			":vc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1e8",
			"fully_qualified": "1f1fb-1f1e8",
			"non_fully_qualified": "1f1fb-1f1e8",
			"output": "1f1fb-1f1e8",
			"default_matches": [
				"1f1fb-1f1e8"
			],
			"greedy_matches": [
				"1f1fb-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1e9": {
		"name": "Sudan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2414,
		"display": 1,
		"shortname": ":flag_sd:",
		"shortname_alternates": [
			":sd:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1e9",
			"fully_qualified": "1f1f8-1f1e9",
			"non_fully_qualified": "1f1f8-1f1e9",
			"output": "1f1f8-1f1e9",
			"default_matches": [
				"1f1f8-1f1e9"
			],
			"greedy_matches": [
				"1f1f8-1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1f7": {
		"name": "Suriname",
		"unicode_version": 6,
		"category": "flags",
		"order": 2415,
		"display": 1,
		"shortname": ":flag_sr:",
		"shortname_alternates": [
			":sr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1f7",
			"fully_qualified": "1f1f8-1f1f7",
			"non_fully_qualified": "1f1f8-1f1f7",
			"output": "1f1f8-1f1f7",
			"default_matches": [
				"1f1f8-1f1f7"
			],
			"greedy_matches": [
				"1f1f8-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ff": {
		"name": "Swaziland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2416,
		"display": 1,
		"shortname": ":flag_sz:",
		"shortname_alternates": [
			":sz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ff",
			"fully_qualified": "1f1f8-1f1ff",
			"non_fully_qualified": "1f1f8-1f1ff",
			"output": "1f1f8-1f1ff",
			"default_matches": [
				"1f1f8-1f1ff"
			],
			"greedy_matches": [
				"1f1f8-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ea": {
		"name": "Sweden",
		"unicode_version": 6,
		"category": "flags",
		"order": 2417,
		"display": 1,
		"shortname": ":flag_se:",
		"shortname_alternates": [
			":se:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ea",
			"fully_qualified": "1f1f8-1f1ea",
			"non_fully_qualified": "1f1f8-1f1ea",
			"output": "1f1f8-1f1ea",
			"default_matches": [
				"1f1f8-1f1ea"
			],
			"greedy_matches": [
				"1f1f8-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1ed": {
		"name": "Switzerland",
		"unicode_version": 6,
		"category": "flags",
		"order": 2418,
		"display": 1,
		"shortname": ":flag_ch:",
		"shortname_alternates": [
			":ch:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1ed",
			"fully_qualified": "1f1e8-1f1ed",
			"non_fully_qualified": "1f1e8-1f1ed",
			"output": "1f1e8-1f1ed",
			"default_matches": [
				"1f1e8-1f1ed"
			],
			"greedy_matches": [
				"1f1e8-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1fe": {
		"name": "Syria",
		"unicode_version": 6,
		"category": "flags",
		"order": 2419,
		"display": 1,
		"shortname": ":flag_sy:",
		"shortname_alternates": [
			":sy:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1fe",
			"fully_qualified": "1f1f8-1f1fe",
			"non_fully_qualified": "1f1f8-1f1fe",
			"output": "1f1f8-1f1fe",
			"default_matches": [
				"1f1f8-1f1fe"
			],
			"greedy_matches": [
				"1f1f8-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1fc": {
		"name": "Taiwan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2420,
		"display": 1,
		"shortname": ":flag_tw:",
		"shortname_alternates": [
			":tw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1fc",
			"fully_qualified": "1f1f9-1f1fc",
			"non_fully_qualified": "1f1f9-1f1fc",
			"output": "1f1f9-1f1fc",
			"default_matches": [
				"1f1f9-1f1fc"
			],
			"greedy_matches": [
				"1f1f9-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1ef": {
		"name": "Tajikistan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2421,
		"display": 1,
		"shortname": ":flag_tj:",
		"shortname_alternates": [
			":tj:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1ef",
			"fully_qualified": "1f1f9-1f1ef",
			"non_fully_qualified": "1f1f9-1f1ef",
			"output": "1f1f9-1f1ef",
			"default_matches": [
				"1f1f9-1f1ef"
			],
			"greedy_matches": [
				"1f1f9-1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1ff": {
		"name": "Tanzania",
		"unicode_version": 6,
		"category": "flags",
		"order": 2422,
		"display": 1,
		"shortname": ":flag_tz:",
		"shortname_alternates": [
			":tz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1ff",
			"fully_qualified": "1f1f9-1f1ff",
			"non_fully_qualified": "1f1f9-1f1ff",
			"output": "1f1f9-1f1ff",
			"default_matches": [
				"1f1f9-1f1ff"
			],
			"greedy_matches": [
				"1f1f9-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1ed": {
		"name": "Thailand",
		"unicode_version": 6,
		"category": "flags",
		"order": 2423,
		"display": 1,
		"shortname": ":flag_th:",
		"shortname_alternates": [
			":th:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1ed",
			"fully_qualified": "1f1f9-1f1ed",
			"non_fully_qualified": "1f1f9-1f1ed",
			"output": "1f1f9-1f1ed",
			"default_matches": [
				"1f1f9-1f1ed"
			],
			"greedy_matches": [
				"1f1f9-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f1": {
		"name": "Timor-Leste",
		"unicode_version": 6,
		"category": "flags",
		"order": 2424,
		"display": 1,
		"shortname": ":flag_tl:",
		"shortname_alternates": [
			":tl:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f1",
			"fully_qualified": "1f1f9-1f1f1",
			"non_fully_qualified": "1f1f9-1f1f1",
			"output": "1f1f9-1f1f1",
			"default_matches": [
				"1f1f9-1f1f1"
			],
			"greedy_matches": [
				"1f1f9-1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1ec": {
		"name": "Togo",
		"unicode_version": 6,
		"category": "flags",
		"order": 2425,
		"display": 1,
		"shortname": ":flag_tg:",
		"shortname_alternates": [
			":tg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1ec",
			"fully_qualified": "1f1f9-1f1ec",
			"non_fully_qualified": "1f1f9-1f1ec",
			"output": "1f1f9-1f1ec",
			"default_matches": [
				"1f1f9-1f1ec"
			],
			"greedy_matches": [
				"1f1f9-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f0": {
		"name": "Tokelau",
		"unicode_version": 6,
		"category": "flags",
		"order": 2426,
		"display": 1,
		"shortname": ":flag_tk:",
		"shortname_alternates": [
			":tk:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f0",
			"fully_qualified": "1f1f9-1f1f0",
			"non_fully_qualified": "1f1f9-1f1f0",
			"output": "1f1f9-1f1f0",
			"default_matches": [
				"1f1f9-1f1f0"
			],
			"greedy_matches": [
				"1f1f9-1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f4": {
		"name": "Tonga",
		"unicode_version": 6,
		"category": "flags",
		"order": 2427,
		"display": 1,
		"shortname": ":flag_to:",
		"shortname_alternates": [
			":to:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f4",
			"fully_qualified": "1f1f9-1f1f4",
			"non_fully_qualified": "1f1f9-1f1f4",
			"output": "1f1f9-1f1f4",
			"default_matches": [
				"1f1f9-1f1f4"
			],
			"greedy_matches": [
				"1f1f9-1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f9": {
		"name": "Trinidad & Tobago",
		"unicode_version": 6,
		"category": "flags",
		"order": 2428,
		"display": 1,
		"shortname": ":flag_tt:",
		"shortname_alternates": [
			":tt:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f9",
			"fully_qualified": "1f1f9-1f1f9",
			"non_fully_qualified": "1f1f9-1f1f9",
			"output": "1f1f9-1f1f9",
			"default_matches": [
				"1f1f9-1f1f9"
			],
			"greedy_matches": [
				"1f1f9-1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f3": {
		"name": "Tunisia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2429,
		"display": 1,
		"shortname": ":flag_tn:",
		"shortname_alternates": [
			":tn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f3",
			"fully_qualified": "1f1f9-1f1f3",
			"non_fully_qualified": "1f1f9-1f1f3",
			"output": "1f1f9-1f1f3",
			"default_matches": [
				"1f1f9-1f1f3"
			],
			"greedy_matches": [
				"1f1f9-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f7": {
		"name": "Turkey",
		"unicode_version": 6,
		"category": "flags",
		"order": 2430,
		"display": 1,
		"shortname": ":flag_tr:",
		"shortname_alternates": [
			":tr:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f7",
			"fully_qualified": "1f1f9-1f1f7",
			"non_fully_qualified": "1f1f9-1f1f7",
			"output": "1f1f9-1f1f7",
			"default_matches": [
				"1f1f9-1f1f7"
			],
			"greedy_matches": [
				"1f1f9-1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1f2": {
		"name": "Turkmenistan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2431,
		"display": 1,
		"shortname": ":flag_tm:",
		"shortname_alternates": [
			":turkmenistan:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1f2",
			"fully_qualified": "1f1f9-1f1f2",
			"non_fully_qualified": "1f1f9-1f1f2",
			"output": "1f1f9-1f1f2",
			"default_matches": [
				"1f1f9-1f1f2"
			],
			"greedy_matches": [
				"1f1f9-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1e8": {
		"name": "Turks & Caicos Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2432,
		"display": 1,
		"shortname": ":flag_tc:",
		"shortname_alternates": [
			":tc:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1e8",
			"fully_qualified": "1f1f9-1f1e8",
			"non_fully_qualified": "1f1f9-1f1e8",
			"output": "1f1f9-1f1e8",
			"default_matches": [
				"1f1f9-1f1e8"
			],
			"greedy_matches": [
				"1f1f9-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1fb": {
		"name": "Tuvalu",
		"unicode_version": 6,
		"category": "flags",
		"order": 2433,
		"display": 1,
		"shortname": ":flag_tv:",
		"shortname_alternates": [
			":tuvalu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1fb",
			"fully_qualified": "1f1f9-1f1fb",
			"non_fully_qualified": "1f1f9-1f1fb",
			"output": "1f1f9-1f1fb",
			"default_matches": [
				"1f1f9-1f1fb"
			],
			"greedy_matches": [
				"1f1f9-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1ee": {
		"name": "U.S. Virgin Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2434,
		"display": 1,
		"shortname": ":flag_vi:",
		"shortname_alternates": [
			":vi:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1ee",
			"fully_qualified": "1f1fb-1f1ee",
			"non_fully_qualified": "1f1fb-1f1ee",
			"output": "1f1fb-1f1ee",
			"default_matches": [
				"1f1fb-1f1ee"
			],
			"greedy_matches": [
				"1f1fb-1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1ec": {
		"name": "Uganda",
		"unicode_version": 6,
		"category": "flags",
		"order": 2435,
		"display": 1,
		"shortname": ":flag_ug:",
		"shortname_alternates": [
			":ug:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1ec",
			"fully_qualified": "1f1fa-1f1ec",
			"non_fully_qualified": "1f1fa-1f1ec",
			"output": "1f1fa-1f1ec",
			"default_matches": [
				"1f1fa-1f1ec"
			],
			"greedy_matches": [
				"1f1fa-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1e6": {
		"name": "Ukraine",
		"unicode_version": 6,
		"category": "flags",
		"order": 2436,
		"display": 1,
		"shortname": ":flag_ua:",
		"shortname_alternates": [
			":ua:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1e6",
			"fully_qualified": "1f1fa-1f1e6",
			"non_fully_qualified": "1f1fa-1f1e6",
			"output": "1f1fa-1f1e6",
			"default_matches": [
				"1f1fa-1f1e6"
			],
			"greedy_matches": [
				"1f1fa-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1ea": {
		"name": "United Arab Emirates",
		"unicode_version": 6,
		"category": "flags",
		"order": 2437,
		"display": 1,
		"shortname": ":flag_ae:",
		"shortname_alternates": [
			":ae:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1ea",
			"fully_qualified": "1f1e6-1f1ea",
			"non_fully_qualified": "1f1e6-1f1ea",
			"output": "1f1e6-1f1ea",
			"default_matches": [
				"1f1e6-1f1ea"
			],
			"greedy_matches": [
				"1f1e6-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ec-1f1e7": {
		"name": "United Kingdom",
		"unicode_version": 6,
		"category": "flags",
		"order": 2438,
		"display": 1,
		"shortname": ":flag_gb:",
		"shortname_alternates": [
			":gb:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec-1f1e7",
			"fully_qualified": "1f1ec-1f1e7",
			"non_fully_qualified": "1f1ec-1f1e7",
			"output": "1f1ec-1f1e7",
			"default_matches": [
				"1f1ec-1f1e7"
			],
			"greedy_matches": [
				"1f1ec-1f1e7"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1f8": {
		"name": "United States",
		"unicode_version": 6,
		"category": "flags",
		"order": 2439,
		"display": 1,
		"shortname": ":flag_us:",
		"shortname_alternates": [
			":us:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1f8",
			"fully_qualified": "1f1fa-1f1f8",
			"non_fully_qualified": "1f1fa-1f1f8",
			"output": "1f1fa-1f1f8",
			"default_matches": [
				"1f1fa-1f1f8"
			],
			"greedy_matches": [
				"1f1fa-1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1fe": {
		"name": "Uruguay",
		"unicode_version": 6,
		"category": "flags",
		"order": 2440,
		"display": 1,
		"shortname": ":flag_uy:",
		"shortname_alternates": [
			":uy:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1fe",
			"fully_qualified": "1f1fa-1f1fe",
			"non_fully_qualified": "1f1fa-1f1fe",
			"output": "1f1fa-1f1fe",
			"default_matches": [
				"1f1fa-1f1fe"
			],
			"greedy_matches": [
				"1f1fa-1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1ff": {
		"name": "Uzbekistan",
		"unicode_version": 6,
		"category": "flags",
		"order": 2441,
		"display": 1,
		"shortname": ":flag_uz:",
		"shortname_alternates": [
			":uz:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1ff",
			"fully_qualified": "1f1fa-1f1ff",
			"non_fully_qualified": "1f1fa-1f1ff",
			"output": "1f1fa-1f1ff",
			"default_matches": [
				"1f1fa-1f1ff"
			],
			"greedy_matches": [
				"1f1fa-1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1fa": {
		"name": "Vanuatu",
		"unicode_version": 6,
		"category": "flags",
		"order": 2442,
		"display": 1,
		"shortname": ":flag_vu:",
		"shortname_alternates": [
			":vu:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1fa",
			"fully_qualified": "1f1fb-1f1fa",
			"non_fully_qualified": "1f1fb-1f1fa",
			"output": "1f1fb-1f1fa",
			"default_matches": [
				"1f1fb-1f1fa"
			],
			"greedy_matches": [
				"1f1fb-1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1e6": {
		"name": "Vatican City",
		"unicode_version": 6,
		"category": "flags",
		"order": 2443,
		"display": 1,
		"shortname": ":flag_va:",
		"shortname_alternates": [
			":va:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1e6",
			"fully_qualified": "1f1fb-1f1e6",
			"non_fully_qualified": "1f1fb-1f1e6",
			"output": "1f1fb-1f1e6",
			"default_matches": [
				"1f1fb-1f1e6"
			],
			"greedy_matches": [
				"1f1fb-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1ea": {
		"name": "Venezuela",
		"unicode_version": 6,
		"category": "flags",
		"order": 2444,
		"display": 1,
		"shortname": ":flag_ve:",
		"shortname_alternates": [
			":ve:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1ea",
			"fully_qualified": "1f1fb-1f1ea",
			"non_fully_qualified": "1f1fb-1f1ea",
			"output": "1f1fb-1f1ea",
			"default_matches": [
				"1f1fb-1f1ea"
			],
			"greedy_matches": [
				"1f1fb-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fb-1f1f3": {
		"name": "Vietnam",
		"unicode_version": 6,
		"category": "flags",
		"order": 2445,
		"display": 1,
		"shortname": ":flag_vn:",
		"shortname_alternates": [
			":vn:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb-1f1f3",
			"fully_qualified": "1f1fb-1f1f3",
			"non_fully_qualified": "1f1fb-1f1f3",
			"output": "1f1fb-1f1f3",
			"default_matches": [
				"1f1fb-1f1f3"
			],
			"greedy_matches": [
				"1f1fb-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fc-1f1eb": {
		"name": "Wallis & Futuna",
		"unicode_version": 6,
		"category": "flags",
		"order": 2446,
		"display": 1,
		"shortname": ":flag_wf:",
		"shortname_alternates": [
			":wf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fc-1f1eb",
			"fully_qualified": "1f1fc-1f1eb",
			"non_fully_qualified": "1f1fc-1f1eb",
			"output": "1f1fc-1f1eb",
			"default_matches": [
				"1f1fc-1f1eb"
			],
			"greedy_matches": [
				"1f1fc-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1ed": {
		"name": "Western Sahara",
		"unicode_version": 6,
		"category": "flags",
		"order": 2447,
		"display": 1,
		"shortname": ":flag_eh:",
		"shortname_alternates": [
			":eh:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1ed",
			"fully_qualified": "1f1ea-1f1ed",
			"non_fully_qualified": "1f1ea-1f1ed",
			"output": "1f1ea-1f1ed",
			"default_matches": [
				"1f1ea-1f1ed"
			],
			"greedy_matches": [
				"1f1ea-1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fe-1f1ea": {
		"name": "Yemen",
		"unicode_version": 6,
		"category": "flags",
		"order": 2448,
		"display": 1,
		"shortname": ":flag_ye:",
		"shortname_alternates": [
			":ye:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fe-1f1ea",
			"fully_qualified": "1f1fe-1f1ea",
			"non_fully_qualified": "1f1fe-1f1ea",
			"output": "1f1fe-1f1ea",
			"default_matches": [
				"1f1fe-1f1ea"
			],
			"greedy_matches": [
				"1f1fe-1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ff-1f1f2": {
		"name": "Zambia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2449,
		"display": 1,
		"shortname": ":flag_zm:",
		"shortname_alternates": [
			":zm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ff-1f1f2",
			"fully_qualified": "1f1ff-1f1f2",
			"non_fully_qualified": "1f1ff-1f1f2",
			"output": "1f1ff-1f1f2",
			"default_matches": [
				"1f1ff-1f1f2"
			],
			"greedy_matches": [
				"1f1ff-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ff-1f1fc": {
		"name": "Zimbabwe",
		"unicode_version": 6,
		"category": "flags",
		"order": 2450,
		"display": 1,
		"shortname": ":flag_zw:",
		"shortname_alternates": [
			":zw:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ff-1f1fc",
			"fully_qualified": "1f1ff-1f1fc",
			"non_fully_qualified": "1f1ff-1f1fc",
			"output": "1f1ff-1f1fc",
			"default_matches": [
				"1f1ff-1f1fc"
			],
			"greedy_matches": [
				"1f1ff-1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e6-1f1e8": {
		"name": "Ascension Island",
		"unicode_version": 6,
		"category": "flags",
		"order": 2451,
		"display": 1,
		"shortname": ":flag_ac:",
		"shortname_alternates": [
			":ac:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6-1f1e8",
			"fully_qualified": "1f1e6-1f1e8",
			"non_fully_qualified": "1f1e6-1f1e8",
			"output": "1f1e6-1f1e8",
			"default_matches": [
				"1f1e6-1f1e8"
			],
			"greedy_matches": [
				"1f1e6-1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f9-1f1e6": {
		"name": "Tristan da Cunha",
		"unicode_version": 6,
		"category": "flags",
		"order": 2452,
		"display": 1,
		"shortname": ":flag_ta:",
		"shortname_alternates": [
			":ta:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9-1f1e6",
			"fully_qualified": "1f1f9-1f1e6",
			"non_fully_qualified": "1f1f9-1f1e6",
			"output": "1f1f9-1f1e6",
			"default_matches": [
				"1f1f9-1f1e6"
			],
			"greedy_matches": [
				"1f1f9-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e7-1f1fb": {
		"name": "Bouvet Island",
		"unicode_version": 6,
		"category": "flags",
		"order": 2453,
		"display": 1,
		"shortname": ":flag_bv:",
		"shortname_alternates": [
			":bv:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7-1f1fb",
			"fully_qualified": "1f1e7-1f1fb",
			"non_fully_qualified": "1f1e7-1f1fb",
			"output": "1f1e7-1f1fb",
			"default_matches": [
				"1f1e7-1f1fb"
			],
			"greedy_matches": [
				"1f1e7-1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ed-1f1f2": {
		"name": "Heard & McDonald Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2454,
		"display": 1,
		"shortname": ":flag_hm:",
		"shortname_alternates": [
			":hm:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed-1f1f2",
			"fully_qualified": "1f1ed-1f1f2",
			"non_fully_qualified": "1f1ed-1f1f2",
			"output": "1f1ed-1f1f2",
			"default_matches": [
				"1f1ed-1f1f2"
			],
			"greedy_matches": [
				"1f1ed-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f8-1f1ef": {
		"name": "Svalbard & Jan Mayen",
		"unicode_version": 6,
		"category": "flags",
		"order": 2455,
		"display": 1,
		"shortname": ":flag_sj:",
		"shortname_alternates": [
			":sj:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8-1f1ef",
			"fully_qualified": "1f1f8-1f1ef",
			"non_fully_qualified": "1f1f8-1f1ef",
			"output": "1f1f8-1f1ef",
			"default_matches": [
				"1f1f8-1f1ef"
			],
			"greedy_matches": [
				"1f1f8-1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1f2": {
		"name": "U.S. Outlying Islands",
		"unicode_version": 6,
		"category": "flags",
		"order": 2456,
		"display": 1,
		"shortname": ":flag_um:",
		"shortname_alternates": [
			":um:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1f2",
			"fully_qualified": "1f1fa-1f1f2",
			"non_fully_qualified": "1f1fa-1f1f2",
			"output": "1f1fa-1f1f2",
			"default_matches": [
				"1f1fa-1f1f2"
			],
			"greedy_matches": [
				"1f1fa-1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1ea-1f1e6": {
		"name": "Ceuta & Melilla",
		"unicode_version": 6,
		"category": "flags",
		"order": 2457,
		"display": 1,
		"shortname": ":flag_ea:",
		"shortname_alternates": [
			":ea:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea-1f1e6",
			"fully_qualified": "1f1ea-1f1e6",
			"non_fully_qualified": "1f1ea-1f1e6",
			"output": "1f1ea-1f1e6",
			"default_matches": [
				"1f1ea-1f1e6"
			],
			"greedy_matches": [
				"1f1ea-1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e8-1f1f5": {
		"name": "Clipperton Island",
		"unicode_version": 6,
		"category": "flags",
		"order": 2458,
		"display": 1,
		"shortname": ":flag_cp:",
		"shortname_alternates": [
			":cp:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8-1f1f5",
			"fully_qualified": "1f1e8-1f1f5",
			"non_fully_qualified": "1f1e8-1f1f5",
			"output": "1f1e8-1f1f5",
			"default_matches": [
				"1f1e8-1f1f5"
			],
			"greedy_matches": [
				"1f1e8-1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1e9-1f1ec": {
		"name": "Diego Garcia",
		"unicode_version": 6,
		"category": "flags",
		"order": 2459,
		"display": 1,
		"shortname": ":flag_dg:",
		"shortname_alternates": [
			":dg:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9-1f1ec",
			"fully_qualified": "1f1e9-1f1ec",
			"non_fully_qualified": "1f1e9-1f1ec",
			"output": "1f1e9-1f1ec",
			"default_matches": [
				"1f1e9-1f1ec"
			],
			"greedy_matches": [
				"1f1e9-1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1f2-1f1eb": {
		"name": "St. Martin",
		"unicode_version": 6,
		"category": "flags",
		"order": 2460,
		"display": 1,
		"shortname": ":flag_mf:",
		"shortname_alternates": [
			":mf:"
		],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2-1f1eb",
			"fully_qualified": "1f1f2-1f1eb",
			"non_fully_qualified": "1f1f2-1f1eb",
			"output": "1f1f2-1f1eb",
			"default_matches": [
				"1f1f2-1f1eb"
			],
			"greedy_matches": [
				"1f1f2-1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f1fa-1f1f3": {
		"name": "United Nations",
		"unicode_version": 6,
		"category": "flags",
		"order": 2461,
		"display": 1,
		"shortname": ":united_nations:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa-1f1f3",
			"fully_qualified": "1f1fa-1f1f3",
			"non_fully_qualified": "1f1fa-1f1f3",
			"output": "1f1fa-1f1f3",
			"default_matches": [
				"1f1fa-1f1f3"
			],
			"greedy_matches": [
				"1f1fa-1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": {
		"name": "England",
		"unicode_version": 7,
		"category": "flags",
		"order": 2462,
		"display": 1,
		"shortname": ":england:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
			"fully_qualified": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
			"non_fully_qualified": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
			"output": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
			"default_matches": [
				"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"
			],
			"greedy_matches": [
				"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": {
		"name": "Scotland",
		"unicode_version": 7,
		"category": "flags",
		"order": 2463,
		"display": 1,
		"shortname": ":scotland:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
			"fully_qualified": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
			"non_fully_qualified": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
			"output": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
			"default_matches": [
				"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"
			],
			"greedy_matches": [
				"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": {
		"name": "Wales",
		"unicode_version": 7,
		"category": "flags",
		"order": 2464,
		"display": 1,
		"shortname": ":wales:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
			"fully_qualified": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
			"non_fully_qualified": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
			"output": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
			"default_matches": [
				"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"
			],
			"greedy_matches": [
				"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"
			],
			"decimal": ""
		},
		"keywords": [
			"flag"
		]
	},
	"002a": {
		"name": "asterisk",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2465,
		"display": 0,
		"shortname": ":asterisk_symbol:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "002a",
			"fully_qualified": "002a-fe0f",
			"non_fully_qualified": "002a",
			"output": "002a-fe0f",
			"default_matches": [
				"002a-fe0f",
				"002a"
			],
			"greedy_matches": [
				"002a-fe0f",
				"002a"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ff": {
		"name": "regional indicator symbol letter z",
		"unicode_version": 6,
		"category": "regional",
		"order": 2466,
		"display": 0,
		"shortname": ":regional_indicator_z:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ff",
			"fully_qualified": "1f1ff",
			"non_fully_qualified": "1f1ff",
			"output": "1f1ff",
			"default_matches": [
				"1f1ff"
			],
			"greedy_matches": [
				"1f1ff"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1fe": {
		"name": "regional indicator symbol letter y",
		"unicode_version": 6,
		"category": "regional",
		"order": 2467,
		"display": 0,
		"shortname": ":regional_indicator_y:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fe",
			"fully_qualified": "1f1fe",
			"non_fully_qualified": "1f1fe",
			"output": "1f1fe",
			"default_matches": [
				"1f1fe"
			],
			"greedy_matches": [
				"1f1fe"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1fd": {
		"name": "regional indicator symbol letter x",
		"unicode_version": 6,
		"category": "regional",
		"order": 2468,
		"display": 0,
		"shortname": ":regional_indicator_x:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fd",
			"fully_qualified": "1f1fd",
			"non_fully_qualified": "1f1fd",
			"output": "1f1fd",
			"default_matches": [
				"1f1fd"
			],
			"greedy_matches": [
				"1f1fd"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0023": {
		"name": "pound symbol",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2469,
		"display": 0,
		"shortname": ":pound_symbol:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0023",
			"fully_qualified": "0023-fe0f",
			"non_fully_qualified": "0023",
			"output": "0023-fe0f",
			"default_matches": [
				"0023-fe0f",
				"0023"
			],
			"greedy_matches": [
				"0023-fe0f",
				"0023"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f3fb": {
		"name": "light skin tone",
		"unicode_version": 8,
		"category": "modifier",
		"order": 2470,
		"display": 0,
		"shortname": ":tone1:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3fb",
			"fully_qualified": "1f3fb",
			"non_fully_qualified": "1f3fb",
			"output": "1f3fb",
			"default_matches": [
				"1f3fb"
			],
			"greedy_matches": [
				"1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f3fc": {
		"name": "medium-light skin tone",
		"unicode_version": 8,
		"category": "modifier",
		"order": 2471,
		"display": 0,
		"shortname": ":tone2:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3fc",
			"fully_qualified": "1f3fc",
			"non_fully_qualified": "1f3fc",
			"output": "1f3fc",
			"default_matches": [
				"1f3fc"
			],
			"greedy_matches": [
				"1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f3fd": {
		"name": "medium skin tone",
		"unicode_version": 8,
		"category": "modifier",
		"order": 2472,
		"display": 0,
		"shortname": ":tone3:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3fd",
			"fully_qualified": "1f3fd",
			"non_fully_qualified": "1f3fd",
			"output": "1f3fd",
			"default_matches": [
				"1f3fd"
			],
			"greedy_matches": [
				"1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f3fe": {
		"name": "medium-dark skin tone",
		"unicode_version": 8,
		"category": "modifier",
		"order": 2473,
		"display": 0,
		"shortname": ":tone4:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3fe",
			"fully_qualified": "1f3fe",
			"non_fully_qualified": "1f3fe",
			"output": "1f3fe",
			"default_matches": [
				"1f3fe"
			],
			"greedy_matches": [
				"1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f3ff": {
		"name": "dark skin tone",
		"unicode_version": 8,
		"category": "modifier",
		"order": 2474,
		"display": 0,
		"shortname": ":tone5:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f3ff",
			"fully_qualified": "1f3ff",
			"non_fully_qualified": "1f3ff",
			"output": "1f3ff",
			"default_matches": [
				"1f3ff"
			],
			"greedy_matches": [
				"1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1fc": {
		"name": "regional indicator symbol letter w",
		"unicode_version": 6,
		"category": "regional",
		"order": 2475,
		"display": 0,
		"shortname": ":regional_indicator_w:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fc",
			"fully_qualified": "1f1fc",
			"non_fully_qualified": "1f1fc",
			"output": "1f1fc",
			"default_matches": [
				"1f1fc"
			],
			"greedy_matches": [
				"1f1fc"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1fb": {
		"name": "regional indicator symbol letter v",
		"unicode_version": 6,
		"category": "regional",
		"order": 2476,
		"display": 0,
		"shortname": ":regional_indicator_v:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fb",
			"fully_qualified": "1f1fb",
			"non_fully_qualified": "1f1fb",
			"output": "1f1fb",
			"default_matches": [
				"1f1fb"
			],
			"greedy_matches": [
				"1f1fb"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1fa": {
		"name": "regional indicator symbol letter u",
		"unicode_version": 6,
		"category": "regional",
		"order": 2477,
		"display": 0,
		"shortname": ":regional_indicator_u:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1fa",
			"fully_qualified": "1f1fa",
			"non_fully_qualified": "1f1fa",
			"output": "1f1fa",
			"default_matches": [
				"1f1fa"
			],
			"greedy_matches": [
				"1f1fa"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f9": {
		"name": "regional indicator symbol letter t",
		"unicode_version": 6,
		"category": "regional",
		"order": 2478,
		"display": 0,
		"shortname": ":regional_indicator_t:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f9",
			"fully_qualified": "1f1f9",
			"non_fully_qualified": "1f1f9",
			"output": "1f1f9",
			"default_matches": [
				"1f1f9"
			],
			"greedy_matches": [
				"1f1f9"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f8": {
		"name": "regional indicator symbol letter s",
		"unicode_version": 6,
		"category": "regional",
		"order": 2479,
		"display": 0,
		"shortname": ":regional_indicator_s:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f8",
			"fully_qualified": "1f1f8",
			"non_fully_qualified": "1f1f8",
			"output": "1f1f8",
			"default_matches": [
				"1f1f8"
			],
			"greedy_matches": [
				"1f1f8"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f7": {
		"name": "regional indicator symbol letter r",
		"unicode_version": 6,
		"category": "regional",
		"order": 2480,
		"display": 0,
		"shortname": ":regional_indicator_r:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f7",
			"fully_qualified": "1f1f7",
			"non_fully_qualified": "1f1f7",
			"output": "1f1f7",
			"default_matches": [
				"1f1f7"
			],
			"greedy_matches": [
				"1f1f7"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f6": {
		"name": "regional indicator symbol letter q",
		"unicode_version": 6,
		"category": "regional",
		"order": 2481,
		"display": 0,
		"shortname": ":regional_indicator_q:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f6",
			"fully_qualified": "1f1f6",
			"non_fully_qualified": "1f1f6",
			"output": "1f1f6",
			"default_matches": [
				"1f1f6"
			],
			"greedy_matches": [
				"1f1f6"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f5": {
		"name": "regional indicator symbol letter p",
		"unicode_version": 6,
		"category": "regional",
		"order": 2482,
		"display": 0,
		"shortname": ":regional_indicator_p:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f5",
			"fully_qualified": "1f1f5",
			"non_fully_qualified": "1f1f5",
			"output": "1f1f5",
			"default_matches": [
				"1f1f5"
			],
			"greedy_matches": [
				"1f1f5"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f4": {
		"name": "regional indicator symbol letter o",
		"unicode_version": 6,
		"category": "regional",
		"order": 2483,
		"display": 0,
		"shortname": ":regional_indicator_o:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f4",
			"fully_qualified": "1f1f4",
			"non_fully_qualified": "1f1f4",
			"output": "1f1f4",
			"default_matches": [
				"1f1f4"
			],
			"greedy_matches": [
				"1f1f4"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f3": {
		"name": "regional indicator symbol letter n",
		"unicode_version": 6,
		"category": "regional",
		"order": 2484,
		"display": 0,
		"shortname": ":regional_indicator_n:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f3",
			"fully_qualified": "1f1f3",
			"non_fully_qualified": "1f1f3",
			"output": "1f1f3",
			"default_matches": [
				"1f1f3"
			],
			"greedy_matches": [
				"1f1f3"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f2": {
		"name": "regional indicator symbol letter m",
		"unicode_version": 6,
		"category": "regional",
		"order": 2485,
		"display": 0,
		"shortname": ":regional_indicator_m:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f2",
			"fully_qualified": "1f1f2",
			"non_fully_qualified": "1f1f2",
			"output": "1f1f2",
			"default_matches": [
				"1f1f2"
			],
			"greedy_matches": [
				"1f1f2"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f1": {
		"name": "regional indicator symbol letter l",
		"unicode_version": 6,
		"category": "regional",
		"order": 2486,
		"display": 0,
		"shortname": ":regional_indicator_l:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f1",
			"fully_qualified": "1f1f1",
			"non_fully_qualified": "1f1f1",
			"output": "1f1f1",
			"default_matches": [
				"1f1f1"
			],
			"greedy_matches": [
				"1f1f1"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1f0": {
		"name": "regional indicator symbol letter k",
		"unicode_version": 6,
		"category": "regional",
		"order": 2487,
		"display": 0,
		"shortname": ":regional_indicator_k:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1f0",
			"fully_qualified": "1f1f0",
			"non_fully_qualified": "1f1f0",
			"output": "1f1f0",
			"default_matches": [
				"1f1f0"
			],
			"greedy_matches": [
				"1f1f0"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ef": {
		"name": "regional indicator symbol letter j",
		"unicode_version": 6,
		"category": "regional",
		"order": 2488,
		"display": 0,
		"shortname": ":regional_indicator_j:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ef",
			"fully_qualified": "1f1ef",
			"non_fully_qualified": "1f1ef",
			"output": "1f1ef",
			"default_matches": [
				"1f1ef"
			],
			"greedy_matches": [
				"1f1ef"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ee": {
		"name": "regional indicator symbol letter i",
		"unicode_version": 6,
		"category": "regional",
		"order": 2489,
		"display": 0,
		"shortname": ":regional_indicator_i:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ee",
			"fully_qualified": "1f1ee",
			"non_fully_qualified": "1f1ee",
			"output": "1f1ee",
			"default_matches": [
				"1f1ee"
			],
			"greedy_matches": [
				"1f1ee"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ed": {
		"name": "regional indicator symbol letter h",
		"unicode_version": 6,
		"category": "regional",
		"order": 2490,
		"display": 0,
		"shortname": ":regional_indicator_h:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ed",
			"fully_qualified": "1f1ed",
			"non_fully_qualified": "1f1ed",
			"output": "1f1ed",
			"default_matches": [
				"1f1ed"
			],
			"greedy_matches": [
				"1f1ed"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ec": {
		"name": "regional indicator symbol letter g",
		"unicode_version": 6,
		"category": "regional",
		"order": 2491,
		"display": 0,
		"shortname": ":regional_indicator_g:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ec",
			"fully_qualified": "1f1ec",
			"non_fully_qualified": "1f1ec",
			"output": "1f1ec",
			"default_matches": [
				"1f1ec"
			],
			"greedy_matches": [
				"1f1ec"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1eb": {
		"name": "regional indicator symbol letter f",
		"unicode_version": 6,
		"category": "regional",
		"order": 2492,
		"display": 0,
		"shortname": ":regional_indicator_f:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1eb",
			"fully_qualified": "1f1eb",
			"non_fully_qualified": "1f1eb",
			"output": "1f1eb",
			"default_matches": [
				"1f1eb"
			],
			"greedy_matches": [
				"1f1eb"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1ea": {
		"name": "regional indicator symbol letter e",
		"unicode_version": 6,
		"category": "regional",
		"order": 2493,
		"display": 0,
		"shortname": ":regional_indicator_e:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1ea",
			"fully_qualified": "1f1ea",
			"non_fully_qualified": "1f1ea",
			"output": "1f1ea",
			"default_matches": [
				"1f1ea"
			],
			"greedy_matches": [
				"1f1ea"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1e9": {
		"name": "regional indicator symbol letter d",
		"unicode_version": 6,
		"category": "regional",
		"order": 2494,
		"display": 0,
		"shortname": ":regional_indicator_d:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e9",
			"fully_qualified": "1f1e9",
			"non_fully_qualified": "1f1e9",
			"output": "1f1e9",
			"default_matches": [
				"1f1e9"
			],
			"greedy_matches": [
				"1f1e9"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1e8": {
		"name": "regional indicator symbol letter c",
		"unicode_version": 6,
		"category": "regional",
		"order": 2495,
		"display": 0,
		"shortname": ":regional_indicator_c:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e8",
			"fully_qualified": "1f1e8",
			"non_fully_qualified": "1f1e8",
			"output": "1f1e8",
			"default_matches": [
				"1f1e8"
			],
			"greedy_matches": [
				"1f1e8"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1e7": {
		"name": "regional indicator symbol letter b",
		"unicode_version": 6,
		"category": "regional",
		"order": 2496,
		"display": 0,
		"shortname": ":regional_indicator_b:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e7",
			"fully_qualified": "1f1e7",
			"non_fully_qualified": "1f1e7",
			"output": "1f1e7",
			"default_matches": [
				"1f1e7"
			],
			"greedy_matches": [
				"1f1e7"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f1e6": {
		"name": "regional indicator symbol letter a",
		"unicode_version": 6,
		"category": "regional",
		"order": 2497,
		"display": 0,
		"shortname": ":regional_indicator_a:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f1e6",
			"fully_qualified": "1f1e6",
			"non_fully_qualified": "1f1e6",
			"output": "1f1e6",
			"default_matches": [
				"1f1e6"
			],
			"greedy_matches": [
				"1f1e6"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0039": {
		"name": "digit nine",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2498,
		"display": 0,
		"shortname": ":digit_nine:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0039",
			"fully_qualified": "0039-fe0f",
			"non_fully_qualified": "0039",
			"output": "0039-fe0f",
			"default_matches": [
				"0039-fe0f",
				"0039"
			],
			"greedy_matches": [
				"0039-fe0f",
				"0039"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0038": {
		"name": "digit eight",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2499,
		"display": 0,
		"shortname": ":digit_eight:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0038",
			"fully_qualified": "0038-fe0f",
			"non_fully_qualified": "0038",
			"output": "0038-fe0f",
			"default_matches": [
				"0038-fe0f",
				"0038"
			],
			"greedy_matches": [
				"0038-fe0f",
				"0038"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0037": {
		"name": "digit seven",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2500,
		"display": 0,
		"shortname": ":digit_seven:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0037",
			"fully_qualified": "0037-fe0f",
			"non_fully_qualified": "0037",
			"output": "0037-fe0f",
			"default_matches": [
				"0037-fe0f",
				"0037"
			],
			"greedy_matches": [
				"0037-fe0f",
				"0037"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0036": {
		"name": "digit six",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2501,
		"display": 0,
		"shortname": ":digit_six:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0036",
			"fully_qualified": "0036-fe0f",
			"non_fully_qualified": "0036",
			"output": "0036-fe0f",
			"default_matches": [
				"0036-fe0f",
				"0036"
			],
			"greedy_matches": [
				"0036-fe0f",
				"0036"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0035": {
		"name": "digit five",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2502,
		"display": 0,
		"shortname": ":digit_five:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0035",
			"fully_qualified": "0035-fe0f",
			"non_fully_qualified": "0035",
			"output": "0035-fe0f",
			"default_matches": [
				"0035-fe0f",
				"0035"
			],
			"greedy_matches": [
				"0035-fe0f",
				"0035"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0034": {
		"name": "digit four",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2503,
		"display": 0,
		"shortname": ":digit_four:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0034",
			"fully_qualified": "0034-fe0f",
			"non_fully_qualified": "0034",
			"output": "0034-fe0f",
			"default_matches": [
				"0034-fe0f",
				"0034"
			],
			"greedy_matches": [
				"0034-fe0f",
				"0034"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0033": {
		"name": "digit three",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2504,
		"display": 0,
		"shortname": ":digit_three:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0033",
			"fully_qualified": "0033-fe0f",
			"non_fully_qualified": "0033",
			"output": "0033-fe0f",
			"default_matches": [
				"0033-fe0f",
				"0033"
			],
			"greedy_matches": [
				"0033-fe0f",
				"0033"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0032": {
		"name": "digit two",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2505,
		"display": 0,
		"shortname": ":digit_two:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0032",
			"fully_qualified": "0032-fe0f",
			"non_fully_qualified": "0032",
			"output": "0032-fe0f",
			"default_matches": [
				"0032-fe0f",
				"0032"
			],
			"greedy_matches": [
				"0032-fe0f",
				"0032"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0031": {
		"name": "digit one",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2506,
		"display": 0,
		"shortname": ":digit_one:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0031",
			"fully_qualified": "0031-fe0f",
			"non_fully_qualified": "0031",
			"output": "0031-fe0f",
			"default_matches": [
				"0031-fe0f",
				"0031"
			],
			"greedy_matches": [
				"0031-fe0f",
				"0031"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"0030": {
		"name": "digit zero",
		"unicode_version": 1.1,
		"category": "symbols",
		"order": 2507,
		"display": 0,
		"shortname": ":digit_zero:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "0030",
			"fully_qualified": "0030-fe0f",
			"non_fully_qualified": "0030",
			"output": "0030-fe0f",
			"default_matches": [
				"0030-fe0f",
				"0030"
			],
			"greedy_matches": [
				"0030-fe0f",
				"0030"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f468-1f469-1f466": {
		"name": "family: man, woman, boy",
		"unicode_version": 6,
		"category": "people",
		"order": 2511,
		"display": 0,
		"shortname": ":family_man_woman_boy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f468-1f469-1f466",
			"fully_qualified": "1f468-200d-1f469-200d-1f466",
			"non_fully_qualified": "1f468-200d-1f469-200d-1f466",
			"output": "1f468-200d-1f469-200d-1f466",
			"default_matches": [
				"1f468-200d-1f469-200d-1f466",
				"1f468-1f469-1f466"
			],
			"greedy_matches": [
				"1f468-200d-1f469-200d-1f466",
				"1f468-1f469-1f466"
			],
			"decimal": ""
		},
		"keywords": [
			"boy",
			"family",
			"man",
			"woman"
		]
	},
	"1f469-2764-1f468": {
		"name": "couple with heart: woman, man",
		"unicode_version": 6,
		"category": "people",
		"order": 2512,
		"display": 0,
		"shortname": ":couple_with_heart_woman_man:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2764-1f468",
			"fully_qualified": "1f469-200d-2764-fe0f-200d-1f468",
			"non_fully_qualified": "1f469-200d-2764-200d-1f468",
			"output": "1f469-200d-2764-fe0f-200d-1f468",
			"default_matches": [
				"1f469-200d-2764-fe0f-200d-1f468",
				"1f469-200d-2764-200d-1f468",
				"1f469-2764-fe0f-1f468"
			],
			"greedy_matches": [
				"1f469-200d-2764-fe0f-200d-1f468",
				"1f469-200d-2764-200d-1f468",
				"1f469-2764-fe0f-1f468"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"love",
			"man",
			"woman"
		]
	},
	"1f469-2764-1f48b-1f468": {
		"name": "kiss: woman, man",
		"unicode_version": 6,
		"category": "people",
		"order": 2513,
		"display": 0,
		"shortname": ":kiss_woman_man:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f469-2764-1f48b-1f468",
			"fully_qualified": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
			"non_fully_qualified": "1f469-200d-2764-200d-1f48b-200d-1f468",
			"output": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
			"default_matches": [
				"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
				"1f469-200d-2764-200d-1f48b-200d-1f468",
				"1f469-2764-fe0f-1f48b-1f468"
			],
			"greedy_matches": [
				"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
				"1f469-200d-2764-200d-1f48b-200d-1f468",
				"1f469-2764-fe0f-1f48b-1f468"
			],
			"decimal": ""
		},
		"keywords": [
			"couple",
			"man",
			"woman"
		]
	},
	"1f928": {
		"name": "face with raised eyebrow",
		"unicode_version": 10,
		"category": "people",
		"order": 2514,
		"display": 1,
		"shortname": ":face_with_raised_eyebrow:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f928",
			"fully_qualified": "1f928",
			"non_fully_qualified": "1f928",
			"output": "1f928",
			"default_matches": [
				"1f928"
			],
			"greedy_matches": [
				"1f928"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f929": {
		"name": "star-struck",
		"unicode_version": 10,
		"category": "people",
		"order": 2515,
		"display": 1,
		"shortname": ":star_struck:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f929",
			"fully_qualified": "1f929",
			"non_fully_qualified": "1f929",
			"output": "1f929",
			"default_matches": [
				"1f929"
			],
			"greedy_matches": [
				"1f929"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f92a": {
		"name": "crazy face",
		"unicode_version": 10,
		"category": "people",
		"order": 2516,
		"display": 1,
		"shortname": ":crazy_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92a",
			"fully_qualified": "1f92a",
			"non_fully_qualified": "1f92a",
			"output": "1f92a",
			"default_matches": [
				"1f92a"
			],
			"greedy_matches": [
				"1f92a"
			],
			"decimal": ""
		},
		"keywords": [
			"eye",
			"large",
			"small"
		]
	},
	"1f92b": {
		"name": "shushing face",
		"unicode_version": 10,
		"category": "people",
		"order": 2517,
		"display": 1,
		"shortname": ":shushing_face:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92b",
			"fully_qualified": "1f92b",
			"non_fully_qualified": "1f92b",
			"output": "1f92b",
			"default_matches": [
				"1f92b"
			],
			"greedy_matches": [
				"1f92b"
			],
			"decimal": ""
		},
		"keywords": [
			"quiet",
			"shush"
		]
	},
	"1f92c": {
		"name": "face with symbols over mouth",
		"unicode_version": 10,
		"category": "people",
		"order": 2518,
		"display": 1,
		"shortname": ":face_with_symbols_over_mouth:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92c",
			"fully_qualified": "1f92c",
			"non_fully_qualified": "1f92c",
			"output": "1f92c",
			"default_matches": [
				"1f92c"
			],
			"greedy_matches": [
				"1f92c"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f92d": {
		"name": "face with hand over mouth",
		"unicode_version": 10,
		"category": "people",
		"order": 2519,
		"display": 1,
		"shortname": ":face_with_hand_over_mouth:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92d",
			"fully_qualified": "1f92d",
			"non_fully_qualified": "1f92d",
			"output": "1f92d",
			"default_matches": [
				"1f92d"
			],
			"greedy_matches": [
				"1f92d"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f92e": {
		"name": "face vomiting",
		"unicode_version": 10,
		"category": "people",
		"order": 2520,
		"display": 1,
		"shortname": ":face_vomiting:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92e",
			"fully_qualified": "1f92e",
			"non_fully_qualified": "1f92e",
			"output": "1f92e",
			"default_matches": [
				"1f92e"
			],
			"greedy_matches": [
				"1f92e"
			],
			"decimal": ""
		},
		"keywords": [
			"sick",
			"vomit"
		]
	},
	"1f92f": {
		"name": "exploding head",
		"unicode_version": 10,
		"category": "people",
		"order": 2521,
		"display": 1,
		"shortname": ":exploding_head:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f92f",
			"fully_qualified": "1f92f",
			"non_fully_qualified": "1f92f",
			"output": "1f92f",
			"default_matches": [
				"1f92f"
			],
			"greedy_matches": [
				"1f92f"
			],
			"decimal": ""
		},
		"keywords": [
			"shocked"
		]
	},
	"1f9d0": {
		"name": "face with monocle",
		"unicode_version": 10,
		"category": "people",
		"order": 2522,
		"display": 1,
		"shortname": ":face_with_monocle:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d0",
			"fully_qualified": "1f9d0",
			"non_fully_qualified": "1f9d0",
			"output": "1f9d0",
			"default_matches": [
				"1f9d0"
			],
			"greedy_matches": [
				"1f9d0"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d1": {
		"name": "adult",
		"unicode_version": 10,
		"category": "people",
		"order": 2523,
		"display": 1,
		"shortname": ":adult:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d1-1f3fb",
			"1f9d1-1f3fc",
			"1f9d1-1f3fd",
			"1f9d1-1f3fe",
			"1f9d1-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1",
			"fully_qualified": "1f9d1",
			"non_fully_qualified": "1f9d1",
			"output": "1f9d1",
			"default_matches": [
				"1f9d1"
			],
			"greedy_matches": [
				"1f9d1"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d2": {
		"name": "child",
		"unicode_version": 10,
		"category": "people",
		"order": 2524,
		"display": 1,
		"shortname": ":child:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d2-1f3fb",
			"1f9d2-1f3fc",
			"1f9d2-1f3fd",
			"1f9d2-1f3fe",
			"1f9d2-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2",
			"fully_qualified": "1f9d2",
			"non_fully_qualified": "1f9d2",
			"output": "1f9d2",
			"default_matches": [
				"1f9d2"
			],
			"greedy_matches": [
				"1f9d2"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d3": {
		"name": "older adult",
		"unicode_version": 10,
		"category": "people",
		"order": 2525,
		"display": 1,
		"shortname": ":older_adult:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d3-1f3fb",
			"1f9d3-1f3fc",
			"1f9d3-1f3fd",
			"1f9d3-1f3fe",
			"1f9d3-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3",
			"fully_qualified": "1f9d3",
			"non_fully_qualified": "1f9d3",
			"output": "1f9d3",
			"default_matches": [
				"1f9d3"
			],
			"greedy_matches": [
				"1f9d3"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d4": {
		"name": "bearded person",
		"unicode_version": 10,
		"category": "people",
		"order": 2526,
		"display": 1,
		"shortname": ":bearded_person:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d4-1f3fb",
			"1f9d4-1f3fc",
			"1f9d4-1f3fd",
			"1f9d4-1f3fe",
			"1f9d4-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4",
			"fully_qualified": "1f9d4",
			"non_fully_qualified": "1f9d4",
			"output": "1f9d4",
			"default_matches": [
				"1f9d4"
			],
			"greedy_matches": [
				"1f9d4"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9d5": {
		"name": "woman with headscarf",
		"unicode_version": 10,
		"category": "people",
		"order": 2527,
		"display": 1,
		"shortname": ":woman_with_headscarf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d5-1f3fb",
			"1f9d5-1f3fc",
			"1f9d5-1f3fd",
			"1f9d5-1f3fe",
			"1f9d5-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5",
			"fully_qualified": "1f9d5",
			"non_fully_qualified": "1f9d5",
			"output": "1f9d5",
			"default_matches": [
				"1f9d5"
			],
			"greedy_matches": [
				"1f9d5"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9e0": {
		"name": "brain",
		"unicode_version": 10,
		"category": "people",
		"order": 2528,
		"display": 1,
		"shortname": ":brain:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e0",
			"fully_qualified": "1f9e0",
			"non_fully_qualified": "1f9e0",
			"output": "1f9e0",
			"default_matches": [
				"1f9e0"
			],
			"greedy_matches": [
				"1f9e0"
			],
			"decimal": ""
		},
		"keywords": [
			"intelligent"
		]
	},
	"1f9e2": {
		"name": "billed cap",
		"unicode_version": 10,
		"category": "people",
		"order": 2529,
		"display": 1,
		"shortname": ":billed_cap:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e2",
			"fully_qualified": "1f9e2",
			"non_fully_qualified": "1f9e2",
			"output": "1f9e2",
			"default_matches": [
				"1f9e2"
			],
			"greedy_matches": [
				"1f9e2"
			],
			"decimal": ""
		},
		"keywords": [
			"baseball cap"
		]
	},
	"1f9d9": {
		"name": "mage",
		"unicode_version": 10,
		"category": "people",
		"order": 2530,
		"display": 0,
		"shortname": ":mage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d9-1f3fb",
			"1f9d9-1f3fc",
			"1f9d9-1f3fd",
			"1f9d9-1f3fe",
			"1f9d9-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9d9-2640",
			"1f9d9-2642"
		],
		"code_points": {
			"base": "1f9d9",
			"fully_qualified": "1f9d9",
			"non_fully_qualified": "1f9d9",
			"output": "1f9d9",
			"default_matches": [
				"1f9d9"
			],
			"greedy_matches": [
				"1f9d9"
			],
			"decimal": ""
		},
		"keywords": [
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9da": {
		"name": "fairy",
		"unicode_version": 10,
		"category": "people",
		"order": 2531,
		"display": 0,
		"shortname": ":fairy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9da-1f3fb",
			"1f9da-1f3fc",
			"1f9da-1f3fd",
			"1f9da-1f3fe",
			"1f9da-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9da-2640",
			"1f9da-2642"
		],
		"code_points": {
			"base": "1f9da",
			"fully_qualified": "1f9da",
			"non_fully_qualified": "1f9da",
			"output": "1f9da",
			"default_matches": [
				"1f9da"
			],
			"greedy_matches": [
				"1f9da"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania"
		]
	},
	"1f9db": {
		"name": "vampire",
		"unicode_version": 10,
		"category": "people",
		"order": 2532,
		"display": 0,
		"shortname": ":vampire:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9db-1f3fb",
			"1f9db-1f3fc",
			"1f9db-1f3fd",
			"1f9db-1f3fe",
			"1f9db-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9db-2640",
			"1f9db-2642"
		],
		"code_points": {
			"base": "1f9db",
			"fully_qualified": "1f9db",
			"non_fully_qualified": "1f9db",
			"output": "1f9db",
			"default_matches": [
				"1f9db"
			],
			"greedy_matches": [
				"1f9db"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"undead"
		]
	},
	"1f9dc": {
		"name": "merperson",
		"unicode_version": 10,
		"category": "people",
		"order": 2533,
		"display": 0,
		"shortname": ":merperson:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dc-1f3fb",
			"1f9dc-1f3fc",
			"1f9dc-1f3fd",
			"1f9dc-1f3fe",
			"1f9dc-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9dc-2642"
		],
		"code_points": {
			"base": "1f9dc",
			"fully_qualified": "1f9dc",
			"non_fully_qualified": "1f9dc",
			"output": "1f9dc",
			"default_matches": [
				"1f9dc"
			],
			"greedy_matches": [
				"1f9dc"
			],
			"decimal": ""
		},
		"keywords": [
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dd": {
		"name": "elf",
		"unicode_version": 10,
		"category": "people",
		"order": 2534,
		"display": 0,
		"shortname": ":elf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dd-1f3fb",
			"1f9dd-1f3fc",
			"1f9dd-1f3fd",
			"1f9dd-1f3fe",
			"1f9dd-1f3ff"
		],
		"gender": null,
		"genders": [
			"1f9dd-2640",
			"1f9dd-2642"
		],
		"code_points": {
			"base": "1f9dd",
			"fully_qualified": "1f9dd",
			"non_fully_qualified": "1f9dd",
			"output": "1f9dd",
			"default_matches": [
				"1f9dd"
			],
			"greedy_matches": [
				"1f9dd"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9de": {
		"name": "genie",
		"unicode_version": 10,
		"category": "people",
		"order": 2535,
		"display": 0,
		"shortname": ":genie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9de-2640",
			"1f9de-2642"
		],
		"code_points": {
			"base": "1f9de",
			"fully_qualified": "1f9de",
			"non_fully_qualified": "1f9de",
			"output": "1f9de",
			"default_matches": [
				"1f9de"
			],
			"greedy_matches": [
				"1f9de"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9df": {
		"name": "zombie",
		"unicode_version": 10,
		"category": "people",
		"order": 2536,
		"display": 0,
		"shortname": ":zombie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9df-2640",
			"1f9df-2642"
		],
		"code_points": {
			"base": "1f9df",
			"fully_qualified": "1f9df",
			"non_fully_qualified": "1f9df",
			"output": "1f9df",
			"default_matches": [
				"1f9df"
			],
			"greedy_matches": [
				"1f9df"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f9e3": {
		"name": "scarf",
		"unicode_version": 10,
		"category": "people",
		"order": 2537,
		"display": 1,
		"shortname": ":scarf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e3",
			"fully_qualified": "1f9e3",
			"non_fully_qualified": "1f9e3",
			"output": "1f9e3",
			"default_matches": [
				"1f9e3"
			],
			"greedy_matches": [
				"1f9e3"
			],
			"decimal": ""
		},
		"keywords": [
			"neck"
		]
	},
	"1f9e4": {
		"name": "gloves",
		"unicode_version": 10,
		"category": "people",
		"order": 2538,
		"display": 1,
		"shortname": ":gloves:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e4",
			"fully_qualified": "1f9e4",
			"non_fully_qualified": "1f9e4",
			"output": "1f9e4",
			"default_matches": [
				"1f9e4"
			],
			"greedy_matches": [
				"1f9e4"
			],
			"decimal": ""
		},
		"keywords": [
			"hand"
		]
	},
	"1f9e5": {
		"name": "coat",
		"unicode_version": 10,
		"category": "people",
		"order": 2539,
		"display": 1,
		"shortname": ":coat:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e5",
			"fully_qualified": "1f9e5",
			"non_fully_qualified": "1f9e5",
			"output": "1f9e5",
			"default_matches": [
				"1f9e5"
			],
			"greedy_matches": [
				"1f9e5"
			],
			"decimal": ""
		},
		"keywords": [
			"jacket"
		]
	},
	"1f9e6": {
		"name": "socks",
		"unicode_version": 10,
		"category": "people",
		"order": 2540,
		"display": 1,
		"shortname": ":socks:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9e6",
			"fully_qualified": "1f9e6",
			"non_fully_qualified": "1f9e6",
			"output": "1f9e6",
			"default_matches": [
				"1f9e6"
			],
			"greedy_matches": [
				"1f9e6"
			],
			"decimal": ""
		},
		"keywords": [
			"stocking"
		]
	},
	"1f91f": {
		"name": "love-you gesture",
		"unicode_version": 10,
		"category": "people",
		"order": 2541,
		"display": 1,
		"shortname": ":love_you_gesture:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f91f-1f3fb",
			"1f91f-1f3fc",
			"1f91f-1f3fd",
			"1f91f-1f3fe",
			"1f91f-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f",
			"fully_qualified": "1f91f",
			"non_fully_qualified": "1f91f",
			"output": "1f91f",
			"default_matches": [
				"1f91f"
			],
			"greedy_matches": [
				"1f91f"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"hand"
		]
	},
	"1f91f-1f3fb": {
		"name": "love-you gesture: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2542,
		"display": 1,
		"shortname": ":love_you_gesture_tone1:",
		"shortname_alternates": [
			":love_you_gesture_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f-1f3fb",
			"fully_qualified": "1f91f-1f3fb",
			"non_fully_qualified": "1f91f-1f3fb",
			"output": "1f91f-1f3fb",
			"default_matches": [
				"1f91f-1f3fb"
			],
			"greedy_matches": [
				"1f91f-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"hand",
			"light skin tone"
		]
	},
	"1f91f-1f3fc": {
		"name": "love-you gesture: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2543,
		"display": 1,
		"shortname": ":love_you_gesture_tone2:",
		"shortname_alternates": [
			":love_you_gesture_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f-1f3fc",
			"fully_qualified": "1f91f-1f3fc",
			"non_fully_qualified": "1f91f-1f3fc",
			"output": "1f91f-1f3fc",
			"default_matches": [
				"1f91f-1f3fc"
			],
			"greedy_matches": [
				"1f91f-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"hand",
			"medium-light skin tone"
		]
	},
	"1f91f-1f3fd": {
		"name": "love-you gesture: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2544,
		"display": 1,
		"shortname": ":love_you_gesture_tone3:",
		"shortname_alternates": [
			":love_you_gesture_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f-1f3fd",
			"fully_qualified": "1f91f-1f3fd",
			"non_fully_qualified": "1f91f-1f3fd",
			"output": "1f91f-1f3fd",
			"default_matches": [
				"1f91f-1f3fd"
			],
			"greedy_matches": [
				"1f91f-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"hand",
			"medium skin tone"
		]
	},
	"1f91f-1f3fe": {
		"name": "love-you gesture: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2545,
		"display": 1,
		"shortname": ":love_you_gesture_tone4:",
		"shortname_alternates": [
			":love_you_gesture_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f-1f3fe",
			"fully_qualified": "1f91f-1f3fe",
			"non_fully_qualified": "1f91f-1f3fe",
			"output": "1f91f-1f3fe",
			"default_matches": [
				"1f91f-1f3fe"
			],
			"greedy_matches": [
				"1f91f-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"hand",
			"medium-dark skin tone"
		]
	},
	"1f91f-1f3ff": {
		"name": "love-you gesture: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2546,
		"display": 1,
		"shortname": ":love_you_gesture_tone5:",
		"shortname_alternates": [
			":love_you_gesture_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f91f-1f3ff",
			"fully_qualified": "1f91f-1f3ff",
			"non_fully_qualified": "1f91f-1f3ff",
			"output": "1f91f-1f3ff",
			"default_matches": [
				"1f91f-1f3ff"
			],
			"greedy_matches": [
				"1f91f-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"ILY",
			"dark skin tone",
			"hand"
		]
	},
	"1f932": {
		"name": "palms up together",
		"unicode_version": 10,
		"category": "people",
		"order": 2547,
		"display": 1,
		"shortname": ":palms_up_together:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f932-1f3fb",
			"1f932-1f3fc",
			"1f932-1f3fd",
			"1f932-1f3fe",
			"1f932-1f3ff"
		],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932",
			"fully_qualified": "1f932",
			"non_fully_qualified": "1f932",
			"output": "1f932",
			"default_matches": [
				"1f932"
			],
			"greedy_matches": [
				"1f932"
			],
			"decimal": ""
		},
		"keywords": [
			""
		]
	},
	"1f932-1f3fb": {
		"name": "palms up together: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2548,
		"display": 1,
		"shortname": ":palms_up_together_tone1:",
		"shortname_alternates": [
			":palms_up_together_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932-1f3fb",
			"fully_qualified": "1f932-1f3fb",
			"non_fully_qualified": "1f932-1f3fb",
			"output": "1f932-1f3fb",
			"default_matches": [
				"1f932-1f3fb"
			],
			"greedy_matches": [
				"1f932-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"prayer"
		]
	},
	"1f932-1f3fc": {
		"name": "palms up together: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2549,
		"display": 1,
		"shortname": ":palms_up_together_tone2:",
		"shortname_alternates": [
			":palms_up_together_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932-1f3fc",
			"fully_qualified": "1f932-1f3fc",
			"non_fully_qualified": "1f932-1f3fc",
			"output": "1f932-1f3fc",
			"default_matches": [
				"1f932-1f3fc"
			],
			"greedy_matches": [
				"1f932-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"prayer"
		]
	},
	"1f932-1f3fd": {
		"name": "palms up together: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2550,
		"display": 1,
		"shortname": ":palms_up_together_tone3:",
		"shortname_alternates": [
			":palms_up_together_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932-1f3fd",
			"fully_qualified": "1f932-1f3fd",
			"non_fully_qualified": "1f932-1f3fd",
			"output": "1f932-1f3fd",
			"default_matches": [
				"1f932-1f3fd"
			],
			"greedy_matches": [
				"1f932-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"prayer"
		]
	},
	"1f932-1f3fe": {
		"name": "palms up together: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2551,
		"display": 1,
		"shortname": ":palms_up_together_tone4:",
		"shortname_alternates": [
			":palms_up_together_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932-1f3fe",
			"fully_qualified": "1f932-1f3fe",
			"non_fully_qualified": "1f932-1f3fe",
			"output": "1f932-1f3fe",
			"default_matches": [
				"1f932-1f3fe"
			],
			"greedy_matches": [
				"1f932-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"prayer"
		]
	},
	"1f932-1f3ff": {
		"name": "palms up together: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2552,
		"display": 1,
		"shortname": ":palms_up_together_tone5:",
		"shortname_alternates": [
			":palms_up_together_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f932-1f3ff",
			"fully_qualified": "1f932-1f3ff",
			"non_fully_qualified": "1f932-1f3ff",
			"output": "1f932-1f3ff",
			"default_matches": [
				"1f932-1f3ff"
			],
			"greedy_matches": [
				"1f932-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"prayer"
		]
	},
	"1f9d1-1f3fb": {
		"name": "adult: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2553,
		"display": 1,
		"shortname": ":adult_tone1:",
		"shortname_alternates": [
			":adult_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1-1f3fb",
			"fully_qualified": "1f9d1-1f3fb",
			"non_fully_qualified": "1f9d1-1f3fb",
			"output": "1f9d1-1f3fb",
			"default_matches": [
				"1f9d1-1f3fb"
			],
			"greedy_matches": [
				"1f9d1-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"light skin tone"
		]
	},
	"1f9d1-1f3fc": {
		"name": "adult: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2554,
		"display": 1,
		"shortname": ":adult_tone2:",
		"shortname_alternates": [
			":adult_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1-1f3fc",
			"fully_qualified": "1f9d1-1f3fc",
			"non_fully_qualified": "1f9d1-1f3fc",
			"output": "1f9d1-1f3fc",
			"default_matches": [
				"1f9d1-1f3fc"
			],
			"greedy_matches": [
				"1f9d1-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-light skin tone"
		]
	},
	"1f9d1-1f3fd": {
		"name": "adult: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2555,
		"display": 1,
		"shortname": ":adult_tone3:",
		"shortname_alternates": [
			":adult_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1-1f3fd",
			"fully_qualified": "1f9d1-1f3fd",
			"non_fully_qualified": "1f9d1-1f3fd",
			"output": "1f9d1-1f3fd",
			"default_matches": [
				"1f9d1-1f3fd"
			],
			"greedy_matches": [
				"1f9d1-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium skin tone"
		]
	},
	"1f9d1-1f3fe": {
		"name": "adult: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2556,
		"display": 1,
		"shortname": ":adult_tone4:",
		"shortname_alternates": [
			":adult_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1-1f3fe",
			"fully_qualified": "1f9d1-1f3fe",
			"non_fully_qualified": "1f9d1-1f3fe",
			"output": "1f9d1-1f3fe",
			"default_matches": [
				"1f9d1-1f3fe"
			],
			"greedy_matches": [
				"1f9d1-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-dark skin tone"
		]
	},
	"1f9d1-1f3ff": {
		"name": "adult: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2557,
		"display": 1,
		"shortname": ":adult_tone5:",
		"shortname_alternates": [
			":adult_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d1-1f3ff",
			"fully_qualified": "1f9d1-1f3ff",
			"non_fully_qualified": "1f9d1-1f3ff",
			"output": "1f9d1-1f3ff",
			"default_matches": [
				"1f9d1-1f3ff"
			],
			"greedy_matches": [
				"1f9d1-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gender-neutral"
		]
	},
	"1f9d2-1f3fb": {
		"name": "child: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2558,
		"display": 1,
		"shortname": ":child_tone1:",
		"shortname_alternates": [
			":child_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2-1f3fb",
			"fully_qualified": "1f9d2-1f3fb",
			"non_fully_qualified": "1f9d2-1f3fb",
			"output": "1f9d2-1f3fb",
			"default_matches": [
				"1f9d2-1f3fb"
			],
			"greedy_matches": [
				"1f9d2-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"light skin tone",
			"young"
		]
	},
	"1f9d2-1f3fc": {
		"name": "child: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2559,
		"display": 1,
		"shortname": ":child_tone2:",
		"shortname_alternates": [
			":child_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2-1f3fc",
			"fully_qualified": "1f9d2-1f3fc",
			"non_fully_qualified": "1f9d2-1f3fc",
			"output": "1f9d2-1f3fc",
			"default_matches": [
				"1f9d2-1f3fc"
			],
			"greedy_matches": [
				"1f9d2-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-light skin tone",
			"young"
		]
	},
	"1f9d2-1f3fd": {
		"name": "child: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2560,
		"display": 1,
		"shortname": ":child_tone3:",
		"shortname_alternates": [
			":child_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2-1f3fd",
			"fully_qualified": "1f9d2-1f3fd",
			"non_fully_qualified": "1f9d2-1f3fd",
			"output": "1f9d2-1f3fd",
			"default_matches": [
				"1f9d2-1f3fd"
			],
			"greedy_matches": [
				"1f9d2-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium skin tone",
			"young"
		]
	},
	"1f9d2-1f3fe": {
		"name": "child: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2561,
		"display": 1,
		"shortname": ":child_tone4:",
		"shortname_alternates": [
			":child_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2-1f3fe",
			"fully_qualified": "1f9d2-1f3fe",
			"non_fully_qualified": "1f9d2-1f3fe",
			"output": "1f9d2-1f3fe",
			"default_matches": [
				"1f9d2-1f3fe"
			],
			"greedy_matches": [
				"1f9d2-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-dark skin tone",
			"young"
		]
	},
	"1f9d2-1f3ff": {
		"name": "child: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2562,
		"display": 1,
		"shortname": ":child_tone5:",
		"shortname_alternates": [
			":child_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d2-1f3ff",
			"fully_qualified": "1f9d2-1f3ff",
			"non_fully_qualified": "1f9d2-1f3ff",
			"output": "1f9d2-1f3ff",
			"default_matches": [
				"1f9d2-1f3ff"
			],
			"greedy_matches": [
				"1f9d2-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gender-neutral",
			"young"
		]
	},
	"1f9d3-1f3fb": {
		"name": "older adult: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2563,
		"display": 1,
		"shortname": ":older_adult_tone1:",
		"shortname_alternates": [
			":older_adult_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3-1f3fb",
			"fully_qualified": "1f9d3-1f3fb",
			"non_fully_qualified": "1f9d3-1f3fb",
			"output": "1f9d3-1f3fb",
			"default_matches": [
				"1f9d3-1f3fb"
			],
			"greedy_matches": [
				"1f9d3-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"light skin tone",
			"old"
		]
	},
	"1f9d3-1f3fc": {
		"name": "older adult: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2564,
		"display": 1,
		"shortname": ":older_adult_tone2:",
		"shortname_alternates": [
			":older_adult_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3-1f3fc",
			"fully_qualified": "1f9d3-1f3fc",
			"non_fully_qualified": "1f9d3-1f3fc",
			"output": "1f9d3-1f3fc",
			"default_matches": [
				"1f9d3-1f3fc"
			],
			"greedy_matches": [
				"1f9d3-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-light skin tone",
			"old"
		]
	},
	"1f9d3-1f3fd": {
		"name": "older adult: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2565,
		"display": 1,
		"shortname": ":older_adult_tone3:",
		"shortname_alternates": [
			":older_adult_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3-1f3fd",
			"fully_qualified": "1f9d3-1f3fd",
			"non_fully_qualified": "1f9d3-1f3fd",
			"output": "1f9d3-1f3fd",
			"default_matches": [
				"1f9d3-1f3fd"
			],
			"greedy_matches": [
				"1f9d3-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium skin tone",
			"old"
		]
	},
	"1f9d3-1f3fe": {
		"name": "older adult: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2566,
		"display": 1,
		"shortname": ":older_adult_tone4:",
		"shortname_alternates": [
			":older_adult_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3-1f3fe",
			"fully_qualified": "1f9d3-1f3fe",
			"non_fully_qualified": "1f9d3-1f3fe",
			"output": "1f9d3-1f3fe",
			"default_matches": [
				"1f9d3-1f3fe"
			],
			"greedy_matches": [
				"1f9d3-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"gender-neutral",
			"medium-dark skin tone",
			"old"
		]
	},
	"1f9d3-1f3ff": {
		"name": "older adult: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2567,
		"display": 1,
		"shortname": ":older_adult_tone5:",
		"shortname_alternates": [
			":older_adult_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d3-1f3ff",
			"fully_qualified": "1f9d3-1f3ff",
			"non_fully_qualified": "1f9d3-1f3ff",
			"output": "1f9d3-1f3ff",
			"default_matches": [
				"1f9d3-1f3ff"
			],
			"greedy_matches": [
				"1f9d3-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"gender-neutral",
			"old"
		]
	},
	"1f9d4-1f3fb": {
		"name": "bearded person: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2568,
		"display": 1,
		"shortname": ":bearded_person_tone1:",
		"shortname_alternates": [
			":bearded_person_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4-1f3fb",
			"fully_qualified": "1f9d4-1f3fb",
			"non_fully_qualified": "1f9d4-1f3fb",
			"output": "1f9d4-1f3fb",
			"default_matches": [
				"1f9d4-1f3fb"
			],
			"greedy_matches": [
				"1f9d4-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"beard",
			"light skin tone"
		]
	},
	"1f9d4-1f3fc": {
		"name": "bearded person: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2569,
		"display": 1,
		"shortname": ":bearded_person_tone2:",
		"shortname_alternates": [
			":bearded_person_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4-1f3fc",
			"fully_qualified": "1f9d4-1f3fc",
			"non_fully_qualified": "1f9d4-1f3fc",
			"output": "1f9d4-1f3fc",
			"default_matches": [
				"1f9d4-1f3fc"
			],
			"greedy_matches": [
				"1f9d4-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"beard",
			"medium-light skin tone"
		]
	},
	"1f9d4-1f3fd": {
		"name": "bearded person: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2570,
		"display": 1,
		"shortname": ":bearded_person_tone3:",
		"shortname_alternates": [
			":bearded_person_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4-1f3fd",
			"fully_qualified": "1f9d4-1f3fd",
			"non_fully_qualified": "1f9d4-1f3fd",
			"output": "1f9d4-1f3fd",
			"default_matches": [
				"1f9d4-1f3fd"
			],
			"greedy_matches": [
				"1f9d4-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"beard",
			"medium skin tone"
		]
	},
	"1f9d4-1f3fe": {
		"name": "bearded person: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2571,
		"display": 1,
		"shortname": ":bearded_person_tone4:",
		"shortname_alternates": [
			":bearded_person_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4-1f3fe",
			"fully_qualified": "1f9d4-1f3fe",
			"non_fully_qualified": "1f9d4-1f3fe",
			"output": "1f9d4-1f3fe",
			"default_matches": [
				"1f9d4-1f3fe"
			],
			"greedy_matches": [
				"1f9d4-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"beard",
			"medium-dark skin tone"
		]
	},
	"1f9d4-1f3ff": {
		"name": "bearded person: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2572,
		"display": 1,
		"shortname": ":bearded_person_tone5:",
		"shortname_alternates": [
			":bearded_person_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d4-1f3ff",
			"fully_qualified": "1f9d4-1f3ff",
			"non_fully_qualified": "1f9d4-1f3ff",
			"output": "1f9d4-1f3ff",
			"default_matches": [
				"1f9d4-1f3ff"
			],
			"greedy_matches": [
				"1f9d4-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"beard",
			"dark skin tone"
		]
	},
	"1f9d5-1f3fb": {
		"name": "woman with headscarf: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2573,
		"display": 1,
		"shortname": ":woman_with_headscarf_tone1:",
		"shortname_alternates": [
			":woman_with_headscarf_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5-1f3fb",
			"fully_qualified": "1f9d5-1f3fb",
			"non_fully_qualified": "1f9d5-1f3fb",
			"output": "1f9d5-1f3fb",
			"default_matches": [
				"1f9d5-1f3fb"
			],
			"greedy_matches": [
				"1f9d5-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"headscarf",
			"hijab",
			"light skin tone",
			"mantilla",
			"tichel"
		]
	},
	"1f9d5-1f3fc": {
		"name": "woman with headscarf: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2574,
		"display": 1,
		"shortname": ":woman_with_headscarf_tone2:",
		"shortname_alternates": [
			":woman_with_headscarf_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5-1f3fc",
			"fully_qualified": "1f9d5-1f3fc",
			"non_fully_qualified": "1f9d5-1f3fc",
			"output": "1f9d5-1f3fc",
			"default_matches": [
				"1f9d5-1f3fc"
			],
			"greedy_matches": [
				"1f9d5-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"headscarf",
			"hijab",
			"mantilla",
			"medium-light skin tone",
			"tichel"
		]
	},
	"1f9d5-1f3fd": {
		"name": "woman with headscarf: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2575,
		"display": 1,
		"shortname": ":woman_with_headscarf_tone3:",
		"shortname_alternates": [
			":woman_with_headscarf_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5-1f3fd",
			"fully_qualified": "1f9d5-1f3fd",
			"non_fully_qualified": "1f9d5-1f3fd",
			"output": "1f9d5-1f3fd",
			"default_matches": [
				"1f9d5-1f3fd"
			],
			"greedy_matches": [
				"1f9d5-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"headscarf",
			"hijab",
			"mantilla",
			"medium skin tone",
			"tichel"
		]
	},
	"1f9d5-1f3fe": {
		"name": "woman with headscarf: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2576,
		"display": 1,
		"shortname": ":woman_with_headscarf_tone4:",
		"shortname_alternates": [
			":woman_with_headscarf_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5-1f3fe",
			"fully_qualified": "1f9d5-1f3fe",
			"non_fully_qualified": "1f9d5-1f3fe",
			"output": "1f9d5-1f3fe",
			"default_matches": [
				"1f9d5-1f3fe"
			],
			"greedy_matches": [
				"1f9d5-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"headscarf",
			"hijab",
			"mantilla",
			"medium-dark skin tone",
			"tichel"
		]
	},
	"1f9d5-1f3ff": {
		"name": "woman with headscarf: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2577,
		"display": 1,
		"shortname": ":woman_with_headscarf_tone5:",
		"shortname_alternates": [
			":woman_with_headscarf_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [],
		"code_points": {
			"base": "1f9d5-1f3ff",
			"fully_qualified": "1f9d5-1f3ff",
			"non_fully_qualified": "1f9d5-1f3ff",
			"output": "1f9d5-1f3ff",
			"default_matches": [
				"1f9d5-1f3ff"
			],
			"greedy_matches": [
				"1f9d5-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"headscarf",
			"hijab",
			"mantilla",
			"tichel"
		]
	},
	"1f9d9-1f3fb": {
		"name": "mage: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2578,
		"display": 0,
		"shortname": ":mage_tone1:",
		"shortname_alternates": [
			":mage_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d9-1f3fb-2640",
			"1f9d9-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9d9-1f3fb",
			"fully_qualified": "1f9d9-1f3fb",
			"non_fully_qualified": "1f9d9-1f3fb",
			"output": "1f9d9-1f3fb",
			"default_matches": [
				"1f9d9-1f3fb"
			],
			"greedy_matches": [
				"1f9d9-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9d9-1f3fc": {
		"name": "mage: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2579,
		"display": 0,
		"shortname": ":mage_tone2:",
		"shortname_alternates": [
			":mage_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d9-1f3fc-2640",
			"1f9d9-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9d9-1f3fc",
			"fully_qualified": "1f9d9-1f3fc",
			"non_fully_qualified": "1f9d9-1f3fc",
			"output": "1f9d9-1f3fc",
			"default_matches": [
				"1f9d9-1f3fc"
			],
			"greedy_matches": [
				"1f9d9-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9d9-1f3fd": {
		"name": "mage: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2580,
		"display": 0,
		"shortname": ":mage_tone3:",
		"shortname_alternates": [
			":mage_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d9-1f3fd-2640",
			"1f9d9-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9d9-1f3fd",
			"fully_qualified": "1f9d9-1f3fd",
			"non_fully_qualified": "1f9d9-1f3fd",
			"output": "1f9d9-1f3fd",
			"default_matches": [
				"1f9d9-1f3fd"
			],
			"greedy_matches": [
				"1f9d9-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9d9-1f3fe": {
		"name": "mage: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2581,
		"display": 0,
		"shortname": ":mage_tone4:",
		"shortname_alternates": [
			":mage_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d9-1f3fe-2640",
			"1f9d9-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9d9-1f3fe",
			"fully_qualified": "1f9d9-1f3fe",
			"non_fully_qualified": "1f9d9-1f3fe",
			"output": "1f9d9-1f3fe",
			"default_matches": [
				"1f9d9-1f3fe"
			],
			"greedy_matches": [
				"1f9d9-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9d9-1f3ff": {
		"name": "mage: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2582,
		"display": 0,
		"shortname": ":mage_tone5:",
		"shortname_alternates": [
			":mage_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9d9-1f3ff-2640",
			"1f9d9-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9d9-1f3ff",
			"fully_qualified": "1f9d9-1f3ff",
			"non_fully_qualified": "1f9d9-1f3ff",
			"output": "1f9d9-1f3ff",
			"default_matches": [
				"1f9d9-1f3ff"
			],
			"greedy_matches": [
				"1f9d9-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sorcerer",
			"sorceress",
			"witch",
			"wizard"
		]
	},
	"1f9da-1f3fb": {
		"name": "fairy: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2583,
		"display": 0,
		"shortname": ":fairy_tone1:",
		"shortname_alternates": [
			":fairy_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9da-1f3fb-2640",
			"1f9da-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9da-1f3fb",
			"fully_qualified": "1f9da-1f3fb",
			"non_fully_qualified": "1f9da-1f3fb",
			"output": "1f9da-1f3fb",
			"default_matches": [
				"1f9da-1f3fb"
			],
			"greedy_matches": [
				"1f9da-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania",
			"light skin tone"
		]
	},
	"1f9da-1f3fc": {
		"name": "fairy: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2584,
		"display": 0,
		"shortname": ":fairy_tone2:",
		"shortname_alternates": [
			":fairy_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9da-1f3fc-2640",
			"1f9da-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9da-1f3fc",
			"fully_qualified": "1f9da-1f3fc",
			"non_fully_qualified": "1f9da-1f3fc",
			"output": "1f9da-1f3fc",
			"default_matches": [
				"1f9da-1f3fc"
			],
			"greedy_matches": [
				"1f9da-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania",
			"medium-light skin tone"
		]
	},
	"1f9da-1f3fd": {
		"name": "fairy: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2585,
		"display": 0,
		"shortname": ":fairy_tone3:",
		"shortname_alternates": [
			":fairy_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9da-1f3fd-2640",
			"1f9da-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9da-1f3fd",
			"fully_qualified": "1f9da-1f3fd",
			"non_fully_qualified": "1f9da-1f3fd",
			"output": "1f9da-1f3fd",
			"default_matches": [
				"1f9da-1f3fd"
			],
			"greedy_matches": [
				"1f9da-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania",
			"medium skin tone"
		]
	},
	"1f9da-1f3fe": {
		"name": "fairy: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2586,
		"display": 0,
		"shortname": ":fairy_tone4:",
		"shortname_alternates": [
			":fairy_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9da-1f3fe-2640",
			"1f9da-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9da-1f3fe",
			"fully_qualified": "1f9da-1f3fe",
			"non_fully_qualified": "1f9da-1f3fe",
			"output": "1f9da-1f3fe",
			"default_matches": [
				"1f9da-1f3fe"
			],
			"greedy_matches": [
				"1f9da-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania",
			"medium-dark skin tone"
		]
	},
	"1f9da-1f3ff": {
		"name": "fairy: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2587,
		"display": 0,
		"shortname": ":fairy_tone5:",
		"shortname_alternates": [
			":fairy_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9da-1f3ff-2640",
			"1f9da-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9da-1f3ff",
			"fully_qualified": "1f9da-1f3ff",
			"non_fully_qualified": "1f9da-1f3ff",
			"output": "1f9da-1f3ff",
			"default_matches": [
				"1f9da-1f3ff"
			],
			"greedy_matches": [
				"1f9da-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"Titania",
			"dark skin tone"
		]
	},
	"1f9db-1f3fb": {
		"name": "vampire: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2588,
		"display": 0,
		"shortname": ":vampire_tone1:",
		"shortname_alternates": [
			":vampire_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9db-1f3fb-2640",
			"1f9db-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9db-1f3fb",
			"fully_qualified": "1f9db-1f3fb",
			"non_fully_qualified": "1f9db-1f3fb",
			"output": "1f9db-1f3fb",
			"default_matches": [
				"1f9db-1f3fb"
			],
			"greedy_matches": [
				"1f9db-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fc": {
		"name": "vampire: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2589,
		"display": 0,
		"shortname": ":vampire_tone2:",
		"shortname_alternates": [
			":vampire_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9db-1f3fc-2640",
			"1f9db-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9db-1f3fc",
			"fully_qualified": "1f9db-1f3fc",
			"non_fully_qualified": "1f9db-1f3fc",
			"output": "1f9db-1f3fc",
			"default_matches": [
				"1f9db-1f3fc"
			],
			"greedy_matches": [
				"1f9db-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium-light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fd": {
		"name": "vampire: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2590,
		"display": 0,
		"shortname": ":vampire_tone3:",
		"shortname_alternates": [
			":vampire_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9db-1f3fd-2640",
			"1f9db-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9db-1f3fd",
			"fully_qualified": "1f9db-1f3fd",
			"non_fully_qualified": "1f9db-1f3fd",
			"output": "1f9db-1f3fd",
			"default_matches": [
				"1f9db-1f3fd"
			],
			"greedy_matches": [
				"1f9db-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium skin tone",
			"undead"
		]
	},
	"1f9db-1f3fe": {
		"name": "vampire: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2591,
		"display": 0,
		"shortname": ":vampire_tone4:",
		"shortname_alternates": [
			":vampire_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9db-1f3fe-2640",
			"1f9db-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9db-1f3fe",
			"fully_qualified": "1f9db-1f3fe",
			"non_fully_qualified": "1f9db-1f3fe",
			"output": "1f9db-1f3fe",
			"default_matches": [
				"1f9db-1f3fe"
			],
			"greedy_matches": [
				"1f9db-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium-dark skin tone",
			"undead"
		]
	},
	"1f9db-1f3ff": {
		"name": "vampire: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2592,
		"display": 0,
		"shortname": ":vampire_tone5:",
		"shortname_alternates": [
			":vampire_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9db-1f3ff-2640",
			"1f9db-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9db-1f3ff",
			"fully_qualified": "1f9db-1f3ff",
			"non_fully_qualified": "1f9db-1f3ff",
			"output": "1f9db-1f3ff",
			"default_matches": [
				"1f9db-1f3ff"
			],
			"greedy_matches": [
				"1f9db-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"dark skin tone",
			"undead"
		]
	},
	"1f9dc-1f3fb": {
		"name": "merperson: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2593,
		"display": 0,
		"shortname": ":merperson_tone1:",
		"shortname_alternates": [
			":merperson_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dc-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9dc-1f3fb",
			"fully_qualified": "1f9dc-1f3fb",
			"non_fully_qualified": "1f9dc-1f3fb",
			"output": "1f9dc-1f3fb",
			"default_matches": [
				"1f9dc-1f3fb"
			],
			"greedy_matches": [
				"1f9dc-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dc-1f3fc": {
		"name": "merperson: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2594,
		"display": 0,
		"shortname": ":merperson_tone2:",
		"shortname_alternates": [
			":merperson_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dc-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9dc-1f3fc",
			"fully_qualified": "1f9dc-1f3fc",
			"non_fully_qualified": "1f9dc-1f3fc",
			"output": "1f9dc-1f3fc",
			"default_matches": [
				"1f9dc-1f3fc"
			],
			"greedy_matches": [
				"1f9dc-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dc-1f3fd": {
		"name": "merperson: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2595,
		"display": 0,
		"shortname": ":merperson_tone3:",
		"shortname_alternates": [
			":merperson_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dc-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9dc-1f3fd",
			"fully_qualified": "1f9dc-1f3fd",
			"non_fully_qualified": "1f9dc-1f3fd",
			"output": "1f9dc-1f3fd",
			"default_matches": [
				"1f9dc-1f3fd"
			],
			"greedy_matches": [
				"1f9dc-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dc-1f3fe": {
		"name": "merperson: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2596,
		"display": 0,
		"shortname": ":merperson_tone4:",
		"shortname_alternates": [
			":merperson_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dc-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9dc-1f3fe",
			"fully_qualified": "1f9dc-1f3fe",
			"non_fully_qualified": "1f9dc-1f3fe",
			"output": "1f9dc-1f3fe",
			"default_matches": [
				"1f9dc-1f3fe"
			],
			"greedy_matches": [
				"1f9dc-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dc-1f3ff": {
		"name": "merperson: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2597,
		"display": 0,
		"shortname": ":merperson_tone5:",
		"shortname_alternates": [
			":merperson_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dc-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9dc-1f3ff",
			"fully_qualified": "1f9dc-1f3ff",
			"non_fully_qualified": "1f9dc-1f3ff",
			"output": "1f9dc-1f3ff",
			"default_matches": [
				"1f9dc-1f3ff"
			],
			"greedy_matches": [
				"1f9dc-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"mermaid",
			"merman",
			"merwoman"
		]
	},
	"1f9dd-1f3fb": {
		"name": "elf: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2598,
		"display": 0,
		"shortname": ":elf_tone1:",
		"shortname_alternates": [
			":elf_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dd-1f3fb-2640",
			"1f9dd-1f3fb-2642"
		],
		"code_points": {
			"base": "1f9dd-1f3fb",
			"fully_qualified": "1f9dd-1f3fb",
			"non_fully_qualified": "1f9dd-1f3fb",
			"output": "1f9dd-1f3fb",
			"default_matches": [
				"1f9dd-1f3fb"
			],
			"greedy_matches": [
				"1f9dd-1f3fb"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"magical"
		]
	},
	"1f9dd-1f3fc": {
		"name": "elf: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2599,
		"display": 0,
		"shortname": ":elf_tone2:",
		"shortname_alternates": [
			":elf_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dd-1f3fc-2640",
			"1f9dd-1f3fc-2642"
		],
		"code_points": {
			"base": "1f9dd-1f3fc",
			"fully_qualified": "1f9dd-1f3fc",
			"non_fully_qualified": "1f9dd-1f3fc",
			"output": "1f9dd-1f3fc",
			"default_matches": [
				"1f9dd-1f3fc"
			],
			"greedy_matches": [
				"1f9dd-1f3fc"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-light skin tone"
		]
	},
	"1f9dd-1f3fd": {
		"name": "elf: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2600,
		"display": 0,
		"shortname": ":elf_tone3:",
		"shortname_alternates": [
			":elf_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dd-1f3fd-2640",
			"1f9dd-1f3fd-2642"
		],
		"code_points": {
			"base": "1f9dd-1f3fd",
			"fully_qualified": "1f9dd-1f3fd",
			"non_fully_qualified": "1f9dd-1f3fd",
			"output": "1f9dd-1f3fd",
			"default_matches": [
				"1f9dd-1f3fd"
			],
			"greedy_matches": [
				"1f9dd-1f3fd"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium skin tone"
		]
	},
	"1f9dd-1f3fe": {
		"name": "elf: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2601,
		"display": 0,
		"shortname": ":elf_tone4:",
		"shortname_alternates": [
			":elf_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dd-1f3fe-2640",
			"1f9dd-1f3fe-2642"
		],
		"code_points": {
			"base": "1f9dd-1f3fe",
			"fully_qualified": "1f9dd-1f3fe",
			"non_fully_qualified": "1f9dd-1f3fe",
			"output": "1f9dd-1f3fe",
			"default_matches": [
				"1f9dd-1f3fe"
			],
			"greedy_matches": [
				"1f9dd-1f3fe"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-dark skin tone"
		]
	},
	"1f9dd-1f3ff": {
		"name": "elf: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2602,
		"display": 0,
		"shortname": ":elf_tone5:",
		"shortname_alternates": [
			":elf_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": null,
		"genders": [
			"1f9dd-1f3ff-2640",
			"1f9dd-1f3ff-2642"
		],
		"code_points": {
			"base": "1f9dd-1f3ff",
			"fully_qualified": "1f9dd-1f3ff",
			"non_fully_qualified": "1f9dd-1f3ff",
			"output": "1f9dd-1f3ff",
			"default_matches": [
				"1f9dd-1f3ff"
			],
			"greedy_matches": [
				"1f9dd-1f3ff"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"magical"
		]
	},
	"1f9d9-2640": {
		"name": "woman mage",
		"unicode_version": 10,
		"category": "people",
		"order": 2603,
		"display": 1,
		"shortname": ":woman_mage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d9-1f3fb-2640",
			"1f9d9-1f3fc-2640",
			"1f9d9-1f3fd-2640",
			"1f9d9-1f3fe-2640",
			"1f9d9-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-2640",
			"fully_qualified": "1f9d9-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-200d-2640",
			"output": "1f9d9-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-200d-2640-fe0f",
				"1f9d9-200d-2640",
				"1f9d9-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-200d-2640-fe0f",
				"1f9d9-200d-2640",
				"1f9d9-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"sorceress",
			"witch"
		]
	},
	"1f9d9-2642": {
		"name": "man mage",
		"unicode_version": 10,
		"category": "people",
		"order": 2604,
		"display": 1,
		"shortname": ":man_mage:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9d9-1f3fb-2642",
			"1f9d9-1f3fc-2642",
			"1f9d9-1f3fd-2642",
			"1f9d9-1f3fe-2642",
			"1f9d9-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-2642",
			"fully_qualified": "1f9d9-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-200d-2642",
			"output": "1f9d9-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-200d-2642-fe0f",
				"1f9d9-200d-2642",
				"1f9d9-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-200d-2642-fe0f",
				"1f9d9-200d-2642",
				"1f9d9-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"sorcerer",
			"wizard"
		]
	},
	"1f9d9-1f3fb-2640": {
		"name": "woman mage: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2605,
		"display": 1,
		"shortname": ":woman_mage_tone1:",
		"shortname_alternates": [
			":woman_mage_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fb-2640",
			"fully_qualified": "1f9d9-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-1f3fb-200d-2640",
			"output": "1f9d9-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-1f3fb-200d-2640-fe0f",
				"1f9d9-1f3fb-200d-2640",
				"1f9d9-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fb-200d-2640-fe0f",
				"1f9d9-1f3fb-200d-2640",
				"1f9d9-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sorceress",
			"witch"
		]
	},
	"1f9d9-1f3fb-2642": {
		"name": "man mage: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2606,
		"display": 1,
		"shortname": ":man_mage_tone1:",
		"shortname_alternates": [
			":man_mage_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fb-2642",
			"fully_qualified": "1f9d9-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-1f3fb-200d-2642",
			"output": "1f9d9-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-1f3fb-200d-2642-fe0f",
				"1f9d9-1f3fb-200d-2642",
				"1f9d9-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fb-200d-2642-fe0f",
				"1f9d9-1f3fb-200d-2642",
				"1f9d9-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"sorcerer",
			"wizard"
		]
	},
	"1f9d9-1f3fc-2640": {
		"name": "woman mage: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2607,
		"display": 1,
		"shortname": ":woman_mage_tone2:",
		"shortname_alternates": [
			":woman_mage_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fc-2640",
			"fully_qualified": "1f9d9-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-1f3fc-200d-2640",
			"output": "1f9d9-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-1f3fc-200d-2640-fe0f",
				"1f9d9-1f3fc-200d-2640",
				"1f9d9-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fc-200d-2640-fe0f",
				"1f9d9-1f3fc-200d-2640",
				"1f9d9-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sorceress",
			"witch"
		]
	},
	"1f9d9-1f3fc-2642": {
		"name": "man mage: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2608,
		"display": 1,
		"shortname": ":man_mage_tone2:",
		"shortname_alternates": [
			":man_mage_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fc-2642",
			"fully_qualified": "1f9d9-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-1f3fc-200d-2642",
			"output": "1f9d9-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-1f3fc-200d-2642-fe0f",
				"1f9d9-1f3fc-200d-2642",
				"1f9d9-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fc-200d-2642-fe0f",
				"1f9d9-1f3fc-200d-2642",
				"1f9d9-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"sorcerer",
			"wizard"
		]
	},
	"1f9d9-1f3fd-2640": {
		"name": "woman mage: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2609,
		"display": 1,
		"shortname": ":woman_mage_tone3:",
		"shortname_alternates": [
			":woman_mage_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fd-2640",
			"fully_qualified": "1f9d9-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-1f3fd-200d-2640",
			"output": "1f9d9-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-1f3fd-200d-2640-fe0f",
				"1f9d9-1f3fd-200d-2640",
				"1f9d9-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fd-200d-2640-fe0f",
				"1f9d9-1f3fd-200d-2640",
				"1f9d9-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sorceress",
			"witch"
		]
	},
	"1f9d9-1f3fd-2642": {
		"name": "man mage: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2610,
		"display": 1,
		"shortname": ":man_mage_tone3:",
		"shortname_alternates": [
			":man_mage_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fd-2642",
			"fully_qualified": "1f9d9-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-1f3fd-200d-2642",
			"output": "1f9d9-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-1f3fd-200d-2642-fe0f",
				"1f9d9-1f3fd-200d-2642",
				"1f9d9-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fd-200d-2642-fe0f",
				"1f9d9-1f3fd-200d-2642",
				"1f9d9-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"sorcerer",
			"wizard"
		]
	},
	"1f9d9-1f3fe-2640": {
		"name": "woman mage: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2611,
		"display": 1,
		"shortname": ":woman_mage_tone4:",
		"shortname_alternates": [
			":woman_mage_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fe-2640",
			"fully_qualified": "1f9d9-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-1f3fe-200d-2640",
			"output": "1f9d9-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-1f3fe-200d-2640-fe0f",
				"1f9d9-1f3fe-200d-2640",
				"1f9d9-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fe-200d-2640-fe0f",
				"1f9d9-1f3fe-200d-2640",
				"1f9d9-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sorceress",
			"witch"
		]
	},
	"1f9d9-1f3fe-2642": {
		"name": "man mage: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2612,
		"display": 1,
		"shortname": ":man_mage_tone4:",
		"shortname_alternates": [
			":man_mage_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3fe-2642",
			"fully_qualified": "1f9d9-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-1f3fe-200d-2642",
			"output": "1f9d9-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-1f3fe-200d-2642-fe0f",
				"1f9d9-1f3fe-200d-2642",
				"1f9d9-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3fe-200d-2642-fe0f",
				"1f9d9-1f3fe-200d-2642",
				"1f9d9-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"sorcerer",
			"wizard"
		]
	},
	"1f9d9-1f3ff-2640": {
		"name": "woman mage: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2613,
		"display": 1,
		"shortname": ":woman_mage_tone5:",
		"shortname_alternates": [
			":woman_mage_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3ff-2640",
			"fully_qualified": "1f9d9-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9d9-1f3ff-200d-2640",
			"output": "1f9d9-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9d9-1f3ff-200d-2640-fe0f",
				"1f9d9-1f3ff-200d-2640",
				"1f9d9-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3ff-200d-2640-fe0f",
				"1f9d9-1f3ff-200d-2640",
				"1f9d9-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sorceress",
			"witch"
		]
	},
	"1f9d9-1f3ff-2642": {
		"name": "man mage: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2614,
		"display": 1,
		"shortname": ":man_mage_tone5:",
		"shortname_alternates": [
			":man_mage_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9d9-1f3ff-2642",
			"fully_qualified": "1f9d9-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9d9-1f3ff-200d-2642",
			"output": "1f9d9-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9d9-1f3ff-200d-2642-fe0f",
				"1f9d9-1f3ff-200d-2642",
				"1f9d9-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9d9-1f3ff-200d-2642-fe0f",
				"1f9d9-1f3ff-200d-2642",
				"1f9d9-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"sorcerer",
			"wizard"
		]
	},
	"1f9da-2640": {
		"name": "woman fairy",
		"unicode_version": 10,
		"category": "people",
		"order": 2615,
		"display": 1,
		"shortname": ":woman_fairy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9da-1f3fb-2640",
			"1f9da-1f3fc-2640",
			"1f9da-1f3fd-2640",
			"1f9da-1f3fe-2640",
			"1f9da-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-2640",
			"fully_qualified": "1f9da-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-200d-2640",
			"output": "1f9da-200d-2640-fe0f",
			"default_matches": [
				"1f9da-200d-2640-fe0f",
				"1f9da-200d-2640",
				"1f9da-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-200d-2640-fe0f",
				"1f9da-200d-2640",
				"1f9da-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania"
		]
	},
	"1f9da-2642": {
		"name": "man fairy",
		"unicode_version": 10,
		"category": "people",
		"order": 2616,
		"display": 1,
		"shortname": ":man_fairy:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9da-1f3fb-2642",
			"1f9da-1f3fc-2642",
			"1f9da-1f3fd-2642",
			"1f9da-1f3fe-2642",
			"1f9da-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-2642",
			"fully_qualified": "1f9da-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-200d-2642",
			"output": "1f9da-200d-2642-fe0f",
			"default_matches": [
				"1f9da-200d-2642-fe0f",
				"1f9da-200d-2642",
				"1f9da-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-200d-2642-fe0f",
				"1f9da-200d-2642",
				"1f9da-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck"
		]
	},
	"1f9da-1f3fb-2640": {
		"name": "woman fairy: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2617,
		"display": 1,
		"shortname": ":woman_fairy_tone1:",
		"shortname_alternates": [
			":woman_fairy_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fb-2640",
			"fully_qualified": "1f9da-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-1f3fb-200d-2640",
			"output": "1f9da-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9da-1f3fb-200d-2640-fe0f",
				"1f9da-1f3fb-200d-2640",
				"1f9da-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fb-200d-2640-fe0f",
				"1f9da-1f3fb-200d-2640",
				"1f9da-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania",
			"light skin tone"
		]
	},
	"1f9da-1f3fb-2642": {
		"name": "man fairy: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2618,
		"display": 1,
		"shortname": ":man_fairy_tone1:",
		"shortname_alternates": [
			":man_fairy_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fb-2642",
			"fully_qualified": "1f9da-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-1f3fb-200d-2642",
			"output": "1f9da-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9da-1f3fb-200d-2642-fe0f",
				"1f9da-1f3fb-200d-2642",
				"1f9da-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fb-200d-2642-fe0f",
				"1f9da-1f3fb-200d-2642",
				"1f9da-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"light skin tone"
		]
	},
	"1f9da-1f3fc-2640": {
		"name": "woman fairy: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2619,
		"display": 1,
		"shortname": ":woman_fairy_tone2:",
		"shortname_alternates": [
			":woman_fairy_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fc-2640",
			"fully_qualified": "1f9da-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-1f3fc-200d-2640",
			"output": "1f9da-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9da-1f3fc-200d-2640-fe0f",
				"1f9da-1f3fc-200d-2640",
				"1f9da-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fc-200d-2640-fe0f",
				"1f9da-1f3fc-200d-2640",
				"1f9da-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania",
			"medium-light skin tone"
		]
	},
	"1f9da-1f3fc-2642": {
		"name": "man fairy: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2620,
		"display": 1,
		"shortname": ":man_fairy_tone2:",
		"shortname_alternates": [
			":man_fairy_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fc-2642",
			"fully_qualified": "1f9da-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-1f3fc-200d-2642",
			"output": "1f9da-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9da-1f3fc-200d-2642-fe0f",
				"1f9da-1f3fc-200d-2642",
				"1f9da-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fc-200d-2642-fe0f",
				"1f9da-1f3fc-200d-2642",
				"1f9da-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"medium-light skin tone"
		]
	},
	"1f9da-1f3fd-2640": {
		"name": "woman fairy: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2621,
		"display": 1,
		"shortname": ":woman_fairy_tone3:",
		"shortname_alternates": [
			":woman_fairy_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fd-2640",
			"fully_qualified": "1f9da-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-1f3fd-200d-2640",
			"output": "1f9da-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9da-1f3fd-200d-2640-fe0f",
				"1f9da-1f3fd-200d-2640",
				"1f9da-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fd-200d-2640-fe0f",
				"1f9da-1f3fd-200d-2640",
				"1f9da-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania",
			"medium skin tone"
		]
	},
	"1f9da-1f3fd-2642": {
		"name": "man fairy: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2622,
		"display": 1,
		"shortname": ":man_fairy_tone3:",
		"shortname_alternates": [
			":man_fairy_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fd-2642",
			"fully_qualified": "1f9da-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-1f3fd-200d-2642",
			"output": "1f9da-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9da-1f3fd-200d-2642-fe0f",
				"1f9da-1f3fd-200d-2642",
				"1f9da-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fd-200d-2642-fe0f",
				"1f9da-1f3fd-200d-2642",
				"1f9da-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"medium skin tone"
		]
	},
	"1f9da-1f3fe-2640": {
		"name": "woman fairy: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2623,
		"display": 1,
		"shortname": ":woman_fairy_tone4:",
		"shortname_alternates": [
			":woman_fairy_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fe-2640",
			"fully_qualified": "1f9da-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-1f3fe-200d-2640",
			"output": "1f9da-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9da-1f3fe-200d-2640-fe0f",
				"1f9da-1f3fe-200d-2640",
				"1f9da-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fe-200d-2640-fe0f",
				"1f9da-1f3fe-200d-2640",
				"1f9da-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania",
			"medium-dark skin tone"
		]
	},
	"1f9da-1f3fe-2642": {
		"name": "man fairy: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2624,
		"display": 1,
		"shortname": ":man_fairy_tone4:",
		"shortname_alternates": [
			":man_fairy_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3fe-2642",
			"fully_qualified": "1f9da-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-1f3fe-200d-2642",
			"output": "1f9da-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9da-1f3fe-200d-2642-fe0f",
				"1f9da-1f3fe-200d-2642",
				"1f9da-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3fe-200d-2642-fe0f",
				"1f9da-1f3fe-200d-2642",
				"1f9da-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"medium-dark skin tone"
		]
	},
	"1f9da-1f3ff-2640": {
		"name": "woman fairy: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2625,
		"display": 1,
		"shortname": ":woman_fairy_tone5:",
		"shortname_alternates": [
			":woman_fairy_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3ff-2640",
			"fully_qualified": "1f9da-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9da-1f3ff-200d-2640",
			"output": "1f9da-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9da-1f3ff-200d-2640-fe0f",
				"1f9da-1f3ff-200d-2640",
				"1f9da-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3ff-200d-2640-fe0f",
				"1f9da-1f3ff-200d-2640",
				"1f9da-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Titania",
			"dark skin tone"
		]
	},
	"1f9da-1f3ff-2642": {
		"name": "man fairy: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2626,
		"display": 1,
		"shortname": ":man_fairy_tone5:",
		"shortname_alternates": [
			":man_fairy_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9da-1f3ff-2642",
			"fully_qualified": "1f9da-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9da-1f3ff-200d-2642",
			"output": "1f9da-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9da-1f3ff-200d-2642-fe0f",
				"1f9da-1f3ff-200d-2642",
				"1f9da-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9da-1f3ff-200d-2642-fe0f",
				"1f9da-1f3ff-200d-2642",
				"1f9da-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Oberon",
			"Puck",
			"dark skin tone"
		]
	},
	"1f9db-2640": {
		"name": "woman vampire",
		"unicode_version": 10,
		"category": "people",
		"order": 2627,
		"display": 1,
		"shortname": ":woman_vampire:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9db-1f3fb-2640",
			"1f9db-1f3fc-2640",
			"1f9db-1f3fd-2640",
			"1f9db-1f3fe-2640",
			"1f9db-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-2640",
			"fully_qualified": "1f9db-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-200d-2640",
			"output": "1f9db-200d-2640-fe0f",
			"default_matches": [
				"1f9db-200d-2640-fe0f",
				"1f9db-200d-2640",
				"1f9db-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-200d-2640-fe0f",
				"1f9db-200d-2640",
				"1f9db-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"undead"
		]
	},
	"1f9db-2642": {
		"name": "man vampire",
		"unicode_version": 10,
		"category": "people",
		"order": 2628,
		"display": 1,
		"shortname": ":man_vampire:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9db-1f3fb-2642",
			"1f9db-1f3fc-2642",
			"1f9db-1f3fd-2642",
			"1f9db-1f3fe-2642",
			"1f9db-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-2642",
			"fully_qualified": "1f9db-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-200d-2642",
			"output": "1f9db-200d-2642-fe0f",
			"default_matches": [
				"1f9db-200d-2642-fe0f",
				"1f9db-200d-2642",
				"1f9db-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-200d-2642-fe0f",
				"1f9db-200d-2642",
				"1f9db-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"undead"
		]
	},
	"1f9db-1f3fb-2640": {
		"name": "woman vampire: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2629,
		"display": 1,
		"shortname": ":woman_vampire_tone1:",
		"shortname_alternates": [
			":woman_vampire_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fb-2640",
			"fully_qualified": "1f9db-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-1f3fb-200d-2640",
			"output": "1f9db-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9db-1f3fb-200d-2640-fe0f",
				"1f9db-1f3fb-200d-2640",
				"1f9db-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fb-200d-2640-fe0f",
				"1f9db-1f3fb-200d-2640",
				"1f9db-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fb-2642": {
		"name": "man vampire: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2630,
		"display": 1,
		"shortname": ":man_vampire_tone1:",
		"shortname_alternates": [
			":man_vampire_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fb-2642",
			"fully_qualified": "1f9db-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-1f3fb-200d-2642",
			"output": "1f9db-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9db-1f3fb-200d-2642-fe0f",
				"1f9db-1f3fb-200d-2642",
				"1f9db-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fb-200d-2642-fe0f",
				"1f9db-1f3fb-200d-2642",
				"1f9db-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fc-2640": {
		"name": "woman vampire: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2631,
		"display": 1,
		"shortname": ":woman_vampire_tone2:",
		"shortname_alternates": [
			":woman_vampire_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fc-2640",
			"fully_qualified": "1f9db-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-1f3fc-200d-2640",
			"output": "1f9db-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9db-1f3fc-200d-2640-fe0f",
				"1f9db-1f3fc-200d-2640",
				"1f9db-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fc-200d-2640-fe0f",
				"1f9db-1f3fc-200d-2640",
				"1f9db-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fc-2642": {
		"name": "man vampire: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2632,
		"display": 1,
		"shortname": ":man_vampire_tone2:",
		"shortname_alternates": [
			":man_vampire_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fc-2642",
			"fully_qualified": "1f9db-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-1f3fc-200d-2642",
			"output": "1f9db-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9db-1f3fc-200d-2642-fe0f",
				"1f9db-1f3fc-200d-2642",
				"1f9db-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fc-200d-2642-fe0f",
				"1f9db-1f3fc-200d-2642",
				"1f9db-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium-light skin tone",
			"undead"
		]
	},
	"1f9db-1f3fd-2640": {
		"name": "woman vampire: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2633,
		"display": 1,
		"shortname": ":woman_vampire_tone3:",
		"shortname_alternates": [
			":woman_vampire_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fd-2640",
			"fully_qualified": "1f9db-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-1f3fd-200d-2640",
			"output": "1f9db-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9db-1f3fd-200d-2640-fe0f",
				"1f9db-1f3fd-200d-2640",
				"1f9db-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fd-200d-2640-fe0f",
				"1f9db-1f3fd-200d-2640",
				"1f9db-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"undead"
		]
	},
	"1f9db-1f3fd-2642": {
		"name": "man vampire: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2634,
		"display": 1,
		"shortname": ":man_vampire_tone3:",
		"shortname_alternates": [
			":man_vampire_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fd-2642",
			"fully_qualified": "1f9db-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-1f3fd-200d-2642",
			"output": "1f9db-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9db-1f3fd-200d-2642-fe0f",
				"1f9db-1f3fd-200d-2642",
				"1f9db-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fd-200d-2642-fe0f",
				"1f9db-1f3fd-200d-2642",
				"1f9db-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium skin tone",
			"undead"
		]
	},
	"1f9db-1f3fe-2640": {
		"name": "woman vampire: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2635,
		"display": 1,
		"shortname": ":woman_vampire_tone4:",
		"shortname_alternates": [
			":woman_vampire_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fe-2640",
			"fully_qualified": "1f9db-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-1f3fe-200d-2640",
			"output": "1f9db-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9db-1f3fe-200d-2640-fe0f",
				"1f9db-1f3fe-200d-2640",
				"1f9db-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fe-200d-2640-fe0f",
				"1f9db-1f3fe-200d-2640",
				"1f9db-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"undead"
		]
	},
	"1f9db-1f3fe-2642": {
		"name": "man vampire: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2636,
		"display": 1,
		"shortname": ":man_vampire_tone4:",
		"shortname_alternates": [
			":man_vampire_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3fe-2642",
			"fully_qualified": "1f9db-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-1f3fe-200d-2642",
			"output": "1f9db-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9db-1f3fe-200d-2642-fe0f",
				"1f9db-1f3fe-200d-2642",
				"1f9db-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3fe-200d-2642-fe0f",
				"1f9db-1f3fe-200d-2642",
				"1f9db-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"medium-dark skin tone",
			"undead"
		]
	},
	"1f9db-1f3ff-2640": {
		"name": "woman vampire: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2637,
		"display": 1,
		"shortname": ":woman_vampire_tone5:",
		"shortname_alternates": [
			":woman_vampire_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3ff-2640",
			"fully_qualified": "1f9db-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9db-1f3ff-200d-2640",
			"output": "1f9db-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9db-1f3ff-200d-2640-fe0f",
				"1f9db-1f3ff-200d-2640",
				"1f9db-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3ff-200d-2640-fe0f",
				"1f9db-1f3ff-200d-2640",
				"1f9db-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"undead"
		]
	},
	"1f9db-1f3ff-2642": {
		"name": "man vampire: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2638,
		"display": 1,
		"shortname": ":man_vampire_tone5:",
		"shortname_alternates": [
			":man_vampire_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9db-1f3ff-2642",
			"fully_qualified": "1f9db-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9db-1f3ff-200d-2642",
			"output": "1f9db-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9db-1f3ff-200d-2642-fe0f",
				"1f9db-1f3ff-200d-2642",
				"1f9db-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9db-1f3ff-200d-2642-fe0f",
				"1f9db-1f3ff-200d-2642",
				"1f9db-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Dracula",
			"dark skin tone",
			"undead"
		]
	},
	"1f9dc-2640": {
		"name": "mermaid",
		"unicode_version": 10,
		"category": "people",
		"order": 2639,
		"display": 1,
		"shortname": ":mermaid:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dc-1f3fb-2640",
			"1f9dc-1f3fc-2640",
			"1f9dc-1f3fd-2640",
			"1f9dc-1f3fe-2640",
			"1f9dc-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-2640",
			"fully_qualified": "1f9dc-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-200d-2640",
			"output": "1f9dc-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-200d-2640-fe0f",
				"1f9dc-200d-2640",
				"1f9dc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-200d-2640-fe0f",
				"1f9dc-200d-2640",
				"1f9dc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"merwoman"
		]
	},
	"1f9dc-2642": {
		"name": "merman",
		"unicode_version": 10,
		"category": "people",
		"order": 2640,
		"display": 1,
		"shortname": ":merman:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dc-1f3fb-2642",
			"1f9dc-1f3fc-2642",
			"1f9dc-1f3fd-2642",
			"1f9dc-1f3fe-2642",
			"1f9dc-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-2642",
			"fully_qualified": "1f9dc-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-200d-2642",
			"output": "1f9dc-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-200d-2642-fe0f",
				"1f9dc-200d-2642",
				"1f9dc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-200d-2642-fe0f",
				"1f9dc-200d-2642",
				"1f9dc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton"
		]
	},
	"1f9dc-1f3fb-2640": {
		"name": "mermaid: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2641,
		"display": 1,
		"shortname": ":mermaid_tone1:",
		"shortname_alternates": [
			":mermaid_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fb-2640",
			"fully_qualified": "1f9dc-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-1f3fb-200d-2640",
			"output": "1f9dc-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-1f3fb-200d-2640-fe0f",
				"1f9dc-1f3fb-200d-2640",
				"1f9dc-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fb-200d-2640-fe0f",
				"1f9dc-1f3fb-200d-2640",
				"1f9dc-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"merwoman"
		]
	},
	"1f9dc-1f3fb-2642": {
		"name": "merman: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2642,
		"display": 1,
		"shortname": ":merman_tone1:",
		"shortname_alternates": [
			":merman_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fb-2642",
			"fully_qualified": "1f9dc-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-1f3fb-200d-2642",
			"output": "1f9dc-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-1f3fb-200d-2642-fe0f",
				"1f9dc-1f3fb-200d-2642",
				"1f9dc-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fb-200d-2642-fe0f",
				"1f9dc-1f3fb-200d-2642",
				"1f9dc-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton",
			"light skin tone"
		]
	},
	"1f9dc-1f3fc-2640": {
		"name": "mermaid: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2643,
		"display": 1,
		"shortname": ":mermaid_tone2:",
		"shortname_alternates": [
			":mermaid_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fc-2640",
			"fully_qualified": "1f9dc-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-1f3fc-200d-2640",
			"output": "1f9dc-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-1f3fc-200d-2640-fe0f",
				"1f9dc-1f3fc-200d-2640",
				"1f9dc-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fc-200d-2640-fe0f",
				"1f9dc-1f3fc-200d-2640",
				"1f9dc-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-light skin tone",
			"merwoman"
		]
	},
	"1f9dc-1f3fc-2642": {
		"name": "merman: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2644,
		"display": 1,
		"shortname": ":merman_tone2:",
		"shortname_alternates": [
			":merman_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fc-2642",
			"fully_qualified": "1f9dc-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-1f3fc-200d-2642",
			"output": "1f9dc-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-1f3fc-200d-2642-fe0f",
				"1f9dc-1f3fc-200d-2642",
				"1f9dc-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fc-200d-2642-fe0f",
				"1f9dc-1f3fc-200d-2642",
				"1f9dc-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton",
			"medium-light skin tone"
		]
	},
	"1f9dc-1f3fd-2640": {
		"name": "mermaid: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2645,
		"display": 1,
		"shortname": ":mermaid_tone3:",
		"shortname_alternates": [
			":mermaid_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fd-2640",
			"fully_qualified": "1f9dc-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-1f3fd-200d-2640",
			"output": "1f9dc-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-1f3fd-200d-2640-fe0f",
				"1f9dc-1f3fd-200d-2640",
				"1f9dc-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fd-200d-2640-fe0f",
				"1f9dc-1f3fd-200d-2640",
				"1f9dc-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium skin tone",
			"merwoman"
		]
	},
	"1f9dc-1f3fd-2642": {
		"name": "merman: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2646,
		"display": 1,
		"shortname": ":merman_tone3:",
		"shortname_alternates": [
			":merman_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fd-2642",
			"fully_qualified": "1f9dc-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-1f3fd-200d-2642",
			"output": "1f9dc-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-1f3fd-200d-2642-fe0f",
				"1f9dc-1f3fd-200d-2642",
				"1f9dc-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fd-200d-2642-fe0f",
				"1f9dc-1f3fd-200d-2642",
				"1f9dc-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton",
			"medium skin tone"
		]
	},
	"1f9dc-1f3fe-2640": {
		"name": "mermaid: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2647,
		"display": 1,
		"shortname": ":mermaid_tone4:",
		"shortname_alternates": [
			":mermaid_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fe-2640",
			"fully_qualified": "1f9dc-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-1f3fe-200d-2640",
			"output": "1f9dc-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-1f3fe-200d-2640-fe0f",
				"1f9dc-1f3fe-200d-2640",
				"1f9dc-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fe-200d-2640-fe0f",
				"1f9dc-1f3fe-200d-2640",
				"1f9dc-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"medium-dark skin tone",
			"merwoman"
		]
	},
	"1f9dc-1f3fe-2642": {
		"name": "merman: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2648,
		"display": 1,
		"shortname": ":merman_tone4:",
		"shortname_alternates": [
			":merman_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3fe-2642",
			"fully_qualified": "1f9dc-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-1f3fe-200d-2642",
			"output": "1f9dc-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-1f3fe-200d-2642-fe0f",
				"1f9dc-1f3fe-200d-2642",
				"1f9dc-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3fe-200d-2642-fe0f",
				"1f9dc-1f3fe-200d-2642",
				"1f9dc-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton",
			"medium-dark skin tone"
		]
	},
	"1f9dc-1f3ff-2640": {
		"name": "mermaid: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2649,
		"display": 1,
		"shortname": ":mermaid_tone5:",
		"shortname_alternates": [
			":mermaid_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3ff-2640",
			"fully_qualified": "1f9dc-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9dc-1f3ff-200d-2640",
			"output": "1f9dc-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9dc-1f3ff-200d-2640-fe0f",
				"1f9dc-1f3ff-200d-2640",
				"1f9dc-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3ff-200d-2640-fe0f",
				"1f9dc-1f3ff-200d-2640",
				"1f9dc-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"merwoman"
		]
	},
	"1f9dc-1f3ff-2642": {
		"name": "merman: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2650,
		"display": 1,
		"shortname": ":merman_tone5:",
		"shortname_alternates": [
			":merman_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dc-1f3ff-2642",
			"fully_qualified": "1f9dc-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9dc-1f3ff-200d-2642",
			"output": "1f9dc-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9dc-1f3ff-200d-2642-fe0f",
				"1f9dc-1f3ff-200d-2642",
				"1f9dc-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dc-1f3ff-200d-2642-fe0f",
				"1f9dc-1f3ff-200d-2642",
				"1f9dc-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"Triton",
			"dark skin tone"
		]
	},
	"1f9dd-2640": {
		"name": "woman elf",
		"unicode_version": 10,
		"category": "people",
		"order": 2651,
		"display": 1,
		"shortname": ":woman_elf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dd-1f3fb-2640",
			"1f9dd-1f3fc-2640",
			"1f9dd-1f3fd-2640",
			"1f9dd-1f3fe-2640",
			"1f9dd-1f3ff-2640"
		],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-2640",
			"fully_qualified": "1f9dd-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-200d-2640",
			"output": "1f9dd-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-200d-2640-fe0f",
				"1f9dd-200d-2640",
				"1f9dd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-200d-2640-fe0f",
				"1f9dd-200d-2640",
				"1f9dd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical"
		]
	},
	"1f9dd-2642": {
		"name": "man elf",
		"unicode_version": 10,
		"category": "people",
		"order": 2652,
		"display": 1,
		"shortname": ":man_elf:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [
			"1f9dd-1f3fb-2642",
			"1f9dd-1f3fc-2642",
			"1f9dd-1f3fd-2642",
			"1f9dd-1f3fe-2642",
			"1f9dd-1f3ff-2642"
		],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-2642",
			"fully_qualified": "1f9dd-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-200d-2642",
			"output": "1f9dd-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-200d-2642-fe0f",
				"1f9dd-200d-2642",
				"1f9dd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-200d-2642-fe0f",
				"1f9dd-200d-2642",
				"1f9dd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical"
		]
	},
	"1f9dd-1f3fb-2640": {
		"name": "woman elf: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2653,
		"display": 1,
		"shortname": ":woman_elf_tone1:",
		"shortname_alternates": [
			":woman_elf_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fb-2640",
			"fully_qualified": "1f9dd-1f3fb-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-1f3fb-200d-2640",
			"output": "1f9dd-1f3fb-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-1f3fb-200d-2640-fe0f",
				"1f9dd-1f3fb-200d-2640",
				"1f9dd-1f3fb-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fb-200d-2640-fe0f",
				"1f9dd-1f3fb-200d-2640",
				"1f9dd-1f3fb-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"magical"
		]
	},
	"1f9dd-1f3fb-2642": {
		"name": "man elf: light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2654,
		"display": 1,
		"shortname": ":man_elf_tone1:",
		"shortname_alternates": [
			":man_elf_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fb",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fb-2642",
			"fully_qualified": "1f9dd-1f3fb-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-1f3fb-200d-2642",
			"output": "1f9dd-1f3fb-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-1f3fb-200d-2642-fe0f",
				"1f9dd-1f3fb-200d-2642",
				"1f9dd-1f3fb-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fb-200d-2642-fe0f",
				"1f9dd-1f3fb-200d-2642",
				"1f9dd-1f3fb-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"light skin tone",
			"magical"
		]
	},
	"1f9dd-1f3fc-2640": {
		"name": "woman elf: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2655,
		"display": 1,
		"shortname": ":woman_elf_tone2:",
		"shortname_alternates": [
			":woman_elf_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fc-2640",
			"fully_qualified": "1f9dd-1f3fc-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-1f3fc-200d-2640",
			"output": "1f9dd-1f3fc-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-1f3fc-200d-2640-fe0f",
				"1f9dd-1f3fc-200d-2640",
				"1f9dd-1f3fc-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fc-200d-2640-fe0f",
				"1f9dd-1f3fc-200d-2640",
				"1f9dd-1f3fc-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-light skin tone"
		]
	},
	"1f9dd-1f3fc-2642": {
		"name": "man elf: medium-light skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2656,
		"display": 1,
		"shortname": ":man_elf_tone2:",
		"shortname_alternates": [
			":man_elf_medium_light_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fc",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fc-2642",
			"fully_qualified": "1f9dd-1f3fc-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-1f3fc-200d-2642",
			"output": "1f9dd-1f3fc-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-1f3fc-200d-2642-fe0f",
				"1f9dd-1f3fc-200d-2642",
				"1f9dd-1f3fc-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fc-200d-2642-fe0f",
				"1f9dd-1f3fc-200d-2642",
				"1f9dd-1f3fc-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-light skin tone"
		]
	},
	"1f9dd-1f3fd-2640": {
		"name": "woman elf: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2657,
		"display": 1,
		"shortname": ":woman_elf_tone3:",
		"shortname_alternates": [
			":woman_elf_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fd-2640",
			"fully_qualified": "1f9dd-1f3fd-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-1f3fd-200d-2640",
			"output": "1f9dd-1f3fd-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-1f3fd-200d-2640-fe0f",
				"1f9dd-1f3fd-200d-2640",
				"1f9dd-1f3fd-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fd-200d-2640-fe0f",
				"1f9dd-1f3fd-200d-2640",
				"1f9dd-1f3fd-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium skin tone"
		]
	},
	"1f9dd-1f3fd-2642": {
		"name": "man elf: medium skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2658,
		"display": 1,
		"shortname": ":man_elf_tone3:",
		"shortname_alternates": [
			":man_elf_medium_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fd",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fd-2642",
			"fully_qualified": "1f9dd-1f3fd-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-1f3fd-200d-2642",
			"output": "1f9dd-1f3fd-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-1f3fd-200d-2642-fe0f",
				"1f9dd-1f3fd-200d-2642",
				"1f9dd-1f3fd-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fd-200d-2642-fe0f",
				"1f9dd-1f3fd-200d-2642",
				"1f9dd-1f3fd-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium skin tone"
		]
	},
	"1f9dd-1f3fe-2640": {
		"name": "woman elf: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2659,
		"display": 1,
		"shortname": ":woman_elf_tone4:",
		"shortname_alternates": [
			":woman_elf_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fe-2640",
			"fully_qualified": "1f9dd-1f3fe-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-1f3fe-200d-2640",
			"output": "1f9dd-1f3fe-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-1f3fe-200d-2640-fe0f",
				"1f9dd-1f3fe-200d-2640",
				"1f9dd-1f3fe-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fe-200d-2640-fe0f",
				"1f9dd-1f3fe-200d-2640",
				"1f9dd-1f3fe-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-dark skin tone"
		]
	},
	"1f9dd-1f3fe-2642": {
		"name": "man elf: medium-dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2660,
		"display": 1,
		"shortname": ":man_elf_tone4:",
		"shortname_alternates": [
			":man_elf_medium_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3fe",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3fe-2642",
			"fully_qualified": "1f9dd-1f3fe-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-1f3fe-200d-2642",
			"output": "1f9dd-1f3fe-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-1f3fe-200d-2642-fe0f",
				"1f9dd-1f3fe-200d-2642",
				"1f9dd-1f3fe-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3fe-200d-2642-fe0f",
				"1f9dd-1f3fe-200d-2642",
				"1f9dd-1f3fe-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"magical",
			"medium-dark skin tone"
		]
	},
	"1f9dd-1f3ff-2640": {
		"name": "woman elf: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2661,
		"display": 1,
		"shortname": ":woman_elf_tone5:",
		"shortname_alternates": [
			":woman_elf_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3ff-2640",
			"fully_qualified": "1f9dd-1f3ff-200d-2640-fe0f",
			"non_fully_qualified": "1f9dd-1f3ff-200d-2640",
			"output": "1f9dd-1f3ff-200d-2640-fe0f",
			"default_matches": [
				"1f9dd-1f3ff-200d-2640-fe0f",
				"1f9dd-1f3ff-200d-2640",
				"1f9dd-1f3ff-2640-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3ff-200d-2640-fe0f",
				"1f9dd-1f3ff-200d-2640",
				"1f9dd-1f3ff-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"magical"
		]
	},
	"1f9dd-1f3ff-2642": {
		"name": "man elf: dark skin tone",
		"unicode_version": 10,
		"category": "people",
		"order": 2662,
		"display": 1,
		"shortname": ":man_elf_tone5:",
		"shortname_alternates": [
			":man_elf_dark_skin_tone:"
		],
		"ascii": [],
		"diversity": "1f3ff",
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9dd-1f3ff-2642",
			"fully_qualified": "1f9dd-1f3ff-200d-2642-fe0f",
			"non_fully_qualified": "1f9dd-1f3ff-200d-2642",
			"output": "1f9dd-1f3ff-200d-2642-fe0f",
			"default_matches": [
				"1f9dd-1f3ff-200d-2642-fe0f",
				"1f9dd-1f3ff-200d-2642",
				"1f9dd-1f3ff-2642-fe0f"
			],
			"greedy_matches": [
				"1f9dd-1f3ff-200d-2642-fe0f",
				"1f9dd-1f3ff-200d-2642",
				"1f9dd-1f3ff-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"dark skin tone",
			"magical"
		]
	},
	"1f9de-2640": {
		"name": "woman genie",
		"unicode_version": 10,
		"category": "people",
		"order": 2663,
		"display": 1,
		"shortname": ":woman_genie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9de-2640",
			"fully_qualified": "1f9de-200d-2640-fe0f",
			"non_fully_qualified": "1f9de-200d-2640",
			"output": "1f9de-200d-2640-fe0f",
			"default_matches": [
				"1f9de-200d-2640-fe0f",
				"1f9de-200d-2640",
				"1f9de-2640-fe0f"
			],
			"greedy_matches": [
				"1f9de-200d-2640-fe0f",
				"1f9de-200d-2640",
				"1f9de-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"djinn"
		]
	},
	"1f9de-2642": {
		"name": "man genie",
		"unicode_version": 10,
		"category": "people",
		"order": 2664,
		"display": 1,
		"shortname": ":man_genie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9de-2642",
			"fully_qualified": "1f9de-200d-2642-fe0f",
			"non_fully_qualified": "1f9de-200d-2642",
			"output": "1f9de-200d-2642-fe0f",
			"default_matches": [
				"1f9de-200d-2642-fe0f",
				"1f9de-200d-2642",
				"1f9de-2642-fe0f"
			],
			"greedy_matches": [
				"1f9de-200d-2642-fe0f",
				"1f9de-200d-2642",
				"1f9de-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"djinn"
		]
	},
	"1f9df-2640": {
		"name": "woman zombie",
		"unicode_version": 10,
		"category": "people",
		"order": 2665,
		"display": 1,
		"shortname": ":woman_zombie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2640",
		"genders": [],
		"code_points": {
			"base": "1f9df-2640",
			"fully_qualified": "1f9df-200d-2640-fe0f",
			"non_fully_qualified": "1f9df-200d-2640",
			"output": "1f9df-200d-2640-fe0f",
			"default_matches": [
				"1f9df-200d-2640-fe0f",
				"1f9df-200d-2640",
				"1f9df-2640-fe0f"
			],
			"greedy_matches": [
				"1f9df-200d-2640-fe0f",
				"1f9df-200d-2640",
				"1f9df-2640-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"undead",
			"walking dead"
		]
	},
	"1f9df-2642": {
		"name": "man zombie",
		"unicode_version": 10,
		"category": "people",
		"order": 2666,
		"display": 1,
		"shortname": ":man_zombie:",
		"shortname_alternates": [],
		"ascii": [],
		"diversity": null,
		"diversities": [],
		"gender": "2642",
		"genders": [],
		"code_points": {
			"base": "1f9df-2642",
			"fully_qualified": "1f9df-200d-2642-fe0f",
			"non_fully_qualified": "1f9df-200d-2642",
			"output": "1f9df-200d-2642-fe0f",
			"default_matches": [
				"1f9df-200d-2642-fe0f",
				"1f9df-200d-2642",
				"1f9df-2642-fe0f"
			],
			"greedy_matches": [
				"1f9df-200d-2642-fe0f",
				"1f9df-200d-2642",
				"1f9df-2642-fe0f"
			],
			"decimal": ""
		},
		"keywords": [
			"undead",
			"walking dead"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/emojione/emoji.json
// module id = 1569
// module chunks = 2